import * as Cr from "onnxruntime-web/all";
async function lv(r, e, t) {
  const { onProgress: n } = e || {};
  try {
    const a = await fetch(r, { signal: t });
    if (!a.ok)
      throw new Error(`HTTP error! status: ${a.status} ${a.statusText}`);
    if (!a.body)
      throw new Error("Response body is null");
    const i = a.headers.get("content-length"), s = i ? parseInt(i, 10) : void 0;
    let l = 0;
    const c = a.body.getReader(), o = [];
    for (n && n({
      loaded: l,
      total: s,
      percent: s ? l / s * 100 : 0
    }); ; ) {
      const { done: m, value: p } = await c.read();
      if (t && t.aborted)
        throw new Error("Download Cancelled");
      if (m)
        break;
      if (o.push(p), l += p.length, n) {
        const d = s ? l / s * 100 : 0;
        n({ loaded: l, total: s, percent: Math.min(d, 100) });
      }
    }
    const u = new Uint8Array(l);
    let f = 0;
    for (const m of o)
      u.set(m, f), f += m.length;
    return n && s && l !== s ? console.warn(
      `Content-Length mismatch: Expected ${s}, got ${l}. Progress might have been inaccurate.`
    ) : n && l > 0 && n({ loaded: l, total: s, percent: 100 }), u.buffer;
  } catch (a) {
    throw console.error("Download failed:", a), a;
  }
}
let Br = null, mt = new OffscreenCanvas(1, 1), xn = mt.getContext("2d", {
  willReadFrequently: !1,
  desynchronized: !0,
  alpha: !1
}), di = null, kn = new OffscreenCanvas(1, 1), Qr = null;
function fv(r) {
  const t = new OffscreenCanvas(r.width, r.height).getContext("2d", {
    willReadFrequently: !0,
    desynchronized: !0
  });
  if (!t)
    throw new Error("Could not create canvas context");
  return t.drawImage(r, 0, 0), t.getImageData(0, 0, r.width, r.height);
}
async function mv(r, e, t) {
  if (r instanceof ImageBitmap && r.width == e && r.height == t)
    return {
      image: fv(r),
      resizedWidth: r.width,
      resizedHeight: r.height
    };
  if (kn.width < e || kn.height < t || Qr === null) {
    if (kn = new OffscreenCanvas(e, t), Qr = kn.getContext("2d", {
      desynchronized: !0,
      willReadFrequently: !0,
      alpha: !1
    }), !Qr)
      throw new Error("could not create canvas context");
    Qr.imageSmoothingQuality = "high", Qr.imageSmoothingEnabled = !0;
  }
  let n = r.width, a = r.height;
  if (n > a ? (a = Math.round(a * e / n), n = e) : (n = Math.round(n * t / a), a = t), Qr.fillStyle = "black", Qr.fillRect(0, 0, e, t), r instanceof ImageData) {
    const s = Br?.width || 0, l = Br?.height || 0;
    if (r.width > s || r.height > l) {
      const u = Math.max(s, r.width), f = Math.max(l, r.height);
      Br = new OffscreenCanvas(u, f);
    }
    const c = {
      desynchronized: !0,
      alpha: !1,
      willReadFrequently: !1,
      colorSpace: "srgb"
    };
    if (!Br)
      throw new Error("tempCanvasForImageData is not initialized");
    const o = Br.getContext("2d", c);
    if (!o)
      throw new Error("could not create canvas context");
    o.imageSmoothingEnabled = !1, o.putImageData(r, 0, 0), Qr.drawImage(Br, 0, 0, r.width, r.height, 0, 0, n, a);
  } else
    Qr.drawImage(r, 0, 0, n, a);
  return {
    image: Qr.getImageData(0, 0, e, t),
    resizedWidth: n,
    resizedHeight: a
  };
}
function pv(r, e) {
  if (r instanceof OffscreenCanvas) {
    const s = r.getContext("2d", {
      willReadFrequently: !1,
      desynchronized: !0,
      alpha: !1
    });
    if (!s)
      throw new Error("could not create canvas context");
    s.imageSmoothingEnabled = !1, r = s.getImageData(0, 0, r.width, r.height);
  }
  const t = r.data.length / r.width / r.height, n = r.width * r.height, a = n * 3;
  let i;
  e && e.length === a ? i = e : i = new Float32Array(a);
  for (let s = 0; s < 3; s++) {
    const l = s * n;
    let c = s;
    for (let o = 0; o < n; o++)
      i[l + o] = r.data[c], c += t;
  }
  return {
    data: i,
    shape: [3, r.height, r.width],
    width: r.width,
    height: r.height,
    channels: 3
  };
}
function Ti(r, e, t) {
  const n = Math.max(0, r.origin.x), a = Math.max(0, r.origin.y), i = Math.min(r.origin.x + r.width, e), s = Math.min(r.origin.y + r.height, t);
  return {
    origin: { x: n, y: a },
    width: i - n,
    height: s - a,
    score: r.score
  };
}
async function Af(r, e) {
  if (!xn)
    throw new Error("tempCropCtx is not initialized");
  xn.imageSmoothingEnabled = !0;
  let t = r;
  r instanceof ImageData && ((!Br || Br.width < r.width || Br.height < r.height) && (Br = new OffscreenCanvas(
    Math.max(Br?.width || 0, r.width),
    Math.max(Br?.height || 0, r.height)
  ), di = Br.getContext("2d", {
    willReadFrequently: !1,
    desynchronized: !0
  })), di.clearRect(0, 0, r.width, r.height), di.putImageData(r, 0, 0), t = Br);
  const n = r.width, a = r.height, i = new Array(e.length);
  for (let s = 0; s < e.length; s++) {
    const {
      origin: { x: l, y: c },
      width: o,
      height: u
    } = e[s];
    (mt.width < o || mt.height < u) && (mt.width = Math.ceil(Math.max(mt.width, o)), mt.height = Math.ceil(Math.max(mt.height, u))), xn.fillStyle = "black", xn.fillRect(0, 0, o, u);
    const f = Ti({ origin: { x: l, y: c }, width: o, height: u, score: e[s].score }, n, a);
    if (t instanceof ImageData)
      throw new Error("source cannot be ImageData here");
    if (f.width > 0 && f.height > 0) {
      const m = f.origin.x - l, p = f.origin.y - c;
      xn.drawImage(
        t,
        f.origin.x,
        f.origin.y,
        f.width,
        f.height,
        m,
        p,
        f.width,
        f.height
      );
    }
    i[s] = createImageBitmap(mt, 0, 0, o, u);
  }
  return await Promise.all(i);
}
const Sf = `(function(){"use strict";let l=null;new OffscreenCanvas(1,1).getContext("2d",{willReadFrequently:!1,desynchronized:!0,alpha:!1});let c=new OffscreenCanvas(1,1),o=null;function u(e){const n=new OffscreenCanvas(e.width,e.height).getContext("2d",{willReadFrequently:!0,desynchronized:!0});if(!n)throw new Error("Could not create canvas context");return n.drawImage(e,0,0),n.getImageData(0,0,e.width,e.height)}async function w(e,t,n){if(e instanceof ImageBitmap&&e.width==t&&e.height==n)return{image:u(e),resizedWidth:e.width,resizedHeight:e.height};if(c.width<t||c.height<n||o===null){if(c=new OffscreenCanvas(t,n),o=c.getContext("2d",{desynchronized:!0,willReadFrequently:!0,alpha:!1}),!o)throw new Error("could not create canvas context");o.imageSmoothingQuality="high",o.imageSmoothingEnabled=!0}let r=e.width,a=e.height;if(r>a?(a=Math.round(a*t/r),r=t):(r=Math.round(r*n/a),a=n),o.fillStyle="black",o.fillRect(0,0,t,n),e instanceof ImageData){const s=l?.width||0,d=l?.height||0;if(e.width>s||e.height>d){const C=Math.max(s,e.width),p=Math.max(d,e.height);l=new OffscreenCanvas(C,p)}const f={desynchronized:!0,alpha:!1,willReadFrequently:!1,colorSpace:"srgb"};if(!l)throw new Error("tempCanvasForImageData is not initialized");const i=l.getContext("2d",f);if(!i)throw new Error("could not create canvas context");i.imageSmoothingEnabled=!1,i.putImageData(e,0,0),o.drawImage(l,0,0,e.width,e.height,0,0,r,a)}else o.drawImage(e,0,0,r,a);return{image:o.getImageData(0,0,t,n),resizedWidth:r,resizedHeight:a}}function g(e,t){if(e instanceof OffscreenCanvas){const s=e.getContext("2d",{willReadFrequently:!1,desynchronized:!0,alpha:!1});if(!s)throw new Error("could not create canvas context");s.imageSmoothingEnabled=!1,e=s.getImageData(0,0,e.width,e.height)}const n=e.data.length/e.width/e.height,r=e.width*e.height,a=r*3;let h;t&&t.length===a?h=t:h=new Float32Array(a);for(let s=0;s<3;s++){const d=s*r;let f=s;for(let i=0;i<r;i++)h[d+i]=e.data[f],f+=n}return{data:h,shape:[3,e.height,e.width],width:e.width,height:e.height,channels:3}}self.onmessage=async function(e){const{image:t,inputWidth:n,inputHeight:r,tensorBuffer:a}=e.data,h=await w(t,n,r),s=g(h.image,a),d={input:t,resizedWidth:h.resizedWidth,resizedHeight:h.resizedHeight,tensor:{data:s.data,shape:s.shape}};self.postMessage(d,[t,s.data.buffer])}})();
`, To = typeof self < "u" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", Sf], { type: "text/javascript;charset=utf-8" });
function dv(r) {
  let e;
  try {
    if (e = To && (self.URL || self.webkitURL).createObjectURL(To), !e) throw "";
    const t = new Worker(e, {
      name: r?.name
    });
    return t.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(e);
    }), t;
  } catch {
    return new Worker(
      "data:text/javascript;charset=utf-8," + encodeURIComponent(Sf),
      {
        name: r?.name
      }
    );
  }
}
class Ya {
  _tensorBuffer;
  constructor(e, t) {
    this.modelConfig = e, this.executorType = t;
  }
  [Symbol.dispose]() {
    this.preprocessImageWorker.terminate();
  }
  preprocessImageWorker = new dv({
    name: "preprocess-image-worker"
  });
  executorType;
  modelConfig;
  async preprocessImage(e) {
    const t = this.modelConfig.inputWidth, n = this.modelConfig.inputHeight;
    return new Promise((a, i) => {
      this.preprocessImageWorker.onmessage = (s) => {
        const l = s.data;
        this._tensorBuffer = l.tensor.data, a(l);
      }, this.preprocessImageWorker.onerror = (s) => i(s), this.preprocessImageWorker.postMessage(
        {
          image: e,
          inputWidth: t,
          inputHeight: n,
          tensorBuffer: this._tensorBuffer
        },
        [e]
      );
    });
  }
  async preprocessImageCpu(e) {
    const t = this.modelConfig.inputWidth, n = this.modelConfig.inputHeight, a = await mv(e, t, n), i = pv(a.image, this._tensorBuffer);
    return this._tensorBuffer = i.data, {
      input: e,
      resizedWidth: a.resizedWidth,
      resizedHeight: a.resizedHeight,
      tensor: i
    };
  }
}
function hr() {
  return hr = Object.assign ? Object.assign.bind() : function(r) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t) ({}).hasOwnProperty.call(t, n) && (r[n] = t[n]);
    }
    return r;
  }, hr.apply(null, arguments);
}
var Ja = {
  // minimum relative difference between two compared values,
  // used by all comparison functions
  relTol: 1e-12,
  // minimum absolute difference between two compared values,
  // used by all comparison functions
  absTol: 1e-15,
  // type of default matrix output. Choose 'matrix' (default) or 'array'
  matrix: "Matrix",
  // type of default number output. Choose 'number' (default) 'BigNumber', 'bigint', or 'Fraction'
  number: "number",
  // type of fallback used for config { number: 'bigint' } when a value cannot be represented
  // in the configured numeric type. Choose 'number' (default) or 'BigNumber'.
  numberFallback: "number",
  // number of significant digits in BigNumbers
  precision: 64,
  // predictable output type of functions. When true, output type depends only
  // on the input types. When false (default), output type can vary depending
  // on input values. For example `math.sqrt(-4)` returns `complex('2i')` when
  // predictable is false, and returns `NaN` when true.
  predictable: !1,
  // random seed for seeded pseudo random number generation
  // null = randomly seed
  randomSeed: null
};
function Mr(r, e) {
  if (Sa(r, e))
    return r[e];
  throw typeof r[e] == "function" && to(r, e) ? new Error('Cannot access method "' + e + '" as a property') : new Error('No access to property "' + e + '"');
}
function an(r, e, t) {
  if (Sa(r, e))
    return r[e] = t, t;
  throw new Error('No access to property "' + e + '"');
}
function Sa(r, e) {
  return !hv(r) && !Array.isArray(r) ? !1 : xe(gv, e) ? !0 : !(e in Object.prototype || e in Function.prototype);
}
function vv(r, e) {
  if (!to(r, e))
    throw new Error('No access to method "' + e + '"');
  return r[e];
}
function to(r, e) {
  return r == null || typeof r[e] != "function" || xe(r, e) && Object.getPrototypeOf && e in Object.getPrototypeOf(r) ? !1 : xe(yv, e) ? !0 : !(e in Object.prototype || e in Function.prototype);
}
function hv(r) {
  return typeof r == "object" && r && r.constructor === Object;
}
var gv = {
  length: !0,
  name: !0
}, yv = {
  toString: !0,
  valueOf: !0,
  toLocaleString: !0
};
class Qa {
  constructor(e) {
    this.wrappedObject = e, this[Symbol.iterator] = this.entries;
  }
  keys() {
    return Object.keys(this.wrappedObject).filter((e) => this.has(e)).values();
  }
  get(e) {
    return Mr(this.wrappedObject, e);
  }
  set(e, t) {
    return an(this.wrappedObject, e, t), this;
  }
  has(e) {
    return Sa(this.wrappedObject, e) && e in this.wrappedObject;
  }
  entries() {
    return Mf(this.keys(), (e) => [e, this.get(e)]);
  }
  forEach(e) {
    for (var t of this.keys())
      e(this.get(t), t, this);
  }
  delete(e) {
    Sa(this.wrappedObject, e) && delete this.wrappedObject[e];
  }
  clear() {
    for (var e of this.keys())
      this.delete(e);
  }
  get size() {
    return Object.keys(this.wrappedObject).length;
  }
}
class Ef {
  /**
   * @param {Map} a
   * @param {Map} b
   * @param {Set} bKeys
   */
  constructor(e, t, n) {
    this.a = e, this.b = t, this.bKeys = n, this[Symbol.iterator] = this.entries;
  }
  get(e) {
    return this.bKeys.has(e) ? this.b.get(e) : this.a.get(e);
  }
  set(e, t) {
    return this.bKeys.has(e) ? this.b.set(e, t) : this.a.set(e, t), this;
  }
  has(e) {
    return this.b.has(e) || this.a.has(e);
  }
  keys() {
    return (/* @__PURE__ */ new Set([...this.a.keys(), ...this.b.keys()]))[Symbol.iterator]();
  }
  entries() {
    return Mf(this.keys(), (e) => [e, this.get(e)]);
  }
  forEach(e) {
    for (var t of this.keys())
      e(this.get(t), t, this);
  }
  delete(e) {
    return this.bKeys.has(e) ? this.b.delete(e) : this.a.delete(e);
  }
  clear() {
    this.a.clear(), this.b.clear();
  }
  get size() {
    return [...this.keys()].length;
  }
}
function Mf(r, e) {
  return {
    next: () => {
      var t = r.next();
      return t.done ? t : {
        value: e(t.value),
        done: !1
      };
    }
  };
}
function Cn() {
  return /* @__PURE__ */ new Map();
}
function Kt(r) {
  if (!r)
    return Cn();
  if (It(r))
    return r;
  if (qt(r))
    return new Qa(r);
  throw new Error("createMap can create maps from objects or Maps");
}
function bv(r) {
  if (r instanceof Qa)
    return r.wrappedObject;
  var e = {};
  for (var t of r.keys()) {
    var n = r.get(t);
    an(e, t, n);
  }
  return e;
}
function Re(r) {
  return typeof r == "number";
}
function $e(r) {
  return !r || typeof r != "object" || typeof r.constructor != "function" ? !1 : r.isBigNumber === !0 && typeof r.constructor.prototype == "object" && r.constructor.prototype.isBigNumber === !0 || typeof r.constructor.isDecimal == "function" && r.constructor.isDecimal(r) === !0;
}
function en(r) {
  return typeof r == "bigint";
}
function Zr(r) {
  return r && typeof r == "object" && Object.getPrototypeOf(r).isComplex === !0 || !1;
}
function Rt(r) {
  return r && typeof r == "object" && Object.getPrototypeOf(r).isFraction === !0 || !1;
}
function Er(r) {
  return r && r.constructor.prototype.isUnit === !0 || !1;
}
function gr(r) {
  return typeof r == "string";
}
var Ye = Array.isArray;
function Ee(r) {
  return r && r.constructor.prototype.isMatrix === !0 || !1;
}
function Ir(r) {
  return Array.isArray(r) || Ee(r);
}
function _n(r) {
  return r && r.isDenseMatrix && r.constructor.prototype.isMatrix === !0 || !1;
}
function gt(r) {
  return r && r.isSparseMatrix && r.constructor.prototype.isMatrix === !0 || !1;
}
function ja(r) {
  return r && r.constructor.prototype.isRange === !0 || !1;
}
function $n(r) {
  return r && r.constructor.prototype.isIndex === !0 || !1;
}
function Cf(r) {
  return typeof r == "boolean";
}
function _f(r) {
  return r && r.constructor.prototype.isResultSet === !0 || !1;
}
function no(r) {
  return r && r.constructor.prototype.isHelp === !0 || !1;
}
function ao(r) {
  return typeof r == "function";
}
function Tf(r) {
  return r instanceof Date;
}
function Ff(r) {
  return r instanceof RegExp;
}
function qt(r) {
  return !!(r && typeof r == "object" && r.constructor === Object && !Zr(r) && !Rt(r));
}
function It(r) {
  return r ? r instanceof Map || r instanceof Qa || typeof r.set == "function" && typeof r.get == "function" && typeof r.keys == "function" && typeof r.has == "function" : !1;
}
function xv(r) {
  return It(r) && It(r.a) && It(r.b);
}
function wv(r) {
  return It(r) && qt(r.wrappedObject);
}
function Bf(r) {
  return r === null;
}
function Of(r) {
  return r === void 0;
}
function wt(r) {
  return r && r.isAccessorNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function zr(r) {
  return r && r.isArrayNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function If(r) {
  return r && r.isAssignmentNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function $f(r) {
  return r && r.isBlockNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function zf(r) {
  return r && r.isConditionalNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function We(r) {
  return r && r.isConstantNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function Fi(r) {
  return We(r) || ir(r) && r.args.length === 1 && We(r.args[0]) && "-+~".includes(r.op);
}
function mn(r) {
  return r && r.isFunctionAssignmentNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function st(r) {
  return r && r.isFunctionNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function Pt(r) {
  return r && r.isIndexNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function Xe(r) {
  return r && r.isNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function zn(r) {
  return r && r.isObjectNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function ir(r) {
  return r && r.isOperatorNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function et(r) {
  return r && r.isParenthesisNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function Rf(r) {
  return r && r.isRangeNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function qf(r) {
  return r && r.isRelationalNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function ur(r) {
  return r && r.isSymbolNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function io(r) {
  return r && r.constructor.prototype.isChain === !0 || !1;
}
function Ke(r) {
  var e = typeof r;
  return e === "object" ? r === null ? "null" : $e(r) ? "BigNumber" : r.constructor && r.constructor.name ? r.constructor.name : "Object" : e;
}
function Te(r) {
  var e = typeof r;
  if (e === "number" || e === "bigint" || e === "string" || e === "boolean" || r === null || r === void 0)
    return r;
  if (typeof r.clone == "function")
    return r.clone();
  if (Array.isArray(r))
    return r.map(function(t) {
      return Te(t);
    });
  if (r instanceof Date) return new Date(r.valueOf());
  if ($e(r)) return r;
  if (qt(r))
    return Dv(r, Te);
  if (e === "function")
    return r;
  throw new TypeError("Cannot clone: unknown type of value (value: ".concat(r, ")"));
}
function Dv(r, e) {
  var t = {};
  for (var n in r)
    xe(r, n) && (t[n] = e(r[n]));
  return t;
}
function Pf(r, e) {
  for (var t in e)
    xe(e, t) && (r[t] = e[t]);
  return r;
}
function Uf(r, e) {
  if (Array.isArray(e))
    throw new TypeError("Arrays are not supported by deepExtend");
  for (var t in e)
    if (xe(e, t) && !(t in Object.prototype) && !(t in Function.prototype))
      if (e[t] && e[t].constructor === Object)
        r[t] === void 0 && (r[t] = {}), r[t] && r[t].constructor === Object ? Uf(r[t], e[t]) : r[t] = e[t];
      else {
        if (Array.isArray(e[t]))
          throw new TypeError("Arrays are not supported by deepExtend");
        r[t] = e[t];
      }
  return r;
}
function ut(r, e) {
  var t, n, a;
  if (Array.isArray(r)) {
    if (!Array.isArray(e) || r.length !== e.length)
      return !1;
    for (n = 0, a = r.length; n < a; n++)
      if (!ut(r[n], e[n]))
        return !1;
    return !0;
  } else {
    if (typeof r == "function")
      return r === e;
    if (r instanceof Object) {
      if (Array.isArray(e) || !(e instanceof Object))
        return !1;
      for (t in r)
        if (!(t in e) || !ut(r[t], e[t]))
          return !1;
      for (t in e)
        if (!(t in r))
          return !1;
      return !0;
    } else
      return r === e;
  }
}
function Nv(r) {
  var e = {};
  return Lf(r, e), e;
}
function Lf(r, e) {
  for (var t in r)
    if (xe(r, t)) {
      var n = r[t];
      typeof n == "object" && n !== null ? Lf(n, e) : e[t] = n;
    }
}
function Tt(r, e, t) {
  var n = !0, a;
  Object.defineProperty(r, e, {
    get: function() {
      return n && (a = t(), n = !1), a;
    },
    set: function(s) {
      a = s, n = !1;
    },
    configurable: !0,
    enumerable: !0
  });
}
function xe(r, e) {
  return r && Object.hasOwnProperty.call(r, e);
}
function Av(r) {
  return r && typeof r.factory == "function";
}
function Sv(r, e) {
  for (var t = {}, n = 0; n < e.length; n++) {
    var a = e[n], i = r[a];
    i !== void 0 && (t[a] = i);
  }
  return t;
}
var Bi = ["Matrix", "Array"], Oi = ["number", "BigNumber", "bigint", "Fraction"];
function Ev(r, e) {
  function t(n) {
    if (n) {
      if (n.epsilon !== void 0) {
        console.warn('Warning: The configuration option "epsilon" is deprecated. Use "relTol" and "absTol" instead.');
        var a = Te(n);
        return a.relTol = n.epsilon, a.absTol = n.epsilon * 1e-3, delete a.epsilon, t(a);
      }
      var i = Te(r);
      Fo(n, "matrix", Bi), Fo(n, "number", Oi), Uf(r, n);
      var s = Te(r), l = Te(n);
      return e("config", s, i, l), s;
    } else
      return Te(r);
  }
  return t.MATRIX_OPTIONS = Bi, t.NUMBER_OPTIONS = Oi, Object.keys(Ja).forEach((n) => {
    Object.defineProperty(t, n, {
      get: () => r[n],
      enumerable: !0,
      configurable: !0
    });
  }), t;
}
function Fo(r, e, t) {
  r[e] !== void 0 && !t.includes(r[e]) && console.warn('Warning: Unknown value "' + r[e] + '" for configuration option "' + e + '". Available options: ' + t.map((n) => JSON.stringify(n)).join(", ") + ".");
}
var Ut = function(e) {
  if (e)
    throw new Error(`The global config is readonly. 
Please create a mathjs instance if you want to change the default configuration. 
Example:

  import { create, all } from 'mathjs';
  const mathjs = create(all);
  mathjs.config({ number: 'BigNumber' });
`);
  return Object.freeze(Ja);
};
hr(Ut, Ja, {
  MATRIX_OPTIONS: Bi,
  NUMBER_OPTIONS: Oi
});
function Bo() {
  return !0;
}
function qr() {
  return !1;
}
function Ht() {
}
const Oo = "Argument is not a typed-function.";
function kf() {
  function r($) {
    return typeof $ == "object" && $ !== null && $.constructor === Object;
  }
  const e = [{
    name: "number",
    test: function($) {
      return typeof $ == "number";
    }
  }, {
    name: "string",
    test: function($) {
      return typeof $ == "string";
    }
  }, {
    name: "boolean",
    test: function($) {
      return typeof $ == "boolean";
    }
  }, {
    name: "Function",
    test: function($) {
      return typeof $ == "function";
    }
  }, {
    name: "Array",
    test: Array.isArray
  }, {
    name: "Date",
    test: function($) {
      return $ instanceof Date;
    }
  }, {
    name: "RegExp",
    test: function($) {
      return $ instanceof RegExp;
    }
  }, {
    name: "Object",
    test: r
  }, {
    name: "null",
    test: function($) {
      return $ === null;
    }
  }, {
    name: "undefined",
    test: function($) {
      return $ === void 0;
    }
  }], t = {
    name: "any",
    test: Bo,
    isAny: !0
  };
  let n, a, i = 0, s = {
    createCount: 0
  };
  function l($) {
    const H = n.get($);
    if (H)
      return H;
    let Y = 'Unknown type "' + $ + '"';
    const K = $.toLowerCase();
    let te;
    for (te of a)
      if (te.toLowerCase() === K) {
        Y += '. Did you mean "' + te + '" ?';
        break;
      }
    throw new TypeError(Y);
  }
  function c($) {
    let H = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "any";
    const Y = H ? l(H).index : a.length, K = [];
    for (let se = 0; se < $.length; ++se) {
      if (!$[se] || typeof $[se].name != "string" || typeof $[se].test != "function")
        throw new TypeError("Object with properties {name: string, test: function} expected");
      const fe = $[se].name;
      if (n.has(fe))
        throw new TypeError('Duplicate type name "' + fe + '"');
      K.push(fe), n.set(fe, {
        name: fe,
        test: $[se].test,
        isAny: $[se].isAny,
        index: Y + se,
        conversionsTo: []
        // Newly added type can't have any conversions to it
      });
    }
    const te = a.slice(Y);
    a = a.slice(0, Y).concat(K).concat(te);
    for (let se = Y + K.length; se < a.length; ++se)
      n.get(a[se]).index = se;
  }
  function o() {
    n = /* @__PURE__ */ new Map(), a = [], i = 0, c([t], !1);
  }
  o(), c(e);
  function u() {
    let $;
    for ($ of a)
      n.get($).conversionsTo = [];
    i = 0;
  }
  function f($) {
    const H = a.filter((Y) => {
      const K = n.get(Y);
      return !K.isAny && K.test($);
    });
    return H.length ? H : ["any"];
  }
  function m($) {
    return $ && typeof $ == "function" && "_typedFunctionData" in $;
  }
  function p($, H, Y) {
    if (!m($))
      throw new TypeError(Oo);
    const K = Y && Y.exact, te = Array.isArray(H) ? H.join(",") : H, se = w(te), fe = x(se);
    if (!K || fe in $.signatures) {
      const Me = $._typedFunctionData.signatureMap.get(fe);
      if (Me)
        return Me;
    }
    const ve = se.length;
    let ge;
    if (K) {
      ge = [];
      let Me;
      for (Me in $.signatures)
        ge.push($._typedFunctionData.signatureMap.get(Me));
    } else
      ge = $._typedFunctionData.signatures;
    for (let Me = 0; Me < ve; ++Me) {
      const Le = se[Me], Ie = [];
      let ar;
      for (ar of ge) {
        const C = S(ar.params, Me);
        if (!(!C || Le.restParam && !C.restParam)) {
          if (!C.hasAny) {
            const V = y(C);
            if (Le.types.some((ie) => !V.has(ie.name)))
              continue;
          }
          Ie.push(ar);
        }
      }
      if (ge = Ie, ge.length === 0) break;
    }
    let me;
    for (me of ge)
      if (me.params.length <= ve)
        return me;
    throw new TypeError("Signature not found (signature: " + ($.name || "unnamed") + "(" + x(se, ", ") + "))");
  }
  function d($, H, Y) {
    return p($, H, Y).implementation;
  }
  function v($, H) {
    const Y = l(H);
    if (Y.test($))
      return $;
    const K = Y.conversionsTo;
    if (K.length === 0)
      throw new Error("There are no conversions to " + H + " defined.");
    for (let te = 0; te < K.length; te++)
      if (l(K[te].from).test($))
        return K[te].convert($);
    throw new Error("Cannot convert " + $ + " to " + H);
  }
  function x($) {
    let H = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    return $.map((Y) => Y.name).join(H);
  }
  function h($) {
    const H = $.indexOf("...") === 0, K = (H ? $.length > 3 ? $.slice(3) : "any" : $).split("|").map((ve) => l(ve.trim()));
    let te = !1, se = H ? "..." : "";
    return {
      types: K.map(function(ve) {
        return te = ve.isAny || te, se += ve.name + "|", {
          name: ve.name,
          typeIndex: ve.index,
          test: ve.test,
          isAny: ve.isAny,
          conversion: null,
          conversionIndex: -1
        };
      }),
      name: se.slice(0, -1),
      // remove trailing '|' from above
      hasAny: te,
      hasConversion: !1,
      restParam: H
    };
  }
  function D($) {
    const H = $.types.map((fe) => fe.name), Y = P(H);
    let K = $.hasAny, te = $.name;
    const se = Y.map(function(fe) {
      const ve = l(fe.from);
      return K = ve.isAny || K, te += "|" + fe.from, {
        name: fe.from,
        typeIndex: ve.index,
        test: ve.test,
        isAny: ve.isAny,
        conversion: fe,
        conversionIndex: fe.index
      };
    });
    return {
      types: $.types.concat(se),
      name: te,
      hasAny: K,
      hasConversion: se.length > 0,
      restParam: $.restParam
    };
  }
  function y($) {
    return $.typeSet || ($.typeSet = /* @__PURE__ */ new Set(), $.types.forEach((H) => $.typeSet.add(H.name))), $.typeSet;
  }
  function w($) {
    const H = [];
    if (typeof $ != "string")
      throw new TypeError("Signatures must be strings");
    const Y = $.trim();
    if (Y === "")
      return H;
    const K = Y.split(",");
    for (let te = 0; te < K.length; ++te) {
      const se = h(K[te].trim());
      if (se.restParam && te !== K.length - 1)
        throw new SyntaxError('Unexpected rest parameter "' + K[te] + '": only allowed for the last parameter');
      if (se.types.length === 0)
        return null;
      H.push(se);
    }
    return H;
  }
  function b($) {
    const H = k($);
    return H ? H.restParam : !1;
  }
  function g($) {
    if (!$ || $.types.length === 0)
      return Bo;
    if ($.types.length === 1)
      return l($.types[0].name).test;
    if ($.types.length === 2) {
      const H = l($.types[0].name).test, Y = l($.types[1].name).test;
      return function(te) {
        return H(te) || Y(te);
      };
    } else {
      const H = $.types.map(function(Y) {
        return l(Y.name).test;
      });
      return function(K) {
        for (let te = 0; te < H.length; te++)
          if (H[te](K))
            return !0;
        return !1;
      };
    }
  }
  function N($) {
    let H, Y, K;
    if (b($)) {
      H = q($).map(g);
      const te = H.length, se = g(k($)), fe = function(ve) {
        for (let ge = te; ge < ve.length; ge++)
          if (!se(ve[ge]))
            return !1;
        return !0;
      };
      return function(ge) {
        for (let me = 0; me < H.length; me++)
          if (!H[me](ge[me]))
            return !1;
        return fe(ge) && ge.length >= te + 1;
      };
    } else
      return $.length === 0 ? function(se) {
        return se.length === 0;
      } : $.length === 1 ? (Y = g($[0]), function(se) {
        return Y(se[0]) && se.length === 1;
      }) : $.length === 2 ? (Y = g($[0]), K = g($[1]), function(se) {
        return Y(se[0]) && K(se[1]) && se.length === 2;
      }) : (H = $.map(g), function(se) {
        for (let fe = 0; fe < H.length; fe++)
          if (!H[fe](se[fe]))
            return !1;
        return se.length === H.length;
      });
  }
  function S($, H) {
    return H < $.length ? $[H] : b($) ? k($) : null;
  }
  function A($, H) {
    const Y = S($, H);
    return Y ? y(Y) : /* @__PURE__ */ new Set();
  }
  function E($) {
    return $.conversion === null || $.conversion === void 0;
  }
  function M($, H) {
    const Y = /* @__PURE__ */ new Set();
    return $.forEach((K) => {
      const te = A(K.params, H);
      let se;
      for (se of te)
        Y.add(se);
    }), Y.has("any") ? ["any"] : Array.from(Y);
  }
  function T($, H, Y) {
    let K, te;
    const se = $ || "unnamed";
    let fe = Y, ve;
    for (ve = 0; ve < H.length; ve++) {
      const Le = [];
      if (fe.forEach((Ie) => {
        const ar = S(Ie.params, ve), C = g(ar);
        (ve < Ie.params.length || b(Ie.params)) && C(H[ve]) && Le.push(Ie);
      }), Le.length === 0) {
        if (te = M(fe, ve), te.length > 0) {
          const Ie = f(H[ve]);
          return K = new TypeError("Unexpected type of argument in function " + se + " (expected: " + te.join(" or ") + ", actual: " + Ie.join(" | ") + ", index: " + ve + ")"), K.data = {
            category: "wrongType",
            fn: se,
            index: ve,
            actual: Ie,
            expected: te
          }, K;
        }
      } else
        fe = Le;
    }
    const ge = fe.map(function(Le) {
      return b(Le.params) ? 1 / 0 : Le.params.length;
    });
    if (H.length < Math.min.apply(null, ge))
      return te = M(fe, ve), K = new TypeError("Too few arguments in function " + se + " (expected: " + te.join(" or ") + ", index: " + H.length + ")"), K.data = {
        category: "tooFewArgs",
        fn: se,
        index: H.length,
        expected: te
      }, K;
    const me = Math.max.apply(null, ge);
    if (H.length > me)
      return K = new TypeError("Too many arguments in function " + se + " (expected: " + me + ", actual: " + H.length + ")"), K.data = {
        category: "tooManyArgs",
        fn: se,
        index: H.length,
        expectedLength: me
      }, K;
    const Me = [];
    for (let Le = 0; Le < H.length; ++Le)
      Me.push(f(H[Le]).join("|"));
    return K = new TypeError('Arguments of type "' + Me.join(", ") + '" do not match any of the defined signatures of function ' + se + "."), K.data = {
      category: "mismatch",
      actual: Me
    }, K;
  }
  function B($) {
    let H = a.length + 1;
    for (let Y = 0; Y < $.types.length; Y++)
      H = Math.min(H, $.types[Y].typeIndex);
    return H;
  }
  function I($) {
    let H = i + 1;
    for (let Y = 0; Y < $.types.length; Y++)
      E($.types[Y]) || (H = Math.min(H, $.types[Y].conversionIndex));
    return H;
  }
  function O($, H) {
    if ($.hasAny) {
      if (!H.hasAny)
        return 0.1;
    } else if (H.hasAny)
      return -0.1;
    if ($.restParam) {
      if (!H.restParam)
        return 0.01;
    } else if (H.restParam)
      return -0.01;
    const Y = B($) - B(H);
    if (Y < 0)
      return -1e-3;
    if (Y > 0)
      return 1e-3;
    const K = I($), te = I(H);
    if ($.hasConversion) {
      if (!H.hasConversion)
        return (1 + K) * 1e-6;
    } else if (H.hasConversion)
      return -(1 + te) * 1e-6;
    const se = K - te;
    return se < 0 ? -1e-7 : se > 0 ? 1e-7 : 0;
  }
  function _($, H) {
    const Y = $.params, K = H.params, te = k(Y), se = k(K), fe = b(Y), ve = b(K);
    if (fe && te.hasAny) {
      if (!ve || !se.hasAny)
        return 1e7;
    } else if (ve && se.hasAny)
      return -1e7;
    let ge = 0, me = 0, Me;
    for (Me of Y)
      Me.hasAny && ++ge, Me.hasConversion && ++me;
    let Le = 0, Ie = 0;
    for (Me of K)
      Me.hasAny && ++Le, Me.hasConversion && ++Ie;
    if (ge !== Le)
      return (ge - Le) * 1e6;
    if (fe && te.hasConversion) {
      if (!ve || !se.hasConversion)
        return 1e5;
    } else if (ve && se.hasConversion)
      return -1e5;
    if (me !== Ie)
      return (me - Ie) * 1e4;
    if (fe) {
      if (!ve)
        return 1e3;
    } else if (ve)
      return -1e3;
    const ar = (Y.length - K.length) * (fe ? -100 : 100);
    if (ar !== 0)
      return ar;
    const C = [];
    let V = 0;
    for (let Fe = 0; Fe < Y.length; ++Fe) {
      const lr = O(Y[Fe], K[Fe]);
      C.push(lr), V += lr;
    }
    if (V !== 0)
      return (V < 0 ? -10 : 10) + V;
    let ie, de = 9;
    const _e = de / (C.length + 1);
    for (ie of C) {
      if (ie !== 0)
        return (ie < 0 ? -de : de) + ie;
      de -= _e;
    }
    return 0;
  }
  function P($) {
    if ($.length === 0)
      return [];
    const H = $.map(l);
    if ($.length === 1) return H[0].conversionsTo;
    const Y = new Set($), K = /* @__PURE__ */ new Set();
    for (let se = 0; se < H.length; ++se)
      for (const fe of H[se].conversionsTo)
        Y.has(fe.from) || K.add(fe.from);
    const te = [];
    for (const se of K) {
      let fe = i + 1, ve = null;
      for (let ge = 0; ge < H.length; ++ge)
        for (const me of H[ge].conversionsTo)
          me.from === se && me.index < fe && (fe = me.index, ve = me);
      te.push(ve);
    }
    return te;
  }
  function W($, H) {
    let Y = H, K = "";
    if ($.some((se) => se.hasConversion)) {
      const se = b($), fe = $.map(L);
      K = fe.map((ve) => ve.name).join(";"), Y = function() {
        const ge = [], me = se ? arguments.length - 1 : arguments.length;
        for (let Me = 0; Me < me; Me++)
          ge[Me] = fe[Me](arguments[Me]);
        return se && (ge[me] = arguments[me].map(fe[me])), H.apply(this, ge);
      };
    }
    let te = Y;
    if (b($)) {
      const se = $.length - 1;
      te = function() {
        return Y.apply(this, Z(arguments, 0, se).concat([Z(arguments, se)]));
      };
    }
    return K && Object.defineProperty(te, "name", {
      value: K
    }), te;
  }
  function L($) {
    let H, Y, K, te;
    const se = [], fe = [];
    let ve = "";
    $.types.forEach(function(me) {
      me.conversion && (ve += me.conversion.from + "~>" + me.conversion.to + ",", se.push(l(me.conversion.from).test), fe.push(me.conversion.convert));
    }), ve ? ve = ve.slice(0, -1) : ve = "pass";
    let ge = (me) => me;
    switch (fe.length) {
      case 0:
        break;
      case 1:
        H = se[0], K = fe[0], ge = function(Me) {
          return H(Me) ? K(Me) : Me;
        };
        break;
      case 2:
        H = se[0], Y = se[1], K = fe[0], te = fe[1], ge = function(Me) {
          return H(Me) ? K(Me) : Y(Me) ? te(Me) : Me;
        };
        break;
      default:
        ge = function(Me) {
          for (let Le = 0; Le < fe.length; Le++)
            if (se[Le](Me))
              return fe[Le](Me);
          return Me;
        };
    }
    return Object.defineProperty(ge, "name", {
      value: ve
    }), ge;
  }
  function J($) {
    function H(Y, K, te) {
      if (K < Y.length) {
        const se = Y[K];
        let fe = [];
        if (se.restParam) {
          const ve = se.types.filter(E);
          ve.length < se.types.length && fe.push({
            types: ve,
            name: "..." + ve.map((ge) => ge.name).join("|"),
            hasAny: ve.some((ge) => ge.isAny),
            hasConversion: !1,
            restParam: !0
          }), fe.push(se);
        } else
          fe = se.types.map(function(ve) {
            return {
              types: [ve],
              name: ve.name,
              hasAny: ve.isAny,
              hasConversion: ve.conversion,
              restParam: !1
            };
          });
        return j(fe, function(ve) {
          return H(Y, K + 1, te.concat([ve]));
        });
      } else
        return [te];
    }
    return H($, 0, []);
  }
  function ee($, H) {
    const Y = Math.max($.length, H.length);
    for (let ve = 0; ve < Y; ve++) {
      const ge = A($, ve), me = A(H, ve);
      let Me = !1, Le;
      for (Le of me)
        if (ge.has(Le)) {
          Me = !0;
          break;
        }
      if (!Me)
        return !1;
    }
    const K = $.length, te = H.length, se = b($), fe = b(H);
    return se ? fe ? K === te : te >= K : fe ? K >= te : K === te;
  }
  function F($) {
    return $.map((H) => De(H) ? he(H.referToSelf.callback) : we(H) ? oe(H.referTo.references, H.referTo.callback) : H);
  }
  function G($, H, Y) {
    const K = [];
    let te;
    for (te of $) {
      let se = Y[te];
      if (typeof se != "number")
        throw new TypeError('No definition for referenced signature "' + te + '"');
      if (se = H[se], typeof se != "function")
        return !1;
      K.push(se);
    }
    return K;
  }
  function z($, H, Y) {
    const K = F($), te = new Array(K.length).fill(!1);
    let se = !0;
    for (; se; ) {
      se = !1;
      let fe = !0;
      for (let ve = 0; ve < K.length; ++ve) {
        if (te[ve]) continue;
        const ge = K[ve];
        if (De(ge))
          K[ve] = ge.referToSelf.callback(Y), K[ve].referToSelf = ge.referToSelf, te[ve] = !0, fe = !1;
        else if (we(ge)) {
          const me = G(ge.referTo.references, K, H);
          me ? (K[ve] = ge.referTo.callback.apply(this, me), K[ve].referTo = ge.referTo, te[ve] = !0, fe = !1) : se = !0;
        }
      }
      if (fe && se)
        throw new SyntaxError("Circular reference detected in resolving typed.referTo");
    }
    return K;
  }
  function le($) {
    const H = /\bthis(\(|\.signatures\b)/;
    Object.keys($).forEach((Y) => {
      const K = $[Y];
      if (H.test(K.toString()))
        throw new SyntaxError("Using `this` to self-reference a function is deprecated since typed-function@3. Use typed.referTo and typed.referToSelf instead.");
    });
  }
  function ne($, H) {
    if (s.createCount++, Object.keys(H).length === 0)
      throw new SyntaxError("No signatures provided");
    s.warnAgainstDeprecatedThis && le(H);
    const Y = [], K = [], te = {}, se = [];
    let fe;
    for (fe in H) {
      if (!Object.prototype.hasOwnProperty.call(H, fe))
        continue;
      const Qe = w(fe);
      if (!Qe) continue;
      Y.forEach(function(bn) {
        if (ee(bn, Qe))
          throw new TypeError('Conflicting signatures "' + x(bn) + '" and "' + x(Qe) + '".');
      }), Y.push(Qe);
      const Fr = K.length;
      K.push(H[fe]);
      const uv = Qe.map(D);
      let Ln;
      for (Ln of J(uv)) {
        const bn = x(Ln);
        se.push({
          params: Ln,
          name: bn,
          fn: Fr
        }), Ln.every((cv) => !cv.hasConversion) && (te[bn] = Fr);
      }
    }
    se.sort(_);
    const ve = z(K, te, yn);
    let ge;
    for (ge in te)
      Object.prototype.hasOwnProperty.call(te, ge) && (te[ge] = ve[te[ge]]);
    const me = [], Me = /* @__PURE__ */ new Map();
    for (ge of se)
      Me.has(ge.name) || (ge.fn = ve[ge.fn], me.push(ge), Me.set(ge.name, ge));
    const Le = me[0] && me[0].params.length <= 2 && !b(me[0].params), Ie = me[1] && me[1].params.length <= 2 && !b(me[1].params), ar = me[2] && me[2].params.length <= 2 && !b(me[2].params), C = me[3] && me[3].params.length <= 2 && !b(me[3].params), V = me[4] && me[4].params.length <= 2 && !b(me[4].params), ie = me[5] && me[5].params.length <= 2 && !b(me[5].params), de = Le && Ie && ar && C && V && ie;
    for (let Qe = 0; Qe < me.length; ++Qe)
      me[Qe].test = N(me[Qe].params);
    const _e = Le ? g(me[0].params[0]) : qr, Fe = Ie ? g(me[1].params[0]) : qr, lr = ar ? g(me[2].params[0]) : qr, pi = C ? g(me[3].params[0]) : qr, Rd = V ? g(me[4].params[0]) : qr, qd = ie ? g(me[5].params[0]) : qr, Pd = Le ? g(me[0].params[1]) : qr, Ud = Ie ? g(me[1].params[1]) : qr, Ld = ar ? g(me[2].params[1]) : qr, kd = C ? g(me[3].params[1]) : qr, Hd = V ? g(me[4].params[1]) : qr, Wd = ie ? g(me[5].params[1]) : qr;
    for (let Qe = 0; Qe < me.length; ++Qe)
      me[Qe].implementation = W(me[Qe].params, me[Qe].fn);
    const Gd = Le ? me[0].implementation : Ht, Vd = Ie ? me[1].implementation : Ht, Zd = ar ? me[2].implementation : Ht, Xd = C ? me[3].implementation : Ht, Yd = V ? me[4].implementation : Ht, Jd = ie ? me[5].implementation : Ht, Qd = Le ? me[0].params.length : -1, jd = Ie ? me[1].params.length : -1, Kd = ar ? me[2].params.length : -1, ev = C ? me[3].params.length : -1, rv = V ? me[4].params.length : -1, tv = ie ? me[5].params.length : -1, nv = de ? 6 : 0, av = me.length, iv = me.map((Qe) => Qe.test), ov = me.map((Qe) => Qe.implementation), sv = function() {
      for (let Fr = nv; Fr < av; Fr++)
        if (iv[Fr](arguments))
          return ov[Fr].apply(this, arguments);
      return s.onMismatch($, arguments, me);
    };
    function yn(Qe, Fr) {
      return arguments.length === Qd && _e(Qe) && Pd(Fr) ? Gd.apply(this, arguments) : arguments.length === jd && Fe(Qe) && Ud(Fr) ? Vd.apply(this, arguments) : arguments.length === Kd && lr(Qe) && Ld(Fr) ? Zd.apply(this, arguments) : arguments.length === ev && pi(Qe) && kd(Fr) ? Xd.apply(this, arguments) : arguments.length === rv && Rd(Qe) && Hd(Fr) ? Yd.apply(this, arguments) : arguments.length === tv && qd(Qe) && Wd(Fr) ? Jd.apply(this, arguments) : sv.apply(this, arguments);
    }
    try {
      Object.defineProperty(yn, "name", {
        value: $
      });
    } catch {
    }
    return yn.signatures = te, yn._typedFunctionData = {
      signatures: me,
      signatureMap: Me
    }, yn;
  }
  function ae($, H, Y) {
    throw T($, H, Y);
  }
  function q($) {
    return Z($, 0, $.length - 1);
  }
  function k($) {
    return $[$.length - 1];
  }
  function Z($, H, Y) {
    return Array.prototype.slice.call($, H, Y);
  }
  function Q($, H) {
    for (let Y = 0; Y < $.length; Y++)
      if (H($[Y]))
        return $[Y];
  }
  function j($, H) {
    return Array.prototype.concat.apply([], $.map(H));
  }
  function ce() {
    const $ = q(arguments).map((Y) => x(w(Y))), H = k(arguments);
    if (typeof H != "function")
      throw new TypeError("Callback function expected as last argument");
    return oe($, H);
  }
  function oe($, H) {
    return {
      referTo: {
        references: $,
        callback: H
      }
    };
  }
  function he($) {
    if (typeof $ != "function")
      throw new TypeError("Callback function expected as first argument");
    return {
      referToSelf: {
        callback: $
      }
    };
  }
  function we($) {
    return $ && typeof $.referTo == "object" && Array.isArray($.referTo.references) && typeof $.referTo.callback == "function";
  }
  function De($) {
    return $ && typeof $.referToSelf == "object" && typeof $.referToSelf.callback == "function";
  }
  function ye($, H) {
    if (!$)
      return H;
    if (H && H !== $) {
      const Y = new Error("Function names do not match (expected: " + $ + ", actual: " + H + ")");
      throw Y.data = {
        actual: H,
        expected: $
      }, Y;
    }
    return $;
  }
  function Ae($) {
    let H;
    for (const Y in $)
      Object.prototype.hasOwnProperty.call($, Y) && (m($[Y]) || typeof $[Y].signature == "string") && (H = ye(H, $[Y].name));
    return H;
  }
  function U($, H) {
    let Y;
    for (Y in H)
      if (Object.prototype.hasOwnProperty.call(H, Y)) {
        if (Y in $ && H[Y] !== $[Y]) {
          const K = new Error('Signature "' + Y + '" is defined twice');
          throw K.data = {
            signature: Y,
            sourceFunction: H[Y],
            destFunction: $[Y]
          }, K;
        }
        $[Y] = H[Y];
      }
  }
  const X = s;
  s = function($) {
    const H = typeof $ == "string", Y = H ? 1 : 0;
    let K = H ? $ : "";
    const te = {};
    for (let se = Y; se < arguments.length; ++se) {
      const fe = arguments[se];
      let ve = {}, ge;
      if (typeof fe == "function" ? (ge = fe.name, typeof fe.signature == "string" ? ve[fe.signature] = fe : m(fe) && (ve = fe.signatures)) : r(fe) && (ve = fe, H || (ge = Ae(fe))), Object.keys(ve).length === 0) {
        const me = new TypeError("Argument to 'typed' at index " + se + " is not a (typed) function, nor an object with signatures as keys and functions as values.");
        throw me.data = {
          index: se,
          argument: fe
        }, me;
      }
      H || (K = ye(K, ge)), U(te, ve);
    }
    return ne(K || "", te);
  }, s.create = kf, s.createCount = X.createCount, s.onMismatch = ae, s.throwMismatchError = ae, s.createError = T, s.clear = o, s.clearConversions = u, s.addTypes = c, s._findType = l, s.referTo = ce, s.referToSelf = he, s.convert = v, s.findSignature = p, s.find = d, s.isTypedFunction = m, s.warnAgainstDeprecatedThis = !0, s.addType = function($, H) {
    let Y = "any";
    H !== !1 && n.has("Object") && (Y = "Object"), s.addTypes([$], Y);
  };
  function re($) {
    if (!$ || typeof $.from != "string" || typeof $.to != "string" || typeof $.convert != "function")
      throw new TypeError("Object with properties {from: string, to: string, convert: function} expected");
    if ($.to === $.from)
      throw new SyntaxError('Illegal to define conversion from "' + $.from + '" to itself.');
  }
  return s.addConversion = function($) {
    let H = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      override: !1
    };
    re($);
    const Y = l($.to), K = Y.conversionsTo.find((te) => te.from === $.from);
    if (K)
      if (H && H.override)
        s.removeConversion({
          from: K.from,
          to: $.to,
          convert: K.convert
        });
      else
        throw new Error('There is already a conversion from "' + $.from + '" to "' + Y.name + '"');
    Y.conversionsTo.push({
      from: $.from,
      to: Y.name,
      convert: $.convert,
      index: i++
    });
  }, s.addConversions = function($, H) {
    $.forEach((Y) => s.addConversion(Y, H));
  }, s.removeConversion = function($) {
    re($);
    const H = l($.to), Y = Q(H.conversionsTo, (te) => te.from === $.from);
    if (!Y)
      throw new Error("Attempt to remove nonexistent conversion from " + $.from + " to " + $.to);
    if (Y.convert !== $.convert)
      throw new Error("Conversion to remove does not match existing conversion");
    const K = H.conversionsTo.indexOf(Y);
    H.conversionsTo.splice(K, 1);
  }, s.resolve = function($, H) {
    if (!m($))
      throw new TypeError(Oo);
    const Y = $._typedFunctionData.signatures;
    for (let K = 0; K < Y.length; ++K)
      if (Y[K].test(H))
        return Y[K];
    return null;
  }, s;
}
const Tn = kf();
function R(r, e, t, n) {
  function a(i) {
    var s = Sv(i, e.map(Hf));
    return Mv(r, e, i), t(s);
  }
  return a.isFactory = !0, a.fn = r, a.dependencies = e.slice().sort(), n && (a.meta = n), a;
}
function En(r) {
  return typeof r == "function" && typeof r.fn == "string" && Array.isArray(r.dependencies);
}
function Mv(r, e, t) {
  var n = e.filter((i) => !Cv(i)).every((i) => t[i] !== void 0);
  if (!n) {
    var a = e.filter((i) => t[i] === void 0);
    throw new Error('Cannot create function "'.concat(r, '", ') + "some dependencies are missing: ".concat(a.map((i) => '"'.concat(i, '"')).join(", "), "."));
  }
}
function Cv(r) {
  return r && r[0] === "?";
}
function Hf(r) {
  return r && r[0] === "?" ? r.slice(1) : r;
}
function Ne(r) {
  return typeof r == "boolean" ? !0 : isFinite(r) ? r === Math.round(r) : !1;
}
function St(r, e) {
  if (e.number === "bigint")
    try {
      BigInt(r);
    } catch {
      return e.numberFallback;
    }
  return e.number;
}
var yt = Math.sign || function(r) {
  return r > 0 ? 1 : r < 0 ? -1 : 0;
}, _v = Math.log2 || function(e) {
  return Math.log(e) / Math.LN2;
}, Tv = Math.log10 || function(e) {
  return Math.log(e) / Math.LN10;
}, Fv = Math.log1p || function(r) {
  return Math.log(r + 1);
}, Bv = Math.cbrt || function(e) {
  if (e === 0)
    return e;
  var t = e < 0, n;
  return t && (e = -e), isFinite(e) ? (n = Math.exp(Math.log(e) / 3), n = (e / (n * n) + 2 * n) / 3) : n = e, t ? -n : n;
}, Ov = Math.expm1 || function(e) {
  return e >= 2e-4 || e <= -2e-4 ? Math.exp(e) - 1 : e + e * e / 2 + e * e * e / 6;
};
function vi(r, e, t) {
  var n = {
    2: "0b",
    8: "0o",
    16: "0x"
  }, a = n[e], i = "";
  if (t) {
    if (t < 1)
      throw new Error("size must be in greater than 0");
    if (!Ne(t))
      throw new Error("size must be an integer");
    if (r > 2 ** (t - 1) - 1 || r < -(2 ** (t - 1)))
      throw new Error("Value must be in range [-2^".concat(t - 1, ", 2^").concat(t - 1, "-1]"));
    if (!Ne(r))
      throw new Error("Value must be an integer");
    r < 0 && (r = r + 2 ** t), i = "i".concat(t);
  }
  var s = "";
  return r < 0 && (r = -r, s = "-"), "".concat(s).concat(a).concat(r.toString(e)).concat(i);
}
function $t(r, e) {
  if (typeof e == "function")
    return e(r);
  if (r === 1 / 0)
    return "Infinity";
  if (r === -1 / 0)
    return "-Infinity";
  if (isNaN(r))
    return "NaN";
  var {
    notation: t,
    precision: n,
    wordSize: a
  } = Wf(e);
  switch (t) {
    case "fixed":
      return Gf(r, n);
    case "exponential":
      return Vf(r, n);
    case "engineering":
      return Iv(r, n);
    case "bin":
      return vi(r, 2, a);
    case "oct":
      return vi(r, 8, a);
    case "hex":
      return vi(r, 16, a);
    case "auto":
      return $v(r, n, e).replace(/((\.\d*?)(0+))($|e)/, function() {
        var i = arguments[2], s = arguments[4];
        return i !== "." ? i + s : s;
      });
    default:
      throw new Error('Unknown notation "' + t + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
  }
}
function Wf(r) {
  var e = "auto", t, n;
  if (r !== void 0)
    if (Re(r))
      t = r;
    else if ($e(r))
      t = r.toNumber();
    else if (qt(r))
      r.precision !== void 0 && (t = Io(r.precision, () => {
        throw new Error('Option "precision" must be a number or BigNumber');
      })), r.wordSize !== void 0 && (n = Io(r.wordSize, () => {
        throw new Error('Option "wordSize" must be a number or BigNumber');
      })), r.notation && (e = r.notation);
    else
      throw new Error("Unsupported type of options, number, BigNumber, or object expected");
  return {
    notation: e,
    precision: t,
    wordSize: n
  };
}
function Rn(r) {
  var e = String(r).toLowerCase().match(/^(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
  if (!e)
    throw new SyntaxError("Invalid number " + r);
  var t = e[1], n = e[2], a = parseFloat(e[4] || "0"), i = n.indexOf(".");
  a += i !== -1 ? i - 1 : n.length - 1;
  var s = n.replace(".", "").replace(/^0*/, function(l) {
    return a -= l.length, "";
  }).replace(/0*$/, "").split("").map(function(l) {
    return parseInt(l);
  });
  return s.length === 0 && (s.push(0), a++), {
    sign: t,
    coefficients: s,
    exponent: a
  };
}
function Iv(r, e) {
  if (isNaN(r) || !isFinite(r))
    return String(r);
  var t = Rn(r), n = Ka(t, e), a = n.exponent, i = n.coefficients, s = a % 3 === 0 ? a : a < 0 ? a - 3 - a % 3 : a - a % 3;
  if (Re(e))
    for (; e > i.length || a - s + 1 > i.length; )
      i.push(0);
  else
    for (var l = Math.abs(a - s) - (i.length - 1), c = 0; c < l; c++)
      i.push(0);
  for (var o = Math.abs(a - s), u = 1; o > 0; )
    u++, o--;
  var f = i.slice(u).join(""), m = Re(e) && f.length || f.match(/[1-9]/) ? "." + f : "", p = i.slice(0, u).join("") + m + "e" + (a >= 0 ? "+" : "") + s.toString();
  return n.sign + p;
}
function Gf(r, e) {
  if (isNaN(r) || !isFinite(r))
    return String(r);
  var t = Rn(r), n = typeof e == "number" ? Ka(t, t.exponent + 1 + e) : t, a = n.coefficients, i = n.exponent + 1, s = i + (e || 0);
  return a.length < s && (a = a.concat(rn(s - a.length))), i < 0 && (a = rn(-i + 1).concat(a), i = 1), i < a.length && a.splice(i, 0, i === 0 ? "0." : "."), n.sign + a.join("");
}
function Vf(r, e) {
  if (isNaN(r) || !isFinite(r))
    return String(r);
  var t = Rn(r), n = e ? Ka(t, e) : t, a = n.coefficients, i = n.exponent;
  a.length < e && (a = a.concat(rn(e - a.length)));
  var s = a.shift();
  return n.sign + s + (a.length > 0 ? "." + a.join("") : "") + "e" + (i >= 0 ? "+" : "") + i;
}
function $v(r, e, t) {
  if (isNaN(r) || !isFinite(r))
    return String(r);
  var n = $o(t?.lowerExp, -3), a = $o(t?.upperExp, 5), i = Rn(r), s = e ? Ka(i, e) : i;
  if (s.exponent < n || s.exponent >= a)
    return Vf(r, e);
  var l = s.coefficients, c = s.exponent;
  l.length < e && (l = l.concat(rn(e - l.length))), l = l.concat(rn(c - l.length + 1 + (l.length < e ? e - l.length : 0))), l = rn(-c).concat(l);
  var o = c > 0 ? c : 0;
  return o < l.length - 1 && l.splice(o + 1, 0, "."), s.sign + l.join("");
}
function Ka(r, e) {
  for (var t = {
    sign: r.sign,
    coefficients: r.coefficients,
    exponent: r.exponent
  }, n = t.coefficients; e <= 0; )
    n.unshift(0), t.exponent++, e++;
  if (n.length > e) {
    var a = n.splice(e, n.length - e);
    if (a[0] >= 5) {
      var i = e - 1;
      for (n[i]++; n[i] === 10; )
        n.pop(), i === 0 && (n.unshift(0), t.exponent++, i++), i--, n[i]++;
    }
  }
  return t;
}
function rn(r) {
  for (var e = [], t = 0; t < r; t++)
    e.push(0);
  return e;
}
function zv(r) {
  return r.toExponential().replace(/e.*$/, "").replace(/^0\.?0*|\./, "").length;
}
function dr(r, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e-8, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  if (t <= 0)
    throw new Error("Relative tolerance must be greater than 0");
  if (n < 0)
    throw new Error("Absolute tolerance must be at least 0");
  return isNaN(r) || isNaN(e) ? !1 : !isFinite(r) || !isFinite(e) ? r === e : r === e ? !0 : Math.abs(r - e) <= Math.max(t * Math.max(Math.abs(r), Math.abs(e)), n);
}
var Rv = Math.acosh || function(r) {
  return Math.log(Math.sqrt(r * r - 1) + r);
}, qv = Math.asinh || function(r) {
  return Math.log(Math.sqrt(r * r + 1) + r);
}, Pv = Math.atanh || function(r) {
  return Math.log((1 + r) / (1 - r)) / 2;
}, Uv = Math.cosh || function(r) {
  return (Math.exp(r) + Math.exp(-r)) / 2;
}, Lv = Math.sinh || function(r) {
  return (Math.exp(r) - Math.exp(-r)) / 2;
}, kv = Math.tanh || function(r) {
  var e = Math.exp(2 * r);
  return (e - 1) / (e + 1);
};
function Hv(r, e) {
  var t = !0, n = e > 0 ? !0 : e < 0 ? !1 : 1 / e === 1 / 0;
  return t ^ n ? -r : r;
}
function Io(r, e) {
  if (Re(r))
    return r;
  if ($e(r))
    return r.toNumber();
  e();
}
function $o(r, e) {
  return Re(r) ? r : $e(r) ? r.toNumber() : e;
}
var Zf = function() {
  return Zf = Tn.create, Tn;
}, Wv = ["?BigNumber", "?Complex", "?DenseMatrix", "?Fraction"], Xf = /* @__PURE__ */ R("typed", Wv, function(e) {
  var {
    BigNumber: t,
    Complex: n,
    DenseMatrix: a,
    Fraction: i
  } = e, s = Zf();
  return s.clear(), s.addTypes([
    {
      name: "number",
      test: Re
    },
    {
      name: "Complex",
      test: Zr
    },
    {
      name: "BigNumber",
      test: $e
    },
    {
      name: "bigint",
      test: en
    },
    {
      name: "Fraction",
      test: Rt
    },
    {
      name: "Unit",
      test: Er
    },
    // The following type matches a valid variable name, i.e., an alphanumeric
    // string starting with an alphabetic character. It is used (at least)
    // in the definition of the derivative() function, as the argument telling
    // what to differentiate over must (currently) be a variable.
    // TODO: deprecate the identifier type (it's not used anymore, see https://github.com/josdejong/mathjs/issues/3253)
    {
      name: "identifier",
      test: (l) => gr && /^(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC4\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])(?:[0-9A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC4\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])*$/.test(l)
    },
    {
      name: "string",
      test: gr
    },
    {
      name: "Chain",
      test: io
    },
    {
      name: "Array",
      test: Ye
    },
    {
      name: "Matrix",
      test: Ee
    },
    {
      name: "DenseMatrix",
      test: _n
    },
    {
      name: "SparseMatrix",
      test: gt
    },
    {
      name: "Range",
      test: ja
    },
    {
      name: "Index",
      test: $n
    },
    {
      name: "boolean",
      test: Cf
    },
    {
      name: "ResultSet",
      test: _f
    },
    {
      name: "Help",
      test: no
    },
    {
      name: "function",
      test: ao
    },
    {
      name: "Date",
      test: Tf
    },
    {
      name: "RegExp",
      test: Ff
    },
    {
      name: "null",
      test: Bf
    },
    {
      name: "undefined",
      test: Of
    },
    {
      name: "AccessorNode",
      test: wt
    },
    {
      name: "ArrayNode",
      test: zr
    },
    {
      name: "AssignmentNode",
      test: If
    },
    {
      name: "BlockNode",
      test: $f
    },
    {
      name: "ConditionalNode",
      test: zf
    },
    {
      name: "ConstantNode",
      test: We
    },
    {
      name: "FunctionNode",
      test: st
    },
    {
      name: "FunctionAssignmentNode",
      test: mn
    },
    {
      name: "IndexNode",
      test: Pt
    },
    {
      name: "Node",
      test: Xe
    },
    {
      name: "ObjectNode",
      test: zn
    },
    {
      name: "OperatorNode",
      test: ir
    },
    {
      name: "ParenthesisNode",
      test: et
    },
    {
      name: "RangeNode",
      test: Rf
    },
    {
      name: "RelationalNode",
      test: qf
    },
    {
      name: "SymbolNode",
      test: ur
    },
    {
      name: "Map",
      test: It
    },
    {
      name: "Object",
      test: qt
    }
    // order 'Object' last, it matches on other classes too
  ]), s.addConversions([{
    from: "number",
    to: "BigNumber",
    convert: function(c) {
      if (t || Hn(c), zv(c) > 15)
        throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + c + "). Use function bignumber(x) to convert to BigNumber.");
      return new t(c);
    }
  }, {
    from: "number",
    to: "Complex",
    convert: function(c) {
      return n || Wn(c), new n(c, 0);
    }
  }, {
    from: "BigNumber",
    to: "Complex",
    convert: function(c) {
      return n || Wn(c), new n(c.toNumber(), 0);
    }
  }, {
    from: "bigint",
    to: "number",
    convert: function(c) {
      if (c > Number.MAX_SAFE_INTEGER)
        throw new TypeError("Cannot implicitly convert bigint to number: value exceeds the max safe integer value (value: " + c + ")");
      return Number(c);
    }
  }, {
    from: "bigint",
    to: "BigNumber",
    convert: function(c) {
      return t || Hn(c), new t(c.toString());
    }
  }, {
    from: "bigint",
    to: "Fraction",
    convert: function(c) {
      return i || Gn(c), new i(c);
    }
  }, {
    from: "Fraction",
    to: "BigNumber",
    convert: function(c) {
      throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
    }
  }, {
    from: "Fraction",
    to: "Complex",
    convert: function(c) {
      return n || Wn(c), new n(c.valueOf(), 0);
    }
  }, {
    from: "number",
    to: "Fraction",
    convert: function(c) {
      i || Gn(c);
      var o = new i(c);
      if (o.valueOf() !== c)
        throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + c + "). Use function fraction(x) to convert to Fraction.");
      return o;
    }
  }, {
    // FIXME: add conversion from Fraction to number, for example for `sqrt(fraction(1,3))`
    //  from: 'Fraction',
    //  to: 'number',
    //  convert: function (x) {
    //    return x.valueOf()
    //  }
    // }, {
    from: "string",
    to: "number",
    convert: function(c) {
      var o = Number(c);
      if (isNaN(o))
        throw new Error('Cannot convert "' + c + '" to a number');
      return o;
    }
  }, {
    from: "string",
    to: "BigNumber",
    convert: function(c) {
      t || Hn(c);
      try {
        return new t(c);
      } catch {
        throw new Error('Cannot convert "' + c + '" to BigNumber');
      }
    }
  }, {
    from: "string",
    to: "bigint",
    convert: function(c) {
      try {
        return BigInt(c);
      } catch {
        throw new Error('Cannot convert "' + c + '" to BigInt');
      }
    }
  }, {
    from: "string",
    to: "Fraction",
    convert: function(c) {
      i || Gn(c);
      try {
        return new i(c);
      } catch {
        throw new Error('Cannot convert "' + c + '" to Fraction');
      }
    }
  }, {
    from: "string",
    to: "Complex",
    convert: function(c) {
      n || Wn(c);
      try {
        return new n(c);
      } catch {
        throw new Error('Cannot convert "' + c + '" to Complex');
      }
    }
  }, {
    from: "boolean",
    to: "number",
    convert: function(c) {
      return +c;
    }
  }, {
    from: "boolean",
    to: "BigNumber",
    convert: function(c) {
      return t || Hn(c), new t(+c);
    }
  }, {
    from: "boolean",
    to: "bigint",
    convert: function(c) {
      return BigInt(+c);
    }
  }, {
    from: "boolean",
    to: "Fraction",
    convert: function(c) {
      return i || Gn(c), new i(+c);
    }
  }, {
    from: "boolean",
    to: "string",
    convert: function(c) {
      return String(c);
    }
  }, {
    from: "Array",
    to: "Matrix",
    convert: function(c) {
      return a || Gv(), new a(c);
    }
  }, {
    from: "Matrix",
    to: "Array",
    convert: function(c) {
      return c.valueOf();
    }
  }]), s.onMismatch = (l, c, o) => {
    var u = s.createError(l, c, o);
    if (["wrongType", "mismatch"].includes(u.data.category) && c.length === 1 && Ir(c[0]) && // check if the function can be unary:
    o.some((m) => !m.params.includes(","))) {
      var f = new TypeError("Function '".concat(l, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(l, ")'."));
      throw f.data = u.data, f;
    }
    throw u;
  }, s.onMismatch = (l, c, o) => {
    var u = s.createError(l, c, o);
    if (["wrongType", "mismatch"].includes(u.data.category) && c.length === 1 && Ir(c[0]) && // check if the function can be unary:
    o.some((m) => !m.params.includes(","))) {
      var f = new TypeError("Function '".concat(l, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(l, ")'."));
      throw f.data = u.data, f;
    }
    throw u;
  }, s;
});
function Hn(r) {
  throw new Error("Cannot convert value ".concat(r, " into a BigNumber: no class 'BigNumber' provided"));
}
function Wn(r) {
  throw new Error("Cannot convert value ".concat(r, " into a Complex number: no class 'Complex' provided"));
}
function Gv() {
  throw new Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided");
}
function Gn(r) {
  throw new Error("Cannot convert value ".concat(r, " into a Fraction, no class 'Fraction' provided."));
}
var Vv = "ResultSet", Zv = [], Xv = /* @__PURE__ */ R(Vv, Zv, () => {
  function r(e) {
    if (!(this instanceof r))
      throw new SyntaxError("Constructor must be called with the new operator");
    this.entries = e || [];
  }
  return r.prototype.type = "ResultSet", r.prototype.isResultSet = !0, r.prototype.valueOf = function() {
    return this.entries;
  }, r.prototype.toString = function() {
    return "[" + this.entries.map(String).join(", ") + "]";
  }, r.prototype.toJSON = function() {
    return {
      mathjs: "ResultSet",
      entries: this.entries
    };
  }, r.fromJSON = function(e) {
    return new r(e.entries);
  }, r;
}, {
  isClass: !0
});
var Jt = 9e15, Et = 1e9, Ii = "0123456789abcdef", Ea = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", Ma = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", $i = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed at run-time using the `Decimal.config` method.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used when rounding to `precision`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The modulo mode used when calculating the modulus: a mod n.
  // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
  // The remainder (r) is calculated as: r = a - n * q.
  //
  // UP         0 The remainder is positive if the dividend is negative, else is negative.
  // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
  // FLOOR      3 The remainder has the same sign as the divisor (Python %).
  // HALF_EVEN  6 The IEEE 754 remainder function.
  // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
  //
  // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
  // division (9) are commonly used for the modulus operation. The other rounding modes can also
  // be used, but they may not give useful results.
  modulo: 1,
  // 0 to 9
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -EXP_LIMIT
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to EXP_LIMIT
  // The minimum exponent value, beneath which underflow to zero occurs.
  // JavaScript numbers: -324  (5e-324)
  minE: -Jt,
  // -1 to -EXP_LIMIT
  // The maximum exponent value, above which overflow to Infinity occurs.
  // JavaScript numbers: 308  (1.7976931348623157e+308)
  maxE: Jt,
  // 1 to EXP_LIMIT
  // Whether to use cryptographically-secure random number generation, if available.
  crypto: !1
  // true/false
}, Yf, it, qe = !0, ei = "[DecimalError] ", Dt = ei + "Invalid argument: ", Jf = ei + "Precision limit exceeded", Qf = ei + "crypto unavailable", jf = "[object Decimal]", Dr = Math.floor, sr = Math.pow, Yv = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, Jv = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, Qv = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, Kf = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, Xr = 1e7, Be = 7, jv = 9007199254740991, Kv = Ea.length - 1, zi = Ma.length - 1, pe = { toStringTag: jf };
pe.absoluteValue = pe.abs = function() {
  var r = new this.constructor(this);
  return r.s < 0 && (r.s = 1), Ce(r);
};
pe.ceil = function() {
  return Ce(new this.constructor(this), this.e + 1, 2);
};
pe.clampedTo = pe.clamp = function(r, e) {
  var t, n = this, a = n.constructor;
  if (r = new a(r), e = new a(e), !r.s || !e.s) return new a(NaN);
  if (r.gt(e)) throw Error(Dt + e);
  return t = n.cmp(r), t < 0 ? r : n.cmp(e) > 0 ? e : new a(n);
};
pe.comparedTo = pe.cmp = function(r) {
  var e, t, n, a, i = this, s = i.d, l = (r = new i.constructor(r)).d, c = i.s, o = r.s;
  if (!s || !l)
    return !c || !o ? NaN : c !== o ? c : s === l ? 0 : !s ^ c < 0 ? 1 : -1;
  if (!s[0] || !l[0]) return s[0] ? c : l[0] ? -o : 0;
  if (c !== o) return c;
  if (i.e !== r.e) return i.e > r.e ^ c < 0 ? 1 : -1;
  for (n = s.length, a = l.length, e = 0, t = n < a ? n : a; e < t; ++e)
    if (s[e] !== l[e]) return s[e] > l[e] ^ c < 0 ? 1 : -1;
  return n === a ? 0 : n > a ^ c < 0 ? 1 : -1;
};
pe.cosine = pe.cos = function() {
  var r, e, t = this, n = t.constructor;
  return t.d ? t.d[0] ? (r = n.precision, e = n.rounding, n.precision = r + Math.max(t.e, t.sd()) + Be, n.rounding = 1, t = eh(n, am(n, t)), n.precision = r, n.rounding = e, Ce(it == 2 || it == 3 ? t.neg() : t, r, e, !0)) : new n(1) : new n(NaN);
};
pe.cubeRoot = pe.cbrt = function() {
  var r, e, t, n, a, i, s, l, c, o, u = this, f = u.constructor;
  if (!u.isFinite() || u.isZero()) return new f(u);
  for (qe = !1, i = u.s * sr(u.s * u, 1 / 3), !i || Math.abs(i) == 1 / 0 ? (t = yr(u.d), r = u.e, (i = (r - t.length + 1) % 3) && (t += i == 1 || i == -2 ? "0" : "00"), i = sr(t, 1 / 3), r = Dr((r + 1) / 3) - (r % 3 == (r < 0 ? -1 : 2)), i == 1 / 0 ? t = "5e" + r : (t = i.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + r), n = new f(t), n.s = u.s) : n = new f(i.toString()), s = (r = f.precision) + 3; ; )
    if (l = n, c = l.times(l).times(l), o = c.plus(u), n = tr(o.plus(u).times(l), o.plus(c), s + 2, 1), yr(l.d).slice(0, s) === (t = yr(n.d)).slice(0, s))
      if (t = t.slice(s - 3, s + 1), t == "9999" || !a && t == "4999") {
        if (!a && (Ce(l, r + 1, 0), l.times(l).times(l).eq(u))) {
          n = l;
          break;
        }
        s += 4, a = 1;
      } else {
        (!+t || !+t.slice(1) && t.charAt(0) == "5") && (Ce(n, r + 1, 1), e = !n.times(n).times(n).eq(u));
        break;
      }
  return qe = !0, Ce(n, r, f.rounding, e);
};
pe.decimalPlaces = pe.dp = function() {
  var r, e = this.d, t = NaN;
  if (e) {
    if (r = e.length - 1, t = (r - Dr(this.e / Be)) * Be, r = e[r], r) for (; r % 10 == 0; r /= 10) t--;
    t < 0 && (t = 0);
  }
  return t;
};
pe.dividedBy = pe.div = function(r) {
  return tr(this, new this.constructor(r));
};
pe.dividedToIntegerBy = pe.divToInt = function(r) {
  var e = this, t = e.constructor;
  return Ce(tr(e, new t(r), 0, 1, 1), t.precision, t.rounding);
};
pe.equals = pe.eq = function(r) {
  return this.cmp(r) === 0;
};
pe.floor = function() {
  return Ce(new this.constructor(this), this.e + 1, 3);
};
pe.greaterThan = pe.gt = function(r) {
  return this.cmp(r) > 0;
};
pe.greaterThanOrEqualTo = pe.gte = function(r) {
  var e = this.cmp(r);
  return e == 1 || e === 0;
};
pe.hyperbolicCosine = pe.cosh = function() {
  var r, e, t, n, a, i = this, s = i.constructor, l = new s(1);
  if (!i.isFinite()) return new s(i.s ? 1 / 0 : NaN);
  if (i.isZero()) return l;
  t = s.precision, n = s.rounding, s.precision = t + Math.max(i.e, i.sd()) + 4, s.rounding = 1, a = i.d.length, a < 32 ? (r = Math.ceil(a / 3), e = (1 / ti(4, r)).toString()) : (r = 16, e = "2.3283064365386962890625e-10"), i = on(s, 1, i.times(e), new s(1), !0);
  for (var c, o = r, u = new s(8); o--; )
    c = i.times(i), i = l.minus(c.times(u.minus(c.times(u))));
  return Ce(i, s.precision = t, s.rounding = n, !0);
};
pe.hyperbolicSine = pe.sinh = function() {
  var r, e, t, n, a = this, i = a.constructor;
  if (!a.isFinite() || a.isZero()) return new i(a);
  if (e = i.precision, t = i.rounding, i.precision = e + Math.max(a.e, a.sd()) + 4, i.rounding = 1, n = a.d.length, n < 3)
    a = on(i, 2, a, a, !0);
  else {
    r = 1.4 * Math.sqrt(n), r = r > 16 ? 16 : r | 0, a = a.times(1 / ti(5, r)), a = on(i, 2, a, a, !0);
    for (var s, l = new i(5), c = new i(16), o = new i(20); r--; )
      s = a.times(a), a = a.times(l.plus(s.times(c.times(s).plus(o))));
  }
  return i.precision = e, i.rounding = t, Ce(a, e, t, !0);
};
pe.hyperbolicTangent = pe.tanh = function() {
  var r, e, t = this, n = t.constructor;
  return t.isFinite() ? t.isZero() ? new n(t) : (r = n.precision, e = n.rounding, n.precision = r + 7, n.rounding = 1, tr(t.sinh(), t.cosh(), n.precision = r, n.rounding = e)) : new n(t.s);
};
pe.inverseCosine = pe.acos = function() {
  var r = this, e = r.constructor, t = r.abs().cmp(1), n = e.precision, a = e.rounding;
  return t !== -1 ? t === 0 ? r.isNeg() ? jr(e, n, a) : new e(0) : new e(NaN) : r.isZero() ? jr(e, n + 4, a).times(0.5) : (e.precision = n + 6, e.rounding = 1, r = new e(1).minus(r).div(r.plus(1)).sqrt().atan(), e.precision = n, e.rounding = a, r.times(2));
};
pe.inverseHyperbolicCosine = pe.acosh = function() {
  var r, e, t = this, n = t.constructor;
  return t.lte(1) ? new n(t.eq(1) ? 0 : NaN) : t.isFinite() ? (r = n.precision, e = n.rounding, n.precision = r + Math.max(Math.abs(t.e), t.sd()) + 4, n.rounding = 1, qe = !1, t = t.times(t).minus(1).sqrt().plus(t), qe = !0, n.precision = r, n.rounding = e, t.ln()) : new n(t);
};
pe.inverseHyperbolicSine = pe.asinh = function() {
  var r, e, t = this, n = t.constructor;
  return !t.isFinite() || t.isZero() ? new n(t) : (r = n.precision, e = n.rounding, n.precision = r + 2 * Math.max(Math.abs(t.e), t.sd()) + 6, n.rounding = 1, qe = !1, t = t.times(t).plus(1).sqrt().plus(t), qe = !0, n.precision = r, n.rounding = e, t.ln());
};
pe.inverseHyperbolicTangent = pe.atanh = function() {
  var r, e, t, n, a = this, i = a.constructor;
  return a.isFinite() ? a.e >= 0 ? new i(a.abs().eq(1) ? a.s / 0 : a.isZero() ? a : NaN) : (r = i.precision, e = i.rounding, n = a.sd(), Math.max(n, r) < 2 * -a.e - 1 ? Ce(new i(a), r, e, !0) : (i.precision = t = n - a.e, a = tr(a.plus(1), new i(1).minus(a), t + r, 1), i.precision = r + 4, i.rounding = 1, a = a.ln(), i.precision = r, i.rounding = e, a.times(0.5))) : new i(NaN);
};
pe.inverseSine = pe.asin = function() {
  var r, e, t, n, a = this, i = a.constructor;
  return a.isZero() ? new i(a) : (e = a.abs().cmp(1), t = i.precision, n = i.rounding, e !== -1 ? e === 0 ? (r = jr(i, t + 4, n).times(0.5), r.s = a.s, r) : new i(NaN) : (i.precision = t + 6, i.rounding = 1, a = a.div(new i(1).minus(a.times(a)).sqrt().plus(1)).atan(), i.precision = t, i.rounding = n, a.times(2)));
};
pe.inverseTangent = pe.atan = function() {
  var r, e, t, n, a, i, s, l, c, o = this, u = o.constructor, f = u.precision, m = u.rounding;
  if (o.isFinite()) {
    if (o.isZero())
      return new u(o);
    if (o.abs().eq(1) && f + 4 <= zi)
      return s = jr(u, f + 4, m).times(0.25), s.s = o.s, s;
  } else {
    if (!o.s) return new u(NaN);
    if (f + 4 <= zi)
      return s = jr(u, f + 4, m).times(0.5), s.s = o.s, s;
  }
  for (u.precision = l = f + 10, u.rounding = 1, t = Math.min(28, l / Be + 2 | 0), r = t; r; --r) o = o.div(o.times(o).plus(1).sqrt().plus(1));
  for (qe = !1, e = Math.ceil(l / Be), n = 1, c = o.times(o), s = new u(o), a = o; r !== -1; )
    if (a = a.times(c), i = s.minus(a.div(n += 2)), a = a.times(c), s = i.plus(a.div(n += 2)), s.d[e] !== void 0) for (r = e; s.d[r] === i.d[r] && r--; ) ;
  return t && (s = s.times(2 << t - 1)), qe = !0, Ce(s, u.precision = f, u.rounding = m, !0);
};
pe.isFinite = function() {
  return !!this.d;
};
pe.isInteger = pe.isInt = function() {
  return !!this.d && Dr(this.e / Be) > this.d.length - 2;
};
pe.isNaN = function() {
  return !this.s;
};
pe.isNegative = pe.isNeg = function() {
  return this.s < 0;
};
pe.isPositive = pe.isPos = function() {
  return this.s > 0;
};
pe.isZero = function() {
  return !!this.d && this.d[0] === 0;
};
pe.lessThan = pe.lt = function(r) {
  return this.cmp(r) < 0;
};
pe.lessThanOrEqualTo = pe.lte = function(r) {
  return this.cmp(r) < 1;
};
pe.logarithm = pe.log = function(r) {
  var e, t, n, a, i, s, l, c, o = this, u = o.constructor, f = u.precision, m = u.rounding, p = 5;
  if (r == null)
    r = new u(10), e = !0;
  else {
    if (r = new u(r), t = r.d, r.s < 0 || !t || !t[0] || r.eq(1)) return new u(NaN);
    e = r.eq(10);
  }
  if (t = o.d, o.s < 0 || !t || !t[0] || o.eq(1))
    return new u(t && !t[0] ? -1 / 0 : o.s != 1 ? NaN : t ? 0 : 1 / 0);
  if (e)
    if (t.length > 1)
      i = !0;
    else {
      for (a = t[0]; a % 10 === 0; ) a /= 10;
      i = a !== 1;
    }
  if (qe = !1, l = f + p, s = bt(o, l), n = e ? Ca(u, l + 10) : bt(r, l), c = tr(s, n, l, 1), Fn(c.d, a = f, m))
    do
      if (l += 10, s = bt(o, l), n = e ? Ca(u, l + 10) : bt(r, l), c = tr(s, n, l, 1), !i) {
        +yr(c.d).slice(a + 1, a + 15) + 1 == 1e14 && (c = Ce(c, f + 1, 0));
        break;
      }
    while (Fn(c.d, a += 10, m));
  return qe = !0, Ce(c, f, m);
};
pe.minus = pe.sub = function(r) {
  var e, t, n, a, i, s, l, c, o, u, f, m, p = this, d = p.constructor;
  if (r = new d(r), !p.d || !r.d)
    return !p.s || !r.s ? r = new d(NaN) : p.d ? r.s = -r.s : r = new d(r.d || p.s !== r.s ? p : NaN), r;
  if (p.s != r.s)
    return r.s = -r.s, p.plus(r);
  if (o = p.d, m = r.d, l = d.precision, c = d.rounding, !o[0] || !m[0]) {
    if (m[0]) r.s = -r.s;
    else if (o[0]) r = new d(p);
    else return new d(c === 3 ? -0 : 0);
    return qe ? Ce(r, l, c) : r;
  }
  if (t = Dr(r.e / Be), u = Dr(p.e / Be), o = o.slice(), i = u - t, i) {
    for (f = i < 0, f ? (e = o, i = -i, s = m.length) : (e = m, t = u, s = o.length), n = Math.max(Math.ceil(l / Be), s) + 2, i > n && (i = n, e.length = 1), e.reverse(), n = i; n--; ) e.push(0);
    e.reverse();
  } else {
    for (n = o.length, s = m.length, f = n < s, f && (s = n), n = 0; n < s; n++)
      if (o[n] != m[n]) {
        f = o[n] < m[n];
        break;
      }
    i = 0;
  }
  for (f && (e = o, o = m, m = e, r.s = -r.s), s = o.length, n = m.length - s; n > 0; --n) o[s++] = 0;
  for (n = m.length; n > i; ) {
    if (o[--n] < m[n]) {
      for (a = n; a && o[--a] === 0; ) o[a] = Xr - 1;
      --o[a], o[n] += Xr;
    }
    o[n] -= m[n];
  }
  for (; o[--s] === 0; ) o.pop();
  for (; o[0] === 0; o.shift()) --t;
  return o[0] ? (r.d = o, r.e = ri(o, t), qe ? Ce(r, l, c) : r) : new d(c === 3 ? -0 : 0);
};
pe.modulo = pe.mod = function(r) {
  var e, t = this, n = t.constructor;
  return r = new n(r), !t.d || !r.s || r.d && !r.d[0] ? new n(NaN) : !r.d || t.d && !t.d[0] ? Ce(new n(t), n.precision, n.rounding) : (qe = !1, n.modulo == 9 ? (e = tr(t, r.abs(), 0, 3, 1), e.s *= r.s) : e = tr(t, r, 0, n.modulo, 1), e = e.times(r), qe = !0, t.minus(e));
};
pe.naturalExponential = pe.exp = function() {
  return Ri(this);
};
pe.naturalLogarithm = pe.ln = function() {
  return bt(this);
};
pe.negated = pe.neg = function() {
  var r = new this.constructor(this);
  return r.s = -r.s, Ce(r);
};
pe.plus = pe.add = function(r) {
  var e, t, n, a, i, s, l, c, o, u, f = this, m = f.constructor;
  if (r = new m(r), !f.d || !r.d)
    return !f.s || !r.s ? r = new m(NaN) : f.d || (r = new m(r.d || f.s === r.s ? f : NaN)), r;
  if (f.s != r.s)
    return r.s = -r.s, f.minus(r);
  if (o = f.d, u = r.d, l = m.precision, c = m.rounding, !o[0] || !u[0])
    return u[0] || (r = new m(f)), qe ? Ce(r, l, c) : r;
  if (i = Dr(f.e / Be), n = Dr(r.e / Be), o = o.slice(), a = i - n, a) {
    for (a < 0 ? (t = o, a = -a, s = u.length) : (t = u, n = i, s = o.length), i = Math.ceil(l / Be), s = i > s ? i + 1 : s + 1, a > s && (a = s, t.length = 1), t.reverse(); a--; ) t.push(0);
    t.reverse();
  }
  for (s = o.length, a = u.length, s - a < 0 && (a = s, t = u, u = o, o = t), e = 0; a; )
    e = (o[--a] = o[a] + u[a] + e) / Xr | 0, o[a] %= Xr;
  for (e && (o.unshift(e), ++n), s = o.length; o[--s] == 0; ) o.pop();
  return r.d = o, r.e = ri(o, n), qe ? Ce(r, l, c) : r;
};
pe.precision = pe.sd = function(r) {
  var e, t = this;
  if (r !== void 0 && r !== !!r && r !== 1 && r !== 0) throw Error(Dt + r);
  return t.d ? (e = em(t.d), r && t.e + 1 > e && (e = t.e + 1)) : e = NaN, e;
};
pe.round = function() {
  var r = this, e = r.constructor;
  return Ce(new e(r), r.e + 1, e.rounding);
};
pe.sine = pe.sin = function() {
  var r, e, t = this, n = t.constructor;
  return t.isFinite() ? t.isZero() ? new n(t) : (r = n.precision, e = n.rounding, n.precision = r + Math.max(t.e, t.sd()) + Be, n.rounding = 1, t = th(n, am(n, t)), n.precision = r, n.rounding = e, Ce(it > 2 ? t.neg() : t, r, e, !0)) : new n(NaN);
};
pe.squareRoot = pe.sqrt = function() {
  var r, e, t, n, a, i, s = this, l = s.d, c = s.e, o = s.s, u = s.constructor;
  if (o !== 1 || !l || !l[0])
    return new u(!o || o < 0 && (!l || l[0]) ? NaN : l ? s : 1 / 0);
  for (qe = !1, o = Math.sqrt(+s), o == 0 || o == 1 / 0 ? (e = yr(l), (e.length + c) % 2 == 0 && (e += "0"), o = Math.sqrt(e), c = Dr((c + 1) / 2) - (c < 0 || c % 2), o == 1 / 0 ? e = "5e" + c : (e = o.toExponential(), e = e.slice(0, e.indexOf("e") + 1) + c), n = new u(e)) : n = new u(o.toString()), t = (c = u.precision) + 3; ; )
    if (i = n, n = i.plus(tr(s, i, t + 2, 1)).times(0.5), yr(i.d).slice(0, t) === (e = yr(n.d)).slice(0, t))
      if (e = e.slice(t - 3, t + 1), e == "9999" || !a && e == "4999") {
        if (!a && (Ce(i, c + 1, 0), i.times(i).eq(s))) {
          n = i;
          break;
        }
        t += 4, a = 1;
      } else {
        (!+e || !+e.slice(1) && e.charAt(0) == "5") && (Ce(n, c + 1, 1), r = !n.times(n).eq(s));
        break;
      }
  return qe = !0, Ce(n, c, u.rounding, r);
};
pe.tangent = pe.tan = function() {
  var r, e, t = this, n = t.constructor;
  return t.isFinite() ? t.isZero() ? new n(t) : (r = n.precision, e = n.rounding, n.precision = r + 10, n.rounding = 1, t = t.sin(), t.s = 1, t = tr(t, new n(1).minus(t.times(t)).sqrt(), r + 10, 0), n.precision = r, n.rounding = e, Ce(it == 2 || it == 4 ? t.neg() : t, r, e, !0)) : new n(NaN);
};
pe.times = pe.mul = function(r) {
  var e, t, n, a, i, s, l, c, o, u = this, f = u.constructor, m = u.d, p = (r = new f(r)).d;
  if (r.s *= u.s, !m || !m[0] || !p || !p[0])
    return new f(!r.s || m && !m[0] && !p || p && !p[0] && !m ? NaN : !m || !p ? r.s / 0 : r.s * 0);
  for (t = Dr(u.e / Be) + Dr(r.e / Be), c = m.length, o = p.length, c < o && (i = m, m = p, p = i, s = c, c = o, o = s), i = [], s = c + o, n = s; n--; ) i.push(0);
  for (n = o; --n >= 0; ) {
    for (e = 0, a = c + n; a > n; )
      l = i[a] + p[n] * m[a - n - 1] + e, i[a--] = l % Xr | 0, e = l / Xr | 0;
    i[a] = (i[a] + e) % Xr | 0;
  }
  for (; !i[--s]; ) i.pop();
  return e ? ++t : i.shift(), r.d = i, r.e = ri(i, t), qe ? Ce(r, f.precision, f.rounding) : r;
};
pe.toBinary = function(r, e) {
  return oo(this, 2, r, e);
};
pe.toDecimalPlaces = pe.toDP = function(r, e) {
  var t = this, n = t.constructor;
  return t = new n(t), r === void 0 ? t : ($r(r, 0, Et), e === void 0 ? e = n.rounding : $r(e, 0, 8), Ce(t, r + t.e + 1, e));
};
pe.toExponential = function(r, e) {
  var t, n = this, a = n.constructor;
  return r === void 0 ? t = rt(n, !0) : ($r(r, 0, Et), e === void 0 ? e = a.rounding : $r(e, 0, 8), n = Ce(new a(n), r + 1, e), t = rt(n, !0, r + 1)), n.isNeg() && !n.isZero() ? "-" + t : t;
};
pe.toFixed = function(r, e) {
  var t, n, a = this, i = a.constructor;
  return r === void 0 ? t = rt(a) : ($r(r, 0, Et), e === void 0 ? e = i.rounding : $r(e, 0, 8), n = Ce(new i(a), r + a.e + 1, e), t = rt(n, !1, r + n.e + 1)), a.isNeg() && !a.isZero() ? "-" + t : t;
};
pe.toFraction = function(r) {
  var e, t, n, a, i, s, l, c, o, u, f, m, p = this, d = p.d, v = p.constructor;
  if (!d) return new v(p);
  if (o = t = new v(1), n = c = new v(0), e = new v(n), i = e.e = em(d) - p.e - 1, s = i % Be, e.d[0] = sr(10, s < 0 ? Be + s : s), r == null)
    r = i > 0 ? e : o;
  else {
    if (l = new v(r), !l.isInt() || l.lt(o)) throw Error(Dt + l);
    r = l.gt(e) ? i > 0 ? e : o : l;
  }
  for (qe = !1, l = new v(yr(d)), u = v.precision, v.precision = i = d.length * Be * 2; f = tr(l, e, 0, 1, 1), a = t.plus(f.times(n)), a.cmp(r) != 1; )
    t = n, n = a, a = o, o = c.plus(f.times(a)), c = a, a = e, e = l.minus(f.times(a)), l = a;
  return a = tr(r.minus(t), n, 0, 1, 1), c = c.plus(a.times(o)), t = t.plus(a.times(n)), c.s = o.s = p.s, m = tr(o, n, i, 1).minus(p).abs().cmp(tr(c, t, i, 1).minus(p).abs()) < 1 ? [o, n] : [c, t], v.precision = u, qe = !0, m;
};
pe.toHexadecimal = pe.toHex = function(r, e) {
  return oo(this, 16, r, e);
};
pe.toNearest = function(r, e) {
  var t = this, n = t.constructor;
  if (t = new n(t), r == null) {
    if (!t.d) return t;
    r = new n(1), e = n.rounding;
  } else {
    if (r = new n(r), e === void 0 ? e = n.rounding : $r(e, 0, 8), !t.d) return r.s ? t : r;
    if (!r.d)
      return r.s && (r.s = t.s), r;
  }
  return r.d[0] ? (qe = !1, t = tr(t, r, 0, e, 1).times(r), qe = !0, Ce(t)) : (r.s = t.s, t = r), t;
};
pe.toNumber = function() {
  return +this;
};
pe.toOctal = function(r, e) {
  return oo(this, 8, r, e);
};
pe.toPower = pe.pow = function(r) {
  var e, t, n, a, i, s, l = this, c = l.constructor, o = +(r = new c(r));
  if (!l.d || !r.d || !l.d[0] || !r.d[0]) return new c(sr(+l, o));
  if (l = new c(l), l.eq(1)) return l;
  if (n = c.precision, i = c.rounding, r.eq(1)) return Ce(l, n, i);
  if (e = Dr(r.e / Be), e >= r.d.length - 1 && (t = o < 0 ? -o : o) <= jv)
    return a = rm(c, l, t, n), r.s < 0 ? new c(1).div(a) : Ce(a, n, i);
  if (s = l.s, s < 0) {
    if (e < r.d.length - 1) return new c(NaN);
    if ((r.d[e] & 1) == 0 && (s = 1), l.e == 0 && l.d[0] == 1 && l.d.length == 1)
      return l.s = s, l;
  }
  return t = sr(+l, o), e = t == 0 || !isFinite(t) ? Dr(o * (Math.log("0." + yr(l.d)) / Math.LN10 + l.e + 1)) : new c(t + "").e, e > c.maxE + 1 || e < c.minE - 1 ? new c(e > 0 ? s / 0 : 0) : (qe = !1, c.rounding = l.s = 1, t = Math.min(12, (e + "").length), a = Ri(r.times(bt(l, n + t)), n), a.d && (a = Ce(a, n + 5, 1), Fn(a.d, n, i) && (e = n + 10, a = Ce(Ri(r.times(bt(l, e + t)), e), e + 5, 1), +yr(a.d).slice(n + 1, n + 15) + 1 == 1e14 && (a = Ce(a, n + 1, 0)))), a.s = s, qe = !0, c.rounding = i, Ce(a, n, i));
};
pe.toPrecision = function(r, e) {
  var t, n = this, a = n.constructor;
  return r === void 0 ? t = rt(n, n.e <= a.toExpNeg || n.e >= a.toExpPos) : ($r(r, 1, Et), e === void 0 ? e = a.rounding : $r(e, 0, 8), n = Ce(new a(n), r, e), t = rt(n, r <= n.e || n.e <= a.toExpNeg, r)), n.isNeg() && !n.isZero() ? "-" + t : t;
};
pe.toSignificantDigits = pe.toSD = function(r, e) {
  var t = this, n = t.constructor;
  return r === void 0 ? (r = n.precision, e = n.rounding) : ($r(r, 1, Et), e === void 0 ? e = n.rounding : $r(e, 0, 8)), Ce(new n(t), r, e);
};
pe.toString = function() {
  var r = this, e = r.constructor, t = rt(r, r.e <= e.toExpNeg || r.e >= e.toExpPos);
  return r.isNeg() && !r.isZero() ? "-" + t : t;
};
pe.truncated = pe.trunc = function() {
  return Ce(new this.constructor(this), this.e + 1, 1);
};
pe.valueOf = pe.toJSON = function() {
  var r = this, e = r.constructor, t = rt(r, r.e <= e.toExpNeg || r.e >= e.toExpPos);
  return r.isNeg() ? "-" + t : t;
};
function yr(r) {
  var e, t, n, a = r.length - 1, i = "", s = r[0];
  if (a > 0) {
    for (i += s, e = 1; e < a; e++)
      n = r[e] + "", t = Be - n.length, t && (i += dt(t)), i += n;
    s = r[e], n = s + "", t = Be - n.length, t && (i += dt(t));
  } else if (s === 0)
    return "0";
  for (; s % 10 === 0; ) s /= 10;
  return i + s;
}
function $r(r, e, t) {
  if (r !== ~~r || r < e || r > t)
    throw Error(Dt + r);
}
function Fn(r, e, t, n) {
  var a, i, s, l;
  for (i = r[0]; i >= 10; i /= 10) --e;
  return --e < 0 ? (e += Be, a = 0) : (a = Math.ceil((e + 1) / Be), e %= Be), i = sr(10, Be - e), l = r[a] % i | 0, n == null ? e < 3 ? (e == 0 ? l = l / 100 | 0 : e == 1 && (l = l / 10 | 0), s = t < 4 && l == 99999 || t > 3 && l == 49999 || l == 5e4 || l == 0) : s = (t < 4 && l + 1 == i || t > 3 && l + 1 == i / 2) && (r[a + 1] / i / 100 | 0) == sr(10, e - 2) - 1 || (l == i / 2 || l == 0) && (r[a + 1] / i / 100 | 0) == 0 : e < 4 ? (e == 0 ? l = l / 1e3 | 0 : e == 1 ? l = l / 100 | 0 : e == 2 && (l = l / 10 | 0), s = (n || t < 4) && l == 9999 || !n && t > 3 && l == 4999) : s = ((n || t < 4) && l + 1 == i || !n && t > 3 && l + 1 == i / 2) && (r[a + 1] / i / 1e3 | 0) == sr(10, e - 3) - 1, s;
}
function da(r, e, t) {
  for (var n, a = [0], i, s = 0, l = r.length; s < l; ) {
    for (i = a.length; i--; ) a[i] *= e;
    for (a[0] += Ii.indexOf(r.charAt(s++)), n = 0; n < a.length; n++)
      a[n] > t - 1 && (a[n + 1] === void 0 && (a[n + 1] = 0), a[n + 1] += a[n] / t | 0, a[n] %= t);
  }
  return a.reverse();
}
function eh(r, e) {
  var t, n, a;
  if (e.isZero()) return e;
  n = e.d.length, n < 32 ? (t = Math.ceil(n / 3), a = (1 / ti(4, t)).toString()) : (t = 16, a = "2.3283064365386962890625e-10"), r.precision += t, e = on(r, 1, e.times(a), new r(1));
  for (var i = t; i--; ) {
    var s = e.times(e);
    e = s.times(s).minus(s).times(8).plus(1);
  }
  return r.precision -= t, e;
}
var tr = /* @__PURE__ */ (function() {
  function r(n, a, i) {
    var s, l = 0, c = n.length;
    for (n = n.slice(); c--; )
      s = n[c] * a + l, n[c] = s % i | 0, l = s / i | 0;
    return l && n.unshift(l), n;
  }
  function e(n, a, i, s) {
    var l, c;
    if (i != s)
      c = i > s ? 1 : -1;
    else
      for (l = c = 0; l < i; l++)
        if (n[l] != a[l]) {
          c = n[l] > a[l] ? 1 : -1;
          break;
        }
    return c;
  }
  function t(n, a, i, s) {
    for (var l = 0; i--; )
      n[i] -= l, l = n[i] < a[i] ? 1 : 0, n[i] = l * s + n[i] - a[i];
    for (; !n[0] && n.length > 1; ) n.shift();
  }
  return function(n, a, i, s, l, c) {
    var o, u, f, m, p, d, v, x, h, D, y, w, b, g, N, S, A, E, M, T, B = n.constructor, I = n.s == a.s ? 1 : -1, O = n.d, _ = a.d;
    if (!O || !O[0] || !_ || !_[0])
      return new B(
        // Return NaN if either NaN, or both Infinity or 0.
        !n.s || !a.s || (O ? _ && O[0] == _[0] : !_) ? NaN : (
          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
          O && O[0] == 0 || !_ ? I * 0 : I / 0
        )
      );
    for (c ? (p = 1, u = n.e - a.e) : (c = Xr, p = Be, u = Dr(n.e / p) - Dr(a.e / p)), M = _.length, A = O.length, h = new B(I), D = h.d = [], f = 0; _[f] == (O[f] || 0); f++) ;
    if (_[f] > (O[f] || 0) && u--, i == null ? (g = i = B.precision, s = B.rounding) : l ? g = i + (n.e - a.e) + 1 : g = i, g < 0)
      D.push(1), d = !0;
    else {
      if (g = g / p + 2 | 0, f = 0, M == 1) {
        for (m = 0, _ = _[0], g++; (f < A || m) && g--; f++)
          N = m * c + (O[f] || 0), D[f] = N / _ | 0, m = N % _ | 0;
        d = m || f < A;
      } else {
        for (m = c / (_[0] + 1) | 0, m > 1 && (_ = r(_, m, c), O = r(O, m, c), M = _.length, A = O.length), S = M, y = O.slice(0, M), w = y.length; w < M; ) y[w++] = 0;
        T = _.slice(), T.unshift(0), E = _[0], _[1] >= c / 2 && ++E;
        do
          m = 0, o = e(_, y, M, w), o < 0 ? (b = y[0], M != w && (b = b * c + (y[1] || 0)), m = b / E | 0, m > 1 ? (m >= c && (m = c - 1), v = r(_, m, c), x = v.length, w = y.length, o = e(v, y, x, w), o == 1 && (m--, t(v, M < x ? T : _, x, c))) : (m == 0 && (o = m = 1), v = _.slice()), x = v.length, x < w && v.unshift(0), t(y, v, w, c), o == -1 && (w = y.length, o = e(_, y, M, w), o < 1 && (m++, t(y, M < w ? T : _, w, c))), w = y.length) : o === 0 && (m++, y = [0]), D[f++] = m, o && y[0] ? y[w++] = O[S] || 0 : (y = [O[S]], w = 1);
        while ((S++ < A || y[0] !== void 0) && g--);
        d = y[0] !== void 0;
      }
      D[0] || D.shift();
    }
    if (p == 1)
      h.e = u, Yf = d;
    else {
      for (f = 1, m = D[0]; m >= 10; m /= 10) f++;
      h.e = f + u * p - 1, Ce(h, l ? i + h.e + 1 : i, s, d);
    }
    return h;
  };
})();
function Ce(r, e, t, n) {
  var a, i, s, l, c, o, u, f, m, p = r.constructor;
  e: if (e != null) {
    if (f = r.d, !f) return r;
    for (a = 1, l = f[0]; l >= 10; l /= 10) a++;
    if (i = e - a, i < 0)
      i += Be, s = e, u = f[m = 0], c = u / sr(10, a - s - 1) % 10 | 0;
    else if (m = Math.ceil((i + 1) / Be), l = f.length, m >= l)
      if (n) {
        for (; l++ <= m; ) f.push(0);
        u = c = 0, a = 1, i %= Be, s = i - Be + 1;
      } else
        break e;
    else {
      for (u = l = f[m], a = 1; l >= 10; l /= 10) a++;
      i %= Be, s = i - Be + a, c = s < 0 ? 0 : u / sr(10, a - s - 1) % 10 | 0;
    }
    if (n = n || e < 0 || f[m + 1] !== void 0 || (s < 0 ? u : u % sr(10, a - s - 1)), o = t < 4 ? (c || n) && (t == 0 || t == (r.s < 0 ? 3 : 2)) : c > 5 || c == 5 && (t == 4 || n || t == 6 && // Check whether the digit to the left of the rounding digit is odd.
    (i > 0 ? s > 0 ? u / sr(10, a - s) : 0 : f[m - 1]) % 10 & 1 || t == (r.s < 0 ? 8 : 7)), e < 1 || !f[0])
      return f.length = 0, o ? (e -= r.e + 1, f[0] = sr(10, (Be - e % Be) % Be), r.e = -e || 0) : f[0] = r.e = 0, r;
    if (i == 0 ? (f.length = m, l = 1, m--) : (f.length = m + 1, l = sr(10, Be - i), f[m] = s > 0 ? (u / sr(10, a - s) % sr(10, s) | 0) * l : 0), o)
      for (; ; )
        if (m == 0) {
          for (i = 1, s = f[0]; s >= 10; s /= 10) i++;
          for (s = f[0] += l, l = 1; s >= 10; s /= 10) l++;
          i != l && (r.e++, f[0] == Xr && (f[0] = 1));
          break;
        } else {
          if (f[m] += l, f[m] != Xr) break;
          f[m--] = 0, l = 1;
        }
    for (i = f.length; f[--i] === 0; ) f.pop();
  }
  return qe && (r.e > p.maxE ? (r.d = null, r.e = NaN) : r.e < p.minE && (r.e = 0, r.d = [0])), r;
}
function rt(r, e, t) {
  if (!r.isFinite()) return nm(r);
  var n, a = r.e, i = yr(r.d), s = i.length;
  return e ? (t && (n = t - s) > 0 ? i = i.charAt(0) + "." + i.slice(1) + dt(n) : s > 1 && (i = i.charAt(0) + "." + i.slice(1)), i = i + (r.e < 0 ? "e" : "e+") + r.e) : a < 0 ? (i = "0." + dt(-a - 1) + i, t && (n = t - s) > 0 && (i += dt(n))) : a >= s ? (i += dt(a + 1 - s), t && (n = t - a - 1) > 0 && (i = i + "." + dt(n))) : ((n = a + 1) < s && (i = i.slice(0, n) + "." + i.slice(n)), t && (n = t - s) > 0 && (a + 1 === s && (i += "."), i += dt(n))), i;
}
function ri(r, e) {
  var t = r[0];
  for (e *= Be; t >= 10; t /= 10) e++;
  return e;
}
function Ca(r, e, t) {
  if (e > Kv)
    throw qe = !0, t && (r.precision = t), Error(Jf);
  return Ce(new r(Ea), e, 1, !0);
}
function jr(r, e, t) {
  if (e > zi) throw Error(Jf);
  return Ce(new r(Ma), e, t, !0);
}
function em(r) {
  var e = r.length - 1, t = e * Be + 1;
  if (e = r[e], e) {
    for (; e % 10 == 0; e /= 10) t--;
    for (e = r[0]; e >= 10; e /= 10) t++;
  }
  return t;
}
function dt(r) {
  for (var e = ""; r--; ) e += "0";
  return e;
}
function rm(r, e, t, n) {
  var a, i = new r(1), s = Math.ceil(n / Be + 4);
  for (qe = !1; ; ) {
    if (t % 2 && (i = i.times(e), Ro(i.d, s) && (a = !0)), t = Dr(t / 2), t === 0) {
      t = i.d.length - 1, a && i.d[t] === 0 && ++i.d[t];
      break;
    }
    e = e.times(e), Ro(e.d, s);
  }
  return qe = !0, i;
}
function zo(r) {
  return r.d[r.d.length - 1] & 1;
}
function tm(r, e, t) {
  for (var n, a, i = new r(e[0]), s = 0; ++s < e.length; ) {
    if (a = new r(e[s]), !a.s) {
      i = a;
      break;
    }
    n = i.cmp(a), (n === t || n === 0 && i.s === t) && (i = a);
  }
  return i;
}
function Ri(r, e) {
  var t, n, a, i, s, l, c, o = 0, u = 0, f = 0, m = r.constructor, p = m.rounding, d = m.precision;
  if (!r.d || !r.d[0] || r.e > 17)
    return new m(r.d ? r.d[0] ? r.s < 0 ? 0 : 1 / 0 : 1 : r.s ? r.s < 0 ? 0 : r : NaN);
  for (e == null ? (qe = !1, c = d) : c = e, l = new m(0.03125); r.e > -2; )
    r = r.times(l), f += 5;
  for (n = Math.log(sr(2, f)) / Math.LN10 * 2 + 5 | 0, c += n, t = i = s = new m(1), m.precision = c; ; ) {
    if (i = Ce(i.times(r), c, 1), t = t.times(++u), l = s.plus(tr(i, t, c, 1)), yr(l.d).slice(0, c) === yr(s.d).slice(0, c)) {
      for (a = f; a--; ) s = Ce(s.times(s), c, 1);
      if (e == null)
        if (o < 3 && Fn(s.d, c - n, p, o))
          m.precision = c += 10, t = i = l = new m(1), u = 0, o++;
        else
          return Ce(s, m.precision = d, p, qe = !0);
      else
        return m.precision = d, s;
    }
    s = l;
  }
}
function bt(r, e) {
  var t, n, a, i, s, l, c, o, u, f, m, p = 1, d = 10, v = r, x = v.d, h = v.constructor, D = h.rounding, y = h.precision;
  if (v.s < 0 || !x || !x[0] || !v.e && x[0] == 1 && x.length == 1)
    return new h(x && !x[0] ? -1 / 0 : v.s != 1 ? NaN : x ? 0 : v);
  if (e == null ? (qe = !1, u = y) : u = e, h.precision = u += d, t = yr(x), n = t.charAt(0), Math.abs(i = v.e) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && t.charAt(1) > 3; )
      v = v.times(r), t = yr(v.d), n = t.charAt(0), p++;
    i = v.e, n > 1 ? (v = new h("0." + t), i++) : v = new h(n + "." + t.slice(1));
  } else
    return o = Ca(h, u + 2, y).times(i + ""), v = bt(new h(n + "." + t.slice(1)), u - d).plus(o), h.precision = y, e == null ? Ce(v, y, D, qe = !0) : v;
  for (f = v, c = s = v = tr(v.minus(1), v.plus(1), u, 1), m = Ce(v.times(v), u, 1), a = 3; ; ) {
    if (s = Ce(s.times(m), u, 1), o = c.plus(tr(s, new h(a), u, 1)), yr(o.d).slice(0, u) === yr(c.d).slice(0, u))
      if (c = c.times(2), i !== 0 && (c = c.plus(Ca(h, u + 2, y).times(i + ""))), c = tr(c, new h(p), u, 1), e == null)
        if (Fn(c.d, u - d, D, l))
          h.precision = u += d, o = s = v = tr(f.minus(1), f.plus(1), u, 1), m = Ce(v.times(v), u, 1), a = l = 1;
        else
          return Ce(c, h.precision = y, D, qe = !0);
      else
        return h.precision = y, c;
    c = o, a += 2;
  }
}
function nm(r) {
  return String(r.s * r.s / 0);
}
function va(r, e) {
  var t, n, a;
  for ((t = e.indexOf(".")) > -1 && (e = e.replace(".", "")), (n = e.search(/e/i)) > 0 ? (t < 0 && (t = n), t += +e.slice(n + 1), e = e.substring(0, n)) : t < 0 && (t = e.length), n = 0; e.charCodeAt(n) === 48; n++) ;
  for (a = e.length; e.charCodeAt(a - 1) === 48; --a) ;
  if (e = e.slice(n, a), e) {
    if (a -= n, r.e = t = t - n - 1, r.d = [], n = (t + 1) % Be, t < 0 && (n += Be), n < a) {
      for (n && r.d.push(+e.slice(0, n)), a -= Be; n < a; ) r.d.push(+e.slice(n, n += Be));
      e = e.slice(n), n = Be - e.length;
    } else
      n -= a;
    for (; n--; ) e += "0";
    r.d.push(+e), qe && (r.e > r.constructor.maxE ? (r.d = null, r.e = NaN) : r.e < r.constructor.minE && (r.e = 0, r.d = [0]));
  } else
    r.e = 0, r.d = [0];
  return r;
}
function rh(r, e) {
  var t, n, a, i, s, l, c, o, u;
  if (e.indexOf("_") > -1) {
    if (e = e.replace(/(\d)_(?=\d)/g, "$1"), Kf.test(e)) return va(r, e);
  } else if (e === "Infinity" || e === "NaN")
    return +e || (r.s = NaN), r.e = NaN, r.d = null, r;
  if (Jv.test(e))
    t = 16, e = e.toLowerCase();
  else if (Yv.test(e))
    t = 2;
  else if (Qv.test(e))
    t = 8;
  else
    throw Error(Dt + e);
  for (i = e.search(/p/i), i > 0 ? (c = +e.slice(i + 1), e = e.substring(2, i)) : e = e.slice(2), i = e.indexOf("."), s = i >= 0, n = r.constructor, s && (e = e.replace(".", ""), l = e.length, i = l - i, a = rm(n, new n(t), i, i * 2)), o = da(e, t, Xr), u = o.length - 1, i = u; o[i] === 0; --i) o.pop();
  return i < 0 ? new n(r.s * 0) : (r.e = ri(o, u), r.d = o, qe = !1, s && (r = tr(r, a, l * 4)), c && (r = r.times(Math.abs(c) < 54 ? sr(2, c) : Nt.pow(2, c))), qe = !0, r);
}
function th(r, e) {
  var t, n = e.d.length;
  if (n < 3)
    return e.isZero() ? e : on(r, 2, e, e);
  t = 1.4 * Math.sqrt(n), t = t > 16 ? 16 : t | 0, e = e.times(1 / ti(5, t)), e = on(r, 2, e, e);
  for (var a, i = new r(5), s = new r(16), l = new r(20); t--; )
    a = e.times(e), e = e.times(i.plus(a.times(s.times(a).minus(l))));
  return e;
}
function on(r, e, t, n, a) {
  var i, s, l, c, o = r.precision, u = Math.ceil(o / Be);
  for (qe = !1, c = t.times(t), l = new r(n); ; ) {
    if (s = tr(l.times(c), new r(e++ * e++), o, 1), l = a ? n.plus(s) : n.minus(s), n = tr(s.times(c), new r(e++ * e++), o, 1), s = l.plus(n), s.d[u] !== void 0) {
      for (i = u; s.d[i] === l.d[i] && i--; ) ;
      if (i == -1) break;
    }
    i = l, l = n, n = s, s = i;
  }
  return qe = !0, s.d.length = u + 1, s;
}
function ti(r, e) {
  for (var t = r; --e; ) t *= r;
  return t;
}
function am(r, e) {
  var t, n = e.s < 0, a = jr(r, r.precision, 1), i = a.times(0.5);
  if (e = e.abs(), e.lte(i))
    return it = n ? 4 : 1, e;
  if (t = e.divToInt(a), t.isZero())
    it = n ? 3 : 2;
  else {
    if (e = e.minus(t.times(a)), e.lte(i))
      return it = zo(t) ? n ? 2 : 3 : n ? 4 : 1, e;
    it = zo(t) ? n ? 1 : 4 : n ? 3 : 2;
  }
  return e.minus(a).abs();
}
function oo(r, e, t, n) {
  var a, i, s, l, c, o, u, f, m, p = r.constructor, d = t !== void 0;
  if (d ? ($r(t, 1, Et), n === void 0 ? n = p.rounding : $r(n, 0, 8)) : (t = p.precision, n = p.rounding), !r.isFinite())
    u = nm(r);
  else {
    for (u = rt(r), s = u.indexOf("."), d ? (a = 2, e == 16 ? t = t * 4 - 3 : e == 8 && (t = t * 3 - 2)) : a = e, s >= 0 && (u = u.replace(".", ""), m = new p(1), m.e = u.length - s, m.d = da(rt(m), 10, a), m.e = m.d.length), f = da(u, 10, a), i = c = f.length; f[--c] == 0; ) f.pop();
    if (!f[0])
      u = d ? "0p+0" : "0";
    else {
      if (s < 0 ? i-- : (r = new p(r), r.d = f, r.e = i, r = tr(r, m, t, n, 0, a), f = r.d, i = r.e, o = Yf), s = f[t], l = a / 2, o = o || f[t + 1] !== void 0, o = n < 4 ? (s !== void 0 || o) && (n === 0 || n === (r.s < 0 ? 3 : 2)) : s > l || s === l && (n === 4 || o || n === 6 && f[t - 1] & 1 || n === (r.s < 0 ? 8 : 7)), f.length = t, o)
        for (; ++f[--t] > a - 1; )
          f[t] = 0, t || (++i, f.unshift(1));
      for (c = f.length; !f[c - 1]; --c) ;
      for (s = 0, u = ""; s < c; s++) u += Ii.charAt(f[s]);
      if (d) {
        if (c > 1)
          if (e == 16 || e == 8) {
            for (s = e == 16 ? 4 : 3, --c; c % s; c++) u += "0";
            for (f = da(u, a, e), c = f.length; !f[c - 1]; --c) ;
            for (s = 1, u = "1."; s < c; s++) u += Ii.charAt(f[s]);
          } else
            u = u.charAt(0) + "." + u.slice(1);
        u = u + (i < 0 ? "p" : "p+") + i;
      } else if (i < 0) {
        for (; ++i; ) u = "0" + u;
        u = "0." + u;
      } else if (++i > c) for (i -= c; i--; ) u += "0";
      else i < c && (u = u.slice(0, i) + "." + u.slice(i));
    }
    u = (e == 16 ? "0x" : e == 2 ? "0b" : e == 8 ? "0o" : "") + u;
  }
  return r.s < 0 ? "-" + u : u;
}
function Ro(r, e) {
  if (r.length > e)
    return r.length = e, !0;
}
function nh(r) {
  return new this(r).abs();
}
function ah(r) {
  return new this(r).acos();
}
function ih(r) {
  return new this(r).acosh();
}
function oh(r, e) {
  return new this(r).plus(e);
}
function sh(r) {
  return new this(r).asin();
}
function uh(r) {
  return new this(r).asinh();
}
function ch(r) {
  return new this(r).atan();
}
function lh(r) {
  return new this(r).atanh();
}
function fh(r, e) {
  r = new this(r), e = new this(e);
  var t, n = this.precision, a = this.rounding, i = n + 4;
  return !r.s || !e.s ? t = new this(NaN) : !r.d && !e.d ? (t = jr(this, i, 1).times(e.s > 0 ? 0.25 : 0.75), t.s = r.s) : !e.d || r.isZero() ? (t = e.s < 0 ? jr(this, n, a) : new this(0), t.s = r.s) : !r.d || e.isZero() ? (t = jr(this, i, 1).times(0.5), t.s = r.s) : e.s < 0 ? (this.precision = i, this.rounding = 1, t = this.atan(tr(r, e, i, 1)), e = jr(this, i, 1), this.precision = n, this.rounding = a, t = r.s < 0 ? t.minus(e) : t.plus(e)) : t = this.atan(tr(r, e, i, 1)), t;
}
function mh(r) {
  return new this(r).cbrt();
}
function ph(r) {
  return Ce(r = new this(r), r.e + 1, 2);
}
function dh(r, e, t) {
  return new this(r).clamp(e, t);
}
function vh(r) {
  if (!r || typeof r != "object") throw Error(ei + "Object expected");
  var e, t, n, a = r.defaults === !0, i = [
    "precision",
    1,
    Et,
    "rounding",
    0,
    8,
    "toExpNeg",
    -Jt,
    0,
    "toExpPos",
    0,
    Jt,
    "maxE",
    0,
    Jt,
    "minE",
    -Jt,
    0,
    "modulo",
    0,
    9
  ];
  for (e = 0; e < i.length; e += 3)
    if (t = i[e], a && (this[t] = $i[t]), (n = r[t]) !== void 0)
      if (Dr(n) === n && n >= i[e + 1] && n <= i[e + 2]) this[t] = n;
      else throw Error(Dt + t + ": " + n);
  if (t = "crypto", a && (this[t] = $i[t]), (n = r[t]) !== void 0)
    if (n === !0 || n === !1 || n === 0 || n === 1)
      if (n)
        if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
          this[t] = !0;
        else
          throw Error(Qf);
      else
        this[t] = !1;
    else
      throw Error(Dt + t + ": " + n);
  return this;
}
function hh(r) {
  return new this(r).cos();
}
function gh(r) {
  return new this(r).cosh();
}
function im(r) {
  var e, t, n;
  function a(i) {
    var s, l, c, o = this;
    if (!(o instanceof a)) return new a(i);
    if (o.constructor = a, qo(i)) {
      o.s = i.s, qe ? !i.d || i.e > a.maxE ? (o.e = NaN, o.d = null) : i.e < a.minE ? (o.e = 0, o.d = [0]) : (o.e = i.e, o.d = i.d.slice()) : (o.e = i.e, o.d = i.d ? i.d.slice() : i.d);
      return;
    }
    if (c = typeof i, c === "number") {
      if (i === 0) {
        o.s = 1 / i < 0 ? -1 : 1, o.e = 0, o.d = [0];
        return;
      }
      if (i < 0 ? (i = -i, o.s = -1) : o.s = 1, i === ~~i && i < 1e7) {
        for (s = 0, l = i; l >= 10; l /= 10) s++;
        qe ? s > a.maxE ? (o.e = NaN, o.d = null) : s < a.minE ? (o.e = 0, o.d = [0]) : (o.e = s, o.d = [i]) : (o.e = s, o.d = [i]);
        return;
      }
      if (i * 0 !== 0) {
        i || (o.s = NaN), o.e = NaN, o.d = null;
        return;
      }
      return va(o, i.toString());
    }
    if (c === "string")
      return (l = i.charCodeAt(0)) === 45 ? (i = i.slice(1), o.s = -1) : (l === 43 && (i = i.slice(1)), o.s = 1), Kf.test(i) ? va(o, i) : rh(o, i);
    if (c === "bigint")
      return i < 0 ? (i = -i, o.s = -1) : o.s = 1, va(o, i.toString());
    throw Error(Dt + i);
  }
  if (a.prototype = pe, a.ROUND_UP = 0, a.ROUND_DOWN = 1, a.ROUND_CEIL = 2, a.ROUND_FLOOR = 3, a.ROUND_HALF_UP = 4, a.ROUND_HALF_DOWN = 5, a.ROUND_HALF_EVEN = 6, a.ROUND_HALF_CEIL = 7, a.ROUND_HALF_FLOOR = 8, a.EUCLID = 9, a.config = a.set = vh, a.clone = im, a.isDecimal = qo, a.abs = nh, a.acos = ah, a.acosh = ih, a.add = oh, a.asin = sh, a.asinh = uh, a.atan = ch, a.atanh = lh, a.atan2 = fh, a.cbrt = mh, a.ceil = ph, a.clamp = dh, a.cos = hh, a.cosh = gh, a.div = yh, a.exp = bh, a.floor = xh, a.hypot = wh, a.ln = Dh, a.log = Nh, a.log10 = Sh, a.log2 = Ah, a.max = Eh, a.min = Mh, a.mod = Ch, a.mul = _h, a.pow = Th, a.random = Fh, a.round = Bh, a.sign = Oh, a.sin = Ih, a.sinh = $h, a.sqrt = zh, a.sub = Rh, a.sum = qh, a.tan = Ph, a.tanh = Uh, a.trunc = Lh, r === void 0 && (r = {}), r && r.defaults !== !0)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], e = 0; e < n.length; ) r.hasOwnProperty(t = n[e++]) || (r[t] = this[t]);
  return a.config(r), a;
}
function yh(r, e) {
  return new this(r).div(e);
}
function bh(r) {
  return new this(r).exp();
}
function xh(r) {
  return Ce(r = new this(r), r.e + 1, 3);
}
function wh() {
  var r, e, t = new this(0);
  for (qe = !1, r = 0; r < arguments.length; )
    if (e = new this(arguments[r++]), e.d)
      t.d && (t = t.plus(e.times(e)));
    else {
      if (e.s)
        return qe = !0, new this(1 / 0);
      t = e;
    }
  return qe = !0, t.sqrt();
}
function qo(r) {
  return r instanceof Nt || r && r.toStringTag === jf || !1;
}
function Dh(r) {
  return new this(r).ln();
}
function Nh(r, e) {
  return new this(r).log(e);
}
function Ah(r) {
  return new this(r).log(2);
}
function Sh(r) {
  return new this(r).log(10);
}
function Eh() {
  return tm(this, arguments, -1);
}
function Mh() {
  return tm(this, arguments, 1);
}
function Ch(r, e) {
  return new this(r).mod(e);
}
function _h(r, e) {
  return new this(r).mul(e);
}
function Th(r, e) {
  return new this(r).pow(e);
}
function Fh(r) {
  var e, t, n, a, i = 0, s = new this(1), l = [];
  if (r === void 0 ? r = this.precision : $r(r, 1, Et), n = Math.ceil(r / Be), this.crypto)
    if (crypto.getRandomValues)
      for (e = crypto.getRandomValues(new Uint32Array(n)); i < n; )
        a = e[i], a >= 429e7 ? e[i] = crypto.getRandomValues(new Uint32Array(1))[0] : l[i++] = a % 1e7;
    else if (crypto.randomBytes) {
      for (e = crypto.randomBytes(n *= 4); i < n; )
        a = e[i] + (e[i + 1] << 8) + (e[i + 2] << 16) + ((e[i + 3] & 127) << 24), a >= 214e7 ? crypto.randomBytes(4).copy(e, i) : (l.push(a % 1e7), i += 4);
      i = n / 4;
    } else
      throw Error(Qf);
  else for (; i < n; ) l[i++] = Math.random() * 1e7 | 0;
  for (n = l[--i], r %= Be, n && r && (a = sr(10, Be - r), l[i] = (n / a | 0) * a); l[i] === 0; i--) l.pop();
  if (i < 0)
    t = 0, l = [0];
  else {
    for (t = -1; l[0] === 0; t -= Be) l.shift();
    for (n = 1, a = l[0]; a >= 10; a /= 10) n++;
    n < Be && (t -= Be - n);
  }
  return s.e = t, s.d = l, s;
}
function Bh(r) {
  return Ce(r = new this(r), r.e + 1, this.rounding);
}
function Oh(r) {
  return r = new this(r), r.d ? r.d[0] ? r.s : 0 * r.s : r.s || NaN;
}
function Ih(r) {
  return new this(r).sin();
}
function $h(r) {
  return new this(r).sinh();
}
function zh(r) {
  return new this(r).sqrt();
}
function Rh(r, e) {
  return new this(r).sub(e);
}
function qh() {
  var r = 0, e = arguments, t = new this(e[r]);
  for (qe = !1; t.s && ++r < e.length; ) t = t.plus(e[r]);
  return qe = !0, Ce(t, this.precision, this.rounding);
}
function Ph(r) {
  return new this(r).tan();
}
function Uh(r) {
  return new this(r).tanh();
}
function Lh(r) {
  return Ce(r = new this(r), r.e + 1, 1);
}
pe[/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")] = pe.toString;
pe[Symbol.toStringTag] = "Decimal";
var Nt = pe.constructor = im($i);
Ea = new Nt(Ea);
Ma = new Nt(Ma);
var kh = "BigNumber", Hh = ["?on", "config"], om = /* @__PURE__ */ R(kh, Hh, (r) => {
  var {
    on: e,
    config: t
  } = r, n = Nt.clone({
    precision: t.precision,
    modulo: Nt.EUCLID
  });
  return n.prototype = Object.create(n.prototype), n.prototype.type = "BigNumber", n.prototype.isBigNumber = !0, n.prototype.toJSON = function() {
    return {
      mathjs: "BigNumber",
      value: this.toString()
    };
  }, n.fromJSON = function(a) {
    return new n(a.value);
  }, e && e("config", function(a, i) {
    a.precision !== i.precision && n.config({
      precision: a.precision
    });
  }), n;
}, {
  isClass: !0
});
const xr = Math.cosh || function(r) {
  return Math.abs(r) < 1e-9 ? 1 - r : (Math.exp(r) + Math.exp(-r)) * 0.5;
}, Pr = Math.sinh || function(r) {
  return Math.abs(r) < 1e-9 ? r : (Math.exp(r) - Math.exp(-r)) * 0.5;
}, Wh = (r) => {
  const e = Math.sin(0.5 * r);
  return -2 * e * e;
}, hi = function(r, e) {
  return r = Math.abs(r), e = Math.abs(e), r < e && ([r, e] = [e, r]), r < 1e8 ? Math.sqrt(r * r + e * e) : (e /= r, r * Math.sqrt(1 + e * e));
}, Wt = function() {
  throw SyntaxError("Invalid Param");
};
function gi(r, e) {
  const t = Math.abs(r), n = Math.abs(e);
  return r === 0 ? Math.log(n) : e === 0 ? Math.log(t) : t < 3e3 && n < 3e3 ? Math.log(r * r + e * e) * 0.5 : (r = r * 0.5, e = e * 0.5, 0.5 * Math.log(r * r + e * e) + Math.LN2);
}
const Gh = { re: 0, im: 0 }, Ft = function(r, e) {
  const t = Gh;
  if (r == null)
    t.re = t.im = 0;
  else if (e !== void 0)
    t.re = r, t.im = e;
  else
    switch (typeof r) {
      case "object":
        if ("im" in r && "re" in r)
          t.re = r.re, t.im = r.im;
        else if ("abs" in r && "arg" in r) {
          if (!isFinite(r.abs) && isFinite(r.arg))
            return ue.INFINITY;
          t.re = r.abs * Math.cos(r.arg), t.im = r.abs * Math.sin(r.arg);
        } else if ("r" in r && "phi" in r) {
          if (!isFinite(r.r) && isFinite(r.phi))
            return ue.INFINITY;
          t.re = r.r * Math.cos(r.phi), t.im = r.r * Math.sin(r.phi);
        } else r.length === 2 ? (t.re = r[0], t.im = r[1]) : Wt();
        break;
      case "string":
        t.im = /* void */
        t.re = 0;
        const n = r.replace(/_/g, "").match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g);
        let a = 1, i = 0;
        n === null && Wt();
        for (let s = 0; s < n.length; s++) {
          const l = n[s];
          l === " " || l === "	" || l === `
` || (l === "+" ? a++ : l === "-" ? i++ : l === "i" || l === "I" ? (a + i === 0 && Wt(), n[s + 1] !== " " && !isNaN(n[s + 1]) ? (t.im += parseFloat((i % 2 ? "-" : "") + n[s + 1]), s++) : t.im += parseFloat((i % 2 ? "-" : "") + "1"), a = i = 0) : ((a + i === 0 || isNaN(l)) && Wt(), n[s + 1] === "i" || n[s + 1] === "I" ? (t.im += parseFloat((i % 2 ? "-" : "") + l), s++) : t.re += parseFloat((i % 2 ? "-" : "") + l), a = i = 0));
        }
        a + i > 0 && Wt();
        break;
      case "number":
        t.im = 0, t.re = r;
        break;
      default:
        Wt();
    }
  return isNaN(t.re) || isNaN(t.im), t;
};
function ue(r, e) {
  if (!(this instanceof ue))
    return new ue(r, e);
  const t = Ft(r, e);
  this.re = t.re, this.im = t.im;
}
ue.prototype = {
  re: 0,
  im: 0,
  /**
   * Calculates the sign of a complex number, which is a normalized complex
   *
   * @returns {Complex}
   */
  sign: function() {
    const r = hi(this.re, this.im);
    return new ue(
      this.re / r,
      this.im / r
    );
  },
  /**
   * Adds two complex numbers
   *
   * @returns {Complex}
   */
  add: function(r, e) {
    const t = Ft(r, e), n = this.isInfinite(), a = !(isFinite(t.re) && isFinite(t.im));
    return n || a ? n && a ? ue.NAN : ue.INFINITY : new ue(
      this.re + t.re,
      this.im + t.im
    );
  },
  /**
   * Subtracts two complex numbers
   *
   * @returns {Complex}
   */
  sub: function(r, e) {
    const t = Ft(r, e), n = this.isInfinite(), a = !(isFinite(t.re) && isFinite(t.im));
    return n || a ? n && a ? ue.NAN : ue.INFINITY : new ue(
      this.re - t.re,
      this.im - t.im
    );
  },
  /**
   * Multiplies two complex numbers
   *
   * @returns {Complex}
   */
  mul: function(r, e) {
    const t = Ft(r, e), n = this.isInfinite(), a = !(isFinite(t.re) && isFinite(t.im)), i = this.re === 0 && this.im === 0, s = t.re === 0 && t.im === 0;
    return n && s || a && i ? ue.NAN : n || a ? ue.INFINITY : t.im === 0 && this.im === 0 ? new ue(this.re * t.re, 0) : new ue(
      this.re * t.re - this.im * t.im,
      this.re * t.im + this.im * t.re
    );
  },
  /**
   * Divides two complex numbers
   *
   * @returns {Complex}
   */
  div: function(r, e) {
    const t = Ft(r, e), n = this.isInfinite(), a = !(isFinite(t.re) && isFinite(t.im)), i = this.re === 0 && this.im === 0, s = t.re === 0 && t.im === 0;
    if (i && s || n && a)
      return ue.NAN;
    if (s || n)
      return ue.INFINITY;
    if (i || a)
      return ue.ZERO;
    if (t.im === 0)
      return new ue(this.re / t.re, this.im / t.re);
    if (Math.abs(t.re) < Math.abs(t.im)) {
      const l = t.re / t.im, c = t.re * l + t.im;
      return new ue(
        (this.re * l + this.im) / c,
        (this.im * l - this.re) / c
      );
    } else {
      const l = t.im / t.re, c = t.im * l + t.re;
      return new ue(
        (this.re + this.im * l) / c,
        (this.im - this.re * l) / c
      );
    }
  },
  /**
   * Calculate the power of two complex numbers
   *
   * @returns {Complex}
   */
  pow: function(r, e) {
    const t = Ft(r, e), n = this.re === 0 && this.im === 0;
    if (t.re === 0 && t.im === 0)
      return ue.ONE;
    if (t.im === 0) {
      if (this.im === 0 && this.re > 0)
        return new ue(Math.pow(this.re, t.re), 0);
      if (this.re === 0)
        switch ((t.re % 4 + 4) % 4) {
          case 0:
            return new ue(Math.pow(this.im, t.re), 0);
          case 1:
            return new ue(0, Math.pow(this.im, t.re));
          case 2:
            return new ue(-Math.pow(this.im, t.re), 0);
          case 3:
            return new ue(0, -Math.pow(this.im, t.re));
        }
    }
    if (n && t.re > 0)
      return ue.ZERO;
    const i = Math.atan2(this.im, this.re), s = gi(this.re, this.im);
    let l = Math.exp(t.re * s - t.im * i), c = t.im * s + t.re * i;
    return new ue(
      l * Math.cos(c),
      l * Math.sin(c)
    );
  },
  /**
   * Calculate the complex square root
   *
   * @returns {Complex}
   */
  sqrt: function() {
    const r = this.re, e = this.im;
    if (e === 0)
      return r >= 0 ? new ue(Math.sqrt(r), 0) : new ue(0, Math.sqrt(-r));
    const t = hi(r, e);
    let n = Math.sqrt(0.5 * (t + Math.abs(r))), a = Math.abs(e) / (2 * n);
    return r >= 0 ? new ue(n, e < 0 ? -a : a) : new ue(a, e < 0 ? -n : n);
  },
  /**
   * Calculate the complex exponent
   *
   * @returns {Complex}
   */
  exp: function() {
    const r = Math.exp(this.re);
    return this.im === 0 ? new ue(r, 0) : new ue(
      r * Math.cos(this.im),
      r * Math.sin(this.im)
    );
  },
  /**
   * Calculate the complex exponent and subtracts one.
   *
   * This may be more accurate than `Complex(x).exp().sub(1)` if
   * `x` is small.
   *
   * @returns {Complex}
   */
  expm1: function() {
    const r = this.re, e = this.im;
    return new ue(
      Math.expm1(r) * Math.cos(e) + Wh(e),
      Math.exp(r) * Math.sin(e)
    );
  },
  /**
   * Calculate the natural log
   *
   * @returns {Complex}
   */
  log: function() {
    const r = this.re, e = this.im;
    return e === 0 && r > 0 ? new ue(Math.log(r), 0) : new ue(
      gi(r, e),
      Math.atan2(e, r)
    );
  },
  /**
   * Calculate the magnitude of the complex number
   *
   * @returns {number}
   */
  abs: function() {
    return hi(this.re, this.im);
  },
  /**
   * Calculate the angle of the complex number
   *
   * @returns {number}
   */
  arg: function() {
    return Math.atan2(this.im, this.re);
  },
  /**
   * Calculate the sine of the complex number
   *
   * @returns {Complex}
   */
  sin: function() {
    const r = this.re, e = this.im;
    return new ue(
      Math.sin(r) * xr(e),
      Math.cos(r) * Pr(e)
    );
  },
  /**
   * Calculate the cosine
   *
   * @returns {Complex}
   */
  cos: function() {
    const r = this.re, e = this.im;
    return new ue(
      Math.cos(r) * xr(e),
      -Math.sin(r) * Pr(e)
    );
  },
  /**
   * Calculate the tangent
   *
   * @returns {Complex}
   */
  tan: function() {
    const r = 2 * this.re, e = 2 * this.im, t = Math.cos(r) + xr(e);
    return new ue(
      Math.sin(r) / t,
      Pr(e) / t
    );
  },
  /**
   * Calculate the cotangent
   *
   * @returns {Complex}
   */
  cot: function() {
    const r = 2 * this.re, e = 2 * this.im, t = Math.cos(r) - xr(e);
    return new ue(
      -Math.sin(r) / t,
      Pr(e) / t
    );
  },
  /**
   * Calculate the secant
   *
   * @returns {Complex}
   */
  sec: function() {
    const r = this.re, e = this.im, t = 0.5 * xr(2 * e) + 0.5 * Math.cos(2 * r);
    return new ue(
      Math.cos(r) * xr(e) / t,
      Math.sin(r) * Pr(e) / t
    );
  },
  /**
   * Calculate the cosecans
   *
   * @returns {Complex}
   */
  csc: function() {
    const r = this.re, e = this.im, t = 0.5 * xr(2 * e) - 0.5 * Math.cos(2 * r);
    return new ue(
      Math.sin(r) * xr(e) / t,
      -Math.cos(r) * Pr(e) / t
    );
  },
  /**
   * Calculate the complex arcus sinus
   *
   * @returns {Complex}
   */
  asin: function() {
    const r = this.re, e = this.im, t = new ue(
      e * e - r * r + 1,
      -2 * r * e
    ).sqrt(), n = new ue(
      t.re - e,
      t.im + r
    ).log();
    return new ue(n.im, -n.re);
  },
  /**
   * Calculate the complex arcus cosinus
   *
   * @returns {Complex}
   */
  acos: function() {
    const r = this.re, e = this.im, t = new ue(
      e * e - r * r + 1,
      -2 * r * e
    ).sqrt(), n = new ue(
      t.re - e,
      t.im + r
    ).log();
    return new ue(Math.PI / 2 - n.im, n.re);
  },
  /**
   * Calculate the complex arcus tangent
   *
   * @returns {Complex}
   */
  atan: function() {
    const r = this.re, e = this.im;
    if (r === 0) {
      if (e === 1)
        return new ue(0, 1 / 0);
      if (e === -1)
        return new ue(0, -1 / 0);
    }
    const t = r * r + (1 - e) * (1 - e), n = new ue(
      (1 - e * e - r * r) / t,
      -2 * r / t
    ).log();
    return new ue(-0.5 * n.im, 0.5 * n.re);
  },
  /**
   * Calculate the complex arcus cotangent
   *
   * @returns {Complex}
   */
  acot: function() {
    const r = this.re, e = this.im;
    if (e === 0)
      return new ue(Math.atan2(1, r), 0);
    const t = r * r + e * e;
    return t !== 0 ? new ue(
      r / t,
      -e / t
    ).atan() : new ue(
      r !== 0 ? r / 0 : 0,
      e !== 0 ? -e / 0 : 0
    ).atan();
  },
  /**
   * Calculate the complex arcus secant
   *
   * @returns {Complex}
   */
  asec: function() {
    const r = this.re, e = this.im;
    if (r === 0 && e === 0)
      return new ue(0, 1 / 0);
    const t = r * r + e * e;
    return t !== 0 ? new ue(
      r / t,
      -e / t
    ).acos() : new ue(
      r !== 0 ? r / 0 : 0,
      e !== 0 ? -e / 0 : 0
    ).acos();
  },
  /**
   * Calculate the complex arcus cosecans
   *
   * @returns {Complex}
   */
  acsc: function() {
    const r = this.re, e = this.im;
    if (r === 0 && e === 0)
      return new ue(Math.PI / 2, 1 / 0);
    const t = r * r + e * e;
    return t !== 0 ? new ue(
      r / t,
      -e / t
    ).asin() : new ue(
      r !== 0 ? r / 0 : 0,
      e !== 0 ? -e / 0 : 0
    ).asin();
  },
  /**
   * Calculate the complex sinh
   *
   * @returns {Complex}
   */
  sinh: function() {
    const r = this.re, e = this.im;
    return new ue(
      Pr(r) * Math.cos(e),
      xr(r) * Math.sin(e)
    );
  },
  /**
   * Calculate the complex cosh
   *
   * @returns {Complex}
   */
  cosh: function() {
    const r = this.re, e = this.im;
    return new ue(
      xr(r) * Math.cos(e),
      Pr(r) * Math.sin(e)
    );
  },
  /**
   * Calculate the complex tanh
   *
   * @returns {Complex}
   */
  tanh: function() {
    const r = 2 * this.re, e = 2 * this.im, t = xr(r) + Math.cos(e);
    return new ue(
      Pr(r) / t,
      Math.sin(e) / t
    );
  },
  /**
   * Calculate the complex coth
   *
   * @returns {Complex}
   */
  coth: function() {
    const r = 2 * this.re, e = 2 * this.im, t = xr(r) - Math.cos(e);
    return new ue(
      Pr(r) / t,
      -Math.sin(e) / t
    );
  },
  /**
   * Calculate the complex csch
   *
   * @returns {Complex}
   */
  csch: function() {
    const r = this.re, e = this.im, t = Math.cos(2 * e) - xr(2 * r);
    return new ue(
      -2 * Pr(r) * Math.cos(e) / t,
      2 * xr(r) * Math.sin(e) / t
    );
  },
  /**
   * Calculate the complex sech
   *
   * @returns {Complex}
   */
  sech: function() {
    const r = this.re, e = this.im, t = Math.cos(2 * e) + xr(2 * r);
    return new ue(
      2 * xr(r) * Math.cos(e) / t,
      -2 * Pr(r) * Math.sin(e) / t
    );
  },
  /**
   * Calculate the complex asinh
   *
   * @returns {Complex}
   */
  asinh: function() {
    const r = this.re, e = this.im;
    if (e === 0) {
      if (r === 0)
        return new ue(0, 0);
      const i = Math.abs(r), s = Math.log(i + Math.sqrt(i * i + 1));
      return new ue(r < 0 ? -s : s, 0);
    }
    const t = r * r - e * e + 1, n = 2 * r * e, a = new ue(t, n).sqrt();
    return new ue(r + a.re, e + a.im).log();
  },
  /**
   * Calculate the complex acosh
   *
   * @returns {Complex}
   */
  acosh: function() {
    const r = this.re, e = this.im;
    if (e === 0) {
      if (r > 1)
        return new ue(
          Math.log(r + Math.sqrt(r - 1) * Math.sqrt(r + 1)),
          0
        );
      if (r < -1) {
        const a = Math.sqrt(r * r - 1);
        return new ue(Math.log(-r + a), Math.PI);
      }
      return new ue(0, Math.acos(r));
    }
    const t = new ue(r - 1, e).sqrt(), n = new ue(r + 1, e).sqrt();
    return new ue(
      r + t.re * n.re - t.im * n.im,
      e + t.re * n.im + t.im * n.re
    ).log();
  },
  /**
   * Calculate the complex atanh
   *
   * @returns {Complex}
   */
  atanh: function() {
    const r = this.re, e = this.im;
    if (e === 0) {
      if (r === 0)
        return new ue(0, 0);
      if (r === 1)
        return new ue(1 / 0, 0);
      if (r === -1)
        return new ue(-1 / 0, 0);
      if (-1 < r && r < 1)
        return new ue(
          0.5 * Math.log((1 + r) / (1 - r)),
          0
        );
      if (r > 1) {
        const c = (r + 1) / (r - 1);
        return new ue(
          0.5 * Math.log(c),
          -Math.PI / 2
        );
      }
      const l = (1 + r) / (1 - r);
      return new ue(
        0.5 * Math.log(-l),
        // log((1 - a)/(1 + a))
        Math.PI / 2
      );
    }
    const t = 1 - r, n = 1 + r, a = t * t + e * e;
    if (a === 0)
      return new ue(
        r !== -1 ? r / 0 : 0,
        e !== 0 ? e / 0 : 0
      );
    const i = (n * t - e * e) / a, s = (e * t + n * e) / a;
    return new ue(
      gi(i, s) / 2,
      Math.atan2(s, i) / 2
    );
  },
  /**
   * Calculate the complex acoth
   *
   * @returns {Complex}
   */
  acoth: function() {
    const r = this.re, e = this.im;
    if (r === 0 && e === 0)
      return new ue(0, Math.PI / 2);
    const t = r * r + e * e;
    return t !== 0 ? new ue(r / t, -e / t).atanh() : new ue(
      r !== 0 ? r / 0 : 0,
      e !== 0 ? -e / 0 : 0
    ).atanh();
  },
  /**
   * Calculate the complex acsch
   *
   * @returns {Complex}
   */
  acsch: function() {
    const r = this.re, e = this.im;
    if (e === 0) {
      if (r === 0)
        return new ue(1 / 0, 0);
      const n = 1 / r;
      return new ue(
        Math.log(n + Math.sqrt(n * n + 1)),
        0
      );
    }
    const t = r * r + e * e;
    return t !== 0 ? new ue(r / t, -e / t).asinh() : new ue(
      r !== 0 ? r / 0 : 0,
      e !== 0 ? -e / 0 : 0
    ).asinh();
  },
  /**
   * Calculate the complex asech
   *
   * @returns {Complex}
   */
  asech: function() {
    const r = this.re, e = this.im;
    if (this.isZero())
      return ue.INFINITY;
    const t = r * r + e * e;
    return t !== 0 ? new ue(r / t, -e / t).acosh() : new ue(
      r !== 0 ? r / 0 : 0,
      e !== 0 ? -e / 0 : 0
    ).acosh();
  },
  /**
   * Calculate the complex inverse 1/z
   *
   * @returns {Complex}
   */
  inverse: function() {
    if (this.isZero())
      return ue.INFINITY;
    if (this.isInfinite())
      return ue.ZERO;
    const r = this.re, e = this.im, t = r * r + e * e;
    return new ue(r / t, -e / t);
  },
  /**
   * Returns the complex conjugate
   *
   * @returns {Complex}
   */
  conjugate: function() {
    return new ue(this.re, -this.im);
  },
  /**
   * Gets the negated complex number
   *
   * @returns {Complex}
   */
  neg: function() {
    return new ue(-this.re, -this.im);
  },
  /**
   * Ceils the actual complex number
   *
   * @returns {Complex}
   */
  ceil: function(r) {
    return r = Math.pow(10, r || 0), new ue(
      Math.ceil(this.re * r) / r,
      Math.ceil(this.im * r) / r
    );
  },
  /**
   * Floors the actual complex number
   *
   * @returns {Complex}
   */
  floor: function(r) {
    return r = Math.pow(10, r || 0), new ue(
      Math.floor(this.re * r) / r,
      Math.floor(this.im * r) / r
    );
  },
  /**
   * Ceils the actual complex number
   *
   * @returns {Complex}
   */
  round: function(r) {
    return r = Math.pow(10, r || 0), new ue(
      Math.round(this.re * r) / r,
      Math.round(this.im * r) / r
    );
  },
  /**
   * Compares two complex numbers
   *
   * **Note:** new Complex(Infinity).equals(Infinity) === false
   *
   * @returns {boolean}
   */
  equals: function(r, e) {
    const t = Ft(r, e);
    return Math.abs(t.re - this.re) <= ue.EPSILON && Math.abs(t.im - this.im) <= ue.EPSILON;
  },
  /**
   * Clones the actual object
   *
   * @returns {Complex}
   */
  clone: function() {
    return new ue(this.re, this.im);
  },
  /**
   * Gets a string of the actual complex number
   *
   * @returns {string}
   */
  toString: function() {
    let r = this.re, e = this.im, t = "";
    return this.isNaN() ? "NaN" : this.isInfinite() ? "Infinity" : (Math.abs(r) < ue.EPSILON && (r = 0), Math.abs(e) < ue.EPSILON && (e = 0), e === 0 ? t + r : (r !== 0 ? (t += r, t += " ", e < 0 ? (e = -e, t += "-") : t += "+", t += " ") : e < 0 && (e = -e, t += "-"), e !== 1 && (t += e), t + "i"));
  },
  /**
   * Returns the actual number as a vector
   *
   * @returns {Array}
   */
  toVector: function() {
    return [this.re, this.im];
  },
  /**
   * Returns the actual real value of the current object
   *
   * @returns {number|null}
   */
  valueOf: function() {
    return this.im === 0 ? this.re : null;
  },
  /**
   * Determines whether a complex number is not on the Riemann sphere.
   *
   * @returns {boolean}
   */
  isNaN: function() {
    return isNaN(this.re) || isNaN(this.im);
  },
  /**
   * Determines whether or not a complex number is at the zero pole of the
   * Riemann sphere.
   *
   * @returns {boolean}
   */
  isZero: function() {
    return this.im === 0 && this.re === 0;
  },
  /**
   * Determines whether a complex number is not at the infinity pole of the
   * Riemann sphere.
   *
   * @returns {boolean}
   */
  isFinite: function() {
    return isFinite(this.re) && isFinite(this.im);
  },
  /**
   * Determines whether or not a complex number is at the infinity pole of the
   * Riemann sphere.
   *
   * @returns {boolean}
   */
  isInfinite: function() {
    return !this.isFinite();
  }
};
ue.ZERO = new ue(0, 0);
ue.ONE = new ue(1, 0);
ue.I = new ue(0, 1);
ue.PI = new ue(Math.PI, 0);
ue.E = new ue(Math.E, 0);
ue.INFINITY = new ue(1 / 0, 1 / 0);
ue.NAN = new ue(NaN, NaN);
ue.EPSILON = 1e-15;
var Vh = "Complex", Zh = [], sm = /* @__PURE__ */ R(Vh, Zh, () => (Object.defineProperty(ue, "name", {
  value: "Complex"
}), ue.prototype.constructor = ue, ue.prototype.type = "Complex", ue.prototype.isComplex = !0, ue.prototype.toJSON = function() {
  return {
    mathjs: "Complex",
    re: this.re,
    im: this.im
  };
}, ue.prototype.toPolar = function() {
  return {
    r: this.abs(),
    phi: this.arg()
  };
}, ue.prototype.format = function(r) {
  var e = "", t = this.im, n = this.re, a = $t(this.re, r), i = $t(this.im, r), s = Re(r) ? r : r ? r.precision : null;
  if (s !== null) {
    var l = Math.pow(10, -s);
    Math.abs(n / t) < l && (n = 0), Math.abs(t / n) < l && (t = 0);
  }
  return t === 0 ? e = a : n === 0 ? t === 1 ? e = "i" : t === -1 ? e = "-i" : e = i + "i" : t < 0 ? t === -1 ? e = a + " - i" : e = a + " - " + i.substring(1) + "i" : t === 1 ? e = a + " + i" : e = a + " + " + i + "i", e;
}, ue.fromPolar = function(r) {
  switch (arguments.length) {
    case 1: {
      var e = arguments[0];
      if (typeof e == "object")
        return ue(e);
      throw new TypeError("Input has to be an object with r and phi keys.");
    }
    case 2: {
      var t = arguments[0], n = arguments[1];
      if (Re(t)) {
        if (Er(n) && n.hasBase("ANGLE") && (n = n.toNumber("rad")), Re(n))
          return new ue({
            r: t,
            phi: n
          });
        throw new TypeError("Phi is not a number nor an angle unit.");
      } else
        throw new TypeError("Radius r is not a number.");
    }
    default:
      throw new SyntaxError("Wrong number of arguments in function fromPolar");
  }
}, ue.prototype.valueOf = ue.prototype.toString, ue.fromJSON = function(r) {
  return new ue(r);
}, ue.compare = function(r, e) {
  return r.re > e.re ? 1 : r.re < e.re ? -1 : r.im > e.im ? 1 : r.im < e.im ? -1 : 0;
}, ue), {
  isClass: !0
});
typeof BigInt > "u" && (BigInt = function(r) {
  if (isNaN(r)) throw new Error("");
  return r;
});
const Se = BigInt(0), He = BigInt(1), pr = BigInt(2), Mn = BigInt(3), Qt = BigInt(5), Or = BigInt(10);
BigInt(Number.MAX_SAFE_INTEGER);
const Xh = 2e3, be = {
  s: He,
  n: Se,
  d: He
};
function nt(r, e) {
  try {
    r = BigInt(r);
  } catch {
    throw pt();
  }
  return r * e;
}
function Gr(r) {
  return typeof r == "bigint" ? r : Math.floor(r);
}
function nr(r, e) {
  if (e === Se)
    throw so();
  const t = Object.create(Ur.prototype);
  t.s = r < Se ? -He : He, r = r < Se ? -r : r;
  const n = Bt(r, e);
  return t.n = r / n, t.d = e / n, t;
}
const Yh = [pr * pr, pr, pr * pr, pr, pr * pr, pr * Mn, pr, pr * Mn];
function Gt(r) {
  const e = /* @__PURE__ */ Object.create(null);
  if (r <= He)
    return e[r] = He, e;
  const t = (n) => {
    e[n] = (e[n] || Se) + He;
  };
  for (; r % pr === Se; )
    t(pr), r /= pr;
  for (; r % Mn === Se; )
    t(Mn), r /= Mn;
  for (; r % Qt === Se; )
    t(Qt), r /= Qt;
  for (let n = 0, a = pr + Qt; a * a <= r; ) {
    for (; r % a === Se; )
      t(a), r /= a;
    a += Yh[n], n = n + 1 & 7;
  }
  return r > He && t(r), e;
}
const mr = function(r, e) {
  let t = Se, n = He, a = He;
  if (r != null) if (e !== void 0) {
    if (typeof r == "bigint")
      t = r;
    else {
      if (isNaN(r))
        throw pt();
      if (r % 1 !== 0)
        throw Po();
      t = BigInt(r);
    }
    if (typeof e == "bigint")
      n = e;
    else {
      if (isNaN(e))
        throw pt();
      if (e % 1 !== 0)
        throw Po();
      n = BigInt(e);
    }
    a = t * n;
  } else if (typeof r == "object") {
    if ("d" in r && "n" in r)
      t = BigInt(r.n), n = BigInt(r.d), "s" in r && (t *= BigInt(r.s));
    else if (0 in r)
      t = BigInt(r[0]), 1 in r && (n = BigInt(r[1]));
    else if (typeof r == "bigint")
      t = r;
    else
      throw pt();
    a = t * n;
  } else if (typeof r == "number") {
    if (isNaN(r))
      throw pt();
    if (r < 0 && (a = -He, r = -r), r % 1 === 0)
      t = BigInt(r);
    else {
      let i = 1, s = 0, l = 1, c = 1, o = 1, u = 1e7;
      for (r >= 1 && (i = 10 ** Math.floor(1 + Math.log10(r)), r /= i); l <= u && o <= u; ) {
        let f = (s + c) / (l + o);
        if (r === f) {
          l + o <= u ? (t = s + c, n = l + o) : o > l ? (t = c, n = o) : (t = s, n = l);
          break;
        } else
          r > f ? (s += c, l += o) : (c += s, o += l), l > u ? (t = c, n = o) : (t = s, n = l);
      }
      t = BigInt(t) * BigInt(i), n = BigInt(n);
    }
  } else if (typeof r == "string") {
    let i = 0, s = Se, l = Se, c = Se, o = He, u = He, f = r.replace(/_/g, "").match(/\d+|./g);
    if (f === null)
      throw pt();
    if (f[i] === "-" ? (a = -He, i++) : f[i] === "+" && i++, f.length === i + 1 ? l = nt(f[i++], a) : f[i + 1] === "." || f[i] === "." ? (f[i] !== "." && (s = nt(f[i++], a)), i++, (i + 1 === f.length || f[i + 1] === "(" && f[i + 3] === ")" || f[i + 1] === "'" && f[i + 3] === "'") && (l = nt(f[i], a), o = Or ** BigInt(f[i].length), i++), (f[i] === "(" && f[i + 2] === ")" || f[i] === "'" && f[i + 2] === "'") && (c = nt(f[i + 1], a), u = Or ** BigInt(f[i + 1].length) - He, i += 3)) : f[i + 1] === "/" || f[i + 1] === ":" ? (l = nt(f[i], a), o = nt(f[i + 2], He), i += 3) : f[i + 3] === "/" && f[i + 1] === " " && (s = nt(f[i], a), l = nt(f[i + 2], a), o = nt(f[i + 4], He), i += 5), f.length <= i)
      n = o * u, a = /* void */
      t = c + n * s + u * l;
    else
      throw pt();
  } else if (typeof r == "bigint")
    t = r, a = r, n = He;
  else
    throw pt();
  if (n === Se)
    throw so();
  be.s = a < Se ? -He : He, be.n = t < Se ? -t : t, be.d = n < Se ? -n : n;
};
function Jh(r, e, t) {
  let n = He;
  for (; e > Se; r = r * r % t, e >>= He)
    e & He && (n = n * r % t);
  return n;
}
function Qh(r, e) {
  for (; e % pr === Se; e /= pr)
    ;
  for (; e % Qt === Se; e /= Qt)
    ;
  if (e === He)
    return Se;
  let t = Or % e, n = 1;
  for (; t !== He; n++)
    if (t = t * Or % e, n > Xh)
      return Se;
  return BigInt(n);
}
function jh(r, e, t) {
  let n = He, a = Jh(Or, t, e);
  for (let i = 0; i < 300; i++) {
    if (n === a)
      return BigInt(i);
    n = n * Or % e, a = a * Or % e;
  }
  return 0;
}
function Bt(r, e) {
  if (!r)
    return e;
  if (!e)
    return r;
  for (; ; ) {
    if (r %= e, !r)
      return e;
    if (e %= r, !e)
      return r;
  }
}
function Ur(r, e) {
  if (mr(r, e), this instanceof Ur)
    r = Bt(be.d, be.n), this.s = be.s, this.n = be.n / r, this.d = be.d / r;
  else
    return nr(be.s * be.n, be.d);
}
const so = function() {
  return new Error("Division by Zero");
}, pt = function() {
  return new Error("Invalid argument");
}, Po = function() {
  return new Error("Parameters must be integer");
};
Ur.prototype = {
  s: He,
  n: Se,
  d: He,
  /**
   * Calculates the absolute value
   *
   * Ex: new Fraction(-4).abs() => 4
   **/
  abs: function() {
    return nr(this.n, this.d);
  },
  /**
   * Inverts the sign of the current fraction
   *
   * Ex: new Fraction(-4).neg() => 4
   **/
  neg: function() {
    return nr(-this.s * this.n, this.d);
  },
  /**
   * Adds two rational numbers
   *
   * Ex: new Fraction({n: 2, d: 3}).add("14.9") => 467 / 30
   **/
  add: function(r, e) {
    return mr(r, e), nr(
      this.s * this.n * be.d + be.s * this.d * be.n,
      this.d * be.d
    );
  },
  /**
   * Subtracts two rational numbers
   *
   * Ex: new Fraction({n: 2, d: 3}).add("14.9") => -427 / 30
   **/
  sub: function(r, e) {
    return mr(r, e), nr(
      this.s * this.n * be.d - be.s * this.d * be.n,
      this.d * be.d
    );
  },
  /**
   * Multiplies two rational numbers
   *
   * Ex: new Fraction("-17.(345)").mul(3) => 5776 / 111
   **/
  mul: function(r, e) {
    return mr(r, e), nr(
      this.s * be.s * this.n * be.n,
      this.d * be.d
    );
  },
  /**
   * Divides two rational numbers
   *
   * Ex: new Fraction("-17.(345)").inverse().div(3)
   **/
  div: function(r, e) {
    return mr(r, e), nr(
      this.s * be.s * this.n * be.d,
      this.d * be.n
    );
  },
  /**
   * Clones the actual object
   *
   * Ex: new Fraction("-17.(345)").clone()
   **/
  clone: function() {
    return nr(this.s * this.n, this.d);
  },
  /**
   * Calculates the modulo of two rational numbers - a more precise fmod
   *
   * Ex: new Fraction('4.(3)').mod([7, 8]) => (13/3) % (7/8) = (5/6)
   * Ex: new Fraction(20, 10).mod().equals(0) ? "is Integer"
   **/
  mod: function(r, e) {
    if (r === void 0)
      return nr(this.s * this.n % this.d, He);
    if (mr(r, e), Se === be.n * this.d)
      throw so();
    return nr(
      this.s * (be.d * this.n) % (be.n * this.d),
      be.d * this.d
    );
  },
  /**
   * Calculates the fractional gcd of two rational numbers
   *
   * Ex: new Fraction(5,8).gcd(3,7) => 1/56
   */
  gcd: function(r, e) {
    return mr(r, e), nr(Bt(be.n, this.n) * Bt(be.d, this.d), be.d * this.d);
  },
  /**
   * Calculates the fractional lcm of two rational numbers
   *
   * Ex: new Fraction(5,8).lcm(3,7) => 15
   */
  lcm: function(r, e) {
    return mr(r, e), be.n === Se && this.n === Se ? nr(Se, He) : nr(be.n * this.n, Bt(be.n, this.n) * Bt(be.d, this.d));
  },
  /**
   * Gets the inverse of the fraction, means numerator and denominator are exchanged
   *
   * Ex: new Fraction([-3, 4]).inverse() => -4 / 3
   **/
  inverse: function() {
    return nr(this.s * this.d, this.n);
  },
  /**
   * Calculates the fraction to some integer exponent
   *
   * Ex: new Fraction(-1,2).pow(-3) => -8
   */
  pow: function(r, e) {
    if (mr(r, e), be.d === He)
      return be.s < Se ? nr((this.s * this.d) ** be.n, this.n ** be.n) : nr((this.s * this.n) ** be.n, this.d ** be.n);
    if (this.s < Se) return null;
    let t = Gt(this.n), n = Gt(this.d), a = He, i = He;
    for (let s in t)
      if (s !== "1") {
        if (s === "0") {
          a = Se;
          break;
        }
        if (t[s] *= be.n, t[s] % be.d === Se)
          t[s] /= be.d;
        else return null;
        a *= BigInt(s) ** t[s];
      }
    for (let s in n)
      if (s !== "1") {
        if (n[s] *= be.n, n[s] % be.d === Se)
          n[s] /= be.d;
        else return null;
        i *= BigInt(s) ** n[s];
      }
    return be.s < Se ? nr(i, a) : nr(a, i);
  },
  /**
   * Calculates the logarithm of a fraction to a given rational base
   *
   * Ex: new Fraction(27, 8).log(9, 4) => 3/2
   */
  log: function(r, e) {
    if (mr(r, e), this.s <= Se || be.s <= Se) return null;
    const t = /* @__PURE__ */ Object.create(null), n = Gt(be.n), a = Gt(be.d), i = Gt(this.n), s = Gt(this.d);
    for (const o in a)
      n[o] = (n[o] || Se) - a[o];
    for (const o in s)
      i[o] = (i[o] || Se) - s[o];
    for (const o in n)
      o !== "1" && (t[o] = !0);
    for (const o in i)
      o !== "1" && (t[o] = !0);
    let l = null, c = null;
    for (const o in t) {
      const u = n[o] || Se, f = i[o] || Se;
      if (u === Se) {
        if (f !== Se)
          return null;
        continue;
      }
      let m = f, p = u;
      const d = Bt(m, p);
      if (m /= d, p /= d, l === null && c === null)
        l = m, c = p;
      else if (m * c !== l * p)
        return null;
    }
    return l !== null && c !== null ? nr(l, c) : null;
  },
  /**
   * Check if two rational numbers are the same
   *
   * Ex: new Fraction(19.6).equals([98, 5]);
   **/
  equals: function(r, e) {
    return mr(r, e), this.s * this.n * be.d === be.s * be.n * this.d;
  },
  /**
   * Check if this rational number is less than another
   *
   * Ex: new Fraction(19.6).lt([98, 5]);
   **/
  lt: function(r, e) {
    return mr(r, e), this.s * this.n * be.d < be.s * be.n * this.d;
  },
  /**
   * Check if this rational number is less than or equal another
   *
   * Ex: new Fraction(19.6).lt([98, 5]);
   **/
  lte: function(r, e) {
    return mr(r, e), this.s * this.n * be.d <= be.s * be.n * this.d;
  },
  /**
   * Check if this rational number is greater than another
   *
   * Ex: new Fraction(19.6).lt([98, 5]);
   **/
  gt: function(r, e) {
    return mr(r, e), this.s * this.n * be.d > be.s * be.n * this.d;
  },
  /**
   * Check if this rational number is greater than or equal another
   *
   * Ex: new Fraction(19.6).lt([98, 5]);
   **/
  gte: function(r, e) {
    return mr(r, e), this.s * this.n * be.d >= be.s * be.n * this.d;
  },
  /**
   * Compare two rational numbers
   * < 0 iff this < that
   * > 0 iff this > that
   * = 0 iff this = that
   *
   * Ex: new Fraction(19.6).compare([98, 5]);
   **/
  compare: function(r, e) {
    mr(r, e);
    let t = this.s * this.n * be.d - be.s * be.n * this.d;
    return (Se < t) - (t < Se);
  },
  /**
   * Calculates the ceil of a rational number
   *
   * Ex: new Fraction('4.(3)').ceil() => (5 / 1)
   **/
  ceil: function(r) {
    return r = Or ** BigInt(r || 0), nr(
      Gr(this.s * r * this.n / this.d) + (r * this.n % this.d > Se && this.s >= Se ? He : Se),
      r
    );
  },
  /**
   * Calculates the floor of a rational number
   *
   * Ex: new Fraction('4.(3)').floor() => (4 / 1)
   **/
  floor: function(r) {
    return r = Or ** BigInt(r || 0), nr(
      Gr(this.s * r * this.n / this.d) - (r * this.n % this.d > Se && this.s < Se ? He : Se),
      r
    );
  },
  /**
   * Rounds a rational numbers
   *
   * Ex: new Fraction('4.(3)').round() => (4 / 1)
   **/
  round: function(r) {
    return r = Or ** BigInt(r || 0), nr(
      Gr(this.s * r * this.n / this.d) + this.s * ((this.s >= Se ? He : Se) + pr * (r * this.n % this.d) > this.d ? He : Se),
      r
    );
  },
  /**
    * Rounds a rational number to a multiple of another rational number
    *
    * Ex: new Fraction('0.9').roundTo("1/8") => 7 / 8
    **/
  roundTo: function(r, e) {
    mr(r, e);
    const t = this.n * be.d, n = this.d * be.n, a = t % n;
    let i = Gr(t / n);
    return a + a >= n && i++, nr(this.s * i * be.n, be.d);
  },
  /**
   * Check if two rational numbers are divisible
   *
   * Ex: new Fraction(19.6).divisible(1.5);
   */
  divisible: function(r, e) {
    return mr(r, e), be.n === Se ? !1 : this.n * be.d % (be.n * this.d) === Se;
  },
  /**
   * Returns a decimal representation of the fraction
   *
   * Ex: new Fraction("100.'91823'").valueOf() => 100.91823918239183
   **/
  valueOf: function() {
    return Number(this.s * this.n) / Number(this.d);
  },
  /**
   * Creates a string representation of a fraction with all digits
   *
   * Ex: new Fraction("100.'91823'").toString() => "100.(91823)"
   **/
  toString: function(r = 15) {
    let e = this.n, t = this.d, n = Qh(e, t), a = jh(e, t, n), i = this.s < Se ? "-" : "";
    if (i += Gr(e / t), e %= t, e *= Or, e && (i += "."), n) {
      for (let s = a; s--; )
        i += Gr(e / t), e %= t, e *= Or;
      i += "(";
      for (let s = n; s--; )
        i += Gr(e / t), e %= t, e *= Or;
      i += ")";
    } else
      for (let s = r; e && s--; )
        i += Gr(e / t), e %= t, e *= Or;
    return i;
  },
  /**
   * Returns a string-fraction representation of a Fraction object
   *
   * Ex: new Fraction("1.'3'").toFraction() => "4 1/3"
   **/
  toFraction: function(r = !1) {
    let e = this.n, t = this.d, n = this.s < Se ? "-" : "";
    if (t === He)
      n += e;
    else {
      const a = Gr(e / t);
      r && a > Se && (n += a, n += " ", e %= t), n += e, n += "/", n += t;
    }
    return n;
  },
  /**
   * Returns a latex representation of a Fraction object
   *
   * Ex: new Fraction("1.'3'").toLatex() => "\frac{4}{3}"
   **/
  toLatex: function(r = !1) {
    let e = this.n, t = this.d, n = this.s < Se ? "-" : "";
    if (t === He)
      n += e;
    else {
      const a = Gr(e / t);
      r && a > Se && (n += a, e %= t), n += "\\frac{", n += e, n += "}{", n += t, n += "}";
    }
    return n;
  },
  /**
   * Returns an array of continued fraction elements
   *
   * Ex: new Fraction("7/8").toContinued() => [0,1,7]
   */
  toContinued: function() {
    let r = this.n, e = this.d;
    const t = [];
    for (; e; ) {
      t.push(Gr(r / e));
      const n = r % e;
      r = e, e = n;
    }
    return t;
  },
  simplify: function(r = 1e-3) {
    const e = BigInt(Math.ceil(1 / r)), t = this.abs(), n = t.toContinued();
    for (let a = 1; a < n.length; a++) {
      let i = nr(n[a - 1], He);
      for (let l = a - 2; l >= 0; l--)
        i = i.inverse().add(n[l]);
      let s = i.sub(t);
      if (s.n * e < s.d)
        return i.mul(this.s);
    }
    return this;
  }
};
var Kh = "Fraction", eg = [], um = /* @__PURE__ */ R(Kh, eg, () => (Object.defineProperty(Ur, "name", {
  value: "Fraction"
}), Ur.prototype.constructor = Ur, Ur.prototype.type = "Fraction", Ur.prototype.isFraction = !0, Ur.prototype.toJSON = function() {
  return {
    mathjs: "Fraction",
    n: String(this.s * this.n),
    d: String(this.d)
  };
}, Ur.fromJSON = function(r) {
  return new Ur(r);
}, Ur), {
  isClass: !0
}), rg = "Range", tg = [], ng = /* @__PURE__ */ R(rg, tg, () => {
  function r(e, t, n) {
    if (!(this instanceof r))
      throw new SyntaxError("Constructor must be called with the new operator");
    var a = e != null, i = t != null, s = n != null;
    if (a) {
      if ($e(e))
        e = e.toNumber();
      else if (typeof e != "number" && !en(e))
        throw new TypeError("Parameter start must be a number or bigint");
    }
    if (i) {
      if ($e(t))
        t = t.toNumber();
      else if (typeof t != "number" && !en(t))
        throw new TypeError("Parameter end must be a number or bigint");
    }
    if (s) {
      if ($e(n))
        n = n.toNumber();
      else if (typeof n != "number" && !en(n))
        throw new TypeError("Parameter step must be a number or bigint");
    }
    if (this.start = a ? parseFloat(e) : 0, this.end = i ? parseFloat(t) : 0, this.step = s ? parseFloat(n) : 1, s && dr(this.step, 0))
      throw new Error("Step must not be zero");
  }
  return r.prototype.type = "Range", r.prototype.isRange = !0, r.parse = function(e) {
    if (typeof e != "string")
      return null;
    var t = e.split(":"), n = t.map(function(i) {
      return parseFloat(i);
    }), a = n.some(function(i) {
      return isNaN(i);
    });
    if (a)
      return null;
    switch (n.length) {
      case 2:
        return new r(n[0], n[1]);
      case 3:
        return new r(n[0], n[2], n[1]);
      default:
        return null;
    }
  }, r.prototype.clone = function() {
    return new r(this.start, this.end, this.step);
  }, r.prototype.size = function() {
    var e = 0, t = this.start, n = this.step, a = this.end, i = a - t;
    return yt(n) === yt(i) ? e = Math.ceil(i / n) : i === 0 && (e = 0), isNaN(e) && (e = 0), [e];
  }, r.prototype.min = function() {
    var e = this.size()[0];
    if (e > 0)
      return this.step > 0 ? this.start : this.start + (e - 1) * this.step;
  }, r.prototype.max = function() {
    var e = this.size()[0];
    if (e > 0)
      return this.step > 0 ? this.start + (e - 1) * this.step : this.start;
  }, r.prototype.forEach = function(e) {
    var t = this.start, n = this.step, a = this.end, i = 0;
    if (n > 0)
      for (; t < a; )
        e(t, [i], this), t += n, i++;
    else if (n < 0)
      for (; t > a; )
        e(t, [i], this), t += n, i++;
  }, r.prototype.map = function(e) {
    var t = [];
    return this.forEach(function(n, a, i) {
      t[a[0]] = e(n, a, i);
    }), t;
  }, r.prototype.toArray = function() {
    var e = [];
    return this.forEach(function(t, n) {
      e[n[0]] = t;
    }), e;
  }, r.prototype.valueOf = function() {
    return this.toArray();
  }, r.prototype.format = function(e) {
    var t = $t(this.start, e);
    return this.step !== 1 && (t += ":" + $t(this.step, e)), t += ":" + $t(this.end, e), t;
  }, r.prototype.toString = function() {
    return this.format();
  }, r.prototype.toJSON = function() {
    return {
      mathjs: "Range",
      start: this.start,
      end: this.end,
      step: this.step
    };
  }, r.fromJSON = function(e) {
    return new r(e.start, e.end, e.step);
  }, r;
}, {
  isClass: !0
}), ag = "Matrix", ig = [], cm = /* @__PURE__ */ R(ag, ig, () => {
  function r() {
    if (!(this instanceof r))
      throw new SyntaxError("Constructor must be called with the new operator");
  }
  return r.prototype.type = "Matrix", r.prototype.isMatrix = !0, r.prototype.storage = function() {
    throw new Error("Cannot invoke storage on a Matrix interface");
  }, r.prototype.datatype = function() {
    throw new Error("Cannot invoke datatype on a Matrix interface");
  }, r.prototype.create = function(e, t) {
    throw new Error("Cannot invoke create on a Matrix interface");
  }, r.prototype.subset = function(e, t, n) {
    throw new Error("Cannot invoke subset on a Matrix interface");
  }, r.prototype.get = function(e) {
    throw new Error("Cannot invoke get on a Matrix interface");
  }, r.prototype.set = function(e, t, n) {
    throw new Error("Cannot invoke set on a Matrix interface");
  }, r.prototype.resize = function(e, t) {
    throw new Error("Cannot invoke resize on a Matrix interface");
  }, r.prototype.reshape = function(e, t) {
    throw new Error("Cannot invoke reshape on a Matrix interface");
  }, r.prototype.clone = function() {
    throw new Error("Cannot invoke clone on a Matrix interface");
  }, r.prototype.size = function() {
    throw new Error("Cannot invoke size on a Matrix interface");
  }, r.prototype.map = function(e, t) {
    throw new Error("Cannot invoke map on a Matrix interface");
  }, r.prototype.forEach = function(e) {
    throw new Error("Cannot invoke forEach on a Matrix interface");
  }, r.prototype[Symbol.iterator] = function() {
    throw new Error("Cannot iterate a Matrix interface");
  }, r.prototype.toArray = function() {
    throw new Error("Cannot invoke toArray on a Matrix interface");
  }, r.prototype.valueOf = function() {
    throw new Error("Cannot invoke valueOf on a Matrix interface");
  }, r.prototype.format = function(e) {
    throw new Error("Cannot invoke format on a Matrix interface");
  }, r.prototype.toString = function() {
    throw new Error("Cannot invoke toString on a Matrix interface");
  }, r;
}, {
  isClass: !0
});
function yi(r, e, t) {
  var n = r.constructor, a = new n(2), i = "";
  if (t) {
    if (t < 1)
      throw new Error("size must be in greater than 0");
    if (!Ne(t))
      throw new Error("size must be an integer");
    if (r.greaterThan(a.pow(t - 1).sub(1)) || r.lessThan(a.pow(t - 1).mul(-1)))
      throw new Error("Value must be in range [-2^".concat(t - 1, ", 2^").concat(t - 1, "-1]"));
    if (!r.isInteger())
      throw new Error("Value must be an integer");
    r.lessThan(0) && (r = r.add(a.pow(t))), i = "i".concat(t);
  }
  switch (e) {
    case 2:
      return "".concat(r.toBinary()).concat(i);
    case 8:
      return "".concat(r.toOctal()).concat(i);
    case 16:
      return "".concat(r.toHexadecimal()).concat(i);
    default:
      throw new Error("Base ".concat(e, " not supported "));
  }
}
function og(r, e) {
  if (typeof e == "function")
    return e(r);
  if (!r.isFinite())
    return r.isNaN() ? "NaN" : r.gt(0) ? "Infinity" : "-Infinity";
  var {
    notation: t,
    precision: n,
    wordSize: a
  } = Wf(e);
  switch (t) {
    case "fixed":
      return ug(r, n);
    case "exponential":
      return Uo(r, n);
    case "engineering":
      return sg(r, n);
    case "bin":
      return yi(r, 2, a);
    case "oct":
      return yi(r, 8, a);
    case "hex":
      return yi(r, 16, a);
    case "auto": {
      var i = Lo(e?.lowerExp, -3), s = Lo(e?.upperExp, 5);
      if (r.isZero()) return "0";
      var l, c = r.toSignificantDigits(n), o = c.e;
      return o >= i && o < s ? l = c.toFixed() : l = Uo(r, n), l.replace(/((\.\d*?)(0+))($|e)/, function() {
        var u = arguments[2], f = arguments[4];
        return u !== "." ? u + f : f;
      });
    }
    default:
      throw new Error('Unknown notation "' + t + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
  }
}
function sg(r, e) {
  var t = r.e, n = t % 3 === 0 ? t : t < 0 ? t - 3 - t % 3 : t - t % 3, a = r.mul(Math.pow(10, -n)), i = a.toPrecision(e);
  if (i.includes("e")) {
    var s = r.constructor;
    i = new s(i).toFixed();
  }
  return i + "e" + (t >= 0 ? "+" : "") + n.toString();
}
function Uo(r, e) {
  return e !== void 0 ? r.toExponential(e - 1) : r.toExponential();
}
function ug(r, e) {
  return r.toFixed(e);
}
function Lo(r, e) {
  return Re(r) ? r : $e(r) ? r.toNumber() : e;
}
function cg(r, e) {
  var t = r.length - e.length, n = r.length;
  return r.substring(t, n) === e;
}
function ke(r, e) {
  var t = lg(r, e);
  return e && typeof e == "object" && "truncate" in e && t.length > e.truncate ? t.substring(0, e.truncate - 3) + "..." : t;
}
function lg(r, e) {
  if (typeof r == "number")
    return $t(r, e);
  if ($e(r))
    return og(r, e);
  if (fg(r))
    return !e || e.fraction !== "decimal" ? "".concat(r.s * r.n, "/").concat(r.d) : r.toString();
  if (Array.isArray(r))
    return lm(r, e);
  if (gr(r))
    return jt(r);
  if (typeof r == "function")
    return r.syntax ? String(r.syntax) : "function";
  if (r && typeof r == "object") {
    if (typeof r.format == "function")
      return r.format(e);
    if (r && r.toString(e) !== {}.toString())
      return r.toString(e);
    var t = Object.keys(r).map((n) => jt(n) + ": " + ke(r[n], e));
    return "{" + t.join(", ") + "}";
  }
  return String(r);
}
function jt(r) {
  for (var e = String(r), t = "", n = 0; n < e.length; ) {
    var a = e.charAt(n);
    t += a in ko ? ko[a] : a, n++;
  }
  return '"' + t + '"';
}
var ko = {
  '"': '\\"',
  "\\": "\\\\",
  "\b": "\\b",
  "\f": "\\f",
  "\n": "\\n",
  "\r": "\\r",
  "	": "\\t"
};
function Lr(r) {
  var e = String(r);
  return e = e.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), e;
}
function lm(r, e) {
  if (Array.isArray(r)) {
    for (var t = "[", n = r.length, a = 0; a < n; a++)
      a !== 0 && (t += ", "), t += lm(r[a], e);
    return t += "]", t;
  } else
    return ke(r, e);
}
function fg(r) {
  return r && typeof r == "object" && typeof r.s == "bigint" && typeof r.n == "bigint" && typeof r.d == "bigint" || !1;
}
function qi(r, e) {
  if (!gr(r))
    throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + Ke(r) + ", index: 0)");
  if (!gr(e))
    throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + Ke(e) + ", index: 1)");
  return r === e ? 0 : r > e ? 1 : -1;
}
function Ue(r, e, t) {
  if (!(this instanceof Ue))
    throw new SyntaxError("Constructor must be called with the new operator");
  this.actual = r, this.expected = e, this.relation = t, this.message = "Dimension mismatch (" + (Array.isArray(r) ? "[" + r.join(", ") + "]" : r) + " " + (this.relation || "!=") + " " + (Array.isArray(e) ? "[" + e.join(", ") + "]" : e) + ")", this.stack = new Error().stack;
}
Ue.prototype = new RangeError();
Ue.prototype.constructor = RangeError;
Ue.prototype.name = "DimensionError";
Ue.prototype.isDimensionError = !0;
function Hr(r, e, t) {
  if (!(this instanceof Hr))
    throw new SyntaxError("Constructor must be called with the new operator");
  this.index = r, arguments.length < 3 ? (this.min = 0, this.max = e) : (this.min = e, this.max = t), this.min !== void 0 && this.index < this.min ? this.message = "Index out of range (" + this.index + " < " + this.min + ")" : this.max !== void 0 && this.index >= this.max ? this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")" : this.message = "Index out of range (" + this.index + ")", this.stack = new Error().stack;
}
Hr.prototype = new RangeError();
Hr.prototype.constructor = RangeError;
Hr.prototype.name = "IndexError";
Hr.prototype.isIndexError = !0;
function Oe(r) {
  for (var e = []; Array.isArray(r); )
    e.push(r.length), r = r[0];
  return e;
}
function fm(r, e, t) {
  var n, a = r.length;
  if (a !== e[t])
    throw new Ue(a, e[t]);
  if (t < e.length - 1) {
    var i = t + 1;
    for (n = 0; n < a; n++) {
      var s = r[n];
      if (!Array.isArray(s))
        throw new Ue(e.length - 1, e.length, "<");
      fm(r[n], e, i);
    }
  } else
    for (n = 0; n < a; n++)
      if (Array.isArray(r[n]))
        throw new Ue(e.length + 1, e.length, ">");
}
function Ho(r, e) {
  var t = e.length === 0;
  if (t) {
    if (Array.isArray(r))
      throw new Ue(r.length, 0);
  } else
    fm(r, e, 0);
}
function _a(r, e) {
  var t = r.isMatrix ? r._size : Oe(r), n = e._sourceSize;
  n.forEach((a, i) => {
    if (a !== null && a !== t[i])
      throw new Ue(a, t[i]);
  });
}
function er(r, e) {
  if (r !== void 0) {
    if (!Re(r) || !Ne(r))
      throw new TypeError("Index must be an integer (value: " + r + ")");
    if (r < 0 || typeof e == "number" && r >= e)
      throw new Hr(r, e);
  }
}
function sn(r) {
  for (var e = 0; e < r._dimensions.length; ++e) {
    var t = r._dimensions[e];
    if (t._data && Ye(t._data)) {
      if (t._size[0] === 0)
        return !0;
    } else if (t.isRange) {
      if (t.start === t.end)
        return !0;
    } else if (gr(t) && t.length === 0)
      return !0;
  }
  return !1;
}
function un(r, e, t) {
  if (!Array.isArray(e))
    throw new TypeError("Array expected");
  if (e.length === 0)
    throw new Error("Resizing to scalar is not supported");
  e.forEach(function(a) {
    if (!Re(a) || !Ne(a) || a < 0)
      throw new TypeError("Invalid size, must contain positive integers (size: " + ke(e) + ")");
  }), (Re(r) || $e(r)) && (r = [r]);
  var n = t !== void 0 ? t : 0;
  return Pi(r, e, 0, n), r;
}
function Pi(r, e, t, n) {
  var a, i, s = r.length, l = e[t], c = Math.min(s, l);
  if (r.length = l, t < e.length - 1) {
    var o = t + 1;
    for (a = 0; a < c; a++)
      i = r[a], Array.isArray(i) || (i = [i], r[a] = i), Pi(i, e, o, n);
    for (a = c; a < l; a++)
      i = [], r[a] = i, Pi(i, e, o, n);
  } else {
    for (a = 0; a < c; a++)
      for (; Array.isArray(r[a]); )
        r[a] = r[a][0];
    for (a = c; a < l; a++)
      r[a] = n;
  }
}
function uo(r, e) {
  var t = Ve(r, !0), n = t.length;
  if (!Array.isArray(r) || !Array.isArray(e))
    throw new TypeError("Array expected");
  if (e.length === 0)
    throw new Ue(0, n, "!=");
  e = co(e, n);
  var a = mm(e);
  if (n !== a)
    throw new Ue(a, n, "!=");
  try {
    return mg(t, e);
  } catch (i) {
    throw i instanceof Ue ? new Ue(a, n, "!=") : i;
  }
}
function co(r, e) {
  var t = mm(r), n = r.slice(), a = -1, i = r.indexOf(a), s = r.indexOf(a, i + 1) >= 0;
  if (s)
    throw new Error("More than one wildcard in sizes");
  var l = i >= 0, c = e % t === 0;
  if (l)
    if (c)
      n[i] = -e / t;
    else
      throw new Error("Could not replace wildcard, since " + e + " is no multiple of " + -t);
  return n;
}
function mm(r) {
  return r.reduce((e, t) => e * t, 1);
}
function mg(r, e) {
  for (var t = r, n, a = e.length - 1; a > 0; a--) {
    var i = e[a];
    n = [];
    for (var s = t.length / i, l = 0; l < s; l++)
      n.push(t.slice(l * i, (l + 1) * i));
    t = n;
  }
  return t;
}
function Ta(r, e) {
  for (var t = Oe(r); Array.isArray(r) && r.length === 1; )
    r = r[0], t.shift();
  for (var n = t.length; t[n - 1] === 1; )
    n--;
  return n < t.length && (r = pm(r, n, 0), t.length = n), r;
}
function pm(r, e, t) {
  var n, a;
  if (t < e) {
    var i = t + 1;
    for (n = 0, a = r.length; n < a; n++)
      r[n] = pm(r[n], e, i);
  } else
    for (; Array.isArray(r); )
      r = r[0];
  return r;
}
function dm(r, e, t, n) {
  var a = n || Oe(r);
  if (t)
    for (var i = 0; i < t; i++)
      r = [r], a.unshift(1);
  for (r = vm(r, e, 0); a.length < e; )
    a.push(1);
  return r;
}
function vm(r, e, t) {
  var n, a;
  if (Array.isArray(r)) {
    var i = t + 1;
    for (n = 0, a = r.length; n < a; n++)
      r[n] = vm(r[n], e, i);
  } else
    for (var s = t; s < e; s++)
      r = [r];
  return r;
}
function Ve(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (!Array.isArray(r))
    return r;
  if (typeof e != "boolean")
    throw new TypeError("Boolean expected for second argument of flatten");
  var t = [];
  return e ? a(r) : n(r), t;
  function n(i) {
    for (var s = 0; s < i.length; s++) {
      var l = i[s];
      Array.isArray(l) ? n(l) : t.push(l);
    }
  }
  function a(i) {
    if (Array.isArray(i[0]))
      for (var s = 0; s < i.length; s++)
        a(i[s]);
    else
      for (var l = 0; l < i.length; l++)
        t.push(i[l]);
  }
}
function xt(r, e) {
  return Array.prototype.map.call(r, e);
}
function hm(r, e) {
  Array.prototype.forEach.call(r, e);
}
function Wo(r, e) {
  if (Oe(r).length !== 1)
    throw new Error("Only one dimensional matrices supported");
  return Array.prototype.filter.call(r, e);
}
function Go(r, e) {
  if (Oe(r).length !== 1)
    throw new Error("Only one dimensional matrices supported");
  return Array.prototype.filter.call(r, (t) => e.test(t));
}
function Vo(r, e) {
  return Array.prototype.join.call(r, e);
}
function cn(r) {
  if (!Array.isArray(r))
    throw new TypeError("Array input expected");
  if (r.length === 0)
    return r;
  var e = [], t = 0;
  e[0] = {
    value: r[0],
    identifier: 0
  };
  for (var n = 1; n < r.length; n++)
    r[n] === r[n - 1] ? t++ : t = 0, e.push({
      value: r[n],
      identifier: t
    });
  return e;
}
function Fa(r) {
  if (!Array.isArray(r))
    throw new TypeError("Array input expected");
  if (r.length === 0)
    return r;
  for (var e = [], t = 0; t < r.length; t++)
    e.push(r[t].value);
  return e;
}
function ni(r, e) {
  for (var t, n = 0, a = 0; a < r.length; a++) {
    var i = r[a], s = Array.isArray(i);
    if (a === 0 && s && (n = i.length), s && i.length !== n)
      return;
    var l = s ? ni(i, e) : e(i);
    if (t === void 0)
      t = l;
    else if (t !== l)
      return "mixed";
  }
  return t;
}
function gm(r, e, t, n) {
  if (n < t) {
    if (r.length !== e.length)
      throw new Ue(r.length, e.length);
    for (var a = [], i = 0; i < r.length; i++)
      a[i] = gm(r[i], e[i], t, n + 1);
    return a;
  } else
    return r.concat(e);
}
function ym() {
  var r = Array.prototype.slice.call(arguments, 0, -1), e = Array.prototype.slice.call(arguments, -1);
  if (r.length === 1)
    return r[0];
  if (r.length > 1)
    return r.slice(1).reduce(function(t, n) {
      return gm(t, n, e, 0);
    }, r[0]);
  throw new Error("Wrong number of arguments in function concat");
}
function Ba() {
  for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
    e[t] = arguments[t];
  for (var n = e.map((m) => m.length), a = Math.max(...n), i = new Array(a).fill(null), s = 0; s < e.length; s++)
    for (var l = e[s], c = n[s], o = 0; o < c; o++) {
      var u = a - c + o;
      l[o] > i[u] && (i[u] = l[o]);
    }
  for (var f = 0; f < e.length; f++)
    bm(e[f], i);
  return i;
}
function bm(r, e) {
  for (var t = e.length, n = r.length, a = 0; a < n; a++) {
    var i = t - n + a;
    if (r[a] < e[i] && r[a] > 1 || r[a] > e[i])
      throw new Error("shape mismatch: mismatch is found in arg with shape (".concat(r, ") not possible to broadcast dimension ").concat(n, " with size ").concat(r[a], " to size ").concat(e[i]));
  }
}
function Ot(r, e) {
  var t = Oe(r);
  if (ut(t, e))
    return r;
  bm(t, e);
  var n = Ba(t, e), a = n.length, i = [...Array(a - t.length).fill(1), ...t], s = dg(r);
  t.length < a && (s = uo(s, i), t = Oe(s));
  for (var l = 0; l < a; l++)
    t[l] < n[l] && (s = pg(s, n[l], l), t = Oe(s));
  return s;
}
function pg(r, e, t) {
  return ym(...Array(e).fill(r), t);
}
function Oa(r, e) {
  if (!Array.isArray(r))
    throw new Error("Array expected");
  var t = Oe(r);
  if (e.length !== t.length)
    throw new Ue(e.length, t.length);
  for (var n = 0; n < e.length; n++)
    er(e[n], t[n]);
  return e.reduce((a, i) => a[i], r);
}
function Ui(r, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  if (r.length === 0)
    return [];
  if (t)
    return i(r);
  var n = [];
  return a(r, 0);
  function a(s, l) {
    if (Array.isArray(s)) {
      for (var c = s.length, o = Array(c), u = 0; u < c; u++)
        n[l] = u, o[u] = a(s[u], l + 1);
      return o;
    } else
      return e(s, n.slice(0, l), r);
  }
  function i(s) {
    if (Array.isArray(s)) {
      for (var l = s.length, c = Array(l), o = 0; o < l; o++)
        c[o] = i(s[o]);
      return c;
    } else
      return e(s);
  }
}
function xm(r, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  if (r.length === 0)
    return;
  if (t) {
    i(r);
    return;
  }
  var n = [];
  a(r, 0);
  function a(s, l) {
    if (Array.isArray(s))
      for (var c = s.length, o = 0; o < c; o++)
        n[l] = o, a(s[o], l + 1);
    else
      e(s, n.slice(0, l), r);
  }
  function i(s) {
    if (Array.isArray(s))
      for (var l = s.length, c = 0; c < l; c++)
        i(s[c]);
    else
      e(s);
  }
}
function dg(r) {
  return hr([], r);
}
function zt(r, e, t, n) {
  if (Tn.isTypedFunction(r)) {
    var a;
    if (n)
      a = 1;
    else {
      var i = (e.isMatrix ? e.size() : Oe(e)).map(() => 0), s = e.isMatrix ? e.get(i) : Oa(e, i);
      a = gg(r, s, i, e);
    }
    var l;
    if (e.isMatrix && e.dataType !== "mixed" && e.dataType !== void 0) {
      var c = vg(r, a);
      l = c !== void 0 ? c : r;
    } else
      l = r;
    return a >= 1 && a <= 3 ? {
      isUnary: a === 1,
      fn: function() {
        for (var u = arguments.length, f = new Array(u), m = 0; m < u; m++)
          f[m] = arguments[m];
        return Zo(l, f.slice(0, a), t, r.name);
      }
    } : {
      isUnary: !1,
      fn: function() {
        for (var u = arguments.length, f = new Array(u), m = 0; m < u; m++)
          f[m] = arguments[m];
        return Zo(l, f, t, r.name);
      }
    };
  }
  return n === void 0 ? {
    isUnary: hg(r),
    fn: r
  } : {
    isUnary: n,
    fn: r
  };
}
function vg(r, e) {
  var t = [];
  if (Object.entries(r.signatures).forEach((n) => {
    var [a, i] = n;
    a.split(",").length === e && t.push(i);
  }), t.length === 1)
    return t[0];
}
function hg(r) {
  if (r.length !== 1) return !1;
  var e = r.toString();
  if (/arguments/.test(e)) return !1;
  var t = e.match(/\(.*?\)/);
  return !/\.\.\./.test(t);
}
function gg(r, e, t, n) {
  for (var a = [e, t, n], i = 3; i > 0; i--) {
    var s = a.slice(0, i);
    if (Tn.resolve(r, s) !== null)
      return i;
  }
}
function Zo(r, e, t, n) {
  try {
    return r(...e);
  } catch (a) {
    yg(a, e, t, n);
  }
}
function yg(r, e, t, n) {
  var a;
  if (r instanceof TypeError && ((a = r.data) === null || a === void 0 ? void 0 : a.category) === "wrongType") {
    var i = [];
    throw i.push("value: ".concat(Ke(e[0]))), e.length >= 2 && i.push("index: ".concat(Ke(e[1]))), e.length >= 3 && i.push("array: ".concat(Ke(e[2]))), new TypeError("Function ".concat(t, " cannot apply callback arguments ") + "".concat(n, "(").concat(i.join(", "), ") at index ").concat(JSON.stringify(e[1])));
  } else
    throw new TypeError("Function ".concat(t, " cannot apply callback arguments ") + "to function ".concat(n, ": ").concat(r.message));
}
var bg = "DenseMatrix", xg = ["Matrix"], wm = /* @__PURE__ */ R(bg, xg, (r) => {
  var {
    Matrix: e
  } = r;
  function t(u, f) {
    if (!(this instanceof t))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (f && !gr(f))
      throw new Error("Invalid datatype: " + f);
    if (Ee(u))
      u.type === "DenseMatrix" ? (this._data = Te(u._data), this._size = Te(u._size), this._datatype = f || u._datatype) : (this._data = u.toArray(), this._size = u.size(), this._datatype = f || u._datatype);
    else if (u && Ye(u.data) && Ye(u.size))
      this._data = u.data, this._size = u.size, Ho(this._data, this._size), this._datatype = f || u.datatype;
    else if (Ye(u))
      this._data = o(u), this._size = Oe(this._data), Ho(this._data, this._size), this._datatype = f;
    else {
      if (u)
        throw new TypeError("Unsupported type of data (" + Ke(u) + ")");
      this._data = [], this._size = [0], this._datatype = f;
    }
  }
  t.prototype = new e(), t.prototype.createDenseMatrix = function(u, f) {
    return new t(u, f);
  }, Object.defineProperty(t, "name", {
    value: "DenseMatrix"
  }), t.prototype.constructor = t, t.prototype.type = "DenseMatrix", t.prototype.isDenseMatrix = !0, t.prototype.getDataType = function() {
    return ni(this._data, Ke);
  }, t.prototype.storage = function() {
    return "dense";
  }, t.prototype.datatype = function() {
    return this._datatype;
  }, t.prototype.create = function(u, f) {
    return new t(u, f);
  }, t.prototype.subset = function(u, f, m) {
    switch (arguments.length) {
      case 1:
        return n(this, u);
      // intentional fall through
      case 2:
      case 3:
        return i(this, u, f, m);
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, t.prototype.get = function(u) {
    return Oa(this._data, u);
  }, t.prototype.set = function(u, f, m) {
    if (!Ye(u))
      throw new TypeError("Array expected");
    if (u.length < this._size.length)
      throw new Ue(u.length, this._size.length, "<");
    var p, d, v, x = u.map(function(D) {
      return D + 1;
    });
    c(this, x, m);
    var h = this._data;
    for (p = 0, d = u.length - 1; p < d; p++)
      v = u[p], er(v, h.length), h = h[v];
    return v = u[u.length - 1], er(v, h.length), h[v] = f, this;
  };
  function n(u, f) {
    if (!$n(f))
      throw new TypeError("Invalid index");
    var m = f.isScalar();
    if (m)
      return u.get(f.min());
    var p = f.size();
    if (p.length !== u._size.length)
      throw new Ue(p.length, u._size.length);
    for (var d = f.min(), v = f.max(), x = 0, h = u._size.length; x < h; x++)
      er(d[x], u._size[x]), er(v[x], u._size[x]);
    var D = new t([]), y = a(u._data, f);
    return D._size = y.size, D._datatype = u._datatype, D._data = y.data, D;
  }
  function a(u, f) {
    var m = f.size().length - 1, p = Array(m);
    return {
      data: d(u),
      size: p
    };
    function d(v) {
      var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, h = f.dimension(x);
      return p[x] = h.size()[0], x < m ? h.map((D) => (er(D, v.length), d(v[D], x + 1))).valueOf() : h.map((D) => (er(D, v.length), v[D])).valueOf();
    }
  }
  function i(u, f, m, p) {
    if (!f || f.isIndex !== !0)
      throw new TypeError("Invalid index");
    var d = f.size(), v = f.isScalar(), x;
    if (Ee(m) ? (x = m.size(), m = m.valueOf()) : x = Oe(m), v) {
      if (x.length !== 0)
        throw new TypeError("Scalar expected");
      u.set(f.min(), m, p);
    } else {
      if (!ut(x, d))
        try {
          x.length === 0 ? m = Ot([m], d) : m = Ot(m, d), x = Oe(m);
        } catch {
        }
      if (d.length < u._size.length)
        throw new Ue(d.length, u._size.length, "<");
      if (x.length < d.length) {
        for (var h = 0, D = 0; d[h] === 1 && x[h] === 1; )
          h++;
        for (; d[h] === 1; )
          D++, h++;
        m = dm(m, d.length, D, x);
      }
      if (!ut(d, x))
        throw new Ue(d, x, ">");
      var y = f.max().map(function(w) {
        return w + 1;
      });
      c(u, y, p), s(u._data, f, m);
    }
    return u;
  }
  function s(u, f, m) {
    var p = f.size().length - 1;
    d(u, m);
    function d(v, x) {
      var h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, D = f.dimension(h);
      h < p ? D.forEach((y, w) => {
        er(y, v.length), d(v[y], x[w[0]], h + 1);
      }) : D.forEach((y, w) => {
        er(y, v.length), v[y] = x[w[0]];
      });
    }
  }
  t.prototype.resize = function(u, f, m) {
    if (!Ir(u))
      throw new TypeError("Array or Matrix expected");
    var p = u.valueOf().map((v) => Array.isArray(v) && v.length === 1 ? v[0] : v), d = m ? this.clone() : this;
    return l(d, p, f);
  };
  function l(u, f, m) {
    if (f.length === 0) {
      for (var p = u._data; Ye(p); )
        p = p[0];
      return p;
    }
    return u._size = f.slice(0), u._data = un(u._data, u._size, m), u;
  }
  t.prototype.reshape = function(u, f) {
    var m = f ? this.clone() : this;
    m._data = uo(m._data, u);
    var p = m._size.reduce((d, v) => d * v);
    return m._size = co(u, p), m;
  };
  function c(u, f, m) {
    for (var p = u._size.slice(0), d = !1; p.length < f.length; )
      p.push(0), d = !0;
    for (var v = 0, x = f.length; v < x; v++)
      f[v] > p[v] && (p[v] = f[v], d = !0);
    d && l(u, p, m);
  }
  t.prototype.clone = function() {
    var u = new t({
      data: Te(this._data),
      size: Te(this._size),
      datatype: this._datatype
    });
    return u;
  }, t.prototype.size = function() {
    return this._size.slice(0);
  }, t.prototype.map = function(u) {
    var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, m = this, p = m._size.length - 1;
    if (p < 0) return m.clone();
    var d = zt(u, m, "map", f), v = d.fn, x = m.create(void 0, m._datatype);
    if (x._size = m._size, f || d.isUnary)
      return x._data = g(m._data), x;
    if (p === 0) {
      for (var h = m.valueOf(), D = Array(h.length), y = 0; y < h.length; y++)
        D[y] = v(h[y], [y], m);
      return x._data = D, x;
    }
    var w = [];
    return x._data = b(m._data), x;
    function b(N) {
      var S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, A = Array(N.length);
      if (S < p)
        for (var E = 0; E < N.length; E++)
          w[S] = E, A[E] = b(N[E], S + 1);
      else
        for (var M = 0; M < N.length; M++)
          w[S] = M, A[M] = v(N[M], w.slice(), m);
      return A;
    }
    function g(N) {
      var S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, A = Array(N.length);
      if (S < p)
        for (var E = 0; E < N.length; E++)
          A[E] = g(N[E], S + 1);
      else
        for (var M = 0; M < N.length; M++)
          A[M] = v(N[M]);
      return A;
    }
  }, t.prototype.forEach = function(u) {
    var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, m = this, p = m._size.length - 1;
    if (p < 0) return;
    var d = zt(u, m, "map", f), v = d.fn;
    if (f || d.isUnary) {
      y(m._data);
      return;
    }
    if (p === 0) {
      for (var x = 0; x < m._data.length; x++)
        v(m._data[x], [x], m);
      return;
    }
    var h = [];
    D(m._data);
    function D(w) {
      var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (b < p)
        for (var g = 0; g < w.length; g++)
          h[b] = g, D(w[g], b + 1);
      else
        for (var N = 0; N < w.length; N++)
          h[b] = N, v(w[N], h.slice(), m);
    }
    function y(w) {
      var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (b < p)
        for (var g = 0; g < w.length; g++)
          y(w[g], b + 1);
      else
        for (var N = 0; N < w.length; N++)
          v(w[N]);
    }
  }, t.prototype[Symbol.iterator] = function* () {
    var u = this._size.length - 1;
    if (!(u < 0)) {
      if (u === 0) {
        for (var f = 0; f < this._data.length; f++)
          yield {
            value: this._data[f],
            index: [f]
          };
        return;
      }
      for (var m = Array(u + 1).fill(0), p = this._size.reduce((D, y) => D * y, 1), d = 0; d < p; d++) {
        for (var v = this._data, x = 0; x < u; x++)
          v = v[m[x]];
        yield {
          value: v[m[u]],
          index: m.slice()
        };
        for (var h = u; h >= 0 && (m[h]++, !(m[h] < this._size[h])); h--)
          m[h] = 0;
      }
    }
  }, t.prototype.rows = function() {
    var u = [], f = this.size();
    if (f.length !== 2)
      throw new TypeError("Rows can only be returned for a 2D matrix.");
    var m = this._data;
    for (var p of m)
      u.push(new t([p], this._datatype));
    return u;
  }, t.prototype.columns = function() {
    var u = this, f = [], m = this.size();
    if (m.length !== 2)
      throw new TypeError("Rows can only be returned for a 2D matrix.");
    for (var p = this._data, d = function(h) {
      var D = p.map((y) => [y[h]]);
      f.push(new t(D, u._datatype));
    }, v = 0; v < m[1]; v++)
      d(v);
    return f;
  }, t.prototype.toArray = function() {
    return Te(this._data);
  }, t.prototype.valueOf = function() {
    return this._data;
  }, t.prototype.format = function(u) {
    return ke(this._data, u);
  }, t.prototype.toString = function() {
    return ke(this._data);
  }, t.prototype.toJSON = function() {
    return {
      mathjs: "DenseMatrix",
      data: this._data,
      size: this._size,
      datatype: this._datatype
    };
  }, t.prototype.diagonal = function(u) {
    if (u) {
      if ($e(u) && (u = u.toNumber()), !Re(u) || !Ne(u))
        throw new TypeError("The parameter k must be an integer number");
    } else
      u = 0;
    for (var f = u > 0 ? u : 0, m = u < 0 ? -u : 0, p = this._size[0], d = this._size[1], v = Math.min(p - m, d - f), x = [], h = 0; h < v; h++)
      x[h] = this._data[h + m][h + f];
    return new t({
      data: x,
      size: [v],
      datatype: this._datatype
    });
  }, t.diagonal = function(u, f, m, p) {
    if (!Ye(u))
      throw new TypeError("Array expected, size parameter");
    if (u.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    if (u = u.map(function(N) {
      if ($e(N) && (N = N.toNumber()), !Re(N) || !Ne(N) || N < 1)
        throw new Error("Size values must be positive integers");
      return N;
    }), m) {
      if ($e(m) && (m = m.toNumber()), !Re(m) || !Ne(m))
        throw new TypeError("The parameter k must be an integer number");
    } else
      m = 0;
    var d = m > 0 ? m : 0, v = m < 0 ? -m : 0, x = u[0], h = u[1], D = Math.min(x - v, h - d), y;
    if (Ye(f)) {
      if (f.length !== D)
        throw new Error("Invalid value array length");
      y = function(S) {
        return f[S];
      };
    } else if (Ee(f)) {
      var w = f.size();
      if (w.length !== 1 || w[0] !== D)
        throw new Error("Invalid matrix length");
      y = function(S) {
        return f.get([S]);
      };
    } else
      y = function() {
        return f;
      };
    p || (p = $e(y(0)) ? y(0).mul(0) : 0);
    var b = [];
    if (u.length > 0) {
      b = un(b, u, p);
      for (var g = 0; g < D; g++)
        b[g + v][g + d] = y(g);
    }
    return new t({
      data: b,
      size: [x, h]
    });
  }, t.fromJSON = function(u) {
    return new t(u);
  }, t.prototype.swapRows = function(u, f) {
    if (!Re(u) || !Ne(u) || !Re(f) || !Ne(f))
      throw new Error("Row index must be positive integers");
    if (this._size.length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    return er(u, this._size[0]), er(f, this._size[0]), t._swapRows(u, f, this._data), this;
  }, t._swapRows = function(u, f, m) {
    var p = m[u];
    m[u] = m[f], m[f] = p;
  };
  function o(u) {
    return Ee(u) ? o(u.valueOf()) : Ye(u) ? u.map(o) : u;
  }
  return t;
}, {
  isClass: !0
}), Xo = "clone", wg = ["typed"], Dg = /* @__PURE__ */ R(Xo, wg, (r) => {
  var {
    typed: e
  } = r;
  return e(Xo, {
    any: Te
  });
});
function Dm(r) {
  var e = r.length, t = r[0].length, n, a, i = [];
  for (a = 0; a < t; a++) {
    var s = [];
    for (n = 0; n < e; n++)
      s.push(r[n][a]);
    i.push(s);
  }
  return i;
}
function pn(r) {
  for (var e = 0; e < r.length; e++)
    if (Ir(r[e]))
      return !0;
  return !1;
}
function At(r, e) {
  Ee(r) ? r.forEach((t) => e(t), !1, !0) : xm(r, e, !0);
}
function Pe(r, e, t) {
  if (!t)
    return Ee(r) ? r.map((a) => e(a), !1, !0) : Ui(r, e, !0);
  var n = (a) => a === 0 ? a : e(a);
  return Ee(r) ? r.map((a) => n(a), !1, !0) : Ui(r, n, !0);
}
function ai(r, e, t) {
  var n = Array.isArray(r) ? Oe(r) : r.size();
  if (e < 0 || e >= n.length)
    throw new Hr(e, n.length);
  return Ee(r) ? r.create(Ia(r.valueOf(), e, t), r.datatype()) : Ia(r, e, t);
}
function Ia(r, e, t) {
  var n, a, i, s;
  if (e <= 0)
    if (Array.isArray(r[0])) {
      for (s = Dm(r), a = [], n = 0; n < s.length; n++)
        a[n] = Ia(s[n], e - 1, t);
      return a;
    } else {
      for (i = r[0], n = 1; n < r.length; n++)
        i = t(i, r[n]);
      return i;
    }
  else {
    for (a = [], n = 0; n < r.length; n++)
      a[n] = Ia(r[n], e - 1, t);
    return a;
  }
}
function Yo(r, e, t, n, a, i, s, l, c, o, u) {
  var f = r._values, m = r._index, p = r._ptr, d, v, x, h;
  if (n)
    for (v = p[e], x = p[e + 1], d = v; d < x; d++)
      h = m[d], t[h] !== i ? (t[h] = i, s.push(h), n[h] = f[d]) : (n[h] = l(n[h], f[d]), a[h] = i);
  else
    for (v = p[e], x = p[e + 1], d = v; d < x; d++)
      h = m[d], t[h] !== i ? (t[h] = i, s.push(h)) : a[h] = i;
}
var Jo = "isInteger", Ng = ["typed"], Nm = /* @__PURE__ */ R(Jo, Ng, (r) => {
  var {
    typed: e
  } = r;
  return e(Jo, {
    number: Ne,
    // TODO: what to do with isInteger(add(0.1, 0.2))  ?
    BigNumber: function(n) {
      return n.isInt();
    },
    bigint: function(n) {
      return !0;
    },
    Fraction: function(n) {
      return n.d === 1n;
    },
    "Array | Matrix": e.referToSelf((t) => (n) => Pe(n, t))
  });
}), Yr = "number", dn = "number, number";
function Am(r) {
  return Math.abs(r);
}
Am.signature = Yr;
function Sm(r, e) {
  return r + e;
}
Sm.signature = dn;
function Em(r, e) {
  return r - e;
}
Em.signature = dn;
function Mm(r, e) {
  return r * e;
}
Mm.signature = dn;
function Cm(r) {
  return -r;
}
Cm.signature = Yr;
function _m(r) {
  return r;
}
_m.signature = Yr;
function Nn(r) {
  return Bv(r);
}
Nn.signature = Yr;
function Tm(r) {
  return r * r * r;
}
Tm.signature = Yr;
function Fm(r) {
  return Math.exp(r);
}
Fm.signature = Yr;
function Bm(r) {
  return Ov(r);
}
Bm.signature = Yr;
function Om(r, e) {
  if (!Ne(r) || !Ne(e))
    throw new Error("Parameters in function lcm must be integer numbers");
  if (r === 0 || e === 0)
    return 0;
  for (var t, n = r * e; e !== 0; )
    t = e, e = r % t, r = t;
  return Math.abs(n / r);
}
Om.signature = dn;
function Qo(r, e) {
  return e ? Math.log(r) / Math.log(e) : Math.log(r);
}
function $a(r) {
  return Tv(r);
}
$a.signature = Yr;
function Li(r) {
  return _v(r);
}
Li.signature = Yr;
function jo(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, t = e < 0;
  if (t && (e = -e), e === 0)
    throw new Error("Root must be non-zero");
  if (r < 0 && Math.abs(e) % 2 !== 1)
    throw new Error("Root must be odd when a is negative.");
  if (r === 0)
    return t ? 1 / 0 : 0;
  if (!isFinite(r))
    return t ? 0 : r;
  var n = Math.pow(Math.abs(r), 1 / e);
  return n = r < 0 ? -n : n, t ? 1 / n : n;
}
function ki(r) {
  return yt(r);
}
ki.signature = Yr;
function Im(r) {
  return r * r;
}
Im.signature = Yr;
function $m(r, e) {
  var t, n, a, i = 0, s = 1, l = 1, c = 0;
  if (!Ne(r) || !Ne(e))
    throw new Error("Parameters in function xgcd must be integer numbers");
  for (; e; )
    n = Math.floor(r / e), a = r - n * e, t = i, i = s - n * i, s = t, t = l, l = c - n * l, c = t, r = e, e = a;
  var o;
  return r < 0 ? o = [-r, -s, -c] : o = [r, r ? s : 0, c], o;
}
$m.signature = dn;
function zm(r, e) {
  return r * r < 1 && e === 1 / 0 || r * r > 1 && e === -1 / 0 ? 0 : Math.pow(r, e);
}
zm.signature = dn;
function wn(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  if (!Ne(e) || e < 0 || e > 15)
    throw new Error("Number of decimals in function round must be an integer from 0 to 15 inclusive");
  return parseFloat(Gf(r, e));
}
var Ag = "number", vn = "number, number";
function Rm(r, e) {
  if (!Ne(r) || !Ne(e))
    throw new Error("Integers expected in function bitAnd");
  return r & e;
}
Rm.signature = vn;
function qm(r) {
  if (!Ne(r))
    throw new Error("Integer expected in function bitNot");
  return ~r;
}
qm.signature = Ag;
function Pm(r, e) {
  if (!Ne(r) || !Ne(e))
    throw new Error("Integers expected in function bitOr");
  return r | e;
}
Pm.signature = vn;
function Um(r, e) {
  if (!Ne(r) || !Ne(e))
    throw new Error("Integers expected in function bitXor");
  return r ^ e;
}
Um.signature = vn;
function Lm(r, e) {
  if (!Ne(r) || !Ne(e))
    throw new Error("Integers expected in function leftShift");
  return r << e;
}
Lm.signature = vn;
function km(r, e) {
  if (!Ne(r) || !Ne(e))
    throw new Error("Integers expected in function rightArithShift");
  return r >> e;
}
km.signature = vn;
function Hm(r, e) {
  if (!Ne(r) || !Ne(e))
    throw new Error("Integers expected in function rightLogShift");
  return r >>> e;
}
Hm.signature = vn;
function ot(r, e) {
  if (e < r)
    return 1;
  if (e === r)
    return e;
  var t = e + r >> 1;
  return ot(r, t) * ot(t + 1, e);
}
function Wm(r, e) {
  if (!Ne(r) || r < 0)
    throw new TypeError("Positive integer value expected in function combinations");
  if (!Ne(e) || e < 0)
    throw new TypeError("Positive integer value expected in function combinations");
  if (e > r)
    throw new TypeError("k must be less than or equal to n");
  for (var t = r - e, n = 1, a = e < t ? t + 1 : e + 1, i = 2, s = e < t ? e : t, l = a; l <= r; ++l)
    for (n *= l; i <= s && n % i === 0; )
      n /= i, ++i;
  return i <= s && (n /= ot(i, s)), n;
}
Wm.signature = "number, number";
var Sg = Math.PI, Eg = 2 * Math.PI, Mg = Math.E, Cg = 1.618033988749895, _g = "number", lo = "number, number";
function Gm(r) {
  return !r;
}
Gm.signature = _g;
function Hi(r, e) {
  return !!(r || e);
}
Hi.signature = lo;
function Wi(r, e) {
  return !!r != !!e;
}
Wi.signature = lo;
function Gi(r, e) {
  return !!(r && e);
}
Gi.signature = lo;
function za(r) {
  var e;
  if (Ne(r))
    return r <= 0 ? isFinite(r) ? 1 / 0 : NaN : r > 171 ? 1 / 0 : ot(1, r - 1);
  if (r < 0.5)
    return Math.PI / (Math.sin(Math.PI * r) * za(1 - r));
  if (r >= 171.35)
    return 1 / 0;
  if (r > 85) {
    var t = r * r, n = t * r, a = n * r, i = a * r;
    return Math.sqrt(2 * Math.PI / r) * Math.pow(r / Math.E, r) * (1 + 1 / (12 * r) + 1 / (288 * t) - 139 / (51840 * n) - 571 / (2488320 * a) + 163879 / (209018880 * i) + 5246819 / (75246796800 * i * r));
  }
  --r, e = tn[0];
  for (var s = 1; s < tn.length; ++s)
    e += tn[s] / (r + s);
  var l = r + Vm + 0.5;
  return Math.sqrt(2 * Math.PI) * Math.pow(l, r + 0.5) * Math.exp(-l) * e;
}
za.signature = "number";
var Vm = 4.7421875, tn = [0.9999999999999971, 57.15623566586292, -59.59796035547549, 14.136097974741746, -0.4919138160976202, 3399464998481189e-20, 4652362892704858e-20, -9837447530487956e-20, 1580887032249125e-19, -21026444172410488e-20, 21743961811521265e-20, -1643181065367639e-19, 8441822398385275e-20, -26190838401581408e-21, 36899182659531625e-22], Zm = 0.9189385332046728, Tg = 5, Fg = 7, Ko = [1.000000000190015, 76.18009172947146, -86.50532032941678, 24.01409824083091, -1.231739572450155, 0.001208650973866179, -5395239384953e-18];
function Ra(r) {
  if (r < 0) return NaN;
  if (r === 0) return 1 / 0;
  if (!isFinite(r)) return r;
  if (r < 0.5)
    return Math.log(Math.PI / Math.sin(Math.PI * r)) - Ra(1 - r);
  r = r - 1;
  for (var e = r + Tg + 0.5, t = Ko[0], n = Fg - 1; n >= 1; n--)
    t += Ko[n] / (r + n);
  return Zm + (r + 0.5) * Math.log(e) - e + Math.log(t);
}
Ra.signature = "number";
var Nr = "number";
function Xm(r) {
  return Rv(r);
}
Xm.signature = Nr;
function Ym(r) {
  return Math.atan(1 / r);
}
Ym.signature = Nr;
function Jm(r) {
  return isFinite(r) ? (Math.log((r + 1) / r) + Math.log(r / (r - 1))) / 2 : 0;
}
Jm.signature = Nr;
function Qm(r) {
  return Math.asin(1 / r);
}
Qm.signature = Nr;
function jm(r) {
  var e = 1 / r;
  return Math.log(e + Math.sqrt(e * e + 1));
}
jm.signature = Nr;
function Km(r) {
  return Math.acos(1 / r);
}
Km.signature = Nr;
function ep(r) {
  var e = 1 / r, t = Math.sqrt(e * e - 1);
  return Math.log(t + e);
}
ep.signature = Nr;
function rp(r) {
  return qv(r);
}
rp.signature = Nr;
function tp(r) {
  return Pv(r);
}
tp.signature = Nr;
function np(r) {
  return 1 / Math.tan(r);
}
np.signature = Nr;
function ap(r) {
  var e = Math.exp(2 * r);
  return (e + 1) / (e - 1);
}
ap.signature = Nr;
function ip(r) {
  return 1 / Math.sin(r);
}
ip.signature = Nr;
function op(r) {
  return r === 0 ? Number.POSITIVE_INFINITY : Math.abs(2 / (Math.exp(r) - Math.exp(-r))) * yt(r);
}
op.signature = Nr;
function sp(r) {
  return 1 / Math.cos(r);
}
sp.signature = Nr;
function up(r) {
  return 2 / (Math.exp(r) + Math.exp(-r));
}
up.signature = Nr;
function cp(r) {
  return Lv(r);
}
cp.signature = Nr;
var fo = "number";
function lp(r) {
  return r < 0;
}
lp.signature = fo;
function fp(r) {
  return r > 0;
}
fp.signature = fo;
function mp(r) {
  return Number.isNaN(r);
}
mp.signature = fo;
function kr(r, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e-9, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  if (t <= 0)
    throw new Error("Relative tolerance must be greater than 0");
  if (n < 0)
    throw new Error("Absolute tolerance must be at least 0");
  return r.isNaN() || e.isNaN() ? !1 : !r.isFinite() || !e.isFinite() ? r.eq(e) : r.eq(e) ? !0 : r.minus(e).abs().lte(r.constructor.max(r.constructor.max(r.abs(), e.abs()).mul(t), n));
}
var es = "isNegative", Bg = ["typed", "config"], Og = /* @__PURE__ */ R(es, Bg, (r) => {
  var {
    typed: e,
    config: t
  } = r;
  return e(es, {
    number: (n) => dr(n, 0, t.relTol, t.absTol) ? !1 : lp(n),
    BigNumber: (n) => kr(n, new n.constructor(0), t.relTol, t.absTol) ? !1 : n.isNeg() && !n.isZero() && !n.isNaN(),
    bigint: (n) => n < 0n,
    Fraction: (n) => n.s < 0n,
    // It's enough to decide on the sign
    Unit: e.referToSelf((n) => (a) => e.find(n, a.valueType())(a.value)),
    "Array | Matrix": e.referToSelf((n) => (a) => Pe(a, n))
  });
}), rs = "isNumeric", Ig = ["typed"], $g = /* @__PURE__ */ R(rs, Ig, (r) => {
  var {
    typed: e
  } = r;
  return e(rs, {
    "number | BigNumber | bigint | Fraction | boolean": () => !0,
    "Complex | Unit | string | null | undefined | Node": () => !1,
    "Array | Matrix": e.referToSelf((t) => (n) => Pe(n, t))
  });
}), ts = "hasNumericValue", zg = ["typed", "isNumeric"], Rg = /* @__PURE__ */ R(ts, zg, (r) => {
  var {
    typed: e,
    isNumeric: t
  } = r;
  return e(ts, {
    boolean: () => !0,
    string: function(a) {
      return a.trim().length > 0 && !isNaN(Number(a));
    },
    any: function(a) {
      return t(a);
    }
  });
}), ns = "isPositive", qg = ["typed", "config"], Pg = /* @__PURE__ */ R(ns, qg, (r) => {
  var {
    typed: e,
    config: t
  } = r;
  return e(ns, {
    number: (n) => dr(n, 0, t.relTol, t.absTol) ? !1 : fp(n),
    BigNumber: (n) => kr(n, new n.constructor(0), t.relTol, t.absTol) ? !1 : !n.isNeg() && !n.isZero() && !n.isNaN(),
    bigint: (n) => n > 0n,
    Fraction: (n) => n.s > 0n && n.n > 0n,
    Unit: e.referToSelf((n) => (a) => e.find(n, a.valueType())(a.value)),
    "Array | Matrix": e.referToSelf((n) => (a) => Pe(a, n))
  });
}), as = "isZero", Ug = ["typed", "equalScalar"], pp = /* @__PURE__ */ R(as, Ug, (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return e(as, {
    "number | BigNumber | Complex | Fraction": (n) => t(n, 0),
    bigint: (n) => n === 0n,
    Unit: e.referToSelf((n) => (a) => e.find(n, a.valueType())(a.value)),
    "Array | Matrix": e.referToSelf((n) => (a) => Pe(a, n))
  });
}), is = "isNaN", Lg = ["typed"], kg = /* @__PURE__ */ R(is, Lg, (r) => {
  var {
    typed: e
  } = r;
  return e(is, {
    number: mp,
    BigNumber: function(n) {
      return n.isNaN();
    },
    bigint: function(n) {
      return !1;
    },
    Fraction: function(n) {
      return !1;
    },
    Complex: function(n) {
      return n.isNaN();
    },
    Unit: function(n) {
      return Number.isNaN(n.value);
    },
    "Array | Matrix": e.referToSelf((t) => (n) => Pe(n, t))
  });
}), os = "typeOf", Hg = ["typed"], Wg = /* @__PURE__ */ R(os, Hg, (r) => {
  var {
    typed: e
  } = r;
  return e(os, {
    any: Ke
  });
});
function Gg(r, e, t, n) {
  return dr(r.re, e.re, t, n) && dr(r.im, e.im, t, n);
}
var hn = /* @__PURE__ */ R("compareUnits", ["typed"], (r) => {
  var {
    typed: e
  } = r;
  return {
    "Unit, Unit": e.referToSelf((t) => (n, a) => {
      if (!n.equalBase(a))
        throw new Error("Cannot compare units with different base");
      return e.find(t, [n.valueType(), a.valueType()])(n.value, a.value);
    })
  };
}), qa = "equalScalar", Vg = ["typed", "config"], dp = /* @__PURE__ */ R(qa, Vg, (r) => {
  var {
    typed: e,
    config: t
  } = r, n = hn({
    typed: e
  });
  return e(qa, {
    "boolean, boolean": function(i, s) {
      return i === s;
    },
    "number, number": function(i, s) {
      return dr(i, s, t.relTol, t.absTol);
    },
    "BigNumber, BigNumber": function(i, s) {
      return i.eq(s) || kr(i, s, t.relTol, t.absTol);
    },
    "bigint, bigint": function(i, s) {
      return i === s;
    },
    "Fraction, Fraction": function(i, s) {
      return i.equals(s);
    },
    "Complex, Complex": function(i, s) {
      return Gg(i, s, t.relTol, t.absTol);
    }
  }, n);
});
R(qa, ["typed", "config"], (r) => {
  var {
    typed: e,
    config: t
  } = r;
  return e(qa, {
    "number, number": function(a, i) {
      return dr(a, i, t.relTol, t.absTol);
    }
  });
});
var Zg = "SparseMatrix", Xg = ["typed", "equalScalar", "Matrix"], vp = /* @__PURE__ */ R(Zg, Xg, (r) => {
  var {
    typed: e,
    equalScalar: t,
    Matrix: n
  } = r;
  function a(v, x) {
    if (!(this instanceof a))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (x && !gr(x))
      throw new Error("Invalid datatype: " + x);
    if (Ee(v))
      i(this, v, x);
    else if (v && Ye(v.index) && Ye(v.ptr) && Ye(v.size))
      this._values = v.values, this._index = v.index, this._ptr = v.ptr, this._size = v.size, this._datatype = x || v.datatype;
    else if (Ye(v))
      s(this, v, x);
    else {
      if (v)
        throw new TypeError("Unsupported type of data (" + Ke(v) + ")");
      this._values = [], this._index = [], this._ptr = [0], this._size = [0, 0], this._datatype = x;
    }
  }
  function i(v, x, h) {
    x.type === "SparseMatrix" ? (v._values = x._values ? Te(x._values) : void 0, v._index = Te(x._index), v._ptr = Te(x._ptr), v._size = Te(x._size), v._datatype = h || x._datatype) : s(v, x.valueOf(), h || x._datatype);
  }
  function s(v, x, h) {
    v._values = [], v._index = [], v._ptr = [], v._datatype = h;
    var D = x.length, y = 0, w = t, b = 0;
    if (gr(h) && (w = e.find(t, [h, h]) || t, b = e.convert(0, h)), D > 0) {
      var g = 0;
      do {
        v._ptr.push(v._index.length);
        for (var N = 0; N < D; N++) {
          var S = x[N];
          if (Ye(S)) {
            if (g === 0 && y < S.length && (y = S.length), g < S.length) {
              var A = S[g];
              w(A, b) || (v._values.push(A), v._index.push(N));
            }
          } else
            g === 0 && y < 1 && (y = 1), w(S, b) || (v._values.push(S), v._index.push(N));
        }
        g++;
      } while (g < y);
    }
    v._ptr.push(v._index.length), v._size = [D, y];
  }
  a.prototype = new n(), a.prototype.createSparseMatrix = function(v, x) {
    return new a(v, x);
  }, Object.defineProperty(a, "name", {
    value: "SparseMatrix"
  }), a.prototype.constructor = a, a.prototype.type = "SparseMatrix", a.prototype.isSparseMatrix = !0, a.prototype.getDataType = function() {
    return ni(this._values, Ke);
  }, a.prototype.storage = function() {
    return "sparse";
  }, a.prototype.datatype = function() {
    return this._datatype;
  }, a.prototype.create = function(v, x) {
    return new a(v, x);
  }, a.prototype.density = function() {
    var v = this._size[0], x = this._size[1];
    return v !== 0 && x !== 0 ? this._index.length / (v * x) : 0;
  }, a.prototype.subset = function(v, x, h) {
    if (!this._values)
      throw new Error("Cannot invoke subset on a Pattern only matrix");
    switch (arguments.length) {
      case 1:
        return l(this, v);
      // intentional fall through
      case 2:
      case 3:
        return c(this, v, x, h);
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  };
  function l(v, x) {
    if (!$n(x))
      throw new TypeError("Invalid index");
    var h = x.isScalar();
    if (h)
      return v.get(x.min());
    var D = x.size();
    if (D.length !== v._size.length)
      throw new Ue(D.length, v._size.length);
    var y, w, b, g, N = x.min(), S = x.max();
    for (y = 0, w = v._size.length; y < w; y++)
      er(N[y], v._size[y]), er(S[y], v._size[y]);
    var A = v._values, E = v._index, M = v._ptr, T = x.dimension(0), B = x.dimension(1), I = [], O = [];
    T.forEach(function(L, J) {
      O[L] = J[0], I[L] = !0;
    });
    var _ = A ? [] : void 0, P = [], W = [];
    return B.forEach(function(L) {
      for (W.push(P.length), b = M[L], g = M[L + 1]; b < g; b++)
        y = E[b], I[y] === !0 && (P.push(O[y]), _ && _.push(A[b]));
    }), W.push(P.length), new a({
      values: _,
      index: P,
      ptr: W,
      size: D,
      datatype: v._datatype
    });
  }
  function c(v, x, h, D) {
    if (!x || x.isIndex !== !0)
      throw new TypeError("Invalid index");
    var y = x.size(), w = x.isScalar(), b;
    if (Ee(h) ? (b = h.size(), h = h.toArray()) : b = Oe(h), w) {
      if (b.length !== 0)
        throw new TypeError("Scalar expected");
      v.set(x.min(), h, D);
    } else {
      if (y.length !== 1 && y.length !== 2)
        throw new Ue(y.length, v._size.length, "<");
      if (b.length < y.length) {
        for (var g = 0, N = 0; y[g] === 1 && b[g] === 1; )
          g++;
        for (; y[g] === 1; )
          N++, g++;
        h = dm(h, y.length, N, b);
      }
      if (!ut(y, b))
        throw new Ue(y, b, ">");
      if (y.length === 1) {
        var S = x.dimension(0);
        S.forEach(function(M, T) {
          er(M), v.set([M, 0], h[T[0]], D);
        });
      } else {
        var A = x.dimension(0), E = x.dimension(1);
        A.forEach(function(M, T) {
          er(M), E.forEach(function(B, I) {
            er(B), v.set([M, B], h[T[0]][I[0]], D);
          });
        });
      }
    }
    return v;
  }
  a.prototype.get = function(v) {
    if (!Ye(v))
      throw new TypeError("Array expected");
    if (v.length !== this._size.length)
      throw new Ue(v.length, this._size.length);
    if (!this._values)
      throw new Error("Cannot invoke get on a Pattern only matrix");
    var x = v[0], h = v[1];
    er(x, this._size[0]), er(h, this._size[1]);
    var D = o(x, this._ptr[h], this._ptr[h + 1], this._index);
    return D < this._ptr[h + 1] && this._index[D] === x ? this._values[D] : 0;
  }, a.prototype.set = function(v, x, h) {
    if (!Ye(v))
      throw new TypeError("Array expected");
    if (v.length !== this._size.length)
      throw new Ue(v.length, this._size.length);
    if (!this._values)
      throw new Error("Cannot invoke set on a Pattern only matrix");
    var D = v[0], y = v[1], w = this._size[0], b = this._size[1], g = t, N = 0;
    gr(this._datatype) && (g = e.find(t, [this._datatype, this._datatype]) || t, N = e.convert(0, this._datatype)), (D > w - 1 || y > b - 1) && (m(this, Math.max(D + 1, w), Math.max(y + 1, b), h), w = this._size[0], b = this._size[1]), er(D, w), er(y, b);
    var S = o(D, this._ptr[y], this._ptr[y + 1], this._index);
    return S < this._ptr[y + 1] && this._index[S] === D ? g(x, N) ? u(S, y, this._values, this._index, this._ptr) : this._values[S] = x : g(x, N) || f(S, D, y, x, this._values, this._index, this._ptr), this;
  };
  function o(v, x, h, D) {
    if (h - x === 0)
      return h;
    for (var y = x; y < h; y++)
      if (D[y] === v)
        return y;
    return x;
  }
  function u(v, x, h, D, y) {
    h.splice(v, 1), D.splice(v, 1);
    for (var w = x + 1; w < y.length; w++)
      y[w]--;
  }
  function f(v, x, h, D, y, w, b) {
    y.splice(v, 0, D), w.splice(v, 0, x);
    for (var g = h + 1; g < b.length; g++)
      b[g]++;
  }
  a.prototype.resize = function(v, x, h) {
    if (!Ir(v))
      throw new TypeError("Array or Matrix expected");
    var D = v.valueOf().map((w) => Array.isArray(w) && w.length === 1 ? w[0] : w);
    if (D.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    D.forEach(function(w) {
      if (!Re(w) || !Ne(w) || w < 0)
        throw new TypeError("Invalid size, must contain positive integers (size: " + ke(D) + ")");
    });
    var y = h ? this.clone() : this;
    return m(y, D[0], D[1], x);
  };
  function m(v, x, h, D) {
    var y = D || 0, w = t, b = 0;
    gr(v._datatype) && (w = e.find(t, [v._datatype, v._datatype]) || t, b = e.convert(0, v._datatype), y = e.convert(y, v._datatype));
    var g = !w(y, b), N = v._size[0], S = v._size[1], A, E, M;
    if (h > S) {
      for (E = S; E < h; E++)
        if (v._ptr[E] = v._values.length, g)
          for (A = 0; A < N; A++)
            v._values.push(y), v._index.push(A);
      v._ptr[h] = v._values.length;
    } else h < S && (v._ptr.splice(h + 1, S - h), v._values.splice(v._ptr[h], v._values.length), v._index.splice(v._ptr[h], v._index.length));
    if (S = h, x > N) {
      if (g) {
        var T = 0;
        for (E = 0; E < S; E++) {
          v._ptr[E] = v._ptr[E] + T, M = v._ptr[E + 1] + T;
          var B = 0;
          for (A = N; A < x; A++, B++)
            v._values.splice(M + B, 0, y), v._index.splice(M + B, 0, A), T++;
        }
        v._ptr[S] = v._values.length;
      }
    } else if (x < N) {
      var I = 0;
      for (E = 0; E < S; E++) {
        v._ptr[E] = v._ptr[E] - I;
        var O = v._ptr[E], _ = v._ptr[E + 1] - I;
        for (M = O; M < _; M++)
          A = v._index[M], A > x - 1 && (v._values.splice(M, 1), v._index.splice(M, 1), I++);
      }
      v._ptr[E] = v._values.length;
    }
    return v._size[0] = x, v._size[1] = h, v;
  }
  a.prototype.reshape = function(v, x) {
    if (!Ye(v))
      throw new TypeError("Array expected");
    if (v.length !== 2)
      throw new Error("Sparse matrices can only be reshaped in two dimensions");
    v.forEach(function(L) {
      if (!Re(L) || !Ne(L) || L <= -2 || L === 0)
        throw new TypeError("Invalid size, must contain positive integers or -1 (size: " + ke(v) + ")");
    });
    var h = this._size[0] * this._size[1];
    v = co(v, h);
    var D = v[0] * v[1];
    if (h !== D)
      throw new Error("Reshaping sparse matrix will result in the wrong number of elements");
    var y = x ? this.clone() : this;
    if (this._size[0] === v[0] && this._size[1] === v[1])
      return y;
    for (var w = [], b = 0; b < y._ptr.length; b++)
      for (var g = 0; g < y._ptr[b + 1] - y._ptr[b]; g++)
        w.push(b);
    for (var N = y._values.slice(), S = y._index.slice(), A = 0; A < y._index.length; A++) {
      var E = S[A], M = w[A], T = E * y._size[1] + M;
      w[A] = T % v[1], S[A] = Math.floor(T / v[1]);
    }
    y._values.length = 0, y._index.length = 0, y._ptr.length = v[1] + 1, y._size = v.slice();
    for (var B = 0; B < y._ptr.length; B++)
      y._ptr[B] = 0;
    for (var I = 0; I < N.length; I++) {
      var O = S[I], _ = w[I], P = N[I], W = o(O, y._ptr[_], y._ptr[_ + 1], y._index);
      f(W, O, _, P, y._values, y._index, y._ptr);
    }
    return y;
  }, a.prototype.clone = function() {
    var v = new a({
      values: this._values ? Te(this._values) : void 0,
      index: Te(this._index),
      ptr: Te(this._ptr),
      size: Te(this._size),
      datatype: this._datatype
    });
    return v;
  }, a.prototype.size = function() {
    return this._size.slice(0);
  }, a.prototype.map = function(v, x) {
    if (!this._values)
      throw new Error("Cannot invoke map on a Pattern only matrix");
    var h = this, D = this._size[0], y = this._size[1], w = zt(v, h, "map"), b = function(N, S, A) {
      return w.fn(N, [S, A], h);
    };
    return p(this, 0, D - 1, 0, y - 1, b, x);
  };
  function p(v, x, h, D, y, w, b) {
    var g = [], N = [], S = [], A = t, E = 0;
    gr(v._datatype) && (A = e.find(t, [v._datatype, v._datatype]) || t, E = e.convert(0, v._datatype));
    for (var M = function(G, z, le) {
      var ne = w(G, z, le);
      A(ne, E) || (g.push(ne), N.push(z));
    }, T = D; T <= y; T++) {
      S.push(g.length);
      var B = v._ptr[T], I = v._ptr[T + 1];
      if (b)
        for (var O = B; O < I; O++) {
          var _ = v._index[O];
          _ >= x && _ <= h && M(v._values[O], _ - x, T - D);
        }
      else {
        for (var P = {}, W = B; W < I; W++) {
          var L = v._index[W];
          P[L] = v._values[W];
        }
        for (var J = x; J <= h; J++) {
          var ee = J in P ? P[J] : 0;
          M(ee, J - x, T - D);
        }
      }
    }
    return S.push(g.length), new a({
      values: g,
      index: N,
      ptr: S,
      size: [h - x + 1, y - D + 1]
    });
  }
  a.prototype.forEach = function(v, x) {
    if (!this._values)
      throw new Error("Cannot invoke forEach on a Pattern only matrix");
    for (var h = this, D = this._size[0], y = this._size[1], w = zt(v, h, "forEach"), b = 0; b < y; b++) {
      var g = this._ptr[b], N = this._ptr[b + 1];
      if (x)
        for (var S = g; S < N; S++) {
          var A = this._index[S];
          w.fn(this._values[S], [A, b], h);
        }
      else {
        for (var E = {}, M = g; M < N; M++) {
          var T = this._index[M];
          E[T] = this._values[M];
        }
        for (var B = 0; B < D; B++) {
          var I = B in E ? E[B] : 0;
          w.fn(I, [B, b], h);
        }
      }
    }
  }, a.prototype[Symbol.iterator] = function* () {
    if (!this._values)
      throw new Error("Cannot iterate a Pattern only matrix");
    for (var v = this._size[1], x = 0; x < v; x++)
      for (var h = this._ptr[x], D = this._ptr[x + 1], y = h; y < D; y++) {
        var w = this._index[y];
        yield {
          value: this._values[y],
          index: [w, x]
        };
      }
  }, a.prototype.toArray = function() {
    return d(this._values, this._index, this._ptr, this._size, !0);
  }, a.prototype.valueOf = function() {
    return d(this._values, this._index, this._ptr, this._size, !1);
  };
  function d(v, x, h, D, y) {
    var w = D[0], b = D[1], g = [], N, S;
    for (N = 0; N < w; N++)
      for (g[N] = [], S = 0; S < b; S++)
        g[N][S] = 0;
    for (S = 0; S < b; S++)
      for (var A = h[S], E = h[S + 1], M = A; M < E; M++)
        N = x[M], g[N][S] = v ? y ? Te(v[M]) : v[M] : 1;
    return g;
  }
  return a.prototype.format = function(v) {
    for (var x = this._size[0], h = this._size[1], D = this.density(), y = "Sparse Matrix [" + ke(x, v) + " x " + ke(h, v) + "] density: " + ke(D, v) + `
`, w = 0; w < h; w++)
      for (var b = this._ptr[w], g = this._ptr[w + 1], N = b; N < g; N++) {
        var S = this._index[N];
        y += `
    (` + ke(S, v) + ", " + ke(w, v) + ") ==> " + (this._values ? ke(this._values[N], v) : "X");
      }
    return y;
  }, a.prototype.toString = function() {
    return ke(this.toArray());
  }, a.prototype.toJSON = function() {
    return {
      mathjs: "SparseMatrix",
      values: this._values,
      index: this._index,
      ptr: this._ptr,
      size: this._size,
      datatype: this._datatype
    };
  }, a.prototype.diagonal = function(v) {
    if (v) {
      if ($e(v) && (v = v.toNumber()), !Re(v) || !Ne(v))
        throw new TypeError("The parameter k must be an integer number");
    } else
      v = 0;
    var x = v > 0 ? v : 0, h = v < 0 ? -v : 0, D = this._size[0], y = this._size[1], w = Math.min(D - h, y - x), b = [], g = [], N = [];
    N[0] = 0;
    for (var S = x; S < y && b.length < w; S++)
      for (var A = this._ptr[S], E = this._ptr[S + 1], M = A; M < E; M++) {
        var T = this._index[M];
        if (T === S - x + h) {
          b.push(this._values[M]), g[b.length - 1] = T - h;
          break;
        }
      }
    return N.push(b.length), new a({
      values: b,
      index: g,
      ptr: N,
      size: [w, 1]
    });
  }, a.fromJSON = function(v) {
    return new a(v);
  }, a.diagonal = function(v, x, h, D, y) {
    if (!Ye(v))
      throw new TypeError("Array expected, size parameter");
    if (v.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    if (v = v.map(function(L) {
      if ($e(L) && (L = L.toNumber()), !Re(L) || !Ne(L) || L < 1)
        throw new Error("Size values must be positive integers");
      return L;
    }), h) {
      if ($e(h) && (h = h.toNumber()), !Re(h) || !Ne(h))
        throw new TypeError("The parameter k must be an integer number");
    } else
      h = 0;
    var w = t, b = 0;
    gr(y) && (w = e.find(t, [y, y]) || t, b = e.convert(0, y));
    var g = h > 0 ? h : 0, N = h < 0 ? -h : 0, S = v[0], A = v[1], E = Math.min(S - N, A - g), M;
    if (Ye(x)) {
      if (x.length !== E)
        throw new Error("Invalid value array length");
      M = function(J) {
        return x[J];
      };
    } else if (Ee(x)) {
      var T = x.size();
      if (T.length !== 1 || T[0] !== E)
        throw new Error("Invalid matrix length");
      M = function(J) {
        return x.get([J]);
      };
    } else
      M = function() {
        return x;
      };
    for (var B = [], I = [], O = [], _ = 0; _ < A; _++) {
      O.push(B.length);
      var P = _ - g;
      if (P >= 0 && P < E) {
        var W = M(P);
        w(W, b) || (I.push(P + N), B.push(W));
      }
    }
    return O.push(B.length), new a({
      values: B,
      index: I,
      ptr: O,
      size: [S, A]
    });
  }, a.prototype.swapRows = function(v, x) {
    if (!Re(v) || !Ne(v) || !Re(x) || !Ne(x))
      throw new Error("Row index must be positive integers");
    if (this._size.length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    return er(v, this._size[0]), er(x, this._size[0]), a._swapRows(v, x, this._size[1], this._values, this._index, this._ptr), this;
  }, a._forEachRow = function(v, x, h, D, y) {
    for (var w = D[v], b = D[v + 1], g = w; g < b; g++)
      y(h[g], x[g]);
  }, a._swapRows = function(v, x, h, D, y, w) {
    for (var b = 0; b < h; b++) {
      var g = w[b], N = w[b + 1], S = o(v, g, N, y), A = o(x, g, N, y);
      if (S < N && A < N && y[S] === v && y[A] === x) {
        if (D) {
          var E = D[S];
          D[S] = D[A], D[A] = E;
        }
        continue;
      }
      if (S < N && y[S] === v && (A >= N || y[A] !== x)) {
        var M = D ? D[S] : void 0;
        y.splice(A, 0, x), D && D.splice(A, 0, M), y.splice(A <= S ? S + 1 : S, 1), D && D.splice(A <= S ? S + 1 : S, 1);
        continue;
      }
      if (A < N && y[A] === x && (S >= N || y[S] !== v)) {
        var T = D ? D[A] : void 0;
        y.splice(S, 0, v), D && D.splice(S, 0, T), y.splice(S <= A ? A + 1 : A, 1), D && D.splice(S <= A ? A + 1 : A, 1);
      }
    }
  }, a;
}, {
  isClass: !0
}), Yg = "number", Jg = ["typed"];
function Qg(r) {
  var e = r.match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/);
  if (e) {
    var t = {
      "0b": 2,
      "0o": 8,
      "0x": 16
    }[e[1]], n = e[2], a = e[3];
    return {
      input: r,
      radix: t,
      integerPart: n,
      fractionalPart: a
    };
  } else
    return null;
}
function jg(r) {
  for (var e = parseInt(r.integerPart, r.radix), t = 0, n = 0; n < r.fractionalPart.length; n++) {
    var a = parseInt(r.fractionalPart[n], r.radix);
    t += a / Math.pow(r.radix, n + 1);
  }
  var i = e + t;
  if (isNaN(i))
    throw new SyntaxError('String "' + r.input + '" is not a valid number');
  return i;
}
var hp = /* @__PURE__ */ R(Yg, Jg, (r) => {
  var {
    typed: e
  } = r, t = e("number", {
    "": function() {
      return 0;
    },
    number: function(a) {
      return a;
    },
    string: function(a) {
      if (a === "NaN") return NaN;
      var i = Qg(a);
      if (i)
        return jg(i);
      var s = 0, l = a.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
      l && (s = Number(l[2]), a = l[1]);
      var c = Number(a);
      if (isNaN(c))
        throw new SyntaxError('String "' + a + '" is not a valid number');
      if (l) {
        if (c > 2 ** s - 1)
          throw new SyntaxError('String "'.concat(a, '" is out of range'));
        c >= 2 ** (s - 1) && (c = c - 2 ** s);
      }
      return c;
    },
    BigNumber: function(a) {
      return a.toNumber();
    },
    bigint: function(a) {
      return Number(a);
    },
    Fraction: function(a) {
      return a.valueOf();
    },
    Unit: e.referToSelf((n) => (a) => {
      var i = a.clone();
      return i.value = n(a.value), i;
    }),
    null: function(a) {
      return 0;
    },
    "Unit, string | Unit": function(a, i) {
      return a.toNumber(i);
    },
    "Array | Matrix": e.referToSelf((n) => (a) => Pe(a, n))
  });
  return t.fromJSON = function(n) {
    return parseFloat(n.value);
  }, t;
}), Kg = "bigint", e0 = ["typed"], r0 = /* @__PURE__ */ R(Kg, e0, (r) => {
  var {
    typed: e
  } = r, t = e("bigint", {
    "": function() {
      return 0n;
    },
    bigint: function(a) {
      return a;
    },
    number: function(a) {
      return BigInt(a.toFixed());
    },
    BigNumber: function(a) {
      return BigInt(a.round().toString());
    },
    Fraction: function(a) {
      return BigInt(a.valueOf().toFixed());
    },
    "string | boolean": function(a) {
      return BigInt(a);
    },
    null: function(a) {
      return 0n;
    },
    "Array | Matrix": e.referToSelf((n) => (a) => Pe(a, n))
  });
  return t.fromJSON = function(n) {
    return BigInt(n.value);
  }, t;
}), ss = "string", t0 = ["typed"], n0 = /* @__PURE__ */ R(ss, t0, (r) => {
  var {
    typed: e
  } = r;
  return e(ss, {
    "": function() {
      return "";
    },
    number: $t,
    null: function(n) {
      return "null";
    },
    boolean: function(n) {
      return n + "";
    },
    string: function(n) {
      return n;
    },
    "Array | Matrix": e.referToSelf((t) => (n) => Pe(n, t)),
    any: function(n) {
      return String(n);
    }
  });
}), us = "boolean", a0 = ["typed"], i0 = /* @__PURE__ */ R(us, a0, (r) => {
  var {
    typed: e
  } = r;
  return e(us, {
    "": function() {
      return !1;
    },
    boolean: function(n) {
      return n;
    },
    number: function(n) {
      return !!n;
    },
    null: function(n) {
      return !1;
    },
    BigNumber: function(n) {
      return !n.isZero();
    },
    string: function(n) {
      var a = n.toLowerCase();
      if (a === "true")
        return !0;
      if (a === "false")
        return !1;
      var i = Number(n);
      if (n !== "" && !isNaN(i))
        return !!i;
      throw new Error('Cannot convert "' + n + '" to a boolean');
    },
    "Array | Matrix": e.referToSelf((t) => (n) => Pe(n, t))
  });
}), o0 = "bignumber", s0 = ["typed", "BigNumber"], gp = /* @__PURE__ */ R(o0, s0, (r) => {
  var {
    typed: e,
    BigNumber: t
  } = r;
  return e("bignumber", {
    "": function() {
      return new t(0);
    },
    number: function(a) {
      return new t(a + "");
    },
    string: function(a) {
      var i = a.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
      if (i) {
        var s = i[2], l = t(i[1]), c = new t(2).pow(Number(s));
        if (l.gt(c.sub(1)))
          throw new SyntaxError('String "'.concat(a, '" is out of range'));
        var o = new t(2).pow(Number(s) - 1);
        return l.gte(o) ? l.sub(c) : l;
      }
      return new t(a);
    },
    BigNumber: function(a) {
      return a;
    },
    bigint: function(a) {
      return new t(a.toString());
    },
    Unit: e.referToSelf((n) => (a) => {
      var i = a.clone();
      return i.value = n(a.value), i;
    }),
    Fraction: function(a) {
      return new t(String(a.n)).div(String(a.d)).times(String(a.s));
    },
    null: function(a) {
      return new t(0);
    },
    "Array | Matrix": e.referToSelf((n) => (a) => Pe(a, n))
  });
}), u0 = "complex", c0 = ["typed", "Complex"], l0 = /* @__PURE__ */ R(u0, c0, (r) => {
  var {
    typed: e,
    Complex: t
  } = r;
  return e("complex", {
    "": function() {
      return t.ZERO;
    },
    number: function(a) {
      return new t(a, 0);
    },
    "number, number": function(a, i) {
      return new t(a, i);
    },
    // TODO: this signature should be redundant
    "BigNumber, BigNumber": function(a, i) {
      return new t(a.toNumber(), i.toNumber());
    },
    Fraction: function(a) {
      return new t(a.valueOf(), 0);
    },
    Complex: function(a) {
      return a.clone();
    },
    string: function(a) {
      return t(a);
    },
    null: function(a) {
      return t(0);
    },
    Object: function(a) {
      if ("re" in a && "im" in a)
        return new t(a.re, a.im);
      if ("r" in a && "phi" in a || "abs" in a && "arg" in a)
        return new t(a);
      throw new Error("Expected object with properties (re and im) or (r and phi) or (abs and arg)");
    },
    "Array | Matrix": e.referToSelf((n) => (a) => Pe(a, n))
  });
}), f0 = "fraction", m0 = ["typed", "Fraction"], yp = /* @__PURE__ */ R(f0, m0, (r) => {
  var {
    typed: e,
    Fraction: t
  } = r;
  return e("fraction", {
    number: function(a) {
      if (!isFinite(a) || isNaN(a))
        throw new Error(a + " cannot be represented as a fraction");
      return new t(a);
    },
    string: function(a) {
      return new t(a);
    },
    "number, number": function(a, i) {
      return new t(a, i);
    },
    "bigint, bigint": function(a, i) {
      return new t(a, i);
    },
    null: function(a) {
      return new t(0);
    },
    BigNumber: function(a) {
      return new t(a.toString());
    },
    bigint: function(a) {
      return new t(a.toString());
    },
    Fraction: function(a) {
      return a;
    },
    Unit: e.referToSelf((n) => (a) => {
      var i = a.clone();
      return i.value = n(a.value), i;
    }),
    Object: function(a) {
      return new t(a);
    },
    "Array | Matrix": e.referToSelf((n) => (a) => Pe(a, n))
  });
}), cs = "matrix", p0 = ["typed", "Matrix", "DenseMatrix", "SparseMatrix"], bp = /* @__PURE__ */ R(cs, p0, (r) => {
  var {
    typed: e,
    Matrix: t,
    DenseMatrix: n,
    SparseMatrix: a
  } = r;
  return e(cs, {
    "": function() {
      return i([]);
    },
    string: function(l) {
      return i([], l);
    },
    "string, string": function(l, c) {
      return i([], l, c);
    },
    Array: function(l) {
      return i(l);
    },
    Matrix: function(l) {
      return i(l, l.storage());
    },
    "Array | Matrix, string": i,
    "Array | Matrix, string, string": i
  });
  function i(s, l, c) {
    if (l === "dense" || l === "default" || l === void 0)
      return new n(s, c);
    if (l === "sparse")
      return new a(s, c);
    throw new TypeError("Unknown matrix type " + JSON.stringify(l) + ".");
  }
}), ls = "matrixFromFunction", d0 = ["typed", "matrix", "isZero"], v0 = /* @__PURE__ */ R(ls, d0, (r) => {
  var {
    typed: e,
    matrix: t,
    isZero: n
  } = r;
  return e(ls, {
    "Array | Matrix, function, string, string": function(s, l, c, o) {
      return a(s, l, c, o);
    },
    "Array | Matrix, function, string": function(s, l, c) {
      return a(s, l, c);
    },
    "Matrix, function": function(s, l) {
      return a(s, l, "dense");
    },
    "Array, function": function(s, l) {
      return a(s, l, "dense").toArray();
    },
    "Array | Matrix, string, function": function(s, l, c) {
      return a(s, c, l);
    },
    "Array | Matrix, string, string, function": function(s, l, c, o) {
      return a(s, o, l, c);
    }
  });
  function a(i, s, l, c) {
    var o;
    return c !== void 0 ? o = t(l, c) : o = t(l), o.resize(i), o.forEach(function(u, f) {
      var m = s(f);
      n(m) || o.set(f, m);
    }), o;
  }
}), fs = "matrixFromRows", h0 = ["typed", "matrix", "flatten", "size"], g0 = /* @__PURE__ */ R(fs, h0, (r) => {
  var {
    typed: e,
    matrix: t,
    flatten: n,
    size: a
  } = r;
  return e(fs, {
    "...Array": function(c) {
      return i(c);
    },
    "...Matrix": function(c) {
      return t(i(c.map((o) => o.toArray())));
    }
    // TODO implement this properly for SparseMatrix
  });
  function i(l) {
    if (l.length === 0) throw new TypeError("At least one row is needed to construct a matrix.");
    var c = s(l[0]), o = [];
    for (var u of l) {
      var f = s(u);
      if (f !== c)
        throw new TypeError("The vectors had different length: " + (c | 0) + " ≠ " + (f | 0));
      o.push(n(u));
    }
    return o;
  }
  function s(l) {
    var c = a(l);
    if (c.length === 1)
      return c[0];
    if (c.length === 2) {
      if (c[0] === 1)
        return c[1];
      if (c[1] === 1)
        return c[0];
      throw new TypeError("At least one of the arguments is not a vector.");
    } else
      throw new TypeError("Only one- or two-dimensional vectors are supported.");
  }
}), ms = "matrixFromColumns", y0 = ["typed", "matrix", "flatten", "size"], b0 = /* @__PURE__ */ R(ms, y0, (r) => {
  var {
    typed: e,
    matrix: t,
    flatten: n,
    size: a
  } = r;
  return e(ms, {
    "...Array": function(c) {
      return i(c);
    },
    "...Matrix": function(c) {
      return t(i(c.map((o) => o.toArray())));
    }
    // TODO implement this properly for SparseMatrix
  });
  function i(l) {
    if (l.length === 0) throw new TypeError("At least one column is needed to construct a matrix.");
    for (var c = s(l[0]), o = [], u = 0; u < c; u++)
      o[u] = [];
    for (var f of l) {
      var m = s(f);
      if (m !== c)
        throw new TypeError("The vectors had different length: " + (c | 0) + " ≠ " + (m | 0));
      for (var p = n(f), d = 0; d < c; d++)
        o[d].push(p[d]);
    }
    return o;
  }
  function s(l) {
    var c = a(l);
    if (c.length === 1)
      return c[0];
    if (c.length === 2) {
      if (c[0] === 1)
        return c[1];
      if (c[1] === 1)
        return c[0];
      throw new TypeError("At least one of the arguments is not a vector.");
    } else
      throw new TypeError("Only one- or two-dimensional vectors are supported.");
  }
}), ps = "splitUnit", x0 = ["typed"], w0 = /* @__PURE__ */ R(ps, x0, (r) => {
  var {
    typed: e
  } = r;
  return e(ps, {
    "Unit, Array": function(n, a) {
      return n.splitUnit(a);
    }
  });
}), ds = "unaryMinus", D0 = ["typed"], xp = /* @__PURE__ */ R(ds, D0, (r) => {
  var {
    typed: e
  } = r;
  return e(ds, {
    number: Cm,
    "Complex | BigNumber | Fraction": (t) => t.neg(),
    bigint: (t) => -t,
    Unit: e.referToSelf((t) => (n) => {
      var a = n.clone();
      return a.value = e.find(t, a.valueType())(n.value), a;
    }),
    // deep map collection, skip zeros since unaryMinus(0) = 0
    "Array | Matrix": e.referToSelf((t) => (n) => Pe(n, t, !0))
    // TODO: add support for string
  });
}), vs = "unaryPlus", N0 = ["typed", "config", "numeric"], A0 = /* @__PURE__ */ R(vs, N0, (r) => {
  var {
    typed: e,
    config: t,
    numeric: n
  } = r;
  return e(vs, {
    number: _m,
    Complex: function(i) {
      return i;
    },
    BigNumber: function(i) {
      return i;
    },
    bigint: function(i) {
      return i;
    },
    Fraction: function(i) {
      return i;
    },
    Unit: function(i) {
      return i.clone();
    },
    // deep map collection, skip zeros since unaryPlus(0) = 0
    "Array | Matrix": e.referToSelf((a) => (i) => Pe(i, a, !0)),
    boolean: function(i) {
      return n(i ? 1 : 0, t.number);
    },
    string: function(i) {
      return n(i, St(i, t));
    }
  });
}), hs = "abs", S0 = ["typed"], wp = /* @__PURE__ */ R(hs, S0, (r) => {
  var {
    typed: e
  } = r;
  return e(hs, {
    number: Am,
    "Complex | BigNumber | Fraction | Unit": (t) => t.abs(),
    bigint: (t) => t < 0n ? -t : t,
    // deep map collection, skip zeros since abs(0) = 0
    "Array | Matrix": e.referToSelf((t) => (n) => Pe(n, t, !0))
  });
}), gs = "mapSlices", E0 = ["typed", "isInteger"], Vi = /* @__PURE__ */ R(gs, E0, (r) => {
  var {
    typed: e,
    isInteger: t
  } = r;
  return e(gs, {
    "Array | Matrix, number | BigNumber, function": function(a, i, s) {
      if (!t(i))
        throw new TypeError("Integer number expected for dimension");
      var l = Array.isArray(a) ? Oe(a) : a.size();
      if (i < 0 || i >= l.length)
        throw new Hr(i, l.length);
      return Ee(a) ? a.create(Pa(a.valueOf(), i, s), a.datatype()) : Pa(a, i, s);
    }
  });
}, {
  formerly: "apply"
});
function Pa(r, e, t) {
  var n, a, i;
  if (e <= 0)
    if (Array.isArray(r[0])) {
      for (i = M0(r), a = [], n = 0; n < i.length; n++)
        a[n] = Pa(i[n], e - 1, t);
      return a;
    } else
      return t(r);
  else {
    for (a = [], n = 0; n < r.length; n++)
      a[n] = Pa(r[n], e - 1, t);
    return a;
  }
}
function M0(r) {
  var e = r.length, t = r[0].length, n, a, i = [];
  for (a = 0; a < t; a++) {
    var s = [];
    for (n = 0; n < e; n++)
      s.push(r[n][a]);
    i.push(s);
  }
  return i;
}
var ys = "addScalar", C0 = ["typed"], Dp = /* @__PURE__ */ R(ys, C0, (r) => {
  var {
    typed: e
  } = r;
  return e(ys, {
    "number, number": Sm,
    "Complex, Complex": function(n, a) {
      return n.add(a);
    },
    "BigNumber, BigNumber": function(n, a) {
      return n.plus(a);
    },
    "bigint, bigint": function(n, a) {
      return n + a;
    },
    "Fraction, Fraction": function(n, a) {
      return n.add(a);
    },
    "Unit, Unit": e.referToSelf((t) => (n, a) => {
      if (n.value === null || n.value === void 0)
        throw new Error("Parameter x contains a unit with undefined value");
      if (a.value === null || a.value === void 0)
        throw new Error("Parameter y contains a unit with undefined value");
      if (!n.equalBase(a)) throw new Error("Units do not match");
      var i = n.clone();
      return i.value = e.find(t, [i.valueType(), a.valueType()])(i.value, a.value), i.fixPrefix = !1, i;
    })
  });
}), bs = "subtractScalar", _0 = ["typed"], Np = /* @__PURE__ */ R(bs, _0, (r) => {
  var {
    typed: e
  } = r;
  return e(bs, {
    "number, number": Em,
    "Complex, Complex": function(n, a) {
      return n.sub(a);
    },
    "BigNumber, BigNumber": function(n, a) {
      return n.minus(a);
    },
    "bigint, bigint": function(n, a) {
      return n - a;
    },
    "Fraction, Fraction": function(n, a) {
      return n.sub(a);
    },
    "Unit, Unit": e.referToSelf((t) => (n, a) => {
      if (n.value === null || n.value === void 0)
        throw new Error("Parameter x contains a unit with undefined value");
      if (a.value === null || a.value === void 0)
        throw new Error("Parameter y contains a unit with undefined value");
      if (!n.equalBase(a)) throw new Error("Units do not match");
      var i = n.clone();
      return i.value = e.find(t, [i.valueType(), a.valueType()])(i.value, a.value), i.fixPrefix = !1, i;
    })
  });
}), xs = "cbrt", T0 = ["config", "typed", "isNegative", "unaryMinus", "matrix", "Complex", "BigNumber", "Fraction"], F0 = /* @__PURE__ */ R(xs, T0, (r) => {
  var {
    config: e,
    typed: t,
    isNegative: n,
    unaryMinus: a,
    matrix: i,
    Complex: s,
    BigNumber: l,
    Fraction: c
  } = r;
  return t(xs, {
    number: Nn,
    // note: signature 'number, boolean' is also supported,
    //       created by typed as it knows how to convert number to Complex
    Complex: o,
    "Complex, boolean": o,
    BigNumber: function(m) {
      return m.cbrt();
    },
    Unit: u
  });
  function o(f, m) {
    var p = f.arg() / 3, d = f.abs(), v = new s(Nn(d), 0).mul(new s(0, p).exp());
    if (m) {
      var x = [v, new s(Nn(d), 0).mul(new s(0, p + Math.PI * 2 / 3).exp()), new s(Nn(d), 0).mul(new s(0, p - Math.PI * 2 / 3).exp())];
      return e.matrix === "Array" ? x : i(x);
    } else
      return v;
  }
  function u(f) {
    if (f.value && Zr(f.value)) {
      var m = f.clone();
      return m.value = 1, m = m.pow(1 / 3), m.value = o(f.value), m;
    } else {
      var p = n(f.value);
      p && (f.value = a(f.value));
      var d;
      $e(f.value) ? d = new l(1).div(3) : Rt(f.value) ? d = new c(1, 3) : d = 1 / 3;
      var v = f.pow(d);
      return p && (v.value = a(v.value)), v;
    }
  }
}), B0 = "matAlgo11xS0s", O0 = ["typed", "equalScalar"], br = /* @__PURE__ */ R(B0, O0, (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return function(a, i, s, l) {
    var c = a._values, o = a._index, u = a._ptr, f = a._size, m = a._datatype;
    if (!c)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var p = f[0], d = f[1], v, x = t, h = 0, D = s;
    typeof m == "string" && (v = m, x = e.find(t, [v, v]), h = e.convert(0, v), i = e.convert(i, v), D = e.find(s, [v, v]));
    for (var y = [], w = [], b = [], g = 0; g < d; g++) {
      b[g] = w.length;
      for (var N = u[g], S = u[g + 1], A = N; A < S; A++) {
        var E = o[A], M = l ? D(i, c[A]) : D(c[A], i);
        x(M, h) || (w.push(E), y.push(M));
      }
    }
    return b[d] = w.length, a.createSparseMatrix({
      values: y,
      index: w,
      ptr: b,
      size: [p, d],
      datatype: v
    });
  };
}), I0 = "matAlgo12xSfs", $0 = ["typed", "DenseMatrix"], cr = /* @__PURE__ */ R(I0, $0, (r) => {
  var {
    typed: e,
    DenseMatrix: t
  } = r;
  return function(a, i, s, l) {
    var c = a._values, o = a._index, u = a._ptr, f = a._size, m = a._datatype;
    if (!c)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var p = f[0], d = f[1], v, x = s;
    typeof m == "string" && (v = m, i = e.convert(i, v), x = e.find(s, [v, v]));
    for (var h = [], D = [], y = [], w = 0; w < d; w++) {
      for (var b = w + 1, g = u[w], N = u[w + 1], S = g; S < N; S++) {
        var A = o[S];
        D[A] = c[S], y[A] = b;
      }
      for (var E = 0; E < p; E++)
        w === 0 && (h[E] = []), y[E] === b ? h[E][w] = l ? x(i, D[E]) : x(D[E], i) : h[E][w] = l ? x(i, 0) : x(0, i);
    }
    return new t({
      data: h,
      size: [p, d],
      datatype: v
    });
  };
}), z0 = "matAlgo14xDs", R0 = ["typed"], Wr = /* @__PURE__ */ R(z0, R0, (r) => {
  var {
    typed: e
  } = r;
  return function(a, i, s, l) {
    var c = a._data, o = a._size, u = a._datatype, f, m = s;
    typeof u == "string" && (f = u, i = e.convert(i, f), m = e.find(s, [f, f]));
    var p = o.length > 0 ? t(m, 0, o, o[0], c, i, l) : [];
    return a.createDenseMatrix({
      data: p,
      size: Te(o),
      datatype: f
    });
  };
  function t(n, a, i, s, l, c, o) {
    var u = [];
    if (a === i.length - 1)
      for (var f = 0; f < s; f++)
        u[f] = o ? n(c, l[f]) : n(l[f], c);
    else
      for (var m = 0; m < s; m++)
        u[m] = t(n, a + 1, i, i[a + 1], l[m], c, o);
    return u;
  }
}), Zi = "ceil", q0 = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "DenseMatrix"], P0 = new Nt(10), U0 = /* @__PURE__ */ R(Zi, ["typed", "config", "round"], (r) => {
  var {
    typed: e,
    config: t,
    round: n
  } = r;
  function a(i) {
    var s = Math.ceil(i), l = n(i);
    return s === l ? s : dr(i, l, t.relTol, t.absTol) && !dr(i, s, t.relTol, t.absTol) ? l : s;
  }
  return e(Zi, {
    number: a,
    "number, number": function(s, l) {
      if (!Ne(l))
        throw new RangeError("number of decimals in function ceil must be an integer");
      if (l < 0 || l > 15)
        throw new RangeError("number of decimals in ceil number must be in range 0-15");
      var c = 10 ** l;
      return a(s * c) / c;
    }
  });
}), L0 = /* @__PURE__ */ R(Zi, q0, (r) => {
  var {
    typed: e,
    config: t,
    round: n,
    matrix: a,
    equalScalar: i,
    zeros: s,
    DenseMatrix: l
  } = r, c = br({
    typed: e,
    equalScalar: i
  }), o = cr({
    typed: e,
    DenseMatrix: l
  }), u = Wr({
    typed: e
  }), f = U0({
    typed: e,
    config: t,
    round: n
  });
  function m(p) {
    var d = (h, D) => kr(h, D, t.relTol, t.absTol), v = p.ceil(), x = n(p);
    return v.eq(x) ? v : d(p, x) && !d(p, v) ? x : v;
  }
  return e("ceil", {
    number: f.signatures.number,
    "number,number": f.signatures["number,number"],
    Complex: function(d) {
      return d.ceil();
    },
    "Complex, number": function(d, v) {
      return d.ceil(v);
    },
    "Complex, BigNumber": function(d, v) {
      return d.ceil(v.toNumber());
    },
    BigNumber: m,
    "BigNumber, BigNumber": function(d, v) {
      var x = P0.pow(v);
      return m(d.mul(x)).div(x);
    },
    bigint: (p) => p,
    "bigint, number": (p, d) => p,
    "bigint, BigNumber": (p, d) => p,
    Fraction: function(d) {
      return d.ceil();
    },
    "Fraction, number": function(d, v) {
      return d.ceil(v);
    },
    "Fraction, BigNumber": function(d, v) {
      return d.ceil(v.toNumber());
    },
    "Unit, number, Unit": e.referToSelf((p) => function(d, v, x) {
      var h = d.toNumeric(x);
      return x.multiply(p(h, v));
    }),
    "Unit, BigNumber, Unit": e.referToSelf((p) => (d, v, x) => p(d, v.toNumber(), x)),
    "Array | Matrix, number | BigNumber, Unit": e.referToSelf((p) => (d, v, x) => Pe(d, (h) => p(h, v, x), !0)),
    "Array | Matrix | Unit, Unit": e.referToSelf((p) => (d, v) => p(d, 0, v)),
    "Array | Matrix": e.referToSelf((p) => (d) => Pe(d, p, !0)),
    "Array, number | BigNumber": e.referToSelf((p) => (d, v) => Pe(d, (x) => p(x, v), !0)),
    "SparseMatrix, number | BigNumber": e.referToSelf((p) => (d, v) => c(d, v, p, !1)),
    "DenseMatrix, number | BigNumber": e.referToSelf((p) => (d, v) => u(d, v, p, !1)),
    "number | Complex | Fraction | BigNumber, Array": e.referToSelf((p) => (d, v) => u(a(v), d, p, !0).valueOf()),
    "number | Complex | Fraction | BigNumber, Matrix": e.referToSelf((p) => (d, v) => i(d, 0) ? s(v.size(), v.storage()) : v.storage() === "dense" ? u(v, d, p, !0) : o(v, d, p, !0))
  });
}), ws = "cube", k0 = ["typed"], H0 = /* @__PURE__ */ R(ws, k0, (r) => {
  var {
    typed: e
  } = r;
  return e(ws, {
    number: Tm,
    Complex: function(n) {
      return n.mul(n).mul(n);
    },
    BigNumber: function(n) {
      return n.times(n).times(n);
    },
    bigint: function(n) {
      return n * n * n;
    },
    Fraction: function(n) {
      return n.pow(3);
    },
    Unit: function(n) {
      return n.pow(3);
    }
  });
}), Ds = "exp", W0 = ["typed"], G0 = /* @__PURE__ */ R(Ds, W0, (r) => {
  var {
    typed: e
  } = r;
  return e(Ds, {
    number: Fm,
    Complex: function(n) {
      return n.exp();
    },
    BigNumber: function(n) {
      return n.exp();
    }
  });
}), Ns = "expm1", V0 = ["typed", "Complex"], Z0 = /* @__PURE__ */ R(Ns, V0, (r) => {
  var {
    typed: e,
    Complex: t
  } = r;
  return e(Ns, {
    number: Bm,
    Complex: function(a) {
      var i = Math.exp(a.re);
      return new t(i * Math.cos(a.im) - 1, i * Math.sin(a.im));
    },
    BigNumber: function(a) {
      return a.exp().minus(1);
    }
  });
}), Xi = "fix", X0 = ["typed", "Complex", "matrix", "ceil", "floor", "equalScalar", "zeros", "DenseMatrix"], Y0 = /* @__PURE__ */ R(Xi, ["typed", "ceil", "floor"], (r) => {
  var {
    typed: e,
    ceil: t,
    floor: n
  } = r;
  return e(Xi, {
    number: function(i) {
      return i > 0 ? n(i) : t(i);
    },
    "number, number": function(i, s) {
      return i > 0 ? n(i, s) : t(i, s);
    }
  });
}), J0 = /* @__PURE__ */ R(Xi, X0, (r) => {
  var {
    typed: e,
    Complex: t,
    matrix: n,
    ceil: a,
    floor: i,
    equalScalar: s,
    zeros: l,
    DenseMatrix: c
  } = r, o = cr({
    typed: e,
    DenseMatrix: c
  }), u = Wr({
    typed: e
  }), f = Y0({
    typed: e,
    ceil: a,
    floor: i
  });
  return e("fix", {
    number: f.signatures.number,
    "number, number | BigNumber": f.signatures["number,number"],
    Complex: function(p) {
      return new t(p.re > 0 ? Math.floor(p.re) : Math.ceil(p.re), p.im > 0 ? Math.floor(p.im) : Math.ceil(p.im));
    },
    "Complex, number": function(p, d) {
      return new t(p.re > 0 ? i(p.re, d) : a(p.re, d), p.im > 0 ? i(p.im, d) : a(p.im, d));
    },
    "Complex, BigNumber": function(p, d) {
      var v = d.toNumber();
      return new t(p.re > 0 ? i(p.re, v) : a(p.re, v), p.im > 0 ? i(p.im, v) : a(p.im, v));
    },
    BigNumber: function(p) {
      return p.isNegative() ? a(p) : i(p);
    },
    "BigNumber, number | BigNumber": function(p, d) {
      return p.isNegative() ? a(p, d) : i(p, d);
    },
    bigint: (m) => m,
    "bigint, number": (m, p) => m,
    "bigint, BigNumber": (m, p) => m,
    Fraction: function(p) {
      return p.s < 0n ? p.ceil() : p.floor();
    },
    "Fraction, number | BigNumber": function(p, d) {
      return p.s < 0n ? a(p, d) : i(p, d);
    },
    "Unit, number, Unit": e.referToSelf((m) => function(p, d, v) {
      var x = p.toNumeric(v);
      return v.multiply(m(x, d));
    }),
    "Unit, BigNumber, Unit": e.referToSelf((m) => (p, d, v) => m(p, d.toNumber(), v)),
    "Array | Matrix, number | BigNumber, Unit": e.referToSelf((m) => (p, d, v) => Pe(p, (x) => m(x, d, v), !0)),
    "Array | Matrix | Unit, Unit": e.referToSelf((m) => (p, d) => m(p, 0, d)),
    "Array | Matrix": e.referToSelf((m) => (p) => Pe(p, m, !0)),
    "Array | Matrix, number | BigNumber": e.referToSelf((m) => (p, d) => Pe(p, (v) => m(v, d), !0)),
    "number | Complex | Fraction | BigNumber, Array": e.referToSelf((m) => (p, d) => u(n(d), p, m, !0).valueOf()),
    "number | Complex | Fraction | BigNumber, Matrix": e.referToSelf((m) => (p, d) => s(p, 0) ? l(d.size(), d.storage()) : d.storage() === "dense" ? u(d, p, m, !0) : o(d, p, m, !0))
  });
}), Yi = "floor", Q0 = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "DenseMatrix"], j0 = new Nt(10), K0 = /* @__PURE__ */ R(Yi, ["typed", "config", "round"], (r) => {
  var {
    typed: e,
    config: t,
    round: n
  } = r;
  function a(i) {
    var s = Math.floor(i), l = n(i);
    return s === l ? s : dr(i, l, t.relTol, t.absTol) && !dr(i, s, t.relTol, t.absTol) ? l : s;
  }
  return e(Yi, {
    number: a,
    "number, number": function(s, l) {
      if (!Ne(l))
        throw new RangeError("number of decimals in function floor must be an integer");
      if (l < 0 || l > 15)
        throw new RangeError("number of decimals in floor number must be in range 0 - 15");
      var c = 10 ** l;
      return a(s * c) / c;
    }
  });
}), Ap = /* @__PURE__ */ R(Yi, Q0, (r) => {
  var {
    typed: e,
    config: t,
    round: n,
    matrix: a,
    equalScalar: i,
    zeros: s,
    DenseMatrix: l
  } = r, c = br({
    typed: e,
    equalScalar: i
  }), o = cr({
    typed: e,
    DenseMatrix: l
  }), u = Wr({
    typed: e
  }), f = K0({
    typed: e,
    config: t,
    round: n
  });
  function m(p) {
    var d = (h, D) => kr(h, D, t.relTol, t.absTol), v = p.floor(), x = n(p);
    return v.eq(x) ? v : d(p, x) && !d(p, v) ? x : v;
  }
  return e("floor", {
    number: f.signatures.number,
    "number,number": f.signatures["number,number"],
    Complex: function(d) {
      return d.floor();
    },
    "Complex, number": function(d, v) {
      return d.floor(v);
    },
    "Complex, BigNumber": function(d, v) {
      return d.floor(v.toNumber());
    },
    BigNumber: m,
    "BigNumber, BigNumber": function(d, v) {
      var x = j0.pow(v);
      return m(d.mul(x)).div(x);
    },
    bigint: (p) => p,
    "bigint, number": (p, d) => p,
    "bigint, BigNumber": (p, d) => p,
    Fraction: function(d) {
      return d.floor();
    },
    "Fraction, number": function(d, v) {
      return d.floor(v);
    },
    "Fraction, BigNumber": function(d, v) {
      return d.floor(v.toNumber());
    },
    "Unit, number, Unit": e.referToSelf((p) => function(d, v, x) {
      var h = d.toNumeric(x);
      return x.multiply(p(h, v));
    }),
    "Unit, BigNumber, Unit": e.referToSelf((p) => (d, v, x) => p(d, v.toNumber(), x)),
    "Array | Matrix, number | BigNumber, Unit": e.referToSelf((p) => (d, v, x) => Pe(d, (h) => p(h, v, x), !0)),
    "Array | Matrix | Unit, Unit": e.referToSelf((p) => (d, v) => p(d, 0, v)),
    "Array | Matrix": e.referToSelf((p) => (d) => Pe(d, p, !0)),
    "Array, number | BigNumber": e.referToSelf((p) => (d, v) => Pe(d, (x) => p(x, v), !0)),
    "SparseMatrix, number | BigNumber": e.referToSelf((p) => (d, v) => c(d, v, p, !1)),
    "DenseMatrix, number | BigNumber": e.referToSelf((p) => (d, v) => u(d, v, p, !1)),
    "number | Complex | Fraction | BigNumber, Array": e.referToSelf((p) => (d, v) => u(a(v), d, p, !0).valueOf()),
    "number | Complex | Fraction | BigNumber, Matrix": e.referToSelf((p) => (d, v) => i(d, 0) ? s(v.size(), v.storage()) : v.storage() === "dense" ? u(v, d, p, !0) : o(v, d, p, !0))
  });
}), e1 = "matAlgo02xDS0", r1 = ["typed", "equalScalar"], Jr = /* @__PURE__ */ R(e1, r1, (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return function(a, i, s, l) {
    var c = a._data, o = a._size, u = a._datatype || a.getDataType(), f = i._values, m = i._index, p = i._ptr, d = i._size, v = i._datatype || i._data === void 0 ? i._datatype : i.getDataType();
    if (o.length !== d.length)
      throw new Ue(o.length, d.length);
    if (o[0] !== d[0] || o[1] !== d[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + o + ") must match Matrix B (" + d + ")");
    if (!f)
      throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var x = o[0], h = o[1], D, y = t, w = 0, b = s;
    typeof u == "string" && u === v && u !== "mixed" && (D = u, y = e.find(t, [D, D]), w = e.convert(0, D), b = e.find(s, [D, D]));
    for (var g = [], N = [], S = [], A = 0; A < h; A++) {
      S[A] = N.length;
      for (var E = p[A], M = p[A + 1], T = E; T < M; T++) {
        var B = m[T], I = l ? b(f[T], c[B][A]) : b(c[B][A], f[T]);
        y(I, w) || (N.push(B), g.push(I));
      }
    }
    return S[h] = N.length, i.createSparseMatrix({
      values: g,
      index: N,
      ptr: S,
      size: [x, h],
      datatype: u === a._datatype && v === i._datatype ? D : void 0
    });
  };
}), t1 = "matAlgo03xDSf", n1 = ["typed"], Ar = /* @__PURE__ */ R(t1, n1, (r) => {
  var {
    typed: e
  } = r;
  return function(n, a, i, s) {
    var l = n._data, c = n._size, o = n._datatype || n.getDataType(), u = a._values, f = a._index, m = a._ptr, p = a._size, d = a._datatype || a._data === void 0 ? a._datatype : a.getDataType();
    if (c.length !== p.length)
      throw new Ue(c.length, p.length);
    if (c[0] !== p[0] || c[1] !== p[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + c + ") must match Matrix B (" + p + ")");
    if (!u)
      throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var v = c[0], x = c[1], h, D = 0, y = i;
    typeof o == "string" && o === d && o !== "mixed" && (h = o, D = e.convert(0, h), y = e.find(i, [h, h]));
    for (var w = [], b = 0; b < v; b++)
      w[b] = [];
    for (var g = [], N = [], S = 0; S < x; S++) {
      for (var A = S + 1, E = m[S], M = m[S + 1], T = E; T < M; T++) {
        var B = f[T];
        g[B] = s ? y(u[T], l[B][S]) : y(l[B][S], u[T]), N[B] = A;
      }
      for (var I = 0; I < v; I++)
        N[I] === A ? w[I][S] = g[I] : w[I][S] = s ? y(D, l[I][S]) : y(l[I][S], D);
    }
    return n.createDenseMatrix({
      data: w,
      size: [v, x],
      datatype: o === n._datatype && d === a._datatype ? h : void 0
    });
  };
}), a1 = "matAlgo05xSfSf", i1 = ["typed", "equalScalar"], ii = /* @__PURE__ */ R(a1, i1, (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return function(a, i, s) {
    var l = a._values, c = a._index, o = a._ptr, u = a._size, f = a._datatype || a._data === void 0 ? a._datatype : a.getDataType(), m = i._values, p = i._index, d = i._ptr, v = i._size, x = i._datatype || i._data === void 0 ? i._datatype : i.getDataType();
    if (u.length !== v.length)
      throw new Ue(u.length, v.length);
    if (u[0] !== v[0] || u[1] !== v[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + v + ")");
    var h = u[0], D = u[1], y, w = t, b = 0, g = s;
    typeof f == "string" && f === x && f !== "mixed" && (y = f, w = e.find(t, [y, y]), b = e.convert(0, y), g = e.find(s, [y, y]));
    var N = l && m ? [] : void 0, S = [], A = [], E = N ? [] : void 0, M = N ? [] : void 0, T = [], B = [], I, O, _, P;
    for (O = 0; O < D; O++) {
      A[O] = S.length;
      var W = O + 1;
      for (_ = o[O], P = o[O + 1]; _ < P; _++)
        I = c[_], S.push(I), T[I] = W, E && (E[I] = l[_]);
      for (_ = d[O], P = d[O + 1]; _ < P; _++)
        I = p[_], T[I] !== W && S.push(I), B[I] = W, M && (M[I] = m[_]);
      if (N)
        for (_ = A[O]; _ < S.length; ) {
          I = S[_];
          var L = T[I], J = B[I];
          if (L === W || J === W) {
            var ee = L === W ? E[I] : b, F = J === W ? M[I] : b, G = g(ee, F);
            w(G, b) ? S.splice(_, 1) : (N.push(G), _++);
          }
        }
    }
    return A[D] = S.length, a.createSparseMatrix({
      values: N,
      index: S,
      ptr: A,
      size: [h, D],
      datatype: f === a._datatype && x === i._datatype ? y : void 0
    });
  };
}), o1 = "matAlgo13xDD", s1 = ["typed"], Sp = /* @__PURE__ */ R(o1, s1, (r) => {
  var {
    typed: e
  } = r;
  return function(a, i, s) {
    var l = a._data, c = a._size, o = a._datatype, u = i._data, f = i._size, m = i._datatype, p = [];
    if (c.length !== f.length)
      throw new Ue(c.length, f.length);
    for (var d = 0; d < c.length; d++) {
      if (c[d] !== f[d])
        throw new RangeError("Dimension mismatch. Matrix A (" + c + ") must match Matrix B (" + f + ")");
      p[d] = c[d];
    }
    var v, x = s;
    typeof o == "string" && o === m && (v = o, x = e.find(s, [v, v]));
    var h = p.length > 0 ? t(x, 0, p, p[0], l, u) : [];
    return a.createDenseMatrix({
      data: h,
      size: p,
      datatype: v
    });
  };
  function t(n, a, i, s, l, c) {
    var o = [];
    if (a === i.length - 1)
      for (var u = 0; u < s; u++)
        o[u] = n(l[u], c[u]);
    else
      for (var f = 0; f < s; f++)
        o[f] = t(n, a + 1, i, i[a + 1], l[f], c[f]);
    return o;
  }
});
function fr(r, e) {
  if (ut(r.size(), e.size()))
    return [r, e];
  var t = Ba(r.size(), e.size());
  return [r, e].map((n) => u1(n, t));
}
function u1(r, e) {
  return ut(r.size(), e) ? r : r.create(Ot(r.valueOf(), e), r.datatype());
}
var c1 = "matrixAlgorithmSuite", l1 = ["typed", "matrix"], rr = /* @__PURE__ */ R(c1, l1, (r) => {
  var {
    typed: e,
    matrix: t
  } = r, n = Sp({
    typed: e
  }), a = Wr({
    typed: e
  });
  return function(s) {
    var l = s.elop, c = s.SD || s.DS, o;
    l ? (o = {
      "DenseMatrix, DenseMatrix": (p, d) => n(...fr(p, d), l),
      "Array, Array": (p, d) => n(...fr(t(p), t(d)), l).valueOf(),
      "Array, DenseMatrix": (p, d) => n(...fr(t(p), d), l),
      "DenseMatrix, Array": (p, d) => n(...fr(p, t(d)), l)
    }, s.SS && (o["SparseMatrix, SparseMatrix"] = (p, d) => s.SS(...fr(p, d), l, !1)), s.DS && (o["DenseMatrix, SparseMatrix"] = (p, d) => s.DS(...fr(p, d), l, !1), o["Array, SparseMatrix"] = (p, d) => s.DS(...fr(t(p), d), l, !1)), c && (o["SparseMatrix, DenseMatrix"] = (p, d) => c(...fr(d, p), l, !0), o["SparseMatrix, Array"] = (p, d) => c(...fr(t(d), p), l, !0))) : (o = {
      "DenseMatrix, DenseMatrix": e.referToSelf((p) => (d, v) => n(...fr(d, v), p)),
      "Array, Array": e.referToSelf((p) => (d, v) => n(...fr(t(d), t(v)), p).valueOf()),
      "Array, DenseMatrix": e.referToSelf((p) => (d, v) => n(...fr(t(d), v), p)),
      "DenseMatrix, Array": e.referToSelf((p) => (d, v) => n(...fr(d, t(v)), p))
    }, s.SS && (o["SparseMatrix, SparseMatrix"] = e.referToSelf((p) => (d, v) => s.SS(...fr(d, v), p, !1))), s.DS && (o["DenseMatrix, SparseMatrix"] = e.referToSelf((p) => (d, v) => s.DS(...fr(d, v), p, !1)), o["Array, SparseMatrix"] = e.referToSelf((p) => (d, v) => s.DS(...fr(t(d), v), p, !1))), c && (o["SparseMatrix, DenseMatrix"] = e.referToSelf((p) => (d, v) => c(...fr(v, d), p, !0)), o["SparseMatrix, Array"] = e.referToSelf((p) => (d, v) => c(...fr(t(v), d), p, !0))));
    var u = s.scalar || "any", f = s.Ds || s.Ss;
    f && (l ? (o["DenseMatrix," + u] = (p, d) => a(p, d, l, !1), o[u + ", DenseMatrix"] = (p, d) => a(d, p, l, !0), o["Array," + u] = (p, d) => a(t(p), d, l, !1).valueOf(), o[u + ", Array"] = (p, d) => a(t(d), p, l, !0).valueOf()) : (o["DenseMatrix," + u] = e.referToSelf((p) => (d, v) => a(d, v, p, !1)), o[u + ", DenseMatrix"] = e.referToSelf((p) => (d, v) => a(v, d, p, !0)), o["Array," + u] = e.referToSelf((p) => (d, v) => a(t(d), v, p, !1).valueOf()), o[u + ", Array"] = e.referToSelf((p) => (d, v) => a(t(v), d, p, !0).valueOf())));
    var m = s.sS !== void 0 ? s.sS : s.Ss;
    return l ? (s.Ss && (o["SparseMatrix," + u] = (p, d) => s.Ss(p, d, l, !1)), m && (o[u + ", SparseMatrix"] = (p, d) => m(d, p, l, !0))) : (s.Ss && (o["SparseMatrix," + u] = e.referToSelf((p) => (d, v) => s.Ss(d, v, p, !1))), m && (o[u + ", SparseMatrix"] = e.referToSelf((p) => (d, v) => m(v, d, p, !0)))), l && l.signatures && Pf(o, l.signatures), o;
  };
}), As = "mod", f1 = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], Ep = /* @__PURE__ */ R(As, f1, (r) => {
  var {
    typed: e,
    config: t,
    round: n,
    matrix: a,
    equalScalar: i,
    zeros: s,
    DenseMatrix: l,
    concat: c
  } = r, o = Ap({
    typed: e,
    config: t,
    round: n,
    matrix: a,
    equalScalar: i,
    zeros: s,
    DenseMatrix: l
  }), u = Jr({
    typed: e,
    equalScalar: i
  }), f = Ar({
    typed: e
  }), m = ii({
    typed: e,
    equalScalar: i
  }), p = br({
    typed: e,
    equalScalar: i
  }), d = cr({
    typed: e,
    DenseMatrix: l
  }), v = rr({
    typed: e,
    matrix: a,
    concat: c
  });
  return e(As, {
    "number, number": x,
    "BigNumber, BigNumber": function(D, y) {
      return y.isZero() ? D : D.sub(y.mul(o(D.div(y))));
    },
    "bigint, bigint": function(D, y) {
      if (y === 0n)
        return D;
      if (D < 0) {
        var w = D % y;
        return w === 0n ? w : w + y;
      }
      return D % y;
    },
    "Fraction, Fraction": function(D, y) {
      return y.equals(0) ? D : D.sub(y.mul(o(D.div(y))));
    }
  }, v({
    SS: m,
    DS: f,
    SD: u,
    Ss: p,
    sS: d
  }));
  function x(h, D) {
    return D === 0 ? h : h - D * o(h / D);
  }
}), m1 = "matAlgo01xDSid", p1 = ["typed"], Mt = /* @__PURE__ */ R(m1, p1, (r) => {
  var {
    typed: e
  } = r;
  return function(n, a, i, s) {
    var l = n._data, c = n._size, o = n._datatype || n.getDataType(), u = a._values, f = a._index, m = a._ptr, p = a._size, d = a._datatype || a._data === void 0 ? a._datatype : a.getDataType();
    if (c.length !== p.length)
      throw new Ue(c.length, p.length);
    if (c[0] !== p[0] || c[1] !== p[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + c + ") must match Matrix B (" + p + ")");
    if (!u)
      throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var v = c[0], x = c[1], h = typeof o == "string" && o !== "mixed" && o === d ? o : void 0, D = h ? e.find(i, [h, h]) : i, y, w, b = [];
    for (y = 0; y < v; y++)
      b[y] = [];
    var g = [], N = [];
    for (w = 0; w < x; w++) {
      for (var S = w + 1, A = m[w], E = m[w + 1], M = A; M < E; M++)
        y = f[M], g[y] = s ? D(u[M], l[y][w]) : D(l[y][w], u[M]), N[y] = S;
      for (y = 0; y < v; y++)
        N[y] === S ? b[y][w] = g[y] : b[y][w] = l[y][w];
    }
    return n.createDenseMatrix({
      data: b,
      size: [v, x],
      datatype: o === n._datatype && d === a._datatype ? h : void 0
    });
  };
}), d1 = "matAlgo04xSidSid", v1 = ["typed", "equalScalar"], mo = /* @__PURE__ */ R(d1, v1, (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return function(a, i, s) {
    var l = a._values, c = a._index, o = a._ptr, u = a._size, f = a._datatype || a._data === void 0 ? a._datatype : a.getDataType(), m = i._values, p = i._index, d = i._ptr, v = i._size, x = i._datatype || i._data === void 0 ? i._datatype : i.getDataType();
    if (u.length !== v.length)
      throw new Ue(u.length, v.length);
    if (u[0] !== v[0] || u[1] !== v[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + v + ")");
    var h = u[0], D = u[1], y, w = t, b = 0, g = s;
    typeof f == "string" && f === x && f !== "mixed" && (y = f, w = e.find(t, [y, y]), b = e.convert(0, y), g = e.find(s, [y, y]));
    var N = l && m ? [] : void 0, S = [], A = [], E = l && m ? [] : void 0, M = l && m ? [] : void 0, T = [], B = [], I, O, _, P, W;
    for (O = 0; O < D; O++) {
      A[O] = S.length;
      var L = O + 1;
      for (P = o[O], W = o[O + 1], _ = P; _ < W; _++)
        I = c[_], S.push(I), T[I] = L, E && (E[I] = l[_]);
      for (P = d[O], W = d[O + 1], _ = P; _ < W; _++)
        if (I = p[_], T[I] === L) {
          if (E) {
            var J = g(E[I], m[_]);
            w(J, b) ? T[I] = null : E[I] = J;
          }
        } else
          S.push(I), B[I] = L, M && (M[I] = m[_]);
      if (E && M)
        for (_ = A[O]; _ < S.length; )
          I = S[_], T[I] === L ? (N[_] = E[I], _++) : B[I] === L ? (N[_] = M[I], _++) : S.splice(_, 1);
    }
    return A[D] = S.length, a.createSparseMatrix({
      values: N,
      index: S,
      ptr: A,
      size: [h, D],
      datatype: f === a._datatype && x === i._datatype ? y : void 0
    });
  };
}), h1 = "matAlgo10xSids", g1 = ["typed", "DenseMatrix"], Lt = /* @__PURE__ */ R(h1, g1, (r) => {
  var {
    typed: e,
    DenseMatrix: t
  } = r;
  return function(a, i, s, l) {
    var c = a._values, o = a._index, u = a._ptr, f = a._size, m = a._datatype;
    if (!c)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var p = f[0], d = f[1], v, x = s;
    typeof m == "string" && (v = m, i = e.convert(i, v), x = e.find(s, [v, v]));
    for (var h = [], D = [], y = [], w = 0; w < d; w++) {
      for (var b = w + 1, g = u[w], N = u[w + 1], S = g; S < N; S++) {
        var A = o[S];
        D[A] = c[S], y[A] = b;
      }
      for (var E = 0; E < p; E++)
        w === 0 && (h[E] = []), y[E] === b ? h[E][w] = l ? x(i, D[E]) : x(D[E], i) : h[E][w] = i;
    }
    return new t({
      data: h,
      size: [p, d],
      datatype: v
    });
  };
});
function ft(r, e, t, n) {
  if (!(this instanceof ft))
    throw new SyntaxError("Constructor must be called with the new operator");
  this.fn = r, this.count = e, this.min = t, this.max = n, this.message = "Wrong number of arguments in function " + r + " (" + e + " provided, " + t + (n != null ? "-" + n : "") + " expected)", this.stack = new Error().stack;
}
ft.prototype = new Error();
ft.prototype.constructor = Error;
ft.prototype.name = "ArgumentsError";
ft.prototype.isArgumentsError = !0;
var Ss = "gcd", y1 = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "BigNumber", "DenseMatrix", "concat"], bi = "number | BigNumber | Fraction | Matrix | Array", b1 = "".concat(bi, ", ").concat(bi, ", ...").concat(bi);
function Es(r) {
  return !r.some((e) => Array.isArray(e));
}
var x1 = /* @__PURE__ */ R(Ss, y1, (r) => {
  var {
    typed: e,
    matrix: t,
    config: n,
    round: a,
    equalScalar: i,
    zeros: s,
    BigNumber: l,
    DenseMatrix: c,
    concat: o
  } = r, u = Ep({
    typed: e,
    config: n,
    round: a,
    matrix: t,
    equalScalar: i,
    zeros: s,
    DenseMatrix: c,
    concat: o
  }), f = Mt({
    typed: e
  }), m = mo({
    typed: e,
    equalScalar: i
  }), p = Lt({
    typed: e,
    DenseMatrix: c
  }), d = rr({
    typed: e,
    matrix: t,
    concat: o
  });
  return e(Ss, {
    "number, number": v,
    "BigNumber, BigNumber": x,
    "Fraction, Fraction": (h, D) => h.gcd(D)
  }, d({
    SS: m,
    DS: f,
    Ss: p
  }), {
    [b1]: e.referToSelf((h) => (D, y, w) => {
      for (var b = h(D, y), g = 0; g < w.length; g++)
        b = h(b, w[g]);
      return b;
    }),
    Array: e.referToSelf((h) => (D) => {
      if (D.length === 1 && Array.isArray(D[0]) && Es(D[0]))
        return h(...D[0]);
      if (Es(D))
        return h(...D);
      throw new ft("gcd() supports only 1d matrices!");
    }),
    Matrix: e.referToSelf((h) => (D) => h(D.toArray()))
  });
  function v(h, D) {
    if (!Ne(h) || !Ne(D))
      throw new Error("Parameters in function gcd must be integer numbers");
    for (var y; D !== 0; )
      y = u(h, D), h = D, D = y;
    return h < 0 ? -h : h;
  }
  function x(h, D) {
    if (!h.isInt() || !D.isInt())
      throw new Error("Parameters in function gcd must be integer numbers");
    for (var y = new l(0); !D.isZero(); ) {
      var w = u(h, D);
      h = D, D = w;
    }
    return h.lt(y) ? h.neg() : h;
  }
}), w1 = "matAlgo06xS0S0", D1 = ["typed", "equalScalar"], oi = /* @__PURE__ */ R(w1, D1, (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return function(a, i, s) {
    var l = a._values, c = a._size, o = a._datatype || a._data === void 0 ? a._datatype : a.getDataType(), u = i._values, f = i._size, m = i._datatype || i._data === void 0 ? i._datatype : i.getDataType();
    if (c.length !== f.length)
      throw new Ue(c.length, f.length);
    if (c[0] !== f[0] || c[1] !== f[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + c + ") must match Matrix B (" + f + ")");
    var p = c[0], d = c[1], v, x = t, h = 0, D = s;
    typeof o == "string" && o === m && o !== "mixed" && (v = o, x = e.find(t, [v, v]), h = e.convert(0, v), D = e.find(s, [v, v]));
    for (var y = l && u ? [] : void 0, w = [], b = [], g = y ? [] : void 0, N = [], S = [], A = 0; A < d; A++) {
      b[A] = w.length;
      var E = A + 1;
      if (Yo(a, A, N, g, S, E, w, D), Yo(i, A, N, g, S, E, w, D), g)
        for (var M = b[A]; M < w.length; ) {
          var T = w[M];
          if (S[T] === E) {
            var B = g[T];
            x(B, h) ? w.splice(M, 1) : (y.push(B), M++);
          } else
            w.splice(M, 1);
        }
      else
        for (var I = b[A]; I < w.length; ) {
          var O = w[I];
          S[O] !== E ? w.splice(I, 1) : I++;
        }
    }
    return b[d] = w.length, a.createSparseMatrix({
      values: y,
      index: w,
      ptr: b,
      size: [p, d],
      datatype: o === a._datatype && m === i._datatype ? v : void 0
    });
  };
}), Ms = "lcm", N1 = ["typed", "matrix", "equalScalar", "concat"], A1 = /* @__PURE__ */ R(Ms, N1, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    concat: a
  } = r, i = Jr({
    typed: e,
    equalScalar: n
  }), s = oi({
    typed: e,
    equalScalar: n
  }), l = br({
    typed: e,
    equalScalar: n
  }), c = rr({
    typed: e,
    matrix: t,
    concat: a
  }), o = "number | BigNumber | Fraction | Matrix | Array", u = {};
  return u["".concat(o, ", ").concat(o, ", ...").concat(o)] = e.referToSelf((m) => (p, d, v) => {
    for (var x = m(p, d), h = 0; h < v.length; h++)
      x = m(x, v[h]);
    return x;
  }), e(Ms, {
    "number, number": Om,
    "BigNumber, BigNumber": f,
    "Fraction, Fraction": (m, p) => m.lcm(p)
  }, c({
    SS: s,
    DS: i,
    Ss: l
  }), u);
  function f(m, p) {
    if (!m.isInt() || !p.isInt())
      throw new Error("Parameters in function lcm must be integer numbers");
    if (m.isZero())
      return m;
    if (p.isZero())
      return p;
    for (var d = m.times(p); !p.isZero(); ) {
      var v = p;
      p = m.mod(v), m = v;
    }
    return d.div(m).abs();
  }
});
function po(r, e, t, n) {
  return function(a) {
    if (a > 0 || t.predictable) {
      if (a <= 0) return NaN;
      var i = a.toString(16), s = i.substring(0, 15);
      return r * (i.length - s.length) + e(+("0x" + s));
    }
    return n(a.toNumber());
  };
}
var Cs = "log10", S1 = ["typed", "config", "Complex"], E1 = $a(16), M1 = /* @__PURE__ */ R(Cs, S1, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n
  } = r;
  function a(s) {
    return s.log().div(Math.LN10);
  }
  function i(s) {
    return a(new n(s, 0));
  }
  return e(Cs, {
    number: function(l) {
      return l >= 0 || t.predictable ? $a(l) : i(l);
    },
    bigint: po(E1, $a, t, i),
    Complex: a,
    BigNumber: function(l) {
      return !l.isNegative() || t.predictable ? l.log() : i(l.toNumber());
    },
    "Array | Matrix": e.referToSelf((s) => (l) => Pe(l, s))
  });
}), _s = "log2", C1 = ["typed", "config", "Complex"], _1 = /* @__PURE__ */ R(_s, C1, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n
  } = r;
  function a(s) {
    return i(new n(s, 0));
  }
  return e(_s, {
    number: function(l) {
      return l >= 0 || t.predictable ? Li(l) : a(l);
    },
    bigint: po(4, Li, t, a),
    Complex: i,
    BigNumber: function(l) {
      return !l.isNegative() || t.predictable ? l.log(2) : a(l.toNumber());
    },
    "Array | Matrix": e.referToSelf((s) => (l) => Pe(l, s))
  });
  function i(s) {
    var l = Math.sqrt(s.re * s.re + s.im * s.im);
    return new n(Math.log2 ? Math.log2(l) : Math.log(l) / Math.LN2, Math.atan2(s.im, s.re) / Math.LN2);
  }
}), T1 = "multiplyScalar", F1 = ["typed"], Mp = /* @__PURE__ */ R(T1, F1, (r) => {
  var {
    typed: e
  } = r;
  return e("multiplyScalar", {
    "number, number": Mm,
    "Complex, Complex": function(n, a) {
      return n.mul(a);
    },
    "BigNumber, BigNumber": function(n, a) {
      return n.times(a);
    },
    "bigint, bigint": function(n, a) {
      return n * a;
    },
    "Fraction, Fraction": function(n, a) {
      return n.mul(a);
    },
    "number | Fraction | BigNumber | Complex, Unit": (t, n) => n.multiply(t),
    "Unit, number | Fraction | BigNumber | Complex | Unit": (t, n) => t.multiply(n)
  });
}), Ts = "multiply", B1 = ["typed", "matrix", "addScalar", "multiplyScalar", "equalScalar", "dot"], Cp = /* @__PURE__ */ R(Ts, B1, (r) => {
  var {
    typed: e,
    matrix: t,
    addScalar: n,
    multiplyScalar: a,
    equalScalar: i,
    dot: s
  } = r, l = br({
    typed: e,
    equalScalar: i
  }), c = Wr({
    typed: e
  });
  function o(b, g) {
    switch (b.length) {
      case 1:
        switch (g.length) {
          case 1:
            if (b[0] !== g[0])
              throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
            break;
          case 2:
            if (b[0] !== g[0])
              throw new RangeError("Dimension mismatch in multiplication. Vector length (" + b[0] + ") must match Matrix rows (" + g[0] + ")");
            break;
          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + g.length + " dimensions)");
        }
        break;
      case 2:
        switch (g.length) {
          case 1:
            if (b[1] !== g[0])
              throw new RangeError("Dimension mismatch in multiplication. Matrix columns (" + b[1] + ") must match Vector length (" + g[0] + ")");
            break;
          case 2:
            if (b[1] !== g[0])
              throw new RangeError("Dimension mismatch in multiplication. Matrix A columns (" + b[1] + ") must match Matrix B rows (" + g[0] + ")");
            break;
          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + g.length + " dimensions)");
        }
        break;
      default:
        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + b.length + " dimensions)");
    }
  }
  function u(b, g, N) {
    if (N === 0)
      throw new Error("Cannot multiply two empty vectors");
    return s(b, g);
  }
  function f(b, g) {
    if (g.storage() !== "dense")
      throw new Error("Support for SparseMatrix not implemented");
    return m(b, g);
  }
  function m(b, g) {
    var N = b._data, S = b._size, A = b._datatype || b.getDataType(), E = g._data, M = g._size, T = g._datatype || g.getDataType(), B = S[0], I = M[1], O, _ = n, P = a;
    A && T && A === T && typeof A == "string" && A !== "mixed" && (O = A, _ = e.find(n, [O, O]), P = e.find(a, [O, O]));
    for (var W = [], L = 0; L < I; L++) {
      for (var J = P(N[0], E[0][L]), ee = 1; ee < B; ee++)
        J = _(J, P(N[ee], E[ee][L]));
      W[L] = J;
    }
    return b.createDenseMatrix({
      data: W,
      size: [I],
      datatype: A === b._datatype && T === g._datatype ? O : void 0
    });
  }
  var p = e("_multiplyMatrixVector", {
    "DenseMatrix, any": v,
    "SparseMatrix, any": D
  }), d = e("_multiplyMatrixMatrix", {
    "DenseMatrix, DenseMatrix": x,
    "DenseMatrix, SparseMatrix": h,
    "SparseMatrix, DenseMatrix": y,
    "SparseMatrix, SparseMatrix": w
  });
  function v(b, g) {
    var N = b._data, S = b._size, A = b._datatype || b.getDataType(), E = g._data, M = g._datatype || g.getDataType(), T = S[0], B = S[1], I, O = n, _ = a;
    A && M && A === M && typeof A == "string" && A !== "mixed" && (I = A, O = e.find(n, [I, I]), _ = e.find(a, [I, I]));
    for (var P = [], W = 0; W < T; W++) {
      for (var L = N[W], J = _(L[0], E[0]), ee = 1; ee < B; ee++)
        J = O(J, _(L[ee], E[ee]));
      P[W] = J;
    }
    return b.createDenseMatrix({
      data: P,
      size: [T],
      datatype: A === b._datatype && M === g._datatype ? I : void 0
    });
  }
  function x(b, g) {
    var N = b._data, S = b._size, A = b._datatype || b.getDataType(), E = g._data, M = g._size, T = g._datatype || g.getDataType(), B = S[0], I = S[1], O = M[1], _, P = n, W = a;
    A && T && A === T && typeof A == "string" && A !== "mixed" && A !== "mixed" && (_ = A, P = e.find(n, [_, _]), W = e.find(a, [_, _]));
    for (var L = [], J = 0; J < B; J++) {
      var ee = N[J];
      L[J] = [];
      for (var F = 0; F < O; F++) {
        for (var G = W(ee[0], E[0][F]), z = 1; z < I; z++)
          G = P(G, W(ee[z], E[z][F]));
        L[J][F] = G;
      }
    }
    return b.createDenseMatrix({
      data: L,
      size: [B, O],
      datatype: A === b._datatype && T === g._datatype ? _ : void 0
    });
  }
  function h(b, g) {
    var N = b._data, S = b._size, A = b._datatype || b.getDataType(), E = g._values, M = g._index, T = g._ptr, B = g._size, I = g._datatype || g._data === void 0 ? g._datatype : g.getDataType();
    if (!E)
      throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");
    var O = S[0], _ = B[1], P, W = n, L = a, J = i, ee = 0;
    A && I && A === I && typeof A == "string" && A !== "mixed" && (P = A, W = e.find(n, [P, P]), L = e.find(a, [P, P]), J = e.find(i, [P, P]), ee = e.convert(0, P));
    for (var F = [], G = [], z = [], le = g.createSparseMatrix({
      values: F,
      index: G,
      ptr: z,
      size: [O, _],
      datatype: A === b._datatype && I === g._datatype ? P : void 0
    }), ne = 0; ne < _; ne++) {
      z[ne] = G.length;
      var ae = T[ne], q = T[ne + 1];
      if (q > ae)
        for (var k = 0, Z = 0; Z < O; Z++) {
          for (var Q = Z + 1, j = void 0, ce = ae; ce < q; ce++) {
            var oe = M[ce];
            k !== Q ? (j = L(N[Z][oe], E[ce]), k = Q) : j = W(j, L(N[Z][oe], E[ce]));
          }
          k === Q && !J(j, ee) && (G.push(Z), F.push(j));
        }
    }
    return z[_] = G.length, le;
  }
  function D(b, g) {
    var N = b._values, S = b._index, A = b._ptr, E = b._datatype || b._data === void 0 ? b._datatype : b.getDataType();
    if (!N)
      throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var M = g._data, T = g._datatype || g.getDataType(), B = b._size[0], I = g._size[0], O = [], _ = [], P = [], W, L = n, J = a, ee = i, F = 0;
    E && T && E === T && typeof E == "string" && E !== "mixed" && (W = E, L = e.find(n, [W, W]), J = e.find(a, [W, W]), ee = e.find(i, [W, W]), F = e.convert(0, W));
    var G = [], z = [];
    P[0] = 0;
    for (var le = 0; le < I; le++) {
      var ne = M[le];
      if (!ee(ne, F))
        for (var ae = A[le], q = A[le + 1], k = ae; k < q; k++) {
          var Z = S[k];
          z[Z] ? G[Z] = L(G[Z], J(ne, N[k])) : (z[Z] = !0, _.push(Z), G[Z] = J(ne, N[k]));
        }
    }
    for (var Q = _.length, j = 0; j < Q; j++) {
      var ce = _[j];
      O[j] = G[ce];
    }
    return P[1] = _.length, b.createSparseMatrix({
      values: O,
      index: _,
      ptr: P,
      size: [B, 1],
      datatype: E === b._datatype && T === g._datatype ? W : void 0
    });
  }
  function y(b, g) {
    var N = b._values, S = b._index, A = b._ptr, E = b._datatype || b._data === void 0 ? b._datatype : b.getDataType();
    if (!N)
      throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var M = g._data, T = g._datatype || g.getDataType(), B = b._size[0], I = g._size[0], O = g._size[1], _, P = n, W = a, L = i, J = 0;
    E && T && E === T && typeof E == "string" && E !== "mixed" && (_ = E, P = e.find(n, [_, _]), W = e.find(a, [_, _]), L = e.find(i, [_, _]), J = e.convert(0, _));
    for (var ee = [], F = [], G = [], z = b.createSparseMatrix({
      values: ee,
      index: F,
      ptr: G,
      size: [B, O],
      datatype: E === b._datatype && T === g._datatype ? _ : void 0
    }), le = [], ne = [], ae = 0; ae < O; ae++) {
      G[ae] = F.length;
      for (var q = ae + 1, k = 0; k < I; k++) {
        var Z = M[k][ae];
        if (!L(Z, J))
          for (var Q = A[k], j = A[k + 1], ce = Q; ce < j; ce++) {
            var oe = S[ce];
            ne[oe] !== q ? (ne[oe] = q, F.push(oe), le[oe] = W(Z, N[ce])) : le[oe] = P(le[oe], W(Z, N[ce]));
          }
      }
      for (var he = G[ae], we = F.length, De = he; De < we; De++) {
        var ye = F[De];
        ee[De] = le[ye];
      }
    }
    return G[O] = F.length, z;
  }
  function w(b, g) {
    var N = b._values, S = b._index, A = b._ptr, E = b._datatype || b._data === void 0 ? b._datatype : b.getDataType(), M = g._values, T = g._index, B = g._ptr, I = g._datatype || g._data === void 0 ? g._datatype : g.getDataType(), O = b._size[0], _ = g._size[1], P = N && M, W, L = n, J = a;
    E && I && E === I && typeof E == "string" && E !== "mixed" && (W = E, L = e.find(n, [W, W]), J = e.find(a, [W, W]));
    for (var ee = P ? [] : void 0, F = [], G = [], z = b.createSparseMatrix({
      values: ee,
      index: F,
      ptr: G,
      size: [O, _],
      datatype: E === b._datatype && I === g._datatype ? W : void 0
    }), le = P ? [] : void 0, ne = [], ae, q, k, Z, Q, j, ce, oe, he = 0; he < _; he++) {
      G[he] = F.length;
      var we = he + 1;
      for (Q = B[he], j = B[he + 1], Z = Q; Z < j; Z++)
        if (oe = T[Z], P)
          for (q = A[oe], k = A[oe + 1], ae = q; ae < k; ae++)
            ce = S[ae], ne[ce] !== we ? (ne[ce] = we, F.push(ce), le[ce] = J(M[Z], N[ae])) : le[ce] = L(le[ce], J(M[Z], N[ae]));
        else
          for (q = A[oe], k = A[oe + 1], ae = q; ae < k; ae++)
            ce = S[ae], ne[ce] !== we && (ne[ce] = we, F.push(ce));
      if (P)
        for (var De = G[he], ye = F.length, Ae = De; Ae < ye; Ae++) {
          var U = F[Ae];
          ee[Ae] = le[U];
        }
    }
    return G[_] = F.length, z;
  }
  return e(Ts, a, {
    // we extend the signatures of multiplyScalar with signatures dealing with matrices
    "Array, Array": e.referTo("Matrix, Matrix", (b) => (g, N) => {
      o(Oe(g), Oe(N));
      var S = b(t(g), t(N));
      return Ee(S) ? S.valueOf() : S;
    }),
    "Matrix, Matrix": function(g, N) {
      var S = g.size(), A = N.size();
      return o(S, A), S.length === 1 ? A.length === 1 ? u(g, N, S[0]) : f(g, N) : A.length === 1 ? p(g, N) : d(g, N);
    },
    "Matrix, Array": e.referTo("Matrix,Matrix", (b) => (g, N) => b(g, t(N))),
    "Array, Matrix": e.referToSelf((b) => (g, N) => b(t(g, N.storage()), N)),
    "SparseMatrix, any": function(g, N) {
      return l(g, N, a, !1);
    },
    "DenseMatrix, any": function(g, N) {
      return c(g, N, a, !1);
    },
    "any, SparseMatrix": function(g, N) {
      return l(N, g, a, !0);
    },
    "any, DenseMatrix": function(g, N) {
      return c(N, g, a, !0);
    },
    "Array, any": function(g, N) {
      return c(t(g), N, a, !1).valueOf();
    },
    "any, Array": function(g, N) {
      return c(t(N), g, a, !0).valueOf();
    },
    "any, any": a,
    "any, any, ...any": e.referToSelf((b) => (g, N, S) => {
      for (var A = b(g, N), E = 0; E < S.length; E++)
        A = b(A, S[E]);
      return A;
    })
  });
}), Fs = "nthRoot", O1 = ["typed", "matrix", "equalScalar", "BigNumber", "concat"], I1 = /* @__PURE__ */ R(Fs, O1, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    BigNumber: a,
    concat: i
  } = r, s = Mt({
    typed: e
  }), l = Jr({
    typed: e,
    equalScalar: n
  }), c = oi({
    typed: e,
    equalScalar: n
  }), o = br({
    typed: e,
    equalScalar: n
  }), u = rr({
    typed: e,
    matrix: t,
    concat: i
  });
  function f() {
    throw new Error("Complex number not supported in function nthRoot. Use nthRoots instead.");
  }
  return e(Fs, {
    number: jo,
    "number, number": jo,
    BigNumber: (p) => m(p, new a(2)),
    "BigNumber, BigNumber": m,
    Complex: f,
    "Complex, number": f,
    Array: e.referTo("DenseMatrix,number", (p) => (d) => p(t(d), 2).valueOf()),
    DenseMatrix: e.referTo("DenseMatrix,number", (p) => (d) => p(d, 2)),
    SparseMatrix: e.referTo("SparseMatrix,number", (p) => (d) => p(d, 2)),
    "SparseMatrix, SparseMatrix": e.referToSelf((p) => (d, v) => {
      if (v.density() === 1)
        return c(d, v, p);
      throw new Error("Root must be non-zero");
    }),
    "DenseMatrix, SparseMatrix": e.referToSelf((p) => (d, v) => {
      if (v.density() === 1)
        return s(d, v, p, !1);
      throw new Error("Root must be non-zero");
    }),
    "Array, SparseMatrix": e.referTo("DenseMatrix,SparseMatrix", (p) => (d, v) => p(t(d), v)),
    "number | BigNumber, SparseMatrix": e.referToSelf((p) => (d, v) => {
      if (v.density() === 1)
        return o(v, d, p, !0);
      throw new Error("Root must be non-zero");
    })
  }, u({
    scalar: "number | BigNumber",
    SD: l,
    Ss: o,
    sS: !1
  }));
  function m(p, d) {
    var v = a.precision, x = a.clone({
      precision: v + 2
    }), h = new a(0), D = new x(1), y = d.isNegative();
    if (y && (d = d.neg()), d.isZero())
      throw new Error("Root must be non-zero");
    if (p.isNegative() && !d.abs().mod(2).equals(1))
      throw new Error("Root must be odd when a is negative.");
    if (p.isZero())
      return y ? new x(1 / 0) : 0;
    if (!p.isFinite())
      return y ? h : p;
    var w = p.abs().pow(D.div(d));
    return w = p.isNeg() ? w.neg() : w, new a((y ? D.div(w) : w).toPrecision(v));
  }
}), Bs = "sign", $1 = ["typed", "BigNumber", "Fraction", "complex"], z1 = /* @__PURE__ */ R(Bs, $1, (r) => {
  var {
    typed: e,
    BigNumber: t,
    complex: n,
    Fraction: a
  } = r;
  return e(Bs, {
    number: ki,
    Complex: function(s) {
      return s.im === 0 ? n(ki(s.re)) : s.sign();
    },
    BigNumber: function(s) {
      return new t(s.cmp(0));
    },
    bigint: function(s) {
      return s > 0n ? 1n : s < 0n ? -1n : 0n;
    },
    Fraction: function(s) {
      return s.n === 0n ? new a(0) : new a(s.s);
    },
    // deep map collection, skip zeros since sign(0) = 0
    "Array | Matrix": e.referToSelf((i) => (s) => Pe(s, i, !0)),
    Unit: e.referToSelf((i) => (s) => {
      if (!s._isDerived() && s.units[0].unit.offset !== 0)
        throw new TypeError("sign is ambiguous for units with offset");
      return e.find(i, s.valueType())(s.value);
    })
  });
}), R1 = "sqrt", q1 = ["config", "typed", "Complex"], P1 = /* @__PURE__ */ R(R1, q1, (r) => {
  var {
    config: e,
    typed: t,
    Complex: n
  } = r;
  return t("sqrt", {
    number: a,
    Complex: function(s) {
      return s.sqrt();
    },
    BigNumber: function(s) {
      return !s.isNegative() || e.predictable ? s.sqrt() : a(s.toNumber());
    },
    Unit: function(s) {
      return s.pow(0.5);
    }
  });
  function a(i) {
    return isNaN(i) ? NaN : i >= 0 || e.predictable ? Math.sqrt(i) : new n(i, 0).sqrt();
  }
}), Os = "square", U1 = ["typed"], L1 = /* @__PURE__ */ R(Os, U1, (r) => {
  var {
    typed: e
  } = r;
  return e(Os, {
    number: Im,
    Complex: function(n) {
      return n.mul(n);
    },
    BigNumber: function(n) {
      return n.times(n);
    },
    bigint: function(n) {
      return n * n;
    },
    Fraction: function(n) {
      return n.mul(n);
    },
    Unit: function(n) {
      return n.pow(2);
    }
  });
}), Is = "subtract", k1 = ["typed", "matrix", "equalScalar", "subtractScalar", "unaryMinus", "DenseMatrix", "concat"], _p = /* @__PURE__ */ R(Is, k1, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    subtractScalar: a,
    unaryMinus: i,
    DenseMatrix: s,
    concat: l
  } = r, c = Mt({
    typed: e
  }), o = Ar({
    typed: e
  }), u = ii({
    typed: e,
    equalScalar: n
  }), f = Lt({
    typed: e,
    DenseMatrix: s
  }), m = cr({
    typed: e,
    DenseMatrix: s
  }), p = rr({
    typed: e,
    matrix: t,
    concat: l
  });
  return e(Is, {
    "any, any": a
  }, p({
    elop: a,
    SS: u,
    DS: c,
    SD: o,
    Ss: m,
    sS: f
  }));
}), $s = "xgcd", H1 = ["typed", "config", "matrix", "BigNumber"], W1 = /* @__PURE__ */ R($s, H1, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    BigNumber: a
  } = r;
  return e($s, {
    "number, number": function(l, c) {
      var o = $m(l, c);
      return t.matrix === "Array" ? o : n(o);
    },
    "BigNumber, BigNumber": i
    // TODO: implement support for Fraction
  });
  function i(s, l) {
    var c, o, u, f = new a(0), m = new a(1), p = f, d = m, v = m, x = f;
    if (!s.isInt() || !l.isInt())
      throw new Error("Parameters in function xgcd must be integer numbers");
    for (; !l.isZero(); )
      o = s.div(l).floor(), u = s.mod(l), c = p, p = d.minus(o.times(p)), d = c, c = v, v = x.minus(o.times(v)), x = c, s = l, l = u;
    var h;
    return s.lt(f) ? h = [s.neg(), d.neg(), x.neg()] : h = [s, s.isZero() ? 0 : d, x], t.matrix === "Array" ? h : n(h);
  }
}), zs = "invmod", G1 = ["typed", "config", "BigNumber", "xgcd", "equal", "smaller", "mod", "add", "isInteger"], V1 = /* @__PURE__ */ R(zs, G1, (r) => {
  var {
    typed: e,
    config: t,
    BigNumber: n,
    xgcd: a,
    equal: i,
    smaller: s,
    mod: l,
    add: c,
    isInteger: o
  } = r;
  return e(zs, {
    "number, number": u,
    "BigNumber, BigNumber": u
  });
  function u(f, m) {
    if (!o(f) || !o(m)) throw new Error("Parameters in function invmod must be integer numbers");
    if (f = l(f, m), i(m, 0)) throw new Error("Divisor must be non zero");
    var p = a(f, m);
    p = p.valueOf();
    var [d, v] = p;
    return i(d, n(1)) ? (v = l(v, m), s(v, n(0)) && (v = c(v, m)), v) : NaN;
  }
}), Z1 = "matAlgo09xS0Sf", X1 = ["typed", "equalScalar"], Tp = /* @__PURE__ */ R(Z1, X1, (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return function(a, i, s) {
    var l = a._values, c = a._index, o = a._ptr, u = a._size, f = a._datatype || a._data === void 0 ? a._datatype : a.getDataType(), m = i._values, p = i._index, d = i._ptr, v = i._size, x = i._datatype || i._data === void 0 ? i._datatype : i.getDataType();
    if (u.length !== v.length)
      throw new Ue(u.length, v.length);
    if (u[0] !== v[0] || u[1] !== v[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + v + ")");
    var h = u[0], D = u[1], y, w = t, b = 0, g = s;
    typeof f == "string" && f === x && f !== "mixed" && (y = f, w = e.find(t, [y, y]), b = e.convert(0, y), g = e.find(s, [y, y]));
    var N = l && m ? [] : void 0, S = [], A = [], E = N ? [] : void 0, M = [], T, B, I, O, _;
    for (B = 0; B < D; B++) {
      A[B] = S.length;
      var P = B + 1;
      if (E)
        for (O = d[B], _ = d[B + 1], I = O; I < _; I++)
          T = p[I], M[T] = P, E[T] = m[I];
      for (O = o[B], _ = o[B + 1], I = O; I < _; I++)
        if (T = c[I], E) {
          var W = M[T] === P ? E[T] : b, L = g(l[I], W);
          w(L, b) || (S.push(T), N.push(L));
        } else
          S.push(T);
    }
    return A[D] = S.length, a.createSparseMatrix({
      values: N,
      index: S,
      ptr: A,
      size: [h, D],
      datatype: f === a._datatype && x === i._datatype ? y : void 0
    });
  };
}), Rs = "dotMultiply", Y1 = ["typed", "matrix", "equalScalar", "multiplyScalar", "concat"], J1 = /* @__PURE__ */ R(Rs, Y1, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    multiplyScalar: a,
    concat: i
  } = r, s = Jr({
    typed: e,
    equalScalar: n
  }), l = Tp({
    typed: e,
    equalScalar: n
  }), c = br({
    typed: e,
    equalScalar: n
  }), o = rr({
    typed: e,
    matrix: t,
    concat: i
  });
  return e(Rs, o({
    elop: a,
    SS: l,
    DS: s,
    Ss: c
  }));
});
function Q1(r, e) {
  if (r.isFinite() && !r.isInteger() || e.isFinite() && !e.isInteger())
    throw new Error("Integers expected in function bitAnd");
  var t = r.constructor;
  if (r.isNaN() || e.isNaN())
    return new t(NaN);
  if (r.isZero() || e.eq(-1) || r.eq(e))
    return r;
  if (e.isZero() || r.eq(-1))
    return e;
  if (!r.isFinite() || !e.isFinite()) {
    if (!r.isFinite() && !e.isFinite())
      return r.isNegative() === e.isNegative() ? r : new t(0);
    if (!r.isFinite())
      return e.isNegative() ? r : r.isNegative() ? new t(0) : e;
    if (!e.isFinite())
      return r.isNegative() ? e : e.isNegative() ? new t(0) : r;
  }
  return vo(r, e, function(n, a) {
    return n & a;
  });
}
function Bn(r) {
  if (r.isFinite() && !r.isInteger())
    throw new Error("Integer expected in function bitNot");
  var e = r.constructor, t = e.precision;
  e.config({
    precision: 1e9
  });
  var n = r.plus(new e(1));
  return n.s = -n.s || null, e.config({
    precision: t
  }), n;
}
function j1(r, e) {
  if (r.isFinite() && !r.isInteger() || e.isFinite() && !e.isInteger())
    throw new Error("Integers expected in function bitOr");
  var t = r.constructor;
  if (r.isNaN() || e.isNaN())
    return new t(NaN);
  var n = new t(-1);
  return r.isZero() || e.eq(n) || r.eq(e) ? e : e.isZero() || r.eq(n) ? r : !r.isFinite() || !e.isFinite() ? !r.isFinite() && !r.isNegative() && e.isNegative() || r.isNegative() && !e.isNegative() && !e.isFinite() ? n : r.isNegative() && e.isNegative() ? r.isFinite() ? r : e : r.isFinite() ? e : r : vo(r, e, function(a, i) {
    return a | i;
  });
}
function vo(r, e, t) {
  var n = r.constructor, a, i, s = +(r.s < 0), l = +(e.s < 0);
  if (s) {
    a = Vn(Bn(r));
    for (var c = 0; c < a.length; ++c)
      a[c] ^= 1;
  } else
    a = Vn(r);
  if (l) {
    i = Vn(Bn(e));
    for (var o = 0; o < i.length; ++o)
      i[o] ^= 1;
  } else
    i = Vn(e);
  var u, f, m;
  a.length <= i.length ? (u = a, f = i, m = s) : (u = i, f = a, m = l);
  var p = u.length, d = f.length, v = t(s, l) ^ 1, x = new n(v ^ 1), h = new n(1), D = new n(2), y = n.precision;
  for (n.config({
    precision: 1e9
  }); p > 0; )
    t(u[--p], f[--d]) === v && (x = x.plus(h)), h = h.times(D);
  for (; d > 0; )
    t(m, f[--d]) === v && (x = x.plus(h)), h = h.times(D);
  return n.config({
    precision: y
  }), v === 0 && (x.s = -x.s), x;
}
function Vn(r) {
  for (var e = r.d, t = e[0] + "", n = 1; n < e.length; ++n) {
    for (var a = e[n] + "", i = 7 - a.length; i--; )
      a = "0" + a;
    t += a;
  }
  for (var s = t.length; t.charAt(s) === "0"; )
    s--;
  var l = r.e, c = t.slice(0, s + 1 || 1), o = c.length;
  if (l > 0)
    if (++l > o)
      for (l -= o; l--; )
        c += "0";
    else l < o && (c = c.slice(0, l) + "." + c.slice(l));
  for (var u = [0], f = 0; f < c.length; ) {
    for (var m = u.length; m--; )
      u[m] *= 10;
    u[0] += parseInt(c.charAt(f++));
    for (var p = 0; p < u.length; ++p)
      u[p] > 1 && ((u[p + 1] === null || u[p + 1] === void 0) && (u[p + 1] = 0), u[p + 1] += u[p] >> 1, u[p] &= 1);
  }
  return u.reverse();
}
function K1(r, e) {
  if (r.isFinite() && !r.isInteger() || e.isFinite() && !e.isInteger())
    throw new Error("Integers expected in function bitXor");
  var t = r.constructor;
  if (r.isNaN() || e.isNaN())
    return new t(NaN);
  if (r.isZero())
    return e;
  if (e.isZero())
    return r;
  if (r.eq(e))
    return new t(0);
  var n = new t(-1);
  return r.eq(n) ? Bn(e) : e.eq(n) ? Bn(r) : !r.isFinite() || !e.isFinite() ? !r.isFinite() && !e.isFinite() ? n : new t(r.isNegative() === e.isNegative() ? 1 / 0 : -1 / 0) : vo(r, e, function(a, i) {
    return a ^ i;
  });
}
function ey(r, e) {
  if (r.isFinite() && !r.isInteger() || e.isFinite() && !e.isInteger())
    throw new Error("Integers expected in function leftShift");
  var t = r.constructor;
  return r.isNaN() || e.isNaN() || e.isNegative() && !e.isZero() ? new t(NaN) : r.isZero() || e.isZero() ? r : !r.isFinite() && !e.isFinite() ? new t(NaN) : e.lt(55) ? r.times(Math.pow(2, e.toNumber()) + "") : r.times(new t(2).pow(e));
}
function ry(r, e) {
  if (r.isFinite() && !r.isInteger() || e.isFinite() && !e.isInteger())
    throw new Error("Integers expected in function rightArithShift");
  var t = r.constructor;
  return r.isNaN() || e.isNaN() || e.isNegative() && !e.isZero() ? new t(NaN) : r.isZero() || e.isZero() ? r : e.isFinite() ? e.lt(55) ? r.div(Math.pow(2, e.toNumber()) + "").floor() : r.div(new t(2).pow(e)).floor() : r.isNegative() ? new t(-1) : r.isFinite() ? new t(0) : new t(NaN);
}
var qs = "bitAnd", ty = ["typed", "matrix", "equalScalar", "concat"], Fp = /* @__PURE__ */ R(qs, ty, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    concat: a
  } = r, i = Jr({
    typed: e,
    equalScalar: n
  }), s = oi({
    typed: e,
    equalScalar: n
  }), l = br({
    typed: e,
    equalScalar: n
  }), c = rr({
    typed: e,
    matrix: t,
    concat: a
  });
  return e(qs, {
    "number, number": Rm,
    "BigNumber, BigNumber": Q1,
    "bigint, bigint": (o, u) => o & u
  }, c({
    SS: s,
    DS: i,
    Ss: l
  }));
}), Ps = "bitNot", ny = ["typed"], ay = /* @__PURE__ */ R(Ps, ny, (r) => {
  var {
    typed: e
  } = r;
  return e(Ps, {
    number: qm,
    BigNumber: Bn,
    bigint: (t) => ~t,
    "Array | Matrix": e.referToSelf((t) => (n) => Pe(n, t))
  });
}), Us = "bitOr", iy = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], Bp = /* @__PURE__ */ R(Us, iy, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    DenseMatrix: a,
    concat: i
  } = r, s = Mt({
    typed: e
  }), l = mo({
    typed: e,
    equalScalar: n
  }), c = Lt({
    typed: e,
    DenseMatrix: a
  }), o = rr({
    typed: e,
    matrix: t,
    concat: i
  });
  return e(Us, {
    "number, number": Pm,
    "BigNumber, BigNumber": j1,
    "bigint, bigint": (u, f) => u | f
  }, o({
    SS: l,
    DS: s,
    Ss: c
  }));
}), oy = "matAlgo07xSSf", sy = ["typed", "SparseMatrix"], tt = /* @__PURE__ */ R(oy, sy, (r) => {
  var {
    typed: e,
    SparseMatrix: t
  } = r;
  return function(i, s, l) {
    var c = i._size, o = i._datatype || i._data === void 0 ? i._datatype : i.getDataType(), u = s._size, f = s._datatype || s._data === void 0 ? s._datatype : s.getDataType();
    if (c.length !== u.length)
      throw new Ue(c.length, u.length);
    if (c[0] !== u[0] || c[1] !== u[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + c + ") must match Matrix B (" + u + ")");
    var m = c[0], p = c[1], d, v = 0, x = l;
    typeof o == "string" && o === f && o !== "mixed" && (d = o, v = e.convert(0, d), x = e.find(l, [d, d]));
    for (var h = [], D = [], y = new Array(p + 1).fill(0), w = [], b = [], g = [], N = [], S = 0; S < p; S++) {
      var A = S + 1, E = 0;
      n(i, S, g, w, A), n(s, S, N, b, A);
      for (var M = 0; M < m; M++) {
        var T = g[M] === A ? w[M] : v, B = N[M] === A ? b[M] : v, I = x(T, B);
        I !== 0 && I !== !1 && (D.push(M), h.push(I), E++);
      }
      y[S + 1] = y[S] + E;
    }
    return new t({
      values: h,
      index: D,
      ptr: y,
      size: [m, p],
      datatype: o === i._datatype && f === s._datatype ? d : void 0
    });
  };
  function n(a, i, s, l, c) {
    for (var o = a._values, u = a._index, f = a._ptr, m = f[i], p = f[i + 1]; m < p; m++) {
      var d = u[m];
      s[d] = c, l[d] = o[m];
    }
  }
}), Ls = "bitXor", uy = ["typed", "matrix", "DenseMatrix", "concat", "SparseMatrix"], cy = /* @__PURE__ */ R(Ls, uy, (r) => {
  var {
    typed: e,
    matrix: t,
    DenseMatrix: n,
    concat: a,
    SparseMatrix: i
  } = r, s = Ar({
    typed: e
  }), l = tt({
    typed: e,
    SparseMatrix: i
  }), c = cr({
    typed: e,
    DenseMatrix: n
  }), o = rr({
    typed: e,
    matrix: t,
    concat: a
  });
  return e(Ls, {
    "number, number": Um,
    "BigNumber, BigNumber": K1,
    "bigint, bigint": (u, f) => u ^ f
  }, o({
    SS: l,
    DS: s,
    Ss: c
  }));
}), ks = "arg", ly = ["typed"], fy = /* @__PURE__ */ R(ks, ly, (r) => {
  var {
    typed: e
  } = r;
  return e(ks, {
    number: function(n) {
      return Math.atan2(0, n);
    },
    BigNumber: function(n) {
      return n.constructor.atan2(0, n);
    },
    Complex: function(n) {
      return n.arg();
    },
    // TODO: implement BigNumber support for function arg
    "Array | Matrix": e.referToSelf((t) => (n) => Pe(n, t))
  });
}), Hs = "conj", my = ["typed"], Op = /* @__PURE__ */ R(Hs, my, (r) => {
  var {
    typed: e
  } = r;
  return e(Hs, {
    "number | BigNumber | Fraction": (t) => t,
    Complex: (t) => t.conjugate(),
    Unit: e.referToSelf((t) => (n) => new n.constructor(t(n.toNumeric()), n.formatUnits())),
    "Array | Matrix": e.referToSelf((t) => (n) => Pe(n, t))
  });
}), Ws = "im", py = ["typed"], dy = /* @__PURE__ */ R(Ws, py, (r) => {
  var {
    typed: e
  } = r;
  return e(Ws, {
    number: () => 0,
    "BigNumber | Fraction": (t) => t.mul(0),
    Complex: (t) => t.im,
    "Array | Matrix": e.referToSelf((t) => (n) => Pe(n, t))
  });
}), Gs = "re", vy = ["typed"], hy = /* @__PURE__ */ R(Gs, vy, (r) => {
  var {
    typed: e
  } = r;
  return e(Gs, {
    "number | BigNumber | Fraction": (t) => t,
    Complex: (t) => t.re,
    "Array | Matrix": e.referToSelf((t) => (n) => Pe(n, t))
  });
}), Vs = "not", gy = ["typed"], yy = /* @__PURE__ */ R(Vs, gy, (r) => {
  var {
    typed: e
  } = r;
  return e(Vs, {
    "null | undefined": () => !0,
    number: Gm,
    Complex: function(n) {
      return n.re === 0 && n.im === 0;
    },
    BigNumber: function(n) {
      return n.isZero() || n.isNaN();
    },
    bigint: (t) => !t,
    Unit: e.referToSelf((t) => (n) => e.find(t, n.valueType())(n.value)),
    "Array | Matrix": e.referToSelf((t) => (n) => Pe(n, t))
  });
}), Zs = "nullish", by = ["typed", "matrix", "size", "flatten", "deepEqual"], Ip = /* @__PURE__ */ R(Zs, by, (r) => {
  var {
    typed: e,
    matrix: t,
    size: n,
    flatten: a,
    deepEqual: i
  } = r, s = Ar({
    typed: e
  }), l = Wr({
    typed: e
  }), c = Sp({
    typed: e
  });
  return e(Zs, {
    // Scalar and SparseMatrix-first short-circuit handlers
    "number|bigint|Complex|BigNumber|Fraction|Unit|string|boolean|SparseMatrix, any": (o, u) => o,
    "null, any": (o, u) => u,
    "undefined, any": (o, u) => u,
    // SparseMatrix-first with collection RHS: enforce exact shape match
    "SparseMatrix, Array | Matrix": (o, u) => {
      var f = a(n(o).valueOf()), m = a(n(u).valueOf());
      if (i(f, m)) return o;
      throw new Ue(f, m);
    },
    // DenseMatrix-first handlers (no broadcasting between collections)
    "DenseMatrix, DenseMatrix": e.referToSelf((o) => (u, f) => c(u, f, o)),
    "DenseMatrix, SparseMatrix": e.referToSelf((o) => (u, f) => s(u, f, o, !1)),
    "DenseMatrix, Array": e.referToSelf((o) => (u, f) => c(u, t(f), o)),
    "DenseMatrix, any": e.referToSelf((o) => (u, f) => l(u, f, o, !1)),
    // Array-first handlers (bridge via matrix() where needed)
    "Array, Array": e.referToSelf((o) => (u, f) => c(t(u), t(f), o).valueOf()),
    "Array, DenseMatrix": e.referToSelf((o) => (u, f) => c(t(u), f, o)),
    "Array, SparseMatrix": e.referToSelf((o) => (u, f) => s(t(u), f, o, !1)),
    "Array, any": e.referToSelf((o) => (u, f) => l(t(u), f, o, !1).valueOf())
  });
}), Xs = "or", xy = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], $p = /* @__PURE__ */ R(Xs, xy, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    DenseMatrix: a,
    concat: i
  } = r, s = Ar({
    typed: e
  }), l = ii({
    typed: e,
    equalScalar: n
  }), c = cr({
    typed: e,
    DenseMatrix: a
  }), o = rr({
    typed: e,
    matrix: t,
    concat: i
  });
  return e(Xs, {
    "number, number": Hi,
    "Complex, Complex": function(f, m) {
      return f.re !== 0 || f.im !== 0 || m.re !== 0 || m.im !== 0;
    },
    "BigNumber, BigNumber": function(f, m) {
      return !f.isZero() && !f.isNaN() || !m.isZero() && !m.isNaN();
    },
    "bigint, bigint": Hi,
    "Unit, Unit": e.referToSelf((u) => (f, m) => u(f.value || 0, m.value || 0))
  }, o({
    SS: l,
    DS: s,
    Ss: c
  }));
}), Ys = "xor", wy = ["typed", "matrix", "DenseMatrix", "concat", "SparseMatrix"], Dy = /* @__PURE__ */ R(Ys, wy, (r) => {
  var {
    typed: e,
    matrix: t,
    DenseMatrix: n,
    concat: a,
    SparseMatrix: i
  } = r, s = Ar({
    typed: e
  }), l = tt({
    typed: e,
    SparseMatrix: i
  }), c = cr({
    typed: e,
    DenseMatrix: n
  }), o = rr({
    typed: e,
    matrix: t,
    concat: a
  });
  return e(Ys, {
    "number, number": Wi,
    "Complex, Complex": function(f, m) {
      return (f.re !== 0 || f.im !== 0) != (m.re !== 0 || m.im !== 0);
    },
    "bigint, bigint": Wi,
    "BigNumber, BigNumber": function(f, m) {
      return (!f.isZero() && !f.isNaN()) != (!m.isZero() && !m.isNaN());
    },
    "Unit, Unit": e.referToSelf((u) => (f, m) => u(f.value || 0, m.value || 0))
  }, o({
    SS: l,
    DS: s,
    Ss: c
  }));
}), Js = "concat", Ny = ["typed", "matrix", "isInteger"], ho = /* @__PURE__ */ R(Js, Ny, (r) => {
  var {
    typed: e,
    matrix: t,
    isInteger: n
  } = r;
  return e(Js, {
    // TODO: change signature to '...Array | Matrix, dim?' when supported
    "...Array | Matrix | number | BigNumber": function(i) {
      var s, l = i.length, c = -1, o, u = !1, f = [];
      for (s = 0; s < l; s++) {
        var m = i[s];
        if (Ee(m) && (u = !0), Re(m) || $e(m)) {
          if (s !== l - 1)
            throw new Error("Dimension must be specified as last argument");
          if (o = c, c = m.valueOf(), !n(c))
            throw new TypeError("Integer number expected for dimension");
          if (c < 0 || s > 0 && c > o)
            throw new Hr(c, o + 1);
        } else {
          var p = Te(m).valueOf(), d = Oe(p);
          if (f[s] = p, o = c, c = d.length - 1, s > 0 && c !== o)
            throw new Ue(o + 1, c + 1);
        }
      }
      if (f.length === 0)
        throw new SyntaxError("At least one matrix expected");
      for (var v = f.shift(); f.length; )
        v = ym(v, f.shift(), c);
      return u ? t(v) : v;
    },
    "...string": function(i) {
      return i.join("");
    }
  });
}), Qs = "column", Ay = ["typed", "Index", "matrix", "range"], zp = /* @__PURE__ */ R(Qs, Ay, (r) => {
  var {
    typed: e,
    Index: t,
    matrix: n,
    range: a
  } = r;
  return e(Qs, {
    "Matrix, number": i,
    "Array, number": function(l, c) {
      return i(n(Te(l)), c).valueOf();
    }
  });
  function i(s, l) {
    if (s.size().length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    er(l, s.size()[1]);
    var c = a(0, s.size()[0]), o = new t(c, l), u = s.subset(o);
    return Ee(u) ? u : n([[u]]);
  }
}), js = "count", Sy = ["typed", "size", "prod"], Ey = /* @__PURE__ */ R(js, Sy, (r) => {
  var {
    typed: e,
    size: t,
    prod: n
  } = r;
  return e(js, {
    string: function(i) {
      return i.length;
    },
    "Matrix | Array": function(i) {
      return n(t(i));
    }
  });
}), Ks = "cross", My = ["typed", "matrix", "subtract", "multiply"], Cy = /* @__PURE__ */ R(Ks, My, (r) => {
  var {
    typed: e,
    matrix: t,
    subtract: n,
    multiply: a
  } = r;
  return e(Ks, {
    "Matrix, Matrix": function(l, c) {
      return t(i(l.toArray(), c.toArray()));
    },
    "Matrix, Array": function(l, c) {
      return t(i(l.toArray(), c));
    },
    "Array, Matrix": function(l, c) {
      return t(i(l, c.toArray()));
    },
    "Array, Array": i
  });
  function i(s, l) {
    var c = Math.max(Oe(s).length, Oe(l).length);
    s = Ta(s), l = Ta(l);
    var o = Oe(s), u = Oe(l);
    if (o.length !== 1 || u.length !== 1 || o[0] !== 3 || u[0] !== 3)
      throw new RangeError("Vectors with length 3 expected (Size A = [" + o.join(", ") + "], B = [" + u.join(", ") + "])");
    var f = [n(a(s[1], l[2]), a(s[2], l[1])), n(a(s[2], l[0]), a(s[0], l[2])), n(a(s[0], l[1]), a(s[1], l[0]))];
    return c > 1 ? [f] : f;
  }
}), eu = "diag", _y = ["typed", "matrix", "DenseMatrix", "SparseMatrix"], Ty = /* @__PURE__ */ R(eu, _y, (r) => {
  var {
    typed: e,
    matrix: t,
    DenseMatrix: n,
    SparseMatrix: a
  } = r;
  return e(eu, {
    // FIXME: simplify this huge amount of signatures as soon as typed-function supports optional arguments
    Array: function(o) {
      return i(o, 0, Oe(o), null);
    },
    "Array, number": function(o, u) {
      return i(o, u, Oe(o), null);
    },
    "Array, BigNumber": function(o, u) {
      return i(o, u.toNumber(), Oe(o), null);
    },
    "Array, string": function(o, u) {
      return i(o, 0, Oe(o), u);
    },
    "Array, number, string": function(o, u, f) {
      return i(o, u, Oe(o), f);
    },
    "Array, BigNumber, string": function(o, u, f) {
      return i(o, u.toNumber(), Oe(o), f);
    },
    Matrix: function(o) {
      return i(o, 0, o.size(), o.storage());
    },
    "Matrix, number": function(o, u) {
      return i(o, u, o.size(), o.storage());
    },
    "Matrix, BigNumber": function(o, u) {
      return i(o, u.toNumber(), o.size(), o.storage());
    },
    "Matrix, string": function(o, u) {
      return i(o, 0, o.size(), u);
    },
    "Matrix, number, string": function(o, u, f) {
      return i(o, u, o.size(), f);
    },
    "Matrix, BigNumber, string": function(o, u, f) {
      return i(o, u.toNumber(), o.size(), f);
    }
  });
  function i(c, o, u, f) {
    if (!Ne(o))
      throw new TypeError("Second parameter in function diag must be an integer");
    var m = o > 0 ? o : 0, p = o < 0 ? -o : 0;
    switch (u.length) {
      case 1:
        return s(c, o, f, u[0], p, m);
      case 2:
        return l(c, o, f, u, p, m);
    }
    throw new RangeError("Matrix for function diag must be 2 dimensional");
  }
  function s(c, o, u, f, m, p) {
    var d = [f + m, f + p];
    if (u && u !== "sparse" && u !== "dense")
      throw new TypeError("Unknown matrix type ".concat(u, '"'));
    var v = u === "sparse" ? a.diagonal(d, c, o) : n.diagonal(d, c, o);
    return u !== null ? v : v.valueOf();
  }
  function l(c, o, u, f, m, p) {
    if (Ee(c)) {
      var d = c.diagonal(o);
      return u !== null ? u !== d.storage() ? t(d, u) : d : d.valueOf();
    }
    for (var v = Math.min(f[0] - m, f[1] - p), x = [], h = 0; h < v; h++)
      x[h] = c[h + m][h + p];
    return u !== null ? t(x) : x;
  }
}), Fy = "filter", By = ["typed"], Rp = /* @__PURE__ */ R(Fy, By, (r) => {
  var {
    typed: e
  } = r;
  return e("filter", {
    "Array, function": ru,
    "Matrix, function": function(n, a) {
      return n.create(ru(n.valueOf(), a), n.datatype());
    },
    "Array, RegExp": Go,
    "Matrix, RegExp": function(n, a) {
      return n.create(Go(n.valueOf(), a), n.datatype());
    }
  });
});
function ru(r, e) {
  var t = zt(e, r, "filter");
  return t.isUnary ? Wo(r, t.fn) : Wo(r, function(n, a, i) {
    return t.fn(n, [a], i);
  });
}
var tu = "flatten", Oy = ["typed"], Iy = /* @__PURE__ */ R(tu, Oy, (r) => {
  var {
    typed: e
  } = r;
  return e(tu, {
    Array: function(n) {
      return Ve(n);
    },
    Matrix: function(n) {
      return n.create(Ve(n.valueOf(), !0), n.datatype());
    }
  });
}), Ji = "forEach", $y = ["typed"], qp = /* @__PURE__ */ R(Ji, $y, (r) => {
  var {
    typed: e
  } = r;
  return e(Ji, {
    "Array, function": zy,
    "Matrix, function": function(n, a) {
      n.forEach(a);
    }
  });
});
function zy(r, e) {
  var t = zt(e, r, Ji);
  xm(r, t.fn, t.isUnary);
}
var nu = "getMatrixDataType", Ry = ["typed"], Pp = /* @__PURE__ */ R(nu, Ry, (r) => {
  var {
    typed: e
  } = r;
  return e(nu, {
    Array: function(n) {
      return ni(n, Ke);
    },
    Matrix: function(n) {
      return n.getDataType();
    }
  });
}), au = "identity", qy = ["typed", "config", "matrix", "BigNumber", "DenseMatrix", "SparseMatrix"], Up = /* @__PURE__ */ R(au, qy, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    BigNumber: a,
    DenseMatrix: i,
    SparseMatrix: s
  } = r;
  return e(au, {
    "": function() {
      return t.matrix === "Matrix" ? n([]) : [];
    },
    string: function(u) {
      return n(u);
    },
    "number | BigNumber": function(u) {
      return c(u, u, t.matrix === "Matrix" ? "dense" : void 0);
    },
    "number | BigNumber, string": function(u, f) {
      return c(u, u, f);
    },
    "number | BigNumber, number | BigNumber": function(u, f) {
      return c(u, f, t.matrix === "Matrix" ? "dense" : void 0);
    },
    "number | BigNumber, number | BigNumber, string": function(u, f, m) {
      return c(u, f, m);
    },
    Array: function(u) {
      return l(u);
    },
    "Array, string": function(u, f) {
      return l(u, f);
    },
    Matrix: function(u) {
      return l(u.valueOf(), u.storage());
    },
    "Matrix, string": function(u, f) {
      return l(u.valueOf(), f);
    }
  });
  function l(o, u) {
    switch (o.length) {
      case 0:
        return u ? n(u) : [];
      case 1:
        return c(o[0], o[0], u);
      case 2:
        return c(o[0], o[1], u);
      default:
        throw new Error("Vector containing two values expected");
    }
  }
  function c(o, u, f) {
    var m = $e(o) || $e(u) ? a : null;
    if ($e(o) && (o = o.toNumber()), $e(u) && (u = u.toNumber()), !Ne(o) || o < 1)
      throw new Error("Parameters in function identity must be positive integers");
    if (!Ne(u) || u < 1)
      throw new Error("Parameters in function identity must be positive integers");
    var p = m ? new a(1) : 1, d = m ? new m(0) : 0, v = [o, u];
    if (f) {
      if (f === "sparse")
        return s.diagonal(v, p, 0, d);
      if (f === "dense")
        return i.diagonal(v, p, 0, d);
      throw new TypeError('Unknown matrix type "'.concat(f, '"'));
    }
    for (var x = un([], v, d), h = o < u ? o : u, D = 0; D < h; D++)
      x[D][D] = p;
    return x;
  }
}), iu = "kron", Py = ["typed", "matrix", "multiplyScalar"], Uy = /* @__PURE__ */ R(iu, Py, (r) => {
  var {
    typed: e,
    matrix: t,
    multiplyScalar: n
  } = r;
  return e(iu, {
    "Matrix, Matrix": function(s, l) {
      return t(a(s.toArray(), l.toArray()));
    },
    "Matrix, Array": function(s, l) {
      return t(a(s.toArray(), l));
    },
    "Array, Matrix": function(s, l) {
      return t(a(s, l.toArray()));
    },
    "Array, Array": a
  });
  function a(i, s) {
    if (Oe(i).length === 1 && (i = [i]), Oe(s).length === 1 && (s = [s]), Oe(i).length > 2 || Oe(s).length > 2)
      throw new RangeError("Vectors with dimensions greater then 2 are not supported expected (Size x = " + JSON.stringify(i.length) + ", y = " + JSON.stringify(s.length) + ")");
    var l = [], c = [];
    return i.map(function(o) {
      return s.map(function(u) {
        return c = [], l.push(c), o.map(function(f) {
          return u.map(function(m) {
            return c.push(n(f, m));
          });
        });
      });
    }) && l;
  }
}), xi = "map", Ly = ["typed"], Lp = /* @__PURE__ */ R(xi, Ly, (r) => {
  var {
    typed: e
  } = r;
  return e(xi, {
    "Array, function": l,
    "Matrix, function": function(o, u) {
      return o.map(u);
    },
    "Array|Matrix, Array|Matrix, ...Array|Matrix|function": (c, o, u) => t([c, o, ...u.slice(0, u.length - 1)], u[u.length - 1])
  });
  function t(c, o) {
    if (typeof o != "function")
      throw new Error("Last argument must be a callback function");
    var u = c[0].isMatrix, f = c.map((b) => b.isMatrix ? b.size() : Oe(b)), m = Ba(...f), p = c.length, d = u ? (b, g) => b.get(g) : Oa, v = c.map((b, g) => {
      var N = f[g].map(() => 0);
      return b.isMatrix ? b.get(N) : Oa(b, N);
    }), x = e.isTypedFunction(o) ? s(o, v, m.map(() => 0), c) : i(o, p);
    if (x < 2) {
      var h = a(x, o, null);
      return n(c, h);
    }
    var D = u ? c.map((b) => b.isMatrix ? b.create(Ot(b.toArray(), m), b.datatype()) : c[0].create(Ot(b.valueOf(), m))) : c.map((b) => b.isMatrix ? Ot(b.toArray(), m) : Ot(b, m)), y = a(x, o, D), w = (b, g) => y([b, ...D.slice(1).map((N) => d(N, g))], g);
    return u ? D[0].map(w) : l(D[0], w);
  }
  function n(c, o) {
    var u = c[0], f = c.map((b) => b.isMatrix ? b.valueOf() : b), m = c.map((b) => b.isMatrix ? b.size() : Oe(b)), p = Ba(...m), d = m.map((b) => p.length - b.length), v = p.length - 1, x = o.length > 1, h = x ? [] : null, D = w(f, 0);
    if (u.isMatrix) {
      var y = u.create();
      return y._data = D, y._size = p, y;
    } else
      return D;
    function w(b) {
      var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, N = p[g], S = Array(N);
      if (g < v)
        for (var A = function(I) {
          h && (h[g] = I), S[I] = w(b.map((O, _) => d[_] > g ? O : O.length === 1 ? O[0] : O[I]), g + 1);
        }, E = 0; E < N; E++)
          A(E);
      else
        for (var M = function(I) {
          h && (h[g] = I), S[I] = o(b.map((O) => O.length === 1 ? O[0] : O[I]), h ? h.slice() : void 0);
        }, T = 0; T < N; T++)
          M(T);
      return S;
    }
  }
  function a(c, o, u) {
    switch (c) {
      case 0:
        return (f) => o(...f);
      case 1:
        return (f, m) => o(...f, m);
      case 2:
        return (f, m) => o(...f, m, ...u);
    }
  }
  function i(c, o) {
    var u = c.toString();
    if (/arguments/.test(u)) return 2;
    var f = u.match(/\(.*?\)/);
    return /\.\.\./.test(f) || c.length > o + 1 ? 2 : c.length === o + 1 ? 1 : 0;
  }
  function s(c, o, u, f) {
    return e.resolve(c, [...o, u, ...f]) !== null ? 2 : e.resolve(c, [...o, u]) !== null ? 1 : (e.resolve(c, o) !== null, 0);
  }
  function l(c, o) {
    var u = zt(o, c, xi);
    return Ui(c, u.fn, u.isUnary);
  }
}), ou = "diff", ky = ["typed", "matrix", "subtract", "number"], kp = /* @__PURE__ */ R(ou, ky, (r) => {
  var {
    typed: e,
    matrix: t,
    subtract: n,
    number: a
  } = r;
  return e(ou, {
    "Array | Matrix": function(u) {
      return Ee(u) ? t(s(u.toArray())) : s(u);
    },
    "Array | Matrix, number": function(u, f) {
      if (!Ne(f)) throw new RangeError("Dimension must be a whole number");
      return Ee(u) ? t(i(u.toArray(), f)) : i(u, f);
    },
    "Array, BigNumber": e.referTo("Array,number", (o) => (u, f) => o(u, a(f))),
    "Matrix, BigNumber": e.referTo("Matrix,number", (o) => (u, f) => o(u, a(f)))
  });
  function i(o, u) {
    if (Ee(o) && (o = o.toArray()), !Array.isArray(o))
      throw RangeError("Array/Matrix does not have that many dimensions");
    if (u > 0) {
      var f = [];
      return o.forEach((m) => {
        f.push(i(m, u - 1));
      }), f;
    } else {
      if (u === 0)
        return s(o);
      throw RangeError("Cannot have negative dimension");
    }
  }
  function s(o) {
    for (var u = [], f = o.length, m = 1; m < f; m++)
      u.push(l(o[m - 1], o[m]));
    return u;
  }
  function l(o, u) {
    Ee(o) && (o = o.toArray()), Ee(u) && (u = u.toArray());
    var f = Array.isArray(o), m = Array.isArray(u);
    if (f && m)
      return c(o, u);
    if (!f && !m)
      return n(u, o);
    throw TypeError("Cannot calculate difference between 1 array and 1 non-array");
  }
  function c(o, u) {
    if (o.length !== u.length)
      throw RangeError("Not all sub-arrays have the same length");
    for (var f = [], m = o.length, p = 0; p < m; p++)
      f.push(l(o[p], u[p]));
    return f;
  }
}), Hy = "ones", Wy = ["typed", "config", "matrix", "BigNumber"], Gy = /* @__PURE__ */ R(Hy, Wy, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    BigNumber: a
  } = r;
  return e("ones", {
    "": function() {
      return t.matrix === "Array" ? i([]) : i([], "default");
    },
    // math.ones(m, n, p, ..., format)
    // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
    "...number | BigNumber | string": function(o) {
      var u = o[o.length - 1];
      if (typeof u == "string") {
        var f = o.pop();
        return i(o, f);
      } else return t.matrix === "Array" ? i(o) : i(o, "default");
    },
    Array: i,
    Matrix: function(o) {
      var u = o.storage();
      return i(o.valueOf(), u);
    },
    "Array | Matrix, string": function(o, u) {
      return i(o.valueOf(), u);
    }
  });
  function i(c, o) {
    var u = s(c), f = u ? new a(1) : 1;
    if (l(c), o) {
      var m = n(o);
      return c.length > 0 ? m.resize(c, f) : m;
    } else {
      var p = [];
      return c.length > 0 ? un(p, c, f) : p;
    }
  }
  function s(c) {
    var o = !1;
    return c.forEach(function(u, f, m) {
      $e(u) && (o = !0, m[f] = u.toNumber());
    }), o;
  }
  function l(c) {
    c.forEach(function(o) {
      if (typeof o != "number" || !Ne(o) || o < 0)
        throw new Error("Parameters in function ones must be positive integers");
    });
  }
});
function go() {
  throw new Error('No "bignumber" implementation available');
}
function Hp() {
  throw new Error('No "fraction" implementation available');
}
function Wp() {
  throw new Error('No "matrix" implementation available');
}
var su = "range", Vy = ["typed", "config", "?matrix", "?bignumber", "equal", "smaller", "smallerEq", "larger", "largerEq", "add", "isZero", "isPositive"], Gp = /* @__PURE__ */ R(su, Vy, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    bignumber: a,
    smaller: i,
    smallerEq: s,
    larger: l,
    largerEq: c,
    add: o,
    isZero: u,
    isPositive: f
  } = r;
  return e(su, {
    // TODO: simplify signatures when typed-function supports default values and optional arguments
    string: p,
    "string, boolean": p,
    number: function(h) {
      throw new TypeError("Too few arguments to function range(): ".concat(h));
    },
    boolean: function(h) {
      throw new TypeError("Unexpected type of argument 1 to function range(): ".concat(h, ", number|bigint|BigNumber|Fraction"));
    },
    "number, number": function(h, D) {
      return m(d(h, D, 1, !1));
    },
    "number, number, number": function(h, D, y) {
      return m(d(h, D, y, !1));
    },
    "number, number, boolean": function(h, D, y) {
      return m(d(h, D, 1, y));
    },
    "number, number, number, boolean": function(h, D, y, w) {
      return m(d(h, D, y, w));
    },
    // Handle bigints; if either limit is bigint, range should be too
    "bigint, bigint|number": function(h, D) {
      return m(d(h, D, 1n, !1));
    },
    "number, bigint": function(h, D) {
      return m(d(BigInt(h), D, 1n, !1));
    },
    "bigint, bigint|number, bigint|number": function(h, D, y) {
      return m(d(h, D, BigInt(y), !1));
    },
    "number, bigint, bigint|number": function(h, D, y) {
      return m(d(BigInt(h), D, BigInt(y), !1));
    },
    "bigint, bigint|number, boolean": function(h, D, y) {
      return m(d(h, D, 1n, y));
    },
    "number, bigint, boolean": function(h, D, y) {
      return m(d(BigInt(h), D, 1n, y));
    },
    "bigint, bigint|number, bigint|number, boolean": function(h, D, y, w) {
      return m(d(h, D, BigInt(y), w));
    },
    "number, bigint, bigint|number, boolean": function(h, D, y, w) {
      return m(d(BigInt(h), D, BigInt(y), w));
    },
    "BigNumber, BigNumber": function(h, D) {
      var y = h.constructor;
      return m(d(h, D, new y(1), !1));
    },
    "BigNumber, BigNumber, BigNumber": function(h, D, y) {
      return m(d(h, D, y, !1));
    },
    "BigNumber, BigNumber, boolean": function(h, D, y) {
      var w = h.constructor;
      return m(d(h, D, new w(1), y));
    },
    "BigNumber, BigNumber, BigNumber, boolean": function(h, D, y, w) {
      return m(d(h, D, y, w));
    },
    "Fraction, Fraction": function(h, D) {
      return m(d(h, D, 1, !1));
    },
    "Fraction, Fraction, Fraction": function(h, D, y) {
      return m(d(h, D, y, !1));
    },
    "Fraction, Fraction, boolean": function(h, D, y) {
      return m(d(h, D, 1, y));
    },
    "Fraction, Fraction, Fraction, boolean": function(h, D, y, w) {
      return m(d(h, D, y, w));
    },
    "Unit, Unit, Unit": function(h, D, y) {
      return m(d(h, D, y, !1));
    },
    "Unit, Unit, Unit, boolean": function(h, D, y, w) {
      return m(d(h, D, y, w));
    }
  });
  function m(x) {
    return t.matrix === "Matrix" ? n ? n(x) : Wp() : x;
  }
  function p(x, h) {
    var D = v(x);
    if (!D)
      throw new SyntaxError('String "' + x + '" is no valid range');
    return t.number === "BigNumber" ? (a === void 0 && go(), m(d(a(D.start), a(D.end), a(D.step)))) : m(d(D.start, D.end, D.step, h));
  }
  function d(x, h, D, y) {
    var w = [];
    if (u(D)) throw new Error("Step must be non-zero");
    for (var b = f(D) ? y ? s : i : y ? c : l, g = x; b(g, h); )
      w.push(g), g = o(g, D);
    return w;
  }
  function v(x) {
    var h = x.split(":"), D = h.map(function(w) {
      return Number(w);
    }), y = D.some(function(w) {
      return isNaN(w);
    });
    if (y)
      return null;
    switch (D.length) {
      case 2:
        return {
          start: D[0],
          end: D[1],
          step: 1
        };
      case 3:
        return {
          start: D[0],
          end: D[2],
          step: D[1]
        };
      default:
        return null;
    }
  }
}), uu = "reshape", Zy = ["typed", "isInteger", "matrix"], Xy = /* @__PURE__ */ R(uu, Zy, (r) => {
  var {
    typed: e,
    isInteger: t
  } = r;
  return e(uu, {
    "Matrix, Array": function(a, i) {
      return a.reshape(i, !0);
    },
    "Array, Array": function(a, i) {
      return i.forEach(function(s) {
        if (!t(s))
          throw new TypeError("Invalid size for dimension: " + s);
      }), uo(a, i);
    }
  });
}), Yy = "resize", Jy = ["config", "matrix"], Qy = /* @__PURE__ */ R(Yy, Jy, (r) => {
  var {
    config: e,
    matrix: t
  } = r;
  return function(i, s, l) {
    if (arguments.length !== 2 && arguments.length !== 3)
      throw new ft("resize", arguments.length, 2, 3);
    if (Ee(s) && (s = s.valueOf()), $e(s[0]) && (s = s.map(function(u) {
      return $e(u) ? u.toNumber() : u;
    })), Ee(i))
      return i.resize(s, l, !0);
    if (typeof i == "string")
      return n(i, s, l);
    var c = Array.isArray(i) ? !1 : e.matrix !== "Array";
    if (s.length === 0) {
      for (; Array.isArray(i); )
        i = i[0];
      return Te(i);
    } else {
      Array.isArray(i) || (i = [i]), i = Te(i);
      var o = un(i, s, l);
      return c ? t(o) : o;
    }
  };
  function n(a, i, s) {
    if (s !== void 0) {
      if (typeof s != "string" || s.length !== 1)
        throw new TypeError("Single character expected as defaultValue");
    } else
      s = " ";
    if (i.length !== 1)
      throw new Ue(i.length, 1);
    var l = i[0];
    if (typeof l != "number" || !Ne(l))
      throw new TypeError("Invalid size, must contain positive integers (size: " + ke(i) + ")");
    if (a.length > l)
      return a.substring(0, l);
    if (a.length < l) {
      for (var c = a, o = 0, u = l - a.length; o < u; o++)
        c += s;
      return c;
    } else
      return a;
  }
}), cu = "rotate", jy = ["typed", "multiply", "rotationMatrix"], Ky = /* @__PURE__ */ R(cu, jy, (r) => {
  var {
    typed: e,
    multiply: t,
    rotationMatrix: n
  } = r;
  return e(cu, {
    "Array , number | BigNumber | Complex | Unit": function(s, l) {
      a(s, 2);
      var c = t(n(l), s);
      return c.toArray();
    },
    "Matrix , number | BigNumber | Complex | Unit": function(s, l) {
      return a(s, 2), t(n(l), s);
    },
    "Array, number | BigNumber | Complex | Unit, Array | Matrix": function(s, l, c) {
      a(s, 3);
      var o = t(n(l, c), s);
      return o;
    },
    "Matrix, number | BigNumber | Complex | Unit, Array | Matrix": function(s, l, c) {
      return a(s, 3), t(n(l, c), s);
    }
  });
  function a(i, s) {
    var l = Array.isArray(i) ? Oe(i) : i.size();
    if (l.length > 2)
      throw new RangeError("Vector must be of dimensions 1x".concat(s));
    if (l.length === 2 && l[1] !== 1)
      throw new RangeError("Vector must be of dimensions 1x".concat(s));
    if (l[0] !== s)
      throw new RangeError("Vector must be of dimensions 1x".concat(s));
  }
}), lu = "rotationMatrix", eb = ["typed", "config", "multiplyScalar", "addScalar", "unaryMinus", "norm", "matrix", "BigNumber", "DenseMatrix", "SparseMatrix", "cos", "sin"], rb = /* @__PURE__ */ R(lu, eb, (r) => {
  var {
    typed: e,
    config: t,
    multiplyScalar: n,
    addScalar: a,
    unaryMinus: i,
    norm: s,
    BigNumber: l,
    matrix: c,
    DenseMatrix: o,
    SparseMatrix: u,
    cos: f,
    sin: m
  } = r;
  return e(lu, {
    "": function() {
      return t.matrix === "Matrix" ? c([]) : [];
    },
    string: function(y) {
      return c(y);
    },
    "number | BigNumber | Complex | Unit": function(y) {
      return p(y, t.matrix === "Matrix" ? "dense" : void 0);
    },
    "number | BigNumber | Complex | Unit, string": function(y, w) {
      return p(y, w);
    },
    "number | BigNumber | Complex | Unit, Array": function(y, w) {
      var b = c(w);
      return d(b), h(y, b, void 0);
    },
    "number | BigNumber | Complex | Unit, Matrix": function(y, w) {
      d(w);
      var b = w.storage() || (t.matrix === "Matrix" ? "dense" : void 0);
      return h(y, w, b);
    },
    "number | BigNumber | Complex | Unit, Array, string": function(y, w, b) {
      var g = c(w);
      return d(g), h(y, g, b);
    },
    "number | BigNumber | Complex | Unit, Matrix, string": function(y, w, b) {
      return d(w), h(y, w, b);
    }
  });
  function p(D, y) {
    var w = $e(D), b = w ? new l(-1) : -1, g = f(D), N = m(D), S = [[g, n(b, N)], [N, g]];
    return x(S, y);
  }
  function d(D) {
    var y = D.size();
    if (y.length < 1 || y[0] !== 3)
      throw new RangeError("Vector must be of dimensions 1x3");
  }
  function v(D) {
    return D.reduce((y, w) => n(y, w));
  }
  function x(D, y) {
    if (y) {
      if (y === "sparse")
        return new u(D);
      if (y === "dense")
        return new o(D);
      throw new TypeError('Unknown matrix type "'.concat(y, '"'));
    }
    return D;
  }
  function h(D, y, w) {
    var b = s(y);
    if (b === 0)
      throw new RangeError("Rotation around zero vector");
    var g = $e(D) ? l : null, N = g ? new g(1) : 1, S = g ? new g(-1) : -1, A = g ? new g(y.get([0]) / b) : y.get([0]) / b, E = g ? new g(y.get([1]) / b) : y.get([1]) / b, M = g ? new g(y.get([2]) / b) : y.get([2]) / b, T = f(D), B = a(N, i(T)), I = m(D), O = a(T, v([A, A, B])), _ = a(v([A, E, B]), v([S, M, I])), P = a(v([A, M, B]), v([E, I])), W = a(v([A, E, B]), v([M, I])), L = a(T, v([E, E, B])), J = a(v([E, M, B]), v([S, A, I])), ee = a(v([A, M, B]), v([S, E, I])), F = a(v([E, M, B]), v([A, I])), G = a(T, v([M, M, B])), z = [[O, _, P], [W, L, J], [ee, F, G]];
    return x(z, w);
  }
}), fu = "row", tb = ["typed", "Index", "matrix", "range"], Vp = /* @__PURE__ */ R(fu, tb, (r) => {
  var {
    typed: e,
    Index: t,
    matrix: n,
    range: a
  } = r;
  return e(fu, {
    "Matrix, number": i,
    "Array, number": function(l, c) {
      return i(n(Te(l)), c).valueOf();
    }
  });
  function i(s, l) {
    if (s.size().length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    er(l, s.size()[0]);
    var c = a(0, s.size()[1]), o = new t(l, c), u = s.subset(o);
    return Ee(u) ? u : n([[u]]);
  }
}), mu = "size", nb = ["typed", "config", "?matrix"], Zp = /* @__PURE__ */ R(mu, nb, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n
  } = r;
  return e(mu, {
    Matrix: function(i) {
      return i.create(i.size(), "number");
    },
    Array: Oe,
    string: function(i) {
      return t.matrix === "Array" ? [i.length] : n([i.length], "dense", "number");
    },
    "number | Complex | BigNumber | Unit | boolean | null": function(i) {
      return t.matrix === "Array" ? [] : n ? n([], "dense", "number") : Wp();
    }
  });
}), pu = "squeeze", ab = ["typed"], ib = /* @__PURE__ */ R(pu, ab, (r) => {
  var {
    typed: e
  } = r;
  return e(pu, {
    Array: function(n) {
      return Ta(Te(n));
    },
    Matrix: function(n) {
      var a = Ta(n.toArray());
      return Array.isArray(a) ? n.create(a, n.datatype()) : a;
    },
    any: function(n) {
      return Te(n);
    }
  });
}), du = "subset", ob = ["typed", "matrix", "zeros", "add"], yo = /* @__PURE__ */ R(du, ob, (r) => {
  var {
    typed: e,
    matrix: t,
    zeros: n,
    add: a
  } = r;
  return e(du, {
    // get subset
    "Matrix, Index": function(l, c) {
      return sn(c) ? t() : (_a(l, c), l.subset(c));
    },
    "Array, Index": e.referTo("Matrix, Index", function(s) {
      return function(l, c) {
        var o = s(t(l), c);
        return c.isScalar() ? o : o.valueOf();
      };
    }),
    "Object, Index": ub,
    "string, Index": sb,
    // set subset
    "Matrix, Index, any, any": function(l, c, o, u) {
      return sn(c) ? l : (_a(l, c), l.clone().subset(c, i(o, c), u));
    },
    "Array, Index, any, any": e.referTo("Matrix, Index, any, any", function(s) {
      return function(l, c, o, u) {
        var f = s(t(l), c, o, u);
        return f.isMatrix ? f.valueOf() : f;
      };
    }),
    "Array, Index, any": e.referTo("Matrix, Index, any, any", function(s) {
      return function(l, c, o) {
        return s(t(l), c, o, void 0).valueOf();
      };
    }),
    "Matrix, Index, any": e.referTo("Matrix, Index, any, any", function(s) {
      return function(l, c, o) {
        return s(l, c, o, void 0);
      };
    }),
    "string, Index, string": vu,
    "string, Index, string, string": vu,
    "Object, Index, any": cb
  });
  function i(s, l) {
    if (typeof s == "string")
      throw new Error("can't boradcast a string");
    if (l._isScalar)
      return s;
    var c = l.size();
    if (c.every((o) => o > 0))
      try {
        return a(s, n(c));
      } catch {
        return s;
      }
    else
      return s;
  }
});
function sb(r, e) {
  if (!$n(e))
    throw new TypeError("Index expected");
  if (sn(e))
    return "";
  if (_a(Array.from(r), e), e.size().length !== 1)
    throw new Ue(e.size().length, 1);
  var t = r.length;
  er(e.min()[0], t), er(e.max()[0], t);
  var n = e.dimension(0), a = "";
  return n.forEach(function(i) {
    a += r.charAt(i);
  }), a;
}
function vu(r, e, t, n) {
  if (!e || e.isIndex !== !0)
    throw new TypeError("Index expected");
  if (sn(e))
    return r;
  if (_a(Array.from(r), e), e.size().length !== 1)
    throw new Ue(e.size().length, 1);
  if (n !== void 0) {
    if (typeof n != "string" || n.length !== 1)
      throw new TypeError("Single character expected as defaultValue");
  } else
    n = " ";
  var a = e.dimension(0), i = a.size()[0];
  if (i !== t.length)
    throw new Ue(a.size()[0], t.length);
  var s = r.length;
  er(e.min()[0]), er(e.max()[0]);
  for (var l = [], c = 0; c < s; c++)
    l[c] = r.charAt(c);
  if (a.forEach(function(f, m) {
    l[f] = t.charAt(m[0]);
  }), l.length > s)
    for (var o = s - 1, u = l.length; o < u; o++)
      l[o] || (l[o] = n);
  return l.join("");
}
function ub(r, e) {
  if (!sn(e)) {
    if (e.size().length !== 1)
      throw new Ue(e.size(), 1);
    var t = e.dimension(0);
    if (typeof t != "string")
      throw new TypeError("String expected as index to retrieve an object property");
    return Mr(r, t);
  }
}
function cb(r, e, t) {
  if (sn(e))
    return r;
  if (e.size().length !== 1)
    throw new Ue(e.size(), 1);
  var n = e.dimension(0);
  if (typeof n != "string")
    throw new TypeError("String expected as index to retrieve an object property");
  var a = Te(r);
  return an(a, n, t), a;
}
var hu = "transpose", lb = ["typed", "matrix"], Xp = /* @__PURE__ */ R(hu, lb, (r) => {
  var {
    typed: e,
    matrix: t
  } = r;
  return e(hu, {
    Array: (s) => n(t(s)).valueOf(),
    Matrix: n,
    any: Te
    // scalars
  });
  function n(s) {
    var l = s.size(), c;
    switch (l.length) {
      case 1:
        c = s.clone();
        break;
      case 2:
        {
          var o = l[0], u = l[1];
          if (u === 0)
            throw new RangeError("Cannot transpose a 2D matrix with no columns (size: " + ke(l) + ")");
          switch (s.storage()) {
            case "dense":
              c = a(s, o, u);
              break;
            case "sparse":
              c = i(s, o, u);
              break;
          }
        }
        break;
      default:
        throw new RangeError("Matrix must be a vector or two dimensional (size: " + ke(l) + ")");
    }
    return c;
  }
  function a(s, l, c) {
    for (var o = s._data, u = [], f, m = 0; m < c; m++) {
      f = u[m] = [];
      for (var p = 0; p < l; p++)
        f[p] = Te(o[p][m]);
    }
    return s.createDenseMatrix({
      data: u,
      size: [c, l],
      datatype: s._datatype
    });
  }
  function i(s, l, c) {
    for (var o = s._values, u = s._index, f = s._ptr, m = o ? [] : void 0, p = [], d = [], v = [], x = 0; x < l; x++)
      v[x] = 0;
    var h, D, y;
    for (h = 0, D = u.length; h < D; h++)
      v[u[h]]++;
    for (var w = 0, b = 0; b < l; b++)
      d.push(w), w += v[b], v[b] = d[b];
    for (d.push(w), y = 0; y < c; y++)
      for (var g = f[y], N = f[y + 1], S = g; S < N; S++) {
        var A = v[u[S]]++;
        p[A] = y, o && (m[A] = Te(o[S]));
      }
    return s.createSparseMatrix({
      values: m,
      index: p,
      ptr: d,
      size: [c, l],
      datatype: s._datatype
    });
  }
}), gu = "ctranspose", fb = ["typed", "transpose", "conj"], mb = /* @__PURE__ */ R(gu, fb, (r) => {
  var {
    typed: e,
    transpose: t,
    conj: n
  } = r;
  return e(gu, {
    any: function(i) {
      return n(t(i));
    }
  });
}), yu = "zeros", pb = ["typed", "config", "matrix", "BigNumber"], Yp = /* @__PURE__ */ R(yu, pb, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    BigNumber: a
  } = r;
  return e(yu, {
    "": function() {
      return t.matrix === "Array" ? i([]) : i([], "default");
    },
    // math.zeros(m, n, p, ..., format)
    // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
    "...number | BigNumber | string": function(o) {
      var u = o[o.length - 1];
      if (typeof u == "string") {
        var f = o.pop();
        return i(o, f);
      } else return t.matrix === "Array" ? i(o) : i(o, "default");
    },
    Array: i,
    Matrix: function(o) {
      var u = o.storage();
      return i(o.valueOf(), u);
    },
    "Array | Matrix, string": function(o, u) {
      return i(o.valueOf(), u);
    }
  });
  function i(c, o) {
    var u = s(c), f = u ? new a(0) : 0;
    if (l(c), o) {
      var m = n(o);
      return c.length > 0 ? m.resize(c, f) : m;
    } else {
      var p = [];
      return c.length > 0 ? un(p, c, f) : p;
    }
  }
  function s(c) {
    var o = !1;
    return c.forEach(function(u, f, m) {
      $e(u) && (o = !0, m[f] = u.toNumber());
    }), o;
  }
  function l(c) {
    c.forEach(function(o) {
      if (typeof o != "number" || !Ne(o) || o < 0)
        throw new Error("Parameters in function zeros must be positive integers");
    });
  }
}), bu = "fft", db = ["typed", "matrix", "addScalar", "multiplyScalar", "divideScalar", "exp", "tau", "i", "dotDivide", "conj", "pow", "ceil", "log2"], vb = /* @__PURE__ */ R(bu, db, (r) => {
  var {
    typed: e,
    matrix: t,
    addScalar: n,
    multiplyScalar: a,
    divideScalar: i,
    exp: s,
    tau: l,
    i: c,
    dotDivide: o,
    conj: u,
    pow: f,
    ceil: m,
    log2: p
  } = r;
  return e(bu, {
    Array: d,
    Matrix: function(y) {
      return y.create(d(y.valueOf()), y.datatype());
    }
  });
  function d(D) {
    var y = Oe(D);
    return y.length === 1 ? h(D, y[0]) : v(D.map((w) => d(w, y.slice(1))), 0);
  }
  function v(D, y) {
    var w = Oe(D);
    if (y !== 0) return new Array(w[0]).fill(0).map((g, N) => v(D[N], y - 1));
    if (w.length === 1) return h(D);
    function b(g) {
      var N = Oe(g);
      return new Array(N[1]).fill(0).map((S, A) => new Array(N[0]).fill(0).map((E, M) => g[M][A]));
    }
    return b(v(b(D), 1));
  }
  function x(D) {
    for (var y = D.length, w = s(i(a(-1, a(c, l)), y)), b = [], g = 1 - y; g < y; g++)
      b.push(f(w, i(f(g, 2), 2)));
    for (var N = f(2, m(p(y + y - 1))), S = [...new Array(y).fill(0).map((_, P) => a(D[P], b[y - 1 + P])), ...new Array(N - y).fill(0)], A = [...new Array(y + y - 1).fill(0).map((_, P) => i(1, b[P])), ...new Array(N - (y + y - 1)).fill(0)], E = h(S), M = h(A), T = new Array(N).fill(0).map((_, P) => a(E[P], M[P])), B = o(u(d(u(T))), N), I = [], O = y - 1; O < y + y - 1; O++)
      I.push(a(B[O], b[O]));
    return I;
  }
  function h(D) {
    var y = D.length;
    if (y === 1) return [D[0]];
    if (y % 2 === 0) {
      for (var w = [...h(D.filter((S, A) => A % 2 === 0)), ...h(D.filter((S, A) => A % 2 === 1))], b = 0; b < y / 2; b++) {
        var g = w[b], N = a(w[b + y / 2], s(a(a(l, c), i(-b, y))));
        w[b] = n(g, N), w[b + y / 2] = n(g, a(-1, N));
      }
      return w;
    } else
      return x(D);
  }
}), xu = "ifft", hb = ["typed", "fft", "dotDivide", "conj"], gb = /* @__PURE__ */ R(xu, hb, (r) => {
  var {
    typed: e,
    fft: t,
    dotDivide: n,
    conj: a
  } = r;
  return e(xu, {
    "Array | Matrix": function(s) {
      var l = Ee(s) ? s.size() : Oe(s);
      return n(a(t(a(s))), l.reduce((c, o) => c * o, 1));
    }
  });
});
function On(r) {
  "@babel/helpers - typeof";
  return On = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, On(r);
}
function yb(r, e) {
  if (On(r) != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e);
    if (On(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(r);
}
function bb(r) {
  var e = yb(r, "string");
  return On(e) == "symbol" ? e : e + "";
}
function or(r, e, t) {
  return (e = bb(e)) in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
function wu(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function xb(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? wu(Object(t), !0).forEach(function(n) {
      or(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : wu(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
var wb = "solveODE", Db = ["typed", "add", "subtract", "multiply", "divide", "max", "map", "abs", "isPositive", "isNegative", "larger", "smaller", "matrix", "bignumber", "unaryMinus"], Nb = /* @__PURE__ */ R(wb, Db, (r) => {
  var {
    typed: e,
    add: t,
    subtract: n,
    multiply: a,
    divide: i,
    max: s,
    map: l,
    abs: c,
    isPositive: o,
    isNegative: u,
    larger: f,
    smaller: m,
    matrix: p,
    bignumber: d,
    unaryMinus: v
  } = r;
  function x(S) {
    return function(A, E, M, T) {
      var B = !(E.length === 2 && (E.every(g) || E.every(Er)));
      if (B)
        throw new Error('"tspan" must be an Array of two numeric values or two units [tStart, tEnd]');
      var I = E[0], O = E[1], _ = f(O, I), P = T.firstStep;
      if (P !== void 0 && !o(P))
        throw new Error('"firstStep" must be positive');
      var W = T.maxStep;
      if (W !== void 0 && !o(W))
        throw new Error('"maxStep" must be positive');
      var L = T.minStep;
      if (L && u(L))
        throw new Error('"minStep" must be positive or zero');
      var J = [I, O, P, L, W].filter(($) => $ !== void 0);
      if (!(J.every(g) || J.every(Er)))
        throw new Error('Inconsistent type of "t" dependant variables');
      for (var ee = 1, F = T.tol ? T.tol : 1e-4, G = T.minDelta ? T.minDelta : 0.2, z = T.maxDelta ? T.maxDelta : 5, le = T.maxIter ? T.maxIter : 1e4, ne = [I, O, ...M, W, L].some($e), [ae, q, k, Z] = ne ? [d(S.a), d(S.c), d(S.b), d(S.bp)] : [S.a, S.c, S.b, S.bp], Q = P ? _ ? P : v(P) : i(n(O, I), ee), j = [I], ce = [M], oe = n(k, Z), he = 0, we = 0, De = w(_), ye = b(_); De(j[he], O); ) {
        var Ae = [];
        Q = ye(j[he], O, Q), Ae.push(A(j[he], ce[he]));
        for (var U = 1; U < q.length; ++U)
          Ae.push(A(t(j[he], a(q[U], Q)), t(ce[he], a(Q, ae[U], Ae))));
        var X = s(c(l(a(oe, Ae), ($) => Er($) ? $.value : $)));
        X < F && F / X > 1 / 4 && (j.push(t(j[he], Q)), ce.push(t(ce[he], a(Q, k, Ae))), he++);
        var re = 0.84 * (F / X) ** (1 / 5);
        if (m(re, G) ? re = G : f(re, z) && (re = z), re = ne ? d(re) : re, Q = a(Q, re), W && f(c(Q), W) ? Q = _ ? W : v(W) : L && m(c(Q), L) && (Q = _ ? L : v(L)), we++, we > le)
          throw new Error("Maximum number of iterations reached, try changing options");
      }
      return {
        t: j,
        y: ce
      };
    };
  }
  function h(S, A, E, M) {
    var T = [[], [0.5], [0, 0.75], [0.2222222222222222, 0.3333333333333333, 0.4444444444444444]], B = [null, 1 / 2, 3 / 4, 1], I = [2 / 9, 1 / 3, 4 / 9, 0], O = [7 / 24, 1 / 4, 1 / 3, 1 / 8], _ = {
      a: T,
      c: B,
      b: I,
      bp: O
    };
    return x(_)(S, A, E, M);
  }
  function D(S, A, E, M) {
    var T = [[], [0.2], [0.075, 0.225], [0.9777777777777777, -3.7333333333333334, 3.5555555555555554], [2.9525986892242035, -11.595793324188385, 9.822892851699436, -0.2908093278463649], [2.8462752525252526, -10.757575757575758, 8.906422717743473, 0.2784090909090909, -0.2735313036020583], [0.09114583333333333, 0, 0.44923629829290207, 0.6510416666666666, -0.322376179245283, 0.13095238095238096]], B = [null, 1 / 5, 3 / 10, 4 / 5, 8 / 9, 1, 1], I = [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84, 0], O = [5179 / 57600, 0, 7571 / 16695, 393 / 640, -92097 / 339200, 187 / 2100, 1 / 40], _ = {
      a: T,
      c: B,
      b: I,
      bp: O
    };
    return x(_)(S, A, E, M);
  }
  function y(S, A, E, M) {
    var T = M.method ? M.method : "RK45", B = {
      RK23: h,
      RK45: D
    };
    if (T.toUpperCase() in B) {
      var I = xb({}, M);
      return delete I.method, B[T.toUpperCase()](S, A, E, I);
    } else {
      var O = Object.keys(B).map((P) => '"'.concat(P, '"')), _ = "".concat(O.slice(0, -1).join(", "), " and ").concat(O.slice(-1));
      throw new Error('Unavailable method "'.concat(T, '". Available methods are ').concat(_));
    }
  }
  function w(S) {
    return S ? m : f;
  }
  function b(S) {
    var A = S ? f : m;
    return function(E, M, T) {
      var B = t(E, T);
      return A(B, M) ? n(M, E) : T;
    };
  }
  function g(S) {
    return $e(S) || Re(S);
  }
  function N(S, A, E, M) {
    var T = y(S, A.toArray(), E.toArray(), M);
    return {
      t: p(T.t),
      y: p(T.y)
    };
  }
  return e("solveODE", {
    "function, Array, Array, Object": y,
    "function, Matrix, Matrix, Object": N,
    "function, Array, Array": (S, A, E) => y(S, A, E, {}),
    "function, Matrix, Matrix": (S, A, E) => N(S, A, E, {}),
    "function, Array, number | BigNumber | Unit": (S, A, E) => {
      var M = y(S, A, [E], {});
      return {
        t: M.t,
        y: M.y.map((T) => T[0])
      };
    },
    "function, Matrix, number | BigNumber | Unit": (S, A, E) => {
      var M = y(S, A.toArray(), [E], {});
      return {
        t: p(M.t),
        y: p(M.y.map((T) => T[0]))
      };
    },
    "function, Array, number | BigNumber | Unit, Object": (S, A, E, M) => {
      var T = y(S, A, [E], M);
      return {
        t: T.t,
        y: T.y.map((B) => B[0])
      };
    },
    "function, Matrix, number | BigNumber | Unit, Object": (S, A, E, M) => {
      var T = y(S, A.toArray(), [E], M);
      return {
        t: p(T.t),
        y: p(T.y.map((B) => B[0]))
      };
    }
  });
}), Ab = "erf", Sb = ["typed"], Eb = /* @__PURE__ */ R(Ab, Sb, (r) => {
  var {
    typed: e
  } = r;
  return e("name", {
    number: function(s) {
      var l = Math.abs(s);
      return l >= _b ? yt(s) : l <= Mb ? yt(s) * t(l) : l <= 4 ? yt(s) * (1 - n(l)) : yt(s) * (1 - a(l));
    },
    "Array | Matrix": e.referToSelf((i) => (s) => Pe(s, i))
    // TODO: For complex numbers, use the approximation for the Faddeeva function
    //  from "More Efficient Computation of the Complex Error Function" (AMS)
  });
  function t(i) {
    var s = i * i, l = at[0][4] * s, c = s, o;
    for (o = 0; o < 3; o += 1)
      l = (l + at[0][o]) * s, c = (c + Vt[0][o]) * s;
    return i * (l + at[0][3]) / (c + Vt[0][3]);
  }
  function n(i) {
    var s = at[1][8] * i, l = i, c;
    for (c = 0; c < 7; c += 1)
      s = (s + at[1][c]) * i, l = (l + Vt[1][c]) * i;
    var o = (s + at[1][7]) / (l + Vt[1][7]), u = parseInt(i * 16) / 16, f = (i - u) * (i + u);
    return Math.exp(-u * u) * Math.exp(-f) * o;
  }
  function a(i) {
    var s = 1 / (i * i), l = at[2][5] * s, c = s, o;
    for (o = 0; o < 4; o += 1)
      l = (l + at[2][o]) * s, c = (c + Vt[2][o]) * s;
    var u = s * (l + at[2][4]) / (c + Vt[2][4]);
    u = (Cb - u) / i, s = parseInt(i * 16) / 16;
    var f = (i - s) * (i + s);
    return Math.exp(-s * s) * Math.exp(-f) * u;
  }
}), Mb = 0.46875, Cb = 0.5641895835477563, at = [[3.1611237438705655, 113.86415415105016, 377.485237685302, 3209.3775891384694, 0.18577770618460315], [0.5641884969886701, 8.883149794388377, 66.11919063714163, 298.6351381974001, 881.952221241769, 1712.0476126340707, 2051.0783778260716, 1230.3393547979972, 21531153547440383e-24], [0.30532663496123236, 0.36034489994980445, 0.12578172611122926, 0.016083785148742275, 6587491615298378e-19, 0.016315387137302097]], Vt = [[23.601290952344122, 244.02463793444417, 1282.6165260773723, 2844.236833439171], [15.744926110709835, 117.6939508913125, 537.1811018620099, 1621.3895745666903, 3290.7992357334597, 4362.619090143247, 3439.3676741437216, 1230.3393548037495], [2.568520192289822, 1.8729528499234604, 0.5279051029514285, 0.06051834131244132, 0.0023352049762686918]], _b = Math.pow(2, 53), Du = "zeta", Tb = ["typed", "config", "multiply", "pow", "divide", "factorial", "equal", "smallerEq", "isNegative", "gamma", "sin", "subtract", "add", "?Complex", "?BigNumber", "pi"], Fb = /* @__PURE__ */ R(Du, Tb, (r) => {
  var {
    typed: e,
    config: t,
    multiply: n,
    pow: a,
    divide: i,
    factorial: s,
    equal: l,
    smallerEq: c,
    isNegative: o,
    gamma: u,
    sin: f,
    subtract: m,
    add: p,
    Complex: d,
    BigNumber: v,
    pi: x
  } = r;
  return e(Du, {
    number: (g) => h(g, (N) => N, () => 20),
    BigNumber: (g) => h(g, (N) => new v(N), () => Math.abs(Math.log10(t.relTol))),
    Complex: D
  });
  function h(g, N, S) {
    return l(g, 0) ? N(-0.5) : l(g, 1) ? N(NaN) : isFinite(g) ? y(g, N, S, (A) => A) : o(g) ? N(NaN) : N(1);
  }
  function D(g) {
    return g.re === 0 && g.im === 0 ? new d(-0.5) : g.re === 1 ? new d(NaN, NaN) : g.re === 1 / 0 && g.im === 0 ? new d(1) : g.im === 1 / 0 || g.re === -1 / 0 ? new d(NaN, NaN) : y(g, (N) => N, (N) => Math.round(1.3 * 15 + 0.9 * Math.abs(N.im)), (N) => N.re);
  }
  function y(g, N, S, A) {
    var E = S(g);
    if (A(g) > -(E - 1) / 2)
      return b(g, N(E), N);
    var M = n(a(2, g), a(N(x), m(g, 1)));
    return M = n(M, f(n(i(N(x), 2), g))), M = n(M, u(m(1, g))), n(M, y(m(1, g), N, S, A));
  }
  function w(g, N) {
    for (var S = g, A = g; c(A, N); A = p(A, 1)) {
      var E = i(n(s(p(N, m(A, 1))), a(4, A)), n(s(m(N, A)), s(n(2, A))));
      S = p(S, E);
    }
    return n(N, S);
  }
  function b(g, N, S) {
    for (var A = i(1, n(w(S(0), N), m(1, a(2, m(1, g))))), E = S(0), M = S(1); c(M, N); M = p(M, 1))
      E = p(E, i(n((-1) ** (M - 1), w(M, N)), a(M, g)));
    return n(A, E);
  }
}), Nu = "mode", Bb = ["typed", "isNaN", "isNumeric"], Ob = /* @__PURE__ */ R(Nu, Bb, (r) => {
  var {
    typed: e,
    isNaN: t,
    isNumeric: n
  } = r;
  return e(Nu, {
    "Array | Matrix": a,
    "...": function(s) {
      return a(s);
    }
  });
  function a(i) {
    i = Ve(i.valueOf());
    var s = i.length;
    if (s === 0)
      throw new Error("Cannot calculate mode of an empty array");
    for (var l = {}, c = [], o = 0, u = 0; u < i.length; u++) {
      var f = i[u];
      if (n(f) && t(f))
        throw new Error("Cannot calculate mode of an array containing NaN values");
      f in l || (l[f] = 0), l[f]++, l[f] === o ? c.push(f) : l[f] > o && (o = l[f], c = [f]);
    }
    return c;
  }
});
function _r(r, e, t) {
  var n;
  return String(r).includes("Unexpected type") ? (n = arguments.length > 2 ? " (type: " + Ke(t) + ", value: " + JSON.stringify(t) + ")" : " (type: " + r.data.actual + ")", new TypeError("Cannot calculate " + e + ", unexpected type of argument" + n)) : String(r).includes("complex numbers") ? (n = arguments.length > 2 ? " (type: " + Ke(t) + ", value: " + JSON.stringify(t) + ")" : "", new TypeError("Cannot calculate " + e + ", no ordering relation is defined for complex numbers" + n)) : r;
}
var Au = "prod", Ib = ["typed", "config", "multiplyScalar", "numeric"], $b = /* @__PURE__ */ R(Au, Ib, (r) => {
  var {
    typed: e,
    config: t,
    multiplyScalar: n,
    numeric: a
  } = r;
  return e(Au, {
    // prod([a, b, c, d, ...])
    "Array | Matrix": i,
    // prod([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": function(l, c) {
      throw new Error("prod(A, dim) is not yet supported");
    },
    // prod(a, b, c, d, ...)
    "...": function(l) {
      return i(l);
    }
  });
  function i(s) {
    var l;
    if (At(s, function(c) {
      try {
        l = l === void 0 ? c : n(l, c);
      } catch (o) {
        throw _r(o, "prod", c);
      }
    }), typeof l == "string" && (l = a(l, St(l, t))), l === void 0)
      throw new Error("Cannot calculate prod of an empty array");
    return l;
  }
}), Su = "format", zb = ["typed"], Rb = /* @__PURE__ */ R(Su, zb, (r) => {
  var {
    typed: e
  } = r;
  return e(Su, {
    any: ke,
    "any, Object | function | number | BigNumber": ke
  });
}), Eu = "bin", qb = ["typed", "format"], Pb = R(Eu, qb, (r) => {
  var {
    typed: e,
    format: t
  } = r;
  return e(Eu, {
    "number | BigNumber": function(a) {
      return t(a, {
        notation: "bin"
      });
    },
    "number | BigNumber, number | BigNumber": function(a, i) {
      return t(a, {
        notation: "bin",
        wordSize: i
      });
    }
  });
}), Mu = "oct", Ub = ["typed", "format"], Lb = R(Mu, Ub, (r) => {
  var {
    typed: e,
    format: t
  } = r;
  return e(Mu, {
    "number | BigNumber": function(a) {
      return t(a, {
        notation: "oct"
      });
    },
    "number | BigNumber, number | BigNumber": function(a, i) {
      return t(a, {
        notation: "oct",
        wordSize: i
      });
    }
  });
}), Cu = "hex", kb = ["typed", "format"], Hb = R(Cu, kb, (r) => {
  var {
    typed: e,
    format: t
  } = r;
  return e(Cu, {
    "number | BigNumber": function(a) {
      return t(a, {
        notation: "hex"
      });
    },
    "number | BigNumber, number | BigNumber": function(a, i) {
      return t(a, {
        notation: "hex",
        wordSize: i
      });
    }
  });
}), Jp = /\$([\w.]+)/g, _u = "print", Wb = ["typed"], Qp = /* @__PURE__ */ R(_u, Wb, (r) => {
  var {
    typed: e
  } = r;
  return e(_u, {
    // note: Matrix will be converted automatically to an Array
    "string, Object | Array": Tu,
    "string, Object | Array, number | Object": Tu
  });
});
function Tu(r, e, t) {
  return r.replace(Jp, function(n, a) {
    var i = a.split("."), s = e[i.shift()];
    for (s !== void 0 && s.isMatrix && (s = s.toArray()); i.length && s !== void 0; ) {
      var l = i.shift();
      s = l ? s[l] : s + ".";
    }
    return s !== void 0 ? gr(s) ? s : ke(s, t) : n;
  });
}
var Fu = "to", Gb = ["typed", "matrix", "concat"], Vb = /* @__PURE__ */ R(Fu, Gb, (r) => {
  var {
    typed: e,
    matrix: t,
    concat: n
  } = r, a = rr({
    typed: e,
    matrix: t,
    concat: n
  });
  return e(Fu, {
    "Unit, Unit | string": (i, s) => i.to(s)
  }, a({
    Ds: !0
  }));
}), Bu = "toBest", Zb = ["typed"], Xb = /* @__PURE__ */ R(Bu, Zb, (r) => {
  var {
    typed: e
  } = r;
  return e(Bu, {
    Unit: (t) => t.toBest(),
    "Unit, string": (t, n) => t.toBest(n.split(",")),
    "Unit, string, Object": (t, n, a) => t.toBest(n.split(","), a),
    "Unit, Array": (t, n) => t.toBest(n),
    "Unit, Array, Object": (t, n, a) => t.toBest(n, a)
  });
}), Ou = "isPrime", Yb = ["typed"], Jb = /* @__PURE__ */ R(Ou, Yb, (r) => {
  var {
    typed: e
  } = r;
  return e(Ou, {
    number: function(n) {
      if (n <= 3)
        return n > 1;
      if (n % 2 === 0 || n % 3 === 0)
        return !1;
      for (var a = 5; a * a <= n; a += 6)
        if (n % a === 0 || n % (a + 2) === 0)
          return !1;
      return !0;
    },
    bigint: function(n) {
      if (n <= 3n)
        return n > 1n;
      if (n % 2n === 0n || n % 3n === 0n)
        return !1;
      for (var a = 5n; a * a <= n; a += 6n)
        if (n % a === 0n || n % (a + 2n) === 0n)
          return !1;
      return !0;
    },
    BigNumber: function(n) {
      if (n.lte(3)) return n.gt(1);
      if (n.mod(2).eq(0) || n.mod(3).eq(0)) return !1;
      if (n.lt(Math.pow(2, 32))) {
        for (var a = n.toNumber(), i = 5; i * i <= a; i += 6)
          if (a % i === 0 || a % (i + 2) === 0)
            return !1;
        return !0;
      }
      function s(D, y, w) {
        for (var b = 1; !y.eq(0); )
          y.mod(2).eq(0) ? (y = y.div(2), D = D.mul(D).mod(w)) : (y = y.sub(1), b = D.mul(b).mod(w));
        return b;
      }
      var l = n.constructor.clone({
        precision: n.toFixed(0).length * 2
      });
      n = new l(n);
      for (var c = 0, o = n.sub(1); o.mod(2).eq(0); )
        o = o.div(2), c += 1;
      var u = null;
      if (n.lt("3317044064679887385961981"))
        u = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41].filter((D) => D < n);
      else {
        var f = Math.min(n.toNumber() - 2, Math.floor(2 * Math.pow(n.toFixed(0).length * Math.log(10), 2)));
        u = [];
        for (var m = 2; m <= f; m += 1)
          u.push(f);
      }
      for (var p = 0; p < u.length; p += 1) {
        var d = u[p], v = s(n.sub(n).add(d), o, n);
        if (!v.eq(1)) {
          for (var x = 0, h = v; !h.eq(n.sub(1)); x += 1, h = h.mul(h).mod(n))
            if (x === c - 1)
              return !1;
        }
      }
      return !0;
    },
    "Array | Matrix": e.referToSelf((t) => (n) => Pe(n, t))
  });
}), Qb = "numeric", jb = ["number", "?bignumber", "?fraction"], jp = /* @__PURE__ */ R(Qb, jb, (r) => {
  var {
    number: e,
    bignumber: t,
    fraction: n
  } = r, a = {
    string: !0,
    number: !0,
    BigNumber: !0,
    Fraction: !0
  }, i = {
    number: (s) => e(s),
    BigNumber: t ? (s) => t(s) : go,
    bigint: (s) => BigInt(s),
    Fraction: n ? (s) => n(s) : Hp
  };
  return function(l) {
    var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "number", o = arguments.length > 2 ? arguments[2] : void 0;
    if (o !== void 0)
      throw new SyntaxError("numeric() takes one or two arguments");
    var u = Ke(l);
    if (!(u in a))
      throw new TypeError("Cannot convert " + l + ' of type "' + u + '"; valid input types are ' + Object.keys(a).join(", "));
    if (!(c in i))
      throw new TypeError("Cannot convert " + l + ' to type "' + c + '"; valid output types are ' + Object.keys(i).join(", "));
    return c === u ? l : i[c](l);
  };
}), Iu = "divideScalar", Kb = ["typed", "numeric"], Kp = /* @__PURE__ */ R(Iu, Kb, (r) => {
  var {
    typed: e,
    numeric: t
  } = r;
  return e(Iu, {
    "number, number": function(a, i) {
      return a / i;
    },
    "Complex, Complex": function(a, i) {
      return a.div(i);
    },
    "BigNumber, BigNumber": function(a, i) {
      return a.div(i);
    },
    "bigint, bigint": function(a, i) {
      return a / i;
    },
    "Fraction, Fraction": function(a, i) {
      return a.div(i);
    },
    "Unit, number | Complex | Fraction | BigNumber | Unit": (n, a) => n.divide(a),
    "number | Fraction | Complex | BigNumber, Unit": (n, a) => a.divideInto(n)
  });
}), $u = "pow", ex = ["typed", "config", "identity", "multiply", "matrix", "inv", "fraction", "number", "Complex"], rx = /* @__PURE__ */ R($u, ex, (r) => {
  var {
    typed: e,
    config: t,
    identity: n,
    multiply: a,
    matrix: i,
    inv: s,
    number: l,
    fraction: c,
    Complex: o
  } = r;
  return e($u, {
    "number, number": u,
    "Complex, Complex": function(d, v) {
      return d.pow(v);
    },
    "BigNumber, BigNumber": function(d, v) {
      return v.isInteger() || d >= 0 || t.predictable ? d.pow(v) : new o(d.toNumber(), 0).pow(v.toNumber(), 0);
    },
    "bigint, bigint": (p, d) => p ** d,
    "Fraction, Fraction": function(d, v) {
      var x = d.pow(v);
      if (x != null)
        return x;
      if (t.predictable)
        throw new Error("Result of pow is non-rational and cannot be expressed as a fraction");
      return u(d.valueOf(), v.valueOf());
    },
    "Array, number": f,
    "Array, BigNumber": function(d, v) {
      return f(d, v.toNumber());
    },
    "Matrix, number": m,
    "Matrix, BigNumber": function(d, v) {
      return m(d, v.toNumber());
    },
    "Unit, number | BigNumber": function(d, v) {
      return d.pow(v);
    }
  });
  function u(p, d) {
    if (t.predictable && !Ne(d) && p < 0)
      try {
        var v = c(d), x = l(v);
        if ((d === x || Math.abs((d - x) / d) < 1e-14) && v.d % 2n === 1n)
          return (v.n % 2n === 0n ? 1 : -1) * Math.pow(-p, d);
      } catch {
      }
    return t.predictable && (p < -1 && d === 1 / 0 || p > -1 && p < 0 && d === -1 / 0) ? NaN : Ne(d) || p >= 0 || t.predictable ? zm(p, d) : p * p < 1 && d === 1 / 0 || p * p > 1 && d === -1 / 0 ? 0 : new o(p, 0).pow(d, 0);
  }
  function f(p, d) {
    if (!Ne(d))
      throw new TypeError("For A^b, b must be an integer (value is " + d + ")");
    var v = Oe(p);
    if (v.length !== 2)
      throw new Error("For A^b, A must be 2 dimensional (A has " + v.length + " dimensions)");
    if (v[0] !== v[1])
      throw new Error("For A^b, A must be square (size is " + v[0] + "x" + v[1] + ")");
    if (d < 0)
      try {
        return f(s(p), -d);
      } catch (D) {
        throw D.message === "Cannot calculate inverse, determinant is zero" ? new TypeError("For A^b, when A is not invertible, b must be a positive integer (value is " + d + ")") : D;
      }
    for (var x = n(v[0]).valueOf(), h = p; d >= 1; )
      (d & 1) === 1 && (x = a(h, x)), d >>= 1, h = a(h, h);
    return x;
  }
  function m(p, d) {
    return i(f(p.valueOf(), d));
  }
}), Zt = "Number of decimals in function round must be an integer", zu = "round", tx = ["typed", "config", "matrix", "equalScalar", "zeros", "BigNumber", "DenseMatrix"], nx = /* @__PURE__ */ R(zu, tx, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    equalScalar: a,
    zeros: i,
    BigNumber: s,
    DenseMatrix: l
  } = r, c = br({
    typed: e,
    equalScalar: a
  }), o = cr({
    typed: e,
    DenseMatrix: l
  }), u = Wr({
    typed: e
  });
  function f(m) {
    return Math.abs(Rn(m).exponent);
  }
  return e(zu, {
    number: function(p) {
      var d = wn(p, f(t.relTol)), v = dr(p, d, t.relTol, t.absTol) ? d : p;
      return wn(v);
    },
    "number, number": function(p, d) {
      var v = f(t.relTol);
      if (d >= v)
        return wn(p, d);
      var x = wn(p, v), h = dr(p, x, t.relTol, t.absTol) ? x : p;
      return wn(h, d);
    },
    "number, BigNumber": function(p, d) {
      if (!d.isInteger())
        throw new TypeError(Zt);
      return new s(p).toDecimalPlaces(d.toNumber());
    },
    Complex: function(p) {
      return p.round();
    },
    "Complex, number": function(p, d) {
      if (d % 1)
        throw new TypeError(Zt);
      return p.round(d);
    },
    "Complex, BigNumber": function(p, d) {
      if (!d.isInteger())
        throw new TypeError(Zt);
      var v = d.toNumber();
      return p.round(v);
    },
    BigNumber: function(p) {
      var d = new s(p).toDecimalPlaces(f(t.relTol)), v = kr(p, d, t.relTol, t.absTol) ? d : p;
      return v.toDecimalPlaces(0);
    },
    "BigNumber, BigNumber": function(p, d) {
      if (!d.isInteger())
        throw new TypeError(Zt);
      var v = f(t.relTol);
      if (d >= v)
        return p.toDecimalPlaces(d.toNumber());
      var x = p.toDecimalPlaces(v), h = kr(p, x, t.relTol, t.absTol) ? x : p;
      return h.toDecimalPlaces(d.toNumber());
    },
    // bigints can't be rounded
    bigint: (m) => m,
    "bigint, number": (m, p) => m,
    "bigint, BigNumber": (m, p) => m,
    Fraction: function(p) {
      return p.round();
    },
    "Fraction, number": function(p, d) {
      if (d % 1)
        throw new TypeError(Zt);
      return p.round(d);
    },
    "Fraction, BigNumber": function(p, d) {
      if (!d.isInteger())
        throw new TypeError(Zt);
      return p.round(d.toNumber());
    },
    "Unit, number, Unit": e.referToSelf((m) => function(p, d, v) {
      var x = p.toNumeric(v);
      return v.multiply(m(x, d));
    }),
    "Unit, BigNumber, Unit": e.referToSelf((m) => (p, d, v) => m(p, d.toNumber(), v)),
    "Array | Matrix, number | BigNumber, Unit": e.referToSelf((m) => (p, d, v) => Pe(p, (x) => m(x, d, v), !0)),
    "Array | Matrix | Unit, Unit": e.referToSelf((m) => (p, d) => m(p, 0, d)),
    "Array | Matrix": e.referToSelf((m) => (p) => Pe(p, m, !0)),
    "SparseMatrix, number | BigNumber": e.referToSelf((m) => (p, d) => c(p, d, m, !1)),
    "DenseMatrix, number | BigNumber": e.referToSelf((m) => (p, d) => u(p, d, m, !1)),
    "Array, number | BigNumber": e.referToSelf((m) => (p, d) => u(n(p), d, m, !1).valueOf()),
    "number | Complex | BigNumber | Fraction, SparseMatrix": e.referToSelf((m) => (p, d) => a(p, 0) ? i(d.size(), d.storage()) : o(d, p, m, !0)),
    "number | Complex | BigNumber | Fraction, DenseMatrix": e.referToSelf((m) => (p, d) => a(p, 0) ? i(d.size(), d.storage()) : u(d, p, m, !0)),
    "number | Complex | BigNumber | Fraction, Array": e.referToSelf((m) => (p, d) => u(n(d), p, m, !0).valueOf())
  });
}), Ru = "log", ax = ["config", "typed", "typeOf", "divideScalar", "Complex"], ix = Math.log(16), ox = /* @__PURE__ */ R(Ru, ax, (r) => {
  var {
    typed: e,
    typeOf: t,
    config: n,
    divideScalar: a,
    Complex: i
  } = r;
  function s(c) {
    return c.log();
  }
  function l(c) {
    return s(new i(c, 0));
  }
  return e(Ru, {
    number: function(o) {
      return o >= 0 || n.predictable ? Qo(o) : l(o);
    },
    bigint: po(ix, Qo, n, l),
    Complex: s,
    BigNumber: function(o) {
      return !o.isNegative() || n.predictable ? o.ln() : l(o.toNumber());
    },
    "any, any": e.referToSelf((c) => (o, u) => {
      if (t(o) === "Fraction" && t(u) === "Fraction") {
        var f = o.log(u);
        if (f !== null)
          return f;
      }
      return a(c(o), c(u));
    })
  });
}), qu = "log1p", sx = ["typed", "config", "divideScalar", "log", "Complex"], ux = /* @__PURE__ */ R(qu, sx, (r) => {
  var {
    typed: e,
    config: t,
    divideScalar: n,
    log: a,
    Complex: i
  } = r;
  return e(qu, {
    number: function(c) {
      return c >= -1 || t.predictable ? Fv(c) : s(new i(c, 0));
    },
    Complex: s,
    BigNumber: function(c) {
      var o = c.plus(1);
      return !o.isNegative() || t.predictable ? o.ln() : s(new i(c.toNumber(), 0));
    },
    "Array | Matrix": e.referToSelf((l) => (c) => Pe(c, l)),
    "any, any": e.referToSelf((l) => (c, o) => n(l(c), a(o)))
  });
  function s(l) {
    var c = l.re + 1;
    return new i(Math.log(Math.sqrt(c * c + l.im * l.im)), Math.atan2(l.im, c));
  }
}), Pu = "nthRoots", cx = ["config", "typed", "divideScalar", "Complex"], lx = /* @__PURE__ */ R(Pu, cx, (r) => {
  var {
    typed: e,
    config: t,
    divideScalar: n,
    Complex: a
  } = r, i = [function(c) {
    return new a(c, 0);
  }, function(c) {
    return new a(0, c);
  }, function(c) {
    return new a(-c, 0);
  }, function(c) {
    return new a(0, -c);
  }];
  function s(l, c) {
    if (c < 0) throw new Error("Root must be greater than zero");
    if (c === 0) throw new Error("Root must be non-zero");
    if (c % 1 !== 0) throw new Error("Root must be an integer");
    if (l === 0 || l.abs() === 0) return [new a(0, 0)];
    var o = typeof l == "number", u;
    (o || l.re === 0 || l.im === 0) && (o ? u = 2 * +(l < 0) : l.im === 0 ? u = 2 * +(l.re < 0) : u = 2 * +(l.im < 0) + 1);
    for (var f = l.arg(), m = l.abs(), p = [], d = Math.pow(m, 1 / c), v = 0; v < c; v++) {
      var x = (u + 4 * v) / c;
      if (x === Math.round(x)) {
        p.push(i[x % 4](d));
        continue;
      }
      p.push(new a({
        r: d,
        phi: (f + 2 * Math.PI * v) / c
      }));
    }
    return p;
  }
  return e(Pu, {
    Complex: function(c) {
      return s(c, 2);
    },
    "Complex, number": s
  });
}), Uu = "dotPow", fx = ["typed", "equalScalar", "matrix", "pow", "DenseMatrix", "concat", "SparseMatrix"], mx = /* @__PURE__ */ R(Uu, fx, (r) => {
  var {
    typed: e,
    equalScalar: t,
    matrix: n,
    pow: a,
    DenseMatrix: i,
    concat: s,
    SparseMatrix: l
  } = r, c = Ar({
    typed: e
  }), o = tt({
    typed: e,
    SparseMatrix: l
  }), u = br({
    typed: e,
    equalScalar: t
  }), f = cr({
    typed: e,
    DenseMatrix: i
  }), m = rr({
    typed: e,
    matrix: n,
    concat: s
  }), p = {};
  for (var d in a.signatures)
    Object.prototype.hasOwnProperty.call(a.signatures, d) && !d.includes("Matrix") && !d.includes("Array") && (p[d] = a.signatures[d]);
  var v = e(p);
  return e(Uu, m({
    elop: v,
    SS: o,
    DS: c,
    Ss: u,
    sS: f
  }));
}), Lu = "dotDivide", px = ["typed", "matrix", "equalScalar", "divideScalar", "DenseMatrix", "concat", "SparseMatrix"], dx = /* @__PURE__ */ R(Lu, px, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    divideScalar: a,
    DenseMatrix: i,
    concat: s,
    SparseMatrix: l
  } = r, c = Jr({
    typed: e,
    equalScalar: n
  }), o = Ar({
    typed: e
  }), u = tt({
    typed: e,
    SparseMatrix: l
  }), f = br({
    typed: e,
    equalScalar: n
  }), m = cr({
    typed: e,
    DenseMatrix: i
  }), p = rr({
    typed: e,
    matrix: t,
    concat: s
  });
  return e(Lu, p({
    elop: a,
    SS: u,
    DS: o,
    SD: c,
    Ss: f,
    sS: m
  }));
});
function qn(r) {
  var {
    DenseMatrix: e
  } = r;
  return function(n, a, i) {
    var s = n.size();
    if (s.length !== 2)
      throw new RangeError("Matrix must be two dimensional (size: " + ke(s) + ")");
    var l = s[0], c = s[1];
    if (l !== c)
      throw new RangeError("Matrix must be square (size: " + ke(s) + ")");
    var o = [];
    if (Ee(a)) {
      var u = a.size(), f = a._data;
      if (u.length === 1) {
        if (u[0] !== l)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var m = 0; m < l; m++)
          o[m] = [f[m]];
        return new e({
          data: o,
          size: [l, 1],
          datatype: a._datatype
        });
      }
      if (u.length === 2) {
        if (u[0] !== l || u[1] !== 1)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        if (_n(a)) {
          if (i) {
            o = [];
            for (var p = 0; p < l; p++)
              o[p] = [f[p][0]];
            return new e({
              data: o,
              size: [l, 1],
              datatype: a._datatype
            });
          }
          return a;
        }
        if (gt(a)) {
          for (var d = 0; d < l; d++)
            o[d] = [0];
          for (var v = a._values, x = a._index, h = a._ptr, D = h[1], y = h[0]; y < D; y++) {
            var w = x[y];
            o[w][0] = v[y];
          }
          return new e({
            data: o,
            size: [l, 1],
            datatype: a._datatype
          });
        }
      }
      throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
    }
    if (Ye(a)) {
      var b = Oe(a);
      if (b.length === 1) {
        if (b[0] !== l)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var g = 0; g < l; g++)
          o[g] = [a[g]];
        return new e({
          data: o,
          size: [l, 1]
        });
      }
      if (b.length === 2) {
        if (b[0] !== l || b[1] !== 1)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var N = 0; N < l; N++)
          o[N] = [a[N][0]];
        return new e({
          data: o,
          size: [l, 1]
        });
      }
      throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
    }
  };
}
var ku = "lsolve", vx = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], hx = /* @__PURE__ */ R(ku, vx, (r) => {
  var {
    typed: e,
    matrix: t,
    divideScalar: n,
    multiplyScalar: a,
    subtractScalar: i,
    equalScalar: s,
    DenseMatrix: l
  } = r, c = qn({
    DenseMatrix: l
  });
  return e(ku, {
    "SparseMatrix, Array | Matrix": function(m, p) {
      return u(m, p);
    },
    "DenseMatrix, Array | Matrix": function(m, p) {
      return o(m, p);
    },
    "Array, Array | Matrix": function(m, p) {
      var d = t(m), v = o(d, p);
      return v.valueOf();
    }
  });
  function o(f, m) {
    m = c(f, m, !0);
    for (var p = m._data, d = f._size[0], v = f._size[1], x = [], h = f._data, D = 0; D < v; D++) {
      var y = p[D][0] || 0, w = void 0;
      if (s(y, 0))
        w = 0;
      else {
        var b = h[D][D];
        if (s(b, 0))
          throw new Error("Linear system cannot be solved since matrix is singular");
        w = n(y, b);
        for (var g = D + 1; g < d; g++)
          p[g] = [i(p[g][0] || 0, a(w, h[g][D]))];
      }
      x[D] = [w];
    }
    return new l({
      data: x,
      size: [d, 1]
    });
  }
  function u(f, m) {
    m = c(f, m, !0);
    for (var p = m._data, d = f._size[0], v = f._size[1], x = f._values, h = f._index, D = f._ptr, y = [], w = 0; w < v; w++) {
      var b = p[w][0] || 0;
      if (s(b, 0))
        y[w] = [0];
      else {
        for (var g = 0, N = [], S = [], A = D[w], E = D[w + 1], M = A; M < E; M++) {
          var T = h[M];
          T === w ? g = x[M] : T > w && (N.push(x[M]), S.push(T));
        }
        if (s(g, 0))
          throw new Error("Linear system cannot be solved since matrix is singular");
        for (var B = n(b, g), I = 0, O = S.length; I < O; I++) {
          var _ = S[I];
          p[_] = [i(p[_][0] || 0, a(B, N[I]))];
        }
        y[w] = [B];
      }
    }
    return new l({
      data: y,
      size: [d, 1]
    });
  }
}), Hu = "usolve", gx = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], yx = /* @__PURE__ */ R(Hu, gx, (r) => {
  var {
    typed: e,
    matrix: t,
    divideScalar: n,
    multiplyScalar: a,
    subtractScalar: i,
    equalScalar: s,
    DenseMatrix: l
  } = r, c = qn({
    DenseMatrix: l
  });
  return e(Hu, {
    "SparseMatrix, Array | Matrix": function(m, p) {
      return u(m, p);
    },
    "DenseMatrix, Array | Matrix": function(m, p) {
      return o(m, p);
    },
    "Array, Array | Matrix": function(m, p) {
      var d = t(m), v = o(d, p);
      return v.valueOf();
    }
  });
  function o(f, m) {
    m = c(f, m, !0);
    for (var p = m._data, d = f._size[0], v = f._size[1], x = [], h = f._data, D = v - 1; D >= 0; D--) {
      var y = p[D][0] || 0, w = void 0;
      if (s(y, 0))
        w = 0;
      else {
        var b = h[D][D];
        if (s(b, 0))
          throw new Error("Linear system cannot be solved since matrix is singular");
        w = n(y, b);
        for (var g = D - 1; g >= 0; g--)
          p[g] = [i(p[g][0] || 0, a(w, h[g][D]))];
      }
      x[D] = [w];
    }
    return new l({
      data: x,
      size: [d, 1]
    });
  }
  function u(f, m) {
    m = c(f, m, !0);
    for (var p = m._data, d = f._size[0], v = f._size[1], x = f._values, h = f._index, D = f._ptr, y = [], w = v - 1; w >= 0; w--) {
      var b = p[w][0] || 0;
      if (s(b, 0))
        y[w] = [0];
      else {
        for (var g = 0, N = [], S = [], A = D[w], E = D[w + 1], M = E - 1; M >= A; M--) {
          var T = h[M];
          T === w ? g = x[M] : T < w && (N.push(x[M]), S.push(T));
        }
        if (s(g, 0))
          throw new Error("Linear system cannot be solved since matrix is singular");
        for (var B = n(b, g), I = 0, O = S.length; I < O; I++) {
          var _ = S[I];
          p[_] = [i(p[_][0], a(B, N[I]))];
        }
        y[w] = [B];
      }
    }
    return new l({
      data: y,
      size: [d, 1]
    });
  }
}), Wu = "lsolveAll", bx = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], xx = /* @__PURE__ */ R(Wu, bx, (r) => {
  var {
    typed: e,
    matrix: t,
    divideScalar: n,
    multiplyScalar: a,
    subtractScalar: i,
    equalScalar: s,
    DenseMatrix: l
  } = r, c = qn({
    DenseMatrix: l
  });
  return e(Wu, {
    "SparseMatrix, Array | Matrix": function(m, p) {
      return u(m, p);
    },
    "DenseMatrix, Array | Matrix": function(m, p) {
      return o(m, p);
    },
    "Array, Array | Matrix": function(m, p) {
      var d = t(m), v = o(d, p);
      return v.map((x) => x.valueOf());
    }
  });
  function o(f, m) {
    for (var p = [c(f, m, !0)._data.map((S) => S[0])], d = f._data, v = f._size[0], x = f._size[1], h = 0; h < x; h++)
      for (var D = p.length, y = 0; y < D; y++) {
        var w = p[y];
        if (s(d[h][h], 0))
          if (s(w[h], 0)) {
            if (y === 0) {
              var g = [...w];
              g[h] = 1;
              for (var N = h + 1; N < x; N++)
                g[N] = i(g[N], d[N][h]);
              p.push(g);
            }
          } else {
            if (y === 0)
              return [];
            p.splice(y, 1), y -= 1, D -= 1;
          }
        else {
          w[h] = n(w[h], d[h][h]);
          for (var b = h + 1; b < x; b++)
            w[b] = i(w[b], a(w[h], d[b][h]));
        }
      }
    return p.map((S) => new l({
      data: S.map((A) => [A]),
      size: [v, 1]
    }));
  }
  function u(f, m) {
    for (var p = [c(f, m, !0)._data.map((ee) => ee[0])], d = f._size[0], v = f._size[1], x = f._values, h = f._index, D = f._ptr, y = 0; y < v; y++)
      for (var w = p.length, b = 0; b < w; b++) {
        for (var g = p[b], N = [], S = [], A = D[y], E = D[y + 1], M = 0, T = A; T < E; T++) {
          var B = h[T];
          B === y ? M = x[T] : B > y && (N.push(x[T]), S.push(B));
        }
        if (s(M, 0))
          if (s(g[y], 0)) {
            if (b === 0) {
              var P = [...g];
              P[y] = 1;
              for (var W = 0, L = S.length; W < L; W++) {
                var J = S[W];
                P[J] = i(P[J], N[W]);
              }
              p.push(P);
            }
          } else {
            if (b === 0)
              return [];
            p.splice(b, 1), b -= 1, w -= 1;
          }
        else {
          g[y] = n(g[y], M);
          for (var I = 0, O = S.length; I < O; I++) {
            var _ = S[I];
            g[_] = i(g[_], a(g[y], N[I]));
          }
        }
      }
    return p.map((ee) => new l({
      data: ee.map((F) => [F]),
      size: [d, 1]
    }));
  }
}), Gu = "usolveAll", wx = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], Dx = /* @__PURE__ */ R(Gu, wx, (r) => {
  var {
    typed: e,
    matrix: t,
    divideScalar: n,
    multiplyScalar: a,
    subtractScalar: i,
    equalScalar: s,
    DenseMatrix: l
  } = r, c = qn({
    DenseMatrix: l
  });
  return e(Gu, {
    "SparseMatrix, Array | Matrix": function(m, p) {
      return u(m, p);
    },
    "DenseMatrix, Array | Matrix": function(m, p) {
      return o(m, p);
    },
    "Array, Array | Matrix": function(m, p) {
      var d = t(m), v = o(d, p);
      return v.map((x) => x.valueOf());
    }
  });
  function o(f, m) {
    for (var p = [c(f, m, !0)._data.map((S) => S[0])], d = f._data, v = f._size[0], x = f._size[1], h = x - 1; h >= 0; h--)
      for (var D = p.length, y = 0; y < D; y++) {
        var w = p[y];
        if (s(d[h][h], 0))
          if (s(w[h], 0)) {
            if (y === 0) {
              var g = [...w];
              g[h] = 1;
              for (var N = h - 1; N >= 0; N--)
                g[N] = i(g[N], d[N][h]);
              p.push(g);
            }
          } else {
            if (y === 0)
              return [];
            p.splice(y, 1), y -= 1, D -= 1;
          }
        else {
          w[h] = n(w[h], d[h][h]);
          for (var b = h - 1; b >= 0; b--)
            w[b] = i(w[b], a(w[h], d[b][h]));
        }
      }
    return p.map((S) => new l({
      data: S.map((A) => [A]),
      size: [v, 1]
    }));
  }
  function u(f, m) {
    for (var p = [c(f, m, !0)._data.map((ee) => ee[0])], d = f._size[0], v = f._size[1], x = f._values, h = f._index, D = f._ptr, y = v - 1; y >= 0; y--)
      for (var w = p.length, b = 0; b < w; b++) {
        for (var g = p[b], N = [], S = [], A = D[y], E = D[y + 1], M = 0, T = E - 1; T >= A; T--) {
          var B = h[T];
          B === y ? M = x[T] : B < y && (N.push(x[T]), S.push(B));
        }
        if (s(M, 0))
          if (s(g[y], 0)) {
            if (b === 0) {
              var P = [...g];
              P[y] = 1;
              for (var W = 0, L = S.length; W < L; W++) {
                var J = S[W];
                P[J] = i(P[J], N[W]);
              }
              p.push(P);
            }
          } else {
            if (b === 0)
              return [];
            p.splice(b, 1), b -= 1, w -= 1;
          }
        else {
          g[y] = n(g[y], M);
          for (var I = 0, O = S.length; I < O; I++) {
            var _ = S[I];
            g[_] = i(g[_], a(g[y], N[I]));
          }
        }
      }
    return p.map((ee) => new l({
      data: ee.map((F) => [F]),
      size: [d, 1]
    }));
  }
}), Nx = "matAlgo08xS0Sid", Ax = ["typed", "equalScalar"], bo = /* @__PURE__ */ R(Nx, Ax, (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return function(a, i, s) {
    var l = a._values, c = a._index, o = a._ptr, u = a._size, f = a._datatype || a._data === void 0 ? a._datatype : a.getDataType(), m = i._values, p = i._index, d = i._ptr, v = i._size, x = i._datatype || i._data === void 0 ? i._datatype : i.getDataType();
    if (u.length !== v.length)
      throw new Ue(u.length, v.length);
    if (u[0] !== v[0] || u[1] !== v[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + v + ")");
    if (!l || !m)
      throw new Error("Cannot perform operation on Pattern Sparse Matrices");
    var h = u[0], D = u[1], y, w = t, b = 0, g = s;
    typeof f == "string" && f === x && f !== "mixed" && (y = f, w = e.find(t, [y, y]), b = e.convert(0, y), g = e.find(s, [y, y]));
    for (var N = [], S = [], A = [], E = [], M = [], T, B, I, O, _ = 0; _ < D; _++) {
      A[_] = S.length;
      var P = _ + 1;
      for (B = o[_], I = o[_ + 1], T = B; T < I; T++)
        O = c[T], M[O] = P, E[O] = l[T], S.push(O);
      for (B = d[_], I = d[_ + 1], T = B; T < I; T++)
        O = p[T], M[O] === P && (E[O] = g(E[O], m[T]));
      for (T = A[_]; T < S.length; ) {
        O = S[T];
        var W = E[O];
        w(W, b) ? S.splice(T, 1) : (N.push(W), T++);
      }
    }
    return A[D] = S.length, a.createSparseMatrix({
      values: N,
      index: S,
      ptr: A,
      size: [h, D],
      datatype: f === a._datatype && x === i._datatype ? y : void 0
    });
  };
}), xo = /* @__PURE__ */ R("useMatrixForArrayScalar", ["typed", "matrix"], (r) => {
  var {
    typed: e,
    matrix: t
  } = r;
  return {
    "Array, number": e.referTo("DenseMatrix, number", (n) => (a, i) => n(t(a), i).valueOf()),
    "Array, BigNumber": e.referTo("DenseMatrix, BigNumber", (n) => (a, i) => n(t(a), i).valueOf()),
    "number, Array": e.referTo("number, DenseMatrix", (n) => (a, i) => n(a, t(i)).valueOf()),
    "BigNumber, Array": e.referTo("BigNumber, DenseMatrix", (n) => (a, i) => n(a, t(i)).valueOf())
  };
}), Vu = "leftShift", Sx = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], Ex = /* @__PURE__ */ R(Vu, Sx, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    zeros: a,
    DenseMatrix: i,
    concat: s
  } = r, l = Mt({
    typed: e
  }), c = Jr({
    typed: e,
    equalScalar: n
  }), o = bo({
    typed: e,
    equalScalar: n
  }), u = Lt({
    typed: e,
    DenseMatrix: i
  }), f = br({
    typed: e,
    equalScalar: n
  }), m = Wr({
    typed: e
  }), p = rr({
    typed: e,
    matrix: t,
    concat: s
  }), d = xo({
    typed: e,
    matrix: t
  });
  return e(Vu, {
    "number, number": Lm,
    "BigNumber, BigNumber": ey,
    "bigint, bigint": (v, x) => v << x,
    "SparseMatrix, number | BigNumber": e.referToSelf((v) => (x, h) => n(h, 0) ? x.clone() : f(x, h, v, !1)),
    "DenseMatrix, number | BigNumber": e.referToSelf((v) => (x, h) => n(h, 0) ? x.clone() : m(x, h, v, !1)),
    "number | BigNumber, SparseMatrix": e.referToSelf((v) => (x, h) => n(x, 0) ? a(h.size(), h.storage()) : u(h, x, v, !0)),
    "number | BigNumber, DenseMatrix": e.referToSelf((v) => (x, h) => n(x, 0) ? a(h.size(), h.storage()) : m(h, x, v, !0))
  }, d, p({
    SS: o,
    DS: l,
    SD: c
  }));
}), Zu = "rightArithShift", Mx = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], Cx = /* @__PURE__ */ R(Zu, Mx, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    zeros: a,
    DenseMatrix: i,
    concat: s
  } = r, l = Mt({
    typed: e
  }), c = Jr({
    typed: e,
    equalScalar: n
  }), o = bo({
    typed: e,
    equalScalar: n
  }), u = Lt({
    typed: e,
    DenseMatrix: i
  }), f = br({
    typed: e,
    equalScalar: n
  }), m = Wr({
    typed: e
  }), p = rr({
    typed: e,
    matrix: t,
    concat: s
  }), d = xo({
    typed: e,
    matrix: t
  });
  return e(Zu, {
    "number, number": km,
    "BigNumber, BigNumber": ry,
    "bigint, bigint": (v, x) => v >> x,
    "SparseMatrix, number | BigNumber": e.referToSelf((v) => (x, h) => n(h, 0) ? x.clone() : f(x, h, v, !1)),
    "DenseMatrix, number | BigNumber": e.referToSelf((v) => (x, h) => n(h, 0) ? x.clone() : m(x, h, v, !1)),
    "number | BigNumber, SparseMatrix": e.referToSelf((v) => (x, h) => n(x, 0) ? a(h.size(), h.storage()) : u(h, x, v, !0)),
    "number | BigNumber, DenseMatrix": e.referToSelf((v) => (x, h) => n(x, 0) ? a(h.size(), h.storage()) : m(h, x, v, !0))
  }, d, p({
    SS: o,
    DS: l,
    SD: c
  }));
}), Xu = "rightLogShift", _x = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], Tx = /* @__PURE__ */ R(Xu, _x, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    zeros: a,
    DenseMatrix: i,
    concat: s
  } = r, l = Mt({
    typed: e
  }), c = Jr({
    typed: e,
    equalScalar: n
  }), o = bo({
    typed: e,
    equalScalar: n
  }), u = Lt({
    typed: e,
    DenseMatrix: i
  }), f = br({
    typed: e,
    equalScalar: n
  }), m = Wr({
    typed: e
  }), p = rr({
    typed: e,
    matrix: t,
    concat: s
  }), d = xo({
    typed: e,
    matrix: t
  });
  return e(Xu, {
    "number, number": Hm,
    // 'BigNumber, BigNumber': ..., // TODO: implement BigNumber support for rightLogShift
    "SparseMatrix, number | BigNumber": e.referToSelf((v) => (x, h) => n(h, 0) ? x.clone() : f(x, h, v, !1)),
    "DenseMatrix, number | BigNumber": e.referToSelf((v) => (x, h) => n(h, 0) ? x.clone() : m(x, h, v, !1)),
    "number | BigNumber, SparseMatrix": e.referToSelf((v) => (x, h) => n(x, 0) ? a(h.size(), h.storage()) : u(h, x, v, !0)),
    "number | BigNumber, DenseMatrix": e.referToSelf((v) => (x, h) => n(x, 0) ? a(h.size(), h.storage()) : m(h, x, v, !0))
  }, d, p({
    SS: o,
    DS: l,
    SD: c
  }));
}), Yu = "and", Fx = ["typed", "matrix", "equalScalar", "zeros", "not", "concat"], ed = /* @__PURE__ */ R(Yu, Fx, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    zeros: a,
    not: i,
    concat: s
  } = r, l = Jr({
    typed: e,
    equalScalar: n
  }), c = oi({
    typed: e,
    equalScalar: n
  }), o = br({
    typed: e,
    equalScalar: n
  }), u = Wr({
    typed: e
  }), f = rr({
    typed: e,
    matrix: t,
    concat: s
  });
  return e(Yu, {
    "number, number": Gi,
    "Complex, Complex": function(p, d) {
      return (p.re !== 0 || p.im !== 0) && (d.re !== 0 || d.im !== 0);
    },
    "BigNumber, BigNumber": function(p, d) {
      return !p.isZero() && !d.isZero() && !p.isNaN() && !d.isNaN();
    },
    "bigint, bigint": Gi,
    "Unit, Unit": e.referToSelf((m) => (p, d) => m(p.value || 0, d.value || 0)),
    "SparseMatrix, any": e.referToSelf((m) => (p, d) => i(d) ? a(p.size(), p.storage()) : o(p, d, m, !1)),
    "DenseMatrix, any": e.referToSelf((m) => (p, d) => i(d) ? a(p.size(), p.storage()) : u(p, d, m, !1)),
    "any, SparseMatrix": e.referToSelf((m) => (p, d) => i(p) ? a(p.size(), p.storage()) : o(d, p, m, !0)),
    "any, DenseMatrix": e.referToSelf((m) => (p, d) => i(p) ? a(p.size(), p.storage()) : u(d, p, m, !0)),
    "Array, any": e.referToSelf((m) => (p, d) => m(t(p), d).valueOf()),
    "any, Array": e.referToSelf((m) => (p, d) => m(p, t(d)).valueOf())
  }, f({
    SS: c,
    DS: l
  }));
}), Ua = "compare", Bx = ["typed", "config", "matrix", "equalScalar", "BigNumber", "Fraction", "DenseMatrix", "concat"], Ox = /* @__PURE__ */ R(Ua, Bx, (r) => {
  var {
    typed: e,
    config: t,
    equalScalar: n,
    matrix: a,
    BigNumber: i,
    Fraction: s,
    DenseMatrix: l,
    concat: c
  } = r, o = Ar({
    typed: e
  }), u = ii({
    typed: e,
    equalScalar: n
  }), f = cr({
    typed: e,
    DenseMatrix: l
  }), m = rr({
    typed: e,
    matrix: a,
    concat: c
  }), p = hn({
    typed: e
  });
  return e(Ua, Ix({
    typed: e,
    config: t
  }), {
    "boolean, boolean": function(v, x) {
      return v === x ? 0 : v > x ? 1 : -1;
    },
    "BigNumber, BigNumber": function(v, x) {
      return kr(v, x, t.relTol, t.absTol) ? new i(0) : new i(v.cmp(x));
    },
    "bigint, bigint": function(v, x) {
      return v === x ? 0n : v > x ? 1n : -1n;
    },
    "Fraction, Fraction": function(v, x) {
      return new s(v.compare(x));
    },
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, p, m({
    SS: u,
    DS: o,
    Ss: f
  }));
}), Ix = /* @__PURE__ */ R(Ua, ["typed", "config"], (r) => {
  var {
    typed: e,
    config: t
  } = r;
  return e(Ua, {
    "number, number": function(a, i) {
      return dr(a, i, t.relTol, t.absTol) ? 0 : a > i ? 1 : -1;
    }
  });
});
function si(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function $x(r) {
  if (Object.prototype.hasOwnProperty.call(r, "__esModule")) return r;
  var e = r.default;
  if (typeof e == "function") {
    var t = function n() {
      var a = !1;
      try {
        a = this instanceof n;
      } catch {
      }
      return a ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(r).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(r, n);
    Object.defineProperty(t, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return r[n];
      }
    });
  }), t;
}
var wi, Ju;
function zx() {
  return Ju || (Ju = 1, wi = function r(e, t) {
    var n = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, a = /(^[ ]*|[ ]*$)/g, i = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, s = /^0x[0-9a-f]+$/i, l = /^0/, c = function(y) {
      return r.insensitive && ("" + y).toLowerCase() || "" + y;
    }, o = c(e).replace(a, "") || "", u = c(t).replace(a, "") || "", f = o.replace(n, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), m = u.replace(n, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), p = parseInt(o.match(s), 16) || f.length !== 1 && o.match(i) && Date.parse(o), d = parseInt(u.match(s), 16) || p && u.match(i) && Date.parse(u) || null, v, x;
    if (d) {
      if (p < d)
        return -1;
      if (p > d)
        return 1;
    }
    for (var h = 0, D = Math.max(f.length, m.length); h < D; h++) {
      if (v = !(f[h] || "").match(l) && parseFloat(f[h]) || f[h] || 0, x = !(m[h] || "").match(l) && parseFloat(m[h]) || m[h] || 0, isNaN(v) !== isNaN(x))
        return isNaN(v) ? 1 : -1;
      if (typeof v != typeof x && (v += "", x += ""), v < x)
        return -1;
      if (v > x)
        return 1;
    }
    return 0;
  }), wi;
}
var Rx = zx();
const Xt = /* @__PURE__ */ si(Rx);
var Qu = "compareNatural", qx = ["typed", "compare"], Px = /* @__PURE__ */ R(Qu, qx, (r) => {
  var {
    typed: e,
    compare: t
  } = r, n = t.signatures["boolean,boolean"];
  return e(Qu, {
    "any, any": a
  });
  function a(c, o) {
    var u = Ke(c), f = Ke(o), m;
    if ((u === "number" || u === "BigNumber" || u === "Fraction") && (f === "number" || f === "BigNumber" || f === "Fraction"))
      return m = t(c, o), m.toString() !== "0" ? m > 0 ? 1 : -1 : Xt(u, f);
    var p = ["Array", "DenseMatrix", "SparseMatrix"];
    if (p.includes(u) || p.includes(f))
      return m = i(a, c, o), m !== 0 ? m : Xt(u, f);
    if (u !== f)
      return Xt(u, f);
    if (u === "Complex")
      return Ux(c, o);
    if (u === "Unit")
      return c.equalBase(o) ? a(c.value, o.value) : s(a, c.formatUnits(), o.formatUnits());
    if (u === "boolean")
      return n(c, o);
    if (u === "string")
      return Xt(c, o);
    if (u === "Object")
      return l(a, c, o);
    if (u === "null" || u === "undefined")
      return 0;
    throw new TypeError('Unsupported type of value "' + u + '"');
  }
  function i(c, o, u) {
    return gt(o) && gt(u) ? s(c, o.toJSON().values, u.toJSON().values) : gt(o) ? i(c, o.toArray(), u) : gt(u) ? i(c, o, u.toArray()) : _n(o) ? i(c, o.toJSON().data, u) : _n(u) ? i(c, o, u.toJSON().data) : Array.isArray(o) ? Array.isArray(u) ? s(c, o, u) : i(c, o, [u]) : i(c, [o], u);
  }
  function s(c, o, u) {
    for (var f = 0, m = Math.min(o.length, u.length); f < m; f++) {
      var p = c(o[f], u[f]);
      if (p !== 0)
        return p;
    }
    return o.length > u.length ? 1 : o.length < u.length ? -1 : 0;
  }
  function l(c, o, u) {
    var f = Object.keys(o), m = Object.keys(u);
    f.sort(Xt), m.sort(Xt);
    var p = s(c, f, m);
    if (p !== 0)
      return p;
    for (var d = 0; d < f.length; d++) {
      var v = c(o[f[d]], u[m[d]]);
      if (v !== 0)
        return v;
    }
    return 0;
  }
});
function Ux(r, e) {
  return r.re > e.re ? 1 : r.re < e.re ? -1 : r.im > e.im ? 1 : r.im < e.im ? -1 : 0;
}
var ju = "compareText", Lx = ["typed", "matrix", "concat"];
qi.signature = "any, any";
var kx = /* @__PURE__ */ R(ju, Lx, (r) => {
  var {
    typed: e,
    matrix: t,
    concat: n
  } = r, a = rr({
    typed: e,
    matrix: t,
    concat: n
  });
  return e(ju, qi, a({
    elop: qi,
    Ds: !0
  }));
}), La = "equal", Hx = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat", "SparseMatrix"], Wx = /* @__PURE__ */ R(La, Hx, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    DenseMatrix: a,
    concat: i,
    SparseMatrix: s
  } = r, l = Ar({
    typed: e
  }), c = tt({
    typed: e,
    SparseMatrix: s
  }), o = cr({
    typed: e,
    DenseMatrix: a
  }), u = rr({
    typed: e,
    matrix: t,
    concat: i
  });
  return e(La, Gx({
    typed: e,
    equalScalar: n
  }), u({
    elop: n,
    SS: c,
    DS: l,
    Ss: o
  }));
}), Gx = R(La, ["typed", "equalScalar"], (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return e(La, {
    "any, any": function(a, i) {
      return a === null ? i === null : i === null ? a === null : a === void 0 ? i === void 0 : i === void 0 ? a === void 0 : t(a, i);
    }
  });
}), Ku = "equalText", Vx = ["typed", "compareText", "isZero"], Zx = /* @__PURE__ */ R(Ku, Vx, (r) => {
  var {
    typed: e,
    compareText: t,
    isZero: n
  } = r;
  return e(Ku, {
    "any, any": function(i, s) {
      return n(t(i, s));
    }
  });
}), ka = "smaller", Xx = ["typed", "config", "bignumber", "matrix", "DenseMatrix", "concat", "SparseMatrix"], rd = /* @__PURE__ */ R(ka, Xx, (r) => {
  var {
    typed: e,
    config: t,
    bignumber: n,
    matrix: a,
    DenseMatrix: i,
    concat: s,
    SparseMatrix: l
  } = r, c = Ar({
    typed: e
  }), o = tt({
    typed: e,
    SparseMatrix: l
  }), u = cr({
    typed: e,
    DenseMatrix: i
  }), f = rr({
    typed: e,
    matrix: a,
    concat: s
  }), m = hn({
    typed: e
  });
  function p(d, v) {
    return d.lt(v) && !kr(d, v, t.relTol, t.absTol);
  }
  return e(ka, Yx({
    typed: e,
    config: t
  }), {
    "boolean, boolean": (d, v) => d < v,
    "BigNumber, BigNumber": p,
    "bigint, bigint": (d, v) => d < v,
    "Fraction, Fraction": (d, v) => d.compare(v) === -1,
    "Fraction, BigNumber": function(v, x) {
      return p(n(v), x);
    },
    "BigNumber, Fraction": function(v, x) {
      return p(v, n(x));
    },
    "Complex, Complex": function(v, x) {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, m, f({
    SS: o,
    DS: c,
    Ss: u
  }));
}), Yx = /* @__PURE__ */ R(ka, ["typed", "config"], (r) => {
  var {
    typed: e,
    config: t
  } = r;
  return e(ka, {
    "number, number": function(a, i) {
      return a < i && !dr(a, i, t.relTol, t.absTol);
    }
  });
}), Ha = "smallerEq", Jx = ["typed", "config", "matrix", "DenseMatrix", "concat", "SparseMatrix"], Qx = /* @__PURE__ */ R(Ha, Jx, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    DenseMatrix: a,
    concat: i,
    SparseMatrix: s
  } = r, l = Ar({
    typed: e
  }), c = tt({
    typed: e,
    SparseMatrix: s
  }), o = cr({
    typed: e,
    DenseMatrix: a
  }), u = rr({
    typed: e,
    matrix: n,
    concat: i
  }), f = hn({
    typed: e
  });
  return e(Ha, jx({
    typed: e,
    config: t
  }), {
    "boolean, boolean": (m, p) => m <= p,
    "BigNumber, BigNumber": function(p, d) {
      return p.lte(d) || kr(p, d, t.relTol, t.absTol);
    },
    "bigint, bigint": (m, p) => m <= p,
    "Fraction, Fraction": (m, p) => m.compare(p) !== 1,
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, f, u({
    SS: c,
    DS: l,
    Ss: o
  }));
}), jx = /* @__PURE__ */ R(Ha, ["typed", "config"], (r) => {
  var {
    typed: e,
    config: t
  } = r;
  return e(Ha, {
    "number, number": function(a, i) {
      return a <= i || dr(a, i, t.relTol, t.absTol);
    }
  });
}), Wa = "larger", Kx = ["typed", "config", "bignumber", "matrix", "DenseMatrix", "concat", "SparseMatrix"], ew = /* @__PURE__ */ R(Wa, Kx, (r) => {
  var {
    typed: e,
    config: t,
    bignumber: n,
    matrix: a,
    DenseMatrix: i,
    concat: s,
    SparseMatrix: l
  } = r, c = Ar({
    typed: e
  }), o = tt({
    typed: e,
    SparseMatrix: l
  }), u = cr({
    typed: e,
    DenseMatrix: i
  }), f = rr({
    typed: e,
    matrix: a,
    concat: s
  }), m = hn({
    typed: e
  });
  function p(d, v) {
    return d.gt(v) && !kr(d, v, t.relTol, t.absTol);
  }
  return e(Wa, rw({
    typed: e,
    config: t
  }), {
    "boolean, boolean": (d, v) => d > v,
    "BigNumber, BigNumber": p,
    "bigint, bigint": (d, v) => d > v,
    "Fraction, Fraction": (d, v) => d.compare(v) === 1,
    "Fraction, BigNumber": function(v, x) {
      return p(n(v), x);
    },
    "BigNumber, Fraction": function(v, x) {
      return p(v, n(x));
    },
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, m, f({
    SS: o,
    DS: c,
    Ss: u
  }));
}), rw = /* @__PURE__ */ R(Wa, ["typed", "config"], (r) => {
  var {
    typed: e,
    config: t
  } = r;
  return e(Wa, {
    "number, number": function(a, i) {
      return a > i && !dr(a, i, t.relTol, t.absTol);
    }
  });
}), Ga = "largerEq", tw = ["typed", "config", "matrix", "DenseMatrix", "concat", "SparseMatrix"], nw = /* @__PURE__ */ R(Ga, tw, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    DenseMatrix: a,
    concat: i,
    SparseMatrix: s
  } = r, l = Ar({
    typed: e
  }), c = tt({
    typed: e,
    SparseMatrix: s
  }), o = cr({
    typed: e,
    DenseMatrix: a
  }), u = rr({
    typed: e,
    matrix: n,
    concat: i
  }), f = hn({
    typed: e
  });
  return e(Ga, aw({
    typed: e,
    config: t
  }), {
    "boolean, boolean": (m, p) => m >= p,
    "BigNumber, BigNumber": function(p, d) {
      return p.gte(d) || kr(p, d, t.relTol, t.absTol);
    },
    "bigint, bigint": function(p, d) {
      return p >= d;
    },
    "Fraction, Fraction": (m, p) => m.compare(p) !== -1,
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, f, u({
    SS: c,
    DS: l,
    Ss: o
  }));
}), aw = /* @__PURE__ */ R(Ga, ["typed", "config"], (r) => {
  var {
    typed: e,
    config: t
  } = r;
  return e(Ga, {
    "number, number": function(a, i) {
      return a >= i || dr(a, i, t.relTol, t.absTol);
    }
  });
}), ec = "deepEqual", iw = ["typed", "equal"], ow = /* @__PURE__ */ R(ec, iw, (r) => {
  var {
    typed: e,
    equal: t
  } = r;
  return e(ec, {
    "any, any": function(i, s) {
      return n(i.valueOf(), s.valueOf());
    }
  });
  function n(a, i) {
    if (Array.isArray(a))
      if (Array.isArray(i)) {
        var s = a.length;
        if (s !== i.length)
          return !1;
        for (var l = 0; l < s; l++)
          if (!n(a[l], i[l]))
            return !1;
        return !0;
      } else
        return !1;
    else
      return Array.isArray(i) ? !1 : t(a, i);
  }
}), Va = "unequal", sw = ["typed", "config", "equalScalar", "matrix", "DenseMatrix", "concat", "SparseMatrix"], uw = /* @__PURE__ */ R(Va, sw, (r) => {
  var {
    typed: e,
    config: t,
    equalScalar: n,
    matrix: a,
    DenseMatrix: i,
    concat: s,
    SparseMatrix: l
  } = r, c = Ar({
    typed: e
  }), o = tt({
    typed: e,
    SparseMatrix: l
  }), u = cr({
    typed: e,
    DenseMatrix: i
  }), f = rr({
    typed: e,
    matrix: a,
    concat: s
  });
  return e(Va, cw({
    typed: e,
    equalScalar: n
  }), f({
    elop: m,
    SS: o,
    DS: c,
    Ss: u
  }));
  function m(p, d) {
    return !n(p, d);
  }
}), cw = R(Va, ["typed", "equalScalar"], (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return e(Va, {
    "any, any": function(a, i) {
      return a === null ? i !== null : i === null ? a !== null : a === void 0 ? i !== void 0 : i === void 0 ? a !== void 0 : !t(a, i);
    }
  });
}), rc = "partitionSelect", lw = ["typed", "isNumeric", "isNaN", "compare"], fw = /* @__PURE__ */ R(rc, lw, (r) => {
  var {
    typed: e,
    isNumeric: t,
    isNaN: n,
    compare: a
  } = r, i = a, s = (o, u) => -a(o, u);
  return e(rc, {
    "Array | Matrix, number": function(u, f) {
      return l(u, f, i);
    },
    "Array | Matrix, number, string": function(u, f, m) {
      if (m === "asc")
        return l(u, f, i);
      if (m === "desc")
        return l(u, f, s);
      throw new Error('Compare string must be "asc" or "desc"');
    },
    "Array | Matrix, number, function": l
  });
  function l(o, u, f) {
    if (!Ne(u) || u < 0)
      throw new Error("k must be a non-negative integer");
    if (Ee(o)) {
      var m = o.size();
      if (m.length > 1)
        throw new Error("Only one dimensional matrices supported");
      return c(o.valueOf(), u, f);
    }
    if (Array.isArray(o))
      return c(o, u, f);
  }
  function c(o, u, f) {
    if (u >= o.length)
      throw new Error("k out of bounds");
    for (var m = 0; m < o.length; m++)
      if (t(o[m]) && n(o[m]))
        return o[m];
    for (var p = 0, d = o.length - 1; p < d; ) {
      for (var v = p, x = d, h = o[Math.floor(Math.random() * (d - p + 1)) + p]; v < x; )
        if (f(o[v], h) >= 0) {
          var D = o[x];
          o[x] = o[v], o[v] = D, --x;
        } else
          ++v;
      f(o[v], h) > 0 && --v, u <= v ? d = v : p = v + 1;
    }
    return o[u];
  }
}), tc = "sort", mw = ["typed", "matrix", "compare", "compareNatural"], pw = /* @__PURE__ */ R(tc, mw, (r) => {
  var {
    typed: e,
    matrix: t,
    compare: n,
    compareNatural: a
  } = r, i = n, s = (u, f) => -n(u, f);
  return e(tc, {
    Array: function(f) {
      return c(f), f.sort(i);
    },
    Matrix: function(f) {
      return o(f), t(f.toArray().sort(i), f.storage());
    },
    "Array, function": function(f, m) {
      return c(f), f.sort(m);
    },
    "Matrix, function": function(f, m) {
      return o(f), t(f.toArray().sort(m), f.storage());
    },
    "Array, string": function(f, m) {
      return c(f), f.sort(l(m));
    },
    "Matrix, string": function(f, m) {
      return o(f), t(f.toArray().sort(l(m)), f.storage());
    }
  });
  function l(u) {
    if (u === "asc")
      return i;
    if (u === "desc")
      return s;
    if (u === "natural")
      return a;
    throw new Error('String "asc", "desc", or "natural" expected');
  }
  function c(u) {
    if (Oe(u).length !== 1)
      throw new Error("One dimensional array expected");
  }
  function o(u) {
    if (u.size().length !== 1)
      throw new Error("One dimensional matrix expected");
  }
}), nc = "max", dw = ["typed", "config", "numeric", "larger", "isNaN"], td = /* @__PURE__ */ R(nc, dw, (r) => {
  var {
    typed: e,
    config: t,
    numeric: n,
    larger: a,
    isNaN: i
  } = r;
  return e(nc, {
    // max([a, b, c, d, ...])
    "Array | Matrix": l,
    // max([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": function(o, u) {
      return ai(o, u.valueOf(), s);
    },
    // max(a, b, c, d, ...)
    "...": function(o) {
      if (pn(o))
        throw new TypeError("Scalar values expected in function max");
      return l(o);
    }
  });
  function s(c, o) {
    try {
      return a(c, o) ? c : o;
    } catch (u) {
      throw _r(u, "max", o);
    }
  }
  function l(c) {
    var o;
    if (At(c, function(u) {
      try {
        (i(u) || o === void 0 || a(u, o)) && (o = u);
      } catch (f) {
        throw _r(f, "max", u);
      }
    }), o === void 0)
      throw new Error("Cannot calculate max of an empty array");
    return typeof o == "string" && (o = n(o, St(o, t))), o;
  }
}), ac = "min", vw = ["typed", "config", "numeric", "smaller", "isNaN"], nd = /* @__PURE__ */ R(ac, vw, (r) => {
  var {
    typed: e,
    config: t,
    numeric: n,
    smaller: a,
    isNaN: i
  } = r;
  return e(ac, {
    // min([a, b, c, d, ...])
    "Array | Matrix": l,
    // min([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": function(o, u) {
      return ai(o, u.valueOf(), s);
    },
    // min(a, b, c, d, ...)
    "...": function(o) {
      if (pn(o))
        throw new TypeError("Scalar values expected in function min");
      return l(o);
    }
  });
  function s(c, o) {
    try {
      return a(c, o) ? c : o;
    } catch (u) {
      throw _r(u, "min", o);
    }
  }
  function l(c) {
    var o;
    if (At(c, function(u) {
      try {
        (i(u) || o === void 0 || a(u, o)) && (o = u);
      } catch (f) {
        throw _r(f, "min", u);
      }
    }), o === void 0)
      throw new Error("Cannot calculate min of an empty array");
    return typeof o == "string" && (o = n(o, St(o, t))), o;
  }
}), hw = "ImmutableDenseMatrix", gw = ["smaller", "DenseMatrix"], ad = /* @__PURE__ */ R(hw, gw, (r) => {
  var {
    smaller: e,
    DenseMatrix: t
  } = r;
  function n(a, i) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (i && !gr(i))
      throw new Error("Invalid datatype: " + i);
    if (Ee(a) || Ye(a)) {
      var s = new t(a, i);
      this._data = s._data, this._size = s._size, this._datatype = s._datatype, this._min = null, this._max = null;
    } else if (a && Ye(a.data) && Ye(a.size))
      this._data = a.data, this._size = a.size, this._datatype = a.datatype, this._min = typeof a.min < "u" ? a.min : null, this._max = typeof a.max < "u" ? a.max : null;
    else {
      if (a)
        throw new TypeError("Unsupported type of data (" + Ke(a) + ")");
      this._data = [], this._size = [0], this._datatype = i, this._min = null, this._max = null;
    }
  }
  return n.prototype = new t(), n.prototype.type = "ImmutableDenseMatrix", n.prototype.isImmutableDenseMatrix = !0, n.prototype.subset = function(a) {
    switch (arguments.length) {
      case 1: {
        var i = t.prototype.subset.call(this, a);
        return Ee(i) ? new n({
          data: i._data,
          size: i._size,
          datatype: i._datatype
        }) : i;
      }
      // intentional fall through
      case 2:
      case 3:
        throw new Error("Cannot invoke set subset on an Immutable Matrix instance");
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, n.prototype.set = function() {
    throw new Error("Cannot invoke set on an Immutable Matrix instance");
  }, n.prototype.resize = function() {
    throw new Error("Cannot invoke resize on an Immutable Matrix instance");
  }, n.prototype.reshape = function() {
    throw new Error("Cannot invoke reshape on an Immutable Matrix instance");
  }, n.prototype.clone = function() {
    return new n({
      data: Te(this._data),
      size: Te(this._size),
      datatype: this._datatype
    });
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "ImmutableDenseMatrix",
      data: this._data,
      size: this._size,
      datatype: this._datatype
    };
  }, n.fromJSON = function(a) {
    return new n(a);
  }, n.prototype.swapRows = function() {
    throw new Error("Cannot invoke swapRows on an Immutable Matrix instance");
  }, n.prototype.min = function() {
    if (this._min === null) {
      var a = null;
      this.forEach(function(i) {
        (a === null || e(i, a)) && (a = i);
      }), this._min = a !== null ? a : void 0;
    }
    return this._min;
  }, n.prototype.max = function() {
    if (this._max === null) {
      var a = null;
      this.forEach(function(i) {
        (a === null || e(a, i)) && (a = i);
      }), this._max = a !== null ? a : void 0;
    }
    return this._max;
  }, n;
}, {
  isClass: !0
}), yw = "Index", bw = ["ImmutableDenseMatrix", "getMatrixDataType"], id = /* @__PURE__ */ R(yw, bw, (r) => {
  var {
    ImmutableDenseMatrix: e,
    getMatrixDataType: t
  } = r;
  function n(i) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    this._dimensions = [], this._sourceSize = [], this._isScalar = !0;
    for (var s = 0, l = arguments.length; s < l; s++) {
      var c = arguments[s], o = Ye(c), u = Ee(c), f = typeof c, m = null;
      if (ja(c))
        this._dimensions.push(c), this._isScalar = !1;
      else if (o || u) {
        var p = void 0;
        t(c) === "boolean" ? (o && (p = a(ic(c).valueOf())), u && (p = a(ic(c._data).valueOf())), m = c.valueOf().length) : p = a(c.valueOf()), this._dimensions.push(p);
        var d = p.size();
        (d.length !== 1 || d[0] !== 1 || m !== null) && (this._isScalar = !1);
      } else if (f === "number")
        this._dimensions.push(a([c]));
      else if (f === "bigint")
        this._dimensions.push(a([Number(c)]));
      else if (f === "string")
        this._dimensions.push(c);
      else
        throw new TypeError("Dimension must be an Array, Matrix, number, bigint, string, or Range");
      this._sourceSize.push(m);
    }
  }
  n.prototype.type = "Index", n.prototype.isIndex = !0;
  function a(i) {
    for (var s = 0, l = i.length; s < l; s++)
      if (typeof i[s] != "number" || !Ne(i[s]))
        throw new TypeError("Index parameters must be positive integer numbers");
    return new e(i);
  }
  return n.prototype.clone = function() {
    var i = new n();
    return i._dimensions = Te(this._dimensions), i._isScalar = this._isScalar, i._sourceSize = this._sourceSize, i;
  }, n.create = function(i) {
    var s = new n();
    return n.apply(s, i), s;
  }, n.prototype.size = function() {
    for (var i = [], s = 0, l = this._dimensions.length; s < l; s++) {
      var c = this._dimensions[s];
      i[s] = typeof c == "string" ? 1 : c.size()[0];
    }
    return i;
  }, n.prototype.max = function() {
    for (var i = [], s = 0, l = this._dimensions.length; s < l; s++) {
      var c = this._dimensions[s];
      i[s] = typeof c == "string" ? c : c.max();
    }
    return i;
  }, n.prototype.min = function() {
    for (var i = [], s = 0, l = this._dimensions.length; s < l; s++) {
      var c = this._dimensions[s];
      i[s] = typeof c == "string" ? c : c.min();
    }
    return i;
  }, n.prototype.forEach = function(i) {
    for (var s = 0, l = this._dimensions.length; s < l; s++)
      i(this._dimensions[s], s, this);
  }, n.prototype.dimension = function(i) {
    return typeof i != "number" ? null : this._dimensions[i] || null;
  }, n.prototype.isObjectProperty = function() {
    return this._dimensions.length === 1 && typeof this._dimensions[0] == "string";
  }, n.prototype.getObjectProperty = function() {
    return this.isObjectProperty() ? this._dimensions[0] : null;
  }, n.prototype.isScalar = function() {
    return this._isScalar;
  }, n.prototype.toArray = function() {
    for (var i = [], s = 0, l = this._dimensions.length; s < l; s++) {
      var c = this._dimensions[s];
      i.push(typeof c == "string" ? c : c.toArray());
    }
    return i;
  }, n.prototype.valueOf = n.prototype.toArray, n.prototype.toString = function() {
    for (var i = [], s = 0, l = this._dimensions.length; s < l; s++) {
      var c = this._dimensions[s];
      typeof c == "string" ? i.push(JSON.stringify(c)) : i.push(c.toString());
    }
    return "[" + i.join(", ") + "]";
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "Index",
      dimensions: this._dimensions
    };
  }, n.fromJSON = function(i) {
    return n.create(i.dimensions);
  }, n;
}, {
  isClass: !0
});
function ic(r) {
  var e = [];
  return r.forEach((t, n) => {
    t && e.push(n);
  }), e;
}
var xw = "FibonacciHeap", ww = ["smaller", "larger"], Dw = /* @__PURE__ */ R(xw, ww, (r) => {
  var {
    smaller: e,
    larger: t
  } = r, n = 1 / Math.log((1 + Math.sqrt(5)) / 2);
  function a() {
    if (!(this instanceof a))
      throw new SyntaxError("Constructor must be called with the new operator");
    this._minimum = null, this._size = 0;
  }
  a.prototype.type = "FibonacciHeap", a.prototype.isFibonacciHeap = !0, a.prototype.insert = function(u, f) {
    var m = {
      key: u,
      value: f,
      degree: 0
    };
    if (this._minimum) {
      var p = this._minimum;
      m.left = p, m.right = p.right, p.right = m, m.right.left = m, e(u, p.key) && (this._minimum = m);
    } else
      m.left = m, m.right = m, this._minimum = m;
    return this._size++, m;
  }, a.prototype.size = function() {
    return this._size;
  }, a.prototype.clear = function() {
    this._minimum = null, this._size = 0;
  }, a.prototype.isEmpty = function() {
    return this._size === 0;
  }, a.prototype.extractMinimum = function() {
    var u = this._minimum;
    if (u === null)
      return u;
    for (var f = this._minimum, m = u.degree, p = u.child; m > 0; ) {
      var d = p.right;
      p.left.right = p.right, p.right.left = p.left, p.left = f, p.right = f.right, f.right = p, p.right.left = p, p.parent = null, p = d, m--;
    }
    return u.left.right = u.right, u.right.left = u.left, u === u.right ? f = null : (f = u.right, f = o(f, this._size)), this._size--, this._minimum = f, u;
  }, a.prototype.remove = function(u) {
    this._minimum = i(this._minimum, u, -1), this.extractMinimum();
  };
  function i(u, f, m) {
    f.key = m;
    var p = f.parent;
    return p && e(f.key, p.key) && (s(u, f, p), l(u, p)), e(f.key, u.key) && (u = f), u;
  }
  function s(u, f, m) {
    f.left.right = f.right, f.right.left = f.left, m.degree--, m.child === f && (m.child = f.right), m.degree === 0 && (m.child = null), f.left = u, f.right = u.right, u.right = f, f.right.left = f, f.parent = null, f.mark = !1;
  }
  function l(u, f) {
    var m = f.parent;
    m && (f.mark ? (s(u, f, m), l(m)) : f.mark = !0);
  }
  var c = function(f, m) {
    f.left.right = f.right, f.right.left = f.left, f.parent = m, m.child ? (f.left = m.child, f.right = m.child.right, m.child.right = f, f.right.left = f) : (m.child = f, f.right = f, f.left = f), m.degree++, f.mark = !1;
  };
  function o(u, f) {
    var m = Math.floor(Math.log(f) * n) + 1, p = new Array(m), d = 0, v = u;
    if (v)
      for (d++, v = v.right; v !== u; )
        d++, v = v.right;
    for (var x; d > 0; ) {
      for (var h = v.degree, D = v.right; x = p[h], !!x; ) {
        if (t(v.key, x.key)) {
          var y = x;
          x = v, v = y;
        }
        c(x, v), p[h] = null, h++;
      }
      p[h] = v, v = D, d--;
    }
    u = null;
    for (var w = 0; w < m; w++)
      x = p[w], x && (u ? (x.left.right = x.right, x.right.left = x.left, x.left = u, x.right = u.right, u.right = x, x.right.left = x, e(x.key, u.key) && (u = x)) : u = x);
    return u;
  }
  return a;
}, {
  isClass: !0
}), Nw = "Spa", Aw = ["addScalar", "equalScalar", "FibonacciHeap"], Sw = /* @__PURE__ */ R(Nw, Aw, (r) => {
  var {
    addScalar: e,
    equalScalar: t,
    FibonacciHeap: n
  } = r;
  function a() {
    if (!(this instanceof a))
      throw new SyntaxError("Constructor must be called with the new operator");
    this._values = [], this._heap = new n();
  }
  return a.prototype.type = "Spa", a.prototype.isSpa = !0, a.prototype.set = function(i, s) {
    if (this._values[i])
      this._values[i].value = s;
    else {
      var l = this._heap.insert(i, s);
      this._values[i] = l;
    }
  }, a.prototype.get = function(i) {
    var s = this._values[i];
    return s ? s.value : 0;
  }, a.prototype.accumulate = function(i, s) {
    var l = this._values[i];
    l ? l.value = e(l.value, s) : (l = this._heap.insert(i, s), this._values[i] = l);
  }, a.prototype.forEach = function(i, s, l) {
    var c = this._heap, o = this._values, u = [], f = c.extractMinimum();
    for (f && u.push(f); f && f.key <= s; )
      f.key >= i && (t(f.value, 0) || l(f.key, f.value, this)), f = c.extractMinimum(), f && u.push(f);
    for (var m = 0; m < u.length; m++) {
      var p = u[m];
      f = c.insert(p.key, p.value), o[f.key] = f;
    }
  }, a.prototype.swap = function(i, s) {
    var l = this._values[i], c = this._values[s];
    if (!l && c)
      l = this._heap.insert(i, c.value), this._heap.remove(c), this._values[i] = l, this._values[s] = void 0;
    else if (l && !c)
      c = this._heap.insert(s, l.value), this._heap.remove(l), this._values[s] = c, this._values[i] = void 0;
    else if (l && c) {
      var o = l.value;
      l.value = c.value, c.value = o;
    }
  }, a;
}, {
  isClass: !0
});
function Ew(r) {
  var e = 0, t = 1, n = /* @__PURE__ */ Object.create(null), a = /* @__PURE__ */ Object.create(null), i = 0, s = function(c) {
    var o = a[c];
    if (o && (delete n[o], delete a[c], --e, t === o)) {
      if (!e) {
        i = 0, t = 1;
        return;
      }
      for (; !Object.prototype.hasOwnProperty.call(n, ++t); )
        ;
    }
  };
  return r = Math.abs(r), {
    hit: function(c) {
      var o = a[c], u = ++i;
      if (n[u] = c, a[c] = u, !o)
        return ++e, e <= r ? void 0 : (c = n[t], s(c), c);
      if (delete n[o], t === o)
        for (; !Object.prototype.hasOwnProperty.call(n, ++t); )
          ;
    },
    delete: s,
    clear: function() {
      e = i = 0, t = 1, n = /* @__PURE__ */ Object.create(null), a = /* @__PURE__ */ Object.create(null);
    }
  };
}
function Pn(r) {
  var {
    hasher: e,
    limit: t
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return t = t ?? Number.POSITIVE_INFINITY, e = e ?? JSON.stringify, function n() {
    typeof n.cache != "object" && (n.cache = {
      values: /* @__PURE__ */ new Map(),
      lru: Ew(t || Number.POSITIVE_INFINITY)
    });
    for (var a = [], i = 0; i < arguments.length; i++)
      a[i] = arguments[i];
    var s = e(a);
    if (n.cache.values.has(s))
      return n.cache.lru.hit(s), n.cache.values.get(s);
    var l = r.apply(r, a);
    return n.cache.values.set(s, l), n.cache.values.delete(n.cache.lru.hit(s)), l;
  };
}
var Mw = Pn(function(r) {
  return new r(1).exp();
}, {
  hasher: ui
}), Cw = Pn(function(r) {
  return new r(1).plus(new r(5).sqrt()).div(2);
}, {
  hasher: ui
}), wo = Pn(function(r) {
  return r.acos(-1);
}, {
  hasher: ui
}), _w = Pn(function(r) {
  return wo(r).times(2);
}, {
  hasher: ui
});
function ui(r) {
  return r[0].precision;
}
function oc(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Di(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? oc(Object(t), !0).forEach(function(n) {
      or(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : oc(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
var Tw = "Unit", Fw = ["?on", "config", "addScalar", "subtractScalar", "multiplyScalar", "divideScalar", "pow", "abs", "fix", "round", "equal", "isNumeric", "format", "toBest", "number", "Complex", "BigNumber", "Fraction"], Bw = /* @__PURE__ */ R(Tw, Fw, (r) => {
  var {
    on: e,
    config: t,
    addScalar: n,
    subtractScalar: a,
    multiplyScalar: i,
    divideScalar: s,
    pow: l,
    abs: c,
    fix: o,
    round: u,
    equal: f,
    isNumeric: m,
    format: p,
    toBest: d,
    number: v,
    Complex: x,
    BigNumber: h,
    Fraction: D
  } = r, y = v;
  function w(U, X) {
    if (!(this instanceof w))
      throw new Error("Constructor must be called with the new operator");
    if (!(U == null || m(U) || Zr(U)))
      throw new TypeError("First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined");
    if (this.fixPrefix = !1, this.skipAutomaticSimplification = !0, X === void 0)
      this.units = [], this.dimensions = G.map(($) => 0);
    else if (typeof X == "string") {
      var re = w.parse(X);
      this.units = re.units, this.dimensions = re.dimensions;
    } else if (Er(X) && X.value === null)
      this.fixPrefix = X.fixPrefix, this.skipAutomaticSimplification = X.skipAutomaticSimplification, this.dimensions = X.dimensions.slice(0), this.units = X.units.map(($) => hr({}, $));
    else
      throw new TypeError("Second parameter in Unit constructor must be a string or valueless Unit");
    this.value = this._normalize(U);
  }
  Object.defineProperty(w, "name", {
    value: "Unit"
  }), w.prototype.constructor = w, w.prototype.type = "Unit", w.prototype.isUnit = !0;
  var b, g, N;
  function S() {
    for (; N === " " || N === "	"; )
      M();
  }
  function A(U) {
    return U >= "0" && U <= "9" || U === ".";
  }
  function E(U) {
    return U >= "0" && U <= "9";
  }
  function M() {
    g++, N = b.charAt(g);
  }
  function T(U) {
    g = U, N = b.charAt(g);
  }
  function B() {
    var U = "", X = g;
    if (N === "+" ? M() : N === "-" && (U += N, M()), !A(N))
      return T(X), null;
    if (N === ".") {
      if (U += N, M(), !E(N))
        return T(X), null;
    } else {
      for (; E(N); )
        U += N, M();
      N === "." && (U += N, M());
    }
    for (; E(N); )
      U += N, M();
    if (N === "E" || N === "e") {
      var re = "", $ = g;
      if (re += N, M(), (N === "+" || N === "-") && (re += N, M()), !E(N))
        return T($), U;
      for (U = U + re; E(N); )
        U += N, M();
    }
    return U;
  }
  function I() {
    for (var U = ""; E(N) || w.isValidAlpha(N); )
      U += N, M();
    var X = U.charAt(0);
    return w.isValidAlpha(X) ? U : null;
  }
  function O(U) {
    return N === U ? (M(), U) : null;
  }
  w.parse = function(U, X) {
    if (X = X || {}, b = U, g = -1, N = "", typeof b != "string")
      throw new TypeError("Invalid argument in Unit.parse, string expected");
    var re = new w();
    re.units = [];
    var $ = 1, H = !1;
    M(), S();
    var Y = B(), K = null;
    if (Y) {
      if (t.number === "BigNumber")
        K = new h(Y);
      else if (t.number === "Fraction")
        try {
          K = new D(Y);
        } catch {
          K = parseFloat(Y);
        }
      else
        K = parseFloat(Y);
      S(), O("*") ? ($ = 1, H = !0) : O("/") && ($ = -1, H = !0);
    }
    for (var te = [], se = 1; ; ) {
      for (S(); N === "("; )
        te.push($), se *= $, $ = 1, M(), S();
      var fe = void 0;
      if (N) {
        var ve = N;
        if (fe = I(), fe === null)
          throw new SyntaxError('Unexpected "' + ve + '" in "' + b + '" at index ' + g.toString());
      } else
        break;
      var ge = _(fe);
      if (ge === null)
        throw new SyntaxError('Unit "' + fe + '" not found.');
      var me = $ * se;
      if (S(), O("^")) {
        S();
        var Me = B();
        if (Me === null)
          throw new SyntaxError('In "' + U + '", "^" must be followed by a floating-point number');
        me *= Me;
      }
      re.units.push({
        unit: ge.unit,
        prefix: ge.prefix,
        power: me
      });
      for (var Le = 0; Le < G.length; Le++)
        re.dimensions[Le] += (ge.unit.dimensions[Le] || 0) * me;
      for (S(); N === ")"; ) {
        if (te.length === 0)
          throw new SyntaxError('Unmatched ")" in "' + b + '" at index ' + g.toString());
        se /= te.pop(), M(), S();
      }
      if (H = !1, O("*") ? ($ = 1, H = !0) : O("/") ? ($ = -1, H = !0) : $ = 1, ge.unit.base) {
        var Ie = ge.unit.base.key;
        Q.auto[Ie] = {
          unit: ge.unit,
          prefix: ge.prefix
        };
      }
    }
    if (S(), N)
      throw new SyntaxError('Could not parse: "' + U + '"');
    if (H)
      throw new SyntaxError('Trailing characters: "' + U + '"');
    if (te.length !== 0)
      throw new SyntaxError('Unmatched "(" in "' + b + '"');
    if (re.units.length === 0 && !X.allowNoUnits)
      throw new SyntaxError('"' + U + '" contains no units');
    return re.value = K !== void 0 ? re._normalize(K) : null, re;
  }, w.prototype.clone = function() {
    var U = new w();
    U.fixPrefix = this.fixPrefix, U.skipAutomaticSimplification = this.skipAutomaticSimplification, U.value = Te(this.value), U.dimensions = this.dimensions.slice(0), U.units = [];
    for (var X = 0; X < this.units.length; X++) {
      U.units[X] = {};
      for (var re in this.units[X])
        xe(this.units[X], re) && (U.units[X][re] = this.units[X][re]);
    }
    return U;
  }, w.prototype.valueType = function() {
    return Ke(this.value);
  }, w.prototype._isDerived = function() {
    return this.units.length === 0 ? !1 : this.units.length > 1 || Math.abs(this.units[0].power - 1) > 1e-15;
  }, w.prototype._normalize = function(U) {
    if (U == null || this.units.length === 0)
      return U;
    for (var X = U, re = w._getNumberConverter(Ke(U)), $ = 0; $ < this.units.length; $++) {
      var H = re(this.units[$].unit.value), Y = re(this.units[$].prefix.value), K = re(this.units[$].power);
      X = i(X, l(i(H, Y), K));
    }
    return X;
  }, w.prototype._denormalize = function(U, X) {
    if (U == null || this.units.length === 0)
      return U;
    for (var re = U, $ = w._getNumberConverter(Ke(U)), H = 0; H < this.units.length; H++) {
      var Y = $(this.units[H].unit.value), K = $(this.units[H].prefix.value), te = $(this.units[H].power);
      re = s(re, l(i(Y, K), te));
    }
    return re;
  };
  var _ = Pn((U) => {
    if (xe(q, U)) {
      var X = q[U], re = X.prefixes[""];
      return {
        unit: X,
        prefix: re
      };
    }
    for (var $ in q)
      if (xe(q, $) && cg(U, $)) {
        var H = q[$], Y = U.length - $.length, K = U.substring(0, Y), te = xe(H.prefixes, K) ? H.prefixes[K] : void 0;
        if (te !== void 0)
          return {
            unit: H,
            prefix: te
          };
      }
    return null;
  }, {
    hasher: (U) => U[0],
    limit: 100
  });
  w.isValuelessUnit = function(U) {
    return _(U) !== null;
  }, w.prototype.hasBase = function(U) {
    if (typeof U == "string" && (U = z[U]), !U)
      return !1;
    for (var X = 0; X < G.length; X++)
      if (Math.abs((this.dimensions[X] || 0) - (U.dimensions[X] || 0)) > 1e-12)
        return !1;
    return !0;
  }, w.prototype.equalBase = function(U) {
    for (var X = 0; X < G.length; X++)
      if (Math.abs((this.dimensions[X] || 0) - (U.dimensions[X] || 0)) > 1e-12)
        return !1;
    return !0;
  }, w.prototype.equals = function(U) {
    return this.equalBase(U) && f(this.value, U.value);
  }, w.prototype.multiply = function(U) {
    for (var X = this.clone(), re = Er(U) ? U : new w(U), $ = 0; $ < G.length; $++)
      X.dimensions[$] = (this.dimensions[$] || 0) + (re.dimensions[$] || 0);
    for (var H = 0; H < re.units.length; H++) {
      var Y = Di({}, re.units[H]);
      X.units.push(Y);
    }
    if (this.value !== null || re.value !== null) {
      var K = this.value === null ? this._normalize(W(re.value)) : this.value, te = re.value === null ? re._normalize(W(this.value)) : re.value;
      X.value = i(K, te);
    } else
      X.value = null;
    return Er(U) && (X.skipAutomaticSimplification = !1), P(X);
  }, w.prototype.divideInto = function(U) {
    return new w(U).divide(this);
  }, w.prototype.divide = function(U) {
    for (var X = this.clone(), re = Er(U) ? U : new w(U), $ = 0; $ < G.length; $++)
      X.dimensions[$] = (this.dimensions[$] || 0) - (re.dimensions[$] || 0);
    for (var H = 0; H < re.units.length; H++) {
      var Y = Di(Di({}, re.units[H]), {}, {
        power: -re.units[H].power
      });
      X.units.push(Y);
    }
    if (this.value !== null || re.value !== null) {
      var K = this.value === null ? this._normalize(W(re.value)) : this.value, te = re.value === null ? re._normalize(W(this.value)) : re.value;
      X.value = s(K, te);
    } else
      X.value = null;
    return Er(U) && (X.skipAutomaticSimplification = !1), P(X);
  }, w.prototype.pow = function(U) {
    for (var X = this.clone(), re = 0; re < G.length; re++)
      X.dimensions[re] = (this.dimensions[re] || 0) * U;
    for (var $ = 0; $ < X.units.length; $++)
      X.units[$].power *= U;
    return X.value !== null ? X.value = l(X.value, U) : X.value = null, X.skipAutomaticSimplification = !1, P(X);
  };
  function P(U) {
    return U.equalBase(z.NONE) && U.value !== null && !t.predictable ? U.value : U;
  }
  function W(U) {
    var X = w._getNumberConverter(Ke(U));
    return X(1);
  }
  w.prototype.abs = function() {
    var U = this.clone();
    if (U.value !== null)
      if (U._isDerived() || U.units.length === 0 || U.units[0].unit.offset === 0)
        U.value = c(U.value);
      else {
        var X = U._numberConverter(), re = X(U.units[0].unit.value), $ = X(U.units[0].unit.offset), H = i(re, $);
        U.value = a(c(n(U.value, H)), H);
      }
    for (var Y in U.units)
      (U.units[Y].unit.name === "VA" || U.units[Y].unit.name === "VAR") && (U.units[Y].unit = q.W);
    return U;
  }, w.prototype.to = function(U) {
    var X = this.value === null ? this._normalize(1) : this.value, re;
    if (typeof U == "string")
      re = w.parse(U);
    else if (Er(U))
      re = U.clone();
    else
      throw new Error("String or Unit expected as parameter");
    if (!this.equalBase(re))
      throw new Error("Units do not match ('".concat(re.toString(), "' != '").concat(this.toString(), "')"));
    if (re.value !== null)
      throw new Error("Cannot convert to a unit with a value");
    if (this.value === null || this._isDerived() || this.units.length === 0 || re.units.length === 0 || this.units[0].unit.offset === re.units[0].unit.offset)
      re.value = Te(X);
    else {
      var $ = w._getNumberConverter(Ke(X)), H = this.units[0].unit.value, Y = this.units[0].unit.offset, K = i(H, Y), te = re.units[0].unit.value, se = re.units[0].unit.offset, fe = i(te, se);
      re.value = n(X, $(a(K, fe)));
    }
    return re.fixPrefix = !0, re.skipAutomaticSimplification = !0, re;
  }, w.prototype.toNumber = function(U) {
    return y(this.toNumeric(U));
  }, w.prototype.toNumeric = function(U) {
    var X;
    return U ? X = this.to(U) : X = this.clone(), X._isDerived() || X.units.length === 0 ? X._denormalize(X.value) : X._denormalize(X.value, X.units[0].prefix.value);
  }, w.prototype.toString = function() {
    return this.format();
  }, w.prototype.toJSON = function() {
    return {
      mathjs: "Unit",
      value: this._denormalize(this.value),
      unit: this.units.length > 0 ? this.formatUnits() : null,
      fixPrefix: this.fixPrefix
    };
  }, w.fromJSON = function(U) {
    var X, re = new w(U.value, (X = U.unit) !== null && X !== void 0 ? X : void 0);
    return re.fixPrefix = U.fixPrefix || !1, re;
  }, w.prototype.valueOf = w.prototype.toString, w.prototype.simplify = function() {
    var U = this.clone(), X = [], re;
    for (var $ in j)
      if (xe(j, $) && U.hasBase(z[$])) {
        re = $;
        break;
      }
    if (re === "NONE")
      U.units = [];
    else {
      var H;
      if (re && xe(j, re) && (H = j[re]), H)
        U.units = [{
          unit: H.unit,
          prefix: H.prefix,
          power: 1
        }];
      else {
        for (var Y = !1, K = 0; K < G.length; K++) {
          var te = G[K];
          Math.abs(U.dimensions[K] || 0) > 1e-12 && (xe(j, te) ? X.push({
            unit: j[te].unit,
            prefix: j[te].prefix,
            power: U.dimensions[K] || 0
          }) : Y = !0);
        }
        X.length < U.units.length && !Y && (U.units = X);
      }
    }
    return U;
  }, w.prototype.toSI = function() {
    for (var U = this.clone(), X = [], re = 0; re < G.length; re++) {
      var $ = G[re];
      if (Math.abs(U.dimensions[re] || 0) > 1e-12)
        if (xe(Q.si, $))
          X.push({
            unit: Q.si[$].unit,
            prefix: Q.si[$].prefix,
            power: U.dimensions[re] || 0
          });
        else
          throw new Error("Cannot express custom unit " + $ + " in SI units");
    }
    return U.units = X, U.fixPrefix = !0, U.skipAutomaticSimplification = !0, this.value !== null ? (U.value = null, this.to(U)) : U;
  }, w.prototype.formatUnits = function() {
    for (var U = "", X = "", re = 0, $ = 0, H = 0; H < this.units.length; H++)
      this.units[H].power > 0 ? (re++, U += " " + this.units[H].prefix.name + this.units[H].unit.name, Math.abs(this.units[H].power - 1) > 1e-15 && (U += "^" + this.units[H].power)) : this.units[H].power < 0 && $++;
    if ($ > 0)
      for (var Y = 0; Y < this.units.length; Y++)
        this.units[Y].power < 0 && (re > 0 ? (X += " " + this.units[Y].prefix.name + this.units[Y].unit.name, Math.abs(this.units[Y].power + 1) > 1e-15 && (X += "^" + -this.units[Y].power)) : (X += " " + this.units[Y].prefix.name + this.units[Y].unit.name, X += "^" + this.units[Y].power));
    U = U.substr(1), X = X.substr(1), re > 1 && $ > 0 && (U = "(" + U + ")"), $ > 1 && re > 0 && (X = "(" + X + ")");
    var K = U;
    return re > 0 && $ > 0 && (K += " / "), K += X, K;
  }, w.prototype.toBest = function() {
    var U = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], X = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (U && !Array.isArray(U))
      throw new Error("Invalid unit type. Expected string or Unit.");
    var re = this.units[0].unit.prefixes;
    if (U && U.length > 0) {
      var $ = U.map((K) => {
        var te = null;
        if (typeof K == "string") {
          if (te = w.parse(K), !te)
            throw new Error("Invalid unit type. Expected compatible string or Unit.");
        } else if (!Er(K))
          throw new Error("Invalid unit type. Expected compatible string or Unit.");
        te === null && (te = K.clone());
        try {
          return this.to(te.formatUnits()), te;
        } catch {
          throw new Error("Invalid unit type. Expected compatible string or Unit.");
        }
      }), H = $.map((K) => K.units[0].prefix);
      this.units[0].unit.prefixes = H.reduce((K, te) => (K[te.name] = te, K), {}), this.units[0].prefix = H[0];
    }
    var Y = L(this, X).simp;
    return this.units[0].unit.prefixes = re, Y.fixPrefix = !0, Y;
  }, w.prototype.format = function(U) {
    var {
      simp: X,
      valueStr: re,
      unitStr: $
    } = L(this, U), H = re;
    return X.value && Zr(X.value) && (H = "(" + H + ")"), $.length > 0 && H.length > 0 && (H += " "), H += $, H;
  };
  function L(U) {
    var X = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, re = U.skipAutomaticSimplification || U.value === null ? U.clone() : U.simplify();
    J(re), ee(re, X.offset);
    var $ = re._denormalize(re.value), H = re.value !== null ? p($, X || {}) : "", Y = re.formatUnits();
    return {
      simp: re,
      valueStr: H,
      unitStr: Y
    };
  }
  function J(U) {
    var X = !1;
    typeof U.value < "u" && U.value !== null && Zr(U.value) && (X = Math.abs(U.value.re) < 1e-14);
    for (var re in U.units)
      xe(U.units, re) && U.units[re].unit && (U.units[re].unit.name === "VA" && X ? U.units[re].unit = q.VAR : U.units[re].unit.name === "VAR" && !X && (U.units[re].unit = q.VA));
  }
  function ee(U, X) {
    U.units.length === 1 && !U.fixPrefix && Math.abs(U.units[0].power - Math.round(U.units[0].power)) < 1e-14 && (U.units[0].prefix = U._bestPrefix(X));
  }
  w.prototype._bestPrefix = function() {
    var U = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1.2;
    if (this.units.length !== 1)
      throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
    if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14)
      throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
    var X = this.value !== null ? c(this.value) : 0, re = c(this.units[0].unit.value), $ = this.units[0].prefix;
    if (X === 0)
      return $;
    var H = this.units[0].power, Y = Math.log(X / Math.pow($.value * re, H)) / Math.LN10 - U;
    if (Y > -2.200001 && Y < 1.800001) return $;
    Y = Math.abs(Y);
    var K = this.units[0].unit.prefixes;
    for (var te in K)
      if (xe(K, te)) {
        var se = K[te];
        if (se.scientific) {
          var fe = Math.abs(Math.log(X / Math.pow(se.value * re, H)) / Math.LN10 - U);
          (fe < Y || fe === Y && se.name.length < $.name.length) && ($ = se, Y = fe);
        }
      }
    return $;
  }, w.prototype.splitUnit = function(U) {
    for (var X = this.clone(), re = [], $ = 0; $ < U.length && (X = X.to(U[$]), $ !== U.length - 1); $++) {
      var H = X.toNumeric(), Y = u(H), K = void 0, te = f(Y, H);
      te ? K = Y : K = o(X.toNumeric());
      var se = new w(K, U[$].toString());
      re.push(se), X = a(X, se);
    }
    for (var fe = 0, ve = 0; ve < re.length; ve++)
      fe = n(fe, re[ve].value);
    return f(fe, this.value) && (X.value = 0), re.push(X), re;
  };
  var F = {
    NONE: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      }
    },
    SHORT: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      da: {
        name: "da",
        value: 10,
        scientific: !1
      },
      h: {
        name: "h",
        value: 100,
        scientific: !1
      },
      k: {
        name: "k",
        value: 1e3,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e6,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e9,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e12,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e15,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e18,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e21,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e24,
        scientific: !0
      },
      R: {
        name: "R",
        value: 1e27,
        scientific: !0
      },
      Q: {
        name: "Q",
        value: 1e30,
        scientific: !0
      },
      d: {
        name: "d",
        value: 0.1,
        scientific: !1
      },
      c: {
        name: "c",
        value: 0.01,
        scientific: !1
      },
      m: {
        name: "m",
        value: 1e-3,
        scientific: !0
      },
      u: {
        name: "u",
        value: 1e-6,
        scientific: !0
      },
      n: {
        name: "n",
        value: 1e-9,
        scientific: !0
      },
      p: {
        name: "p",
        value: 1e-12,
        scientific: !0
      },
      f: {
        name: "f",
        value: 1e-15,
        scientific: !0
      },
      a: {
        name: "a",
        value: 1e-18,
        scientific: !0
      },
      z: {
        name: "z",
        value: 1e-21,
        scientific: !0
      },
      y: {
        name: "y",
        value: 1e-24,
        scientific: !0
      },
      r: {
        name: "r",
        value: 1e-27,
        scientific: !0
      },
      q: {
        name: "q",
        value: 1e-30,
        scientific: !0
      }
    },
    LONG: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      deca: {
        name: "deca",
        value: 10,
        scientific: !1
      },
      hecto: {
        name: "hecto",
        value: 100,
        scientific: !1
      },
      kilo: {
        name: "kilo",
        value: 1e3,
        scientific: !0
      },
      mega: {
        name: "mega",
        value: 1e6,
        scientific: !0
      },
      giga: {
        name: "giga",
        value: 1e9,
        scientific: !0
      },
      tera: {
        name: "tera",
        value: 1e12,
        scientific: !0
      },
      peta: {
        name: "peta",
        value: 1e15,
        scientific: !0
      },
      exa: {
        name: "exa",
        value: 1e18,
        scientific: !0
      },
      zetta: {
        name: "zetta",
        value: 1e21,
        scientific: !0
      },
      yotta: {
        name: "yotta",
        value: 1e24,
        scientific: !0
      },
      ronna: {
        name: "ronna",
        value: 1e27,
        scientific: !0
      },
      quetta: {
        name: "quetta",
        value: 1e30,
        scientific: !0
      },
      deci: {
        name: "deci",
        value: 0.1,
        scientific: !1
      },
      centi: {
        name: "centi",
        value: 0.01,
        scientific: !1
      },
      milli: {
        name: "milli",
        value: 1e-3,
        scientific: !0
      },
      micro: {
        name: "micro",
        value: 1e-6,
        scientific: !0
      },
      nano: {
        name: "nano",
        value: 1e-9,
        scientific: !0
      },
      pico: {
        name: "pico",
        value: 1e-12,
        scientific: !0
      },
      femto: {
        name: "femto",
        value: 1e-15,
        scientific: !0
      },
      atto: {
        name: "atto",
        value: 1e-18,
        scientific: !0
      },
      zepto: {
        name: "zepto",
        value: 1e-21,
        scientific: !0
      },
      yocto: {
        name: "yocto",
        value: 1e-24,
        scientific: !0
      },
      ronto: {
        name: "ronto",
        value: 1e-27,
        scientific: !0
      },
      quecto: {
        name: "quecto",
        value: 1e-30,
        scientific: !0
      }
    },
    SQUARED: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      da: {
        name: "da",
        value: 100,
        scientific: !1
      },
      h: {
        name: "h",
        value: 1e4,
        scientific: !1
      },
      k: {
        name: "k",
        value: 1e6,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e12,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e18,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e24,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e30,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e36,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e42,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e48,
        scientific: !0
      },
      R: {
        name: "R",
        value: 1e54,
        scientific: !0
      },
      Q: {
        name: "Q",
        value: 1e60,
        scientific: !0
      },
      d: {
        name: "d",
        value: 0.01,
        scientific: !1
      },
      c: {
        name: "c",
        value: 1e-4,
        scientific: !1
      },
      m: {
        name: "m",
        value: 1e-6,
        scientific: !0
      },
      u: {
        name: "u",
        value: 1e-12,
        scientific: !0
      },
      n: {
        name: "n",
        value: 1e-18,
        scientific: !0
      },
      p: {
        name: "p",
        value: 1e-24,
        scientific: !0
      },
      f: {
        name: "f",
        value: 1e-30,
        scientific: !0
      },
      a: {
        name: "a",
        value: 1e-36,
        scientific: !0
      },
      z: {
        name: "z",
        value: 1e-42,
        scientific: !0
      },
      y: {
        name: "y",
        value: 1e-48,
        scientific: !0
      },
      r: {
        name: "r",
        value: 1e-54,
        scientific: !0
      },
      q: {
        name: "q",
        value: 1e-60,
        scientific: !0
      }
    },
    CUBIC: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      da: {
        name: "da",
        value: 1e3,
        scientific: !1
      },
      h: {
        name: "h",
        value: 1e6,
        scientific: !1
      },
      k: {
        name: "k",
        value: 1e9,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e18,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e27,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e36,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e45,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e54,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e63,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e72,
        scientific: !0
      },
      R: {
        name: "R",
        value: 1e81,
        scientific: !0
      },
      Q: {
        name: "Q",
        value: 1e90,
        scientific: !0
      },
      d: {
        name: "d",
        value: 1e-3,
        scientific: !1
      },
      c: {
        name: "c",
        value: 1e-6,
        scientific: !1
      },
      m: {
        name: "m",
        value: 1e-9,
        scientific: !0
      },
      u: {
        name: "u",
        value: 1e-18,
        scientific: !0
      },
      n: {
        name: "n",
        value: 1e-27,
        scientific: !0
      },
      p: {
        name: "p",
        value: 1e-36,
        scientific: !0
      },
      f: {
        name: "f",
        value: 1e-45,
        scientific: !0
      },
      a: {
        name: "a",
        value: 1e-54,
        scientific: !0
      },
      z: {
        name: "z",
        value: 1e-63,
        scientific: !0
      },
      y: {
        name: "y",
        value: 1e-72,
        scientific: !0
      },
      r: {
        name: "r",
        value: 1e-81,
        scientific: !0
      },
      q: {
        name: "q",
        value: 1e-90,
        scientific: !0
      }
    },
    BINARY_SHORT_SI: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      k: {
        name: "k",
        value: 1e3,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e6,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e9,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e12,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e15,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e18,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e21,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e24,
        scientific: !0
      }
    },
    BINARY_SHORT_IEC: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      Ki: {
        name: "Ki",
        value: 1024,
        scientific: !0
      },
      Mi: {
        name: "Mi",
        value: Math.pow(1024, 2),
        scientific: !0
      },
      Gi: {
        name: "Gi",
        value: Math.pow(1024, 3),
        scientific: !0
      },
      Ti: {
        name: "Ti",
        value: Math.pow(1024, 4),
        scientific: !0
      },
      Pi: {
        name: "Pi",
        value: Math.pow(1024, 5),
        scientific: !0
      },
      Ei: {
        name: "Ei",
        value: Math.pow(1024, 6),
        scientific: !0
      },
      Zi: {
        name: "Zi",
        value: Math.pow(1024, 7),
        scientific: !0
      },
      Yi: {
        name: "Yi",
        value: Math.pow(1024, 8),
        scientific: !0
      }
    },
    BINARY_LONG_SI: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      kilo: {
        name: "kilo",
        value: 1e3,
        scientific: !0
      },
      mega: {
        name: "mega",
        value: 1e6,
        scientific: !0
      },
      giga: {
        name: "giga",
        value: 1e9,
        scientific: !0
      },
      tera: {
        name: "tera",
        value: 1e12,
        scientific: !0
      },
      peta: {
        name: "peta",
        value: 1e15,
        scientific: !0
      },
      exa: {
        name: "exa",
        value: 1e18,
        scientific: !0
      },
      zetta: {
        name: "zetta",
        value: 1e21,
        scientific: !0
      },
      yotta: {
        name: "yotta",
        value: 1e24,
        scientific: !0
      }
    },
    BINARY_LONG_IEC: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      kibi: {
        name: "kibi",
        value: 1024,
        scientific: !0
      },
      mebi: {
        name: "mebi",
        value: Math.pow(1024, 2),
        scientific: !0
      },
      gibi: {
        name: "gibi",
        value: Math.pow(1024, 3),
        scientific: !0
      },
      tebi: {
        name: "tebi",
        value: Math.pow(1024, 4),
        scientific: !0
      },
      pebi: {
        name: "pebi",
        value: Math.pow(1024, 5),
        scientific: !0
      },
      exi: {
        name: "exi",
        value: Math.pow(1024, 6),
        scientific: !0
      },
      zebi: {
        name: "zebi",
        value: Math.pow(1024, 7),
        scientific: !0
      },
      yobi: {
        name: "yobi",
        value: Math.pow(1024, 8),
        scientific: !0
      }
    },
    BTU: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      MM: {
        name: "MM",
        value: 1e6,
        scientific: !0
      }
    }
  };
  F.SHORTLONG = hr({}, F.SHORT, F.LONG), F.BINARY_SHORT = hr({}, F.BINARY_SHORT_SI, F.BINARY_SHORT_IEC), F.BINARY_LONG = hr({}, F.BINARY_LONG_SI, F.BINARY_LONG_IEC);
  var G = ["MASS", "LENGTH", "TIME", "CURRENT", "TEMPERATURE", "LUMINOUS_INTENSITY", "AMOUNT_OF_SUBSTANCE", "ANGLE", "BIT"], z = {
    NONE: {
      dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    MASS: {
      dimensions: [1, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    LENGTH: {
      dimensions: [0, 1, 0, 0, 0, 0, 0, 0, 0]
    },
    TIME: {
      dimensions: [0, 0, 1, 0, 0, 0, 0, 0, 0]
    },
    CURRENT: {
      dimensions: [0, 0, 0, 1, 0, 0, 0, 0, 0]
    },
    TEMPERATURE: {
      dimensions: [0, 0, 0, 0, 1, 0, 0, 0, 0]
    },
    LUMINOUS_INTENSITY: {
      dimensions: [0, 0, 0, 0, 0, 1, 0, 0, 0]
    },
    AMOUNT_OF_SUBSTANCE: {
      dimensions: [0, 0, 0, 0, 0, 0, 1, 0, 0]
    },
    FORCE: {
      dimensions: [1, 1, -2, 0, 0, 0, 0, 0, 0]
    },
    SURFACE: {
      dimensions: [0, 2, 0, 0, 0, 0, 0, 0, 0]
    },
    VOLUME: {
      dimensions: [0, 3, 0, 0, 0, 0, 0, 0, 0]
    },
    ENERGY: {
      dimensions: [1, 2, -2, 0, 0, 0, 0, 0, 0]
    },
    POWER: {
      dimensions: [1, 2, -3, 0, 0, 0, 0, 0, 0]
    },
    PRESSURE: {
      dimensions: [1, -1, -2, 0, 0, 0, 0, 0, 0]
    },
    ELECTRIC_CHARGE: {
      dimensions: [0, 0, 1, 1, 0, 0, 0, 0, 0]
    },
    ELECTRIC_CAPACITANCE: {
      dimensions: [-1, -2, 4, 2, 0, 0, 0, 0, 0]
    },
    ELECTRIC_POTENTIAL: {
      dimensions: [1, 2, -3, -1, 0, 0, 0, 0, 0]
    },
    ELECTRIC_RESISTANCE: {
      dimensions: [1, 2, -3, -2, 0, 0, 0, 0, 0]
    },
    ELECTRIC_INDUCTANCE: {
      dimensions: [1, 2, -2, -2, 0, 0, 0, 0, 0]
    },
    ELECTRIC_CONDUCTANCE: {
      dimensions: [-1, -2, 3, 2, 0, 0, 0, 0, 0]
    },
    MAGNETIC_FLUX: {
      dimensions: [1, 2, -2, -1, 0, 0, 0, 0, 0]
    },
    MAGNETIC_FLUX_DENSITY: {
      dimensions: [1, 0, -2, -1, 0, 0, 0, 0, 0]
    },
    FREQUENCY: {
      dimensions: [0, 0, -1, 0, 0, 0, 0, 0, 0]
    },
    ANGLE: {
      dimensions: [0, 0, 0, 0, 0, 0, 0, 1, 0]
    },
    BIT: {
      dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 1]
    }
  };
  for (var le in z)
    xe(z, le) && (z[le].key = le);
  var ne = {}, ae = {
    name: "",
    base: ne,
    value: 1,
    offset: 0,
    dimensions: G.map((U) => 0)
  }, q = {
    // length
    meter: {
      name: "meter",
      base: z.LENGTH,
      prefixes: F.LONG,
      value: 1,
      offset: 0
    },
    inch: {
      name: "inch",
      base: z.LENGTH,
      prefixes: F.NONE,
      value: 0.0254,
      offset: 0
    },
    foot: {
      name: "foot",
      base: z.LENGTH,
      prefixes: F.NONE,
      value: 0.3048,
      offset: 0
    },
    yard: {
      name: "yard",
      base: z.LENGTH,
      prefixes: F.NONE,
      value: 0.9144,
      offset: 0
    },
    mile: {
      name: "mile",
      base: z.LENGTH,
      prefixes: F.NONE,
      value: 1609.344,
      offset: 0
    },
    link: {
      name: "link",
      base: z.LENGTH,
      prefixes: F.NONE,
      value: 0.201168,
      offset: 0
    },
    rod: {
      name: "rod",
      base: z.LENGTH,
      prefixes: F.NONE,
      value: 5.0292,
      offset: 0
    },
    chain: {
      name: "chain",
      base: z.LENGTH,
      prefixes: F.NONE,
      value: 20.1168,
      offset: 0
    },
    angstrom: {
      name: "angstrom",
      base: z.LENGTH,
      prefixes: F.NONE,
      value: 1e-10,
      offset: 0
    },
    m: {
      name: "m",
      base: z.LENGTH,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    in: {
      name: "in",
      base: z.LENGTH,
      prefixes: F.NONE,
      value: 0.0254,
      offset: 0
    },
    ft: {
      name: "ft",
      base: z.LENGTH,
      prefixes: F.NONE,
      value: 0.3048,
      offset: 0
    },
    yd: {
      name: "yd",
      base: z.LENGTH,
      prefixes: F.NONE,
      value: 0.9144,
      offset: 0
    },
    mi: {
      name: "mi",
      base: z.LENGTH,
      prefixes: F.NONE,
      value: 1609.344,
      offset: 0
    },
    li: {
      name: "li",
      base: z.LENGTH,
      prefixes: F.NONE,
      value: 0.201168,
      offset: 0
    },
    rd: {
      name: "rd",
      base: z.LENGTH,
      prefixes: F.NONE,
      value: 5.02921,
      offset: 0
    },
    ch: {
      name: "ch",
      base: z.LENGTH,
      prefixes: F.NONE,
      value: 20.1168,
      offset: 0
    },
    mil: {
      name: "mil",
      base: z.LENGTH,
      prefixes: F.NONE,
      value: 254e-7,
      offset: 0
    },
    // 1/1000 inch
    // Surface
    m2: {
      name: "m2",
      base: z.SURFACE,
      prefixes: F.SQUARED,
      value: 1,
      offset: 0
    },
    sqin: {
      name: "sqin",
      base: z.SURFACE,
      prefixes: F.NONE,
      value: 64516e-8,
      offset: 0
    },
    // 645.16 mm2
    sqft: {
      name: "sqft",
      base: z.SURFACE,
      prefixes: F.NONE,
      value: 0.09290304,
      offset: 0
    },
    // 0.09290304 m2
    sqyd: {
      name: "sqyd",
      base: z.SURFACE,
      prefixes: F.NONE,
      value: 0.83612736,
      offset: 0
    },
    // 0.83612736 m2
    sqmi: {
      name: "sqmi",
      base: z.SURFACE,
      prefixes: F.NONE,
      value: 2589988110336e-6,
      offset: 0
    },
    // 2.589988110336 km2
    sqrd: {
      name: "sqrd",
      base: z.SURFACE,
      prefixes: F.NONE,
      value: 25.29295,
      offset: 0
    },
    // 25.29295 m2
    sqch: {
      name: "sqch",
      base: z.SURFACE,
      prefixes: F.NONE,
      value: 404.6873,
      offset: 0
    },
    // 404.6873 m2
    sqmil: {
      name: "sqmil",
      base: z.SURFACE,
      prefixes: F.NONE,
      value: 64516e-14,
      offset: 0
    },
    // 6.4516 * 10^-10 m2
    acre: {
      name: "acre",
      base: z.SURFACE,
      prefixes: F.NONE,
      value: 4046.86,
      offset: 0
    },
    // 4046.86 m2
    hectare: {
      name: "hectare",
      base: z.SURFACE,
      prefixes: F.NONE,
      value: 1e4,
      offset: 0
    },
    // 10000 m2
    // Volume
    m3: {
      name: "m3",
      base: z.VOLUME,
      prefixes: F.CUBIC,
      value: 1,
      offset: 0
    },
    L: {
      name: "L",
      base: z.VOLUME,
      prefixes: F.SHORT,
      value: 1e-3,
      offset: 0
    },
    // litre
    l: {
      name: "l",
      base: z.VOLUME,
      prefixes: F.SHORT,
      value: 1e-3,
      offset: 0
    },
    // litre
    litre: {
      name: "litre",
      base: z.VOLUME,
      prefixes: F.LONG,
      value: 1e-3,
      offset: 0
    },
    cuin: {
      name: "cuin",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 16387064e-12,
      offset: 0
    },
    // 1.6387064e-5 m3
    cuft: {
      name: "cuft",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 0.028316846592,
      offset: 0
    },
    // 28.316 846 592 L
    cuyd: {
      name: "cuyd",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 0.764554857984,
      offset: 0
    },
    // 764.554 857 984 L
    teaspoon: {
      name: "teaspoon",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 5e-6,
      offset: 0
    },
    // 5 mL
    tablespoon: {
      name: "tablespoon",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 15e-6,
      offset: 0
    },
    // 15 mL
    // {name: 'cup', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.000240, offset: 0}, // 240 mL  // not possible, we have already another cup
    drop: {
      name: "drop",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 5e-8,
      offset: 0
    },
    // 0.05 mL = 5e-8 m3
    gtt: {
      name: "gtt",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 5e-8,
      offset: 0
    },
    // 0.05 mL = 5e-8 m3
    // Liquid volume
    minim: {
      name: "minim",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 61611519921875e-21,
      offset: 0
    },
    // 1/61440 gallons
    fluiddram: {
      name: "fluiddram",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 36966911953125e-19,
      offset: 0
    },
    // 1/1024 gallons
    fluidounce: {
      name: "fluidounce",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 295735295625e-16,
      offset: 0
    },
    // 1/128 gallons
    gill: {
      name: "gill",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 11829411825e-14,
      offset: 0
    },
    // 1/32 gallons
    cc: {
      name: "cc",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 1e-6,
      offset: 0
    },
    // 1e-6 L
    cup: {
      name: "cup",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 2365882365e-13,
      offset: 0
    },
    // 1/16 gallons
    pint: {
      name: "pint",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 473176473e-12,
      offset: 0
    },
    // 1/8 gallons
    quart: {
      name: "quart",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 946352946e-12,
      offset: 0
    },
    // 1/4 gallons
    gallon: {
      name: "gallon",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 0.003785411784,
      offset: 0
    },
    // 3.785411784 L
    beerbarrel: {
      name: "beerbarrel",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 0.117347765304,
      offset: 0
    },
    // 31 gallons
    oilbarrel: {
      name: "oilbarrel",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 0.158987294928,
      offset: 0
    },
    // 42 gallons
    hogshead: {
      name: "hogshead",
      base: z.VOLUME,
      prefixes: F.NONE,
      value: 0.238480942392,
      offset: 0
    },
    // 63 gallons
    // Mass
    g: {
      name: "g",
      base: z.MASS,
      prefixes: F.SHORT,
      value: 1e-3,
      offset: 0
    },
    gram: {
      name: "gram",
      base: z.MASS,
      prefixes: F.LONG,
      value: 1e-3,
      offset: 0
    },
    ton: {
      name: "ton",
      base: z.MASS,
      prefixes: F.SHORT,
      value: 907.18474,
      offset: 0
    },
    t: {
      name: "t",
      base: z.MASS,
      prefixes: F.SHORT,
      value: 1e3,
      offset: 0
    },
    tonne: {
      name: "tonne",
      base: z.MASS,
      prefixes: F.LONG,
      value: 1e3,
      offset: 0
    },
    grain: {
      name: "grain",
      base: z.MASS,
      prefixes: F.NONE,
      value: 6479891e-11,
      offset: 0
    },
    dram: {
      name: "dram",
      base: z.MASS,
      prefixes: F.NONE,
      value: 0.0017718451953125,
      offset: 0
    },
    ounce: {
      name: "ounce",
      base: z.MASS,
      prefixes: F.NONE,
      value: 0.028349523125,
      offset: 0
    },
    poundmass: {
      name: "poundmass",
      base: z.MASS,
      prefixes: F.NONE,
      value: 0.45359237,
      offset: 0
    },
    hundredweight: {
      name: "hundredweight",
      base: z.MASS,
      prefixes: F.NONE,
      value: 45.359237,
      offset: 0
    },
    stick: {
      name: "stick",
      base: z.MASS,
      prefixes: F.NONE,
      value: 0.115,
      offset: 0
    },
    stone: {
      name: "stone",
      base: z.MASS,
      prefixes: F.NONE,
      value: 6.35029318,
      offset: 0
    },
    gr: {
      name: "gr",
      base: z.MASS,
      prefixes: F.NONE,
      value: 6479891e-11,
      offset: 0
    },
    dr: {
      name: "dr",
      base: z.MASS,
      prefixes: F.NONE,
      value: 0.0017718451953125,
      offset: 0
    },
    oz: {
      name: "oz",
      base: z.MASS,
      prefixes: F.NONE,
      value: 0.028349523125,
      offset: 0
    },
    lbm: {
      name: "lbm",
      base: z.MASS,
      prefixes: F.NONE,
      value: 0.45359237,
      offset: 0
    },
    cwt: {
      name: "cwt",
      base: z.MASS,
      prefixes: F.NONE,
      value: 45.359237,
      offset: 0
    },
    // Time
    s: {
      name: "s",
      base: z.TIME,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    min: {
      name: "min",
      base: z.TIME,
      prefixes: F.NONE,
      value: 60,
      offset: 0
    },
    h: {
      name: "h",
      base: z.TIME,
      prefixes: F.NONE,
      value: 3600,
      offset: 0
    },
    second: {
      name: "second",
      base: z.TIME,
      prefixes: F.LONG,
      value: 1,
      offset: 0
    },
    sec: {
      name: "sec",
      base: z.TIME,
      prefixes: F.LONG,
      value: 1,
      offset: 0
    },
    minute: {
      name: "minute",
      base: z.TIME,
      prefixes: F.NONE,
      value: 60,
      offset: 0
    },
    hour: {
      name: "hour",
      base: z.TIME,
      prefixes: F.NONE,
      value: 3600,
      offset: 0
    },
    day: {
      name: "day",
      base: z.TIME,
      prefixes: F.NONE,
      value: 86400,
      offset: 0
    },
    week: {
      name: "week",
      base: z.TIME,
      prefixes: F.NONE,
      value: 7 * 86400,
      offset: 0
    },
    month: {
      name: "month",
      base: z.TIME,
      prefixes: F.NONE,
      value: 2629800,
      // 1/12th of Julian year
      offset: 0
    },
    year: {
      name: "year",
      base: z.TIME,
      prefixes: F.NONE,
      value: 31557600,
      // Julian year
      offset: 0
    },
    decade: {
      name: "decade",
      base: z.TIME,
      prefixes: F.NONE,
      value: 315576e3,
      // Julian decade
      offset: 0
    },
    century: {
      name: "century",
      base: z.TIME,
      prefixes: F.NONE,
      value: 315576e4,
      // Julian century
      offset: 0
    },
    millennium: {
      name: "millennium",
      base: z.TIME,
      prefixes: F.NONE,
      value: 315576e5,
      // Julian millennium
      offset: 0
    },
    // Frequency
    hertz: {
      name: "Hertz",
      base: z.FREQUENCY,
      prefixes: F.LONG,
      value: 1,
      offset: 0,
      reciprocal: !0
    },
    Hz: {
      name: "Hz",
      base: z.FREQUENCY,
      prefixes: F.SHORT,
      value: 1,
      offset: 0,
      reciprocal: !0
    },
    // Angle
    rad: {
      name: "rad",
      base: z.ANGLE,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    radian: {
      name: "radian",
      base: z.ANGLE,
      prefixes: F.LONG,
      value: 1,
      offset: 0
    },
    // deg = rad / (2*pi) * 360 = rad / 0.017453292519943295769236907684888
    deg: {
      name: "deg",
      base: z.ANGLE,
      prefixes: F.SHORT,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    degree: {
      name: "degree",
      base: z.ANGLE,
      prefixes: F.LONG,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // grad = rad / (2*pi) * 400  = rad / 0.015707963267948966192313216916399
    grad: {
      name: "grad",
      base: z.ANGLE,
      prefixes: F.SHORT,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    gradian: {
      name: "gradian",
      base: z.ANGLE,
      prefixes: F.LONG,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // cycle = rad / (2*pi) = rad / 6.2831853071795864769252867665793
    cycle: {
      name: "cycle",
      base: z.ANGLE,
      prefixes: F.NONE,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // arcsec = rad / (3600 * (360 / 2 * pi)) = rad / 0.0000048481368110953599358991410235795
    arcsec: {
      name: "arcsec",
      base: z.ANGLE,
      prefixes: F.NONE,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // arcmin = rad / (60 * (360 / 2 * pi)) = rad / 0.00029088820866572159615394846141477
    arcmin: {
      name: "arcmin",
      base: z.ANGLE,
      prefixes: F.NONE,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // Electric current
    A: {
      name: "A",
      base: z.CURRENT,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    ampere: {
      name: "ampere",
      base: z.CURRENT,
      prefixes: F.LONG,
      value: 1,
      offset: 0
    },
    // Temperature
    // K(C) = °C + 273.15
    // K(F) = (°F + 459.67) * (5 / 9)
    // K(R) = °R * (5 / 9)
    K: {
      name: "K",
      base: z.TEMPERATURE,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    degC: {
      name: "degC",
      base: z.TEMPERATURE,
      prefixes: F.SHORT,
      value: 1,
      offset: 273.15
    },
    degF: {
      name: "degF",
      base: z.TEMPERATURE,
      prefixes: F.SHORT,
      value: new D(5, 9),
      offset: 459.67
    },
    degR: {
      name: "degR",
      base: z.TEMPERATURE,
      prefixes: F.SHORT,
      value: new D(5, 9),
      offset: 0
    },
    kelvin: {
      name: "kelvin",
      base: z.TEMPERATURE,
      prefixes: F.LONG,
      value: 1,
      offset: 0
    },
    celsius: {
      name: "celsius",
      base: z.TEMPERATURE,
      prefixes: F.LONG,
      value: 1,
      offset: 273.15
    },
    fahrenheit: {
      name: "fahrenheit",
      base: z.TEMPERATURE,
      prefixes: F.LONG,
      value: new D(5, 9),
      offset: 459.67
    },
    rankine: {
      name: "rankine",
      base: z.TEMPERATURE,
      prefixes: F.LONG,
      value: new D(5, 9),
      offset: 0
    },
    // amount of substance
    mol: {
      name: "mol",
      base: z.AMOUNT_OF_SUBSTANCE,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    mole: {
      name: "mole",
      base: z.AMOUNT_OF_SUBSTANCE,
      prefixes: F.LONG,
      value: 1,
      offset: 0
    },
    // luminous intensity
    cd: {
      name: "cd",
      base: z.LUMINOUS_INTENSITY,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    candela: {
      name: "candela",
      base: z.LUMINOUS_INTENSITY,
      prefixes: F.LONG,
      value: 1,
      offset: 0
    },
    // TODO: units STERADIAN
    // {name: 'sr', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
    // {name: 'steradian', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
    // Force
    N: {
      name: "N",
      base: z.FORCE,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    newton: {
      name: "newton",
      base: z.FORCE,
      prefixes: F.LONG,
      value: 1,
      offset: 0
    },
    dyn: {
      name: "dyn",
      base: z.FORCE,
      prefixes: F.SHORT,
      value: 1e-5,
      offset: 0
    },
    dyne: {
      name: "dyne",
      base: z.FORCE,
      prefixes: F.LONG,
      value: 1e-5,
      offset: 0
    },
    lbf: {
      name: "lbf",
      base: z.FORCE,
      prefixes: F.NONE,
      value: 4.4482216152605,
      offset: 0
    },
    poundforce: {
      name: "poundforce",
      base: z.FORCE,
      prefixes: F.NONE,
      value: 4.4482216152605,
      offset: 0
    },
    kip: {
      name: "kip",
      base: z.FORCE,
      prefixes: F.LONG,
      value: 4448.2216,
      offset: 0
    },
    kilogramforce: {
      name: "kilogramforce",
      base: z.FORCE,
      prefixes: F.NONE,
      value: 9.80665,
      offset: 0
    },
    // Energy
    J: {
      name: "J",
      base: z.ENERGY,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    joule: {
      name: "joule",
      base: z.ENERGY,
      prefixes: F.LONG,
      value: 1,
      offset: 0
    },
    erg: {
      name: "erg",
      base: z.ENERGY,
      prefixes: F.SHORTLONG,
      // Both kiloerg and kerg are acceptable
      value: 1e-7,
      offset: 0
    },
    Wh: {
      name: "Wh",
      base: z.ENERGY,
      prefixes: F.SHORT,
      value: 3600,
      offset: 0
    },
    BTU: {
      name: "BTU",
      base: z.ENERGY,
      prefixes: F.BTU,
      value: 1055.05585262,
      offset: 0
    },
    eV: {
      name: "eV",
      base: z.ENERGY,
      prefixes: F.SHORT,
      value: 1602176565e-28,
      offset: 0
    },
    electronvolt: {
      name: "electronvolt",
      base: z.ENERGY,
      prefixes: F.LONG,
      value: 1602176565e-28,
      offset: 0
    },
    // Power
    W: {
      name: "W",
      base: z.POWER,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    watt: {
      name: "watt",
      base: z.POWER,
      prefixes: F.LONG,
      value: 1,
      offset: 0
    },
    hp: {
      name: "hp",
      base: z.POWER,
      prefixes: F.NONE,
      value: 745.6998715386,
      offset: 0
    },
    // Electrical power units
    VAR: {
      name: "VAR",
      base: z.POWER,
      prefixes: F.SHORT,
      value: x.I,
      offset: 0
    },
    VA: {
      name: "VA",
      base: z.POWER,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    // Pressure
    Pa: {
      name: "Pa",
      base: z.PRESSURE,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    psi: {
      name: "psi",
      base: z.PRESSURE,
      prefixes: F.NONE,
      value: 6894.75729276459,
      offset: 0
    },
    atm: {
      name: "atm",
      base: z.PRESSURE,
      prefixes: F.NONE,
      value: 101325,
      offset: 0
    },
    bar: {
      name: "bar",
      base: z.PRESSURE,
      prefixes: F.SHORTLONG,
      value: 1e5,
      offset: 0
    },
    torr: {
      name: "torr",
      base: z.PRESSURE,
      prefixes: F.NONE,
      value: 133.322,
      offset: 0
    },
    mmHg: {
      name: "mmHg",
      base: z.PRESSURE,
      prefixes: F.NONE,
      value: 133.322,
      offset: 0
    },
    mmH2O: {
      name: "mmH2O",
      base: z.PRESSURE,
      prefixes: F.NONE,
      value: 9.80665,
      offset: 0
    },
    cmH2O: {
      name: "cmH2O",
      base: z.PRESSURE,
      prefixes: F.NONE,
      value: 98.0665,
      offset: 0
    },
    // Electric charge
    coulomb: {
      name: "coulomb",
      base: z.ELECTRIC_CHARGE,
      prefixes: F.LONG,
      value: 1,
      offset: 0
    },
    C: {
      name: "C",
      base: z.ELECTRIC_CHARGE,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    // Electric capacitance
    farad: {
      name: "farad",
      base: z.ELECTRIC_CAPACITANCE,
      prefixes: F.LONG,
      value: 1,
      offset: 0
    },
    F: {
      name: "F",
      base: z.ELECTRIC_CAPACITANCE,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    // Electric potential
    volt: {
      name: "volt",
      base: z.ELECTRIC_POTENTIAL,
      prefixes: F.LONG,
      value: 1,
      offset: 0
    },
    V: {
      name: "V",
      base: z.ELECTRIC_POTENTIAL,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    // Electric resistance
    ohm: {
      name: "ohm",
      base: z.ELECTRIC_RESISTANCE,
      prefixes: F.SHORTLONG,
      // Both Mohm and megaohm are acceptable
      value: 1,
      offset: 0
    },
    /*
     * Unicode breaks in browsers if charset is not specified
    Ω: {
      name: 'Ω',
      base: BASE_UNITS.ELECTRIC_RESISTANCE,
      prefixes: PREFIXES.SHORT,
      value: 1,
      offset: 0
    },
    */
    // Electric inductance
    henry: {
      name: "henry",
      base: z.ELECTRIC_INDUCTANCE,
      prefixes: F.LONG,
      value: 1,
      offset: 0
    },
    H: {
      name: "H",
      base: z.ELECTRIC_INDUCTANCE,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    // Electric conductance
    siemens: {
      name: "siemens",
      base: z.ELECTRIC_CONDUCTANCE,
      prefixes: F.LONG,
      value: 1,
      offset: 0
    },
    S: {
      name: "S",
      base: z.ELECTRIC_CONDUCTANCE,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    // Magnetic flux
    weber: {
      name: "weber",
      base: z.MAGNETIC_FLUX,
      prefixes: F.LONG,
      value: 1,
      offset: 0
    },
    Wb: {
      name: "Wb",
      base: z.MAGNETIC_FLUX,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    // Magnetic flux density
    tesla: {
      name: "tesla",
      base: z.MAGNETIC_FLUX_DENSITY,
      prefixes: F.LONG,
      value: 1,
      offset: 0
    },
    T: {
      name: "T",
      base: z.MAGNETIC_FLUX_DENSITY,
      prefixes: F.SHORT,
      value: 1,
      offset: 0
    },
    // Binary
    b: {
      name: "b",
      base: z.BIT,
      prefixes: F.BINARY_SHORT,
      value: 1,
      offset: 0
    },
    bits: {
      name: "bits",
      base: z.BIT,
      prefixes: F.BINARY_LONG,
      value: 1,
      offset: 0
    },
    B: {
      name: "B",
      base: z.BIT,
      prefixes: F.BINARY_SHORT,
      value: 8,
      offset: 0
    },
    bytes: {
      name: "bytes",
      base: z.BIT,
      prefixes: F.BINARY_LONG,
      value: 8,
      offset: 0
    }
  }, k = {
    meters: "meter",
    inches: "inch",
    feet: "foot",
    yards: "yard",
    miles: "mile",
    links: "link",
    rods: "rod",
    chains: "chain",
    angstroms: "angstrom",
    lt: "l",
    litres: "litre",
    liter: "litre",
    liters: "litre",
    teaspoons: "teaspoon",
    tablespoons: "tablespoon",
    minims: "minim",
    fldr: "fluiddram",
    fluiddrams: "fluiddram",
    floz: "fluidounce",
    fluidounces: "fluidounce",
    gi: "gill",
    gills: "gill",
    cp: "cup",
    cups: "cup",
    pt: "pint",
    pints: "pint",
    qt: "quart",
    quarts: "quart",
    gal: "gallon",
    gallons: "gallon",
    bbl: "beerbarrel",
    beerbarrels: "beerbarrel",
    obl: "oilbarrel",
    oilbarrels: "oilbarrel",
    hogsheads: "hogshead",
    gtts: "gtt",
    grams: "gram",
    tons: "ton",
    tonnes: "tonne",
    grains: "grain",
    drams: "dram",
    ounces: "ounce",
    poundmasses: "poundmass",
    hundredweights: "hundredweight",
    sticks: "stick",
    lb: "lbm",
    lbs: "lbm",
    kips: "kip",
    kgf: "kilogramforce",
    acres: "acre",
    hectares: "hectare",
    sqfeet: "sqft",
    sqyard: "sqyd",
    sqmile: "sqmi",
    sqmiles: "sqmi",
    mmhg: "mmHg",
    mmh2o: "mmH2O",
    cmh2o: "cmH2O",
    seconds: "second",
    secs: "second",
    minutes: "minute",
    mins: "minute",
    hours: "hour",
    hr: "hour",
    hrs: "hour",
    days: "day",
    weeks: "week",
    months: "month",
    years: "year",
    decades: "decade",
    centuries: "century",
    millennia: "millennium",
    hertz: "hertz",
    radians: "radian",
    degrees: "degree",
    gradians: "gradian",
    cycles: "cycle",
    arcsecond: "arcsec",
    arcseconds: "arcsec",
    arcminute: "arcmin",
    arcminutes: "arcmin",
    BTUs: "BTU",
    watts: "watt",
    joules: "joule",
    amperes: "ampere",
    amps: "ampere",
    amp: "ampere",
    coulombs: "coulomb",
    volts: "volt",
    ohms: "ohm",
    farads: "farad",
    webers: "weber",
    teslas: "tesla",
    electronvolts: "electronvolt",
    moles: "mole",
    bit: "bits",
    byte: "bytes"
  };
  function Z(U) {
    if (U.number === "BigNumber") {
      var X = wo(h);
      q.rad.value = new h(1), q.deg.value = X.div(180), q.grad.value = X.div(200), q.cycle.value = X.times(2), q.arcsec.value = X.div(648e3), q.arcmin.value = X.div(10800);
    } else
      q.rad.value = 1, q.deg.value = Math.PI / 180, q.grad.value = Math.PI / 200, q.cycle.value = Math.PI * 2, q.arcsec.value = Math.PI / 648e3, q.arcmin.value = Math.PI / 10800;
    q.radian.value = q.rad.value, q.degree.value = q.deg.value, q.gradian.value = q.grad.value;
  }
  Z(t), e && e("config", function(U, X) {
    U.number !== X.number && Z(U);
  });
  var Q = {
    si: {
      // Base units
      NONE: {
        unit: ae,
        prefix: F.NONE[""]
      },
      LENGTH: {
        unit: q.m,
        prefix: F.SHORT[""]
      },
      MASS: {
        unit: q.g,
        prefix: F.SHORT.k
      },
      TIME: {
        unit: q.s,
        prefix: F.SHORT[""]
      },
      CURRENT: {
        unit: q.A,
        prefix: F.SHORT[""]
      },
      TEMPERATURE: {
        unit: q.K,
        prefix: F.SHORT[""]
      },
      LUMINOUS_INTENSITY: {
        unit: q.cd,
        prefix: F.SHORT[""]
      },
      AMOUNT_OF_SUBSTANCE: {
        unit: q.mol,
        prefix: F.SHORT[""]
      },
      ANGLE: {
        unit: q.rad,
        prefix: F.SHORT[""]
      },
      BIT: {
        unit: q.bits,
        prefix: F.SHORT[""]
      },
      // Derived units
      FORCE: {
        unit: q.N,
        prefix: F.SHORT[""]
      },
      ENERGY: {
        unit: q.J,
        prefix: F.SHORT[""]
      },
      POWER: {
        unit: q.W,
        prefix: F.SHORT[""]
      },
      PRESSURE: {
        unit: q.Pa,
        prefix: F.SHORT[""]
      },
      ELECTRIC_CHARGE: {
        unit: q.C,
        prefix: F.SHORT[""]
      },
      ELECTRIC_CAPACITANCE: {
        unit: q.F,
        prefix: F.SHORT[""]
      },
      ELECTRIC_POTENTIAL: {
        unit: q.V,
        prefix: F.SHORT[""]
      },
      ELECTRIC_RESISTANCE: {
        unit: q.ohm,
        prefix: F.SHORT[""]
      },
      ELECTRIC_INDUCTANCE: {
        unit: q.H,
        prefix: F.SHORT[""]
      },
      ELECTRIC_CONDUCTANCE: {
        unit: q.S,
        prefix: F.SHORT[""]
      },
      MAGNETIC_FLUX: {
        unit: q.Wb,
        prefix: F.SHORT[""]
      },
      MAGNETIC_FLUX_DENSITY: {
        unit: q.T,
        prefix: F.SHORT[""]
      },
      FREQUENCY: {
        unit: q.Hz,
        prefix: F.SHORT[""]
      }
    }
  };
  Q.cgs = JSON.parse(JSON.stringify(Q.si)), Q.cgs.LENGTH = {
    unit: q.m,
    prefix: F.SHORT.c
  }, Q.cgs.MASS = {
    unit: q.g,
    prefix: F.SHORT[""]
  }, Q.cgs.FORCE = {
    unit: q.dyn,
    prefix: F.SHORT[""]
  }, Q.cgs.ENERGY = {
    unit: q.erg,
    prefix: F.NONE[""]
  }, Q.us = JSON.parse(JSON.stringify(Q.si)), Q.us.LENGTH = {
    unit: q.ft,
    prefix: F.NONE[""]
  }, Q.us.MASS = {
    unit: q.lbm,
    prefix: F.NONE[""]
  }, Q.us.TEMPERATURE = {
    unit: q.degF,
    prefix: F.NONE[""]
  }, Q.us.FORCE = {
    unit: q.lbf,
    prefix: F.NONE[""]
  }, Q.us.ENERGY = {
    unit: q.BTU,
    prefix: F.BTU[""]
  }, Q.us.POWER = {
    unit: q.hp,
    prefix: F.NONE[""]
  }, Q.us.PRESSURE = {
    unit: q.psi,
    prefix: F.NONE[""]
  }, Q.auto = JSON.parse(JSON.stringify(Q.si));
  var j = Q.auto;
  w.setUnitSystem = function(U) {
    if (xe(Q, U))
      j = Q[U];
    else
      throw new Error("Unit system " + U + " does not exist. Choices are: " + Object.keys(Q).join(", "));
  }, w.getUnitSystem = function() {
    for (var U in Q)
      if (xe(Q, U) && Q[U] === j)
        return U;
  }, w.typeConverters = {
    BigNumber: function(X) {
      return X != null && X.isFraction ? new h(String(X.n)).div(String(X.d)).times(String(X.s)) : new h(X + "");
    },
    Fraction: function(X) {
      return new D(X);
    },
    Complex: function(X) {
      return X;
    },
    number: function(X) {
      return X != null && X.isFraction ? v(X) : X;
    }
  }, w.prototype._numberConverter = function() {
    var U = w.typeConverters[this.valueType()];
    if (U)
      return U;
    throw new TypeError('Unsupported Unit value type "' + this.valueType() + '"');
  }, w._getNumberConverter = function(U) {
    if (!w.typeConverters[U])
      throw new TypeError('Unsupported type "' + U + '"');
    return w.typeConverters[U];
  };
  for (var ce in q)
    if (xe(q, ce)) {
      var oe = q[ce];
      oe.dimensions = oe.base.dimensions;
    }
  for (var he in k)
    if (xe(k, he)) {
      var we = q[k[he]], De = {};
      for (var ye in we)
        xe(we, ye) && (De[ye] = we[ye]);
      De.name = he, q[he] = De;
    }
  w.isValidAlpha = function(X) {
    return /^[a-zA-Z]$/.test(X);
  };
  function Ae(U) {
    for (var X = 0; X < U.length; X++) {
      if (N = U.charAt(X), X === 0 && !w.isValidAlpha(N))
        throw new Error('Invalid unit name (must begin with alpha character): "' + U + '"');
      if (X > 0 && !(w.isValidAlpha(N) || E(N)))
        throw new Error('Invalid unit name (only alphanumeric characters are allowed): "' + U + '"');
    }
  }
  return w.createUnit = function(U, X) {
    if (typeof U != "object")
      throw new TypeError("createUnit expects first parameter to be of type 'Object'");
    if (X && X.override) {
      for (var re in U)
        if (xe(U, re) && w.deleteUnit(re), U[re].aliases)
          for (var $ = 0; $ < U[re].aliases.length; $++)
            w.deleteUnit(U[re].aliases[$]);
    }
    var H;
    for (var Y in U)
      xe(U, Y) && (H = w.createUnitSingle(Y, U[Y]));
    return H;
  }, w.createUnitSingle = function(U, X) {
    if ((typeof X > "u" || X === null) && (X = {}), typeof U != "string")
      throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");
    if (xe(q, U))
      throw new Error('Cannot create unit "' + U + '": a unit with that name already exists');
    Ae(U);
    var re = null, $ = [], H = 0, Y, K, te;
    if (X && X.type === "Unit")
      re = X.clone();
    else if (typeof X == "string")
      X !== "" && (Y = X);
    else if (typeof X == "object")
      Y = X.definition, K = X.prefixes, H = X.offset, te = X.baseName, X.aliases && ($ = X.aliases.valueOf());
    else
      throw new TypeError('Cannot create unit "' + U + '" from "' + X.toString() + '": expecting "string" or "Unit" or "Object"');
    if ($) {
      for (var se = 0; se < $.length; se++)
        if (xe(q, $[se]))
          throw new Error('Cannot create alias "' + $[se] + '": a unit with that name already exists');
    }
    if (Y && typeof Y == "string" && !re)
      try {
        re = w.parse(Y, {
          allowNoUnits: !0
        });
      } catch (Fe) {
        throw Fe.message = 'Could not create unit "' + U + '" from "' + Y + '": ' + Fe.message, Fe;
      }
    else Y && Y.type === "Unit" && (re = Y.clone());
    $ = $ || [], H = H || 0, K && K.toUpperCase ? K = F[K.toUpperCase()] || F.NONE : K = F.NONE;
    var fe = {};
    if (re) {
      fe = {
        name: U,
        value: re.value,
        dimensions: re.dimensions.slice(0),
        prefixes: K,
        offset: H
      };
      var Me = !1;
      for (var Le in z)
        if (xe(z, Le)) {
          for (var Ie = !0, ar = 0; ar < G.length; ar++)
            if (Math.abs((fe.dimensions[ar] || 0) - (z[Le].dimensions[ar] || 0)) > 1e-12) {
              Ie = !1;
              break;
            }
          if (Ie) {
            Me = !0, fe.base = z[Le];
            break;
          }
        }
      if (!Me) {
        te = te || U + "_STUFF";
        var C = {
          dimensions: re.dimensions.slice(0)
        };
        C.key = te, z[te] = C, j[te] = {
          unit: fe,
          prefix: F.NONE[""]
        }, fe.base = z[te];
      }
    } else {
      if (te = te || U + "_STUFF", G.indexOf(te) >= 0)
        throw new Error('Cannot create new base unit "' + U + '": a base unit with that name already exists (and cannot be overridden)');
      G.push(te);
      for (var ve in z)
        xe(z, ve) && (z[ve].dimensions[G.length - 1] = 0);
      for (var ge = {
        dimensions: []
      }, me = 0; me < G.length; me++)
        ge.dimensions[me] = 0;
      ge.dimensions[G.length - 1] = 1, ge.key = te, z[te] = ge, fe = {
        name: U,
        value: 1,
        dimensions: z[te].dimensions.slice(0),
        prefixes: K,
        offset: H,
        base: z[te]
      }, j[te] = {
        unit: fe,
        prefix: F.NONE[""]
      };
    }
    w.UNITS[U] = fe;
    for (var V = 0; V < $.length; V++) {
      var ie = $[V], de = {};
      for (var _e in fe)
        xe(fe, _e) && (de[_e] = fe[_e]);
      de.name = ie, w.UNITS[ie] = de;
    }
    return delete _.cache, new w(null, U);
  }, w.deleteUnit = function(U) {
    delete w.UNITS[U], delete _.cache;
  }, w.PREFIXES = F, w.BASE_DIMENSIONS = G, w.BASE_UNITS = z, w.UNIT_SYSTEMS = Q, w.UNITS = q, w;
}, {
  isClass: !0
}), sc = "unit", Ow = ["typed", "Unit"], Iw = /* @__PURE__ */ R(sc, Ow, (r) => {
  var {
    typed: e,
    Unit: t
  } = r;
  return e(sc, {
    Unit: function(a) {
      return a.clone();
    },
    string: function(a) {
      return t.isValuelessUnit(a) ? new t(null, a) : t.parse(a, {
        allowNoUnits: !0
      });
    },
    "number | BigNumber | Fraction | Complex, string | Unit": function(a, i) {
      return new t(a, i);
    },
    "number | BigNumber | Fraction": function(a) {
      return new t(a);
    },
    "Array | Matrix": e.referToSelf((n) => (a) => Pe(a, n))
  });
}), uc = "sparse", $w = ["typed", "SparseMatrix"], zw = /* @__PURE__ */ R(uc, $w, (r) => {
  var {
    typed: e,
    SparseMatrix: t
  } = r;
  return e(uc, {
    "": function() {
      return new t([]);
    },
    string: function(a) {
      return new t([], a);
    },
    "Array | Matrix": function(a) {
      return new t(a);
    },
    "Array | Matrix, string": function(a, i) {
      return new t(a, i);
    }
  });
}), cc = "createUnit", Rw = ["typed", "Unit"], qw = /* @__PURE__ */ R(cc, Rw, (r) => {
  var {
    typed: e,
    Unit: t
  } = r;
  return e(cc, {
    // General function signature. First parameter is an object where each property is the definition of a new unit. The object keys are the unit names and the values are the definitions. The values can be objects, strings, or Units. If a property is an empty object or an empty string, a new base unit is created. The second parameter is the options.
    "Object, Object": function(a, i) {
      return t.createUnit(a, i);
    },
    // Same as above but without the options.
    Object: function(a) {
      return t.createUnit(a, {});
    },
    // Shortcut method for creating one unit.
    "string, Unit | string | Object, Object": function(a, i, s) {
      var l = {};
      return l[a] = i, t.createUnit(l, s);
    },
    // Same as above but without the options.
    "string, Unit | string | Object": function(a, i) {
      var s = {};
      return s[a] = i, t.createUnit(s, {});
    },
    // Without a definition, creates a base unit.
    string: function(a) {
      var i = {};
      return i[a] = {}, t.createUnit(i, {});
    }
  });
}), lc = "acos", Pw = ["typed", "config", "Complex"], Uw = /* @__PURE__ */ R(lc, Pw, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n
  } = r;
  return e(lc, {
    number: function(i) {
      return i >= -1 && i <= 1 || t.predictable ? Math.acos(i) : new n(i, 0).acos();
    },
    Complex: function(i) {
      return i.acos();
    },
    BigNumber: function(i) {
      return i.acos();
    }
  });
}), fc = "acosh", Lw = ["typed", "config", "Complex"], kw = /* @__PURE__ */ R(fc, Lw, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n
  } = r;
  return e(fc, {
    number: function(i) {
      return i >= 1 || t.predictable ? Xm(i) : i <= -1 ? new n(Math.log(Math.sqrt(i * i - 1) - i), Math.PI) : new n(i, 0).acosh();
    },
    Complex: function(i) {
      return i.acosh();
    },
    BigNumber: function(i) {
      return i.acosh();
    }
  });
}), mc = "acot", Hw = ["typed", "BigNumber"], Ww = /* @__PURE__ */ R(mc, Hw, (r) => {
  var {
    typed: e,
    BigNumber: t
  } = r;
  return e(mc, {
    number: Ym,
    Complex: function(a) {
      return a.acot();
    },
    BigNumber: function(a) {
      return new t(1).div(a).atan();
    }
  });
}), pc = "acoth", Gw = ["typed", "config", "Complex", "BigNumber"], Vw = /* @__PURE__ */ R(pc, Gw, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n,
    BigNumber: a
  } = r;
  return e(pc, {
    number: function(s) {
      return s >= 1 || s <= -1 || t.predictable ? Jm(s) : new n(s, 0).acoth();
    },
    Complex: function(s) {
      return s.acoth();
    },
    BigNumber: function(s) {
      return new a(1).div(s).atanh();
    }
  });
}), dc = "acsc", Zw = ["typed", "config", "Complex", "BigNumber"], Xw = /* @__PURE__ */ R(dc, Zw, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n,
    BigNumber: a
  } = r;
  return e(dc, {
    number: function(s) {
      return s <= -1 || s >= 1 || t.predictable ? Qm(s) : new n(s, 0).acsc();
    },
    Complex: function(s) {
      return s.acsc();
    },
    BigNumber: function(s) {
      return new a(1).div(s).asin();
    }
  });
}), vc = "acsch", Yw = ["typed", "BigNumber"], Jw = /* @__PURE__ */ R(vc, Yw, (r) => {
  var {
    typed: e,
    BigNumber: t
  } = r;
  return e(vc, {
    number: jm,
    Complex: function(a) {
      return a.acsch();
    },
    BigNumber: function(a) {
      return new t(1).div(a).asinh();
    }
  });
}), hc = "asec", Qw = ["typed", "config", "Complex", "BigNumber"], jw = /* @__PURE__ */ R(hc, Qw, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n,
    BigNumber: a
  } = r;
  return e(hc, {
    number: function(s) {
      return s <= -1 || s >= 1 || t.predictable ? Km(s) : new n(s, 0).asec();
    },
    Complex: function(s) {
      return s.asec();
    },
    BigNumber: function(s) {
      return new a(1).div(s).acos();
    }
  });
}), gc = "asech", Kw = ["typed", "config", "Complex", "BigNumber"], eD = /* @__PURE__ */ R(gc, Kw, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n,
    BigNumber: a
  } = r;
  return e(gc, {
    number: function(s) {
      if (s <= 1 && s >= -1 || t.predictable) {
        var l = 1 / s;
        if (l > 0 || t.predictable)
          return ep(s);
        var c = Math.sqrt(l * l - 1);
        return new n(Math.log(c - l), Math.PI);
      }
      return new n(s, 0).asech();
    },
    Complex: function(s) {
      return s.asech();
    },
    BigNumber: function(s) {
      return new a(1).div(s).acosh();
    }
  });
}), yc = "asin", rD = ["typed", "config", "Complex"], tD = /* @__PURE__ */ R(yc, rD, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n
  } = r;
  return e(yc, {
    number: function(i) {
      return i >= -1 && i <= 1 || t.predictable ? Math.asin(i) : new n(i, 0).asin();
    },
    Complex: function(i) {
      return i.asin();
    },
    BigNumber: function(i) {
      return i.asin();
    }
  });
}), nD = "asinh", aD = ["typed"], iD = /* @__PURE__ */ R(nD, aD, (r) => {
  var {
    typed: e
  } = r;
  return e("asinh", {
    number: rp,
    Complex: function(n) {
      return n.asinh();
    },
    BigNumber: function(n) {
      return n.asinh();
    }
  });
}), oD = "atan", sD = ["typed"], uD = /* @__PURE__ */ R(oD, sD, (r) => {
  var {
    typed: e
  } = r;
  return e("atan", {
    number: function(n) {
      return Math.atan(n);
    },
    Complex: function(n) {
      return n.atan();
    },
    BigNumber: function(n) {
      return n.atan();
    }
  });
}), bc = "atan2", cD = ["typed", "matrix", "equalScalar", "BigNumber", "DenseMatrix", "concat"], lD = /* @__PURE__ */ R(bc, cD, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    BigNumber: a,
    DenseMatrix: i,
    concat: s
  } = r, l = Jr({
    typed: e,
    equalScalar: n
  }), c = Ar({
    typed: e
  }), o = Tp({
    typed: e,
    equalScalar: n
  }), u = br({
    typed: e,
    equalScalar: n
  }), f = cr({
    typed: e,
    DenseMatrix: i
  }), m = rr({
    typed: e,
    matrix: t,
    concat: s
  });
  return e(bc, {
    "number, number": Math.atan2,
    // Complex numbers doesn't seem to have a reasonable implementation of
    // atan2(). Even Matlab removed the support, after they only calculated
    // the atan only on base of the real part of the numbers and ignored
    // the imaginary.
    "BigNumber, BigNumber": (p, d) => a.atan2(p, d)
  }, m({
    scalar: "number | BigNumber",
    SS: o,
    DS: c,
    SD: l,
    Ss: u,
    sS: f
  }));
}), xc = "atanh", fD = ["typed", "config", "Complex"], mD = /* @__PURE__ */ R(xc, fD, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n
  } = r;
  return e(xc, {
    number: function(i) {
      return i <= 1 && i >= -1 || t.predictable ? tp(i) : new n(i, 0).atanh();
    },
    Complex: function(i) {
      return i.atanh();
    },
    BigNumber: function(i) {
      return i.atanh();
    }
  });
}), gn = /* @__PURE__ */ R("trigUnit", ["typed"], (r) => {
  var {
    typed: e
  } = r;
  return {
    Unit: e.referToSelf((t) => (n) => {
      if (!n.hasBase(n.constructor.BASE_UNITS.ANGLE))
        throw new TypeError("Unit in function cot is no angle");
      return e.find(t, n.valueType())(n.value);
    })
  };
}), wc = "cos", pD = ["typed"], dD = /* @__PURE__ */ R(wc, pD, (r) => {
  var {
    typed: e
  } = r, t = gn({
    typed: e
  });
  return e(wc, {
    number: Math.cos,
    "Complex | BigNumber": (n) => n.cos()
  }, t);
}), Dc = "cosh", vD = ["typed"], hD = /* @__PURE__ */ R(Dc, vD, (r) => {
  var {
    typed: e
  } = r;
  return e(Dc, {
    number: Uv,
    "Complex | BigNumber": (t) => t.cosh()
  });
}), Nc = "cot", gD = ["typed", "BigNumber"], yD = /* @__PURE__ */ R(Nc, gD, (r) => {
  var {
    typed: e,
    BigNumber: t
  } = r, n = gn({
    typed: e
  });
  return e(Nc, {
    number: np,
    Complex: (a) => a.cot(),
    BigNumber: (a) => new t(1).div(a.tan())
  }, n);
}), Ac = "coth", bD = ["typed", "BigNumber"], xD = /* @__PURE__ */ R(Ac, bD, (r) => {
  var {
    typed: e,
    BigNumber: t
  } = r;
  return e(Ac, {
    number: ap,
    Complex: (n) => n.coth(),
    BigNumber: (n) => new t(1).div(n.tanh())
  });
}), Sc = "csc", wD = ["typed", "BigNumber"], DD = /* @__PURE__ */ R(Sc, wD, (r) => {
  var {
    typed: e,
    BigNumber: t
  } = r, n = gn({
    typed: e
  });
  return e(Sc, {
    number: ip,
    Complex: (a) => a.csc(),
    BigNumber: (a) => new t(1).div(a.sin())
  }, n);
}), Ec = "csch", ND = ["typed", "BigNumber"], AD = /* @__PURE__ */ R(Ec, ND, (r) => {
  var {
    typed: e,
    BigNumber: t
  } = r;
  return e(Ec, {
    number: op,
    Complex: (n) => n.csch(),
    BigNumber: (n) => new t(1).div(n.sinh())
  });
}), Mc = "sec", SD = ["typed", "BigNumber"], ED = /* @__PURE__ */ R(Mc, SD, (r) => {
  var {
    typed: e,
    BigNumber: t
  } = r, n = gn({
    typed: e
  });
  return e(Mc, {
    number: sp,
    Complex: (a) => a.sec(),
    BigNumber: (a) => new t(1).div(a.cos())
  }, n);
}), Cc = "sech", MD = ["typed", "BigNumber"], CD = /* @__PURE__ */ R(Cc, MD, (r) => {
  var {
    typed: e,
    BigNumber: t
  } = r;
  return e(Cc, {
    number: up,
    Complex: (n) => n.sech(),
    BigNumber: (n) => new t(1).div(n.cosh())
  });
}), _c = "sin", _D = ["typed"], TD = /* @__PURE__ */ R(_c, _D, (r) => {
  var {
    typed: e
  } = r, t = gn({
    typed: e
  });
  return e(_c, {
    number: Math.sin,
    "Complex | BigNumber": (n) => n.sin()
  }, t);
}), Tc = "sinh", FD = ["typed"], BD = /* @__PURE__ */ R(Tc, FD, (r) => {
  var {
    typed: e
  } = r;
  return e(Tc, {
    number: cp,
    "Complex | BigNumber": (t) => t.sinh()
  });
}), Fc = "tan", OD = ["typed"], ID = /* @__PURE__ */ R(Fc, OD, (r) => {
  var {
    typed: e
  } = r, t = gn({
    typed: e
  });
  return e(Fc, {
    number: Math.tan,
    "Complex | BigNumber": (n) => n.tan()
  }, t);
}), $D = "tanh", zD = ["typed"], RD = /* @__PURE__ */ R($D, zD, (r) => {
  var {
    typed: e
  } = r;
  return e("tanh", {
    number: kv,
    "Complex | BigNumber": (t) => t.tanh()
  });
}), Bc = "setCartesian", qD = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], PD = /* @__PURE__ */ R(Bc, qD, (r) => {
  var {
    typed: e,
    size: t,
    subset: n,
    compareNatural: a,
    Index: i,
    DenseMatrix: s
  } = r;
  return e(Bc, {
    "Array | Matrix, Array | Matrix": function(c, o) {
      var u = [];
      if (n(t(c), new i(0)) !== 0 && n(t(o), new i(0)) !== 0) {
        var f = Ve(Array.isArray(c) ? c : c.toArray()).sort(a), m = Ve(Array.isArray(o) ? o : o.toArray()).sort(a);
        u = [];
        for (var p = 0; p < f.length; p++)
          for (var d = 0; d < m.length; d++)
            u.push([f[p], m[d]]);
      }
      return Array.isArray(c) && Array.isArray(o) ? u : new s(u);
    }
  });
}), Oc = "setDifference", UD = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], LD = /* @__PURE__ */ R(Oc, UD, (r) => {
  var {
    typed: e,
    size: t,
    subset: n,
    compareNatural: a,
    Index: i,
    DenseMatrix: s
  } = r;
  return e(Oc, {
    "Array | Matrix, Array | Matrix": function(c, o) {
      var u;
      if (n(t(c), new i(0)) === 0)
        u = [];
      else {
        if (n(t(o), new i(0)) === 0)
          return Ve(c.toArray());
        var f = cn(Ve(Array.isArray(c) ? c : c.toArray()).sort(a)), m = cn(Ve(Array.isArray(o) ? o : o.toArray()).sort(a));
        u = [];
        for (var p, d = 0; d < f.length; d++) {
          p = !1;
          for (var v = 0; v < m.length; v++)
            if (a(f[d].value, m[v].value) === 0 && f[d].identifier === m[v].identifier) {
              p = !0;
              break;
            }
          p || u.push(f[d]);
        }
      }
      return Array.isArray(c) && Array.isArray(o) ? Fa(u) : new s(Fa(u));
    }
  });
}), Ic = "setDistinct", kD = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], HD = /* @__PURE__ */ R(Ic, kD, (r) => {
  var {
    typed: e,
    size: t,
    subset: n,
    compareNatural: a,
    Index: i,
    DenseMatrix: s
  } = r;
  return e(Ic, {
    "Array | Matrix": function(c) {
      var o;
      if (n(t(c), new i(0)) === 0)
        o = [];
      else {
        var u = Ve(Array.isArray(c) ? c : c.toArray()).sort(a);
        o = [], o.push(u[0]);
        for (var f = 1; f < u.length; f++)
          a(u[f], u[f - 1]) !== 0 && o.push(u[f]);
      }
      return Array.isArray(c) ? o : new s(o);
    }
  });
}), $c = "setIntersect", WD = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], GD = /* @__PURE__ */ R($c, WD, (r) => {
  var {
    typed: e,
    size: t,
    subset: n,
    compareNatural: a,
    Index: i,
    DenseMatrix: s
  } = r;
  return e($c, {
    "Array | Matrix, Array | Matrix": function(c, o) {
      var u;
      if (n(t(c), new i(0)) === 0 || n(t(o), new i(0)) === 0)
        u = [];
      else {
        var f = cn(Ve(Array.isArray(c) ? c : c.toArray()).sort(a)), m = cn(Ve(Array.isArray(o) ? o : o.toArray()).sort(a));
        u = [];
        for (var p = 0; p < f.length; p++)
          for (var d = 0; d < m.length; d++)
            if (a(f[p].value, m[d].value) === 0 && f[p].identifier === m[d].identifier) {
              u.push(f[p]);
              break;
            }
      }
      return Array.isArray(c) && Array.isArray(o) ? Fa(u) : new s(Fa(u));
    }
  });
}), zc = "setIsSubset", VD = ["typed", "size", "subset", "compareNatural", "Index"], ZD = /* @__PURE__ */ R(zc, VD, (r) => {
  var {
    typed: e,
    size: t,
    subset: n,
    compareNatural: a,
    Index: i
  } = r;
  return e(zc, {
    "Array | Matrix, Array | Matrix": function(l, c) {
      if (n(t(l), new i(0)) === 0)
        return !0;
      if (n(t(c), new i(0)) === 0)
        return !1;
      for (var o = cn(Ve(Array.isArray(l) ? l : l.toArray()).sort(a)), u = cn(Ve(Array.isArray(c) ? c : c.toArray()).sort(a)), f, m = 0; m < o.length; m++) {
        f = !1;
        for (var p = 0; p < u.length; p++)
          if (a(o[m].value, u[p].value) === 0 && o[m].identifier === u[p].identifier) {
            f = !0;
            break;
          }
        if (f === !1)
          return !1;
      }
      return !0;
    }
  });
}), Rc = "setMultiplicity", XD = ["typed", "size", "subset", "compareNatural", "Index"], YD = /* @__PURE__ */ R(Rc, XD, (r) => {
  var {
    typed: e,
    size: t,
    subset: n,
    compareNatural: a,
    Index: i
  } = r;
  return e(Rc, {
    "number | BigNumber | Fraction | Complex, Array | Matrix": function(l, c) {
      if (n(t(c), new i(0)) === 0)
        return 0;
      for (var o = Ve(Array.isArray(c) ? c : c.toArray()), u = 0, f = 0; f < o.length; f++)
        a(o[f], l) === 0 && u++;
      return u;
    }
  });
}), qc = "setPowerset", JD = ["typed", "size", "subset", "compareNatural", "Index"], QD = /* @__PURE__ */ R(qc, JD, (r) => {
  var {
    typed: e,
    size: t,
    subset: n,
    compareNatural: a,
    Index: i
  } = r;
  return e(qc, {
    "Array | Matrix": function(o) {
      if (n(t(o), new i(0)) === 0)
        return [];
      for (var u = Ve(Array.isArray(o) ? o : o.toArray()).sort(a), f = [], m = 0; m.toString(2).length <= u.length; )
        f.push(s(u, m.toString(2).split("").reverse())), m++;
      return l(f);
    }
  });
  function s(c, o) {
    for (var u = [], f = 0; f < o.length; f++)
      o[f] === "1" && u.push(c[f]);
    return u;
  }
  function l(c) {
    for (var o = [], u = c.length - 1; u > 0; u--)
      for (var f = 0; f < u; f++)
        c[f].length > c[f + 1].length && (o = c[f], c[f] = c[f + 1], c[f + 1] = o);
    return c;
  }
}), Pc = "setSize", jD = ["typed", "compareNatural"], KD = /* @__PURE__ */ R(Pc, jD, (r) => {
  var {
    typed: e,
    compareNatural: t
  } = r;
  return e(Pc, {
    "Array | Matrix": function(a) {
      return Array.isArray(a) ? Ve(a).length : Ve(a.toArray()).length;
    },
    "Array | Matrix, boolean": function(a, i) {
      if (i === !1 || a.length === 0)
        return Array.isArray(a) ? Ve(a).length : Ve(a.toArray()).length;
      for (var s = Ve(Array.isArray(a) ? a : a.toArray()).sort(t), l = 1, c = 1; c < s.length; c++)
        t(s[c], s[c - 1]) !== 0 && l++;
      return l;
    }
  });
}), Uc = "setSymDifference", e2 = ["typed", "size", "concat", "subset", "setDifference", "Index"], r2 = /* @__PURE__ */ R(Uc, e2, (r) => {
  var {
    typed: e,
    size: t,
    concat: n,
    subset: a,
    setDifference: i,
    Index: s
  } = r;
  return e(Uc, {
    "Array | Matrix, Array | Matrix": function(c, o) {
      if (a(t(c), new s(0)) === 0)
        return Ve(o);
      if (a(t(o), new s(0)) === 0)
        return Ve(c);
      var u = Ve(c), f = Ve(o);
      return n(i(u, f), i(f, u));
    }
  });
}), Lc = "setUnion", t2 = ["typed", "size", "concat", "subset", "setIntersect", "setSymDifference", "Index"], n2 = /* @__PURE__ */ R(Lc, t2, (r) => {
  var {
    typed: e,
    size: t,
    concat: n,
    subset: a,
    setIntersect: i,
    setSymDifference: s,
    Index: l
  } = r;
  return e(Lc, {
    "Array | Matrix, Array | Matrix": function(o, u) {
      if (a(t(o), new l(0)) === 0)
        return Ve(u);
      if (a(t(u), new l(0)) === 0)
        return Ve(o);
      var f = Ve(o), m = Ve(u);
      return n(s(f, m), i(f, m));
    }
  });
}), kc = "add", a2 = ["typed", "matrix", "addScalar", "equalScalar", "DenseMatrix", "SparseMatrix", "concat"], od = /* @__PURE__ */ R(kc, a2, (r) => {
  var {
    typed: e,
    matrix: t,
    addScalar: n,
    equalScalar: a,
    DenseMatrix: i,
    SparseMatrix: s,
    concat: l
  } = r, c = Mt({
    typed: e
  }), o = mo({
    typed: e,
    equalScalar: a
  }), u = Lt({
    typed: e,
    DenseMatrix: i
  }), f = rr({
    typed: e,
    matrix: t,
    concat: l
  });
  return e(kc, {
    "any, any": n,
    "any, any, ...any": e.referToSelf((m) => (p, d, v) => {
      for (var x = m(p, d), h = 0; h < v.length; h++)
        x = m(x, v[h]);
      return x;
    })
  }, f({
    elop: n,
    DS: c,
    SS: o,
    Ss: u
  }));
}), Hc = "hypot", i2 = ["typed", "abs", "addScalar", "divideScalar", "multiplyScalar", "sqrt", "smaller", "isPositive"], o2 = /* @__PURE__ */ R(Hc, i2, (r) => {
  var {
    typed: e,
    abs: t,
    addScalar: n,
    divideScalar: a,
    multiplyScalar: i,
    sqrt: s,
    smaller: l,
    isPositive: c
  } = r;
  return e(Hc, {
    "... number | BigNumber": o,
    Array: o,
    Matrix: (u) => o(Ve(u.toArray(), !0))
  });
  function o(u) {
    for (var f = 0, m = 0, p = 0; p < u.length; p++) {
      if (Zr(u[p]))
        throw new TypeError("Unexpected type of argument to hypot");
      var d = t(u[p]);
      l(m, d) ? (f = i(f, i(a(m, d), a(m, d))), f = n(f, 1), m = d) : f = n(f, c(d) ? i(a(d, m), a(d, m)) : d);
    }
    return i(m, s(f));
  }
}), Wc = "norm", s2 = ["typed", "abs", "add", "pow", "conj", "sqrt", "multiply", "equalScalar", "larger", "smaller", "matrix", "ctranspose", "eigs"], u2 = /* @__PURE__ */ R(Wc, s2, (r) => {
  var {
    typed: e,
    abs: t,
    add: n,
    pow: a,
    conj: i,
    sqrt: s,
    multiply: l,
    equalScalar: c,
    larger: o,
    smaller: u,
    matrix: f,
    ctranspose: m,
    eigs: p
  } = r;
  return e(Wc, {
    number: Math.abs,
    Complex: function(S) {
      return S.abs();
    },
    BigNumber: function(S) {
      return S.abs();
    },
    boolean: function(S) {
      return Math.abs(S);
    },
    Array: function(S) {
      return g(f(S), 2);
    },
    Matrix: function(S) {
      return g(S, 2);
    },
    "Array, number | BigNumber | string": function(S, A) {
      return g(f(S), A);
    },
    "Matrix, number | BigNumber | string": function(S, A) {
      return g(S, A);
    }
  });
  function d(N) {
    var S = 0;
    return N.forEach(function(A) {
      var E = t(A);
      o(E, S) && (S = E);
    }, !0), S;
  }
  function v(N) {
    var S;
    return N.forEach(function(A) {
      var E = t(A);
      (!S || u(E, S)) && (S = E);
    }, !0), S || 0;
  }
  function x(N, S) {
    if (S === Number.POSITIVE_INFINITY || S === "inf")
      return d(N);
    if (S === Number.NEGATIVE_INFINITY || S === "-inf")
      return v(N);
    if (S === "fro")
      return g(N, 2);
    if (typeof S == "number" && !isNaN(S)) {
      if (!c(S, 0)) {
        var A = 0;
        return N.forEach(function(E) {
          A = n(a(t(E), S), A);
        }, !0), a(A, 1 / S);
      }
      return Number.POSITIVE_INFINITY;
    }
    throw new Error("Unsupported parameter value");
  }
  function h(N) {
    var S = 0;
    return N.forEach(function(A, E) {
      S = n(S, l(A, i(A)));
    }), t(s(S));
  }
  function D(N) {
    var S = [], A = 0;
    return N.forEach(function(E, M) {
      var T = M[1], B = n(S[T] || 0, t(E));
      o(B, A) && (A = B), S[T] = B;
    }, !0), A;
  }
  function y(N) {
    var S = N.size();
    if (S[0] !== S[1])
      throw new RangeError("Invalid matrix dimensions");
    var A = m(N), E = l(A, N), M = p(E).values.toArray(), T = M[M.length - 1];
    return t(s(T));
  }
  function w(N) {
    var S = [], A = 0;
    return N.forEach(function(E, M) {
      var T = M[0], B = n(S[T] || 0, t(E));
      o(B, A) && (A = B), S[T] = B;
    }, !0), A;
  }
  function b(N, S) {
    if (S === 1)
      return D(N);
    if (S === Number.POSITIVE_INFINITY || S === "inf")
      return w(N);
    if (S === "fro")
      return h(N);
    if (S === 2)
      return y(N);
    throw new Error("Unsupported parameter value " + S);
  }
  function g(N, S) {
    var A = N.size();
    if (A.length === 1)
      return x(N, S);
    if (A.length === 2) {
      if (A[0] && A[1])
        return b(N, S);
      throw new RangeError("Invalid matrix dimensions");
    }
  }
}), Gc = "dot", c2 = ["typed", "addScalar", "multiplyScalar", "conj", "size"], sd = /* @__PURE__ */ R(Gc, c2, (r) => {
  var {
    typed: e,
    addScalar: t,
    multiplyScalar: n,
    conj: a,
    size: i
  } = r;
  return e(Gc, {
    "Array | DenseMatrix, Array | DenseMatrix": l,
    "SparseMatrix, SparseMatrix": c
  });
  function s(u, f) {
    var m = o(u), p = o(f), d, v;
    if (m.length === 1)
      d = m[0];
    else if (m.length === 2 && m[1] === 1)
      d = m[0];
    else
      throw new RangeError("Expected a column vector, instead got a matrix of size (" + m.join(", ") + ")");
    if (p.length === 1)
      v = p[0];
    else if (p.length === 2 && p[1] === 1)
      v = p[0];
    else
      throw new RangeError("Expected a column vector, instead got a matrix of size (" + p.join(", ") + ")");
    if (d !== v) throw new RangeError("Vectors must have equal length (" + d + " != " + v + ")");
    if (d === 0) throw new RangeError("Cannot calculate the dot product of empty vectors");
    return d;
  }
  function l(u, f) {
    var m = s(u, f), p = Ee(u) ? u._data : u, d = Ee(u) ? u._datatype || u.getDataType() : void 0, v = Ee(f) ? f._data : f, x = Ee(f) ? f._datatype || f.getDataType() : void 0, h = o(u).length === 2, D = o(f).length === 2, y = t, w = n;
    if (d && x && d === x && typeof d == "string" && d !== "mixed") {
      var b = d;
      y = e.find(t, [b, b]), w = e.find(n, [b, b]);
    }
    if (!h && !D) {
      for (var g = w(a(p[0]), v[0]), N = 1; N < m; N++)
        g = y(g, w(a(p[N]), v[N]));
      return g;
    }
    if (!h && D) {
      for (var S = w(a(p[0]), v[0][0]), A = 1; A < m; A++)
        S = y(S, w(a(p[A]), v[A][0]));
      return S;
    }
    if (h && !D) {
      for (var E = w(a(p[0][0]), v[0]), M = 1; M < m; M++)
        E = y(E, w(a(p[M][0]), v[M]));
      return E;
    }
    if (h && D) {
      for (var T = w(a(p[0][0]), v[0][0]), B = 1; B < m; B++)
        T = y(T, w(a(p[B][0]), v[B][0]));
      return T;
    }
  }
  function c(u, f) {
    s(u, f);
    for (var m = u._index, p = u._values, d = f._index, v = f._values, x = 0, h = t, D = n, y = 0, w = 0; y < m.length && w < d.length; ) {
      var b = m[y], g = d[w];
      if (b < g) {
        y++;
        continue;
      }
      if (b > g) {
        w++;
        continue;
      }
      b === g && (x = h(x, D(p[y], v[w])), y++, w++);
    }
    return x;
  }
  function o(u) {
    return Ee(u) ? u.size() : i(u);
  }
}), l2 = "trace", f2 = ["typed", "matrix", "add"], m2 = /* @__PURE__ */ R(l2, f2, (r) => {
  var {
    typed: e,
    matrix: t,
    add: n
  } = r;
  return e("trace", {
    Array: function(l) {
      return a(t(l));
    },
    SparseMatrix: i,
    DenseMatrix: a,
    any: Te
  });
  function a(s) {
    var l = s._size, c = s._data;
    switch (l.length) {
      case 1:
        if (l[0] === 1)
          return Te(c[0]);
        throw new RangeError("Matrix must be square (size: " + ke(l) + ")");
      case 2: {
        var o = l[0], u = l[1];
        if (o === u) {
          for (var f = 0, m = 0; m < o; m++)
            f = n(f, c[m][m]);
          return f;
        } else
          throw new RangeError("Matrix must be square (size: " + ke(l) + ")");
      }
      default:
        throw new RangeError("Matrix must be two dimensional (size: " + ke(l) + ")");
    }
  }
  function i(s) {
    var l = s._values, c = s._index, o = s._ptr, u = s._size, f = u[0], m = u[1];
    if (f === m) {
      var p = 0;
      if (l.length > 0)
        for (var d = 0; d < m; d++)
          for (var v = o[d], x = o[d + 1], h = v; h < x; h++) {
            var D = c[h];
            if (D === d) {
              p = n(p, l[h]);
              break;
            }
            if (D > d)
              break;
          }
      return p;
    }
    throw new RangeError("Matrix must be square (size: " + ke(u) + ")");
  }
}), Vc = "index", p2 = ["typed", "Index"], ud = /* @__PURE__ */ R(Vc, p2, (r) => {
  var {
    typed: e,
    Index: t
  } = r;
  return e(Vc, {
    "...number | string | BigNumber | Range | Array | Matrix": function(a) {
      var i = a.map(function(l) {
        return $e(l) ? l.toNumber() : Ye(l) || Ee(l) ? l.map(function(c) {
          return $e(c) ? c.toNumber() : c;
        }) : l;
      }), s = new t();
      return t.apply(s, i), s;
    }
  });
}), cd = /* @__PURE__ */ new Set(["end"]), d2 = "Node", v2 = ["mathWithTransform"], h2 = /* @__PURE__ */ R(d2, v2, (r) => {
  var {
    mathWithTransform: e
  } = r;
  function t(a) {
    for (var i of [...cd])
      if (a.has(i))
        throw new Error('Scope contains an illegal symbol, "' + i + '" is a reserved keyword');
  }
  class n {
    get type() {
      return "Node";
    }
    get isNode() {
      return !0;
    }
    /**
     * Evaluate the node
     * @param {Object} [scope]  Scope to read/write variables
     * @return {*}              Returns the result
     */
    evaluate(i) {
      return this.compile().evaluate(i);
    }
    /**
     * Compile the node into an optimized, evauatable JavaScript function
     * @return {{evaluate: function([Object])}} object
     *                Returns an object with a function 'evaluate',
     *                which can be invoked as expr.evaluate([scope: Object]),
     *                where scope is an optional object with
     *                variables.
     */
    compile() {
      var i = this._compile(e, {}), s = {}, l = null;
      function c(o) {
        var u = Kt(o);
        return t(u), i(u, s, l);
      }
      return {
        evaluate: c
      };
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(i, s) {
      throw new Error("Method _compile must be implemented by type " + this.type);
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(i) {
      throw new Error("Cannot run forEach on a Node interface");
    }
    /**
     * Create a new Node whose children are the results of calling the
     * provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {OperatorNode} Returns a transformed copy of the node
     */
    map(i) {
      throw new Error("Cannot run map on a Node interface");
    }
    /**
     * Validate whether an object is a Node, for use with map
     * @param {Node} node
     * @returns {Node} Returns the input if it's a node, else throws an Error
     * @protected
     */
    _ifNode(i) {
      if (!Xe(i))
        throw new TypeError("Callback function must return a Node");
      return i;
    }
    /**
     * Recursively traverse all nodes in a node tree. Executes given callback for
     * this node and each of its child nodes.
     * @param {function(node: Node, path: string, parent: Node)} callback
     *          A callback called for every node in the node tree.
     */
    traverse(i) {
      i(this, null, null);
      function s(l, c) {
        l.forEach(function(o, u, f) {
          c(o, u, f), s(o, c);
        });
      }
      s(this, i);
    }
    /**
     * Recursively transform a node tree via a transform function.
     *
     * For example, to replace all nodes of type SymbolNode having name 'x' with
     * a ConstantNode with value 2:
     *
     *     const res = Node.transform(function (node, path, parent) {
     *       if (node && node.isSymbolNode) && (node.name === 'x')) {
     *         return new ConstantNode(2)
     *       }
     *       else {
     *         return node
     *       }
     *     })
     *
     * @param {function(node: Node, path: string, parent: Node) : Node} callback
     *          A mapping function accepting a node, and returning
     *          a replacement for the node or the original node. The "signature"
     *          of the callback must be:
     *          callback(node: Node, index: string, parent: Node) : Node
     * @return {Node} Returns the original node or its replacement
     */
    transform(i) {
      function s(l, c, o) {
        var u = i(l, c, o);
        return u !== l ? u : l.map(s);
      }
      return s(this, null, null);
    }
    /**
     * Find any node in the node tree matching given filter function. For
     * example, to find all nodes of type SymbolNode having name 'x':
     *
     *     const results = Node.filter(function (node) {
     *       return (node && node.isSymbolNode) && (node.name === 'x')
     *     })
     *
     * @param {function(node: Node, path: string, parent: Node) : Node} callback
     *            A test function returning true when a node matches, and false
     *            otherwise. Function signature:
     *            callback(node: Node, index: string, parent: Node) : boolean
     * @return {Node[]} nodes
     *            An array with nodes matching given filter criteria
     */
    filter(i) {
      var s = [];
      return this.traverse(function(l, c, o) {
        i(l, c, o) && s.push(l);
      }), s;
    }
    /**
     * Create a shallow clone of this node
     * @return {Node}
     */
    clone() {
      throw new Error("Cannot clone a Node interface");
    }
    /**
     * Create a deep clone of this node
     * @return {Node}
     */
    cloneDeep() {
      return this.map(function(i) {
        return i.cloneDeep();
      });
    }
    /**
     * Deep compare this node with another node.
     * @param {Node} other
     * @return {boolean} Returns true when both nodes are of the same type and
     *                   contain the same values (as do their childs)
     */
    equals(i) {
      return i ? this.type === i.type && ut(this, i) : !1;
    }
    /**
     * Get string representation. (wrapper function)
     *
     * This function can get an object of the following form:
     * {
     *    handler: //This can be a callback function of the form
     *             // "function callback(node, options)"or
     *             // a map that maps function names (used in FunctionNodes)
     *             // to callbacks
     *    parenthesis: "keep" //the parenthesis option (This is optional)
     * }
     *
     * @param {Object} [options]
     * @return {string}
     */
    toString(i) {
      var s = this._getCustomString(i);
      return typeof s < "u" ? s : this._toString(i);
    }
    /**
     * Internal function to generate the string output.
     * This has to be implemented by every Node
     *
     * @throws {Error}
     */
    _toString() {
      throw new Error("_toString not implemented for " + this.type);
    }
    /**
     * Get a JSON representation of the node
     * Both .toJSON() and the static .fromJSON(json) should be implemented by all
     * implementations of Node
     * @returns {Object}
     */
    toJSON() {
      throw new Error("Cannot serialize object: toJSON not implemented by " + this.type);
    }
    /**
     * Get HTML representation. (wrapper function)
     *
     * This function can get an object of the following form:
     * {
     *    handler: //This can be a callback function of the form
     *             // "function callback(node, options)" or
     *             // a map that maps function names (used in FunctionNodes)
     *             // to callbacks
     *    parenthesis: "keep" //the parenthesis option (This is optional)
     * }
     *
     * @param {Object} [options]
     * @return {string}
     */
    toHTML(i) {
      var s = this._getCustomString(i);
      return typeof s < "u" ? s : this._toHTML(i);
    }
    /**
     * Internal function to generate the HTML output.
     * This has to be implemented by every Node
     *
     * @throws {Error}
     */
    _toHTML() {
      throw new Error("_toHTML not implemented for " + this.type);
    }
    /**
     * Get LaTeX representation. (wrapper function)
     *
     * This function can get an object of the following form:
     * {
     *    handler: //This can be a callback function of the form
     *             // "function callback(node, options)"or
     *             // a map that maps function names (used in FunctionNodes)
     *             // to callbacks
     *    parenthesis: "keep" //the parenthesis option (This is optional)
     * }
     *
     * @param {Object} [options]
     * @return {string}
     */
    toTex(i) {
      var s = this._getCustomString(i);
      return typeof s < "u" ? s : this._toTex(i);
    }
    /**
     * Internal function to generate the LaTeX output.
     * This has to be implemented by every Node
     *
     * @param {Object} [options]
     * @throws {Error}
     */
    _toTex(i) {
      throw new Error("_toTex not implemented for " + this.type);
    }
    /**
     * Helper used by `to...` functions.
     */
    _getCustomString(i) {
      if (i && typeof i == "object")
        switch (typeof i.handler) {
          case "object":
          case "undefined":
            return;
          case "function":
            return i.handler(this, i);
          default:
            throw new TypeError("Object or function expected as callback");
        }
    }
    /**
     * Get identifier.
     * @return {string}
     */
    getIdentifier() {
      return this.type;
    }
    /**
     * Get the content of the current Node.
     * @return {Node} node
     **/
    getContent() {
      return this;
    }
  }
  return n;
}, {
  isClass: !0,
  isNode: !0
});
function Tr(r) {
  return r && r.isIndexError ? new Hr(r.index + 1, r.min + 1, r.max !== void 0 ? r.max + 1 : void 0) : r;
}
function ld(r) {
  var {
    subset: e
  } = r;
  return function(n, a) {
    try {
      if (Array.isArray(n))
        return e(n, a);
      if (n && typeof n.subset == "function")
        return n.subset(a);
      if (typeof n == "string")
        return e(n, a);
      if (typeof n == "object") {
        if (!a.isObjectProperty())
          throw new TypeError("Cannot apply a numeric index as object property");
        return Mr(n, a.getObjectProperty());
      } else
        throw new TypeError("Cannot apply index: unsupported type of object");
    } catch (i) {
      throw Tr(i);
    }
  };
}
var Zn = "AccessorNode", g2 = ["subset", "Node"], y2 = /* @__PURE__ */ R(Zn, g2, (r) => {
  var {
    subset: e,
    Node: t
  } = r, n = ld({
    subset: e
  });
  function a(s) {
    return !(wt(s) || zr(s) || We(s) || st(s) || zn(s) || et(s) || ur(s));
  }
  class i extends t {
    /**
     * @constructor AccessorNode
     * @extends {Node}
     * Access an object property or get a matrix subset
     *
     * @param {Node} object                 The object from which to retrieve
     *                                      a property or subset.
     * @param {IndexNode} index             IndexNode containing ranges
     */
    constructor(l, c) {
      if (super(), !Xe(l))
        throw new TypeError('Node expected for parameter "object"');
      if (!Pt(c))
        throw new TypeError('IndexNode expected for parameter "index"');
      this.object = l, this.index = c;
    }
    // readonly property name
    get name() {
      return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : "" : this.object.name || "";
    }
    get type() {
      return Zn;
    }
    get isAccessorNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(l, c) {
      var o = this.object._compile(l, c), u = this.index._compile(l, c);
      if (this.index.isObjectProperty()) {
        var f = this.index.getObjectProperty();
        return function(p, d, v) {
          return Mr(o(p, d, v), f);
        };
      } else
        return function(p, d, v) {
          var x = o(p, d, v), h = u(p, d, x);
          return n(x, h);
        };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(l) {
      l(this.object, "object", this), l(this.index, "index", this);
    }
    /**
     * Create a new AccessorNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {AccessorNode} Returns a transformed copy of the node
     */
    map(l) {
      return new i(this._ifNode(l(this.object, "object", this)), this._ifNode(l(this.index, "index", this)));
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {AccessorNode}
     */
    clone() {
      return new i(this.object, this.index);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string}
     */
    _toString(l) {
      var c = this.object.toString(l);
      return a(this.object) && (c = "(" + c + ")"), c + this.index.toString(l);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string}
     */
    _toHTML(l) {
      var c = this.object.toHTML(l);
      return a(this.object) && (c = '<span class="math-parenthesis math-round-parenthesis">(</span>' + c + '<span class="math-parenthesis math-round-parenthesis">)</span>'), c + this.index.toHTML(l);
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string}
     */
    _toTex(l) {
      var c = this.object.toTex(l);
      return a(this.object) && (c = "\\left(' + object + '\\right)"), c + this.index.toTex(l);
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: Zn,
        object: this.object,
        index: this.index
      };
    }
    /**
     * Instantiate an AccessorNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "AccessorNode", object: ..., index: ...}`,
     *     where mathjs is optional
     * @returns {AccessorNode}
     */
    static fromJSON(l) {
      return new i(l.object, l.index);
    }
  }
  return or(i, "name", Zn), i;
}, {
  isClass: !0,
  isNode: !0
}), Xn = "ArrayNode", b2 = ["Node"], x2 = /* @__PURE__ */ R(Xn, b2, (r) => {
  var {
    Node: e
  } = r;
  class t extends e {
    /**
     * @constructor ArrayNode
     * @extends {Node}
     * Holds an 1-dimensional array with items
     * @param {Node[]} [items]   1 dimensional array with items
     */
    constructor(a) {
      if (super(), this.items = a || [], !Array.isArray(this.items) || !this.items.every(Xe))
        throw new TypeError("Array containing Nodes expected");
    }
    get type() {
      return Xn;
    }
    get isArrayNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(a, i) {
      var s = xt(this.items, function(o) {
        return o._compile(a, i);
      }), l = a.config.matrix !== "Array";
      if (l) {
        var c = a.matrix;
        return function(u, f, m) {
          return c(xt(s, function(p) {
            return p(u, f, m);
          }));
        };
      } else
        return function(u, f, m) {
          return xt(s, function(p) {
            return p(u, f, m);
          });
        };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(a) {
      for (var i = 0; i < this.items.length; i++) {
        var s = this.items[i];
        a(s, "items[" + i + "]", this);
      }
    }
    /**
     * Create a new ArrayNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {ArrayNode} Returns a transformed copy of the node
     */
    map(a) {
      for (var i = [], s = 0; s < this.items.length; s++)
        i[s] = this._ifNode(a(this.items[s], "items[" + s + "]", this));
      return new t(i);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {ArrayNode}
     */
    clone() {
      return new t(this.items.slice(0));
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toString(a) {
      var i = this.items.map(function(s) {
        return s.toString(a);
      });
      return "[" + i.join(", ") + "]";
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: Xn,
        items: this.items
      };
    }
    /**
     * Instantiate an ArrayNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "ArrayNode", items: [...]}`,
     *                       where mathjs is optional
     * @returns {ArrayNode}
     */
    static fromJSON(a) {
      return new t(a.items);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toHTML(a) {
      var i = this.items.map(function(s) {
        return s.toHTML(a);
      });
      return '<span class="math-parenthesis math-square-parenthesis">[</span>' + i.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(a) {
      function i(s, l) {
        var c = s.some(zr) && !s.every(zr), o = l || c, u = o ? "&" : "\\\\", f = s.map(function(m) {
          return m.items ? i(m.items, !l) : m.toTex(a);
        }).join(u);
        return c || !o || o && !l ? "\\begin{bmatrix}" + f + "\\end{bmatrix}" : f;
      }
      return i(this.items, !1);
    }
  }
  return or(t, "name", Xn), t;
}, {
  isClass: !0,
  isNode: !0
});
function w2(r) {
  var {
    subset: e,
    matrix: t
  } = r;
  return function(a, i, s) {
    try {
      if (Array.isArray(a)) {
        var l = t(a).subset(i, s).valueOf();
        return l.forEach((c, o) => {
          a[o] = c;
        }), a;
      } else {
        if (a && typeof a.subset == "function")
          return a.subset(i, s);
        if (typeof a == "string")
          return e(a, i, s);
        if (typeof a == "object") {
          if (!i.isObjectProperty())
            throw TypeError("Cannot apply a numeric index as object property");
          return an(a, i.getObjectProperty(), s), a;
        } else
          throw new TypeError("Cannot apply index: unsupported type of object");
      }
    } catch (c) {
      throw Tr(c);
    }
  };
}
var Vr = [{
  // assignment
  AssignmentNode: {},
  FunctionAssignmentNode: {}
}, {
  // conditional expression
  ConditionalNode: {
    latexLeftParens: !1,
    latexRightParens: !1,
    latexParens: !1
    // conditionals don't need parentheses in LaTeX because
    // they are 2 dimensional
  }
}, {
  // logical or
  "OperatorNode:or": {
    op: "or",
    associativity: "left",
    associativeWith: []
  }
}, {
  // logical xor
  "OperatorNode:xor": {
    op: "xor",
    associativity: "left",
    associativeWith: []
  }
}, {
  // logical and
  "OperatorNode:and": {
    op: "and",
    associativity: "left",
    associativeWith: []
  }
}, {
  // bitwise or
  "OperatorNode:bitOr": {
    op: "|",
    associativity: "left",
    associativeWith: []
  }
}, {
  // bitwise xor
  "OperatorNode:bitXor": {
    op: "^|",
    associativity: "left",
    associativeWith: []
  }
}, {
  // bitwise and
  "OperatorNode:bitAnd": {
    op: "&",
    associativity: "left",
    associativeWith: []
  }
}, {
  // relational operators
  "OperatorNode:equal": {
    op: "==",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:unequal": {
    op: "!=",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:smaller": {
    op: "<",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:larger": {
    op: ">",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:smallerEq": {
    op: "<=",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:largerEq": {
    op: ">=",
    associativity: "left",
    associativeWith: []
  },
  RelationalNode: {
    associativity: "left",
    associativeWith: []
  }
}, {
  // bitshift operators
  "OperatorNode:leftShift": {
    op: "<<",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:rightArithShift": {
    op: ">>",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:rightLogShift": {
    op: ">>>",
    associativity: "left",
    associativeWith: []
  }
}, {
  // unit conversion
  "OperatorNode:to": {
    op: "to",
    associativity: "left",
    associativeWith: []
  }
}, {
  // range
  RangeNode: {}
}, {
  // addition, subtraction
  "OperatorNode:add": {
    op: "+",
    associativity: "left",
    associativeWith: ["OperatorNode:add", "OperatorNode:subtract"]
  },
  "OperatorNode:subtract": {
    op: "-",
    associativity: "left",
    associativeWith: []
  }
}, {
  // multiply, divide, modulus
  "OperatorNode:multiply": {
    op: "*",
    associativity: "left",
    associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "Operator:dotMultiply", "Operator:dotDivide"]
  },
  "OperatorNode:divide": {
    op: "/",
    associativity: "left",
    associativeWith: [],
    latexLeftParens: !1,
    latexRightParens: !1,
    latexParens: !1
    // fractions don't require parentheses because
    // they're 2 dimensional, so parens aren't needed
    // in LaTeX
  },
  "OperatorNode:dotMultiply": {
    op: ".*",
    associativity: "left",
    associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "OperatorNode:dotMultiply", "OperatorNode:doDivide"]
  },
  "OperatorNode:dotDivide": {
    op: "./",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:mod": {
    op: "mod",
    associativity: "left",
    associativeWith: []
  }
}, {
  // Repeat multiplication for implicit multiplication
  "OperatorNode:multiply": {
    associativity: "left",
    associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "Operator:dotMultiply", "Operator:dotDivide"]
  }
}, {
  // unary prefix operators
  "OperatorNode:unaryPlus": {
    op: "+",
    associativity: "right"
  },
  "OperatorNode:unaryMinus": {
    op: "-",
    associativity: "right"
  },
  "OperatorNode:bitNot": {
    op: "~",
    associativity: "right"
  },
  "OperatorNode:not": {
    op: "not",
    associativity: "right"
  }
}, {
  // exponentiation
  "OperatorNode:pow": {
    op: "^",
    associativity: "right",
    associativeWith: [],
    latexRightParens: !1
    // the exponent doesn't need parentheses in
    // LaTeX because it's 2 dimensional
    // (it's on top)
  },
  "OperatorNode:dotPow": {
    op: ".^",
    associativity: "right",
    associativeWith: []
  }
}, {
  // nullish coalescing
  "OperatorNode:nullish": {
    op: "??",
    associativity: "left",
    associativeWith: []
  }
}, {
  // factorial
  "OperatorNode:factorial": {
    op: "!",
    associativity: "left"
  }
}, {
  // matrix transpose
  "OperatorNode:ctranspose": {
    op: "'",
    associativity: "left"
  }
}];
function Yn(r, e) {
  if (!e || e !== "auto") return r;
  for (var t = r; et(t); ) t = t.content;
  return t;
}
function je(r, e, t, n) {
  var a = r;
  e !== "keep" && (a = r.getContent());
  for (var i = a.getIdentifier(), s = null, l = 0; l < Vr.length; l++)
    if (i in Vr[l]) {
      s = l;
      break;
    }
  if (i === "OperatorNode:multiply" && a.implicit && t !== "show") {
    var c = Yn(a.args[0], e);
    !(We(c) && n && n.getIdentifier() === "OperatorNode:divide" && Fi(Yn(n.args[0], e))) && !(c.getIdentifier() === "OperatorNode:divide" && Fi(Yn(c.args[0], e)) && We(Yn(c.args[1]))) && (s += 1);
  }
  return s;
}
function Dn(r, e) {
  var t = r;
  e !== "keep" && (t = r.getContent());
  var n = t.getIdentifier(), a = je(t, e);
  if (a === null)
    return null;
  var i = Vr[a][n];
  if (xe(i, "associativity")) {
    if (i.associativity === "left")
      return "left";
    if (i.associativity === "right")
      return "right";
    throw Error("'" + n + "' has the invalid associativity '" + i.associativity + "'.");
  }
  return null;
}
function Ni(r, e, t) {
  var n = t !== "keep" ? r.getContent() : r, a = t !== "keep" ? r.getContent() : e, i = n.getIdentifier(), s = a.getIdentifier(), l = je(n, t);
  if (l === null)
    return null;
  var c = Vr[l][i];
  if (xe(c, "associativeWith") && c.associativeWith instanceof Array) {
    for (var o = 0; o < c.associativeWith.length; o++)
      if (c.associativeWith[o] === s)
        return !0;
    return !1;
  }
  return null;
}
function D2(r) {
  var e = "OperatorNode:" + r;
  for (var t of Vr)
    if (e in t)
      return t[e].op;
  return null;
}
var Jn = "AssignmentNode", N2 = [
  "subset",
  "?matrix",
  // FIXME: should not be needed at all, should be handled by subset
  "Node"
], A2 = /* @__PURE__ */ R(Jn, N2, (r) => {
  var {
    subset: e,
    matrix: t,
    Node: n
  } = r, a = ld({
    subset: e
  }), i = w2({
    subset: e,
    matrix: t
  });
  function s(c, o, u) {
    o || (o = "keep");
    var f = je(c, o, u), m = je(c.value, o, u);
    return o === "all" || m !== null && m <= f;
  }
  class l extends n {
    /**
     * @constructor AssignmentNode
     * @extends {Node}
     *
     * Define a symbol, like `a=3.2`, update a property like `a.b=3.2`, or
     * replace a subset of a matrix like `A[2,2]=42`.
     *
     * Syntax:
     *
     *     new AssignmentNode(symbol, value)
     *     new AssignmentNode(object, index, value)
     *
     * Usage:
     *
     *    new AssignmentNode(new SymbolNode('a'), new ConstantNode(2))  // a=2
     *    new AssignmentNode(new SymbolNode('a'),
     *                       new IndexNode('b'),
     *                       new ConstantNode(2))   // a.b=2
     *    new AssignmentNode(new SymbolNode('a'),
     *                       new IndexNode(1, 2),
     *                       new ConstantNode(3))  // a[1,2]=3
     *
     * @param {SymbolNode | AccessorNode} object
     *     Object on which to assign a value
     * @param {IndexNode} [index=null]
     *     Index, property name or matrix index. Optional. If not provided
     *     and `object` is a SymbolNode, the property is assigned to the
     *     global scope.
     * @param {Node} value
     *     The value to be assigned
     */
    constructor(o, u, f) {
      if (super(), this.object = o, this.index = f ? u : null, this.value = f || u, !ur(o) && !wt(o))
        throw new TypeError('SymbolNode or AccessorNode expected as "object"');
      if (ur(o) && o.name === "end")
        throw new Error('Cannot assign to symbol "end"');
      if (this.index && !Pt(this.index))
        throw new TypeError('IndexNode expected as "index"');
      if (!Xe(this.value))
        throw new TypeError('Node expected as "value"');
    }
    // class name for typing purposes:
    // readonly property name
    get name() {
      return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : "" : this.object.name || "";
    }
    get type() {
      return Jn;
    }
    get isAssignmentNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(o, u) {
      var f = this.object._compile(o, u), m = this.index ? this.index._compile(o, u) : null, p = this.value._compile(o, u), d = this.object.name;
      if (this.index)
        if (this.index.isObjectProperty()) {
          var v = this.index.getObjectProperty();
          return function(w, b, g) {
            var N = f(w, b, g), S = p(w, b, g);
            return an(N, v, S), S;
          };
        } else {
          if (ur(this.object))
            return function(w, b, g) {
              var N = f(w, b, g), S = p(w, b, g), A = m(w, b, N);
              return w.set(d, i(N, A, S)), S;
            };
          var x = this.object.object._compile(o, u);
          if (this.object.index.isObjectProperty()) {
            var h = this.object.index.getObjectProperty();
            return function(w, b, g) {
              var N = x(w, b, g), S = Mr(N, h), A = m(w, b, S), E = p(w, b, g);
              return an(N, h, i(S, A, E)), E;
            };
          } else {
            var D = this.object.index._compile(o, u);
            return function(w, b, g) {
              var N = x(w, b, g), S = D(w, b, N), A = a(N, S), E = m(w, b, A), M = p(w, b, g);
              return i(N, S, i(A, E, M)), M;
            };
          }
        }
      else {
        if (!ur(this.object))
          throw new TypeError("SymbolNode expected as object");
        return function(w, b, g) {
          var N = p(w, b, g);
          return w.set(d, N), N;
        };
      }
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(o) {
      o(this.object, "object", this), this.index && o(this.index, "index", this), o(this.value, "value", this);
    }
    /**
     * Create a new AssignmentNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {AssignmentNode} Returns a transformed copy of the node
     */
    map(o) {
      var u = this._ifNode(o(this.object, "object", this)), f = this.index ? this._ifNode(o(this.index, "index", this)) : null, m = this._ifNode(o(this.value, "value", this));
      return new l(u, f, m);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {AssignmentNode}
     */
    clone() {
      return new l(this.object, this.index, this.value);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string}
     */
    _toString(o) {
      var u = this.object.toString(o), f = this.index ? this.index.toString(o) : "", m = this.value.toString(o);
      return s(this, o && o.parenthesis, o && o.implicit) && (m = "(" + m + ")"), u + f + " = " + m;
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: Jn,
        object: this.object,
        index: this.index,
        value: this.value
      };
    }
    /**
     * Instantiate an AssignmentNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "AssignmentNode", object: ..., index: ..., value: ...}`,
     *     where mathjs is optional
     * @returns {AssignmentNode}
     */
    static fromJSON(o) {
      return new l(o.object, o.index, o.value);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string}
     */
    _toHTML(o) {
      var u = this.object.toHTML(o), f = this.index ? this.index.toHTML(o) : "", m = this.value.toHTML(o);
      return s(this, o && o.parenthesis, o && o.implicit) && (m = '<span class="math-paranthesis math-round-parenthesis">(</span>' + m + '<span class="math-paranthesis math-round-parenthesis">)</span>'), u + f + '<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + m;
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string}
     */
    _toTex(o) {
      var u = this.object.toTex(o), f = this.index ? this.index.toTex(o) : "", m = this.value.toTex(o);
      return s(this, o && o.parenthesis, o && o.implicit) && (m = "\\left(".concat(m, "\\right)")), u + f + "=" + m;
    }
  }
  return or(l, "name", Jn), l;
}, {
  isClass: !0,
  isNode: !0
}), Qn = "BlockNode", S2 = ["ResultSet", "Node"], E2 = /* @__PURE__ */ R(Qn, S2, (r) => {
  var {
    ResultSet: e,
    Node: t
  } = r;
  class n extends t {
    /**
     * @constructor BlockNode
     * @extends {Node}
     * Holds a set with blocks
     * @param {Array.<{node: Node} | {node: Node, visible: boolean}>} blocks
     *            An array with blocks, where a block is constructed as an
     *            Object with properties block, which is a Node, and visible,
     *            which is a boolean. The property visible is optional and
     *            is true by default
     */
    constructor(i) {
      if (super(), !Array.isArray(i)) throw new Error("Array expected");
      this.blocks = i.map(function(s) {
        var l = s && s.node, c = s && s.visible !== void 0 ? s.visible : !0;
        if (!Xe(l)) throw new TypeError('Property "node" must be a Node');
        if (typeof c != "boolean")
          throw new TypeError('Property "visible" must be a boolean');
        return {
          node: l,
          visible: c
        };
      });
    }
    get type() {
      return Qn;
    }
    get isBlockNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(i, s) {
      var l = xt(this.blocks, function(c) {
        return {
          evaluate: c.node._compile(i, s),
          visible: c.visible
        };
      });
      return function(o, u, f) {
        var m = [];
        return hm(l, function(d) {
          var v = d.evaluate(o, u, f);
          d.visible && m.push(v);
        }), new e(m);
      };
    }
    /**
     * Execute a callback for each of the child blocks of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(i) {
      for (var s = 0; s < this.blocks.length; s++)
        i(this.blocks[s].node, "blocks[" + s + "].node", this);
    }
    /**
     * Create a new BlockNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {BlockNode} Returns a transformed copy of the node
     */
    map(i) {
      for (var s = [], l = 0; l < this.blocks.length; l++) {
        var c = this.blocks[l], o = this._ifNode(i(c.node, "blocks[" + l + "].node", this));
        s[l] = {
          node: o,
          visible: c.visible
        };
      }
      return new n(s);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {BlockNode}
     */
    clone() {
      var i = this.blocks.map(function(s) {
        return {
          node: s.node,
          visible: s.visible
        };
      });
      return new n(i);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toString(i) {
      return this.blocks.map(function(s) {
        return s.node.toString(i) + (s.visible ? "" : ";");
      }).join(`
`);
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: Qn,
        blocks: this.blocks
      };
    }
    /**
     * Instantiate an BlockNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "BlockNode", blocks: [{node: ..., visible: false}, ...]}`,
     *     where mathjs is optional
     * @returns {BlockNode}
     */
    static fromJSON(i) {
      return new n(i.blocks);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toHTML(i) {
      return this.blocks.map(function(s) {
        return s.node.toHTML(i) + (s.visible ? "" : '<span class="math-separator">;</span>');
      }).join('<span class="math-separator"><br /></span>');
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(i) {
      return this.blocks.map(function(s) {
        return s.node.toTex(i) + (s.visible ? "" : ";");
      }).join(`\\;\\;
`);
    }
  }
  return or(n, "name", Qn), n;
}, {
  isClass: !0,
  isNode: !0
}), jn = "ConditionalNode", M2 = ["Node"], C2 = /* @__PURE__ */ R(jn, M2, (r) => {
  var {
    Node: e
  } = r;
  function t(a) {
    if (typeof a == "number" || typeof a == "boolean" || typeof a == "string")
      return !!a;
    if (a) {
      if ($e(a))
        return !a.isZero();
      if (Zr(a))
        return !!(a.re || a.im);
      if (Er(a))
        return !!a.value;
    }
    if (a == null)
      return !1;
    throw new TypeError('Unsupported type of condition "' + Ke(a) + '"');
  }
  class n extends e {
    /**
     * A lazy evaluating conditional operator: 'condition ? trueExpr : falseExpr'
     *
     * @param {Node} condition   Condition, must result in a boolean
     * @param {Node} trueExpr    Expression evaluated when condition is true
     * @param {Node} falseExpr   Expression evaluated when condition is true
     *
     * @constructor ConditionalNode
     * @extends {Node}
     */
    constructor(i, s, l) {
      if (super(), !Xe(i))
        throw new TypeError("Parameter condition must be a Node");
      if (!Xe(s))
        throw new TypeError("Parameter trueExpr must be a Node");
      if (!Xe(l))
        throw new TypeError("Parameter falseExpr must be a Node");
      this.condition = i, this.trueExpr = s, this.falseExpr = l;
    }
    get type() {
      return jn;
    }
    get isConditionalNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(i, s) {
      var l = this.condition._compile(i, s), c = this.trueExpr._compile(i, s), o = this.falseExpr._compile(i, s);
      return function(f, m, p) {
        return t(l(f, m, p)) ? c(f, m, p) : o(f, m, p);
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(i) {
      i(this.condition, "condition", this), i(this.trueExpr, "trueExpr", this), i(this.falseExpr, "falseExpr", this);
    }
    /**
     * Create a new ConditionalNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {ConditionalNode} Returns a transformed copy of the node
     */
    map(i) {
      return new n(this._ifNode(i(this.condition, "condition", this)), this._ifNode(i(this.trueExpr, "trueExpr", this)), this._ifNode(i(this.falseExpr, "falseExpr", this)));
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {ConditionalNode}
     */
    clone() {
      return new n(this.condition, this.trueExpr, this.falseExpr);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    _toString(i) {
      var s = i && i.parenthesis ? i.parenthesis : "keep", l = je(this, s, i && i.implicit), c = this.condition.toString(i), o = je(this.condition, s, i && i.implicit);
      (s === "all" || this.condition.type === "OperatorNode" || o !== null && o <= l) && (c = "(" + c + ")");
      var u = this.trueExpr.toString(i), f = je(this.trueExpr, s, i && i.implicit);
      (s === "all" || this.trueExpr.type === "OperatorNode" || f !== null && f <= l) && (u = "(" + u + ")");
      var m = this.falseExpr.toString(i), p = je(this.falseExpr, s, i && i.implicit);
      return (s === "all" || this.falseExpr.type === "OperatorNode" || p !== null && p <= l) && (m = "(" + m + ")"), c + " ? " + u + " : " + m;
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: jn,
        condition: this.condition,
        trueExpr: this.trueExpr,
        falseExpr: this.falseExpr
      };
    }
    /**
     * Instantiate an ConditionalNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     ```
     *     {"mathjs": "ConditionalNode",
     *      "condition": ...,
     *      "trueExpr": ...,
     *      "falseExpr": ...}
     *     ```
     *     where mathjs is optional
     * @returns {ConditionalNode}
     */
    static fromJSON(i) {
      return new n(i.condition, i.trueExpr, i.falseExpr);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(i) {
      var s = i && i.parenthesis ? i.parenthesis : "keep", l = je(this, s, i && i.implicit), c = this.condition.toHTML(i), o = je(this.condition, s, i && i.implicit);
      (s === "all" || this.condition.type === "OperatorNode" || o !== null && o <= l) && (c = '<span class="math-parenthesis math-round-parenthesis">(</span>' + c + '<span class="math-parenthesis math-round-parenthesis">)</span>');
      var u = this.trueExpr.toHTML(i), f = je(this.trueExpr, s, i && i.implicit);
      (s === "all" || this.trueExpr.type === "OperatorNode" || f !== null && f <= l) && (u = '<span class="math-parenthesis math-round-parenthesis">(</span>' + u + '<span class="math-parenthesis math-round-parenthesis">)</span>');
      var m = this.falseExpr.toHTML(i), p = je(this.falseExpr, s, i && i.implicit);
      return (s === "all" || this.falseExpr.type === "OperatorNode" || p !== null && p <= l) && (m = '<span class="math-parenthesis math-round-parenthesis">(</span>' + m + '<span class="math-parenthesis math-round-parenthesis">)</span>'), c + '<span class="math-operator math-conditional-operator">?</span>' + u + '<span class="math-operator math-conditional-operator">:</span>' + m;
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(i) {
      return "\\begin{cases} {" + this.trueExpr.toTex(i) + "}, &\\quad{\\text{if }\\;" + this.condition.toTex(i) + "}\\\\{" + this.falseExpr.toTex(i) + "}, &\\quad{\\text{otherwise}}\\end{cases}";
    }
  }
  return or(n, "name", jn), n;
}, {
  isClass: !0,
  isNode: !0
}), Ai, Zc;
function _2() {
  if (Zc) return Ai;
  Zc = 1;
  var r = Object.assign || function(a) {
    for (var i = 1; i < arguments.length; i++) {
      var s = arguments[i];
      for (var l in s)
        Object.prototype.hasOwnProperty.call(s, l) && (a[l] = s[l]);
    }
    return a;
  }, e = {
    "{": "\\{",
    "}": "\\}",
    "\\": "\\textbackslash{}",
    "#": "\\#",
    $: "\\$",
    "%": "\\%",
    "&": "\\&",
    "^": "\\textasciicircum{}",
    _: "\\_",
    "~": "\\textasciitilde{}"
  }, t = {
    "–": "\\--",
    "—": "\\---",
    " ": "~",
    "	": "\\qquad{}",
    "\r\n": "\\newline{}",
    "\n": "\\newline{}"
  }, n = function(i, s) {
    return r({}, i, s);
  };
  return Ai = function(a) {
    for (var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = i.preserveFormatting, l = s === void 0 ? !1 : s, c = i.escapeMapFn, o = c === void 0 ? n : c, u = String(a), f = "", m = o(r({}, e), l ? r({}, t) : {}), p = Object.keys(m), d = function() {
      var x = !1;
      p.forEach(function(h, D) {
        x || u.length >= h.length && u.slice(0, h.length) === h && (f += m[p[D]], u = u.slice(h.length, u.length), x = !0);
      }), x || (f += u.slice(0, 1), u = u.slice(1, u.length));
    }; u; )
      d();
    return f;
  }, Ai;
}
var T2 = _2();
const F2 = /* @__PURE__ */ si(T2);
var Qi = {
  // GREEK LETTERS
  Alpha: "A",
  alpha: "\\alpha",
  Beta: "B",
  beta: "\\beta",
  Gamma: "\\Gamma",
  gamma: "\\gamma",
  Delta: "\\Delta",
  delta: "\\delta",
  Epsilon: "E",
  epsilon: "\\epsilon",
  varepsilon: "\\varepsilon",
  Zeta: "Z",
  zeta: "\\zeta",
  Eta: "H",
  eta: "\\eta",
  Theta: "\\Theta",
  theta: "\\theta",
  vartheta: "\\vartheta",
  Iota: "I",
  iota: "\\iota",
  Kappa: "K",
  kappa: "\\kappa",
  varkappa: "\\varkappa",
  Lambda: "\\Lambda",
  lambda: "\\lambda",
  Mu: "M",
  mu: "\\mu",
  Nu: "N",
  nu: "\\nu",
  Xi: "\\Xi",
  xi: "\\xi",
  Omicron: "O",
  omicron: "o",
  Pi: "\\Pi",
  pi: "\\pi",
  varpi: "\\varpi",
  Rho: "P",
  rho: "\\rho",
  varrho: "\\varrho",
  Sigma: "\\Sigma",
  sigma: "\\sigma",
  varsigma: "\\varsigma",
  Tau: "T",
  tau: "\\tau",
  Upsilon: "\\Upsilon",
  upsilon: "\\upsilon",
  Phi: "\\Phi",
  phi: "\\phi",
  varphi: "\\varphi",
  Chi: "X",
  chi: "\\chi",
  Psi: "\\Psi",
  psi: "\\psi",
  Omega: "\\Omega",
  omega: "\\omega",
  // logic
  true: "\\mathrm{True}",
  false: "\\mathrm{False}",
  // other
  i: "i",
  // TODO use \i ??
  inf: "\\infty",
  Inf: "\\infty",
  infinity: "\\infty",
  Infinity: "\\infty",
  oo: "\\infty",
  lim: "\\lim",
  undefined: "\\mathbf{?}"
}, Ge = {
  transpose: "^\\top",
  ctranspose: "^H",
  factorial: "!",
  pow: "^",
  dotPow: ".^\\wedge",
  // TODO find ideal solution
  unaryPlus: "+",
  unaryMinus: "-",
  bitNot: "\\~",
  // TODO find ideal solution
  not: "\\neg",
  multiply: "\\cdot",
  divide: "\\frac",
  // TODO how to handle that properly?
  dotMultiply: ".\\cdot",
  // TODO find ideal solution
  dotDivide: ".:",
  // TODO find ideal solution
  mod: "\\mod",
  add: "+",
  subtract: "-",
  to: "\\rightarrow",
  leftShift: "<<",
  rightArithShift: ">>",
  rightLogShift: ">>>",
  equal: "=",
  unequal: "\\neq",
  smaller: "<",
  larger: ">",
  smallerEq: "\\leq",
  largerEq: "\\geq",
  bitAnd: "\\&",
  bitXor: "\\underline{|}",
  bitOr: "|",
  and: "\\wedge",
  xor: "\\veebar",
  or: "\\vee"
}, Xc = {
  // arithmetic
  abs: {
    1: "\\left|${args[0]}\\right|"
  },
  add: {
    2: "\\left(${args[0]}".concat(Ge.add, "${args[1]}\\right)")
  },
  cbrt: {
    1: "\\sqrt[3]{${args[0]}}"
  },
  ceil: {
    1: "\\left\\lceil${args[0]}\\right\\rceil"
  },
  cube: {
    1: "\\left(${args[0]}\\right)^3"
  },
  divide: {
    2: "\\frac{${args[0]}}{${args[1]}}"
  },
  dotDivide: {
    2: "\\left(${args[0]}".concat(Ge.dotDivide, "${args[1]}\\right)")
  },
  dotMultiply: {
    2: "\\left(${args[0]}".concat(Ge.dotMultiply, "${args[1]}\\right)")
  },
  dotPow: {
    2: "\\left(${args[0]}".concat(Ge.dotPow, "${args[1]}\\right)")
  },
  exp: {
    1: "\\exp\\left(${args[0]}\\right)"
  },
  expm1: "\\left(e".concat(Ge.pow, "{${args[0]}}-1\\right)"),
  fix: {
    1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
  },
  floor: {
    1: "\\left\\lfloor${args[0]}\\right\\rfloor"
  },
  fraction: {
    2: "\\frac{${args[0]}}{${args[1]}}"
  },
  gcd: "\\gcd\\left(${args}\\right)",
  hypot: "\\hypot\\left(${args}\\right)",
  log: {
    1: "\\ln\\left(${args[0]}\\right)",
    2: "\\log_{${args[1]}}\\left(${args[0]}\\right)"
  },
  log10: {
    1: "\\log_{10}\\left(${args[0]}\\right)"
  },
  log1p: {
    1: "\\ln\\left(${args[0]}+1\\right)",
    2: "\\log_{${args[1]}}\\left(${args[0]}+1\\right)"
  },
  log2: "\\log_{2}\\left(${args[0]}\\right)",
  mod: {
    2: "\\left(${args[0]}".concat(Ge.mod, "${args[1]}\\right)")
  },
  multiply: {
    2: "\\left(${args[0]}".concat(Ge.multiply, "${args[1]}\\right)")
  },
  norm: {
    1: "\\left\\|${args[0]}\\right\\|",
    2: void 0
    // use default template
  },
  nthRoot: {
    2: "\\sqrt[${args[1]}]{${args[0]}}"
  },
  nthRoots: {
    2: "\\{y : y^${args[1]} = {${args[0]}}\\}"
  },
  pow: {
    2: "\\left(${args[0]}\\right)".concat(Ge.pow, "{${args[1]}}")
  },
  round: {
    1: "\\left\\lfloor${args[0]}\\right\\rceil",
    2: void 0
    // use default template
  },
  sign: {
    1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
  },
  sqrt: {
    1: "\\sqrt{${args[0]}}"
  },
  square: {
    1: "\\left(${args[0]}\\right)^2"
  },
  subtract: {
    2: "\\left(${args[0]}".concat(Ge.subtract, "${args[1]}\\right)")
  },
  unaryMinus: {
    1: "".concat(Ge.unaryMinus, "\\left(${args[0]}\\right)")
  },
  unaryPlus: {
    1: "".concat(Ge.unaryPlus, "\\left(${args[0]}\\right)")
  },
  // bitwise
  bitAnd: {
    2: "\\left(${args[0]}".concat(Ge.bitAnd, "${args[1]}\\right)")
  },
  bitNot: {
    1: Ge.bitNot + "\\left(${args[0]}\\right)"
  },
  bitOr: {
    2: "\\left(${args[0]}".concat(Ge.bitOr, "${args[1]}\\right)")
  },
  bitXor: {
    2: "\\left(${args[0]}".concat(Ge.bitXor, "${args[1]}\\right)")
  },
  leftShift: {
    2: "\\left(${args[0]}".concat(Ge.leftShift, "${args[1]}\\right)")
  },
  rightArithShift: {
    2: "\\left(${args[0]}".concat(Ge.rightArithShift, "${args[1]}\\right)")
  },
  rightLogShift: {
    2: "\\left(${args[0]}".concat(Ge.rightLogShift, "${args[1]}\\right)")
  },
  // combinatorics
  bellNumbers: {
    1: "\\mathrm{B}_{${args[0]}}"
  },
  catalan: {
    1: "\\mathrm{C}_{${args[0]}}"
  },
  stirlingS2: {
    2: "\\mathrm{S}\\left(${args}\\right)"
  },
  // complex
  arg: {
    1: "\\arg\\left(${args[0]}\\right)"
  },
  conj: {
    1: "\\left(${args[0]}\\right)^*"
  },
  im: {
    1: "\\Im\\left\\lbrace${args[0]}\\right\\rbrace"
  },
  re: {
    1: "\\Re\\left\\lbrace${args[0]}\\right\\rbrace"
  },
  // logical
  and: {
    2: "\\left(${args[0]}".concat(Ge.and, "${args[1]}\\right)")
  },
  not: {
    1: Ge.not + "\\left(${args[0]}\\right)"
  },
  or: {
    2: "\\left(${args[0]}".concat(Ge.or, "${args[1]}\\right)")
  },
  xor: {
    2: "\\left(${args[0]}".concat(Ge.xor, "${args[1]}\\right)")
  },
  // matrix
  cross: {
    2: "\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)"
  },
  ctranspose: {
    1: "\\left(${args[0]}\\right)".concat(Ge.ctranspose)
  },
  det: {
    1: "\\det\\left(${args[0]}\\right)"
  },
  dot: {
    2: "\\left(${args[0]}\\cdot${args[1]}\\right)"
  },
  expm: {
    1: "\\exp\\left(${args[0]}\\right)"
  },
  inv: {
    1: "\\left(${args[0]}\\right)^{-1}"
  },
  pinv: {
    1: "\\left(${args[0]}\\right)^{+}"
  },
  sqrtm: {
    1: "{${args[0]}}".concat(Ge.pow, "{\\frac{1}{2}}")
  },
  trace: {
    1: "\\mathrm{tr}\\left(${args[0]}\\right)"
  },
  transpose: {
    1: "\\left(${args[0]}\\right)".concat(Ge.transpose)
  },
  // probability
  combinations: {
    2: "\\binom{${args[0]}}{${args[1]}}"
  },
  combinationsWithRep: {
    2: "\\left(\\!\\!{\\binom{${args[0]}}{${args[1]}}}\\!\\!\\right)"
  },
  factorial: {
    1: "\\left(${args[0]}\\right)".concat(Ge.factorial)
  },
  gamma: {
    1: "\\Gamma\\left(${args[0]}\\right)"
  },
  lgamma: {
    1: "\\ln\\Gamma\\left(${args[0]}\\right)"
  },
  // relational
  equal: {
    2: "\\left(${args[0]}".concat(Ge.equal, "${args[1]}\\right)")
  },
  larger: {
    2: "\\left(${args[0]}".concat(Ge.larger, "${args[1]}\\right)")
  },
  largerEq: {
    2: "\\left(${args[0]}".concat(Ge.largerEq, "${args[1]}\\right)")
  },
  smaller: {
    2: "\\left(${args[0]}".concat(Ge.smaller, "${args[1]}\\right)")
  },
  smallerEq: {
    2: "\\left(${args[0]}".concat(Ge.smallerEq, "${args[1]}\\right)")
  },
  unequal: {
    2: "\\left(${args[0]}".concat(Ge.unequal, "${args[1]}\\right)")
  },
  // special
  erf: {
    1: "erf\\left(${args[0]}\\right)"
  },
  // statistics
  max: "\\max\\left(${args}\\right)",
  min: "\\min\\left(${args}\\right)",
  variance: "\\mathrm{Var}\\left(${args}\\right)",
  // trigonometry
  acos: {
    1: "\\cos^{-1}\\left(${args[0]}\\right)"
  },
  acosh: {
    1: "\\cosh^{-1}\\left(${args[0]}\\right)"
  },
  acot: {
    1: "\\cot^{-1}\\left(${args[0]}\\right)"
  },
  acoth: {
    1: "\\coth^{-1}\\left(${args[0]}\\right)"
  },
  acsc: {
    1: "\\csc^{-1}\\left(${args[0]}\\right)"
  },
  acsch: {
    1: "\\mathrm{csch}^{-1}\\left(${args[0]}\\right)"
  },
  asec: {
    1: "\\sec^{-1}\\left(${args[0]}\\right)"
  },
  asech: {
    1: "\\mathrm{sech}^{-1}\\left(${args[0]}\\right)"
  },
  asin: {
    1: "\\sin^{-1}\\left(${args[0]}\\right)"
  },
  asinh: {
    1: "\\sinh^{-1}\\left(${args[0]}\\right)"
  },
  atan: {
    1: "\\tan^{-1}\\left(${args[0]}\\right)"
  },
  atan2: {
    2: "\\mathrm{atan2}\\left(${args}\\right)"
  },
  atanh: {
    1: "\\tanh^{-1}\\left(${args[0]}\\right)"
  },
  cos: {
    1: "\\cos\\left(${args[0]}\\right)"
  },
  cosh: {
    1: "\\cosh\\left(${args[0]}\\right)"
  },
  cot: {
    1: "\\cot\\left(${args[0]}\\right)"
  },
  coth: {
    1: "\\coth\\left(${args[0]}\\right)"
  },
  csc: {
    1: "\\csc\\left(${args[0]}\\right)"
  },
  csch: {
    1: "\\mathrm{csch}\\left(${args[0]}\\right)"
  },
  sec: {
    1: "\\sec\\left(${args[0]}\\right)"
  },
  sech: {
    1: "\\mathrm{sech}\\left(${args[0]}\\right)"
  },
  sin: {
    1: "\\sin\\left(${args[0]}\\right)"
  },
  sinh: {
    1: "\\sinh\\left(${args[0]}\\right)"
  },
  tan: {
    1: "\\tan\\left(${args[0]}\\right)"
  },
  tanh: {
    1: "\\tanh\\left(${args[0]}\\right)"
  },
  // unit
  to: {
    2: "\\left(${args[0]}".concat(Ge.to, "${args[1]}\\right)")
  },
  // utils
  numeric: function(e, t) {
    return e.args[0].toTex();
  },
  // type
  number: {
    0: "0",
    1: "\\left(${args[0]}\\right)",
    2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
  },
  string: {
    0: '\\mathtt{""}',
    1: "\\mathrm{string}\\left(${args[0]}\\right)"
  },
  bignumber: {
    0: "0",
    1: "\\left(${args[0]}\\right)"
  },
  bigint: {
    0: "0",
    1: "\\left(${args[0]}\\right)"
  },
  complex: {
    0: "0",
    1: "\\left(${args[0]}\\right)",
    2: "\\left(\\left(${args[0]}\\right)+".concat(Qi.i, "\\cdot\\left(${args[1]}\\right)\\right)")
  },
  matrix: {
    0: "\\begin{bmatrix}\\end{bmatrix}",
    1: "\\left(${args[0]}\\right)",
    2: "\\left(${args[0]}\\right)"
  },
  sparse: {
    0: "\\begin{bsparse}\\end{bsparse}",
    1: "\\left(${args[0]}\\right)"
  },
  unit: {
    1: "\\left(${args[0]}\\right)",
    2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
  }
}, B2 = "\\mathrm{${name}}\\left(${args}\\right)", Yc = {
  deg: "^\\circ"
};
function ji(r) {
  return F2(r, {
    preserveFormatting: !0
  });
}
function fd(r, e) {
  return e = typeof e > "u" ? !1 : e, e ? xe(Yc, r) ? Yc[r] : "\\mathrm{" + ji(r) + "}" : xe(Qi, r) ? Qi[r] : ji(r);
}
var Kn = "ConstantNode", O2 = ["Node"], I2 = /* @__PURE__ */ R(Kn, O2, (r) => {
  var {
    Node: e
  } = r;
  class t extends e {
    /**
     * A ConstantNode holds a constant value like a number or string.
     *
     * Usage:
     *
     *     new ConstantNode(2.3)
     *     new ConstantNode('hello')
     *
     * @param {*} value    Value can be any type (number, BigNumber, bigint, string, ...)
     * @constructor ConstantNode
     * @extends {Node}
     */
    constructor(a) {
      super(), this.value = a;
    }
    get type() {
      return Kn;
    }
    get isConstantNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(a, i) {
      var s = this.value;
      return function() {
        return s;
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(a) {
    }
    /**
     * Create a new ConstantNode with children produced by the given callback.
     * Trivial because there are no children.
     * @param {function(child: Node, path: string, parent: Node) : Node} callback
     * @returns {ConstantNode} Returns a clone of the node
     */
    map(a) {
      return this.clone();
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {ConstantNode}
     */
    clone() {
      return new t(this.value);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    _toString(a) {
      return ke(this.value, a);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(a) {
      var i = this._toString(a);
      switch (Ke(this.value)) {
        case "number":
        case "bigint":
        case "BigNumber":
        case "Fraction":
          return '<span class="math-number">' + i + "</span>";
        case "string":
          return '<span class="math-string">' + i + "</span>";
        case "boolean":
          return '<span class="math-boolean">' + i + "</span>";
        case "null":
          return '<span class="math-null-symbol">' + i + "</span>";
        case "undefined":
          return '<span class="math-undefined">' + i + "</span>";
        default:
          return '<span class="math-symbol">' + i + "</span>";
      }
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: Kn,
        value: this.value
      };
    }
    /**
     * Instantiate a ConstantNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "SymbolNode", value: 2.3}`,
     *                       where mathjs is optional
     * @returns {ConstantNode}
     */
    static fromJSON(a) {
      return new t(a.value);
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(a) {
      var i = this._toString(a), s = Ke(this.value);
      switch (s) {
        case "string":
          return "\\mathtt{" + ji(i) + "}";
        case "number":
        case "BigNumber": {
          var l = s === "BigNumber" ? this.value.isFinite() : isFinite(this.value);
          if (!l)
            return this.value.valueOf() < 0 ? "-\\infty" : "\\infty";
          var c = i.toLowerCase().indexOf("e");
          return c !== -1 ? i.substring(0, c) + "\\cdot10^{" + i.substring(c + 1) + "}" : i;
        }
        case "bigint":
          return i.toString();
        case "Fraction":
          return this.value.toLatex();
        default:
          return i;
      }
    }
  }
  return or(t, "name", Kn), t;
}, {
  isClass: !0,
  isNode: !0
}), ea = "FunctionAssignmentNode", $2 = ["typed", "Node"], z2 = /* @__PURE__ */ R(ea, $2, (r) => {
  var {
    typed: e,
    Node: t
  } = r;
  function n(i, s, l) {
    var c = je(i, s, l), o = je(i.expr, s, l);
    return s === "all" || o !== null && o <= c;
  }
  class a extends t {
    /**
     * @constructor FunctionAssignmentNode
     * @extends {Node}
     * Function assignment
     *
     * @param {string} name           Function name
     * @param {string[] | Array.<{name: string, type: string}>} params
     *                                Array with function parameter names, or an
     *                                array with objects containing the name
     *                                and type of the parameter
     * @param {Node} expr             The function expression
     */
    constructor(s, l, c) {
      if (super(), typeof s != "string")
        throw new TypeError('String expected for parameter "name"');
      if (!Array.isArray(l))
        throw new TypeError('Array containing strings or objects expected for parameter "params"');
      if (!Xe(c))
        throw new TypeError('Node expected for parameter "expr"');
      if (cd.has(s))
        throw new Error('Illegal function name, "' + s + '" is a reserved keyword');
      var o = /* @__PURE__ */ new Set();
      for (var u of l) {
        var f = typeof u == "string" ? u : u.name;
        if (o.has(f))
          throw new Error('Duplicate parameter name "'.concat(f, '"'));
        o.add(f);
      }
      this.name = s, this.params = l.map(function(m) {
        return m && m.name || m;
      }), this.types = l.map(function(m) {
        return m && m.type || "any";
      }), this.expr = c;
    }
    get type() {
      return ea;
    }
    get isFunctionAssignmentNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(s, l) {
      var c = Object.create(l);
      hm(this.params, function(v) {
        c[v] = !0;
      });
      var o = this.expr, u = o._compile(s, c), f = this.name, m = this.params, p = Vo(this.types, ","), d = f + "(" + Vo(this.params, ", ") + ")";
      return function(x, h, D) {
        var y = {};
        y[p] = function() {
          for (var b = Object.create(h), g = 0; g < m.length; g++)
            b[m[g]] = arguments[g];
          return u(x, b, D);
        };
        var w = e(f, y);
        return w.syntax = d, w.expr = o.toString(), x.set(f, w), w;
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(s) {
      s(this.expr, "expr", this);
    }
    /**
     * Create a new FunctionAssignmentNode whose children are the results of
     * calling the provided callback function for each child of the original
     * node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {FunctionAssignmentNode} Returns a transformed copy of the node
     */
    map(s) {
      var l = this._ifNode(s(this.expr, "expr", this));
      return new a(this.name, this.params.slice(0), l);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {FunctionAssignmentNode}
     */
    clone() {
      return new a(this.name, this.params.slice(0), this.expr);
    }
    /**
     * get string representation
     * @param {Object} options
     * @return {string} str
     */
    _toString(s) {
      var l = s && s.parenthesis ? s.parenthesis : "keep", c = this.expr.toString(s);
      return n(this, l, s && s.implicit) && (c = "(" + c + ")"), this.name + "(" + this.params.join(", ") + ") = " + c;
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      var s = this.types;
      return {
        mathjs: ea,
        name: this.name,
        params: this.params.map(function(l, c) {
          return {
            name: l,
            type: s[c]
          };
        }),
        expr: this.expr
      };
    }
    /**
     * Instantiate an FunctionAssignmentNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     ```
     *     {"mathjs": "FunctionAssignmentNode",
     *      name: ..., params: ..., expr: ...}
     *     ```
     *     where mathjs is optional
     * @returns {FunctionAssignmentNode}
     */
    static fromJSON(s) {
      return new a(s.name, s.params, s.expr);
    }
    /**
     * get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(s) {
      for (var l = s && s.parenthesis ? s.parenthesis : "keep", c = [], o = 0; o < this.params.length; o++)
        c.push('<span class="math-symbol math-parameter">' + Lr(this.params[o]) + "</span>");
      var u = this.expr.toHTML(s);
      return n(this, l, s && s.implicit) && (u = '<span class="math-parenthesis math-round-parenthesis">(</span>' + u + '<span class="math-parenthesis math-round-parenthesis">)</span>'), '<span class="math-function">' + Lr(this.name) + '</span><span class="math-parenthesis math-round-parenthesis">(</span>' + c.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + u;
    }
    /**
     * get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(s) {
      var l = s && s.parenthesis ? s.parenthesis : "keep", c = this.expr.toTex(s);
      return n(this, l, s && s.implicit) && (c = "\\left(".concat(c, "\\right)")), "\\mathrm{" + this.name + "}\\left(" + this.params.map(fd).join(",") + "\\right)=" + c;
    }
  }
  return or(a, "name", ea), a;
}, {
  isClass: !0,
  isNode: !0
}), ra = "IndexNode", R2 = ["Node", "size"], q2 = /* @__PURE__ */ R(ra, R2, (r) => {
  var {
    Node: e,
    size: t
  } = r;
  class n extends e {
    /**
     * @constructor IndexNode
     * @extends Node
     *
     * Describes a subset of a matrix or an object property.
     * Cannot be used on its own, needs to be used within an AccessorNode or
     * AssignmentNode.
     *
     * @param {Node[]} dimensions
     * @param {boolean} [dotNotation=false]
     *     Optional property describing whether this index was written using dot
     *     notation like `a.b`, or using bracket notation like `a["b"]`
     *     (which is the default). This property is used for string conversion.
     */
    constructor(i, s) {
      if (super(), this.dimensions = i, this.dotNotation = s || !1, !Array.isArray(i) || !i.every(Xe))
        throw new TypeError('Array containing Nodes expected for parameter "dimensions"');
      if (this.dotNotation && !this.isObjectProperty())
        throw new Error("dotNotation only applicable for object properties");
    }
    get type() {
      return ra;
    }
    get isIndexNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(i, s) {
      var l = xt(this.dimensions, function(o, u) {
        var f = o.filter((d) => d.isSymbolNode && d.name === "end").length > 0;
        if (f) {
          var m = Object.create(s);
          m.end = !0;
          var p = o._compile(i, m);
          return function(v, x, h) {
            if (!Ee(h) && !Ye(h) && !gr(h))
              throw new TypeError('Cannot resolve "end": context must be a Matrix, Array, or string but is ' + Ke(h));
            var D = t(h).valueOf(), y = Object.create(x);
            return y.end = D[u], p(v, y, h);
          };
        } else
          return o._compile(i, s);
      }), c = Mr(i, "index");
      return function(u, f, m) {
        var p = xt(l, function(d) {
          return d(u, f, m);
        });
        return c(...p);
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(i) {
      for (var s = 0; s < this.dimensions.length; s++)
        i(this.dimensions[s], "dimensions[" + s + "]", this);
    }
    /**
     * Create a new IndexNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {IndexNode} Returns a transformed copy of the node
     */
    map(i) {
      for (var s = [], l = 0; l < this.dimensions.length; l++)
        s[l] = this._ifNode(i(this.dimensions[l], "dimensions[" + l + "]", this));
      return new n(s, this.dotNotation);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {IndexNode}
     */
    clone() {
      return new n(this.dimensions.slice(0), this.dotNotation);
    }
    /**
     * Test whether this IndexNode contains a single property name
     * @return {boolean}
     */
    isObjectProperty() {
      return this.dimensions.length === 1 && We(this.dimensions[0]) && typeof this.dimensions[0].value == "string";
    }
    /**
     * Returns the property name if IndexNode contains a property.
     * If not, returns null.
     * @return {string | null}
     */
    getObjectProperty() {
      return this.isObjectProperty() ? this.dimensions[0].value : null;
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    _toString(i) {
      return this.dotNotation ? "." + this.getObjectProperty() : "[" + this.dimensions.join(", ") + "]";
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: ra,
        dimensions: this.dimensions,
        dotNotation: this.dotNotation
      };
    }
    /**
     * Instantiate an IndexNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "IndexNode", dimensions: [...], dotNotation: false}`,
     *     where mathjs is optional
     * @returns {IndexNode}
     */
    static fromJSON(i) {
      return new n(i.dimensions, i.dotNotation);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(i) {
      for (var s = [], l = 0; l < this.dimensions.length; l++)
        s[l] = this.dimensions[l].toHTML();
      return this.dotNotation ? '<span class="math-operator math-accessor-operator">.</span><span class="math-symbol math-property">' + Lr(this.getObjectProperty()) + "</span>" : '<span class="math-parenthesis math-square-parenthesis">[</span>' + s.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(i) {
      var s = this.dimensions.map(function(l) {
        return l.toTex(i);
      });
      return this.dotNotation ? "." + this.getObjectProperty() : "_{" + s.join(",") + "}";
    }
  }
  return or(n, "name", ra), n;
}, {
  isClass: !0,
  isNode: !0
}), ta = "ObjectNode", P2 = ["Node"], U2 = /* @__PURE__ */ R(ta, P2, (r) => {
  var {
    Node: e
  } = r;
  class t extends e {
    /**
     * @constructor ObjectNode
     * @extends {Node}
     * Holds an object with keys/values
     * @param {Object.<string, Node>} [properties]   object with key/value pairs
     */
    constructor(a) {
      if (super(), this.properties = a || {}, a && (typeof a != "object" || !Object.keys(a).every(function(i) {
        return Xe(a[i]);
      })))
        throw new TypeError("Object containing Nodes expected");
    }
    get type() {
      return ta;
    }
    get isObjectNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(a, i) {
      var s = {};
      for (var l in this.properties)
        if (xe(this.properties, l)) {
          var c = jt(l), o = JSON.parse(c), u = Mr(this.properties, l);
          s[o] = u._compile(a, i);
        }
      return function(m, p, d) {
        var v = {};
        for (var x in s)
          xe(s, x) && (v[x] = s[x](m, p, d));
        return v;
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(a) {
      for (var i in this.properties)
        xe(this.properties, i) && a(this.properties[i], "properties[" + jt(i) + "]", this);
    }
    /**
     * Create a new ObjectNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {ObjectNode} Returns a transformed copy of the node
     */
    map(a) {
      var i = {};
      for (var s in this.properties)
        xe(this.properties, s) && (i[s] = this._ifNode(a(this.properties[s], "properties[" + jt(s) + "]", this)));
      return new t(i);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {ObjectNode}
     */
    clone() {
      var a = {};
      for (var i in this.properties)
        xe(this.properties, i) && (a[i] = this.properties[i]);
      return new t(a);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toString(a) {
      var i = [];
      for (var s in this.properties)
        xe(this.properties, s) && i.push(jt(s) + ": " + this.properties[s].toString(a));
      return "{" + i.join(", ") + "}";
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: ta,
        properties: this.properties
      };
    }
    /**
     * Instantiate an OperatorNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "ObjectNode", "properties": {...}}`,
     *                       where mathjs is optional
     * @returns {ObjectNode}
     */
    static fromJSON(a) {
      return new t(a.properties);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toHTML(a) {
      var i = [];
      for (var s in this.properties)
        xe(this.properties, s) && i.push('<span class="math-symbol math-property">' + Lr(s) + '</span><span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>' + this.properties[s].toHTML(a));
      return '<span class="math-parenthesis math-curly-parenthesis">{</span>' + i.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-curly-parenthesis">}</span>';
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(a) {
      var i = [];
      for (var s in this.properties)
        xe(this.properties, s) && i.push("\\mathbf{" + s + ":} & " + this.properties[s].toTex(a) + "\\\\");
      var l = "\\left\\{\\begin{array}{ll}" + i.join(`
`) + "\\end{array}\\right\\}";
      return l;
    }
  }
  return or(t, "name", ta), t;
}, {
  isClass: !0,
  isNode: !0
});
function An(r, e) {
  return new Ef(r, new Qa(e), new Set(Object.keys(e)));
}
var na = "OperatorNode", L2 = ["Node"], k2 = /* @__PURE__ */ R(na, L2, (r) => {
  var {
    Node: e
  } = r;
  function t(i, s) {
    var l = i;
    if (s === "auto")
      for (; et(l); ) l = l.content;
    return We(l) ? !0 : ir(l) ? t(l.args[0], s) : !1;
  }
  function n(i, s, l, c, o) {
    var u = je(i, s, l), f = Dn(i, s);
    if (s === "all" || c.length > 2 && i.getIdentifier() !== "OperatorNode:add" && i.getIdentifier() !== "OperatorNode:multiply")
      return c.map(function(E) {
        switch (E.getContent().type) {
          // Nodes that don't need extra parentheses
          case "ArrayNode":
          case "ConstantNode":
          case "SymbolNode":
          case "ParenthesisNode":
            return !1;
          default:
            return !0;
        }
      });
    var m;
    switch (c.length) {
      case 0:
        m = [];
        break;
      case 1:
        {
          var p = je(c[0], s, l, i);
          if (o && p !== null) {
            var d, v;
            if (s === "keep" ? (d = c[0].getIdentifier(), v = i.getIdentifier()) : (d = c[0].getContent().getIdentifier(), v = i.getContent().getIdentifier()), Vr[u][v].latexLeftParens === !1) {
              m = [!1];
              break;
            }
            if (Vr[p][d].latexParens === !1) {
              m = [!1];
              break;
            }
          }
          if (p === null) {
            m = [!1];
            break;
          }
          if (p <= u) {
            m = [!0];
            break;
          }
          m = [!1];
        }
        break;
      case 2:
        {
          var x, h = je(c[0], s, l, i), D = Ni(i, c[0], s);
          h === null ? x = !1 : h === u && f === "right" && !D || h < u ? x = !0 : x = !1;
          var y, w = je(c[1], s, l, i), b = Ni(i, c[1], s);
          if (w === null ? y = !1 : w === u && f === "left" && !b || w < u ? y = !0 : y = !1, o) {
            var g, N, S;
            s === "keep" ? (g = i.getIdentifier(), N = i.args[0].getIdentifier(), S = i.args[1].getIdentifier()) : (g = i.getContent().getIdentifier(), N = i.args[0].getContent().getIdentifier(), S = i.args[1].getContent().getIdentifier()), h !== null && (Vr[u][g].latexLeftParens === !1 && (x = !1), Vr[h][N].latexParens === !1 && (x = !1)), w !== null && (Vr[u][g].latexRightParens === !1 && (y = !1), Vr[w][S].latexParens === !1 && (y = !1));
          }
          m = [x, y];
        }
        break;
      default:
        (i.getIdentifier() === "OperatorNode:add" || i.getIdentifier() === "OperatorNode:multiply") && (m = c.map(function(E) {
          var M = je(E, s, l, i), T = Ni(i, E, s), B = Dn(E, s);
          return M === null ? !1 : u === M && f === B && !T ? !0 : M < u;
        }));
        break;
    }
    if (c.length >= 2 && i.getIdentifier() === "OperatorNode:multiply" && i.implicit && s !== "all" && l === "hide")
      for (var A = 1; A < m.length; ++A)
        t(c[A], s) && !m[A - 1] && (s !== "keep" || !et(c[A - 1])) && (m[A] = !0);
    return m;
  }
  class a extends e {
    /**
     * @constructor OperatorNode
     * @extends {Node}
     * An operator with two arguments, like 2+3
     *
     * @param {string} op           Operator name, for example '+'
     * @param {string} fn           Function name, for example 'add'
     * @param {Node[]} args         Operator arguments
     * @param {boolean} [implicit]  Is this an implicit multiplication?
     * @param {boolean} [isPercentage] Is this an percentage Operation?
     */
    constructor(s, l, c, o, u) {
      if (super(), typeof s != "string")
        throw new TypeError('string expected for parameter "op"');
      if (typeof l != "string")
        throw new TypeError('string expected for parameter "fn"');
      if (!Array.isArray(c) || !c.every(Xe))
        throw new TypeError('Array containing Nodes expected for parameter "args"');
      this.implicit = o === !0, this.isPercentage = u === !0, this.op = s, this.fn = l, this.args = c || [];
    }
    get type() {
      return na;
    }
    get isOperatorNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(s, l) {
      if (typeof this.fn != "string" || !to(s, this.fn))
        throw s[this.fn] ? new Error('No access to function "' + this.fn + '"') : new Error("Function " + this.fn + ' missing in provided namespace "math"');
      var c = Mr(s, this.fn), o = xt(this.args, function(d) {
        return d._compile(s, l);
      });
      if (typeof c == "function" && c.rawArgs === !0) {
        var u = this.args;
        return function(v, x, h) {
          return c(u, s, An(v, x));
        };
      } else if (o.length === 1) {
        var f = o[0];
        return function(v, x, h) {
          return c(f(v, x, h));
        };
      } else if (o.length === 2) {
        var m = o[0], p = o[1];
        return function(v, x, h) {
          return c(m(v, x, h), p(v, x, h));
        };
      } else
        return function(v, x, h) {
          return c.apply(null, xt(o, function(D) {
            return D(v, x, h);
          }));
        };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(s) {
      for (var l = 0; l < this.args.length; l++)
        s(this.args[l], "args[" + l + "]", this);
    }
    /**
     * Create a new OperatorNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {OperatorNode} Returns a transformed copy of the node
     */
    map(s) {
      for (var l = [], c = 0; c < this.args.length; c++)
        l[c] = this._ifNode(s(this.args[c], "args[" + c + "]", this));
      return new a(this.op, this.fn, l, this.implicit, this.isPercentage);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {OperatorNode}
     */
    clone() {
      return new a(this.op, this.fn, this.args.slice(0), this.implicit, this.isPercentage);
    }
    /**
     * Check whether this is an unary OperatorNode:
     * has exactly one argument, like `-a`.
     * @return {boolean}
     *     Returns true when an unary operator node, false otherwise.
     */
    isUnary() {
      return this.args.length === 1;
    }
    /**
     * Check whether this is a binary OperatorNode:
     * has exactly two arguments, like `a + b`.
     * @return {boolean}
     *     Returns true when a binary operator node, false otherwise.
     */
    isBinary() {
      return this.args.length === 2;
    }
    /**
     * Get string representation.
     * @param {Object} options
     * @return {string} str
     */
    _toString(s) {
      var l = s && s.parenthesis ? s.parenthesis : "keep", c = s && s.implicit ? s.implicit : "hide", o = this.args, u = n(this, l, c, o, !1);
      if (o.length === 1) {
        var f = Dn(this, l), m = o[0].toString(s);
        u[0] && (m = "(" + m + ")");
        var p = /[a-zA-Z]+/.test(this.op);
        return f === "right" ? this.op + (p ? " " : "") + m : f === "left" ? m + (p ? " " : "") + this.op : m + this.op;
      } else if (o.length === 2) {
        var d = o[0].toString(s), v = o[1].toString(s);
        return u[0] && (d = "(" + d + ")"), u[1] && (v = "(" + v + ")"), this.implicit && this.getIdentifier() === "OperatorNode:multiply" && c === "hide" ? d + " " + v : d + " " + this.op + " " + v;
      } else if (o.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
        var x = o.map(function(h, D) {
          return h = h.toString(s), u[D] && (h = "(" + h + ")"), h;
        });
        return this.implicit && this.getIdentifier() === "OperatorNode:multiply" && c === "hide" ? x.join(" ") : x.join(" " + this.op + " ");
      } else
        return this.fn + "(" + this.args.join(", ") + ")";
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: na,
        op: this.op,
        fn: this.fn,
        args: this.args,
        implicit: this.implicit,
        isPercentage: this.isPercentage
      };
    }
    /**
     * Instantiate an OperatorNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     ```
     *     {"mathjs": "OperatorNode",
     *      "op": "+", "fn": "add", "args": [...],
     *      "implicit": false,
     *      "isPercentage":false}
     *     ```
     *     where mathjs is optional
     * @returns {OperatorNode}
     */
    static fromJSON(s) {
      return new a(s.op, s.fn, s.args, s.implicit, s.isPercentage);
    }
    /**
     * Get HTML representation.
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(s) {
      var l = s && s.parenthesis ? s.parenthesis : "keep", c = s && s.implicit ? s.implicit : "hide", o = this.args, u = n(this, l, c, o, !1);
      if (o.length === 1) {
        var f = Dn(this, l), m = o[0].toHTML(s);
        return u[0] && (m = '<span class="math-parenthesis math-round-parenthesis">(</span>' + m + '<span class="math-parenthesis math-round-parenthesis">)</span>'), f === "right" ? '<span class="math-operator math-unary-operator math-lefthand-unary-operator">' + Lr(this.op) + "</span>" + m : m + '<span class="math-operator math-unary-operator math-righthand-unary-operator">' + Lr(this.op) + "</span>";
      } else if (o.length === 2) {
        var p = o[0].toHTML(s), d = o[1].toHTML(s);
        return u[0] && (p = '<span class="math-parenthesis math-round-parenthesis">(</span>' + p + '<span class="math-parenthesis math-round-parenthesis">)</span>'), u[1] && (d = '<span class="math-parenthesis math-round-parenthesis">(</span>' + d + '<span class="math-parenthesis math-round-parenthesis">)</span>'), this.implicit && this.getIdentifier() === "OperatorNode:multiply" && c === "hide" ? p + '<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>' + d : p + '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + Lr(this.op) + "</span>" + d;
      } else {
        var v = o.map(function(x, h) {
          return x = x.toHTML(s), u[h] && (x = '<span class="math-parenthesis math-round-parenthesis">(</span>' + x + '<span class="math-parenthesis math-round-parenthesis">)</span>'), x;
        });
        return o.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply") ? this.implicit && this.getIdentifier() === "OperatorNode:multiply" && c === "hide" ? v.join('<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>') : v.join('<span class="math-operator math-binary-operator math-explicit-binary-operator">' + Lr(this.op) + "</span>") : '<span class="math-function">' + Lr(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + v.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
      }
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(s) {
      var l = s && s.parenthesis ? s.parenthesis : "keep", c = s && s.implicit ? s.implicit : "hide", o = this.args, u = n(this, l, c, o, !0), f = Ge[this.fn];
      if (f = typeof f > "u" ? this.op : f, o.length === 1) {
        var m = Dn(this, l), p = o[0].toTex(s);
        return u[0] && (p = "\\left(".concat(p, "\\right)")), m === "right" ? f + p : p + f;
      } else if (o.length === 2) {
        var d = o[0], v = d.toTex(s);
        u[0] && (v = "\\left(".concat(v, "\\right)"));
        var x = o[1], h = x.toTex(s);
        u[1] && (h = "\\left(".concat(h, "\\right)"));
        var D;
        switch (l === "keep" ? D = d.getIdentifier() : D = d.getContent().getIdentifier(), this.getIdentifier()) {
          case "OperatorNode:divide":
            return f + "{" + v + "}{" + h + "}";
          case "OperatorNode:pow":
            switch (v = "{" + v + "}", h = "{" + h + "}", D) {
              case "ConditionalNode":
              //
              case "OperatorNode:divide":
                v = "\\left(".concat(v, "\\right)");
            }
            break;
          case "OperatorNode:multiply":
            if (this.implicit && c === "hide")
              return v + "~" + h;
        }
        return v + f + h;
      } else if (o.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
        var y = o.map(function(w, b) {
          return w = w.toTex(s), u[b] && (w = "\\left(".concat(w, "\\right)")), w;
        });
        return this.getIdentifier() === "OperatorNode:multiply" && this.implicit && c === "hide" ? y.join("~") : y.join(f);
      } else
        return "\\mathrm{" + this.fn + "}\\left(" + o.map(function(w) {
          return w.toTex(s);
        }).join(",") + "\\right)";
    }
    /**
     * Get identifier.
     * @return {string}
     */
    getIdentifier() {
      return this.type + ":" + this.fn;
    }
  }
  return or(a, "name", na), a;
}, {
  isClass: !0,
  isNode: !0
}), aa = "ParenthesisNode", H2 = ["Node"], W2 = /* @__PURE__ */ R(aa, H2, (r) => {
  var {
    Node: e
  } = r;
  class t extends e {
    /**
     * @constructor ParenthesisNode
     * @extends {Node}
     * A parenthesis node describes manual parenthesis from the user input
     * @param {Node} content
     * @extends {Node}
     */
    constructor(a) {
      if (super(), !Xe(a))
        throw new TypeError('Node expected for parameter "content"');
      this.content = a;
    }
    get type() {
      return aa;
    }
    get isParenthesisNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(a, i) {
      return this.content._compile(a, i);
    }
    /**
     * Get the content of the current Node.
     * @return {Node} content
     * @override
     **/
    getContent() {
      return this.content.getContent();
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(a) {
      a(this.content, "content", this);
    }
    /**
     * Create a new ParenthesisNode whose child is the result of calling
     * the provided callback function on the child of this node.
     * @param {function(child: Node, path: string, parent: Node) : Node} callback
     * @returns {ParenthesisNode} Returns a clone of the node
     */
    map(a) {
      var i = a(this.content, "content", this);
      return new t(i);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {ParenthesisNode}
     */
    clone() {
      return new t(this.content);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toString(a) {
      return !a || a && !a.parenthesis || a && a.parenthesis === "keep" ? "(" + this.content.toString(a) + ")" : this.content.toString(a);
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: aa,
        content: this.content
      };
    }
    /**
     * Instantiate an ParenthesisNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "ParenthesisNode", "content": ...}`,
     *                       where mathjs is optional
     * @returns {ParenthesisNode}
     */
    static fromJSON(a) {
      return new t(a.content);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toHTML(a) {
      return !a || a && !a.parenthesis || a && a.parenthesis === "keep" ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + this.content.toHTML(a) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : this.content.toHTML(a);
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toTex(a) {
      return !a || a && !a.parenthesis || a && a.parenthesis === "keep" ? "\\left(".concat(this.content.toTex(a), "\\right)") : this.content.toTex(a);
    }
  }
  return or(t, "name", aa), t;
}, {
  isClass: !0,
  isNode: !0
}), ia = "RangeNode", G2 = ["Node"], V2 = /* @__PURE__ */ R(ia, G2, (r) => {
  var {
    Node: e
  } = r;
  function t(a, i, s) {
    var l = je(a, i, s), c = {}, o = je(a.start, i, s);
    if (c.start = o !== null && o <= l || i === "all", a.step) {
      var u = je(a.step, i, s);
      c.step = u !== null && u <= l || i === "all";
    }
    var f = je(a.end, i, s);
    return c.end = f !== null && f <= l || i === "all", c;
  }
  class n extends e {
    /**
     * @constructor RangeNode
     * @extends {Node}
     * create a range
     * @param {Node} start  included lower-bound
     * @param {Node} end    included upper-bound
     * @param {Node} [step] optional step
     */
    constructor(i, s, l) {
      if (super(), !Xe(i)) throw new TypeError("Node expected");
      if (!Xe(s)) throw new TypeError("Node expected");
      if (l && !Xe(l)) throw new TypeError("Node expected");
      if (arguments.length > 3) throw new Error("Too many arguments");
      this.start = i, this.end = s, this.step = l || null;
    }
    get type() {
      return ia;
    }
    get isRangeNode() {
      return !0;
    }
    /**
     * Check whether the RangeNode needs the `end` symbol to be defined.
     * This end is the size of the Matrix in current dimension.
     * @return {boolean}
     */
    needsEnd() {
      var i = this.filter(function(s) {
        return ur(s) && s.name === "end";
      });
      return i.length > 0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(i, s) {
      var l = i.range, c = this.start._compile(i, s), o = this.end._compile(i, s);
      if (this.step) {
        var u = this.step._compile(i, s);
        return function(m, p, d) {
          return l(c(m, p, d), o(m, p, d), u(m, p, d));
        };
      } else
        return function(m, p, d) {
          return l(c(m, p, d), o(m, p, d));
        };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(i) {
      i(this.start, "start", this), i(this.end, "end", this), this.step && i(this.step, "step", this);
    }
    /**
     * Create a new RangeNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {RangeNode} Returns a transformed copy of the node
     */
    map(i) {
      return new n(this._ifNode(i(this.start, "start", this)), this._ifNode(i(this.end, "end", this)), this.step && this._ifNode(i(this.step, "step", this)));
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {RangeNode}
     */
    clone() {
      return new n(this.start, this.end, this.step && this.step);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    _toString(i) {
      var s = i && i.parenthesis ? i.parenthesis : "keep", l = t(this, s, i && i.implicit), c, o = this.start.toString(i);
      if (l.start && (o = "(" + o + ")"), c = o, this.step) {
        var u = this.step.toString(i);
        l.step && (u = "(" + u + ")"), c += ":" + u;
      }
      var f = this.end.toString(i);
      return l.end && (f = "(" + f + ")"), c += ":" + f, c;
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: ia,
        start: this.start,
        end: this.end,
        step: this.step
      };
    }
    /**
     * Instantiate an RangeNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "RangeNode", "start": ..., "end": ..., "step": ...}`,
     *     where mathjs is optional
     * @returns {RangeNode}
     */
    static fromJSON(i) {
      return new n(i.start, i.end, i.step);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(i) {
      var s = i && i.parenthesis ? i.parenthesis : "keep", l = t(this, s, i && i.implicit), c, o = this.start.toHTML(i);
      if (l.start && (o = '<span class="math-parenthesis math-round-parenthesis">(</span>' + o + '<span class="math-parenthesis math-round-parenthesis">)</span>'), c = o, this.step) {
        var u = this.step.toHTML(i);
        l.step && (u = '<span class="math-parenthesis math-round-parenthesis">(</span>' + u + '<span class="math-parenthesis math-round-parenthesis">)</span>'), c += '<span class="math-operator math-range-operator">:</span>' + u;
      }
      var f = this.end.toHTML(i);
      return l.end && (f = '<span class="math-parenthesis math-round-parenthesis">(</span>' + f + '<span class="math-parenthesis math-round-parenthesis">)</span>'), c += '<span class="math-operator math-range-operator">:</span>' + f, c;
    }
    /**
     * Get LaTeX representation
     * @params {Object} options
     * @return {string} str
     */
    _toTex(i) {
      var s = i && i.parenthesis ? i.parenthesis : "keep", l = t(this, s, i && i.implicit), c = this.start.toTex(i);
      if (l.start && (c = "\\left(".concat(c, "\\right)")), this.step) {
        var o = this.step.toTex(i);
        l.step && (o = "\\left(".concat(o, "\\right)")), c += ":" + o;
      }
      var u = this.end.toTex(i);
      return l.end && (u = "\\left(".concat(u, "\\right)")), c += ":" + u, c;
    }
  }
  return or(n, "name", ia), n;
}, {
  isClass: !0,
  isNode: !0
}), oa = "RelationalNode", Z2 = ["Node"], X2 = /* @__PURE__ */ R(oa, Z2, (r) => {
  var {
    Node: e
  } = r, t = {
    equal: "==",
    unequal: "!=",
    smaller: "<",
    larger: ">",
    smallerEq: "<=",
    largerEq: ">="
  };
  class n extends e {
    /**
     * A node representing a chained conditional expression, such as 'x > y > z'
     *
     * @param {String[]} conditionals
     *     An array of conditional operators used to compare the parameters
     * @param {Node[]} params
     *     The parameters that will be compared
     *
     * @constructor RelationalNode
     * @extends {Node}
     */
    constructor(i, s) {
      if (super(), !Array.isArray(i))
        throw new TypeError("Parameter conditionals must be an array");
      if (!Array.isArray(s))
        throw new TypeError("Parameter params must be an array");
      if (i.length !== s.length - 1)
        throw new TypeError("Parameter params must contain exactly one more element than parameter conditionals");
      this.conditionals = i, this.params = s;
    }
    get type() {
      return oa;
    }
    get isRelationalNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(i, s) {
      var l = this, c = this.params.map((o) => o._compile(i, s));
      return function(u, f, m) {
        for (var p, d = c[0](u, f, m), v = 0; v < l.conditionals.length; v++) {
          p = d, d = c[v + 1](u, f, m);
          var x = Mr(i, l.conditionals[v]);
          if (!x(p, d))
            return !1;
        }
        return !0;
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(i) {
      this.params.forEach((s, l) => i(s, "params[" + l + "]", this), this);
    }
    /**
     * Create a new RelationalNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {RelationalNode} Returns a transformed copy of the node
     */
    map(i) {
      return new n(this.conditionals.slice(), this.params.map((s, l) => this._ifNode(i(s, "params[" + l + "]", this)), this));
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {RelationalNode}
     */
    clone() {
      return new n(this.conditionals, this.params);
    }
    /**
     * Get string representation.
     * @param {Object} options
     * @return {string} str
     */
    _toString(i) {
      for (var s = i && i.parenthesis ? i.parenthesis : "keep", l = je(this, s, i && i.implicit), c = this.params.map(function(f, m) {
        var p = je(f, s, i && i.implicit);
        return s === "all" || p !== null && p <= l ? "(" + f.toString(i) + ")" : f.toString(i);
      }), o = c[0], u = 0; u < this.conditionals.length; u++)
        o += " " + t[this.conditionals[u]], o += " " + c[u + 1];
      return o;
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: oa,
        conditionals: this.conditionals,
        params: this.params
      };
    }
    /**
     * Instantiate a RelationalNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "RelationalNode", "conditionals": ..., "params": ...}`,
     *     where mathjs is optional
     * @returns {RelationalNode}
     */
    static fromJSON(i) {
      return new n(i.conditionals, i.params);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(i) {
      for (var s = i && i.parenthesis ? i.parenthesis : "keep", l = je(this, s, i && i.implicit), c = this.params.map(function(f, m) {
        var p = je(f, s, i && i.implicit);
        return s === "all" || p !== null && p <= l ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + f.toHTML(i) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : f.toHTML(i);
      }), o = c[0], u = 0; u < this.conditionals.length; u++)
        o += '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + Lr(t[this.conditionals[u]]) + "</span>" + c[u + 1];
      return o;
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(i) {
      for (var s = i && i.parenthesis ? i.parenthesis : "keep", l = je(this, s, i && i.implicit), c = this.params.map(function(f, m) {
        var p = je(f, s, i && i.implicit);
        return s === "all" || p !== null && p <= l ? "\\left(" + f.toTex(i) + "\right)" : f.toTex(i);
      }), o = c[0], u = 0; u < this.conditionals.length; u++)
        o += Ge[this.conditionals[u]] + c[u + 1];
      return o;
    }
  }
  return or(n, "name", oa), n;
}, {
  isClass: !0,
  isNode: !0
}), Y2 = "SymbolNode", J2 = ["math", "?Unit", "Node"], Q2 = /* @__PURE__ */ R(Y2, J2, (r) => {
  var {
    math: e,
    Unit: t,
    Node: n
  } = r;
  function a(s) {
    return t ? t.isValuelessUnit(s) : !1;
  }
  class i extends n {
    /**
     * @constructor SymbolNode
     * @extends {Node}
     * A symbol node can hold and resolve a symbol
     * @param {string} name
     * @extends {Node}
     */
    constructor(l) {
      if (super(), typeof l != "string")
        throw new TypeError('String expected for parameter "name"');
      this.name = l;
    }
    get type() {
      return "SymbolNode";
    }
    get isSymbolNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(l, c) {
      var o = this.name;
      if (c[o] === !0)
        return function(f, m, p) {
          return Mr(m, o);
        };
      if (o in l)
        return function(f, m, p) {
          return f.has(o) ? f.get(o) : Mr(l, o);
        };
      var u = a(o);
      return function(f, m, p) {
        return f.has(o) ? f.get(o) : u ? new t(null, o) : i.onUndefinedSymbol(o);
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(l) {
    }
    /**
     * Create a new SymbolNode with children produced by the given callback.
     * Trivial since a SymbolNode has no children
     * @param {function(child: Node, path: string, parent: Node) : Node} callback
     * @returns {SymbolNode} Returns a clone of the node
     */
    map(l) {
      return this.clone();
    }
    /**
     * Throws an error 'Undefined symbol {name}'
     * @param {string} name
     */
    static onUndefinedSymbol(l) {
      throw new Error("Undefined symbol " + l);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {SymbolNode}
     */
    clone() {
      return new i(this.name);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toString(l) {
      return this.name;
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toHTML(l) {
      var c = Lr(this.name);
      return c === "true" || c === "false" ? '<span class="math-symbol math-boolean">' + c + "</span>" : c === "i" ? '<span class="math-symbol math-imaginary-symbol">' + c + "</span>" : c === "Infinity" ? '<span class="math-symbol math-infinity-symbol">' + c + "</span>" : c === "NaN" ? '<span class="math-symbol math-nan-symbol">' + c + "</span>" : c === "null" ? '<span class="math-symbol math-null-symbol">' + c + "</span>" : c === "undefined" ? '<span class="math-symbol math-undefined-symbol">' + c + "</span>" : '<span class="math-symbol">' + c + "</span>";
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: "SymbolNode",
        name: this.name
      };
    }
    /**
     * Instantiate a SymbolNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "SymbolNode", name: "x"}`,
     *                       where mathjs is optional
     * @returns {SymbolNode}
     */
    static fromJSON(l) {
      return new i(l.name);
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toTex(l) {
      var c = !1;
      typeof e[this.name] > "u" && a(this.name) && (c = !0);
      var o = fd(this.name, c);
      return o[0] === "\\" ? o : " " + o;
    }
  }
  return i;
}, {
  isClass: !0,
  isNode: !0
}), sa = "FunctionNode", j2 = ["math", "Node", "SymbolNode"], K2 = /* @__PURE__ */ R(sa, j2, (r) => {
  var e, {
    math: t,
    Node: n,
    SymbolNode: a
  } = r, i = (c) => ke(c, {
    truncate: 78
  });
  function s(c, o, u) {
    for (var f = "", m = /\$(?:\{([a-z_][a-z_0-9]*)(?:\[([0-9]+)\])?\}|\$)/gi, p = 0, d; (d = m.exec(c)) !== null; )
      if (f += c.substring(p, d.index), p = d.index, d[0] === "$$")
        f += "$", p++;
      else {
        p += d[0].length;
        var v = o[d[1]];
        if (!v)
          throw new ReferenceError("Template: Property " + d[1] + " does not exist.");
        if (d[2] === void 0)
          switch (typeof v) {
            case "string":
              f += v;
              break;
            case "object":
              if (Xe(v))
                f += v.toTex(u);
              else if (Array.isArray(v))
                f += v.map(function(x, h) {
                  if (Xe(x))
                    return x.toTex(u);
                  throw new TypeError("Template: " + d[1] + "[" + h + "] is not a Node.");
                }).join(",");
              else
                throw new TypeError("Template: " + d[1] + " has to be a Node, String or array of Nodes");
              break;
            default:
              throw new TypeError("Template: " + d[1] + " has to be a Node, String or array of Nodes");
          }
        else if (Xe(v[d[2]] && v[d[2]]))
          f += v[d[2]].toTex(u);
        else
          throw new TypeError("Template: " + d[1] + "[" + d[2] + "] is not a Node.");
      }
    return f += c.slice(p), f;
  }
  class l extends n {
    /**
     * @constructor FunctionNode
     * @extends {./Node}
     * invoke a list with arguments on a node
     * @param {./Node | string} fn
     *     Item resolving to a function on which to invoke
     *     the arguments, typically a SymbolNode or AccessorNode
     * @param {./Node[]} args
     */
    constructor(o, u) {
      if (super(), typeof o == "string" && (o = new a(o)), !Xe(o)) throw new TypeError('Node expected as parameter "fn"');
      if (!Array.isArray(u) || !u.every(Xe))
        throw new TypeError('Array containing Nodes expected for parameter "args"');
      this.fn = o, this.args = u || [];
    }
    // readonly property name
    get name() {
      return this.fn.name || "";
    }
    get type() {
      return sa;
    }
    get isFunctionNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(o, u) {
      var f = this.args.map((S) => S._compile(o, u));
      if (ur(this.fn)) {
        var m = this.fn.name;
        if (u[m]) {
          var h = this.args;
          return function(A, E, M) {
            var T = Mr(E, m);
            if (typeof T != "function")
              throw new TypeError("Argument '".concat(m, "' was not a function; received: ").concat(i(T)));
            if (T.rawArgs)
              return T(h, o, An(A, E));
            var B = f.map((I) => I(A, E, M));
            return T.apply(T, B);
          };
        } else {
          var p = m in o ? Mr(o, m) : void 0, d = typeof p == "function" && p.rawArgs === !0, v = (S) => {
            var A;
            if (S.has(m))
              A = S.get(m);
            else if (m in o)
              A = Mr(o, m);
            else
              return l.onUndefinedFunction(m);
            if (typeof A == "function")
              return A;
            throw new TypeError("'".concat(m, `' is not a function; its value is:
  `).concat(i(A)));
          };
          if (d) {
            var x = this.args;
            return function(A, E, M) {
              var T = v(A);
              if (T.rawArgs === !0)
                return T(x, o, An(A, E));
              var B = f.map((I) => I(A, E, M));
              return T(...B);
            };
          } else
            switch (f.length) {
              case 0:
                return function(A, E, M) {
                  var T = v(A);
                  return T();
                };
              case 1:
                return function(A, E, M) {
                  var T = v(A), B = f[0];
                  return T(B(A, E, M));
                };
              case 2:
                return function(A, E, M) {
                  var T = v(A), B = f[0], I = f[1];
                  return T(B(A, E, M), I(A, E, M));
                };
              default:
                return function(A, E, M) {
                  var T = v(A), B = f.map((I) => I(A, E, M));
                  return T(...B);
                };
            }
        }
      } else if (wt(this.fn) && Pt(this.fn.index) && this.fn.index.isObjectProperty()) {
        var D = this.fn.object._compile(o, u), y = this.fn.index.getObjectProperty(), w = this.args;
        return function(A, E, M) {
          var T = D(A, E, M), B = vv(T, y);
          if (B != null && B.rawArgs)
            return B(w, o, An(A, E));
          var I = f.map((O) => O(A, E, M));
          return B.apply(T, I);
        };
      } else {
        var b = this.fn.toString(), g = this.fn._compile(o, u), N = this.args;
        return function(A, E, M) {
          var T = g(A, E, M);
          if (typeof T != "function")
            throw new TypeError("Expression '".concat(b, "' did not evaluate to a function; value is:") + `
  `.concat(i(T)));
          if (T.rawArgs)
            return T(N, o, An(A, E));
          var B = f.map((I) => I(A, E, M));
          return T.apply(T, B);
        };
      }
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(o) {
      o(this.fn, "fn", this);
      for (var u = 0; u < this.args.length; u++)
        o(this.args[u], "args[" + u + "]", this);
    }
    /**
     * Create a new FunctionNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {FunctionNode} Returns a transformed copy of the node
     */
    map(o) {
      for (var u = this._ifNode(o(this.fn, "fn", this)), f = [], m = 0; m < this.args.length; m++)
        f[m] = this._ifNode(o(this.args[m], "args[" + m + "]", this));
      return new l(u, f);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {FunctionNode}
     */
    clone() {
      return new l(this.fn, this.args.slice(0));
    }
    /**
     * Throws an error 'Undefined function {name}'
     * @param {string} name
     */
    /**
     * Get string representation. (wrapper function)
     * This overrides parts of Node's toString function.
     * If callback is an object containing callbacks, it
     * calls the correct callback for the current node,
     * otherwise it falls back to calling Node's toString
     * function.
     *
     * @param {Object} options
     * @return {string} str
     * @override
     */
    toString(o) {
      var u, f = this.fn.toString(o);
      return o && typeof o.handler == "object" && xe(o.handler, f) && (u = o.handler[f](this, o)), typeof u < "u" ? u : super.toString(o);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    _toString(o) {
      var u = this.args.map(function(m) {
        return m.toString(o);
      }), f = mn(this.fn) ? "(" + this.fn.toString(o) + ")" : this.fn.toString(o);
      return f + "(" + u.join(", ") + ")";
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: sa,
        fn: this.fn,
        args: this.args
      };
    }
    /**
     * Instantiate an AssignmentNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "FunctionNode", fn: ..., args: ...}`,
     *                       where mathjs is optional
     * @returns {FunctionNode}
     */
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(o) {
      var u = this.args.map(function(f) {
        return f.toHTML(o);
      });
      return '<span class="math-function">' + Lr(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + u.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
    }
    /**
     * Get LaTeX representation. (wrapper function)
     * This overrides parts of Node's toTex function.
     * If callback is an object containing callbacks, it
     * calls the correct callback for the current node,
     * otherwise it falls back to calling Node's toTex
     * function.
     *
     * @param {Object} options
     * @return {string}
     */
    toTex(o) {
      var u;
      return o && typeof o.handler == "object" && xe(o.handler, this.name) && (u = o.handler[this.name](this, o)), typeof u < "u" ? u : super.toTex(o);
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(o) {
      var u = this.args.map(function(p) {
        return p.toTex(o);
      }), f;
      Xc[this.name] && (f = Xc[this.name]), t[this.name] && (typeof t[this.name].toTex == "function" || typeof t[this.name].toTex == "object" || typeof t[this.name].toTex == "string") && (f = t[this.name].toTex);
      var m;
      switch (typeof f) {
        case "function":
          m = f(this, o);
          break;
        case "string":
          m = s(f, this, o);
          break;
        case "object":
          switch (typeof f[u.length]) {
            case "function":
              m = f[u.length](this, o);
              break;
            case "string":
              m = s(f[u.length], this, o);
              break;
          }
      }
      return typeof m < "u" ? m : s(B2, this, o);
    }
    /**
     * Get identifier.
     * @return {string}
     */
    getIdentifier() {
      return this.type + ":" + this.name;
    }
  }
  return e = l, or(l, "name", sa), or(l, "onUndefinedFunction", function(c) {
    throw new Error("Undefined function " + c);
  }), or(l, "fromJSON", function(c) {
    return new e(c.fn, c.args);
  }), l;
}, {
  isClass: !0,
  isNode: !0
}), Jc = "parse", eN = ["typed", "numeric", "config", "AccessorNode", "ArrayNode", "AssignmentNode", "BlockNode", "ConditionalNode", "ConstantNode", "FunctionAssignmentNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "RangeNode", "RelationalNode", "SymbolNode"], rN = /* @__PURE__ */ R(Jc, eN, (r) => {
  var {
    typed: e,
    numeric: t,
    config: n,
    AccessorNode: a,
    ArrayNode: i,
    AssignmentNode: s,
    BlockNode: l,
    ConditionalNode: c,
    ConstantNode: o,
    FunctionAssignmentNode: u,
    FunctionNode: f,
    IndexNode: m,
    ObjectNode: p,
    OperatorNode: d,
    ParenthesisNode: v,
    RangeNode: x,
    RelationalNode: h,
    SymbolNode: D
  } = r, y = e(Jc, {
    string: function(V) {
      return ee(V, {});
    },
    "Array | Matrix": function(V) {
      return w(V, {});
    },
    "string, Object": function(V, ie) {
      var de = ie.nodes !== void 0 ? ie.nodes : {};
      return ee(V, de);
    },
    "Array | Matrix, Object": w
  });
  function w(C) {
    var V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ie = V.nodes !== void 0 ? V.nodes : {};
    return Pe(C, function(de) {
      if (typeof de != "string") throw new TypeError("String expected");
      return ee(de, ie);
    });
  }
  var b = {
    NULL: 0,
    DELIMITER: 1,
    NUMBER: 2,
    SYMBOL: 3,
    UNKNOWN: 4
  }, g = {
    ",": !0,
    "(": !0,
    ")": !0,
    "[": !0,
    "]": !0,
    "{": !0,
    "}": !0,
    '"': !0,
    "'": !0,
    ";": !0,
    "+": !0,
    "-": !0,
    "*": !0,
    ".*": !0,
    "/": !0,
    "./": !0,
    "%": !0,
    "^": !0,
    ".^": !0,
    "~": !0,
    "!": !0,
    "&": !0,
    "|": !0,
    "^|": !0,
    "=": !0,
    ":": !0,
    "?": !0,
    "??": !0,
    "==": !0,
    "!=": !0,
    "<": !0,
    ">": !0,
    "<=": !0,
    ">=": !0,
    "<<": !0,
    ">>": !0,
    ">>>": !0
  }, N = {
    mod: !0,
    to: !0,
    in: !0,
    and: !0,
    xor: !0,
    or: !0,
    not: !0
  }, S = {
    true: !0,
    false: !1,
    null: null,
    undefined: void 0
  }, A = ["NaN", "Infinity"], E = {
    '"': '"',
    "'": "'",
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: `
`,
    r: "\r",
    t: "	"
    // note that \u is handled separately in parseStringToken()
  };
  function M() {
    return {
      extraNodes: {},
      // current extra nodes, must be careful not to mutate
      expression: "",
      // current expression
      comment: "",
      // last parsed comment
      index: 0,
      // current index in expr
      token: "",
      // current token
      tokenType: b.NULL,
      // type of the token
      nestingLevel: 0,
      // level of nesting inside parameters, used to ignore newline characters
      conditionalLevel: null
      // when a conditional is being parsed, the level of the conditional is stored here
    };
  }
  function T(C, V) {
    return C.expression.substr(C.index, V);
  }
  function B(C) {
    return T(C, 1);
  }
  function I(C) {
    C.index++;
  }
  function O(C) {
    return C.expression.charAt(C.index - 1);
  }
  function _(C) {
    return C.expression.charAt(C.index + 1);
  }
  function P(C) {
    for (C.tokenType = b.NULL, C.token = "", C.comment = ""; ; ) {
      if (B(C) === "#")
        for (; B(C) !== `
` && B(C) !== ""; )
          C.comment += B(C), I(C);
      if (y.isWhitespace(B(C), C.nestingLevel))
        I(C);
      else
        break;
    }
    if (B(C) === "") {
      C.tokenType = b.DELIMITER;
      return;
    }
    if (B(C) === `
` && !C.nestingLevel) {
      C.tokenType = b.DELIMITER, C.token = B(C), I(C);
      return;
    }
    var V = B(C), ie = T(C, 2), de = T(C, 3);
    if (de.length === 3 && g[de]) {
      C.tokenType = b.DELIMITER, C.token = de, I(C), I(C), I(C);
      return;
    }
    if (ie.length === 2 && g[ie]) {
      C.tokenType = b.DELIMITER, C.token = ie, I(C), I(C);
      return;
    }
    if (g[V]) {
      C.tokenType = b.DELIMITER, C.token = V, I(C);
      return;
    }
    if (y.isDigitDot(V)) {
      C.tokenType = b.NUMBER;
      var _e = T(C, 2);
      if (_e === "0b" || _e === "0o" || _e === "0x") {
        for (C.token += B(C), I(C), C.token += B(C), I(C); y.isHexDigit(B(C)); )
          C.token += B(C), I(C);
        if (B(C) === ".")
          for (C.token += ".", I(C); y.isHexDigit(B(C)); )
            C.token += B(C), I(C);
        else if (B(C) === "i")
          for (C.token += "i", I(C); y.isDigit(B(C)); )
            C.token += B(C), I(C);
        return;
      }
      if (B(C) === ".") {
        if (C.token += B(C), I(C), !y.isDigit(B(C))) {
          C.tokenType = b.DELIMITER;
          return;
        }
      } else {
        for (; y.isDigit(B(C)); )
          C.token += B(C), I(C);
        y.isDecimalMark(B(C), _(C)) && (C.token += B(C), I(C));
      }
      for (; y.isDigit(B(C)); )
        C.token += B(C), I(C);
      if (B(C) === "E" || B(C) === "e") {
        if (y.isDigit(_(C)) || _(C) === "-" || _(C) === "+") {
          if (C.token += B(C), I(C), (B(C) === "+" || B(C) === "-") && (C.token += B(C), I(C)), !y.isDigit(B(C)))
            throw Ie(C, 'Digit expected, got "' + B(C) + '"');
          for (; y.isDigit(B(C)); )
            C.token += B(C), I(C);
          if (y.isDecimalMark(B(C), _(C)))
            throw Ie(C, 'Digit expected, got "' + B(C) + '"');
        } else if (y.isDecimalMark(_(C), C.expression.charAt(C.index + 2)))
          throw I(C), Ie(C, 'Digit expected, got "' + B(C) + '"');
      }
      return;
    }
    if (y.isAlpha(B(C), O(C), _(C))) {
      for (; y.isAlpha(B(C), O(C), _(C)) || y.isDigit(B(C)); )
        C.token += B(C), I(C);
      xe(N, C.token) ? C.tokenType = b.DELIMITER : C.tokenType = b.SYMBOL;
      return;
    }
    for (C.tokenType = b.UNKNOWN; B(C) !== ""; )
      C.token += B(C), I(C);
    throw Ie(C, 'Syntax error in part "' + C.token + '"');
  }
  function W(C) {
    do
      P(C);
    while (C.token === `
`);
  }
  function L(C) {
    C.nestingLevel++;
  }
  function J(C) {
    C.nestingLevel--;
  }
  y.isAlpha = function(V, ie, de) {
    return y.isValidLatinOrGreek(V) || y.isValidMathSymbol(V, de) || y.isValidMathSymbol(ie, V);
  }, y.isValidLatinOrGreek = function(V) {
    return /^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(V);
  }, y.isValidMathSymbol = function(V, ie) {
    return /^[\uD835]$/.test(V) && /^[\uDC00-\uDFFF]$/.test(ie) && /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(ie);
  }, y.isWhitespace = function(V, ie) {
    return V === " " || V === "	" || V === " " || V === `
` && ie > 0;
  }, y.isDecimalMark = function(V, ie) {
    return V === "." && ie !== "/" && ie !== "*" && ie !== "^";
  }, y.isDigitDot = function(V) {
    return V >= "0" && V <= "9" || V === ".";
  }, y.isDigit = function(V) {
    return V >= "0" && V <= "9";
  }, y.isHexDigit = function(V) {
    return V >= "0" && V <= "9" || V >= "a" && V <= "f" || V >= "A" && V <= "F";
  };
  function ee(C, V) {
    var ie = M();
    hr(ie, {
      expression: C,
      extraNodes: V
    }), P(ie);
    var de = F(ie);
    if (ie.token !== "")
      throw ie.tokenType === b.DELIMITER ? ar(ie, "Unexpected operator " + ie.token) : Ie(ie, 'Unexpected part "' + ie.token + '"');
    return de;
  }
  function F(C) {
    var V, ie = [], de;
    for (C.token !== "" && C.token !== `
` && C.token !== ";" && (V = G(C), C.comment && (V.comment = C.comment)); C.token === `
` || C.token === ";"; )
      ie.length === 0 && V && (de = C.token !== ";", ie.push({
        node: V,
        visible: de
      })), P(C), C.token !== `
` && C.token !== ";" && C.token !== "" && (V = G(C), C.comment && (V.comment = C.comment), de = C.token !== ";", ie.push({
        node: V,
        visible: de
      }));
    return ie.length > 0 ? new l(ie) : (V || (V = new o(void 0), C.comment && (V.comment = C.comment)), V);
  }
  function G(C) {
    var V, ie, de, _e, Fe = z(C);
    if (C.token === "=") {
      if (ur(Fe))
        return V = Fe.name, W(C), de = G(C), new s(new D(V), de);
      if (wt(Fe))
        return W(C), de = G(C), new s(Fe.object, Fe.index, de);
      if (st(Fe) && ur(Fe.fn) && (_e = !0, ie = [], V = Fe.name, Fe.args.forEach(function(lr, pi) {
        ur(lr) ? ie[pi] = lr.name : _e = !1;
      }), _e))
        return W(C), de = G(C), new u(V, ie, de);
      throw Ie(C, "Invalid left hand side of assignment operator =");
    }
    return Fe;
  }
  function z(C) {
    for (var V = le(C); C.token === "?"; ) {
      var ie = C.conditionalLevel;
      C.conditionalLevel = C.nestingLevel, W(C);
      var de = V, _e = G(C);
      if (C.token !== ":") throw Ie(C, "False part of conditional expression expected");
      C.conditionalLevel = null, W(C);
      var Fe = G(C);
      V = new c(de, _e, Fe), C.conditionalLevel = ie;
    }
    return V;
  }
  function le(C) {
    for (var V = ne(C); C.token === "or"; )
      W(C), V = new d("or", "or", [V, ne(C)]);
    return V;
  }
  function ne(C) {
    for (var V = ae(C); C.token === "xor"; )
      W(C), V = new d("xor", "xor", [V, ae(C)]);
    return V;
  }
  function ae(C) {
    for (var V = q(C); C.token === "and"; )
      W(C), V = new d("and", "and", [V, q(C)]);
    return V;
  }
  function q(C) {
    for (var V = k(C); C.token === "|"; )
      W(C), V = new d("|", "bitOr", [V, k(C)]);
    return V;
  }
  function k(C) {
    for (var V = Z(C); C.token === "^|"; )
      W(C), V = new d("^|", "bitXor", [V, Z(C)]);
    return V;
  }
  function Z(C) {
    for (var V = Q(C); C.token === "&"; )
      W(C), V = new d("&", "bitAnd", [V, Q(C)]);
    return V;
  }
  function Q(C) {
    for (var V = [j(C)], ie = [], de = {
      "==": "equal",
      "!=": "unequal",
      "<": "smaller",
      ">": "larger",
      "<=": "smallerEq",
      ">=": "largerEq"
    }; xe(de, C.token); ) {
      var _e = {
        name: C.token,
        fn: de[C.token]
      };
      ie.push(_e), W(C), V.push(j(C));
    }
    return V.length === 1 ? V[0] : V.length === 2 ? new d(ie[0].name, ie[0].fn, V) : new h(ie.map((Fe) => Fe.fn), V);
  }
  function j(C) {
    var V, ie, de, _e;
    V = ce(C);
    for (var Fe = {
      "<<": "leftShift",
      ">>": "rightArithShift",
      ">>>": "rightLogShift"
    }; xe(Fe, C.token); )
      ie = C.token, de = Fe[ie], W(C), _e = [V, ce(C)], V = new d(ie, de, _e);
    return V;
  }
  function ce(C) {
    var V, ie, de, _e;
    V = oe(C);
    for (var Fe = {
      to: "to",
      in: "to"
      // alias of 'to'
    }; xe(Fe, C.token); )
      ie = C.token, de = Fe[ie], W(C), ie === "in" && "])},;".includes(C.token) ? V = new d("*", "multiply", [V, new D("in")], !0) : (_e = [V, oe(C)], V = new d(ie, de, _e));
    return V;
  }
  function oe(C) {
    var V, ie = [];
    if (C.token === ":" ? V = new o(1) : V = he(C), C.token === ":" && C.conditionalLevel !== C.nestingLevel) {
      for (ie.push(V); C.token === ":" && ie.length < 3; )
        W(C), C.token === ")" || C.token === "]" || C.token === "," || C.token === "" ? ie.push(new D("end")) : ie.push(he(C));
      ie.length === 3 ? V = new x(ie[0], ie[2], ie[1]) : V = new x(ie[0], ie[1]);
    }
    return V;
  }
  function he(C) {
    var V, ie, de, _e;
    V = we(C);
    for (var Fe = {
      "+": "add",
      "-": "subtract"
    }; xe(Fe, C.token); ) {
      ie = C.token, de = Fe[ie], W(C);
      var lr = we(C);
      lr.isPercentage ? _e = [V, new d("*", "multiply", [V, lr])] : _e = [V, lr], V = new d(ie, de, _e);
    }
    return V;
  }
  function we(C) {
    var V, ie, de, _e;
    V = De(C), ie = V;
    for (var Fe = {
      "*": "multiply",
      ".*": "dotMultiply",
      "/": "divide",
      "./": "dotDivide",
      "%": "mod",
      mod: "mod"
    }; xe(Fe, C.token); )
      if (de = C.token, _e = Fe[de], W(C), de === "%" && C.tokenType === b.DELIMITER && C.token !== "(")
        if (C.token !== "" && Fe[C.token]) {
          var lr = new d("/", "divide", [V, new o(100)], !1, !0);
          de = C.token, _e = Fe[de], W(C), ie = De(C), V = new d(de, _e, [lr, ie]);
        } else
          V = new d("/", "divide", [V, new o(100)], !1, !0);
      else
        ie = De(C), V = new d(de, _e, [V, ie]);
    return V;
  }
  function De(C) {
    var V, ie;
    for (V = ye(C), ie = V; C.tokenType === b.SYMBOL || C.token === "in" && We(V) || C.token === "in" && ir(V) && V.fn === "unaryMinus" && We(V.args[0]) || C.tokenType === b.NUMBER && !We(ie) && (!ir(ie) || ie.op === "!") || C.token === "("; )
      ie = ye(C), V = new d(
        "*",
        "multiply",
        [V, ie],
        !0
        /* implicit */
      );
    return V;
  }
  function ye(C) {
    for (var V = Ae(C), ie = V, de = []; C.token === "/" && Fi(ie); )
      if (de.push(hr({}, C)), W(C), C.tokenType === b.NUMBER)
        if (de.push(hr({}, C)), W(C), C.tokenType === b.SYMBOL || C.token === "(" || C.token === "in")
          hr(C, de.pop()), de.pop(), ie = Ae(C), V = new d("/", "divide", [V, ie]);
        else {
          de.pop(), hr(C, de.pop());
          break;
        }
      else {
        hr(C, de.pop());
        break;
      }
    return V;
  }
  function Ae(C) {
    var V, ie, de, _e = {
      "-": "unaryMinus",
      "+": "unaryPlus",
      "~": "bitNot",
      not: "not"
    };
    return xe(_e, C.token) ? (de = _e[C.token], V = C.token, W(C), ie = [Ae(C)], new d(V, de, ie)) : U(C);
  }
  function U(C) {
    var V, ie, de, _e;
    return V = X(C), (C.token === "^" || C.token === ".^") && (ie = C.token, de = ie === "^" ? "pow" : "dotPow", W(C), _e = [V, Ae(C)], V = new d(ie, de, _e)), V;
  }
  function X(C) {
    for (var V = re(C); C.token === "??"; )
      W(C), V = new d("??", "nullish", [V, re(C)]);
    return V;
  }
  function re(C) {
    var V, ie, de, _e;
    V = $(C);
    for (var Fe = {
      "!": "factorial",
      "'": "ctranspose"
    }; xe(Fe, C.token); )
      ie = C.token, de = Fe[ie], P(C), _e = [V], V = new d(ie, de, _e), V = Y(C, V);
    return V;
  }
  function $(C) {
    var V = [];
    if (C.tokenType === b.SYMBOL && xe(C.extraNodes, C.token)) {
      var ie = C.extraNodes[C.token];
      if (P(C), C.token === "(") {
        if (V = [], L(C), P(C), C.token !== ")")
          for (V.push(G(C)); C.token === ","; )
            P(C), V.push(G(C));
        if (C.token !== ")")
          throw Ie(C, "Parenthesis ) expected");
        J(C), P(C);
      }
      return new ie(V);
    }
    return H(C);
  }
  function H(C) {
    var V, ie;
    return C.tokenType === b.SYMBOL || C.tokenType === b.DELIMITER && C.token in N ? (ie = C.token, P(C), xe(S, ie) ? V = new o(S[ie]) : A.includes(ie) ? V = new o(t(ie, "number")) : V = new D(ie), V = Y(C, V), V) : K(C);
  }
  function Y(C, V, ie) {
    for (var de; C.token === "(" || C.token === "[" || C.token === "."; )
      if (de = [], C.token === "(")
        if (ur(V) || wt(V)) {
          if (L(C), P(C), C.token !== ")")
            for (de.push(G(C)); C.token === ","; )
              P(C), de.push(G(C));
          if (C.token !== ")")
            throw Ie(C, "Parenthesis ) expected");
          J(C), P(C), V = new f(V, de);
        } else
          return V;
      else if (C.token === "[") {
        if (L(C), P(C), C.token !== "]")
          for (de.push(G(C)); C.token === ","; )
            P(C), de.push(G(C));
        if (C.token !== "]")
          throw Ie(C, "Parenthesis ] expected");
        J(C), P(C), V = new a(V, new m(de));
      } else {
        P(C);
        var _e = C.tokenType === b.SYMBOL || C.tokenType === b.DELIMITER && C.token in N;
        if (!_e)
          throw Ie(C, "Property name expected after dot");
        de.push(new o(C.token)), P(C);
        var Fe = !0;
        V = new a(V, new m(de, Fe));
      }
    return V;
  }
  function K(C) {
    var V, ie;
    return C.token === '"' || C.token === "'" ? (ie = te(C, C.token), V = new o(ie), V = Y(C, V), V) : se(C);
  }
  function te(C, V) {
    for (var ie = ""; B(C) !== "" && B(C) !== V; )
      if (B(C) === "\\") {
        I(C);
        var de = B(C), _e = E[de];
        if (_e !== void 0)
          ie += _e, C.index += 1;
        else if (de === "u") {
          var Fe = C.expression.slice(C.index + 1, C.index + 5);
          if (/^[0-9A-Fa-f]{4}$/.test(Fe))
            ie += String.fromCharCode(parseInt(Fe, 16)), C.index += 5;
          else
            throw Ie(C, "Invalid unicode character \\u".concat(Fe));
        } else
          throw Ie(C, "Bad escape character \\".concat(de));
      } else
        ie += B(C), I(C);
    if (P(C), C.token !== V)
      throw Ie(C, "End of string ".concat(V, " expected"));
    return P(C), ie;
  }
  function se(C) {
    var V, ie, de, _e;
    if (C.token === "[") {
      if (L(C), P(C), C.token !== "]") {
        var Fe = fe(C);
        if (C.token === ";") {
          for (de = 1, ie = [Fe]; C.token === ";"; )
            P(C), C.token !== "]" && (ie[de] = fe(C), de++);
          if (C.token !== "]")
            throw Ie(C, "End of matrix ] expected");
          J(C), P(C), _e = ie[0].items.length;
          for (var lr = 1; lr < de; lr++)
            if (ie[lr].items.length !== _e)
              throw ar(C, "Column dimensions mismatch (" + ie[lr].items.length + " !== " + _e + ")");
          V = new i(ie);
        } else {
          if (C.token !== "]")
            throw Ie(C, "End of matrix ] expected");
          J(C), P(C), V = Fe;
        }
      } else
        J(C), P(C), V = new i([]);
      return Y(C, V);
    }
    return ve(C);
  }
  function fe(C) {
    for (var V = [G(C)], ie = 1; C.token === ","; )
      P(C), C.token !== "]" && C.token !== ";" && (V[ie] = G(C), ie++);
    return new i(V);
  }
  function ve(C) {
    if (C.token === "{") {
      L(C);
      var V, ie = {};
      do
        if (P(C), C.token !== "}") {
          if (C.token === '"' || C.token === "'")
            V = te(C, C.token);
          else if (C.tokenType === b.SYMBOL || C.tokenType === b.DELIMITER && C.token in N)
            V = C.token, P(C);
          else
            throw Ie(C, "Symbol or string expected as object key");
          if (C.token !== ":")
            throw Ie(C, "Colon : expected after object key");
          P(C), ie[V] = G(C);
        }
      while (C.token === ",");
      if (C.token !== "}")
        throw Ie(C, "Comma , or bracket } expected after object value");
      J(C), P(C);
      var de = new p(ie);
      return de = Y(C, de), de;
    }
    return ge(C);
  }
  function ge(C) {
    var V;
    if (C.tokenType === b.NUMBER) {
      V = C.token, P(C);
      var ie = St(V, n), de = t(V, ie);
      return new o(de);
    }
    return me(C);
  }
  function me(C) {
    var V;
    if (C.token === "(") {
      if (L(C), P(C), V = G(C), C.token !== ")")
        throw Ie(C, "Parenthesis ) expected");
      return J(C), P(C), V = new v(V), V = Y(C, V), V;
    }
    return Me(C);
  }
  function Me(C) {
    throw C.token === "" ? Ie(C, "Unexpected end of expression") : Ie(C, "Value expected");
  }
  function Le(C) {
    return C.index - C.token.length + 1;
  }
  function Ie(C, V) {
    var ie = Le(C), de = new SyntaxError(V + " (char " + ie + ")");
    return de.char = ie, de;
  }
  function ar(C, V) {
    var ie = Le(C), de = new SyntaxError(V + " (char " + ie + ")");
    return de.char = ie, de;
  }
  return e.addConversion({
    from: "string",
    to: "Node",
    convert: y
  }), y;
}), Qc = "compile", tN = ["typed", "parse"], nN = /* @__PURE__ */ R(Qc, tN, (r) => {
  var {
    typed: e,
    parse: t
  } = r;
  return e(Qc, {
    string: function(a) {
      return t(a).compile();
    },
    "Array | Matrix": function(a) {
      return Pe(a, function(i) {
        return t(i).compile();
      });
    }
  });
}), jc = "evaluate", aN = ["typed", "parse"], iN = /* @__PURE__ */ R(jc, aN, (r) => {
  var {
    typed: e,
    parse: t
  } = r;
  return e(jc, {
    string: function(a) {
      var i = Cn();
      return t(a).compile().evaluate(i);
    },
    "string, Map | Object": function(a, i) {
      return t(a).compile().evaluate(i);
    },
    "Array | Matrix": function(a) {
      var i = Cn();
      return Pe(a, function(s) {
        return t(s).compile().evaluate(i);
      });
    },
    "Array | Matrix, Map | Object": function(a, i) {
      return Pe(a, function(s) {
        return t(s).compile().evaluate(i);
      });
    }
  });
}), oN = "Parser", sN = ["evaluate", "parse"], uN = /* @__PURE__ */ R(oN, sN, (r) => {
  var {
    evaluate: e,
    parse: t
  } = r;
  function n() {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    Object.defineProperty(this, "scope", {
      value: Cn(),
      writable: !1
    });
  }
  n.prototype.type = "Parser", n.prototype.isParser = !0, n.prototype.evaluate = function(i) {
    return e(i, this.scope);
  }, n.prototype.get = function(i) {
    if (this.scope.has(i))
      return this.scope.get(i);
  }, n.prototype.getAll = function() {
    return bv(this.scope);
  }, n.prototype.getAllAsMap = function() {
    return this.scope;
  };
  function a(i) {
    if (i.length === 0)
      return !1;
    for (var s = 0; s < i.length; s++) {
      var l = i.charAt(s - 1), c = i.charAt(s), o = i.charAt(s + 1), u = t.isAlpha(c, l, o) || s > 0 && t.isDigit(c);
      if (!u)
        return !1;
    }
    return !0;
  }
  return n.prototype.set = function(i, s) {
    if (!a(i))
      throw new Error("Invalid variable name: '".concat(i, "'. Variable names must follow the specified rules."));
    return this.scope.set(i, s), s;
  }, n.prototype.remove = function(i) {
    this.scope.delete(i);
  }, n.prototype.clear = function() {
    this.scope.clear();
  }, n.prototype.toJSON = function() {
    var i = {
      mathjs: "Parser",
      variables: {},
      functions: {}
    };
    for (var [s, l] of this.scope)
      if (ao(l)) {
        if (!cN(l))
          throw new Error("Cannot serialize external function ".concat(s));
        i.functions[s] = "".concat(l.syntax, " = ").concat(l.expr);
      } else
        i.variables[s] = l;
    return i;
  }, n.fromJSON = function(i) {
    var s = new n();
    return Object.entries(i.variables).forEach((l) => {
      var [c, o] = l;
      return s.set(c, o);
    }), Object.entries(i.functions).forEach((l) => {
      var [c, o] = l;
      return s.evaluate(o);
    }), s;
  }, n;
}, {
  isClass: !0
});
function cN(r) {
  return typeof r == "function" && typeof r.syntax == "string" && typeof r.expr == "string";
}
var Kc = "parser", lN = ["typed", "Parser"], fN = /* @__PURE__ */ R(Kc, lN, (r) => {
  var {
    typed: e,
    Parser: t
  } = r;
  return e(Kc, {
    "": function() {
      return new t();
    }
  });
}), el = "lup", mN = ["typed", "matrix", "abs", "addScalar", "divideScalar", "multiplyScalar", "subtractScalar", "larger", "equalScalar", "unaryMinus", "DenseMatrix", "SparseMatrix", "Spa"], pN = /* @__PURE__ */ R(el, mN, (r) => {
  var {
    typed: e,
    matrix: t,
    abs: n,
    addScalar: a,
    divideScalar: i,
    multiplyScalar: s,
    subtractScalar: l,
    larger: c,
    equalScalar: o,
    unaryMinus: u,
    DenseMatrix: f,
    SparseMatrix: m,
    Spa: p
  } = r;
  return e(el, {
    DenseMatrix: function(h) {
      return d(h);
    },
    SparseMatrix: function(h) {
      return v(h);
    },
    Array: function(h) {
      var D = t(h), y = d(D);
      return {
        L: y.L.valueOf(),
        U: y.U.valueOf(),
        p: y.p
      };
    }
  });
  function d(x) {
    var h = x._size[0], D = x._size[1], y = Math.min(h, D), w = Te(x._data), b = [], g = [h, y], N = [], S = [y, D], A, E, M, T = [];
    for (A = 0; A < h; A++)
      T[A] = A;
    for (E = 0; E < D; E++) {
      if (E > 0)
        for (A = 0; A < h; A++) {
          var B = Math.min(A, E), I = 0;
          for (M = 0; M < B; M++)
            I = a(I, s(w[A][M], w[M][E]));
          w[A][E] = l(w[A][E], I);
        }
      var O = E, _ = 0, P = 0;
      for (A = E; A < h; A++) {
        var W = w[A][E], L = n(W);
        c(L, _) && (O = A, _ = L, P = W);
      }
      if (E !== O && (T[E] = [T[O], T[O] = T[E]][0], f._swapRows(E, O, w)), E < h)
        for (A = E + 1; A < h; A++) {
          var J = w[A][E];
          o(J, 0) || (w[A][E] = i(w[A][E], P));
        }
    }
    for (E = 0; E < D; E++)
      for (A = 0; A < h; A++) {
        if (E === 0 && (A < D && (N[A] = []), b[A] = []), A < E) {
          A < D && (N[A][E] = w[A][E]), E < h && (b[A][E] = 0);
          continue;
        }
        if (A === E) {
          A < D && (N[A][E] = w[A][E]), E < h && (b[A][E] = 1);
          continue;
        }
        A < D && (N[A][E] = 0), E < h && (b[A][E] = w[A][E]);
      }
    var ee = new f({
      data: b,
      size: g
    }), F = new f({
      data: N,
      size: S
    }), G = [];
    for (A = 0, y = T.length; A < y; A++)
      G[T[A]] = A;
    return {
      L: ee,
      U: F,
      p: G,
      toString: function() {
        return "L: " + this.L.toString() + `
U: ` + this.U.toString() + `
P: ` + this.p;
      }
    };
  }
  function v(x) {
    var h = x._size[0], D = x._size[1], y = Math.min(h, D), w = x._values, b = x._index, g = x._ptr, N = [], S = [], A = [], E = [h, y], M = [], T = [], B = [], I = [y, D], O, _, P, W = [], L = [];
    for (O = 0; O < h; O++)
      W[O] = O, L[O] = O;
    var J = function(G, z) {
      var le = L[G], ne = L[z];
      W[le] = z, W[ne] = G, L[G] = ne, L[z] = le;
    }, ee = function() {
      var G = new p();
      _ < h && (A.push(N.length), N.push(1), S.push(_)), B.push(M.length);
      var z = g[_], le = g[_ + 1];
      for (P = z; P < le; P++)
        O = b[P], G.set(W[O], w[P]);
      _ > 0 && G.forEach(0, _ - 1, function(k, Z) {
        m._forEachRow(k, N, S, A, function(Q, j) {
          Q > k && G.accumulate(Q, u(s(j, Z)));
        });
      });
      var ne = _, ae = G.get(_), q = n(ae);
      G.forEach(_ + 1, h - 1, function(k, Z) {
        var Q = n(Z);
        c(Q, q) && (ne = k, q = Q, ae = Z);
      }), _ !== ne && (m._swapRows(_, ne, E[1], N, S, A), m._swapRows(_, ne, I[1], M, T, B), G.swap(_, ne), J(_, ne)), G.forEach(0, h - 1, function(k, Z) {
        k <= _ ? (M.push(Z), T.push(k)) : (Z = i(Z, ae), o(Z, 0) || (N.push(Z), S.push(k)));
      });
    };
    for (_ = 0; _ < D; _++)
      ee();
    return B.push(M.length), A.push(N.length), {
      L: new m({
        values: N,
        index: S,
        ptr: A,
        size: E
      }),
      U: new m({
        values: M,
        index: T,
        ptr: B,
        size: I
      }),
      p: W,
      toString: function() {
        return "L: " + this.L.toString() + `
U: ` + this.U.toString() + `
P: ` + this.p;
      }
    };
  }
}), rl = "qr", dN = ["typed", "matrix", "zeros", "identity", "isZero", "equal", "sign", "sqrt", "conj", "unaryMinus", "addScalar", "divideScalar", "multiplyScalar", "subtractScalar", "complex"], vN = /* @__PURE__ */ R(rl, dN, (r) => {
  var {
    typed: e,
    matrix: t,
    zeros: n,
    identity: a,
    isZero: i,
    equal: s,
    sign: l,
    sqrt: c,
    conj: o,
    unaryMinus: u,
    addScalar: f,
    divideScalar: m,
    multiplyScalar: p,
    subtractScalar: d,
    complex: v
  } = r;
  return hr(e(rl, {
    DenseMatrix: function(w) {
      return h(w);
    },
    SparseMatrix: function(w) {
      return D();
    },
    Array: function(w) {
      var b = t(w), g = h(b);
      return {
        Q: g.Q.valueOf(),
        R: g.R.valueOf()
      };
    }
  }), {
    _denseQRimpl: x
  });
  function x(y) {
    var w = y._size[0], b = y._size[1], g = a([w], "dense"), N = g._data, S = y.clone(), A = S._data, E, M, T, B = n([w], "");
    for (T = 0; T < Math.min(b, w); ++T) {
      var I = A[T][T], O = u(s(I, 0) ? 1 : l(I)), _ = o(O), P = 0;
      for (E = T; E < w; E++)
        P = f(P, p(A[E][T], o(A[E][T])));
      var W = p(O, c(P));
      if (!i(W)) {
        var L = d(I, W);
        for (B[T] = 1, E = T + 1; E < w; E++)
          B[E] = m(A[E][T], L);
        var J = u(o(m(L, W))), ee = void 0;
        for (M = T; M < b; M++) {
          for (ee = 0, E = T; E < w; E++)
            ee = f(ee, p(o(B[E]), A[E][M]));
          for (ee = p(ee, J), E = T; E < w; E++)
            A[E][M] = p(d(A[E][M], p(B[E], ee)), _);
        }
        for (E = 0; E < w; E++) {
          for (ee = 0, M = T; M < w; M++)
            ee = f(ee, p(N[E][M], B[M]));
          for (ee = p(ee, J), M = T; M < w; ++M)
            N[E][M] = m(d(N[E][M], p(ee, o(B[M]))), _);
        }
      }
    }
    return {
      Q: g,
      R: S,
      toString: function() {
        return "Q: " + this.Q.toString() + `
R: ` + this.R.toString();
      }
    };
  }
  function h(y) {
    var w = x(y), b = w.R._data;
    if (y._data.length > 0)
      for (var g = b[0][0].type === "Complex" ? v(0) : 0, N = 0; N < b.length; ++N)
        for (var S = 0; S < N && S < (b[0] || []).length; ++S)
          b[N][S] = g;
    return w;
  }
  function D(y) {
    throw new Error("qr not implemented for sparse matrices yet");
  }
});
function hN(r, e, t, n) {
  r._values;
  for (var a = r._index, i = r._ptr, s = r._size, l = r._datatype, c = s[0], o = s[1], u = null, f = [], m = [], p = 0, d = 0; d < o; d++) {
    m[d] = p;
    for (var v = t ? t[d] : d, x = i[v], h = i[v + 1], D = x; D < h; D++) {
      var y = a[D];
      f[p] = y, p++;
    }
  }
  return m[o] = p, r.createSparseMatrix({
    values: u,
    index: f,
    ptr: m,
    size: [c, o],
    datatype: l
  });
}
function md(r, e, t, n, a, i, s) {
  var l = 0;
  for (t[s] = r; l >= 0; ) {
    var c = t[s + l], o = t[n + c];
    o === -1 ? (l--, i[e++] = c) : (t[n + c] = t[a + o], ++l, t[s + l] = o);
  }
  return e;
}
function gN(r, e) {
  if (!r)
    return null;
  var t = 0, n, a = [], i = [], s = 0, l = e, c = 2 * e;
  for (n = 0; n < e; n++)
    i[s + n] = -1;
  for (n = e - 1; n >= 0; n--)
    r[n] !== -1 && (i[l + n] = i[s + r[n]], i[s + r[n]] = n);
  for (n = 0; n < e; n++)
    r[n] === -1 && (t = md(n, t, i, s, l, a, c));
  return a;
}
function yN(r, e) {
  if (!r)
    return null;
  var t = r._index, n = r._ptr, a = r._size, i = a[0], s = a[1], l = [], c = [], o = 0, u = s, f, m;
  for (f = 0; f < i; f++)
    c[u + f] = -1;
  for (var p = 0; p < s; p++) {
    l[p] = -1, c[o + p] = -1;
    for (var d = n[p], v = n[p + 1], x = d; x < v; x++) {
      var h = t[x];
      for (f = c[u + h]; f !== -1 && f < p; f = m)
        m = c[o + f], c[o + f] = p, m === -1 && (l[f] = p);
      c[u + h] = p;
    }
  }
  return l;
}
function bN(r, e, t) {
  for (var n = r._values, a = r._index, i = r._ptr, s = r._size, l = s[1], c = 0, o = 0; o < l; o++) {
    var u = i[o];
    for (i[o] = c; u < i[o + 1]; u++)
      e(a[u], o, n ? n[u] : 1, t) && (a[c] = a[u], n && (n[c] = n[u]), c++);
  }
  return i[l] = c, a.splice(c, a.length - c), n && n.splice(c, n.length - c), c;
}
function vt(r) {
  return -r - 2;
}
var xN = "csAmd", wN = ["add", "multiply", "transpose"], DN = /* @__PURE__ */ R(xN, wN, (r) => {
  var {
    add: e,
    multiply: t,
    transpose: n
  } = r;
  return function(u, f) {
    if (!f || u <= 0 || u > 3)
      return null;
    var m = f._size, p = m[0], d = m[1], v = 0, x = Math.max(16, 10 * Math.sqrt(d));
    x = Math.min(d - 2, x);
    var h = a(u, f, p, d, x);
    bN(h, c, null);
    for (var D = h._index, y = h._ptr, w = y[d], b = [], g = [], N = 0, S = d + 1, A = 2 * (d + 1), E = 3 * (d + 1), M = 4 * (d + 1), T = 5 * (d + 1), B = 6 * (d + 1), I = 7 * (d + 1), O = b, _ = i(d, y, g, N, E, O, A, I, S, B, M, T), P = s(d, y, g, T, M, B, x, S, E, O, A), W = 0, L, J, ee, F, G, z, le, ne, ae, q, k, Z, Q, j, ce, oe; P < d; ) {
      for (ee = -1; W < d && (ee = g[E + W]) === -1; W++) ;
      g[A + ee] !== -1 && (O[g[A + ee]] = -1), g[E + W] = g[A + ee];
      var he = g[M + ee], we = g[S + ee];
      P += we;
      var De = 0;
      g[S + ee] = -we;
      var ye = y[ee], Ae = he === 0 ? ye : w, U = Ae;
      for (F = 1; F <= he + 1; F++) {
        for (F > he ? (z = ee, le = ye, ne = g[N + ee] - he) : (z = D[ye++], le = y[z], ne = g[N + z]), G = 1; G <= ne; G++)
          L = D[le++], !((ae = g[S + L]) <= 0) && (De += ae, g[S + L] = -ae, D[U++] = L, g[A + L] !== -1 && (O[g[A + L]] = O[L]), O[L] !== -1 ? g[A + O[L]] = g[A + L] : g[E + g[T + L]] = g[A + L]);
        z !== ee && (y[z] = vt(ee), g[B + z] = 0);
      }
      for (he !== 0 && (w = U), g[T + ee] = De, y[ee] = Ae, g[N + ee] = U - Ae, g[M + ee] = -2, _ = l(_, v, g, B, d), q = Ae; q < U; q++)
        if (L = D[q], !((k = g[M + L]) <= 0)) {
          ae = -g[S + L];
          var X = _ - ae;
          for (ye = y[L], Z = y[L] + k - 1; ye <= Z; ye++)
            z = D[ye], g[B + z] >= _ ? g[B + z] -= ae : g[B + z] !== 0 && (g[B + z] = g[T + z] + X);
        }
      for (q = Ae; q < U; q++) {
        for (L = D[q], Z = y[L], Q = Z + g[M + L] - 1, j = Z, ce = 0, oe = 0, ye = Z; ye <= Q; ye++)
          if (z = D[ye], g[B + z] !== 0) {
            var re = g[B + z] - _;
            re > 0 ? (oe += re, D[j++] = z, ce += z) : (y[z] = vt(ee), g[B + z] = 0);
          }
        g[M + L] = j - Z + 1;
        var $ = j, H = Z + g[N + L];
        for (ye = Q + 1; ye < H; ye++) {
          J = D[ye];
          var Y = g[S + J];
          Y <= 0 || (oe += Y, D[j++] = J, ce += J);
        }
        oe === 0 ? (y[L] = vt(ee), ae = -g[S + L], De -= ae, we += ae, P += ae, g[S + L] = 0, g[M + L] = -1) : (g[T + L] = Math.min(g[T + L], oe), D[j] = D[$], D[$] = D[Z], D[Z] = ee, g[N + L] = j - Z + 1, ce = (ce < 0 ? -ce : ce) % d, g[A + L] = g[I + ce], g[I + ce] = L, O[L] = ce);
      }
      for (g[T + ee] = De, v = Math.max(v, De), _ = l(_ + v, v, g, B, d), q = Ae; q < U; q++)
        if (L = D[q], !(g[S + L] >= 0))
          for (ce = O[L], L = g[I + ce], g[I + ce] = -1; L !== -1 && g[A + L] !== -1; L = g[A + L], _++) {
            for (ne = g[N + L], k = g[M + L], ye = y[L] + 1; ye <= y[L] + ne - 1; ye++)
              g[B + D[ye]] = _;
            var K = L;
            for (J = g[A + L]; J !== -1; ) {
              var te = g[N + J] === ne && g[M + J] === k;
              for (ye = y[J] + 1; te && ye <= y[J] + ne - 1; ye++)
                g[B + D[ye]] !== _ && (te = 0);
              te ? (y[J] = vt(L), g[S + L] += g[S + J], g[S + J] = 0, g[M + J] = -1, J = g[A + J], g[A + K] = J) : (K = J, J = g[A + J]);
            }
          }
      for (ye = Ae, q = Ae; q < U; q++)
        L = D[q], !((ae = -g[S + L]) <= 0) && (g[S + L] = ae, oe = g[T + L] + De - ae, oe = Math.min(oe, d - P - ae), g[E + oe] !== -1 && (O[g[E + oe]] = L), g[A + L] = g[E + oe], O[L] = -1, g[E + oe] = L, W = Math.min(W, oe), g[T + L] = oe, D[ye++] = L);
      g[S + ee] = we, (g[N + ee] = ye - Ae) === 0 && (y[ee] = -1, g[B + ee] = 0), he !== 0 && (w = ye);
    }
    for (L = 0; L < d; L++)
      y[L] = vt(y[L]);
    for (J = 0; J <= d; J++)
      g[E + J] = -1;
    for (J = d; J >= 0; J--)
      g[S + J] > 0 || (g[A + J] = g[E + y[J]], g[E + y[J]] = J);
    for (z = d; z >= 0; z--)
      g[S + z] <= 0 || y[z] !== -1 && (g[A + z] = g[E + y[z]], g[E + y[z]] = z);
    for (ee = 0, L = 0; L <= d; L++)
      y[L] === -1 && (ee = md(L, ee, g, E, A, b, B));
    return b.splice(b.length - 1, 1), b;
  };
  function a(o, u, f, m, p) {
    var d = n(u);
    if (o === 1 && m === f)
      return e(u, d);
    if (o === 2) {
      for (var v = d._index, x = d._ptr, h = 0, D = 0; D < f; D++) {
        var y = x[D];
        if (x[D] = h, !(x[D + 1] - y > p))
          for (var w = x[D + 1]; y < w; y++)
            v[h++] = v[y];
      }
      return x[f] = h, u = n(d), t(d, u);
    }
    return t(d, u);
  }
  function i(o, u, f, m, p, d, v, x, h, D, y, w) {
    for (var b = 0; b < o; b++)
      f[m + b] = u[b + 1] - u[b];
    f[m + o] = 0;
    for (var g = 0; g <= o; g++)
      f[p + g] = -1, d[g] = -1, f[v + g] = -1, f[x + g] = -1, f[h + g] = 1, f[D + g] = 1, f[y + g] = 0, f[w + g] = f[m + g];
    var N = l(0, 0, f, D, o);
    return f[y + o] = -2, u[o] = -1, f[D + o] = 0, N;
  }
  function s(o, u, f, m, p, d, v, x, h, D, y) {
    for (var w = 0, b = 0; b < o; b++) {
      var g = f[m + b];
      if (g === 0)
        f[p + b] = -2, w++, u[b] = -1, f[d + b] = 0;
      else if (g > v)
        f[x + b] = 0, f[p + b] = -1, w++, u[b] = vt(o), f[x + o]++;
      else {
        var N = f[h + g];
        N !== -1 && (D[N] = b), f[y + b] = f[h + g], f[h + g] = b;
      }
    }
    return w;
  }
  function l(o, u, f, m, p) {
    if (o < 2 || o + u < 0) {
      for (var d = 0; d < p; d++)
        f[m + d] !== 0 && (f[m + d] = 1);
      o = 2;
    }
    return o;
  }
  function c(o, u) {
    return o !== u;
  }
});
function NN(r, e, t, n, a, i, s) {
  var l, c, o = 0, u;
  if (r <= e || t[n + e] <= t[a + r])
    return -1;
  t[a + r] = t[n + e];
  var f = t[i + r];
  if (t[i + r] = e, f === -1)
    o = 1, u = r;
  else {
    for (o = 2, u = f; u !== t[s + u]; u = t[s + u]) ;
    for (l = f; l !== u; l = c)
      c = t[s + l], t[s + l] = u;
  }
  return {
    jleaf: o,
    q: u
  };
}
var AN = "csCounts", SN = ["transpose"], EN = /* @__PURE__ */ R(AN, SN, (r) => {
  var {
    transpose: e
  } = r;
  return function(t, n, a, i) {
    if (!t || !n || !a)
      return null;
    var s = t._size, l = s[0], c = s[1], o, u, f, m, p, d, v, x = 4 * c + (i ? c + l + 1 : 0), h = [], D = 0, y = c, w = 2 * c, b = 3 * c, g = 4 * c, N = 5 * c + 1;
    for (f = 0; f < x; f++)
      h[f] = -1;
    var S = [], A = e(t), E = A._index, M = A._ptr;
    for (f = 0; f < c; f++)
      for (u = a[f], S[u] = h[b + u] === -1 ? 1 : 0; u !== -1 && h[b + u] === -1; u = n[u])
        h[b + u] = f;
    if (i) {
      for (f = 0; f < c; f++)
        h[a[f]] = f;
      for (o = 0; o < l; o++) {
        for (f = c, d = M[o], v = M[o + 1], p = d; p < v; p++)
          f = Math.min(f, h[E[p]]);
        h[N + o] = h[g + f], h[g + f] = o;
      }
    }
    for (o = 0; o < c; o++)
      h[D + o] = o;
    for (f = 0; f < c; f++) {
      for (u = a[f], n[u] !== -1 && S[n[u]]--, m = i ? h[g + f] : u; m !== -1; m = i ? h[N + m] : -1)
        for (p = M[m]; p < M[m + 1]; p++) {
          o = E[p];
          var T = NN(o, u, h, b, y, w, D);
          T.jleaf >= 1 && S[u]++, T.jleaf === 2 && S[T.q]--;
        }
      n[u] !== -1 && (h[D + u] = n[u]);
    }
    for (u = 0; u < c; u++)
      n[u] !== -1 && (S[n[u]] += S[u]);
    return S;
  };
}), MN = "csSqr", CN = ["add", "multiply", "transpose"], _N = /* @__PURE__ */ R(MN, CN, (r) => {
  var {
    add: e,
    multiply: t,
    transpose: n
  } = r, a = DN({
    add: e,
    multiply: t,
    transpose: n
  }), i = EN({
    transpose: n
  });
  return function(c, o, u) {
    var f = o._ptr, m = o._size, p = m[1], d, v = {};
    if (v.q = a(c, o), c && !v.q)
      return null;
    if (u) {
      var x = c ? hN(o, null, v.q) : o;
      v.parent = yN(x);
      var h = gN(v.parent, p);
      if (v.cp = i(x, v.parent, h, 1), x && v.parent && v.cp && s(x, v))
        for (v.unz = 0, d = 0; d < p; d++)
          v.unz += v.cp[d];
    } else
      v.unz = 4 * f[p] + p, v.lnz = v.unz;
    return v;
  };
  function s(l, c) {
    var o = l._ptr, u = l._index, f = l._size, m = f[0], p = f[1];
    c.pinv = [], c.leftmost = [];
    var d = c.parent, v = c.pinv, x = c.leftmost, h = [], D = 0, y = m, w = m + p, b = m + 2 * p, g, N, S, A, E;
    for (N = 0; N < p; N++)
      h[y + N] = -1, h[w + N] = -1, h[b + N] = 0;
    for (g = 0; g < m; g++)
      x[g] = -1;
    for (N = p - 1; N >= 0; N--)
      for (A = o[N], E = o[N + 1], S = A; S < E; S++)
        x[u[S]] = N;
    for (g = m - 1; g >= 0; g--)
      v[g] = -1, N = x[g], N !== -1 && (h[b + N]++ === 0 && (h[w + N] = g), h[D + g] = h[y + N], h[y + N] = g);
    for (c.lnz = 0, c.m2 = m, N = 0; N < p; N++)
      if (g = h[y + N], c.lnz++, g < 0 && (g = c.m2++), v[g] = N, !(--b[N] <= 0)) {
        c.lnz += h[b + N];
        var M = d[N];
        M !== -1 && (h[b + M] === 0 && (h[w + M] = h[w + N]), h[D + h[w + N]] = h[y + M], h[y + M] = h[D + g], h[b + M] += h[b + N]);
      }
    for (g = 0; g < m; g++)
      v[g] < 0 && (v[g] = N++);
    return !0;
  }
});
function Ki(r, e) {
  return r[e] < 0;
}
function pd(r, e) {
  r[e] = vt(r[e]);
}
function tl(r) {
  return r < 0 ? vt(r) : r;
}
function TN(r, e, t, n, a) {
  var i = e._index, s = e._ptr, l = e._size, c = l[1], o, u, f, m = 0;
  for (n[0] = r; m >= 0; ) {
    r = n[m];
    var p = a ? a[r] : r;
    Ki(s, r) || (pd(s, r), n[c + m] = p < 0 ? 0 : tl(s[p]));
    var d = 1;
    for (u = n[c + m], f = p < 0 ? 0 : tl(s[p + 1]); u < f; u++)
      if (o = i[u], !Ki(s, o)) {
        n[c + m] = u, n[++m] = o, d = 0;
        break;
      }
    d && (m--, n[--t] = r);
  }
  return t;
}
function FN(r, e, t, n, a) {
  var i = r._ptr, s = r._size, l = e._index, c = e._ptr, o = s[1], u, f, m, p = o;
  for (f = c[t], m = c[t + 1], u = f; u < m; u++) {
    var d = l[u];
    Ki(i, d) || (p = TN(d, r, p, n, a));
  }
  for (u = p; u < o; u++)
    pd(i, n[u]);
  return p;
}
var BN = "csSpsolve", ON = ["divideScalar", "multiply", "subtract"], IN = /* @__PURE__ */ R(BN, ON, (r) => {
  var {
    divideScalar: e,
    multiply: t,
    subtract: n
  } = r;
  return function(i, s, l, c, o, u, f) {
    var m = i._values, p = i._index, d = i._ptr, v = i._size, x = v[1], h = s._values, D = s._index, y = s._ptr, w, b, g, N, S = FN(i, s, l, c, u);
    for (w = S; w < x; w++)
      o[c[w]] = 0;
    for (b = y[l], g = y[l + 1], w = b; w < g; w++)
      o[D[w]] = h[w];
    for (var A = S; A < x; A++) {
      var E = c[A], M = u ? u[E] : E;
      if (!(M < 0))
        for (b = d[M], g = d[M + 1], o[E] = e(o[E], m[f ? b : g - 1]), w = f ? b + 1 : b, N = f ? g : g - 1; w < N; w++) {
          var T = p[w];
          o[T] = n(o[T], t(m[w], o[E]));
        }
    }
    return S;
  };
}), $N = "csLu", zN = ["abs", "divideScalar", "multiply", "subtract", "larger", "largerEq", "SparseMatrix"], RN = /* @__PURE__ */ R($N, zN, (r) => {
  var {
    abs: e,
    divideScalar: t,
    multiply: n,
    subtract: a,
    larger: i,
    largerEq: s,
    SparseMatrix: l
  } = r, c = IN({
    divideScalar: t,
    multiply: n,
    subtract: a
  });
  return function(u, f, m) {
    if (!u)
      return null;
    var p = u._size, d = p[1], v, x = 100, h = 100;
    f && (v = f.q, x = f.lnz || x, h = f.unz || h);
    var D = [], y = [], w = [], b = new l({
      values: D,
      index: y,
      ptr: w,
      size: [d, d]
    }), g = [], N = [], S = [], A = new l({
      values: g,
      index: N,
      ptr: S,
      size: [d, d]
    }), E = [], M, T, B = [], I = [];
    for (M = 0; M < d; M++)
      B[M] = 0, E[M] = -1, w[M + 1] = 0;
    x = 0, h = 0;
    for (var O = 0; O < d; O++) {
      w[O] = x, S[O] = h;
      var _ = v ? v[O] : O, P = c(b, u, _, I, B, E, 1), W = -1, L = -1;
      for (T = P; T < d; T++)
        if (M = I[T], E[M] < 0) {
          var J = e(B[M]);
          i(J, L) && (L = J, W = M);
        } else
          N[h] = E[M], g[h++] = B[M];
      if (W === -1 || L <= 0)
        return null;
      E[_] < 0 && s(e(B[_]), n(L, m)) && (W = _);
      var ee = B[W];
      for (N[h] = O, g[h++] = ee, E[W] = O, y[x] = W, D[x++] = 1, T = P; T < d; T++)
        M = I[T], E[M] < 0 && (y[x] = M, D[x++] = t(B[M], ee)), B[M] = 0;
    }
    for (w[d] = x, S[d] = h, T = 0; T < x; T++)
      y[T] = E[y[T]];
    return D.splice(x, D.length - x), y.splice(x, y.length - x), g.splice(h, g.length - h), N.splice(h, N.length - h), {
      L: b,
      U: A,
      pinv: E
    };
  };
}), nl = "slu", qN = ["typed", "abs", "add", "multiply", "transpose", "divideScalar", "subtract", "larger", "largerEq", "SparseMatrix"], PN = /* @__PURE__ */ R(nl, qN, (r) => {
  var {
    typed: e,
    abs: t,
    add: n,
    multiply: a,
    transpose: i,
    divideScalar: s,
    subtract: l,
    larger: c,
    largerEq: o,
    SparseMatrix: u
  } = r, f = _N({
    add: n,
    multiply: a,
    transpose: i
  }), m = RN({
    abs: t,
    divideScalar: s,
    multiply: a,
    subtract: l,
    larger: c,
    largerEq: o,
    SparseMatrix: u
  });
  return e(nl, {
    "SparseMatrix, number, number": function(d, v, x) {
      if (!Ne(v) || v < 0 || v > 3)
        throw new Error("Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]");
      if (x < 0 || x > 1)
        throw new Error("Partial pivoting threshold must be a number from 0 to 1");
      var h = f(v, d, !1), D = m(d, h, x);
      return {
        L: D.L,
        U: D.U,
        p: D.pinv,
        q: h.q,
        toString: function() {
          return "L: " + this.L.toString() + `
U: ` + this.U.toString() + `
p: ` + this.p.toString() + (this.q ? `
q: ` + this.q.toString() : "") + `
`;
        }
      };
    }
  });
});
function al(r, e) {
  var t, n = e.length, a = [];
  if (r)
    for (t = 0; t < n; t++)
      a[r[t]] = e[t];
  else
    for (t = 0; t < n; t++)
      a[t] = e[t];
  return a;
}
var il = "lusolve", UN = ["typed", "matrix", "lup", "slu", "usolve", "lsolve", "DenseMatrix"], LN = /* @__PURE__ */ R(il, UN, (r) => {
  var {
    typed: e,
    matrix: t,
    lup: n,
    slu: a,
    usolve: i,
    lsolve: s,
    DenseMatrix: l
  } = r, c = qn({
    DenseMatrix: l
  });
  return e(il, {
    "Array, Array | Matrix": function(m, p) {
      m = t(m);
      var d = n(m), v = u(d.L, d.U, d.p, null, p);
      return v.valueOf();
    },
    "DenseMatrix, Array | Matrix": function(m, p) {
      var d = n(m);
      return u(d.L, d.U, d.p, null, p);
    },
    "SparseMatrix, Array | Matrix": function(m, p) {
      var d = n(m);
      return u(d.L, d.U, d.p, null, p);
    },
    "SparseMatrix, Array | Matrix, number, number": function(m, p, d, v) {
      var x = a(m, d, v);
      return u(x.L, x.U, x.p, x.q, p);
    },
    "Object, Array | Matrix": function(m, p) {
      return u(m.L, m.U, m.p, m.q, p);
    }
  });
  function o(f) {
    if (Ee(f))
      return f;
    if (Ye(f))
      return t(f);
    throw new TypeError("Invalid Matrix LU decomposition");
  }
  function u(f, m, p, d, v) {
    f = o(f), m = o(m), p && (v = c(f, v, !0), v._data = al(p, v._data));
    var x = s(f, v), h = i(m, x);
    return d && (h._data = al(d, h._data)), h;
  }
}), ol = "polynomialRoot", kN = ["typed", "isZero", "equalScalar", "add", "subtract", "multiply", "divide", "sqrt", "unaryMinus", "cbrt", "typeOf", "im", "re"], HN = /* @__PURE__ */ R(ol, kN, (r) => {
  var {
    typed: e,
    isZero: t,
    equalScalar: n,
    add: a,
    subtract: i,
    multiply: s,
    divide: l,
    sqrt: c,
    unaryMinus: o,
    cbrt: u,
    typeOf: f,
    im: m,
    re: p
  } = r;
  return e(ol, {
    "number|Complex, ...number|Complex": (d, v) => {
      for (var x = [d, ...v]; x.length > 0 && t(x[x.length - 1]); )
        x.pop();
      if (x.length < 2)
        throw new RangeError("Polynomial [".concat(d, ", ").concat(v, "] must have a non-zero non-constant coefficient"));
      switch (x.length) {
        case 2:
          return [o(l(x[0], x[1]))];
        case 3: {
          var [h, D, y] = x, w = s(2, y), b = s(D, D), g = s(4, y, h);
          if (n(b, g)) return [l(o(D), w)];
          var N = c(i(b, g));
          return [l(i(N, D), w), l(i(o(N), D), w)];
        }
        case 4: {
          var [S, A, E, M] = x, T = o(s(3, M)), B = s(E, E), I = s(3, M, A), O = a(s(2, E, E, E), s(27, M, M, S)), _ = s(9, M, E, A);
          if (n(B, I) && n(O, _))
            return [l(E, T)];
          var P = i(B, I), W = i(O, _), L = a(s(18, M, E, A, S), s(E, E, A, A)), J = a(s(4, E, E, E, S), s(4, M, A, A, A), s(27, M, M, S, S));
          if (n(L, J))
            return [
              l(i(s(4, M, E, A), a(s(9, M, M, S), s(E, E, E))), s(M, P)),
              // simple root
              l(i(s(9, M, S), s(E, A)), s(2, P))
              // double root
            ];
          var ee;
          n(B, I) ? ee = W : ee = l(a(W, c(i(s(W, W), s(4, P, P, P)))), 2);
          var F = !0, G = u(ee, F).toArray().map((z) => l(a(E, z, l(P, z)), T));
          return G.map((z) => f(z) === "Complex" && n(p(z), p(z) + m(z)) ? p(z) : z);
        }
        default:
          throw new RangeError("only implemented for cubic or lower-order polynomials, not ".concat(x));
      }
    }
  });
}), WN = "Help", GN = ["evaluate"], VN = /* @__PURE__ */ R(WN, GN, (r) => {
  var {
    evaluate: e
  } = r;
  function t(n) {
    if (!(this instanceof t))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (!n) throw new Error('Argument "doc" missing');
    this.doc = n;
  }
  return t.prototype.type = "Help", t.prototype.isHelp = !0, t.prototype.toString = function() {
    var n = this.doc || {}, a = `
`;
    if (n.name && (a += "Name: " + n.name + `

`), n.category && (a += "Category: " + n.category + `

`), n.description && (a += `Description:
    ` + n.description + `

`), n.syntax && (a += `Syntax:
    ` + n.syntax.join(`
    `) + `

`), n.examples) {
      a += `Examples:
`;
      for (var i = !1, s = e("config()"), l = {
        config: (f) => (i = !0, e("config(newConfig)", {
          newConfig: f
        }))
      }, c = 0; c < n.examples.length; c++) {
        var o = n.examples[c];
        a += "    " + o + `
`;
        var u = void 0;
        try {
          u = e(o, l);
        } catch (f) {
          u = f;
        }
        u !== void 0 && !no(u) && (a += "        " + ke(u, {
          precision: 14
        }) + `
`);
      }
      a += `
`, i && e("config(originalConfig)", {
        originalConfig: s
      });
    }
    return n.mayThrow && n.mayThrow.length && (a += "Throws: " + n.mayThrow.join(", ") + `

`), n.seealso && n.seealso.length && (a += "See also: " + n.seealso.join(", ") + `
`), a;
  }, t.prototype.toJSON = function() {
    var n = Te(this.doc);
    return n.mathjs = "Help", n;
  }, t.fromJSON = function(n) {
    var a = {};
    return Object.keys(n).filter((i) => i !== "mathjs").forEach((i) => {
      a[i] = n[i];
    }), new t(a);
  }, t.prototype.valueOf = t.prototype.toString, t;
}, {
  isClass: !0
}), ZN = "Chain", XN = ["?on", "math", "typed"], YN = /* @__PURE__ */ R(ZN, XN, (r) => {
  var {
    on: e,
    math: t,
    typed: n
  } = r;
  function a(o) {
    if (!(this instanceof a))
      throw new SyntaxError("Constructor must be called with the new operator");
    io(o) ? this.value = o.value : this.value = o;
  }
  a.prototype.type = "Chain", a.prototype.isChain = !0, a.prototype.done = function() {
    return this.value;
  }, a.prototype.valueOf = function() {
    return this.value;
  }, a.prototype.toString = function() {
    return ke(this.value);
  }, a.prototype.toJSON = function() {
    return {
      mathjs: "Chain",
      value: this.value
    };
  }, a.fromJSON = function(o) {
    return new a(o.value);
  };
  function i(o, u) {
    typeof u == "function" && (a.prototype[o] = l(u));
  }
  function s(o, u) {
    Tt(a.prototype, o, function() {
      var m = u();
      if (typeof m == "function")
        return l(m);
    });
  }
  function l(o) {
    return function() {
      if (arguments.length === 0)
        return new a(o(this.value));
      for (var u = [this.value], f = 0; f < arguments.length; f++)
        u[f + 1] = arguments[f];
      if (n.isTypedFunction(o)) {
        var m = n.resolve(o, u);
        if (m.params.length === 1)
          throw new Error("chain function " + o.name + " cannot match rest parameter between chain value and additional arguments.");
        return new a(m.implementation.apply(o, u));
      }
      return new a(o.apply(o, u));
    };
  }
  a.createProxy = function(o, u) {
    if (typeof o == "string")
      i(o, u);
    else {
      var f = function(d) {
        xe(o, d) && c[d] === void 0 && s(d, () => o[d]);
      };
      for (var m in o)
        f(m);
    }
  };
  var c = {
    expression: !0,
    docs: !0,
    type: !0,
    classes: !0,
    json: !0,
    error: !0,
    isChain: !0
    // conflicts with the property isChain of a Chain instance
  };
  return a.createProxy(t), e && e("import", function(o, u, f) {
    f || s(o, u);
  }), a;
}, {
  isClass: !0
}), sl = {
  name: "e",
  category: "Constants",
  syntax: ["e"],
  description: "Euler's number, the base of the natural logarithm. Approximately equal to 2.71828",
  examples: ["e", "e ^ 2", "exp(2)", "log(e)"],
  seealso: ["exp"]
}, JN = {
  name: "false",
  category: "Constants",
  syntax: ["false"],
  description: "Boolean value false",
  examples: ["false"],
  seealso: ["true"]
}, QN = {
  name: "i",
  category: "Constants",
  syntax: ["i"],
  description: "Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.",
  examples: ["i", "i * i", "sqrt(-1)"],
  seealso: []
}, jN = {
  name: "Infinity",
  category: "Constants",
  syntax: ["Infinity"],
  description: "Infinity, a number which is larger than the maximum number that can be handled by a floating point number.",
  examples: ["Infinity", "1 / 0"],
  seealso: []
}, KN = {
  name: "LN10",
  category: "Constants",
  syntax: ["LN10"],
  description: "Returns the natural logarithm of 10, approximately equal to 2.302",
  examples: ["LN10", "log(10)"],
  seealso: []
}, eA = {
  name: "LN2",
  category: "Constants",
  syntax: ["LN2"],
  description: "Returns the natural logarithm of 2, approximately equal to 0.693",
  examples: ["LN2", "log(2)"],
  seealso: []
}, rA = {
  name: "LOG10E",
  category: "Constants",
  syntax: ["LOG10E"],
  description: "Returns the base-10 logarithm of E, approximately equal to 0.434",
  examples: ["LOG10E", "log(e, 10)"],
  seealso: []
}, tA = {
  name: "LOG2E",
  category: "Constants",
  syntax: ["LOG2E"],
  description: "Returns the base-2 logarithm of E, approximately equal to 1.442",
  examples: ["LOG2E", "log(e, 2)"],
  seealso: []
}, nA = {
  name: "NaN",
  category: "Constants",
  syntax: ["NaN"],
  description: "Not a number",
  examples: ["NaN", "0 / 0"],
  seealso: []
}, aA = {
  name: "null",
  category: "Constants",
  syntax: ["null"],
  description: "Value null",
  examples: ["null"],
  seealso: ["true", "false"]
}, iA = {
  name: "phi",
  category: "Constants",
  syntax: ["phi"],
  description: "Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...",
  examples: ["phi"],
  seealso: []
}, ul = {
  name: "pi",
  category: "Constants",
  syntax: ["pi"],
  description: "The number pi is a mathematical constant that is the ratio of a circle's circumference to its diameter, and is approximately equal to 3.14159",
  examples: ["pi", "sin(pi/2)"],
  seealso: ["tau"]
}, oA = {
  name: "SQRT1_2",
  category: "Constants",
  syntax: ["SQRT1_2"],
  description: "Returns the square root of 1/2, approximately equal to 0.707",
  examples: ["SQRT1_2", "sqrt(1/2)"],
  seealso: []
}, sA = {
  name: "SQRT2",
  category: "Constants",
  syntax: ["SQRT2"],
  description: "Returns the square root of 2, approximately equal to 1.414",
  examples: ["SQRT2", "sqrt(2)"],
  seealso: []
}, uA = {
  name: "tau",
  category: "Constants",
  syntax: ["tau"],
  description: "Tau is the ratio constant of a circle's circumference to radius, equal to 2 * pi, approximately 6.2832.",
  examples: ["tau", "2 * pi"],
  seealso: ["pi"]
}, cA = {
  name: "true",
  category: "Constants",
  syntax: ["true"],
  description: "Boolean value true",
  examples: ["true"],
  seealso: ["false"]
}, lA = {
  name: "version",
  category: "Constants",
  syntax: ["version"],
  description: "A string with the version number of math.js",
  examples: ["version"],
  seealso: []
}, fA = {
  name: "bignumber",
  category: "Construction",
  syntax: ["bignumber(x)"],
  description: "Create a big number from a number or string.",
  examples: ["0.1 + 0.2", "bignumber(0.1) + bignumber(0.2)", 'bignumber("7.2")', 'bignumber("7.2e500")', "bignumber([0.1, 0.2, 0.3])"],
  seealso: ["boolean", "bigint", "complex", "fraction", "index", "matrix", "string", "unit"]
}, mA = {
  name: "bigint",
  category: "Construction",
  syntax: ["bigint(x)"],
  description: "Create a bigint, an integer with an arbitrary number of digits, from a number or string.",
  examples: ["123123123123123123 # a large number will lose digits", 'bigint("123123123123123123")', 'bignumber(["1", "3", "5"])'],
  seealso: ["boolean", "bignumber", "number", "complex", "fraction", "index", "matrix", "string", "unit"]
}, pA = {
  name: "boolean",
  category: "Construction",
  syntax: ["x", "boolean(x)"],
  description: "Convert a string or number into a boolean.",
  examples: ["boolean(0)", "boolean(1)", "boolean(3)", 'boolean("true")', 'boolean("false")', "boolean([1, 0, 1, 1])"],
  seealso: ["bignumber", "complex", "index", "matrix", "number", "string", "unit"]
}, dA = {
  name: "complex",
  category: "Construction",
  syntax: ["complex()", "complex(re, im)", "complex(string)"],
  description: "Create a complex number.",
  examples: ["complex()", "complex(2, 3)", 'complex("7 - 2i")'],
  seealso: ["bignumber", "boolean", "index", "matrix", "number", "string", "unit"]
}, vA = {
  name: "createUnit",
  category: "Construction",
  syntax: ["createUnit(definitions)", "createUnit(name, definition)"],
  description: "Create a user-defined unit and register it with the Unit type.",
  examples: ['createUnit("foo")', 'createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})', 'createUnit("mph", "1 mile/hour")'],
  seealso: ["unit", "splitUnit"]
}, hA = {
  name: "fraction",
  category: "Construction",
  syntax: ["fraction(num)", "fraction(matrix)", "fraction(num,den)", "fraction({n: num, d: den})"],
  description: "Create a fraction from a number or from integer numerator and denominator.",
  examples: ["fraction(0.125)", "fraction(1, 3) + fraction(2, 5)", "fraction({n: 333, d: 53})", "fraction([sqrt(9), sqrt(10), sqrt(11)])"],
  seealso: ["bignumber", "boolean", "complex", "index", "matrix", "string", "unit"]
}, gA = {
  name: "index",
  category: "Construction",
  syntax: ["[start]", "[start:end]", "[start:step:end]", "[start1, start 2, ...]", "[start1:end1, start2:end2, ...]", "[start1:step1:end1, start2:step2:end2, ...]"],
  description: "Create an index to get or replace a subset of a matrix",
  examples: ["A = [1, 2, 3; 4, 5, 6]", "A[1, :]", "A[1, 2] = 50", "A[1:2, 1:2] = 1", "B = [1, 2, 3]", "B[B>1 and B<3]"],
  seealso: ["bignumber", "boolean", "complex", "matrix", "number", "range", "string", "unit"]
}, yA = {
  name: "matrix",
  category: "Construction",
  syntax: ["[]", "[a1, b1, ...; a2, b2, ...]", "matrix()", 'matrix("dense")', "matrix([...])"],
  description: "Create a matrix.",
  examples: ["[]", "[1, 2, 3]", "[1, 2, 3; 4, 5, 6]", "matrix()", "matrix([3, 4])", 'matrix([3, 4; 5, 6], "sparse")', 'matrix([3, 4; 5, 6], "sparse", "number")'],
  seealso: ["bignumber", "boolean", "complex", "index", "number", "string", "unit", "sparse"]
}, bA = {
  name: "number",
  category: "Construction",
  syntax: ["x", "number(x)", "number(unit, valuelessUnit)"],
  description: "Create a number or convert a string or boolean into a number.",
  examples: ["2", "2e3", "4.05", "number(2)", 'number("7.2")', "number(true)", "number([true, false, true, true])", 'number(unit("52cm"), "m")'],
  seealso: ["bignumber", "bigint", "boolean", "complex", "fraction", "index", "matrix", "string", "unit"]
}, xA = {
  name: "sparse",
  category: "Construction",
  syntax: ["sparse()", "sparse([a1, b1, ...; a1, b2, ...])", 'sparse([a1, b1, ...; a1, b2, ...], "number")'],
  description: "Create a sparse matrix.",
  examples: ["sparse()", "sparse([3, 4; 5, 6])", 'sparse([3, 0; 5, 0], "number")'],
  seealso: ["bignumber", "boolean", "complex", "index", "number", "string", "unit", "matrix"]
}, wA = {
  name: "splitUnit",
  category: "Construction",
  syntax: ["splitUnit(unit: Unit, parts: Unit[])"],
  description: "Split a unit in an array of units whose sum is equal to the original unit.",
  examples: ['splitUnit(1 m, ["feet", "inch"])'],
  seealso: ["unit", "createUnit"]
}, DA = {
  name: "string",
  category: "Construction",
  syntax: ['"text"', "string(x)"],
  description: "Create a string or convert a value to a string",
  examples: ['"Hello World!"', "string(4.2)", "string(3 + 2i)"],
  seealso: ["bignumber", "boolean", "complex", "index", "matrix", "number", "unit"]
}, NA = {
  name: "unit",
  category: "Construction",
  syntax: ["value unit", "unit(value, unit)", "unit(string)"],
  description: "Create a unit.",
  examples: ["5.5 mm", "3 inch", 'unit(7.1, "kilogram")', 'unit("23 deg")'],
  seealso: ["bignumber", "boolean", "complex", "index", "matrix", "number", "string"]
}, AA = {
  name: "config",
  category: "Core",
  syntax: ["config()", "config(options)"],
  description: "Get configuration or change configuration.",
  examples: ["config()", "1/3 + 1/4", 'config({number: "Fraction"})', "1/3 + 1/4"],
  seealso: []
}, SA = {
  name: "import",
  category: "Core",
  syntax: ["import(functions)", "import(functions, options)"],
  description: "Import functions or constants from an object.",
  examples: ["import({myFn: f(x)=x^2, myConstant: 32 })", "myFn(2)", "myConstant"],
  seealso: []
}, EA = {
  name: "typed",
  category: "Core",
  syntax: ["typed(signatures)", "typed(name, signatures)"],
  description: "Create a typed function.",
  examples: ['double = typed({ "number": f(x)=x+x, "string": f(x)=concat(x,x) })', "double(2)", 'double("hello")'],
  seealso: []
}, MA = {
  name: "derivative",
  category: "Algebra",
  syntax: ["derivative(expr, variable)", "derivative(expr, variable, {simplify: boolean})"],
  description: "Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.",
  examples: ['derivative("2x^3", "x")', 'derivative("2x^3", "x", {simplify: false})', 'derivative("2x^2 + 3x + 4", "x")', 'derivative("sin(2x)", "x")', 'f = parse("x^2 + x")', 'x = parse("x")', "df = derivative(f, x)", "df.evaluate({x: 3})"],
  seealso: ["simplify", "parse", "evaluate"]
}, CA = {
  name: "leafCount",
  category: "Algebra",
  syntax: ["leafCount(expr)"],
  description: "Computes the number of leaves in the parse tree of the given expression",
  examples: ['leafCount("e^(i*pi)-1")', 'leafCount(parse("{a: 22/7, b: 10^(1/2)}"))'],
  seealso: ["simplify"]
}, _A = {
  name: "lsolve",
  category: "Algebra",
  syntax: ["x=lsolve(L, b)"],
  description: "Finds one solution of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",
  examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lsolve(a, b)"],
  seealso: ["lsolveAll", "lup", "lusolve", "usolve", "matrix", "sparse"]
}, TA = {
  name: "lsolveAll",
  category: "Algebra",
  syntax: ["x=lsolveAll(L, b)"],
  description: "Finds all solutions of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",
  examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lsolve(a, b)"],
  seealso: ["lsolve", "lup", "lusolve", "usolve", "matrix", "sparse"]
}, FA = {
  name: "lup",
  category: "Algebra",
  syntax: ["lup(m)"],
  description: "Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U",
  examples: ["lup([[2, 1], [1, 4]])", "lup(matrix([[2, 1], [1, 4]]))", "lup(sparse([[2, 1], [1, 4]]))"],
  seealso: ["lusolve", "lsolve", "usolve", "matrix", "sparse", "slu", "qr"]
}, BA = {
  name: "lusolve",
  category: "Algebra",
  syntax: ["x=lusolve(A, b)", "x=lusolve(lu, b)"],
  description: "Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.",
  examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lusolve(a, b)"],
  seealso: ["lup", "slu", "lsolve", "usolve", "matrix", "sparse"]
}, OA = {
  name: "polynomialRoot",
  category: "Algebra",
  syntax: ["x=polynomialRoot(-6, 3)", "x=polynomialRoot(4, -4, 1)", "x=polynomialRoot(-8, 12, -6, 1)"],
  description: "Finds the roots of a univariate polynomial given by its coefficients starting from constant, linear, and so on, increasing in degree.",
  examples: ["a = polynomialRoot(-6, 11, -6, 1)"],
  seealso: ["cbrt", "sqrt"]
}, IA = {
  name: "qr",
  category: "Algebra",
  syntax: ["qr(A)"],
  description: "Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.",
  examples: ["qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])"],
  seealso: ["lup", "slu", "matrix"]
}, $A = {
  name: "rationalize",
  category: "Algebra",
  syntax: ["rationalize(expr)", "rationalize(expr, scope)", "rationalize(expr, scope, detailed)"],
  description: "Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.",
  examples: ['rationalize("2x/y - y/(x+1)")', 'rationalize("2x/y - y/(x+1)", true)'],
  seealso: ["simplify"]
}, zA = {
  name: "resolve",
  category: "Algebra",
  syntax: ["resolve(node, scope)"],
  description: "Recursively substitute variables in an expression tree.",
  examples: ['resolve(parse("1 + x"), { x: 7 })', 'resolve(parse("size(text)"), { text: "Hello World" })', 'resolve(parse("x + y"), { x: parse("3z") })', 'resolve(parse("3x"), { x: parse("y+z"), z: parse("w^y") })'],
  seealso: ["simplify", "evaluate"],
  mayThrow: ["ReferenceError"]
}, RA = {
  name: "simplify",
  category: "Algebra",
  syntax: ["simplify(expr)", "simplify(expr, rules)"],
  description: "Simplify an expression tree.",
  examples: ['simplify("3 + 2 / 4")', 'simplify("2x + x")', 'f = parse("x * (x + 2 + x)")', "simplified = simplify(f)", "simplified.evaluate({x: 2})"],
  seealso: ["simplifyCore", "derivative", "evaluate", "parse", "rationalize", "resolve"]
}, qA = {
  name: "simplifyConstant",
  category: "Algebra",
  syntax: ["simplifyConstant(expr)", "simplifyConstant(expr, options)"],
  description: "Replace constant subexpressions of node with their values.",
  examples: ['simplifyConstant("(3-3)*x")', 'simplifyConstant(parse("z-cos(tau/8)"))'],
  seealso: ["simplify", "simplifyCore", "evaluate"]
}, PA = {
  name: "simplifyCore",
  category: "Algebra",
  syntax: ["simplifyCore(node)"],
  description: "Perform simple one-pass simplifications on an expression tree.",
  examples: ['simplifyCore(parse("0*x"))', 'simplifyCore(parse("(x+0)*2"))'],
  seealso: ["simplify", "simplifyConstant", "evaluate"]
}, UA = {
  name: "slu",
  category: "Algebra",
  syntax: ["slu(A, order, threshold)"],
  description: "Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U",
  examples: ["slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)"],
  seealso: ["lusolve", "lsolve", "usolve", "matrix", "sparse", "lup", "qr"]
}, LA = {
  name: "symbolicEqual",
  category: "Algebra",
  syntax: ["symbolicEqual(expr1, expr2)", "symbolicEqual(expr1, expr2, options)"],
  description: "Returns true if the difference of the expressions simplifies to 0",
  examples: ['symbolicEqual("x*y","y*x")', 'symbolicEqual("abs(x^2)", "x^2")', 'symbolicEqual("abs(x)", "x", {context: {abs: {trivial: true}}})'],
  seealso: ["simplify", "evaluate"]
}, kA = {
  name: "usolve",
  category: "Algebra",
  syntax: ["x=usolve(U, b)"],
  description: "Finds one solution of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",
  examples: ["x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"],
  seealso: ["usolveAll", "lup", "lusolve", "lsolve", "matrix", "sparse"]
}, HA = {
  name: "usolveAll",
  category: "Algebra",
  syntax: ["x=usolve(U, b)"],
  description: "Finds all solutions of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",
  examples: ["x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"],
  seealso: ["usolve", "lup", "lusolve", "lsolve", "matrix", "sparse"]
}, WA = {
  name: "abs",
  category: "Arithmetic",
  syntax: ["abs(x)"],
  description: "Compute the absolute value.",
  examples: ["abs(3.5)", "abs(-4.2)"],
  seealso: ["sign"]
}, GA = {
  name: "add",
  category: "Operators",
  syntax: ["x + y", "add(x, y)"],
  description: "Add two values.",
  examples: ["a = 2.1 + 3.6", "a - 3.6", "3 + 2i", "3 cm + 2 inch", '"2.3" + "4"'],
  seealso: ["subtract"]
}, VA = {
  name: "cbrt",
  category: "Arithmetic",
  syntax: ["cbrt(x)", "cbrt(x, allRoots)"],
  description: "Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned",
  examples: ["cbrt(64)", "cube(4)", "cbrt(-8)", "cbrt(2 + 3i)", "cbrt(8i)", "cbrt(8i, true)", "cbrt(27 m^3)"],
  seealso: ["square", "sqrt", "cube", "multiply"]
}, ZA = {
  name: "ceil",
  category: "Arithmetic",
  syntax: ["ceil(x)", "ceil(x, n)", "ceil(unit, valuelessUnit)", "ceil(unit, n, valuelessUnit)"],
  description: "Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.",
  examples: ["ceil(3.2)", "ceil(3.8)", "ceil(-4.2)", "ceil(3.241cm, cm)", "ceil(3.241cm, 2, cm)"],
  seealso: ["floor", "fix", "round"]
}, XA = {
  name: "cube",
  category: "Arithmetic",
  syntax: ["cube(x)"],
  description: "Compute the cube of a value. The cube of x is x * x * x.",
  examples: ["cube(2)", "2^3", "2 * 2 * 2"],
  seealso: ["multiply", "square", "pow"]
}, YA = {
  name: "divide",
  category: "Operators",
  syntax: ["x / y", "divide(x, y)"],
  description: "Divide two values.",
  examples: ["a = 2 / 3", "a * 3", "4.5 / 2", "3 + 4 / 2", "(3 + 4) / 2", "18 km / 4.5"],
  seealso: ["multiply"]
}, JA = {
  name: "dotDivide",
  category: "Operators",
  syntax: ["x ./ y", "dotDivide(x, y)"],
  description: "Divide two values element wise.",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "b = [2, 1, 1; 3, 2, 5]", "a ./ b"],
  seealso: ["multiply", "dotMultiply", "divide"]
}, QA = {
  name: "dotMultiply",
  category: "Operators",
  syntax: ["x .* y", "dotMultiply(x, y)"],
  description: "Multiply two values element wise.",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "b = [2, 1, 1; 3, 2, 5]", "a .* b"],
  seealso: ["multiply", "divide", "dotDivide"]
}, jA = {
  name: "dotPow",
  category: "Operators",
  syntax: ["x .^ y", "dotPow(x, y)"],
  description: "Calculates the power of x to y element wise.",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "a .^ 2"],
  seealso: ["pow"]
}, KA = {
  name: "exp",
  category: "Arithmetic",
  syntax: ["exp(x)"],
  description: "Calculate the exponent of a value.",
  examples: ["exp(1.3)", "e ^ 1.3", "log(exp(1.3))", "x = 2.4", "(exp(i*x) == cos(x) + i*sin(x))   # Euler's formula"],
  seealso: ["expm", "expm1", "pow", "log"]
}, eS = {
  name: "expm",
  category: "Arithmetic",
  syntax: ["exp(x)"],
  description: "Compute the matrix exponential, expm(A) = e^A. The matrix must be square. Not to be confused with exp(a), which performs element-wise exponentiation.",
  examples: ["expm([[0,2],[0,0]])"],
  seealso: ["exp"]
}, rS = {
  name: "expm1",
  category: "Arithmetic",
  syntax: ["expm1(x)"],
  description: "Calculate the value of subtracting 1 from the exponential value.",
  examples: ["expm1(2)", "pow(e, 2) - 1", "log(expm1(2) + 1)"],
  seealso: ["exp", "pow", "log"]
}, tS = {
  name: "fix",
  category: "Arithmetic",
  syntax: ["fix(x)", "fix(x, n)", "fix(unit, valuelessUnit)", "fix(unit, n, valuelessUnit)"],
  description: "Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.",
  examples: ["fix(3.2)", "fix(3.8)", "fix(-4.2)", "fix(-4.8)", "fix(3.241cm, cm)", "fix(3.241cm, 2, cm)"],
  seealso: ["ceil", "floor", "round"]
}, nS = {
  name: "floor",
  category: "Arithmetic",
  syntax: ["floor(x)", "floor(x, n)", "floor(unit, valuelessUnit)", "floor(unit, n, valuelessUnit)"],
  description: "Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.",
  examples: ["floor(3.2)", "floor(3.8)", "floor(-4.2)", "floor(3.241cm, cm)", "floor(3.241cm, 2, cm)"],
  seealso: ["ceil", "fix", "round"]
}, aS = {
  name: "gcd",
  category: "Arithmetic",
  syntax: ["gcd(a, b)", "gcd(a, b, c, ...)"],
  description: "Compute the greatest common divisor.",
  examples: ["gcd(8, 12)", "gcd(-4, 6)", "gcd(25, 15, -10)"],
  seealso: ["lcm", "xgcd"]
}, iS = {
  name: "hypot",
  category: "Arithmetic",
  syntax: ["hypot(a, b, c, ...)", "hypot([a, b, c, ...])"],
  description: "Calculate the hypotenuse of a list with values.",
  examples: ["hypot(3, 4)", "sqrt(3^2 + 4^2)", "hypot(-2)", "hypot([3, 4, 5])"],
  seealso: ["abs", "norm"]
}, oS = {
  name: "invmod",
  category: "Arithmetic",
  syntax: ["invmod(a, b)"],
  description: "Calculate the (modular) multiplicative inverse of a modulo b. Solution to the equation ax ≣ 1 (mod b)",
  examples: ["invmod(8, 12)", "invmod(7, 13)", "invmod(15151, 15122)"],
  seealso: ["gcd", "xgcd"]
}, sS = {
  name: "lcm",
  category: "Arithmetic",
  syntax: ["lcm(x, y)"],
  description: "Compute the least common multiple.",
  examples: ["lcm(4, 6)", "lcm(6, 21)", "lcm(6, 21, 5)"],
  seealso: ["gcd"]
}, uS = {
  name: "log",
  category: "Arithmetic",
  syntax: ["log(x)", "log(x, base)"],
  description: "Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).",
  examples: ["log(3.5)", "a = log(2.4)", "exp(a)", "10 ^ 4", "log(10000, 10)", "log(10000) / log(10)", "b = log(1024, 2)", "2 ^ b"],
  seealso: ["exp", "log1p", "log2", "log10"]
}, cS = {
  name: "log10",
  category: "Arithmetic",
  syntax: ["log10(x)"],
  description: "Compute the 10-base logarithm of a value.",
  examples: ["log10(0.00001)", "log10(10000)", "10 ^ 4", "log(10000) / log(10)", "log(10000, 10)"],
  seealso: ["exp", "log"]
}, lS = {
  name: "log1p",
  category: "Arithmetic",
  syntax: ["log1p(x)", "log1p(x, base)"],
  description: "Calculate the logarithm of a `value+1`",
  examples: ["log1p(2.5)", "exp(log1p(1.4))", "pow(10, 4)", "log1p(9999, 10)", "log1p(9999) / log(10)"],
  seealso: ["exp", "log", "log2", "log10"]
}, fS = {
  name: "log2",
  category: "Arithmetic",
  syntax: ["log2(x)"],
  description: "Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.",
  examples: ["log2(0.03125)", "log2(16)", "log2(16) / log2(2)", "pow(2, 4)"],
  seealso: ["exp", "log1p", "log", "log10"]
}, mS = {
  name: "mod",
  category: "Operators",
  syntax: ["x % y", "x mod y", "mod(x, y)"],
  description: "Calculates the modulus, the remainder of an integer division.",
  examples: ["7 % 3", "11 % 2", "10 mod 4", "isOdd(x) = x % 2", "isOdd(2)", "isOdd(3)"],
  seealso: ["divide"]
}, pS = {
  name: "multiply",
  category: "Operators",
  syntax: ["x * y", "multiply(x, y)"],
  description: "multiply two values.",
  examples: ["a = 2.1 * 3.4", "a / 3.4", "2 * 3 + 4", "2 * (3 + 4)", "3 * 2.1 km"],
  seealso: ["divide"]
}, dS = {
  name: "norm",
  category: "Arithmetic",
  syntax: ["norm(x)", "norm(x, p)"],
  description: "Calculate the norm of a number, vector or matrix.",
  examples: ["abs(-3.5)", "norm(-3.5)", "norm(3 - 4i)", "norm([1, 2, -3], Infinity)", "norm([1, 2, -3], -Infinity)", "norm([3, 4], 2)", "norm([[1, 2], [3, 4]], 1)", 'norm([[1, 2], [3, 4]], "inf")', 'norm([[1, 2], [3, 4]], "fro")']
}, vS = {
  name: "nthRoot",
  category: "Arithmetic",
  syntax: ["nthRoot(a)", "nthRoot(a, root)"],
  description: 'Calculate the nth root of a value. The principal nth root of a positive real number A, is the positive real solution of the equation "x^root = A".',
  examples: ["4 ^ 3", "nthRoot(64, 3)", "nthRoot(9, 2)", "sqrt(9)"],
  seealso: ["nthRoots", "pow", "sqrt"]
}, hS = {
  name: "nthRoots",
  category: "Arithmetic",
  syntax: ["nthRoots(A)", "nthRoots(A, root)"],
  description: 'Calculate the nth roots of a value. An nth root of a positive real number A, is a positive real solution of the equation "x^root = A". This function returns an array of complex values.',
  examples: ["nthRoots(1)", "nthRoots(1, 3)"],
  seealso: ["sqrt", "pow", "nthRoot"]
}, gS = {
  name: "pow",
  category: "Operators",
  syntax: ["x ^ y", "pow(x, y)"],
  description: "Calculates the power of x to y, x^y.",
  examples: ["2^3", "2*2*2", "1 + e ^ (pi * i)", "pow([[1, 2], [4, 3]], 2)", "pow([[1, 2], [4, 3]], -1)"],
  seealso: ["multiply", "nthRoot", "nthRoots", "sqrt"]
}, yS = {
  name: "round",
  category: "Arithmetic",
  syntax: ["round(x)", "round(x, n)", "round(unit, valuelessUnit)", "round(unit, n, valuelessUnit)"],
  description: "round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.",
  examples: ["round(3.2)", "round(3.8)", "round(-4.2)", "round(-4.8)", "round(pi, 3)", "round(123.45678, 2)", "round(3.241cm, 2, cm)", "round([3.2, 3.8, -4.7])"],
  seealso: ["ceil", "floor", "fix"]
}, bS = {
  name: "sign",
  category: "Arithmetic",
  syntax: ["sign(x)"],
  description: "Compute the sign of a value. The sign of a value x is 1 when x>0, -1 when x<0, and 0 when x=0.",
  examples: ["sign(3.5)", "sign(-4.2)", "sign(0)"],
  seealso: ["abs"]
}, xS = {
  name: "sqrt",
  category: "Arithmetic",
  syntax: ["sqrt(x)"],
  description: "Compute the square root value. If x = y * y, then y is the square root of x.",
  examples: ["sqrt(25)", "5 * 5", "sqrt(-1)"],
  seealso: ["square", "sqrtm", "multiply", "nthRoot", "nthRoots", "pow"]
}, wS = {
  name: "sqrtm",
  category: "Arithmetic",
  syntax: ["sqrtm(x)"],
  description: "Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.",
  examples: ["sqrtm([[33, 24], [48, 57]])"],
  seealso: ["sqrt", "abs", "square", "multiply"]
}, DS = {
  name: "sylvester",
  category: "Algebra",
  syntax: ["sylvester(A,B,C)"],
  description: "Solves the real-valued Sylvester equation AX+XB=C for X",
  examples: ["sylvester([[-1, -2], [1, 1]], [[-2, 1], [-1, 2]], [[-3, 2], [3, 0]])", "A = [[-1, -2], [1, 1]]; B = [[2, -1], [1, -2]]; C = [[-3, 2], [3, 0]]", "sylvester(A, B, C)"],
  seealso: ["schur", "lyap"]
}, NS = {
  name: "schur",
  category: "Algebra",
  syntax: ["schur(A)"],
  description: "Performs a real Schur decomposition of the real matrix A = UTU'",
  examples: ["schur([[1, 0], [-4, 3]])", "A = [[1, 0], [-4, 3]]", "schur(A)"],
  seealso: ["lyap", "sylvester"]
}, AS = {
  name: "lyap",
  category: "Algebra",
  syntax: ["lyap(A,Q)"],
  description: "Solves the Continuous-time Lyapunov equation AP+PA'+Q=0 for P",
  examples: ["lyap([[-2, 0], [1, -4]], [[3, 1], [1, 3]])", "A = [[-2, 0], [1, -4]]", "Q = [[3, 1], [1, 3]]", "lyap(A,Q)"],
  seealso: ["schur", "sylvester"]
}, SS = {
  name: "square",
  category: "Arithmetic",
  syntax: ["square(x)"],
  description: "Compute the square of a value. The square of x is x * x.",
  examples: ["square(3)", "sqrt(9)", "3^2", "3 * 3"],
  seealso: ["multiply", "pow", "sqrt", "cube"]
}, ES = {
  name: "subtract",
  category: "Operators",
  syntax: ["x - y", "subtract(x, y)"],
  description: "subtract two values.",
  examples: ["a = 5.3 - 2", "a + 2", "2/3 - 1/6", "2 * 3 - 3", "2.1 km - 500m"],
  seealso: ["add"]
}, MS = {
  name: "unaryMinus",
  category: "Operators",
  syntax: ["-x", "unaryMinus(x)"],
  description: "Inverse the sign of a value. Converts booleans and strings to numbers.",
  examples: ["-4.5", "-(-5.6)", '-"22"'],
  seealso: ["add", "subtract", "unaryPlus"]
}, CS = {
  name: "unaryPlus",
  category: "Operators",
  syntax: ["+x", "unaryPlus(x)"],
  description: "Converts booleans and strings to numbers.",
  examples: ["+true", '+"2"'],
  seealso: ["add", "subtract", "unaryMinus"]
}, _S = {
  name: "xgcd",
  category: "Arithmetic",
  syntax: ["xgcd(a, b)"],
  description: "Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.",
  examples: ["xgcd(8, 12)", "gcd(8, 12)", "xgcd(36163, 21199)"],
  seealso: ["gcd", "lcm"]
}, TS = {
  name: "bitAnd",
  category: "Bitwise",
  syntax: ["x & y", "bitAnd(x, y)"],
  description: "Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0",
  examples: ["5 & 3", "bitAnd(53, 131)", "[1, 12, 31] & 42"],
  seealso: ["bitNot", "bitOr", "bitXor", "leftShift", "rightArithShift", "rightLogShift"]
}, FS = {
  name: "bitNot",
  category: "Bitwise",
  syntax: ["~x", "bitNot(x)"],
  description: "Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.",
  examples: ["~1", "~2", "bitNot([2, -3, 4])"],
  seealso: ["bitAnd", "bitOr", "bitXor", "leftShift", "rightArithShift", "rightLogShift"]
}, BS = {
  name: "bitOr",
  category: "Bitwise",
  syntax: ["x | y", "bitOr(x, y)"],
  description: "Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.",
  examples: ["5 | 3", "bitOr([1, 2, 3], 4)"],
  seealso: ["bitAnd", "bitNot", "bitXor", "leftShift", "rightArithShift", "rightLogShift"]
}, OS = {
  name: "bitXor",
  category: "Bitwise",
  syntax: ["bitXor(x, y)"],
  description: "Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.",
  examples: ["bitOr(1, 2)", "bitXor([2, 3, 4], 4)"],
  seealso: ["bitAnd", "bitNot", "bitOr", "leftShift", "rightArithShift", "rightLogShift"]
}, IS = {
  name: "leftShift",
  category: "Bitwise",
  syntax: ["x << y", "leftShift(x, y)"],
  description: "Bitwise left logical shift of a value x by y number of bits.",
  examples: ["4 << 1", "8 >> 1"],
  seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "rightArithShift", "rightLogShift"]
}, $S = {
  name: "rightArithShift",
  category: "Bitwise",
  syntax: ["x >> y", "rightArithShift(x, y)"],
  description: "Bitwise right arithmetic shift of a value x by y number of bits.",
  examples: ["8 >> 1", "4 << 1", "-12 >> 2"],
  seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "leftShift", "rightLogShift"]
}, zS = {
  name: "rightLogShift",
  category: "Bitwise",
  syntax: ["x >>> y", "rightLogShift(x, y)"],
  description: "Bitwise right logical shift of a value x by y number of bits.",
  examples: ["8 >>> 1", "4 << 1", "-12 >>> 2"],
  seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "leftShift", "rightArithShift"]
}, RS = {
  name: "bellNumbers",
  category: "Combinatorics",
  syntax: ["bellNumbers(n)"],
  description: "The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.",
  examples: ["bellNumbers(3)", "bellNumbers(8)"],
  seealso: ["stirlingS2"]
}, qS = {
  name: "catalan",
  category: "Combinatorics",
  syntax: ["catalan(n)"],
  description: "The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.",
  examples: ["catalan(3)", "catalan(8)"],
  seealso: ["bellNumbers"]
}, PS = {
  name: "composition",
  category: "Combinatorics",
  syntax: ["composition(n, k)"],
  description: "The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.",
  examples: ["composition(5, 3)"],
  seealso: ["combinations"]
}, US = {
  name: "stirlingS2",
  category: "Combinatorics",
  syntax: ["stirlingS2(n, k)"],
  description: "he Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.",
  examples: ["stirlingS2(5, 3)"],
  seealso: ["bellNumbers"]
}, LS = {
  name: "arg",
  category: "Complex",
  syntax: ["arg(x)"],
  description: "Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).",
  examples: ["arg(2 + 2i)", "atan2(3, 2)", "arg(2 + 3i)"],
  seealso: ["re", "im", "conj", "abs"]
}, kS = {
  name: "conj",
  category: "Complex",
  syntax: ["conj(x)"],
  description: "Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.",
  examples: ["conj(2 + 3i)", "conj(2 - 3i)", "conj(-5.2i)"],
  seealso: ["re", "im", "abs", "arg"]
}, HS = {
  name: "im",
  category: "Complex",
  syntax: ["im(x)"],
  description: "Get the imaginary part of a complex number.",
  examples: ["im(2 + 3i)", "re(2 + 3i)", "im(-5.2i)", "im(2.4)"],
  seealso: ["re", "conj", "abs", "arg"]
}, WS = {
  name: "re",
  category: "Complex",
  syntax: ["re(x)"],
  description: "Get the real part of a complex number.",
  examples: ["re(2 + 3i)", "im(2 + 3i)", "re(-5.2i)", "re(2.4)"],
  seealso: ["im", "conj", "abs", "arg"]
}, GS = {
  name: "evaluate",
  category: "Expression",
  syntax: ["evaluate(expression)", "evaluate(expression, scope)", "evaluate([expr1, expr2, expr3, ...])", "evaluate([expr1, expr2, expr3, ...], scope)"],
  description: "Evaluate an expression or an array with expressions.",
  examples: ['evaluate("2 + 3")', 'evaluate("sqrt(16)")', 'evaluate("2 inch to cm")', 'evaluate("sin(x * pi)", { "x": 1/2 })', 'evaluate(["width=2", "height=4","width*height"])'],
  seealso: ["parser", "parse", "compile"]
}, VS = {
  name: "parser",
  category: "Expression",
  syntax: ["parser()"],
  description: "Create a parser object that keeps a context of variables and their values, allowing the evaluation of expressions in that context.",
  examples: ["myParser = parser()", 'myParser.evaluate("sqrt(3^2 + 4^2)")', 'myParser.set("x", 3)', 'myParser.evaluate("y = x + 3")', 'myParser.evaluate(["y = x + 3", "y = y + 1"])', 'myParser.get("y")'],
  seealso: ["evaluate", "parse", "compile"]
}, ZS = {
  name: "parse",
  category: "Expression",
  syntax: ["parse(expr)", "parse(expr, options)", "parse([expr1, expr2, expr3, ...])", "parse([expr1, expr2, expr3, ...], options)"],
  description: "Parse an expression. Returns a node tree, which can be evaluated by invoking node.evaluate() or transformed into a functional object via node.compile().",
  examples: ['node1 = parse("sqrt(3^2 + 4^2)")', "node1.evaluate()", "code1 = node1.compile()", "code1.evaluate()", "scope = {a: 3, b: 4}", 'node2 = parse("a * b")', "node2.evaluate(scope)", "code2 = node2.compile()", "code2.evaluate(scope)"],
  seealso: ["parser", "evaluate", "compile"]
}, XS = {
  name: "compile",
  category: "Expression",
  syntax: ["compile(expr) ", "compile([expr1, expr2, expr3, ...])"],
  description: "Parse and compile an expression. Returns a an object with a function evaluate([scope]) to evaluate the compiled expression.",
  examples: ['code1 = compile("sqrt(3^2 + 4^2)")', "code1.evaluate() ", 'code2 = compile("a * b")', "code2.evaluate({a: 3, b: 4})"],
  seealso: ["parser", "parse", "evaluate"]
}, YS = {
  name: "help",
  category: "Expression",
  syntax: ["help(object)", "help(string)"],
  description: "Display documentation on a function or data type.",
  examples: ["help(sqrt)", 'help("complex")'],
  seealso: []
}, JS = {
  name: "distance",
  category: "Geometry",
  syntax: ["distance([x1, y1], [x2, y2])", "distance([[x1, y1], [x2, y2]])"],
  description: "Calculates the Euclidean distance between two points.",
  examples: ["distance([0,0], [4,4])", "distance([[0,0], [4,4]])"],
  seealso: []
}, QS = {
  name: "intersect",
  category: "Geometry",
  syntax: ["intersect(expr1, expr2, expr3, expr4)", "intersect(expr1, expr2, expr3)"],
  description: "Computes the intersection point of lines and/or planes.",
  examples: ["intersect([0, 0], [10, 10], [10, 0], [0, 10])", "intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])"],
  seealso: []
}, jS = {
  name: "and",
  category: "Logical",
  syntax: ["x and y", "and(x, y)"],
  description: "Logical and. Test whether two values are both defined with a nonzero/nonempty value.",
  examples: ["true and false", "true and true", "2 and 4"],
  seealso: ["not", "or", "xor"]
}, KS = {
  name: "not",
  category: "Logical",
  syntax: ["not x", "not(x)"],
  description: "Logical not. Flips the boolean value of given argument.",
  examples: ["not true", "not false", "not 2", "not 0"],
  seealso: ["and", "or", "xor"]
}, eE = {
  name: "nullish",
  category: "Logical",
  syntax: ["x ?? y", "nullish(x, y)"],
  description: "Nullish coalescing operator. Returns the right-hand operand when the left-hand operand is null or undefined, and otherwise returns the left-hand operand.",
  examples: ["null ?? 42", "undefined ?? 42", "0 ?? 42", "false ?? 42", "null ?? undefined ?? 42"],
  seealso: ["and", "or", "not"]
}, rE = {
  name: "or",
  category: "Logical",
  syntax: ["x or y", "or(x, y)"],
  description: "Logical or. Test if at least one value is defined with a nonzero/nonempty value.",
  examples: ["true or false", "false or false", "0 or 4"],
  seealso: ["not", "and", "xor"]
}, tE = {
  name: "xor",
  category: "Logical",
  syntax: ["x xor y", "xor(x, y)"],
  description: "Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.",
  examples: ["true xor false", "false xor false", "true xor true", "0 xor 4"],
  seealso: ["not", "and", "or"]
}, nE = {
  name: "mapSlices",
  category: "Matrix",
  syntax: ["mapSlices(A, dim, callback)"],
  description: "Generate a matrix one dimension less than A by applying callback to each slice of A along dimension dim.",
  examples: [
    "A = [[1, 2], [3, 4]]",
    "mapSlices(A, 1, sum)",
    // returns [4, 6]
    "mapSlices(A, 2, prod)"
    // returns [2, 12]
  ],
  seealso: ["map", "forEach"]
}, aE = {
  name: "column",
  category: "Matrix",
  syntax: ["column(x, index)"],
  description: "Return a column from a matrix or array.",
  examples: ["A = [[1, 2], [3, 4]]", "column(A, 1)", "column(A, 2)"],
  seealso: ["row", "matrixFromColumns"]
}, iE = {
  name: "concat",
  category: "Matrix",
  syntax: ["concat(A, B, C, ...)", "concat(A, B, C, ..., dim)"],
  description: "Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.",
  examples: ["A = [1, 2; 5, 6]", "B = [3, 4; 7, 8]", "concat(A, B)", "concat(A, B, 1)", "concat(A, B, 2)"],
  seealso: ["det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, oE = {
  name: "count",
  category: "Matrix",
  syntax: ["count(x)"],
  description: "Count the number of elements of a matrix, array or string.",
  examples: ["a = [1, 2; 3, 4; 5, 6]", "count(a)", "size(a)", 'count("hello world")'],
  seealso: ["size"]
}, sE = {
  name: "cross",
  category: "Matrix",
  syntax: ["cross(A, B)"],
  description: "Calculate the cross product for two vectors in three dimensional space.",
  examples: ["cross([1, 1, 0],  [0, 1, 1])", "cross([3, -3, 1], [4, 9, 2])", "cross([2, 3, 4],  [5, 6, 7])"],
  seealso: ["multiply", "dot"]
}, uE = {
  name: "ctranspose",
  category: "Matrix",
  syntax: ["x'", "ctranspose(x)"],
  description: "Complex Conjugate and Transpose a matrix",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "a'", "ctranspose(a)"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "zeros"]
}, cE = {
  name: "det",
  category: "Matrix",
  syntax: ["det(x)"],
  description: "Calculate the determinant of a matrix",
  examples: ["det([1, 2; 3, 4])", "det([-2, 2, 3; -1, 1, 3; 2, 0, -1])"],
  seealso: ["concat", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, lE = {
  name: "diag",
  category: "Matrix",
  syntax: ["diag(x)", "diag(x, k)"],
  description: "Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.",
  examples: ["diag(1:3)", "diag(1:3, 1)", "a = [1, 2, 3; 4, 5, 6; 7, 8, 9]", "diag(a)"],
  seealso: ["concat", "det", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, fE = {
  name: "diff",
  category: "Matrix",
  syntax: ["diff(arr)", "diff(arr, dim)"],
  description: ["Create a new matrix or array with the difference of the passed matrix or array.", "Dim parameter is optional and used to indicate the dimension of the array/matrix to apply the difference", "If no dimension parameter is passed it is assumed as dimension 0", "Dimension is zero-based in javascript and one-based in the parser", "Arrays must be 'rectangular' meaning arrays like [1, 2]", "If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays"],
  examples: ["A = [1, 2, 4, 7, 0]", "diff(A)", "diff(A, 1)", "B = [[1, 2], [3, 4]]", "diff(B)", "diff(B, 1)", "diff(B, 2)", "diff(B, bignumber(2))", "diff([[1, 2], matrix([3, 4])], 2)"],
  seealso: ["subtract", "partitionSelect"]
}, mE = {
  name: "dot",
  category: "Matrix",
  syntax: ["dot(A, B)", "A * B"],
  description: "Calculate the dot product of two vectors. The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn",
  examples: ["dot([2, 4, 1], [2, 2, 3])", "[2, 4, 1] * [2, 2, 3]"],
  seealso: ["multiply", "cross"]
}, pE = {
  name: "eigs",
  category: "Matrix",
  syntax: ["eigs(x)"],
  description: "Calculate the eigenvalues and optionally eigenvectors of a square matrix",
  examples: ["eigs([[5, 2.3], [2.3, 1]])", "eigs([[1, 2, 3], [4, 5, 6], [7, 8, 9]], { precision: 1e-6, eigenvectors: false })"],
  seealso: ["inv"]
}, dE = {
  name: "filter",
  category: "Matrix",
  syntax: ["filter(x, test)"],
  description: "Filter items in a matrix.",
  examples: ["isPositive(x) = x > 0", "filter([6, -2, -1, 4, 3], isPositive)", "filter([6, -2, 0, 1, 0], x != 0)"],
  seealso: ["sort", "map", "forEach"]
}, vE = {
  name: "flatten",
  category: "Matrix",
  syntax: ["flatten(x)"],
  description: "Flatten a multi dimensional matrix into a single dimensional matrix.",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "size(a)", "b = flatten(a)", "size(b)"],
  seealso: ["concat", "resize", "size", "squeeze"]
}, hE = {
  name: "forEach",
  category: "Matrix",
  syntax: ["forEach(x, callback)"],
  description: "Iterates over all elements of a matrix/array, and executes the given callback function.",
  examples: ["numberOfPets = {}", "addPet(n) = numberOfPets[n] = (numberOfPets[n] ? numberOfPets[n]:0 ) + 1;", 'forEach(["Dog","Cat","Cat"], addPet)', "numberOfPets"],
  seealso: ["map", "sort", "filter"]
}, gE = {
  name: "getMatrixDataType",
  category: "Matrix",
  syntax: ["getMatrixDataType(x)"],
  description: 'Find the data type of all elements in a matrix or array, for example "number" if all items are a number and "Complex" if all values are complex numbers. If a matrix contains more than one data type, it will return "mixed".',
  examples: ["getMatrixDataType([1, 2, 3])", "getMatrixDataType([[5 cm], [2 inch]])", 'getMatrixDataType([1, "text"])', "getMatrixDataType([1, bignumber(4)])"],
  seealso: ["matrix", "sparse", "typeOf"]
}, yE = {
  name: "identity",
  category: "Matrix",
  syntax: ["identity(n)", "identity(m, n)", "identity([m, n])"],
  description: "Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.",
  examples: ["identity(3)", "identity(3, 5)", "a = [1, 2, 3; 4, 5, 6]", "identity(size(a))"],
  seealso: ["concat", "det", "diag", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, bE = {
  name: "inv",
  category: "Matrix",
  syntax: ["inv(x)"],
  description: "Calculate the inverse of a matrix",
  examples: ["inv([1, 2; 3, 4])", "inv(4)", "1 / 4"],
  seealso: ["concat", "det", "diag", "identity", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, xE = {
  name: "pinv",
  category: "Matrix",
  syntax: ["pinv(x)"],
  description: "Calculate the Moore–Penrose inverse of a matrix",
  examples: ["pinv([1, 2; 3, 4])", "pinv([[1, 0], [0, 1], [0, 1]])", "pinv(4)"],
  seealso: ["inv"]
}, wE = {
  name: "kron",
  category: "Matrix",
  syntax: ["kron(x, y)"],
  description: "Calculates the Kronecker product of 2 matrices or vectors.",
  examples: ["kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])", "kron([1,1], [2,3,4])"],
  seealso: ["multiply", "dot", "cross"]
}, DE = {
  name: "map",
  category: "Matrix",
  syntax: ["map(x, callback)", "map(x, y, ..., callback)"],
  description: "Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array or the matrices/arrays.",
  examples: ["map([1, 2, 3], square)", "map([1, 2], [3, 4], f(a,b) = a + b)"],
  seealso: ["filter", "forEach"]
}, NE = {
  name: "matrixFromColumns",
  category: "Matrix",
  syntax: ["matrixFromColumns(...arr)", "matrixFromColumns(row1, row2)", "matrixFromColumns(row1, row2, row3)"],
  description: "Create a dense matrix from vectors as individual columns.",
  examples: ["matrixFromColumns([1, 2, 3], [[4],[5],[6]])"],
  seealso: ["matrix", "matrixFromRows", "matrixFromFunction", "zeros"]
}, AE = {
  name: "matrixFromFunction",
  category: "Matrix",
  syntax: ["matrixFromFunction(size, fn)", "matrixFromFunction(size, fn, format)", "matrixFromFunction(size, fn, format, datatype)", "matrixFromFunction(size, format, fn)", "matrixFromFunction(size, format, datatype, fn)"],
  description: "Create a matrix by evaluating a generating function at each index.",
  examples: ["f(I) = I[1] - I[2]", "matrixFromFunction([3,3], f)", "g(I) = I[1] - I[2] == 1 ? 4 : 0", 'matrixFromFunction([100, 100], "sparse", g)', "matrixFromFunction([5], random)"],
  seealso: ["matrix", "matrixFromRows", "matrixFromColumns", "zeros"]
}, SE = {
  name: "matrixFromRows",
  category: "Matrix",
  syntax: ["matrixFromRows(...arr)", "matrixFromRows(row1, row2)", "matrixFromRows(row1, row2, row3)"],
  description: "Create a dense matrix from vectors as individual rows.",
  examples: ["matrixFromRows([1, 2, 3], [[4],[5],[6]])"],
  seealso: ["matrix", "matrixFromColumns", "matrixFromFunction", "zeros"]
}, EE = {
  name: "ones",
  category: "Matrix",
  syntax: ["ones(m)", "ones(m, n)", "ones(m, n, p, ...)", "ones([m])", "ones([m, n])", "ones([m, n, p, ...])"],
  description: "Create a matrix containing ones.",
  examples: ["ones(3)", "ones(3, 5)", "ones([2,3]) * 4.5", "a = [1, 2, 3; 4, 5, 6]", "ones(size(a))"],
  seealso: ["concat", "det", "diag", "identity", "inv", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, ME = {
  name: "partitionSelect",
  category: "Matrix",
  syntax: ["partitionSelect(x, k)", "partitionSelect(x, k, compare)"],
  description: "Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.",
  examples: ["partitionSelect([5, 10, 1], 2)", 'partitionSelect(["C", "B", "A", "D"], 1, compareText)', "arr = [5, 2, 1]", "partitionSelect(arr, 0) # returns 1, arr is now: [1, 2, 5]", "arr", "partitionSelect(arr, 1, 'desc') # returns 2, arr is now: [5, 2, 1]", "arr"],
  seealso: ["sort"]
}, CE = {
  name: "range",
  category: "Type",
  syntax: ["start:end", "start:step:end", "range(start, end)", "range(start, end, step)", "range(string)"],
  description: "Create a range. Lower bound of the range is included, upper bound is excluded.",
  examples: ["1:5", "3:-1:-3", "range(3, 7)", "range(0, 12, 2)", 'range("4:10")', "range(1m, 1m, 3m)", "a = [1, 2, 3, 4; 5, 6, 7, 8]", "a[1:2, 1:2]"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, _E = {
  name: "reshape",
  category: "Matrix",
  syntax: ["reshape(x, sizes)"],
  description: "Reshape a multi dimensional array to fit the specified dimensions.",
  examples: ["reshape([1, 2, 3, 4, 5, 6], [2, 3])", "reshape([[1, 2], [3, 4]], [1, 4])", "reshape([[1, 2], [3, 4]], [4])", "reshape([1, 2, 3, 4], [-1, 2])"],
  seealso: ["size", "squeeze", "resize"]
}, TE = {
  name: "resize",
  category: "Matrix",
  syntax: ["resize(x, size)", "resize(x, size, defaultValue)"],
  description: "Resize a matrix.",
  examples: ["resize([1,2,3,4,5], [3])", "resize([1,2,3], [5])", "resize([1,2,3], [5], -1)", "resize(2, [2, 3])", 'resize("hello", [8], "!")'],
  seealso: ["size", "subset", "squeeze", "reshape"]
}, FE = {
  name: "rotate",
  category: "Matrix",
  syntax: ["rotate(w, theta)", "rotate(w, theta, v)"],
  description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.",
  examples: ["rotate([1, 0], pi / 2)", 'rotate(matrix([1, 0]), unit("35deg"))', 'rotate([1, 0, 0], unit("90deg"), [0, 0, 1])', 'rotate(matrix([1, 0, 0]), unit("90deg"), matrix([0, 0, 1]))'],
  seealso: ["matrix", "rotationMatrix"]
}, BE = {
  name: "rotationMatrix",
  category: "Matrix",
  syntax: ["rotationMatrix(theta)", "rotationMatrix(theta, v)", "rotationMatrix(theta, v, format)"],
  description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.",
  examples: ["rotationMatrix(pi / 2)", 'rotationMatrix(unit("45deg"), [0, 0, 1])', 'rotationMatrix(1, matrix([0, 0, 1]), "sparse")'],
  seealso: ["cos", "sin"]
}, OE = {
  name: "row",
  category: "Matrix",
  syntax: ["row(x, index)"],
  description: "Return a row from a matrix or array.",
  examples: ["A = [[1, 2], [3, 4]]", "row(A, 1)", "row(A, 2)"],
  seealso: ["column", "matrixFromRows"]
}, IE = {
  name: "size",
  category: "Matrix",
  syntax: ["size(x)"],
  description: "Calculate the size of a matrix.",
  examples: ["size(2.3)", 'size("hello world")', "a = [1, 2; 3, 4; 5, 6]", "size(a)", "size(1:6)"],
  seealso: ["concat", "count", "det", "diag", "identity", "inv", "ones", "range", "squeeze", "subset", "trace", "transpose", "zeros"]
}, $E = {
  name: "sort",
  category: "Matrix",
  syntax: ["sort(x)", "sort(x, compare)"],
  description: 'Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.',
  examples: ["sort([5, 10, 1])", 'sort(["C", "B", "A", "D"], "natural")', "sortByLength(a, b) = size(a)[1] - size(b)[1]", 'sort(["Langdon", "Tom", "Sara"], sortByLength)', 'sort(["10", "1", "2"], "natural")'],
  seealso: ["map", "filter", "forEach"]
}, zE = {
  name: "squeeze",
  category: "Matrix",
  syntax: ["squeeze(x)"],
  description: "Remove inner and outer singleton dimensions from a matrix.",
  examples: ["a = zeros(3,2,1)", "size(squeeze(a))", "b = zeros(1,1,3)", "size(squeeze(b))"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "subset", "trace", "transpose", "zeros"]
}, RE = {
  name: "subset",
  category: "Matrix",
  syntax: ["value(index)", "value(index) = replacement", "subset(value, [index])", "subset(value, [index], replacement)"],
  description: "Get or set a subset of the entries of a matrix or characters of a string. Indexes are one-based. There should be one index specification for each dimension of the target. Each specification can be a single index, a list of indices, or a range in colon notation `l:u`. In a range, both the lower bound l and upper bound u are included; and if a bound is omitted it defaults to the most extreme valid value. The cartesian product of the indices specified in each dimension determines the target of the operation.",
  examples: ["d = [1, 2; 3, 4]", "e = []", "e[1, 1:2] = [5, 6]", "e[2, :] = [7, 8]", "f = d * e", "f[2, 1]", "f[:, 1]", "f[[1,2], [1,3]] = [9, 10; 11, 12]", "f"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "trace", "transpose", "zeros"]
}, qE = {
  name: "trace",
  category: "Matrix",
  syntax: ["trace(A)"],
  description: "Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.",
  examples: ["A = [1, 2, 3; -1, 2, 3; 2, 0, 3]", "trace(A)"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "transpose", "zeros"]
}, PE = {
  name: "transpose",
  category: "Matrix",
  syntax: ["x'", "transpose(x)"],
  description: "Transpose a matrix",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "a'", "transpose(a)"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "zeros"]
}, UE = {
  name: "zeros",
  category: "Matrix",
  syntax: ["zeros(m)", "zeros(m, n)", "zeros(m, n, p, ...)", "zeros([m])", "zeros([m, n])", "zeros([m, n, p, ...])"],
  description: "Create a matrix containing zeros.",
  examples: ["zeros(3)", "zeros(3, 5)", "a = [1, 2, 3; 4, 5, 6]", "zeros(size(a))"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose"]
}, LE = {
  name: "fft",
  category: "Matrix",
  syntax: ["fft(x)"],
  description: "Calculate N-dimensional Fourier transform",
  examples: ["fft([[1, 0], [1, 0]])"],
  seealso: ["ifft"]
}, kE = {
  name: "ifft",
  category: "Matrix",
  syntax: ["ifft(x)"],
  description: "Calculate N-dimensional inverse Fourier transform",
  examples: ["ifft([[2, 2], [0, 0]])"],
  seealso: ["fft"]
}, HE = {
  name: "combinations",
  category: "Probability",
  syntax: ["combinations(n, k)"],
  description: "Compute the number of combinations of n items taken k at a time",
  examples: ["combinations(7, 5)"],
  seealso: ["combinationsWithRep", "permutations", "factorial"]
}, WE = {
  name: "combinationsWithRep",
  category: "Probability",
  syntax: ["combinationsWithRep(n, k)"],
  description: "Compute the number of combinations of n items taken k at a time with replacements.",
  examples: ["combinationsWithRep(7, 5)"],
  seealso: ["combinations", "permutations", "factorial"]
}, GE = {
  name: "factorial",
  category: "Probability",
  syntax: ["n!", "factorial(n)"],
  description: "Compute the factorial of a value",
  examples: ["5!", "5 * 4 * 3 * 2 * 1", "3!"],
  seealso: ["combinations", "combinationsWithRep", "permutations", "gamma"]
}, VE = {
  name: "gamma",
  category: "Probability",
  syntax: ["gamma(n)"],
  description: "Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.",
  examples: ["gamma(4)", "3!", "gamma(1/2)", "sqrt(pi)"],
  seealso: ["factorial"]
}, ZE = {
  name: "lgamma",
  category: "Probability",
  syntax: ["lgamma(n)"],
  description: "Logarithm of the gamma function for real, positive numbers and complex numbers, using Lanczos approximation for numbers and Stirling series for complex numbers.",
  examples: ["lgamma(4)", "lgamma(1/2)", "lgamma(i)", "lgamma(complex(1.1, 2))"],
  seealso: ["gamma"]
}, XE = {
  name: "kldivergence",
  category: "Probability",
  syntax: ["kldivergence(x, y)"],
  description: "Calculate the Kullback-Leibler (KL) divergence  between two distributions.",
  examples: ["kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])"],
  seealso: []
}, YE = {
  name: "multinomial",
  category: "Probability",
  syntax: ["multinomial(A)"],
  description: "Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.",
  examples: ["multinomial([1, 2, 1])"],
  seealso: ["combinations", "factorial"]
}, JE = {
  name: "permutations",
  category: "Probability",
  syntax: ["permutations(n)", "permutations(n, k)"],
  description: "Compute the number of permutations of n items taken k at a time",
  examples: ["permutations(5)", "permutations(5, 3)"],
  seealso: ["combinations", "combinationsWithRep", "factorial"]
}, QE = {
  name: "pickRandom",
  category: "Probability",
  syntax: ["pickRandom(array)", "pickRandom(array, number)", "pickRandom(array, weights)", "pickRandom(array, number, weights)", "pickRandom(array, weights, number)"],
  description: "Pick a random entry from a given array.",
  examples: ["pickRandom(0:10)", "pickRandom([1, 3, 1, 6])", "pickRandom([1, 3, 1, 6], 2)", "pickRandom([1, 3, 1, 6], [2, 3, 2, 1])", "pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])", "pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)"],
  seealso: ["random", "randomInt"]
}, jE = {
  name: "random",
  category: "Probability",
  syntax: ["random()", "random(max)", "random(min, max)", "random(size)", "random(size, max)", "random(size, min, max)"],
  description: "Return a random number.",
  examples: ["random()", "random(10, 20)", "random([2, 3])"],
  seealso: ["pickRandom", "randomInt"]
}, KE = {
  name: "randomInt",
  category: "Probability",
  syntax: ["randomInt(max)", "randomInt(min, max)", "randomInt(size)", "randomInt(size, max)", "randomInt(size, min, max)"],
  description: "Return a random integer number",
  examples: ["randomInt(10, 20)", "randomInt([2, 3], 10)"],
  seealso: ["pickRandom", "random"]
}, eM = {
  name: "compare",
  category: "Relational",
  syntax: ["compare(x, y)"],
  description: "Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
  examples: ["compare(2, 3)", "compare(3, 2)", "compare(2, 2)", "compare(5cm, 40mm)", "compare(2, [1, 2, 3])"],
  seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compareNatural", "compareText"]
}, rM = {
  name: "compareNatural",
  category: "Relational",
  syntax: ["compareNatural(x, y)"],
  description: "Compare two values of any type in a deterministic, natural way. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
  examples: ["compareNatural(2, 3)", "compareNatural(3, 2)", "compareNatural(2, 2)", "compareNatural(5cm, 40mm)", 'compareNatural("2", "10")', "compareNatural(2 + 3i, 2 + 4i)", "compareNatural([1, 2, 4], [1, 2, 3])", "compareNatural([1, 5], [1, 2, 3])", "compareNatural([1, 2], [1, 2])", "compareNatural({a: 2}, {a: 4})"],
  seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compare", "compareText"]
}, tM = {
  name: "compareText",
  category: "Relational",
  syntax: ["compareText(x, y)"],
  description: "Compare two strings lexically. Comparison is case sensitive. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
  examples: ['compareText("B", "A")', 'compareText("A", "B")', 'compareText("A", "A")', 'compareText("2", "10")', 'compare("2", "10")', "compare(2, 10)", 'compareNatural("2", "10")', 'compareText("B", ["A", "B", "C"])'],
  seealso: ["compare", "compareNatural"]
}, nM = {
  name: "deepEqual",
  category: "Relational",
  syntax: ["deepEqual(x, y)"],
  description: "Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.",
  examples: ["deepEqual([1,3,4], [1,3,4])", "deepEqual([1,3,4], [1,3])"],
  seealso: ["equal", "unequal", "smaller", "larger", "smallerEq", "largerEq", "compare"]
}, aM = {
  name: "equal",
  category: "Relational",
  syntax: ["x == y", "equal(x, y)"],
  description: "Check equality of two values. Returns true if the values are equal, and false if not.",
  examples: ["2+2 == 3", "2+2 == 4", "a = 3.2", "b = 6-2.8", "a == b", "50cm == 0.5m"],
  seealso: ["unequal", "smaller", "larger", "smallerEq", "largerEq", "compare", "deepEqual", "equalText"]
}, iM = {
  name: "equalText",
  category: "Relational",
  syntax: ["equalText(x, y)"],
  description: "Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.",
  examples: ['equalText("Hello", "Hello")', 'equalText("a", "A")', 'equal("2e3", "2000")', 'equalText("2e3", "2000")', 'equalText("B", ["A", "B", "C"])'],
  seealso: ["compare", "compareNatural", "compareText", "equal"]
}, oM = {
  name: "larger",
  category: "Relational",
  syntax: ["x > y", "larger(x, y)"],
  description: "Check if value x is larger than y. Returns true if x is larger than y, and false if not. Comparing a value with NaN returns false.",
  examples: ["2 > 3", "5 > 2*2", "a = 3.3", "b = 6-2.8", "(a > b)", "(b < a)", "5 cm > 2 inch"],
  seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compare"]
}, sM = {
  name: "largerEq",
  category: "Relational",
  syntax: ["x >= y", "largerEq(x, y)"],
  description: "Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.",
  examples: ["2 >= 1+1", "2 > 1+1", "a = 3.2", "b = 6-2.8", "(a >= b)"],
  seealso: ["equal", "unequal", "smallerEq", "smaller", "compare"]
}, uM = {
  name: "smaller",
  category: "Relational",
  syntax: ["x < y", "smaller(x, y)"],
  description: "Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not. Comparing a value with NaN returns false.",
  examples: ["2 < 3", "5 < 2*2", "a = 3.3", "b = 6-2.8", "(a < b)", "5 cm < 2 inch"],
  seealso: ["equal", "unequal", "larger", "smallerEq", "largerEq", "compare"]
}, cM = {
  name: "smallerEq",
  category: "Relational",
  syntax: ["x <= y", "smallerEq(x, y)"],
  description: "Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.",
  examples: ["2 <= 1+1", "2 < 1+1", "a = 3.2", "b = 6-2.8", "(a <= b)"],
  seealso: ["equal", "unequal", "larger", "smaller", "largerEq", "compare"]
}, lM = {
  name: "unequal",
  category: "Relational",
  syntax: ["x != y", "unequal(x, y)"],
  description: "Check unequality of two values. Returns true if the values are unequal, and false if they are equal.",
  examples: ["2+2 != 3", "2+2 != 4", "a = 3.2", "b = 6-2.8", "a != b", "50cm != 0.5m", "5 cm != 2 inch"],
  seealso: ["equal", "smaller", "larger", "smallerEq", "largerEq", "compare", "deepEqual"]
}, fM = {
  name: "setCartesian",
  category: "Set",
  syntax: ["setCartesian(set1, set2)"],
  description: "Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays and the values will be sorted in ascending order before the operation.",
  examples: ["setCartesian([1, 2], [3, 4])"],
  seealso: ["setUnion", "setIntersect", "setDifference", "setPowerset"]
}, mM = {
  name: "setDifference",
  category: "Set",
  syntax: ["setDifference(set1, set2)"],
  description: "Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setDifference([1, 2, 3, 4], [3, 4, 5, 6])", "setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],
  seealso: ["setUnion", "setIntersect", "setSymDifference"]
}, pM = {
  name: "setDistinct",
  category: "Set",
  syntax: ["setDistinct(set)"],
  description: "Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",
  examples: ["setDistinct([1, 1, 1, 2, 2, 3])"],
  seealso: ["setMultiplicity"]
}, dM = {
  name: "setIntersect",
  category: "Set",
  syntax: ["setIntersect(set1, set2)"],
  description: "Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setIntersect([1, 2, 3, 4], [3, 4, 5, 6])", "setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],
  seealso: ["setUnion", "setDifference"]
}, vM = {
  name: "setIsSubset",
  category: "Set",
  syntax: ["setIsSubset(set1, set2)"],
  description: "Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setIsSubset([1, 2], [3, 4, 5, 6])", "setIsSubset([3, 4], [3, 4, 5, 6])"],
  seealso: ["setUnion", "setIntersect", "setDifference"]
}, hM = {
  name: "setMultiplicity",
  category: "Set",
  syntax: ["setMultiplicity(element, set)"],
  description: "Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",
  examples: ["setMultiplicity(1, [1, 2, 2, 4])", "setMultiplicity(2, [1, 2, 2, 4])"],
  seealso: ["setDistinct", "setSize"]
}, gM = {
  name: "setPowerset",
  category: "Set",
  syntax: ["setPowerset(set)"],
  description: "Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.",
  examples: ["setPowerset([1, 2, 3])"],
  seealso: ["setCartesian"]
}, yM = {
  name: "setSize",
  category: "Set",
  syntax: ["setSize(set)", "setSize(set, unique)"],
  description: 'Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.',
  examples: ["setSize([1, 2, 2, 4])", "setSize([1, 2, 2, 4], true)"],
  seealso: ["setUnion", "setIntersect", "setDifference"]
}, bM = {
  name: "setSymDifference",
  category: "Set",
  syntax: ["setSymDifference(set1, set2)"],
  description: "Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])", "setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],
  seealso: ["setUnion", "setIntersect", "setDifference"]
}, xM = {
  name: "setUnion",
  category: "Set",
  syntax: ["setUnion(set1, set2)"],
  description: "Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setUnion([1, 2, 3, 4], [3, 4, 5, 6])", "setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],
  seealso: ["setIntersect", "setDifference"]
}, wM = {
  name: "zpk2tf",
  category: "Signal",
  syntax: ["zpk2tf(z, p, k)"],
  description: "Compute the transfer function of a zero-pole-gain model.",
  examples: ["zpk2tf([1, 2], [-1, -2], 1)", "zpk2tf([1, 2], [-1, -2])", "zpk2tf([1 - 3i, 2 + 2i], [-1, -2])"],
  seealso: []
}, DM = {
  name: "freqz",
  category: "Signal",
  syntax: ["freqz(b, a)", "freqz(b, a, w)"],
  description: "Calculates the frequency response of a filter given its numerator and denominator coefficients.",
  examples: ["freqz([1, 2], [1, 2, 3])", "freqz([1, 2], [1, 2, 3], [0, 1])", "freqz([1, 2], [1, 2, 3], 512)"],
  seealso: []
}, NM = {
  name: "erf",
  category: "Special",
  syntax: ["erf(x)"],
  description: "Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x",
  examples: ["erf(0.2)", "erf(-0.5)", "erf(4)"],
  seealso: []
}, AM = {
  name: "zeta",
  category: "Special",
  syntax: ["zeta(s)"],
  description: "Compute the Riemann Zeta Function using an infinite series and Riemann's Functional Equation for the entire complex plane",
  examples: ["zeta(0.2)", "zeta(-0.5)", "zeta(4)"],
  seealso: []
}, SM = {
  name: "mad",
  category: "Statistics",
  syntax: ["mad(a, b, c, ...)", "mad(A)"],
  description: "Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.",
  examples: ["mad(10, 20, 30)", "mad([1, 2, 3])"],
  seealso: ["mean", "median", "std", "abs"]
}, EM = {
  name: "max",
  category: "Statistics",
  syntax: ["max(a, b, c, ...)", "max(A)", "max(A, dimension)"],
  description: "Compute the maximum value of a list of values. If any NaN values are found, the function yields the last NaN in the input.",
  examples: ["max(2, 3, 4, 1)", "max([2, 3, 4, 1])", "max([2, 5; 4, 3])", "max([2, 5; 4, 3], 1)", "max([2, 5; 4, 3], 2)", "max(2.7, 7.1, -4.5, 2.0, 4.1)", "min(2.7, 7.1, -4.5, 2.0, 4.1)"],
  seealso: ["mean", "median", "min", "prod", "std", "sum", "variance"]
}, MM = {
  name: "mean",
  category: "Statistics",
  syntax: ["mean(a, b, c, ...)", "mean(A)", "mean(A, dimension)"],
  description: "Compute the arithmetic mean of a list of values.",
  examples: ["mean(2, 3, 4, 1)", "mean([2, 3, 4, 1])", "mean([2, 5; 4, 3])", "mean([2, 5; 4, 3], 1)", "mean([2, 5; 4, 3], 2)", "mean([1.0, 2.7, 3.2, 4.0])"],
  seealso: ["max", "median", "min", "prod", "std", "sum", "variance"]
}, CM = {
  name: "median",
  category: "Statistics",
  syntax: ["median(a, b, c, ...)", "median(A)"],
  description: "Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.",
  examples: ["median(5, 2, 7)", "median([3, -1, 5, 7])"],
  seealso: ["max", "mean", "min", "prod", "std", "sum", "variance", "quantileSeq"]
}, _M = {
  name: "min",
  category: "Statistics",
  syntax: ["min(a, b, c, ...)", "min(A)", "min(A, dimension)"],
  description: "Compute the minimum value of a list of values. If any NaN values are found, the function yields the last NaN in the input.",
  examples: ["min(2, 3, 4, 1)", "min([2, 3, 4, 1])", "min([2, 5; 4, 3])", "min([2, 5; 4, 3], 1)", "min([2, 5; 4, 3], 2)", "min(2.7, 7.1, -4.5, 2.0, 4.1)", "max(2.7, 7.1, -4.5, 2.0, 4.1)"],
  seealso: ["max", "mean", "median", "prod", "std", "sum", "variance"]
}, TM = {
  name: "mode",
  category: "Statistics",
  syntax: ["mode(a, b, c, ...)", "mode(A)", "mode(A, a, b, B, c, ...)"],
  description: "Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.",
  examples: ["mode(2, 1, 4, 3, 1)", "mode([1, 2.7, 3.2, 4, 2.7])", "mode(1, 4, 6, 1, 6)"],
  seealso: ["max", "mean", "min", "median", "prod", "std", "sum", "variance"]
}, FM = {
  name: "prod",
  category: "Statistics",
  syntax: ["prod(a, b, c, ...)", "prod(A)"],
  description: "Compute the product of all values.",
  examples: ["prod(2, 3, 4)", "prod([2, 3, 4])", "prod([2, 5; 4, 3])"],
  seealso: ["max", "mean", "min", "median", "min", "std", "sum", "variance"]
}, BM = {
  name: "quantileSeq",
  category: "Statistics",
  syntax: ["quantileSeq(A, prob[, sorted])", "quantileSeq(A, [prob1, prob2, ...][, sorted])", "quantileSeq(A, N[, sorted])"],
  description: `Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probability are: Number, BigNumber. 

In case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.`,
  examples: ["quantileSeq([3, -1, 5, 7], 0.5)", "quantileSeq([3, -1, 5, 7], [1/3, 2/3])", "quantileSeq([3, -1, 5, 7], 2)", "quantileSeq([-1, 3, 5, 7], 0.5, true)"],
  seealso: ["mean", "median", "min", "max", "prod", "std", "sum", "variance"]
}, OM = {
  name: "std",
  category: "Statistics",
  syntax: ["std(a, b, c, ...)", "std(A)", "std(A, dimension)", "std(A, normalization)", "std(A, dimension, normalization)"],
  description: 'Compute the standard deviation of all values, defined as std(A) = sqrt(variance(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
  examples: ["std(2, 4, 6)", "std([2, 4, 6, 8])", 'std([2, 4, 6, 8], "uncorrected")', 'std([2, 4, 6, 8], "biased")', "std([1, 2, 3; 4, 5, 6])"],
  seealso: ["max", "mean", "min", "median", "prod", "sum", "variance"]
}, IM = {
  name: "cumsum",
  category: "Statistics",
  syntax: ["cumsum(a, b, c, ...)", "cumsum(A)"],
  description: "Compute the cumulative sum of all values.",
  examples: ["cumsum(2, 3, 4, 1)", "cumsum([2, 3, 4, 1])", "cumsum([1, 2; 3, 4])", "cumsum([1, 2; 3, 4], 1)", "cumsum([1, 2; 3, 4], 2)"],
  seealso: ["max", "mean", "median", "min", "prod", "std", "sum", "variance"]
}, $M = {
  name: "sum",
  category: "Statistics",
  syntax: ["sum(a, b, c, ...)", "sum(A)", "sum(A, dimension)"],
  description: "Compute the sum of all values.",
  examples: ["sum(2, 3, 4, 1)", "sum([2, 3, 4, 1])", "sum([2, 5; 4, 3])"],
  seealso: ["max", "mean", "median", "min", "prod", "std", "variance"]
}, zM = {
  name: "variance",
  category: "Statistics",
  syntax: ["variance(a, b, c, ...)", "variance(A)", "variance(A, dimension)", "variance(A, normalization)", "variance(A, dimension, normalization)"],
  description: 'Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
  examples: ["variance(2, 4, 6)", "variance([2, 4, 6, 8])", 'variance([2, 4, 6, 8], "uncorrected")', 'variance([2, 4, 6, 8], "biased")', "variance([1, 2, 3; 4, 5, 6])"],
  seealso: ["max", "mean", "min", "median", "min", "prod", "std", "sum"]
}, RM = {
  name: "corr",
  category: "Statistics",
  syntax: ["corr(A,B)"],
  description: "Compute the correlation coefficient of a two list with values, For matrices, the matrix correlation coefficient is calculated.",
  examples: ["corr([2, 4, 6, 8],[1, 2, 3, 6])", "corr(matrix([[1, 2.2, 3, 4.8, 5], [1, 2, 3, 4, 5]]), matrix([[4, 5.3, 6.6, 7, 8], [1, 2, 3, 4, 5]]))"],
  seealso: ["max", "mean", "min", "median", "min", "prod", "std", "sum"]
}, qM = {
  name: "acos",
  category: "Trigonometry",
  syntax: ["acos(x)"],
  description: "Compute the inverse cosine of a value in radians.",
  examples: ["acos(0.5)", "acos(cos(2.3))"],
  seealso: ["cos", "atan", "asin"]
}, PM = {
  name: "acosh",
  category: "Trigonometry",
  syntax: ["acosh(x)"],
  description: "Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.",
  examples: ["acosh(1.5)"],
  seealso: ["cosh", "asinh", "atanh"]
}, UM = {
  name: "acot",
  category: "Trigonometry",
  syntax: ["acot(x)"],
  description: "Calculate the inverse cotangent of a value.",
  examples: ["acot(0.5)", "acot(cot(0.5))", "acot(2)"],
  seealso: ["cot", "atan"]
}, LM = {
  name: "acoth",
  category: "Trigonometry",
  syntax: ["acoth(x)"],
  description: "Calculate the inverse hyperbolic tangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.",
  examples: ["acoth(2)", "acoth(0.5)"],
  seealso: ["acsch", "asech"]
}, kM = {
  name: "acsc",
  category: "Trigonometry",
  syntax: ["acsc(x)"],
  description: "Calculate the inverse cotangent of a value.",
  examples: ["acsc(2)", "acsc(csc(0.5))", "acsc(0.5)"],
  seealso: ["csc", "asin", "asec"]
}, HM = {
  name: "acsch",
  category: "Trigonometry",
  syntax: ["acsch(x)"],
  description: "Calculate the inverse hyperbolic cosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.",
  examples: ["acsch(0.5)"],
  seealso: ["asech", "acoth"]
}, WM = {
  name: "asec",
  category: "Trigonometry",
  syntax: ["asec(x)"],
  description: "Calculate the inverse secant of a value.",
  examples: ["asec(0.5)", "asec(sec(0.5))", "asec(2)"],
  seealso: ["acos", "acot", "acsc"]
}, GM = {
  name: "asech",
  category: "Trigonometry",
  syntax: ["asech(x)"],
  description: "Calculate the inverse secant of a value.",
  examples: ["asech(0.5)"],
  seealso: ["acsch", "acoth"]
}, VM = {
  name: "asin",
  category: "Trigonometry",
  syntax: ["asin(x)"],
  description: "Compute the inverse sine of a value in radians.",
  examples: ["asin(0.5)", "asin(sin(0.5))"],
  seealso: ["sin", "acos", "atan"]
}, ZM = {
  name: "asinh",
  category: "Trigonometry",
  syntax: ["asinh(x)"],
  description: "Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.",
  examples: ["asinh(0.5)"],
  seealso: ["acosh", "atanh"]
}, XM = {
  name: "atan",
  category: "Trigonometry",
  syntax: ["atan(x)"],
  description: "Compute the inverse tangent of a value in radians.",
  examples: ["atan(0.5)", "atan(tan(0.5))"],
  seealso: ["tan", "acos", "asin"]
}, YM = {
  name: "atan2",
  category: "Trigonometry",
  syntax: ["atan2(y, x)"],
  description: "Computes the principal value of the arc tangent of y/x in radians.",
  examples: ["atan2(2, 2) / pi", "angle = 60 deg in rad", "x = cos(angle)", "y = sin(angle)", "atan2(y, x)"],
  seealso: ["sin", "cos", "tan"]
}, JM = {
  name: "atanh",
  category: "Trigonometry",
  syntax: ["atanh(x)"],
  description: "Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.",
  examples: ["atanh(0.5)"],
  seealso: ["acosh", "asinh"]
}, QM = {
  name: "cos",
  category: "Trigonometry",
  syntax: ["cos(x)"],
  description: "Compute the cosine of x in radians.",
  examples: ["cos(2)", "cos(pi / 4) ^ 2", "cos(180 deg)", "cos(60 deg)", "sin(0.2)^2 + cos(0.2)^2"],
  seealso: ["acos", "sin", "tan"]
}, jM = {
  name: "cosh",
  category: "Trigonometry",
  syntax: ["cosh(x)"],
  description: "Compute the hyperbolic cosine of x in radians.",
  examples: ["cosh(0.5)"],
  seealso: ["sinh", "tanh", "coth"]
}, KM = {
  name: "cot",
  category: "Trigonometry",
  syntax: ["cot(x)"],
  description: "Compute the cotangent of x in radians. Defined as 1/tan(x)",
  examples: ["cot(2)", "1 / tan(2)"],
  seealso: ["sec", "csc", "tan"]
}, eC = {
  name: "coth",
  category: "Trigonometry",
  syntax: ["coth(x)"],
  description: "Compute the hyperbolic cotangent of x in radians.",
  examples: ["coth(2)", "1 / tanh(2)"],
  seealso: ["sech", "csch", "tanh"]
}, rC = {
  name: "csc",
  category: "Trigonometry",
  syntax: ["csc(x)"],
  description: "Compute the cosecant of x in radians. Defined as 1/sin(x)",
  examples: ["csc(2)", "1 / sin(2)"],
  seealso: ["sec", "cot", "sin"]
}, tC = {
  name: "csch",
  category: "Trigonometry",
  syntax: ["csch(x)"],
  description: "Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)",
  examples: ["csch(2)", "1 / sinh(2)"],
  seealso: ["sech", "coth", "sinh"]
}, nC = {
  name: "sec",
  category: "Trigonometry",
  syntax: ["sec(x)"],
  description: "Compute the secant of x in radians. Defined as 1/cos(x)",
  examples: ["sec(2)", "1 / cos(2)"],
  seealso: ["cot", "csc", "cos"]
}, aC = {
  name: "sech",
  category: "Trigonometry",
  syntax: ["sech(x)"],
  description: "Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)",
  examples: ["sech(2)", "1 / cosh(2)"],
  seealso: ["coth", "csch", "cosh"]
}, iC = {
  name: "sin",
  category: "Trigonometry",
  syntax: ["sin(x)"],
  description: "Compute the sine of x in radians.",
  examples: ["sin(2)", "sin(pi / 4) ^ 2", "sin(90 deg)", "sin(30 deg)", "sin(0.2)^2 + cos(0.2)^2"],
  seealso: ["asin", "cos", "tan"]
}, oC = {
  name: "sinh",
  category: "Trigonometry",
  syntax: ["sinh(x)"],
  description: "Compute the hyperbolic sine of x in radians.",
  examples: ["sinh(0.5)"],
  seealso: ["cosh", "tanh"]
}, sC = {
  name: "tan",
  category: "Trigonometry",
  syntax: ["tan(x)"],
  description: "Compute the tangent of x in radians.",
  examples: ["tan(0.5)", "sin(0.5) / cos(0.5)", "tan(pi / 4)", "tan(45 deg)"],
  seealso: ["atan", "sin", "cos"]
}, uC = {
  name: "tanh",
  category: "Trigonometry",
  syntax: ["tanh(x)"],
  description: "Compute the hyperbolic tangent of x in radians.",
  examples: ["tanh(0.5)", "sinh(0.5) / cosh(0.5)"],
  seealso: ["sinh", "cosh"]
}, cC = {
  name: "to",
  category: "Units",
  syntax: ["x to unit", "to(x, unit)"],
  description: "Change the unit of a value.",
  examples: ["5 inch to cm", "3.2kg to g", "16 bytes in bits"],
  seealso: []
}, lC = {
  name: "toBest",
  category: "Units",
  syntax: ["toBest(x)", "toBest(x, unitList)", "toBest(x, unitList, options)"],
  description: "Converts to the most appropriate display unit.",
  examples: ['toBest(unit(5000, "m"))', 'toBest(unit(3500000, "W"))', 'toBest(unit(0.000000123, "A"))', 'toBest(unit(10, "m"), "cm")', 'toBest(unit(10, "m"), "mm,km", {offset: 1.5})'],
  seealso: []
}, fC = {
  name: "bin",
  category: "Utils",
  syntax: ["bin(value)"],
  description: "Format a number as binary",
  examples: ["bin(2)"],
  seealso: ["oct", "hex"]
}, mC = {
  name: "clone",
  category: "Utils",
  syntax: ["clone(x)"],
  description: "Clone a variable. Creates a copy of primitive variables, and a deep copy of matrices",
  examples: ["clone(3.5)", "clone(2 - 4i)", "clone(45 deg)", "clone([1, 2; 3, 4])", 'clone("hello world")'],
  seealso: []
}, pC = {
  name: "format",
  category: "Utils",
  syntax: ["format(value)", "format(value, precision)"],
  description: "Format a value of any type as string.",
  examples: ["format(2.3)", "format(3 - 4i)", "format([])", "format(pi, 3)"],
  seealso: ["print"]
}, dC = {
  name: "hasNumericValue",
  category: "Utils",
  syntax: ["hasNumericValue(x)"],
  description: "Test whether a value is an numeric value. In case of a string, true is returned if the string contains a numeric value.",
  examples: ["hasNumericValue(2)", 'hasNumericValue("2")', 'isNumeric("2")', "hasNumericValue(0)", "hasNumericValue(bignumber(500))", "hasNumericValue(fraction(0.125))", "hasNumericValue(2 + 3i)", 'hasNumericValue([2.3, "foo", false])'],
  seealso: ["isInteger", "isZero", "isNegative", "isPositive", "isNaN", "isNumeric"]
}, vC = {
  name: "hex",
  category: "Utils",
  syntax: ["hex(value)"],
  description: "Format a number as hexadecimal",
  examples: ["hex(240)"],
  seealso: ["bin", "oct"]
}, hC = {
  name: "isInteger",
  category: "Utils",
  syntax: ["isInteger(x)"],
  description: "Test whether a value is an integer number.",
  examples: ["isInteger(2)", "isInteger(3.5)", "isInteger([3, 0.5, -2])"],
  seealso: ["isNegative", "isNumeric", "isPositive", "isZero"]
}, gC = {
  name: "isNaN",
  category: "Utils",
  syntax: ["isNaN(x)"],
  description: "Test whether a value is NaN (not a number)",
  examples: ["isNaN(2)", "isNaN(0 / 0)", "isNaN(NaN)", "isNaN(Infinity)"],
  seealso: ["isNegative", "isNumeric", "isPositive", "isZero"]
}, yC = {
  name: "isNegative",
  category: "Utils",
  syntax: ["isNegative(x)"],
  description: "Test whether a value is negative: smaller than zero.",
  examples: ["isNegative(2)", "isNegative(0)", "isNegative(-4)", "isNegative([3, 0.5, -2])"],
  seealso: ["isInteger", "isNumeric", "isPositive", "isZero"]
}, bC = {
  name: "isNumeric",
  category: "Utils",
  syntax: ["isNumeric(x)"],
  description: "Test whether a value is a numeric value. Returns true when the input is a number, BigNumber, Fraction, or boolean.",
  examples: ["isNumeric(2)", 'isNumeric("2")', 'hasNumericValue("2")', "isNumeric(0)", "isNumeric(bignumber(500))", "isNumeric(fraction(0.125))", "isNumeric(2 + 3i)", 'isNumeric([2.3, "foo", false])'],
  seealso: ["isInteger", "isZero", "isNegative", "isPositive", "isNaN", "hasNumericValue"]
}, xC = {
  name: "isPositive",
  category: "Utils",
  syntax: ["isPositive(x)"],
  description: "Test whether a value is positive: larger than zero.",
  examples: ["isPositive(2)", "isPositive(0)", "isPositive(-4)", "isPositive([3, 0.5, -2])"],
  seealso: ["isInteger", "isNumeric", "isNegative", "isZero"]
}, wC = {
  name: "isPrime",
  category: "Utils",
  syntax: ["isPrime(x)"],
  description: "Test whether a value is prime: has no divisors other than itself and one.",
  examples: ["isPrime(3)", "isPrime(-2)", "isPrime([2, 17, 100])"],
  seealso: ["isInteger", "isNumeric", "isNegative", "isZero"]
}, DC = {
  name: "isZero",
  category: "Utils",
  syntax: ["isZero(x)"],
  description: "Test whether a value is zero.",
  examples: ["isZero(2)", "isZero(0)", "isZero(-4)", "isZero([3, 0, -2, 0])"],
  seealso: ["isInteger", "isNumeric", "isNegative", "isPositive"]
}, NC = {
  name: "numeric",
  category: "Utils",
  syntax: ["numeric(x)"],
  description: "Convert a numeric input to a specific numeric type: number, BigNumber, bigint, or Fraction.",
  examples: ['numeric("4")', 'numeric("4", "number")', 'numeric("4", "bigint")', 'numeric("4", "BigNumber")', 'numeric("4", "Fraction")', 'numeric(4, "Fraction")', 'numeric(fraction(2, 5), "number")'],
  seealso: ["number", "bigint", "fraction", "bignumber", "string", "format"]
}, AC = {
  name: "oct",
  category: "Utils",
  syntax: ["oct(value)"],
  description: "Format a number as octal",
  examples: ["oct(56)"],
  seealso: ["bin", "hex"]
}, SC = {
  name: "print",
  category: "Utils",
  syntax: ["print(template, values)", "print(template, values, precision)"],
  description: "Interpolate values into a string template.",
  examples: ['print("Lucy is $age years old", {age: 5})', 'print("The value of pi is $pi", {pi: pi}, 3)', 'print("Hello, $user.name!", {user: {name: "John"}})', 'print("Values: $1, $2, $3", [6, 9, 4])'],
  seealso: ["format"]
}, EC = {
  name: "typeOf",
  category: "Utils",
  syntax: ["typeOf(x)"],
  description: "Get the type of a variable.",
  examples: ["typeOf(3.5)", "typeOf(2 - 4i)", "typeOf(45 deg)", 'typeOf("hello world")'],
  seealso: ["getMatrixDataType"]
}, MC = {
  name: "solveODE",
  category: "Numeric",
  syntax: ["solveODE(func, tspan, y0)", "solveODE(func, tspan, y0, options)"],
  description: "Numerical Integration of Ordinary Differential Equations.",
  examples: ["f(t,y) = y", "tspan = [0, 4]", "solveODE(f, tspan, 1)", "solveODE(f, tspan, [1, 2])", 'solveODE(f, tspan, 1, { method:"RK23", maxStep:0.1 })'],
  seealso: ["derivative", "simplifyCore"]
}, CC = {
  // construction functions
  bignumber: fA,
  bigint: mA,
  boolean: pA,
  complex: dA,
  createUnit: vA,
  fraction: hA,
  index: gA,
  matrix: yA,
  number: bA,
  sparse: xA,
  splitUnit: wA,
  string: DA,
  unit: NA,
  // constants
  e: sl,
  E: sl,
  false: JN,
  i: QN,
  Infinity: jN,
  LN2: eA,
  LN10: KN,
  LOG2E: tA,
  LOG10E: rA,
  NaN: nA,
  null: aA,
  pi: ul,
  PI: ul,
  phi: iA,
  SQRT1_2: oA,
  SQRT2: sA,
  tau: uA,
  true: cA,
  version: lA,
  // physical constants
  // TODO: more detailed docs for physical constants
  speedOfLight: {
    description: "Speed of light in vacuum",
    examples: ["speedOfLight"]
  },
  gravitationConstant: {
    description: "Newtonian constant of gravitation",
    examples: ["gravitationConstant"]
  },
  planckConstant: {
    description: "Planck constant",
    examples: ["planckConstant"]
  },
  reducedPlanckConstant: {
    description: "Reduced Planck constant",
    examples: ["reducedPlanckConstant"]
  },
  magneticConstant: {
    description: "Magnetic constant (vacuum permeability)",
    examples: ["magneticConstant"]
  },
  electricConstant: {
    description: "Electric constant (vacuum permeability)",
    examples: ["electricConstant"]
  },
  vacuumImpedance: {
    description: "Characteristic impedance of vacuum",
    examples: ["vacuumImpedance"]
  },
  coulomb: {
    description: "Coulomb's constant. Deprecated in favor of coulombConstant",
    examples: ["coulombConstant"]
  },
  coulombConstant: {
    description: "Coulomb's constant",
    examples: ["coulombConstant"]
  },
  elementaryCharge: {
    description: "Elementary charge",
    examples: ["elementaryCharge"]
  },
  bohrMagneton: {
    description: "Bohr magneton",
    examples: ["bohrMagneton"]
  },
  conductanceQuantum: {
    description: "Conductance quantum",
    examples: ["conductanceQuantum"]
  },
  inverseConductanceQuantum: {
    description: "Inverse conductance quantum",
    examples: ["inverseConductanceQuantum"]
  },
  // josephson: {description: 'Josephson constant', examples: ['josephson']},
  magneticFluxQuantum: {
    description: "Magnetic flux quantum",
    examples: ["magneticFluxQuantum"]
  },
  nuclearMagneton: {
    description: "Nuclear magneton",
    examples: ["nuclearMagneton"]
  },
  klitzing: {
    description: "Von Klitzing constant",
    examples: ["klitzing"]
  },
  bohrRadius: {
    description: "Bohr radius",
    examples: ["bohrRadius"]
  },
  classicalElectronRadius: {
    description: "Classical electron radius",
    examples: ["classicalElectronRadius"]
  },
  electronMass: {
    description: "Electron mass",
    examples: ["electronMass"]
  },
  fermiCoupling: {
    description: "Fermi coupling constant",
    examples: ["fermiCoupling"]
  },
  fineStructure: {
    description: "Fine-structure constant",
    examples: ["fineStructure"]
  },
  hartreeEnergy: {
    description: "Hartree energy",
    examples: ["hartreeEnergy"]
  },
  protonMass: {
    description: "Proton mass",
    examples: ["protonMass"]
  },
  deuteronMass: {
    description: "Deuteron Mass",
    examples: ["deuteronMass"]
  },
  neutronMass: {
    description: "Neutron mass",
    examples: ["neutronMass"]
  },
  quantumOfCirculation: {
    description: "Quantum of circulation",
    examples: ["quantumOfCirculation"]
  },
  rydberg: {
    description: "Rydberg constant",
    examples: ["rydberg"]
  },
  thomsonCrossSection: {
    description: "Thomson cross section",
    examples: ["thomsonCrossSection"]
  },
  weakMixingAngle: {
    description: "Weak mixing angle",
    examples: ["weakMixingAngle"]
  },
  efimovFactor: {
    description: "Efimov factor",
    examples: ["efimovFactor"]
  },
  atomicMass: {
    description: "Atomic mass constant",
    examples: ["atomicMass"]
  },
  avogadro: {
    description: "Avogadro's number",
    examples: ["avogadro"]
  },
  boltzmann: {
    description: "Boltzmann constant",
    examples: ["boltzmann"]
  },
  faraday: {
    description: "Faraday constant",
    examples: ["faraday"]
  },
  firstRadiation: {
    description: "First radiation constant",
    examples: ["firstRadiation"]
  },
  loschmidt: {
    description: "Loschmidt constant at T=273.15 K and p=101.325 kPa",
    examples: ["loschmidt"]
  },
  gasConstant: {
    description: "Gas constant",
    examples: ["gasConstant"]
  },
  molarPlanckConstant: {
    description: "Molar Planck constant",
    examples: ["molarPlanckConstant"]
  },
  molarVolume: {
    description: "Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa",
    examples: ["molarVolume"]
  },
  sackurTetrode: {
    description: "Sackur-Tetrode constant at T=1 K and p=101.325 kPa",
    examples: ["sackurTetrode"]
  },
  secondRadiation: {
    description: "Second radiation constant",
    examples: ["secondRadiation"]
  },
  stefanBoltzmann: {
    description: "Stefan-Boltzmann constant",
    examples: ["stefanBoltzmann"]
  },
  wienDisplacement: {
    description: "Wien displacement law constant",
    examples: ["wienDisplacement"]
  },
  // spectralRadiance: {description: 'First radiation constant for spectral radiance', examples: ['spectralRadiance']},
  molarMass: {
    description: "Molar mass constant",
    examples: ["molarMass"]
  },
  molarMassC12: {
    description: "Molar mass constant of carbon-12",
    examples: ["molarMassC12"]
  },
  gravity: {
    description: "Standard acceleration of gravity (standard acceleration of free-fall on Earth)",
    examples: ["gravity"]
  },
  planckLength: {
    description: "Planck length",
    examples: ["planckLength"]
  },
  planckMass: {
    description: "Planck mass",
    examples: ["planckMass"]
  },
  planckTime: {
    description: "Planck time",
    examples: ["planckTime"]
  },
  planckCharge: {
    description: "Planck charge",
    examples: ["planckCharge"]
  },
  planckTemperature: {
    description: "Planck temperature",
    examples: ["planckTemperature"]
  },
  // functions - algebra
  derivative: MA,
  lsolve: _A,
  lsolveAll: TA,
  lup: FA,
  lusolve: BA,
  leafCount: CA,
  polynomialRoot: OA,
  resolve: zA,
  simplify: RA,
  simplifyConstant: qA,
  simplifyCore: PA,
  symbolicEqual: LA,
  rationalize: $A,
  slu: UA,
  usolve: kA,
  usolveAll: HA,
  qr: IA,
  // functions - arithmetic
  abs: WA,
  add: GA,
  cbrt: VA,
  ceil: ZA,
  cube: XA,
  divide: YA,
  dotDivide: JA,
  dotMultiply: QA,
  dotPow: jA,
  exp: KA,
  expm: eS,
  expm1: rS,
  fix: tS,
  floor: nS,
  gcd: aS,
  hypot: iS,
  lcm: sS,
  log: uS,
  log2: fS,
  log1p: lS,
  log10: cS,
  mod: mS,
  multiply: pS,
  norm: dS,
  nthRoot: vS,
  nthRoots: hS,
  pow: gS,
  round: yS,
  sign: bS,
  sqrt: xS,
  sqrtm: wS,
  square: SS,
  subtract: ES,
  unaryMinus: MS,
  unaryPlus: CS,
  xgcd: _S,
  invmod: oS,
  // functions - bitwise
  bitAnd: TS,
  bitNot: FS,
  bitOr: BS,
  bitXor: OS,
  leftShift: IS,
  rightArithShift: $S,
  rightLogShift: zS,
  // functions - combinatorics
  bellNumbers: RS,
  catalan: qS,
  composition: PS,
  stirlingS2: US,
  // functions - core
  config: AA,
  import: SA,
  typed: EA,
  // functions - complex
  arg: LS,
  conj: kS,
  re: WS,
  im: HS,
  // functions - expression
  evaluate: GS,
  help: YS,
  parse: ZS,
  parser: VS,
  compile: XS,
  // functions - geometry
  distance: JS,
  intersect: QS,
  // functions - logical
  and: jS,
  not: KS,
  nullish: eE,
  or: rE,
  xor: tE,
  // functions - matrix
  mapSlices: nE,
  concat: iE,
  count: oE,
  cross: sE,
  column: aE,
  ctranspose: uE,
  det: cE,
  diag: lE,
  diff: fE,
  dot: mE,
  getMatrixDataType: gE,
  identity: yE,
  filter: dE,
  flatten: vE,
  forEach: hE,
  inv: bE,
  pinv: xE,
  eigs: pE,
  kron: wE,
  matrixFromFunction: AE,
  matrixFromRows: SE,
  matrixFromColumns: NE,
  map: DE,
  ones: EE,
  partitionSelect: ME,
  range: CE,
  resize: TE,
  reshape: _E,
  rotate: FE,
  rotationMatrix: BE,
  row: OE,
  size: IE,
  sort: $E,
  squeeze: zE,
  subset: RE,
  trace: qE,
  transpose: PE,
  zeros: UE,
  fft: LE,
  ifft: kE,
  sylvester: DS,
  schur: NS,
  lyap: AS,
  // functions - numeric
  solveODE: MC,
  // functions - probability
  combinations: HE,
  combinationsWithRep: WE,
  // distribution: distributionDocs,
  factorial: GE,
  gamma: VE,
  kldivergence: XE,
  lgamma: ZE,
  multinomial: YE,
  permutations: JE,
  pickRandom: QE,
  random: jE,
  randomInt: KE,
  // functions - relational
  compare: eM,
  compareNatural: rM,
  compareText: tM,
  deepEqual: nM,
  equal: aM,
  equalText: iM,
  larger: oM,
  largerEq: sM,
  smaller: uM,
  smallerEq: cM,
  unequal: lM,
  // functions - set
  setCartesian: fM,
  setDifference: mM,
  setDistinct: pM,
  setIntersect: dM,
  setIsSubset: vM,
  setMultiplicity: hM,
  setPowerset: gM,
  setSize: yM,
  setSymDifference: bM,
  setUnion: xM,
  // functions - signal
  zpk2tf: wM,
  freqz: DM,
  // functions - special
  erf: NM,
  zeta: AM,
  // functions - statistics
  cumsum: IM,
  mad: SM,
  max: EM,
  mean: MM,
  median: CM,
  min: _M,
  mode: TM,
  prod: FM,
  quantileSeq: BM,
  std: OM,
  sum: $M,
  variance: zM,
  corr: RM,
  // functions - trigonometry
  acos: qM,
  acosh: PM,
  acot: UM,
  acoth: LM,
  acsc: kM,
  acsch: HM,
  asec: WM,
  asech: GM,
  asin: VM,
  asinh: ZM,
  atan: XM,
  atanh: JM,
  atan2: YM,
  cos: QM,
  cosh: jM,
  cot: KM,
  coth: eC,
  csc: rC,
  csch: tC,
  sec: nC,
  sech: aC,
  sin: iC,
  sinh: oC,
  tan: sC,
  tanh: uC,
  // functions - units
  to: cC,
  toBest: lC,
  // functions - utils
  clone: mC,
  format: pC,
  bin: fC,
  oct: AC,
  hex: vC,
  isNaN: gC,
  isInteger: hC,
  isNegative: yC,
  isNumeric: bC,
  hasNumericValue: dC,
  isPositive: xC,
  isPrime: wC,
  isZero: DC,
  print: SC,
  typeOf: EC,
  numeric: NC
}, cl = "help", _C = ["typed", "mathWithTransform", "Help"], TC = /* @__PURE__ */ R(cl, _C, (r) => {
  var {
    typed: e,
    mathWithTransform: t,
    Help: n
  } = r;
  return e(cl, {
    any: function(i) {
      var s, l = i;
      if (typeof i != "string") {
        for (s in t)
          if (xe(t, s) && i === t[s]) {
            l = s;
            break;
          }
      }
      var c = Mr(CC, l);
      if (!c) {
        var o = typeof l == "function" ? l.name : l;
        throw new Error('No documentation found on "' + o + '"');
      }
      return new n(c);
    }
  });
}), ll = "chain", FC = ["typed", "Chain"], BC = /* @__PURE__ */ R(ll, FC, (r) => {
  var {
    typed: e,
    Chain: t
  } = r;
  return e(ll, {
    "": function() {
      return new t();
    },
    any: function(a) {
      return new t(a);
    }
  });
}), fl = "det", OC = ["typed", "matrix", "subtractScalar", "multiply", "divideScalar", "isZero", "unaryMinus"], dd = /* @__PURE__ */ R(fl, OC, (r) => {
  var {
    typed: e,
    matrix: t,
    subtractScalar: n,
    multiply: a,
    divideScalar: i,
    isZero: s,
    unaryMinus: l
  } = r;
  return e(fl, {
    any: function(u) {
      return Te(u);
    },
    "Array | Matrix": function(u) {
      var f;
      switch (Ee(u) ? f = u.size() : Array.isArray(u) ? (u = t(u), f = u.size()) : f = [], f.length) {
        case 0:
          return Te(u);
        case 1:
          if (f[0] === 1)
            return Te(u.valueOf()[0]);
          if (f[0] === 0)
            return 1;
          throw new RangeError("Matrix must be square (size: " + ke(f) + ")");
        case 2: {
          var m = f[0], p = f[1];
          if (m === p)
            return c(u.clone().valueOf(), m);
          if (p === 0)
            return 1;
          throw new RangeError("Matrix must be square (size: " + ke(f) + ")");
        }
        default:
          throw new RangeError("Matrix must be two dimensional (size: " + ke(f) + ")");
      }
    }
  });
  function c(o, u, f) {
    if (u === 1)
      return Te(o[0][0]);
    if (u === 2)
      return n(a(o[0][0], o[1][1]), a(o[1][0], o[0][1]));
    for (var m = !1, p = new Array(u).fill(0).map((N, S) => S), d = 0; d < u; d++) {
      var v = p[d];
      if (s(o[v][d])) {
        var x = void 0;
        for (x = d + 1; x < u; x++)
          if (!s(o[p[x]][d])) {
            v = p[x], p[x] = p[d], p[d] = v, m = !m;
            break;
          }
        if (x === u) return o[v][d];
      }
      for (var h = o[v][d], D = d === 0 ? 1 : o[p[d - 1]][d - 1], y = d + 1; y < u; y++)
        for (var w = p[y], b = d + 1; b < u; b++)
          o[w][b] = i(n(a(o[w][b], h), a(o[w][d], o[v][b])), D);
    }
    var g = o[p[u - 1]][u - 1];
    return m ? l(g) : g;
  }
}), ml = "inv", IC = ["typed", "matrix", "divideScalar", "addScalar", "multiply", "unaryMinus", "det", "identity", "abs"], vd = /* @__PURE__ */ R(ml, IC, (r) => {
  var {
    typed: e,
    matrix: t,
    divideScalar: n,
    addScalar: a,
    multiply: i,
    unaryMinus: s,
    det: l,
    identity: c,
    abs: o
  } = r;
  return e(ml, {
    "Array | Matrix": function(m) {
      var p = Ee(m) ? m.size() : Oe(m);
      switch (p.length) {
        case 1:
          if (p[0] === 1)
            return Ee(m) ? t([n(1, m.valueOf()[0])]) : [n(1, m[0])];
          throw new RangeError("Matrix must be square (size: " + ke(p) + ")");
        case 2: {
          var d = p[0], v = p[1];
          if (d === v)
            return Ee(m) ? t(u(m.valueOf(), d, v), m.storage()) : u(m, d, v);
          throw new RangeError("Matrix must be square (size: " + ke(p) + ")");
        }
        default:
          throw new RangeError("Matrix must be two dimensional (size: " + ke(p) + ")");
      }
    },
    any: function(m) {
      return n(1, m);
    }
  });
  function u(f, m, p) {
    var d, v, x, h, D;
    if (m === 1) {
      if (h = f[0][0], h === 0)
        throw Error("Cannot calculate inverse, determinant is zero");
      return [[n(1, h)]];
    } else if (m === 2) {
      var y = l(f);
      if (y === 0)
        throw Error("Cannot calculate inverse, determinant is zero");
      return [[n(f[1][1], y), n(s(f[0][1]), y)], [n(s(f[1][0]), y), n(f[0][0], y)]];
    } else {
      var w = f.concat();
      for (d = 0; d < m; d++)
        w[d] = w[d].concat();
      for (var b = c(m).valueOf(), g = 0; g < p; g++) {
        var N = o(w[g][g]), S = g;
        for (d = g + 1; d < m; )
          o(w[d][g]) > N && (N = o(w[d][g]), S = d), d++;
        if (N === 0)
          throw Error("Cannot calculate inverse, determinant is zero");
        d = S, d !== g && (D = w[g], w[g] = w[d], w[d] = D, D = b[g], b[g] = b[d], b[d] = D);
        var A = w[g], E = b[g];
        for (d = 0; d < m; d++) {
          var M = w[d], T = b[d];
          if (d !== g) {
            if (M[g] !== 0) {
              for (x = n(s(M[g]), A[g]), v = g; v < p; v++)
                M[v] = a(M[v], i(x, A[v]));
              for (v = 0; v < p; v++)
                T[v] = a(T[v], i(x, E[v]));
            }
          } else {
            for (x = A[g], v = g; v < p; v++)
              M[v] = n(M[v], x);
            for (v = 0; v < p; v++)
              T[v] = n(T[v], x);
          }
        }
      }
      return b;
    }
  }
}), pl = "pinv", $C = ["typed", "matrix", "inv", "deepEqual", "equal", "dotDivide", "dot", "ctranspose", "divideScalar", "multiply", "add", "Complex"], zC = /* @__PURE__ */ R(pl, $C, (r) => {
  var {
    typed: e,
    matrix: t,
    inv: n,
    deepEqual: a,
    equal: i,
    dotDivide: s,
    dot: l,
    ctranspose: c,
    divideScalar: o,
    multiply: u,
    add: f,
    Complex: m
  } = r;
  return e(pl, {
    "Array | Matrix": function(y) {
      var w = Ee(y) ? y.size() : Oe(y);
      switch (w.length) {
        case 1:
          return h(y) ? c(y) : w[0] === 1 ? n(y) : s(c(y), l(y, y));
        case 2: {
          if (h(y)) return c(y);
          var b = w[0], g = w[1];
          if (b === g)
            try {
              return n(y);
            } catch (N) {
              if (!(N instanceof Error && N.message.match(/Cannot calculate inverse, determinant is zero/))) throw N;
            }
          return Ee(y) ? t(p(y.valueOf(), b, g), y.storage()) : p(y, b, g);
        }
        default:
          throw new RangeError("Matrix must be two dimensional (size: " + ke(w) + ")");
      }
    },
    any: function(y) {
      return i(y, 0) ? Te(y) : o(1, y);
    }
  });
  function p(D, y, w) {
    var {
      C: b,
      F: g
    } = v(D, y, w), N = u(n(u(c(b), b)), c(b)), S = u(c(g), n(u(g, c(g))));
    return u(S, N);
  }
  function d(D, y, w) {
    for (var b = Te(D), g = 0, N = 0; N < y; N++) {
      if (w <= g)
        return b;
      for (var S = N; x(b[S][g]); )
        if (S++, y === S && (S = N, g++, w === g))
          return b;
      [b[S], b[N]] = [b[N], b[S]];
      for (var A = b[N][g], E = 0; E < w; E++)
        b[N][E] = s(b[N][E], A);
      for (var M = 0; M < y; M++)
        if (M !== N) {
          A = b[M][g];
          for (var T = 0; T < w; T++)
            b[M][T] = f(b[M][T], u(-1, u(A, b[N][T])));
        }
      g++;
    }
    return b;
  }
  function v(D, y, w) {
    var b = d(D, y, w), g = D.map((S, A) => S.filter((E, M) => M < y && !x(l(b[M], b[M])))), N = b.filter((S, A) => !x(l(b[A], b[A])));
    return {
      C: g,
      F: N
    };
  }
  function x(D) {
    return i(f(D, m(1, 1)), f(0, m(1, 1)));
  }
  function h(D) {
    return a(f(D, m(1, 1)), f(u(D, 0), m(1, 1)));
  }
});
function RC(r) {
  var {
    addScalar: e,
    subtract: t,
    flatten: n,
    multiply: a,
    multiplyScalar: i,
    divideScalar: s,
    sqrt: l,
    abs: c,
    bignumber: o,
    diag: u,
    size: f,
    reshape: m,
    inv: p,
    qr: d,
    usolve: v,
    usolveAll: x,
    equal: h,
    complex: D,
    larger: y,
    smaller: w,
    matrixFromColumns: b,
    dot: g
  } = r;
  function N(F, G, z, le) {
    var ne = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, ae = S(F, G, z, le, ne);
    A(F, G, z, le, ne, ae);
    var {
      values: q,
      C: k
    } = E(F, G, z, le, ne);
    if (ne) {
      var Z = M(F, G, k, ae, q, z, le);
      return {
        values: q,
        eigenvectors: Z
      };
    }
    return {
      values: q
    };
  }
  function S(F, G, z, le, ne) {
    var ae = le === "BigNumber", q = le === "Complex", k = ae ? o(0) : 0, Z = ae ? o(1) : q ? D(1) : 1, Q = ae ? o(1) : 1, j = ae ? o(10) : 2, ce = i(j, j), oe;
    ne && (oe = Array(G).fill(Z));
    for (var he = !1; !he; ) {
      he = !0;
      for (var we = 0; we < G; we++) {
        for (var De = k, ye = k, Ae = 0; Ae < G; Ae++)
          we !== Ae && (De = e(De, c(F[Ae][we])), ye = e(ye, c(F[we][Ae])));
        if (!h(De, 0) && !h(ye, 0)) {
          for (var U = Q, X = De, re = s(ye, j), $ = i(ye, j); w(X, re); )
            X = i(X, ce), U = i(U, j);
          for (; y(X, $); )
            X = s(X, ce), U = s(U, j);
          var H = w(s(e(X, ye), U), i(e(De, ye), 0.95));
          if (H) {
            he = !1;
            for (var Y = s(1, U), K = 0; K < G; K++)
              we !== K && (F[we][K] = i(F[we][K], Y), F[K][we] = i(F[K][we], U));
            ne && (oe[we] = i(oe[we], Y));
          }
        }
      }
    }
    return ne ? u(oe) : null;
  }
  function A(F, G, z, le, ne, ae) {
    var q = le === "BigNumber", k = le === "Complex", Z = q ? o(0) : k ? D(0) : 0;
    q && (z = o(z));
    for (var Q = 0; Q < G - 2; Q++) {
      for (var j = 0, ce = Z, oe = Q + 1; oe < G; oe++) {
        var he = F[oe][Q];
        w(c(ce), c(he)) && (ce = he, j = oe);
      }
      if (!w(c(ce), z)) {
        if (j !== Q + 1) {
          var we = F[j];
          F[j] = F[Q + 1], F[Q + 1] = we;
          for (var De = 0; De < G; De++) {
            var ye = F[De][j];
            F[De][j] = F[De][Q + 1], F[De][Q + 1] = ye;
          }
          if (ne) {
            var Ae = ae[j];
            ae[j] = ae[Q + 1], ae[Q + 1] = Ae;
          }
        }
        for (var U = Q + 2; U < G; U++) {
          var X = s(F[U][Q], ce);
          if (X !== 0) {
            for (var re = 0; re < G; re++)
              F[U][re] = t(F[U][re], i(X, F[Q + 1][re]));
            for (var $ = 0; $ < G; $++)
              F[$][Q + 1] = e(F[$][Q + 1], i(X, F[$][U]));
            if (ne)
              for (var H = 0; H < G; H++)
                ae[U][H] = t(ae[U][H], i(X, ae[Q + 1][H]));
          }
        }
      }
    }
    return ae;
  }
  function E(F, G, z, le, ne) {
    var ae = le === "BigNumber", q = le === "Complex", k = ae ? o(1) : q ? D(1) : 1;
    ae && (z = o(z));
    for (var Z = Te(F), Q = [], j = G, ce = [], oe = ne ? u(Array(G).fill(k)) : void 0, he = ne ? u(Array(j).fill(k)) : void 0, we = 0; we <= 100; ) {
      we += 1;
      for (var De = Z[j - 1][j - 1], ye = 0; ye < j; ye++)
        Z[ye][ye] = t(Z[ye][ye], De);
      var {
        Q: Ae,
        R: U
      } = d(Z);
      Z = a(U, Ae);
      for (var X = 0; X < j; X++)
        Z[X][X] = e(Z[X][X], De);
      if (ne && (he = a(he, Ae)), j === 1 || w(c(Z[j - 1][j - 2]), z)) {
        we = 0, Q.push(Z[j - 1][j - 1]), ne && (ce.unshift([[1]]), I(he, G), oe = a(oe, he), j > 1 && (he = u(Array(j - 1).fill(k)))), j -= 1, Z.pop();
        for (var re = 0; re < j; re++)
          Z[re].pop();
      } else if (j === 2 || w(c(Z[j - 2][j - 3]), z)) {
        we = 0;
        var $ = T(Z[j - 2][j - 2], Z[j - 2][j - 1], Z[j - 1][j - 2], Z[j - 1][j - 1]);
        Q.push(...$), ne && (ce.unshift(B(Z[j - 2][j - 2], Z[j - 2][j - 1], Z[j - 1][j - 2], Z[j - 1][j - 1], $[0], $[1], z, le)), I(he, G), oe = a(oe, he), j > 2 && (he = u(Array(j - 2).fill(k)))), j -= 2, Z.pop(), Z.pop();
        for (var H = 0; H < j; H++)
          Z[H].pop(), Z[H].pop();
      }
      if (j === 0)
        break;
    }
    if (Q.sort((te, se) => +t(c(te), c(se))), we > 100) {
      var Y = Error("The eigenvalues failed to converge. Only found these eigenvalues: " + Q.join(", "));
      throw Y.values = Q, Y.vectors = [], Y;
    }
    var K = ne ? a(oe, O(ce, G)) : void 0;
    return {
      values: Q,
      C: K
    };
  }
  function M(F, G, z, le, ne, ae, q) {
    var k = p(z), Z = a(k, F, z), Q = q === "BigNumber", j = q === "Complex", ce = Q ? o(0) : j ? D(0) : 0, oe = Q ? o(1) : j ? D(1) : 1, he = [], we = [];
    for (var De of ne) {
      var ye = _(he, De, h);
      ye === -1 ? (he.push(De), we.push(1)) : we[ye] += 1;
    }
    for (var Ae = [], U = he.length, X = Array(G).fill(ce), re = u(Array(G).fill(oe)), $ = function() {
      var K = he[H], te = t(Z, a(K, re)), se = x(te, X);
      for (se.shift(); se.length < we[H]; ) {
        var fe = P(te, G, se, ae, q);
        if (fe === null)
          break;
        se.push(fe);
      }
      var ve = a(p(le), z);
      se = se.map((ge) => a(ve, ge)), Ae.push(...se.map((ge) => ({
        value: K,
        vector: n(ge)
      })));
    }, H = 0; H < U; H++)
      $();
    return Ae;
  }
  function T(F, G, z, le) {
    var ne = e(F, le), ae = t(i(F, le), i(G, z)), q = i(ne, 0.5), k = i(l(t(i(ne, ne), i(4, ae))), 0.5);
    return [e(q, k), t(q, k)];
  }
  function B(F, G, z, le, ne, ae, q, k) {
    var Z = k === "BigNumber", Q = k === "Complex", j = Z ? o(0) : Q ? D(0) : 0, ce = Z ? o(1) : Q ? D(1) : 1;
    if (w(c(z), q))
      return [[ce, j], [j, ce]];
    if (y(c(t(ne, ae)), q))
      return [[t(ne, le), t(ae, le)], [z, z]];
    var oe = t(F, ne), he = t(le, ne);
    return w(c(G), q) && w(c(he), q) ? [[oe, ce], [z, j]] : [[G, j], [he, ce]];
  }
  function I(F, G) {
    for (var z = 0; z < F.length; z++)
      F[z].push(...Array(G - F[z].length).fill(0));
    for (var le = F.length; le < G; le++)
      F.push(Array(G).fill(0)), F[le][le] = 1;
    return F;
  }
  function O(F, G) {
    for (var z = [], le = 0; le < G; le++)
      z[le] = Array(G).fill(0);
    var ne = 0;
    for (var ae of F) {
      for (var q = ae.length, k = 0; k < q; k++)
        for (var Z = 0; Z < q; Z++)
          z[ne + k][ne + Z] = ae[k][Z];
      ne += q;
    }
    return z;
  }
  function _(F, G, z) {
    for (var le = 0; le < F.length; le++)
      if (z(F[le], G))
        return le;
    return -1;
  }
  function P(F, G, z, le, ne) {
    for (var ae = ne === "BigNumber" ? o(1e3) : 1e3, q, k = 0; k < 5; ++k) {
      q = W(G, z, ne);
      try {
        q = v(F, q);
      } catch {
        continue;
      }
      if (y(J(q), ae))
        break;
    }
    if (k >= 5)
      return null;
    for (k = 0; ; ) {
      var Z = v(F, q);
      if (w(J(L(q, [Z])), le))
        break;
      if (++k >= 10)
        return null;
      q = ee(Z);
    }
    return q;
  }
  function W(F, G, z) {
    var le = z === "BigNumber", ne = z === "Complex", ae = Array(F).fill(0).map((q) => 2 * Math.random() - 1);
    return le && (ae = ae.map((q) => o(q))), ne && (ae = ae.map((q) => D(q))), ae = L(ae, G), ee(ae, z);
  }
  function L(F, G) {
    var z = f(F);
    for (var le of G)
      le = m(le, z), F = t(F, a(s(g(le, F), g(le, le)), le));
    return F;
  }
  function J(F) {
    return c(l(g(F, F)));
  }
  function ee(F, G) {
    var z = G === "BigNumber", le = G === "Complex", ne = z ? o(1) : le ? D(1) : 1;
    return a(s(ne, J(F)), F);
  }
  return N;
}
function qC(r) {
  var {
    config: e,
    addScalar: t,
    subtract: n,
    abs: a,
    atan: i,
    cos: s,
    sin: l,
    multiplyScalar: c,
    inv: o,
    bignumber: u,
    multiply: f,
    add: m
  } = r;
  function p(A, E) {
    var M = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e.relTol, T = arguments.length > 3 ? arguments[3] : void 0, B = arguments.length > 4 ? arguments[4] : void 0;
    if (T === "number")
      return d(A, M, B);
    if (T === "BigNumber")
      return v(A, M, B);
    throw TypeError("Unsupported data type: " + T);
  }
  function d(A, E, M) {
    var T = A.length, B = Math.abs(E / T), I, O;
    if (M) {
      O = new Array(T);
      for (var _ = 0; _ < T; _++)
        O[_] = Array(T).fill(0), O[_][_] = 1;
    }
    for (var P = g(A); Math.abs(P[1]) >= Math.abs(B); ) {
      var W = P[0][0], L = P[0][1];
      I = x(A[W][W], A[L][L], A[W][L]), A = b(A, I, W, L), M && (O = D(O, I, W, L)), P = g(A);
    }
    for (var J = Array(T).fill(0), ee = 0; ee < T; ee++)
      J[ee] = A[ee][ee];
    return S(Te(J), O, M);
  }
  function v(A, E, M) {
    var T = A.length, B = a(E / T), I, O;
    if (M) {
      O = new Array(T);
      for (var _ = 0; _ < T; _++)
        O[_] = Array(T).fill(0), O[_][_] = 1;
    }
    for (var P = N(A); a(P[1]) >= a(B); ) {
      var W = P[0][0], L = P[0][1];
      I = h(A[W][W], A[L][L], A[W][L]), A = w(A, I, W, L), M && (O = y(O, I, W, L)), P = N(A);
    }
    for (var J = Array(T).fill(0), ee = 0; ee < T; ee++)
      J[ee] = A[ee][ee];
    return S(Te(J), O, M);
  }
  function x(A, E, M) {
    var T = E - A;
    return Math.abs(T) <= e.relTol ? Math.PI / 4 : 0.5 * Math.atan(2 * M / (E - A));
  }
  function h(A, E, M) {
    var T = n(E, A);
    return a(T) <= e.relTol ? u(-1).acos().div(4) : c(0.5, i(f(2, M, o(T))));
  }
  function D(A, E, M, T) {
    for (var B = A.length, I = Math.cos(E), O = Math.sin(E), _ = Array(B).fill(0), P = Array(B).fill(0), W = 0; W < B; W++)
      _[W] = I * A[W][M] - O * A[W][T], P[W] = O * A[W][M] + I * A[W][T];
    for (var L = 0; L < B; L++)
      A[L][M] = _[L], A[L][T] = P[L];
    return A;
  }
  function y(A, E, M, T) {
    for (var B = A.length, I = s(E), O = l(E), _ = Array(B).fill(u(0)), P = Array(B).fill(u(0)), W = 0; W < B; W++)
      _[W] = n(c(I, A[W][M]), c(O, A[W][T])), P[W] = t(c(O, A[W][M]), c(I, A[W][T]));
    for (var L = 0; L < B; L++)
      A[L][M] = _[L], A[L][T] = P[L];
    return A;
  }
  function w(A, E, M, T) {
    for (var B = A.length, I = u(s(E)), O = u(l(E)), _ = c(I, I), P = c(O, O), W = Array(B).fill(u(0)), L = Array(B).fill(u(0)), J = f(u(2), I, O, A[M][T]), ee = t(n(c(_, A[M][M]), J), c(P, A[T][T])), F = m(c(P, A[M][M]), J, c(_, A[T][T])), G = 0; G < B; G++)
      W[G] = n(c(I, A[M][G]), c(O, A[T][G])), L[G] = t(c(O, A[M][G]), c(I, A[T][G]));
    A[M][M] = ee, A[T][T] = F, A[M][T] = u(0), A[T][M] = u(0);
    for (var z = 0; z < B; z++)
      z !== M && z !== T && (A[M][z] = W[z], A[z][M] = W[z], A[T][z] = L[z], A[z][T] = L[z]);
    return A;
  }
  function b(A, E, M, T) {
    for (var B = A.length, I = Math.cos(E), O = Math.sin(E), _ = I * I, P = O * O, W = Array(B).fill(0), L = Array(B).fill(0), J = _ * A[M][M] - 2 * I * O * A[M][T] + P * A[T][T], ee = P * A[M][M] + 2 * I * O * A[M][T] + _ * A[T][T], F = 0; F < B; F++)
      W[F] = I * A[M][F] - O * A[T][F], L[F] = O * A[M][F] + I * A[T][F];
    A[M][M] = J, A[T][T] = ee, A[M][T] = 0, A[T][M] = 0;
    for (var G = 0; G < B; G++)
      G !== M && G !== T && (A[M][G] = W[G], A[G][M] = W[G], A[T][G] = L[G], A[G][T] = L[G]);
    return A;
  }
  function g(A) {
    for (var E = A.length, M = 0, T = [0, 1], B = 0; B < E; B++)
      for (var I = B + 1; I < E; I++)
        Math.abs(M) < Math.abs(A[B][I]) && (M = Math.abs(A[B][I]), T = [B, I]);
    return [T, M];
  }
  function N(A) {
    for (var E = A.length, M = 0, T = [0, 1], B = 0; B < E; B++)
      for (var I = B + 1; I < E; I++)
        a(M) < a(A[B][I]) && (M = a(A[B][I]), T = [B, I]);
    return [T, M];
  }
  function S(A, E, M) {
    var T = A.length, B = Array(T), I;
    if (M) {
      I = Array(T);
      for (var O = 0; O < T; O++)
        I[O] = Array(T);
    }
    for (var _ = 0; _ < T; _++) {
      for (var P = 0, W = A[0], L = 0; L < A.length; L++)
        a(A[L]) < a(W) && (P = L, W = A[P]);
      if (B[_] = A.splice(P, 1)[0], M)
        for (var J = 0; J < T; J++)
          I[_][J] = E[J][P], E[J].splice(P, 1);
    }
    if (!M) return {
      values: B
    };
    var ee = I.map((F, G) => ({
      value: B[G],
      vector: F
    }));
    return {
      values: B,
      eigenvectors: ee
    };
  }
  return p;
}
var PC = "eigs", UC = ["config", "typed", "matrix", "addScalar", "equal", "subtract", "abs", "atan", "cos", "sin", "multiplyScalar", "divideScalar", "inv", "bignumber", "multiply", "add", "larger", "column", "flatten", "number", "complex", "sqrt", "diag", "size", "reshape", "qr", "usolve", "usolveAll", "im", "re", "smaller", "matrixFromColumns", "dot"], LC = /* @__PURE__ */ R(PC, UC, (r) => {
  var {
    config: e,
    typed: t,
    matrix: n,
    addScalar: a,
    subtract: i,
    equal: s,
    abs: l,
    atan: c,
    cos: o,
    sin: u,
    multiplyScalar: f,
    divideScalar: m,
    inv: p,
    bignumber: d,
    multiply: v,
    add: x,
    larger: h,
    column: D,
    flatten: y,
    number: w,
    complex: b,
    sqrt: g,
    diag: N,
    size: S,
    reshape: A,
    qr: E,
    usolve: M,
    usolveAll: T,
    im: B,
    re: I,
    smaller: O,
    matrixFromColumns: _,
    dot: P
  } = r, W = qC({
    config: e,
    addScalar: a,
    subtract: i,
    abs: l,
    atan: c,
    cos: o,
    sin: u,
    multiplyScalar: f,
    inv: p,
    bignumber: d,
    multiply: v,
    add: x
  }), L = RC({
    addScalar: a,
    subtract: i,
    multiply: v,
    multiplyScalar: f,
    flatten: y,
    divideScalar: m,
    sqrt: g,
    abs: l,
    bignumber: d,
    diag: N,
    size: S,
    reshape: A,
    qr: E,
    inv: p,
    usolve: M,
    usolveAll: T,
    equal: s,
    complex: b,
    larger: h,
    smaller: O,
    matrixFromColumns: _,
    dot: P
  });
  return t("eigs", {
    // The conversion to matrix in the first two implementations,
    // just to convert back to an array right away in
    // computeValuesAndVectors, is unfortunate, and should perhaps be
    // streamlined. It is done because the Matrix object carries some
    // type information about its entries, and so constructing the matrix
    // is a roundabout way of doing type detection.
    Array: function(ae) {
      return J(n(ae));
    },
    "Array, number|BigNumber": function(ae, q) {
      return J(n(ae), {
        precision: q
      });
    },
    "Array, Object"(ne, ae) {
      return J(n(ne), ae);
    },
    Matrix: function(ae) {
      return J(ae, {
        matricize: !0
      });
    },
    "Matrix, number|BigNumber": function(ae, q) {
      return J(ae, {
        precision: q,
        matricize: !0
      });
    },
    "Matrix, Object": function(ae, q) {
      var k = {
        matricize: !0
      };
      return hr(k, q), J(ae, k);
    }
  });
  function J(ne) {
    var ae, q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, k = "eigenvectors" in q ? q.eigenvectors : !0, Z = (ae = q.precision) !== null && ae !== void 0 ? ae : e.relTol, Q = ee(ne, Z, k);
    return q.matricize && (Q.values = n(Q.values), k && (Q.eigenvectors = Q.eigenvectors.map((j) => {
      var {
        value: ce,
        vector: oe
      } = j;
      return {
        value: ce,
        vector: n(oe)
      };
    }))), k && Object.defineProperty(Q, "vectors", {
      enumerable: !1,
      // to make sure that the eigenvectors can still be
      // converted to string.
      get: () => {
        throw new Error("eigs(M).vectors replaced with eigs(M).eigenvectors");
      }
    }), Q;
  }
  function ee(ne, ae, q) {
    var k = ne.toArray(), Z = ne.size();
    if (Z.length !== 2 || Z[0] !== Z[1])
      throw new RangeError("Matrix must be square (size: ".concat(ke(Z), ")"));
    var Q = Z[0];
    if (G(k, Q, ae) && (z(k, Q), F(k, Q, ae))) {
      var j = le(ne, k, Q);
      return W(k, Q, ae, j, q);
    }
    var ce = le(ne, k, Q);
    return L(k, Q, ae, ce, q);
  }
  function F(ne, ae, q) {
    for (var k = 0; k < ae; k++)
      for (var Z = k; Z < ae; Z++)
        if (h(d(l(i(ne[k][Z], ne[Z][k]))), q))
          return !1;
    return !0;
  }
  function G(ne, ae, q) {
    for (var k = 0; k < ae; k++)
      for (var Z = 0; Z < ae; Z++)
        if (h(d(l(B(ne[k][Z]))), q))
          return !1;
    return !0;
  }
  function z(ne, ae) {
    for (var q = 0; q < ae; q++)
      for (var k = 0; k < ae; k++)
        ne[q][k] = I(ne[q][k]);
  }
  function le(ne, ae, q) {
    var k = ne.datatype();
    if (k === "number" || k === "BigNumber" || k === "Complex")
      return k;
    for (var Z = !1, Q = !1, j = !1, ce = 0; ce < q; ce++)
      for (var oe = 0; oe < q; oe++) {
        var he = ae[ce][oe];
        if (Re(he) || Rt(he))
          Z = !0;
        else if ($e(he))
          Q = !0;
        else if (Zr(he))
          j = !0;
        else
          throw TypeError("Unsupported type in Matrix: " + Ke(he));
      }
    if (Q && j && console.warn("Complex BigNumbers not supported, this operation will lose precission."), j) {
      for (var we = 0; we < q; we++)
        for (var De = 0; De < q; De++)
          ae[we][De] = b(ae[we][De]);
      return "Complex";
    }
    if (Q) {
      for (var ye = 0; ye < q; ye++)
        for (var Ae = 0; Ae < q; Ae++)
          ae[ye][Ae] = d(ae[ye][Ae]);
      return "BigNumber";
    }
    if (Z) {
      for (var U = 0; U < q; U++)
        for (var X = 0; X < q; X++)
          ae[U][X] = w(ae[U][X]);
      return "number";
    } else
      throw TypeError("Matrix contains unsupported types only.");
  }
}), dl = "expm", kC = ["typed", "abs", "add", "identity", "inv", "multiply"], HC = /* @__PURE__ */ R(dl, kC, (r) => {
  var {
    typed: e,
    abs: t,
    add: n,
    identity: a,
    inv: i,
    multiply: s
  } = r;
  return e(dl, {
    Matrix: function(f) {
      var m = f.size();
      if (m.length !== 2 || m[0] !== m[1])
        throw new RangeError("Matrix must be square (size: " + ke(m) + ")");
      for (var p = m[0], d = 1e-15, v = l(f), x = c(v, d), h = x.q, D = x.j, y = s(f, Math.pow(2, -D)), w = a(p), b = a(p), g = 1, N = y, S = -1, A = 1; A <= h; A++)
        A > 1 && (N = s(N, y), S = -S), g = g * (h - A + 1) / ((2 * h - A + 1) * A), w = n(w, s(g, N)), b = n(b, s(g * S, N));
      for (var E = s(i(b), w), M = 0; M < D; M++)
        E = s(E, E);
      return gt(f) ? f.createSparseMatrix(E) : E;
    }
  });
  function l(u) {
    for (var f = u.size()[0], m = 0, p = 0; p < f; p++) {
      for (var d = 0, v = 0; v < f; v++)
        d += t(u.get([p, v]));
      m = Math.max(d, m);
    }
    return m;
  }
  function c(u, f) {
    for (var m = 30, p = 0; p < m; p++)
      for (var d = 0; d <= p; d++) {
        var v = p - d;
        if (o(u, d, v) < f)
          return {
            q: d,
            j: v
          };
      }
    throw new Error("Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)");
  }
  function o(u, f, m) {
    for (var p = 1, d = 2; d <= f; d++)
      p *= d;
    for (var v = p, x = f + 1; x <= 2 * f; x++)
      v *= x;
    var h = v * (2 * f + 1);
    return 8 * Math.pow(u / Math.pow(2, m), 2 * f) * p * p / (v * h);
  }
}), vl = "sqrtm", WC = ["typed", "abs", "add", "multiply", "map", "sqrt", "subtract", "inv", "size", "max", "identity"], GC = /* @__PURE__ */ R(vl, WC, (r) => {
  var {
    typed: e,
    abs: t,
    add: n,
    multiply: a,
    map: i,
    sqrt: s,
    subtract: l,
    inv: c,
    size: o,
    max: u,
    identity: f
  } = r, m = 1e3, p = 1e-6;
  function d(v) {
    var x, h = 0, D = v, y = f(o(v));
    do {
      var w = D;
      if (D = a(0.5, n(w, c(y))), y = a(0.5, n(y, c(w))), x = u(t(l(D, w))), x > p && ++h > m)
        throw new Error("computing square root of matrix: iterative method could not converge");
    } while (x > p);
    return D;
  }
  return e(vl, {
    "Array | Matrix": function(x) {
      var h = Ee(x) ? x.size() : Oe(x);
      switch (h.length) {
        case 1:
          if (h[0] === 1)
            return i(x, s);
          throw new RangeError("Matrix must be square (size: " + ke(h) + ")");
        case 2: {
          var D = h[0], y = h[1];
          if (D === y)
            return d(x);
          throw new RangeError("Matrix must be square (size: " + ke(h) + ")");
        }
        default:
          throw new RangeError("Matrix must be at most two dimensional (size: " + ke(h) + ")");
      }
    }
  });
}), hl = "sylvester", VC = ["typed", "schur", "matrixFromColumns", "matrix", "multiply", "range", "concat", "transpose", "index", "subset", "add", "subtract", "identity", "lusolve", "abs"], ZC = /* @__PURE__ */ R(hl, VC, (r) => {
  var {
    typed: e,
    schur: t,
    matrixFromColumns: n,
    matrix: a,
    multiply: i,
    range: s,
    concat: l,
    transpose: c,
    index: o,
    subset: u,
    add: f,
    subtract: m,
    identity: p,
    lusolve: d,
    abs: v
  } = r;
  return e(hl, {
    "Matrix, Matrix, Matrix": x,
    "Array, Matrix, Matrix": function(D, y, w) {
      return x(a(D), y, w);
    },
    "Array, Array, Matrix": function(D, y, w) {
      return x(a(D), a(y), w);
    },
    "Array, Matrix, Array": function(D, y, w) {
      return x(a(D), y, a(w));
    },
    "Matrix, Array, Matrix": function(D, y, w) {
      return x(D, a(y), w);
    },
    "Matrix, Array, Array": function(D, y, w) {
      return x(D, a(y), a(w));
    },
    "Matrix, Matrix, Array": function(D, y, w) {
      return x(D, y, a(w));
    },
    "Array, Array, Array": function(D, y, w) {
      return x(a(D), a(y), a(w)).toArray();
    }
  });
  function x(h, D, y) {
    for (var w = D.size()[0], b = h.size()[0], g = t(h), N = g.T, S = g.U, A = t(i(-1, D)), E = A.T, M = A.U, T = i(i(c(S), y), M), B = s(0, b), I = [], O = (j, ce) => l(j, ce, 1), _ = (j, ce) => l(j, ce, 0), P = 0; P < w; P++)
      if (P < w - 1 && v(u(E, o(P + 1, P))) > 1e-5) {
        for (var W = _(u(T, o(B, P)), u(T, o(B, P + 1))), L = 0; L < P; L++)
          W = f(W, _(i(I[L], u(E, o(L, P))), i(I[L], u(E, o(L, P + 1)))));
        var J = i(p(b), i(-1, u(E, o(P, P)))), ee = i(p(b), i(-1, u(E, o(P + 1, P)))), F = i(p(b), i(-1, u(E, o(P, P + 1)))), G = i(p(b), i(-1, u(E, o(P + 1, P + 1)))), z = _(O(f(N, J), ee), O(F, f(N, G))), le = d(z, W);
        I[P] = le.subset(o(s(0, b), 0)), I[P + 1] = le.subset(o(s(b, 2 * b), 0)), P++;
      } else {
        for (var ne = u(T, o(B, P)), ae = 0; ae < P; ae++)
          ne = f(ne, i(I[ae], u(E, o(ae, P))));
        var q = u(E, o(P, P)), k = m(N, i(q, p(b)));
        I[P] = d(k, ne);
      }
    var Z = a(n(...I)), Q = i(S, i(Z, c(M)));
    return Q;
  }
}), gl = "schur", XC = ["typed", "matrix", "identity", "multiply", "qr", "norm", "subtract"], YC = /* @__PURE__ */ R(gl, XC, (r) => {
  var {
    typed: e,
    matrix: t,
    identity: n,
    multiply: a,
    qr: i,
    norm: s,
    subtract: l
  } = r;
  return e(gl, {
    Array: function(u) {
      var f = c(t(u));
      return {
        U: f.U.valueOf(),
        T: f.T.valueOf()
      };
    },
    Matrix: function(u) {
      return c(u);
    }
  });
  function c(o) {
    var u = o.size()[0], f = o, m = n(u), p = 0, d;
    do {
      d = f;
      var v = i(f), x = v.Q, h = v.R;
      if (f = a(h, x), m = a(m, x), p++ > 100)
        break;
    } while (s(l(f, d)) > 1e-4);
    return {
      U: m,
      T: f
    };
  }
}), yl = "lyap", JC = ["typed", "matrix", "sylvester", "multiply", "transpose"], QC = /* @__PURE__ */ R(yl, JC, (r) => {
  var {
    typed: e,
    matrix: t,
    sylvester: n,
    multiply: a,
    transpose: i
  } = r;
  return e(yl, {
    "Matrix, Matrix": function(l, c) {
      return n(l, i(l), a(-1, c));
    },
    "Array, Matrix": function(l, c) {
      return n(t(l), i(t(l)), a(-1, c));
    },
    "Matrix, Array": function(l, c) {
      return n(l, i(t(l)), t(a(-1, c)));
    },
    "Array, Array": function(l, c) {
      return n(t(l), i(t(l)), t(a(-1, c))).toArray();
    }
  });
}), jC = "divide", KC = ["typed", "matrix", "multiply", "equalScalar", "divideScalar", "inv"], e_ = /* @__PURE__ */ R(jC, KC, (r) => {
  var {
    typed: e,
    matrix: t,
    multiply: n,
    equalScalar: a,
    divideScalar: i,
    inv: s
  } = r, l = br({
    typed: e,
    equalScalar: a
  }), c = Wr({
    typed: e
  });
  return e("divide", Pf({
    // we extend the signatures of divideScalar with signatures dealing with matrices
    "Array | Matrix, Array | Matrix": function(u, f) {
      return n(u, s(f));
    },
    "DenseMatrix, any": function(u, f) {
      return c(u, f, i, !1);
    },
    "SparseMatrix, any": function(u, f) {
      return l(u, f, i, !1);
    },
    "Array, any": function(u, f) {
      return c(t(u), f, i, !1).valueOf();
    },
    "any, Array | Matrix": function(u, f) {
      return n(u, s(f));
    }
  }, i.signatures));
}), bl = "distance", r_ = ["typed", "addScalar", "subtractScalar", "divideScalar", "multiplyScalar", "deepEqual", "sqrt", "abs"], t_ = /* @__PURE__ */ R(bl, r_, (r) => {
  var {
    typed: e,
    addScalar: t,
    subtractScalar: n,
    multiplyScalar: a,
    divideScalar: i,
    deepEqual: s,
    sqrt: l,
    abs: c
  } = r;
  return e(bl, {
    "Array, Array, Array": function(b, g, N) {
      if (b.length === 2 && g.length === 2 && N.length === 2) {
        if (!u(b))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
        if (!u(g))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
        if (!u(N))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
        if (s(g, N))
          throw new TypeError("LinePoint1 should not be same with LinePoint2");
        var S = n(N[1], g[1]), A = n(g[0], N[0]), E = n(a(N[0], g[1]), a(g[0], N[1]));
        return x(b[0], b[1], S, A, E);
      } else
        throw new TypeError("Invalid Arguments: Try again");
    },
    "Object, Object, Object": function(b, g, N) {
      if (Object.keys(b).length === 2 && Object.keys(g).length === 2 && Object.keys(N).length === 2) {
        if (!u(b))
          throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
        if (!u(g))
          throw new TypeError("Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers");
        if (!u(N))
          throw new TypeError("Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers");
        if (s(d(g), d(N)))
          throw new TypeError("LinePoint1 should not be same with LinePoint2");
        if ("pointX" in b && "pointY" in b && "lineOnePtX" in g && "lineOnePtY" in g && "lineTwoPtX" in N && "lineTwoPtY" in N) {
          var S = n(N.lineTwoPtY, g.lineOnePtY), A = n(g.lineOnePtX, N.lineTwoPtX), E = n(a(N.lineTwoPtX, g.lineOnePtY), a(g.lineOnePtX, N.lineTwoPtY));
          return x(b.pointX, b.pointY, S, A, E);
        } else
          throw new TypeError("Key names do not match");
      } else
        throw new TypeError("Invalid Arguments: Try again");
    },
    "Array, Array": function(b, g) {
      if (b.length === 2 && g.length === 3) {
        if (!u(b))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
        if (!f(g))
          throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
        return x(b[0], b[1], g[0], g[1], g[2]);
      } else if (b.length === 3 && g.length === 6) {
        if (!f(b))
          throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
        if (!p(g))
          throw new TypeError("Array with 6 numbers or BigNumbers expected for second argument");
        return h(b[0], b[1], b[2], g[0], g[1], g[2], g[3], g[4], g[5]);
      } else if (b.length === g.length && b.length > 0) {
        if (!m(b))
          throw new TypeError("All values of an array should be numbers or BigNumbers");
        if (!m(g))
          throw new TypeError("All values of an array should be numbers or BigNumbers");
        return D(b, g);
      } else
        throw new TypeError("Invalid Arguments: Try again");
    },
    "Object, Object": function(b, g) {
      if (Object.keys(b).length === 2 && Object.keys(g).length === 3) {
        if (!u(b))
          throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
        if (!f(g))
          throw new TypeError("Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers");
        if ("pointX" in b && "pointY" in b && "xCoeffLine" in g && "yCoeffLine" in g && "constant" in g)
          return x(b.pointX, b.pointY, g.xCoeffLine, g.yCoeffLine, g.constant);
        throw new TypeError("Key names do not match");
      } else if (Object.keys(b).length === 3 && Object.keys(g).length === 6) {
        if (!f(b))
          throw new TypeError("Values of pointX, pointY and pointZ should be numbers or BigNumbers");
        if (!p(g))
          throw new TypeError("Values of x0, y0, z0, a, b and c should be numbers or BigNumbers");
        if ("pointX" in b && "pointY" in b && "x0" in g && "y0" in g && "z0" in g && "a" in g && "b" in g && "c" in g)
          return h(b.pointX, b.pointY, b.pointZ, g.x0, g.y0, g.z0, g.a, g.b, g.c);
        throw new TypeError("Key names do not match");
      } else if (Object.keys(b).length === 2 && Object.keys(g).length === 2) {
        if (!u(b))
          throw new TypeError("Values of pointOneX and pointOneY should be numbers or BigNumbers");
        if (!u(g))
          throw new TypeError("Values of pointTwoX and pointTwoY should be numbers or BigNumbers");
        if ("pointOneX" in b && "pointOneY" in b && "pointTwoX" in g && "pointTwoY" in g)
          return D([b.pointOneX, b.pointOneY], [g.pointTwoX, g.pointTwoY]);
        throw new TypeError("Key names do not match");
      } else if (Object.keys(b).length === 3 && Object.keys(g).length === 3) {
        if (!f(b))
          throw new TypeError("Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers");
        if (!f(g))
          throw new TypeError("Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers");
        if ("pointOneX" in b && "pointOneY" in b && "pointOneZ" in b && "pointTwoX" in g && "pointTwoY" in g && "pointTwoZ" in g)
          return D([b.pointOneX, b.pointOneY, b.pointOneZ], [g.pointTwoX, g.pointTwoY, g.pointTwoZ]);
        throw new TypeError("Key names do not match");
      } else
        throw new TypeError("Invalid Arguments: Try again");
    },
    Array: function(b) {
      if (!v(b))
        throw new TypeError("Incorrect array format entered for pairwise distance calculation");
      return y(b);
    }
  });
  function o(w) {
    return typeof w == "number" || $e(w);
  }
  function u(w) {
    return w.constructor !== Array && (w = d(w)), o(w[0]) && o(w[1]);
  }
  function f(w) {
    return w.constructor !== Array && (w = d(w)), o(w[0]) && o(w[1]) && o(w[2]);
  }
  function m(w) {
    return Array.isArray(w) || (w = d(w)), w.every(o);
  }
  function p(w) {
    return w.constructor !== Array && (w = d(w)), o(w[0]) && o(w[1]) && o(w[2]) && o(w[3]) && o(w[4]) && o(w[5]);
  }
  function d(w) {
    for (var b = Object.keys(w), g = [], N = 0; N < b.length; N++)
      g.push(w[b[N]]);
    return g;
  }
  function v(w) {
    if (w[0].length === 2 && o(w[0][0]) && o(w[0][1])) {
      if (w.some((b) => b.length !== 2 || !o(b[0]) || !o(b[1])))
        return !1;
    } else if (w[0].length === 3 && o(w[0][0]) && o(w[0][1]) && o(w[0][2])) {
      if (w.some((b) => b.length !== 3 || !o(b[0]) || !o(b[1]) || !o(b[2])))
        return !1;
    } else
      return !1;
    return !0;
  }
  function x(w, b, g, N, S) {
    var A = c(t(t(a(g, w), a(N, b)), S)), E = l(t(a(g, g), a(N, N)));
    return i(A, E);
  }
  function h(w, b, g, N, S, A, E, M, T) {
    var B = [n(a(n(S, b), T), a(n(A, g), M)), n(a(n(A, g), E), a(n(N, w), T)), n(a(n(N, w), M), a(n(S, b), E))];
    B = l(t(t(a(B[0], B[0]), a(B[1], B[1])), a(B[2], B[2])));
    var I = l(t(t(a(E, E), a(M, M)), a(T, T)));
    return i(B, I);
  }
  function D(w, b) {
    for (var g = w.length, N = 0, S = 0, A = 0; A < g; A++)
      S = n(w[A], b[A]), N = t(a(S, S), N);
    return l(N);
  }
  function y(w) {
    for (var b = [], g = [], N = [], S = 0; S < w.length - 1; S++)
      for (var A = S + 1; A < w.length; A++)
        w[0].length === 2 ? (g = [w[S][0], w[S][1]], N = [w[A][0], w[A][1]]) : w[0].length === 3 && (g = [w[S][0], w[S][1], w[S][2]], N = [w[A][0], w[A][1], w[A][2]]), b.push(D(g, N));
    return b;
  }
}), n_ = "intersect", a_ = ["typed", "config", "abs", "add", "addScalar", "matrix", "multiply", "multiplyScalar", "divideScalar", "subtract", "smaller", "equalScalar", "flatten", "isZero", "isNumeric"], i_ = /* @__PURE__ */ R(n_, a_, (r) => {
  var {
    typed: e,
    config: t,
    abs: n,
    add: a,
    addScalar: i,
    matrix: s,
    multiply: l,
    multiplyScalar: c,
    divideScalar: o,
    subtract: u,
    smaller: f,
    equalScalar: m,
    flatten: p,
    isZero: d,
    isNumeric: v
  } = r;
  return e("intersect", {
    "Array, Array, Array": x,
    "Array, Array, Array, Array": h,
    "Matrix, Matrix, Matrix": function(M, T, B) {
      var I = x(M.valueOf(), T.valueOf(), B.valueOf());
      return I === null ? null : s(I);
    },
    "Matrix, Matrix, Matrix, Matrix": function(M, T, B, I) {
      var O = h(M.valueOf(), T.valueOf(), B.valueOf(), I.valueOf());
      return O === null ? null : s(O);
    }
  });
  function x(E, M, T) {
    if (E = D(E), M = D(M), T = D(T), !w(E))
      throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
    if (!w(M))
      throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
    if (!b(T))
      throw new TypeError("Array with 4 numbers expected as third argument");
    return A(E[0], E[1], E[2], M[0], M[1], M[2], T[0], T[1], T[2], T[3]);
  }
  function h(E, M, T, B) {
    if (E = D(E), M = D(M), T = D(T), B = D(B), E.length === 2) {
      if (!y(E))
        throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
      if (!y(M))
        throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
      if (!y(T))
        throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
      if (!y(B))
        throw new TypeError("Array with 2 numbers or BigNumbers expected for fourth argument");
      return g(E, M, T, B);
    } else if (E.length === 3) {
      if (!w(E))
        throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
      if (!w(M))
        throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
      if (!w(T))
        throw new TypeError("Array with 3 numbers or BigNumbers expected for third argument");
      if (!w(B))
        throw new TypeError("Array with 3 numbers or BigNumbers expected for fourth argument");
      return S(E[0], E[1], E[2], M[0], M[1], M[2], T[0], T[1], T[2], B[0], B[1], B[2]);
    } else
      throw new TypeError("Arrays with two or thee dimensional points expected");
  }
  function D(E) {
    return E.length === 1 ? E[0] : E.length > 1 && Array.isArray(E[0]) && E.every((M) => Array.isArray(M) && M.length === 1) ? p(E) : E;
  }
  function y(E) {
    return E.length === 2 && v(E[0]) && v(E[1]);
  }
  function w(E) {
    return E.length === 3 && v(E[0]) && v(E[1]) && v(E[2]);
  }
  function b(E) {
    return E.length === 4 && v(E[0]) && v(E[1]) && v(E[2]) && v(E[3]);
  }
  function g(E, M, T, B) {
    var I = E, O = T, _ = u(I, M), P = u(O, B), W = u(c(_[0], P[1]), c(P[0], _[1]));
    if (d(W) || f(n(W), t.relTol))
      return null;
    var L = c(P[0], I[1]), J = c(P[1], I[0]), ee = c(P[0], O[1]), F = c(P[1], O[0]), G = o(i(u(u(L, J), ee), F), W);
    return a(l(_, G), I);
  }
  function N(E, M, T, B, I, O, _, P, W, L, J, ee) {
    var F = c(u(E, M), u(T, B)), G = c(u(I, O), u(_, P)), z = c(u(W, L), u(J, ee));
    return i(i(F, G), z);
  }
  function S(E, M, T, B, I, O, _, P, W, L, J, ee) {
    var F = N(E, _, L, _, M, P, J, P, T, W, ee, W), G = N(L, _, B, E, J, P, I, M, ee, W, O, T), z = N(E, _, B, E, M, P, I, M, T, W, O, T), le = N(L, _, L, _, J, P, J, P, ee, W, ee, W), ne = N(B, E, B, E, I, M, I, M, O, T, O, T), ae = u(c(F, G), c(z, le)), q = u(c(ne, le), c(G, G));
    if (d(q)) return null;
    var k = o(ae, q), Z = o(i(F, c(k, G)), le), Q = i(E, c(k, u(B, E))), j = i(M, c(k, u(I, M))), ce = i(T, c(k, u(O, T))), oe = i(_, c(Z, u(L, _))), he = i(P, c(Z, u(J, P))), we = i(W, c(Z, u(ee, W)));
    return m(Q, oe) && m(j, he) && m(ce, we) ? [Q, j, ce] : null;
  }
  function A(E, M, T, B, I, O, _, P, W, L) {
    var J = c(E, _), ee = c(B, _), F = c(M, P), G = c(I, P), z = c(T, W), le = c(O, W), ne = u(u(u(L, J), F), z), ae = u(u(u(i(i(ee, G), le), J), F), z), q = o(ne, ae), k = i(E, c(q, u(B, E))), Z = i(M, c(q, u(I, M))), Q = i(T, c(q, u(O, T)));
    return [k, Z, Q];
  }
}), xl = "sum", o_ = ["typed", "config", "add", "numeric"], hd = /* @__PURE__ */ R(xl, o_, (r) => {
  var {
    typed: e,
    config: t,
    add: n,
    numeric: a
  } = r;
  return e(xl, {
    // sum([a, b, c, d, ...])
    "Array | Matrix": i,
    // sum([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": s,
    // sum(a, b, c, d, ...)
    "...": function(c) {
      if (pn(c))
        throw new TypeError("Scalar values expected in function sum");
      return i(c);
    }
  });
  function i(l) {
    var c;
    return At(l, function(o) {
      try {
        c = c === void 0 ? o : n(c, o);
      } catch (u) {
        throw _r(u, "sum", o);
      }
    }), c === void 0 && (c = a(0, t.number)), typeof c == "string" && (c = a(c, St(c, t))), c;
  }
  function s(l, c) {
    try {
      var o = ai(l, c, n);
      return o;
    } catch (u) {
      throw _r(u, "sum");
    }
  }
}), ua = "cumsum", s_ = ["typed", "add", "unaryPlus"], gd = /* @__PURE__ */ R(ua, s_, (r) => {
  var {
    typed: e,
    add: t,
    unaryPlus: n
  } = r;
  return e(ua, {
    // sum([a, b, c, d, ...])
    Array: a,
    Matrix: function(o) {
      return o.create(a(o.valueOf(), o.datatype()));
    },
    // sum([a, b, c, d, ...], dim)
    "Array, number | BigNumber": s,
    "Matrix, number | BigNumber": function(o, u) {
      return o.create(s(o.valueOf(), u), o.datatype());
    },
    // cumsum(a, b, c, d, ...)
    "...": function(o) {
      if (pn(o))
        throw new TypeError("All values expected to be scalar in function cumsum");
      return a(o);
    }
  });
  function a(c) {
    try {
      return i(c);
    } catch (o) {
      throw _r(o, ua);
    }
  }
  function i(c) {
    if (c.length === 0)
      return [];
    for (var o = [n(c[0])], u = 1; u < c.length; ++u)
      o.push(t(o[u - 1], c[u]));
    return o;
  }
  function s(c, o) {
    var u = Oe(c);
    if (o < 0 || o >= u.length)
      throw new Hr(o, u.length);
    try {
      return l(c, o);
    } catch (f) {
      throw _r(f, ua);
    }
  }
  function l(c, o) {
    var u, f, m;
    if (o <= 0) {
      var p = c[0][0];
      if (Array.isArray(p)) {
        for (m = Dm(c), f = [], u = 0; u < m.length; u++)
          f[u] = l(m[u], o - 1);
        return f;
      } else
        return i(c);
    } else {
      for (f = [], u = 0; u < c.length; u++)
        f[u] = l(c[u], o - 1);
      return f;
    }
  }
}), wl = "mean", u_ = ["typed", "add", "divide"], yd = /* @__PURE__ */ R(wl, u_, (r) => {
  var {
    typed: e,
    add: t,
    divide: n
  } = r;
  return e(wl, {
    // mean([a, b, c, d, ...])
    "Array | Matrix": i,
    // mean([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": a,
    // mean(a, b, c, d, ...)
    "...": function(l) {
      if (pn(l))
        throw new TypeError("Scalar values expected in function mean");
      return i(l);
    }
  });
  function a(s, l) {
    try {
      var c = ai(s, l, t), o = Array.isArray(s) ? Oe(s) : s.size();
      return n(c, o[l]);
    } catch (u) {
      throw _r(u, "mean");
    }
  }
  function i(s) {
    var l, c = 0;
    if (At(s, function(o) {
      try {
        l = l === void 0 ? o : t(l, o), c++;
      } catch (u) {
        throw _r(u, "mean", o);
      }
    }), c === 0)
      throw new Error("Cannot calculate the mean of an empty array");
    return n(l, c);
  }
}), Dl = "median", c_ = ["typed", "add", "divide", "compare", "partitionSelect"], l_ = /* @__PURE__ */ R(Dl, c_, (r) => {
  var {
    typed: e,
    add: t,
    divide: n,
    compare: a,
    partitionSelect: i
  } = r;
  function s(o) {
    try {
      o = Ve(o.valueOf());
      var u = o.length;
      if (u === 0)
        throw new Error("Cannot calculate median of an empty array");
      if (u % 2 === 0) {
        for (var f = u / 2 - 1, m = i(o, f + 1), p = o[f], d = 0; d < f; ++d)
          a(o[d], p) > 0 && (p = o[d]);
        return c(p, m);
      } else {
        var v = i(o, (u - 1) / 2);
        return l(v);
      }
    } catch (x) {
      throw _r(x, "median");
    }
  }
  var l = e({
    "number | BigNumber | Complex | Unit": function(u) {
      return u;
    }
  }), c = e({
    "number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit": function(u, f) {
      return n(t(u, f), 2);
    }
  });
  return e(Dl, {
    // median([a, b, c, d, ...])
    "Array | Matrix": s,
    // median([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": function(u, f) {
      throw new Error("median(A, dim) is not yet supported");
    },
    // median(a, b, c, d, ...)
    "...": function(u) {
      if (pn(u))
        throw new TypeError("Scalar values expected in function median");
      return s(u);
    }
  });
}), Nl = "mad", f_ = ["typed", "abs", "map", "median", "subtract"], m_ = /* @__PURE__ */ R(Nl, f_, (r) => {
  var {
    typed: e,
    abs: t,
    map: n,
    median: a,
    subtract: i
  } = r;
  return e(Nl, {
    // mad([a, b, c, d, ...])
    "Array | Matrix": s,
    // mad(a, b, c, d, ...)
    "...": function(c) {
      return s(c);
    }
  });
  function s(l) {
    if (l = Ve(l.valueOf()), l.length === 0)
      throw new Error("Cannot calculate median absolute deviation (mad) of an empty array");
    try {
      var c = a(l);
      return a(n(l, function(o) {
        return t(i(o, c));
      }));
    } catch (o) {
      throw o instanceof TypeError && o.message.includes("median") ? new TypeError(o.message.replace("median", "mad")) : _r(o, "mad");
    }
  }
}), Si = "unbiased", Al = "variance", p_ = ["typed", "add", "subtract", "multiply", "divide", "mapSlices", "isNaN"], bd = /* @__PURE__ */ R(Al, p_, (r) => {
  var {
    typed: e,
    add: t,
    subtract: n,
    multiply: a,
    divide: i,
    mapSlices: s,
    isNaN: l
  } = r;
  return e(Al, {
    // variance([a, b, c, d, ...])
    "Array | Matrix": function(f) {
      return c(f, Si);
    },
    // variance([a, b, c, d, ...], normalization)
    "Array | Matrix, string": c,
    // variance([a, b, c, c, ...], dim)
    "Array | Matrix, number | BigNumber": function(f, m) {
      return o(f, m, Si);
    },
    // variance([a, b, c, c, ...], dim, normalization)
    "Array | Matrix, number | BigNumber, string": o,
    // variance(a, b, c, d, ...)
    "...": function(f) {
      return c(f, Si);
    }
  });
  function c(u, f) {
    var m, p = 0;
    if (u.length === 0)
      throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
    if (At(u, function(x) {
      try {
        m = m === void 0 ? x : t(m, x), p++;
      } catch (h) {
        throw _r(h, "variance", x);
      }
    }), p === 0) throw new Error("Cannot calculate variance of an empty array");
    var d = i(m, p);
    if (m = void 0, At(u, function(x) {
      var h = n(x, d);
      m = m === void 0 ? a(h, h) : t(m, a(h, h));
    }), l(m))
      return m;
    switch (f) {
      case "uncorrected":
        return i(m, p);
      case "biased":
        return i(m, p + 1);
      case "unbiased": {
        var v = $e(m) ? m.mul(0) : 0;
        return p === 1 ? v : i(m, p - 1);
      }
      default:
        throw new Error('Unknown normalization "' + f + '". Choose "unbiased" (default), "uncorrected", or "biased".');
    }
  }
  function o(u, f, m) {
    try {
      if (u.length === 0)
        throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
      return s(u, f, (p) => c(p, m));
    } catch (p) {
      throw _r(p, "variance");
    }
  }
}), Sl = "quantileSeq", d_ = ["typed", "?bignumber", "add", "subtract", "divide", "multiply", "partitionSelect", "compare", "isInteger", "smaller", "smallerEq", "larger", "mapSlices"], xd = /* @__PURE__ */ R(Sl, d_, (r) => {
  var {
    typed: e,
    bignumber: t,
    add: n,
    subtract: a,
    divide: i,
    multiply: s,
    partitionSelect: l,
    compare: c,
    isInteger: o,
    smaller: u,
    smallerEq: f,
    larger: m,
    mapSlices: p
  } = r;
  return e(Sl, {
    "Array | Matrix, number | BigNumber": (D, y) => v(D, y, !1),
    "Array | Matrix, number | BigNumber, number": (D, y, w) => d(D, y, !1, w, v),
    "Array | Matrix, number | BigNumber, boolean": v,
    "Array | Matrix, number | BigNumber, boolean, number": (D, y, w, b) => d(D, y, w, b, v),
    "Array | Matrix, Array | Matrix": (D, y) => x(D, y, !1),
    "Array | Matrix, Array | Matrix, number": (D, y, w) => d(D, y, !1, w, x),
    "Array | Matrix, Array | Matrix, boolean": x,
    "Array | Matrix, Array | Matrix, boolean, number": (D, y, w, b) => d(D, y, w, b, x)
  });
  function d(D, y, w, b, g) {
    return p(D, b, (N) => g(N, y, w));
  }
  function v(D, y, w) {
    var b, g = D.valueOf();
    if (u(y, 0))
      throw new Error("N/prob must be non-negative");
    if (f(y, 1))
      return Re(y) ? h(g, y, w) : t(h(g, y, w));
    if (m(y, 1)) {
      if (!o(y))
        throw new Error("N must be a positive integer");
      if (m(y, 4294967295))
        throw new Error("N must be less than or equal to 2^32-1, as that is the maximum length of an Array");
      var N = n(y, 1);
      b = [];
      for (var S = 0; u(S, y); S++) {
        var A = i(S + 1, N);
        b.push(h(g, A, w));
      }
      return Re(y) ? b : t(b);
    }
  }
  function x(D, y, w) {
    for (var b = D.valueOf(), g = y.valueOf(), N = [], S = 0; S < g.length; ++S)
      N.push(h(b, g[S], w));
    return N;
  }
  function h(D, y, w) {
    var b = Ve(D), g = b.length;
    if (g === 0)
      throw new Error("Cannot calculate quantile of an empty sequence");
    var N = Re(y) ? y * (g - 1) : y.times(g - 1), S = Re(y) ? Math.floor(N) : N.floor().toNumber(), A = Re(y) ? N % 1 : N.minus(S);
    if (o(N))
      return w ? b[N] : l(b, Re(y) ? N : N.valueOf());
    var E, M;
    if (w)
      E = b[S], M = b[S + 1];
    else {
      M = l(b, S + 1), E = b[S];
      for (var T = 0; T < S; ++T)
        c(b[T], E) > 0 && (E = b[T]);
    }
    return n(s(E, a(1, A)), s(M, A));
  }
}), El = "std", v_ = ["typed", "map", "sqrt", "variance"], wd = /* @__PURE__ */ R(El, v_, (r) => {
  var {
    typed: e,
    map: t,
    sqrt: n,
    variance: a
  } = r;
  return e(El, {
    // std([a, b, c, d, ...])
    "Array | Matrix": i,
    // std([a, b, c, d, ...], normalization)
    "Array | Matrix, string": i,
    // std([a, b, c, c, ...], dim)
    "Array | Matrix, number | BigNumber": i,
    // std([a, b, c, c, ...], dim, normalization)
    "Array | Matrix, number | BigNumber, string": i,
    // std(a, b, c, d, ...)
    "...": function(l) {
      return i(l);
    }
  });
  function i(s, l) {
    if (s.length === 0)
      throw new SyntaxError("Function std requires one or more parameters (0 provided)");
    try {
      var c = a.apply(null, arguments);
      return Ir(c) ? t(c, n) : n(c);
    } catch (o) {
      throw o instanceof TypeError && o.message.includes(" variance") ? new TypeError(o.message.replace(" variance", " std")) : o;
    }
  }
}), Ml = "corr", h_ = ["typed", "matrix", "mean", "sqrt", "sum", "add", "subtract", "multiply", "pow", "divide"], g_ = /* @__PURE__ */ R(Ml, h_, (r) => {
  var {
    typed: e,
    matrix: t,
    sqrt: n,
    sum: a,
    add: i,
    subtract: s,
    multiply: l,
    pow: c,
    divide: o
  } = r;
  return e(Ml, {
    "Array, Array": function(p, d) {
      return u(p, d);
    },
    "Matrix, Matrix": function(p, d) {
      var v = u(p.toArray(), d.toArray());
      return Array.isArray(v) ? t(v) : v;
    }
  });
  function u(m, p) {
    var d = [];
    if (Array.isArray(m[0]) && Array.isArray(p[0])) {
      if (m.length !== p.length)
        throw new SyntaxError("Dimension mismatch. Array A and B must have the same length.");
      for (var v = 0; v < m.length; v++) {
        if (m[v].length !== p[v].length)
          throw new SyntaxError("Dimension mismatch. Array A and B must have the same number of elements.");
        d.push(f(m[v], p[v]));
      }
      return d;
    } else {
      if (m.length !== p.length)
        throw new SyntaxError("Dimension mismatch. Array A and B must have the same number of elements.");
      return f(m, p);
    }
  }
  function f(m, p) {
    var d = m.length, v = a(m), x = a(p), h = m.reduce((g, N, S) => i(g, l(N, p[S])), 0), D = a(m.map((g) => c(g, 2))), y = a(p.map((g) => c(g, 2))), w = s(l(d, h), l(v, x)), b = n(l(s(l(d, D), c(v, 2)), s(l(d, y), c(x, 2))));
    return o(w, b);
  }
}), Cl = "combinations", y_ = ["typed"], b_ = /* @__PURE__ */ R(Cl, y_, (r) => {
  var {
    typed: e
  } = r;
  return e(Cl, {
    "number, number": Wm,
    "BigNumber, BigNumber": function(n, a) {
      var i = n.constructor, s, l, c = n.minus(a), o = new i(1);
      if (!_l(n) || !_l(a))
        throw new TypeError("Positive integer value expected in function combinations");
      if (a.gt(n))
        throw new TypeError("k must be less than n in function combinations");
      if (s = o, a.lt(c))
        for (l = o; l.lte(c); l = l.plus(o))
          s = s.times(a.plus(l)).dividedBy(l);
      else
        for (l = o; l.lte(a); l = l.plus(o))
          s = s.times(c.plus(l)).dividedBy(l);
      return s;
    }
    // TODO: implement support for collection in combinations
  });
});
function _l(r) {
  return r.isInteger() && r.gte(0);
}
var Tl = "combinationsWithRep", x_ = ["typed"], w_ = /* @__PURE__ */ R(Tl, x_, (r) => {
  var {
    typed: e
  } = r;
  return e(Tl, {
    "number, number": function(n, a) {
      if (!Ne(n) || n < 0)
        throw new TypeError("Positive integer value expected in function combinationsWithRep");
      if (!Ne(a) || a < 0)
        throw new TypeError("Positive integer value expected in function combinationsWithRep");
      if (n < 1)
        throw new TypeError("k must be less than or equal to n + k - 1");
      if (a < n - 1) {
        var i = ot(n, n + a - 1);
        return i / ot(1, a);
      }
      var s = ot(a + 1, n + a - 1);
      return s / ot(1, n - 1);
    },
    "BigNumber, BigNumber": function(n, a) {
      var i = n.constructor, s, l, c = new i(1), o = n.minus(c);
      if (!Fl(n) || !Fl(a))
        throw new TypeError("Positive integer value expected in function combinationsWithRep");
      if (n.lt(c))
        throw new TypeError("k must be less than or equal to n + k - 1 in function combinationsWithRep");
      if (s = c, a.lt(o))
        for (l = c; l.lte(o); l = l.plus(c))
          s = s.times(a.plus(l)).dividedBy(l);
      else
        for (l = c; l.lte(a); l = l.plus(c))
          s = s.times(o.plus(l)).dividedBy(l);
      return s;
    }
  });
});
function Fl(r) {
  return r.isInteger() && r.gte(0);
}
var Bl = "gamma", D_ = ["typed", "config", "multiplyScalar", "pow", "BigNumber", "Complex"], N_ = /* @__PURE__ */ R(Bl, D_, (r) => {
  var {
    typed: e,
    config: t,
    multiplyScalar: n,
    pow: a,
    BigNumber: i,
    Complex: s
  } = r;
  function l(o) {
    if (o.im === 0)
      return za(o.re);
    if (o.re < 0.5) {
      var u = new s(1 - o.re, -o.im), f = new s(Math.PI * o.re, Math.PI * o.im);
      return new s(Math.PI).div(f.sin()).div(l(u));
    }
    o = new s(o.re - 1, o.im);
    for (var m = new s(tn[0], 0), p = 1; p < tn.length; ++p) {
      var d = new s(tn[p], 0);
      m = m.add(d.div(o.add(p)));
    }
    var v = new s(o.re + Vm + 0.5, o.im), x = Math.sqrt(2 * Math.PI), h = v.pow(o.add(0.5)), D = v.neg().exp();
    return m.mul(x).mul(h).mul(D);
  }
  return e(Bl, {
    number: za,
    Complex: l,
    BigNumber: function(u) {
      if (u.isInteger())
        return u.isNegative() || u.isZero() ? new i(1 / 0) : c(u.minus(1));
      if (!u.isFinite())
        return new i(u.isNegative() ? NaN : 1 / 0);
      throw new Error("Integer BigNumber expected");
    }
  });
  function c(o) {
    if (o < 8)
      return new i([1, 1, 2, 6, 24, 120, 720, 5040][o]);
    var u = t.precision + (Math.log(o.toNumber()) | 0), f = i.clone({
      precision: u
    });
    if (o % 2 === 1)
      return o.times(c(new i(o - 1)));
    for (var m = o, p = new f(o), d = o.toNumber(); m > 2; )
      m -= 2, d += m, p = p.times(d);
    return new i(p.toPrecision(i.precision));
  }
}), Ol = "lgamma", A_ = ["Complex", "typed"], S_ = /* @__PURE__ */ R(Ol, A_, (r) => {
  var {
    Complex: e,
    typed: t
  } = r, n = 7, a = 7, i = [-0.029550653594771242, 0.00641025641025641, -0.0019175269175269176, 8417508417508417e-19, -5952380952380953e-19, 7936507936507937e-19, -0.002777777777777778, 0.08333333333333333];
  return t(Ol, {
    number: Ra,
    Complex: s,
    BigNumber: function() {
      throw new Error("mathjs doesn't yet provide an implementation of the algorithm lgamma for BigNumber");
    }
  });
  function s(o) {
    var u = 6.283185307179586, f = 1.1447298858494002, m = 0.1;
    if (o.isNaN())
      return new e(NaN, NaN);
    if (o.im === 0)
      return new e(Ra(o.re), 0);
    if (o.re >= n || Math.abs(o.im) >= a)
      return l(o);
    if (o.re <= m) {
      var p = Hv(u, o.im) * Math.floor(0.5 * o.re + 0.25), d = o.mul(Math.PI).sin().log(), v = s(new e(1 - o.re, -o.im));
      return new e(f, p).sub(d).sub(v);
    } else return o.im >= 0 ? c(o) : c(o.conjugate()).conjugate();
  }
  function l(o) {
    for (var u = o.sub(0.5).mul(o.log()).sub(o).add(Zm), f = new e(1, 0).div(o), m = f.div(o), p = i[0], d = i[1], v = 2 * m.re, x = m.re * m.re + m.im * m.im, h = 2; h < 8; h++) {
      var D = d;
      d = -x * p + i[h], p = v * p + D;
    }
    var y = f.mul(m.mul(p).add(d));
    return u.add(y);
  }
  function c(o) {
    var u = 0, f = 0, m = o;
    for (o = o.add(1); o.re <= n; ) {
      m = m.mul(o);
      var p = m.im < 0 ? 1 : 0;
      p !== 0 && f === 0 && u++, f = p, o = o.add(1);
    }
    return l(o).sub(m.log()).sub(new e(0, u * 2 * Math.PI * 1));
  }
}), Il = "factorial", E_ = ["typed", "gamma"], M_ = /* @__PURE__ */ R(Il, E_, (r) => {
  var {
    typed: e,
    gamma: t
  } = r;
  return e(Il, {
    number: function(a) {
      if (a < 0)
        throw new Error("Value must be non-negative");
      return t(a + 1);
    },
    BigNumber: function(a) {
      if (a.isNegative())
        throw new Error("Value must be non-negative");
      return t(a.plus(1));
    },
    "Array | Matrix": e.referToSelf((n) => (a) => Pe(a, n))
  });
}), $l = "kldivergence", C_ = ["typed", "matrix", "divide", "sum", "multiply", "map", "dotDivide", "log", "isNumeric"], __ = /* @__PURE__ */ R($l, C_, (r) => {
  var {
    typed: e,
    matrix: t,
    divide: n,
    sum: a,
    multiply: i,
    map: s,
    dotDivide: l,
    log: c,
    isNumeric: o
  } = r;
  return e($l, {
    "Array, Array": function(m, p) {
      return u(t(m), t(p));
    },
    "Matrix, Array": function(m, p) {
      return u(m, t(p));
    },
    "Array, Matrix": function(m, p) {
      return u(t(m), p);
    },
    "Matrix, Matrix": function(m, p) {
      return u(m, p);
    }
  });
  function u(f, m) {
    var p = m.size().length, d = f.size().length;
    if (p > 1)
      throw new Error("first object must be one dimensional");
    if (d > 1)
      throw new Error("second object must be one dimensional");
    if (p !== d)
      throw new Error("Length of two vectors must be equal");
    var v = a(f);
    if (v === 0)
      throw new Error("Sum of elements in first object must be non zero");
    var x = a(m);
    if (x === 0)
      throw new Error("Sum of elements in second object must be non zero");
    var h = n(f, a(f)), D = n(m, a(m)), y = a(i(h, s(l(h, D), (w) => c(w))));
    return o(y) ? y : Number.NaN;
  }
}), zl = "multinomial", T_ = ["typed", "add", "divide", "multiply", "factorial", "isInteger", "isPositive"], F_ = /* @__PURE__ */ R(zl, T_, (r) => {
  var {
    typed: e,
    add: t,
    divide: n,
    multiply: a,
    factorial: i,
    isInteger: s,
    isPositive: l
  } = r;
  return e(zl, {
    "Array | Matrix": function(o) {
      var u = 0, f = 1;
      return At(o, function(m) {
        if (!s(m) || !l(m))
          throw new TypeError("Positive integer value expected in function multinomial");
        u = t(u, m), f = a(f, i(m));
      }), n(i(u), f);
    }
  });
}), Rl = "permutations", B_ = ["typed", "factorial"], O_ = /* @__PURE__ */ R(Rl, B_, (r) => {
  var {
    typed: e,
    factorial: t
  } = r;
  return e(Rl, {
    "number | BigNumber": t,
    "number, number": function(a, i) {
      if (!Ne(a) || a < 0)
        throw new TypeError("Positive integer value expected in function permutations");
      if (!Ne(i) || i < 0)
        throw new TypeError("Positive integer value expected in function permutations");
      if (i > a)
        throw new TypeError("second argument k must be less than or equal to first argument n");
      return ot(a - i + 1, a);
    },
    "BigNumber, BigNumber": function(a, i) {
      var s, l;
      if (!ql(a) || !ql(i))
        throw new TypeError("Positive integer value expected in function permutations");
      if (i.gt(a))
        throw new TypeError("second argument k must be less than or equal to first argument n");
      var c = a.mul(0).add(1);
      for (s = c, l = a.minus(i).plus(1); l.lte(a); l = l.plus(1))
        s = s.times(l);
      return s;
    }
    // TODO: implement support for collection in permutations
  });
});
function ql(r) {
  return r.isInteger() && r.gte(0);
}
var ha = { exports: {} }, I_ = ha.exports, Pl;
function $_() {
  return Pl || (Pl = 1, (function(r) {
    (function(e, t, n) {
      function a(c) {
        var o = this, u = l();
        o.next = function() {
          var f = 2091639 * o.s0 + o.c * 23283064365386963e-26;
          return o.s0 = o.s1, o.s1 = o.s2, o.s2 = f - (o.c = f | 0);
        }, o.c = 1, o.s0 = u(" "), o.s1 = u(" "), o.s2 = u(" "), o.s0 -= u(c), o.s0 < 0 && (o.s0 += 1), o.s1 -= u(c), o.s1 < 0 && (o.s1 += 1), o.s2 -= u(c), o.s2 < 0 && (o.s2 += 1), u = null;
      }
      function i(c, o) {
        return o.c = c.c, o.s0 = c.s0, o.s1 = c.s1, o.s2 = c.s2, o;
      }
      function s(c, o) {
        var u = new a(c), f = o && o.state, m = u.next;
        return m.int32 = function() {
          return u.next() * 4294967296 | 0;
        }, m.double = function() {
          return m() + (m() * 2097152 | 0) * 11102230246251565e-32;
        }, m.quick = m, f && (typeof f == "object" && i(f, u), m.state = function() {
          return i(u, {});
        }), m;
      }
      function l() {
        var c = 4022871197, o = function(u) {
          u = String(u);
          for (var f = 0; f < u.length; f++) {
            c += u.charCodeAt(f);
            var m = 0.02519603282416938 * c;
            c = m >>> 0, m -= c, m *= c, c = m >>> 0, m -= c, c += m * 4294967296;
          }
          return (c >>> 0) * 23283064365386963e-26;
        };
        return o;
      }
      t && t.exports ? t.exports = s : this.alea = s;
    })(
      I_,
      r
    );
  })(ha)), ha.exports;
}
var ga = { exports: {} }, z_ = ga.exports, Ul;
function R_() {
  return Ul || (Ul = 1, (function(r) {
    (function(e, t, n) {
      function a(l) {
        var c = this, o = "";
        c.x = 0, c.y = 0, c.z = 0, c.w = 0, c.next = function() {
          var f = c.x ^ c.x << 11;
          return c.x = c.y, c.y = c.z, c.z = c.w, c.w ^= c.w >>> 19 ^ f ^ f >>> 8;
        }, l === (l | 0) ? c.x = l : o += l;
        for (var u = 0; u < o.length + 64; u++)
          c.x ^= o.charCodeAt(u) | 0, c.next();
      }
      function i(l, c) {
        return c.x = l.x, c.y = l.y, c.z = l.z, c.w = l.w, c;
      }
      function s(l, c) {
        var o = new a(l), u = c && c.state, f = function() {
          return (o.next() >>> 0) / 4294967296;
        };
        return f.double = function() {
          do
            var m = o.next() >>> 11, p = (o.next() >>> 0) / 4294967296, d = (m + p) / (1 << 21);
          while (d === 0);
          return d;
        }, f.int32 = o.next, f.quick = f, u && (typeof u == "object" && i(u, o), f.state = function() {
          return i(o, {});
        }), f;
      }
      t && t.exports ? t.exports = s : this.xor128 = s;
    })(
      z_,
      r
    );
  })(ga)), ga.exports;
}
var ya = { exports: {} }, q_ = ya.exports, Ll;
function P_() {
  return Ll || (Ll = 1, (function(r) {
    (function(e, t, n) {
      function a(l) {
        var c = this, o = "";
        c.next = function() {
          var f = c.x ^ c.x >>> 2;
          return c.x = c.y, c.y = c.z, c.z = c.w, c.w = c.v, (c.d = c.d + 362437 | 0) + (c.v = c.v ^ c.v << 4 ^ (f ^ f << 1)) | 0;
        }, c.x = 0, c.y = 0, c.z = 0, c.w = 0, c.v = 0, l === (l | 0) ? c.x = l : o += l;
        for (var u = 0; u < o.length + 64; u++)
          c.x ^= o.charCodeAt(u) | 0, u == o.length && (c.d = c.x << 10 ^ c.x >>> 4), c.next();
      }
      function i(l, c) {
        return c.x = l.x, c.y = l.y, c.z = l.z, c.w = l.w, c.v = l.v, c.d = l.d, c;
      }
      function s(l, c) {
        var o = new a(l), u = c && c.state, f = function() {
          return (o.next() >>> 0) / 4294967296;
        };
        return f.double = function() {
          do
            var m = o.next() >>> 11, p = (o.next() >>> 0) / 4294967296, d = (m + p) / (1 << 21);
          while (d === 0);
          return d;
        }, f.int32 = o.next, f.quick = f, u && (typeof u == "object" && i(u, o), f.state = function() {
          return i(o, {});
        }), f;
      }
      t && t.exports ? t.exports = s : this.xorwow = s;
    })(
      q_,
      r
    );
  })(ya)), ya.exports;
}
var ba = { exports: {} }, U_ = ba.exports, kl;
function L_() {
  return kl || (kl = 1, (function(r) {
    (function(e, t, n) {
      function a(l) {
        var c = this;
        c.next = function() {
          var u = c.x, f = c.i, m, p;
          return m = u[f], m ^= m >>> 7, p = m ^ m << 24, m = u[f + 1 & 7], p ^= m ^ m >>> 10, m = u[f + 3 & 7], p ^= m ^ m >>> 3, m = u[f + 4 & 7], p ^= m ^ m << 7, m = u[f + 7 & 7], m = m ^ m << 13, p ^= m ^ m << 9, u[f] = p, c.i = f + 1 & 7, p;
        };
        function o(u, f) {
          var m, p = [];
          if (f === (f | 0))
            p[0] = f;
          else
            for (f = "" + f, m = 0; m < f.length; ++m)
              p[m & 7] = p[m & 7] << 15 ^ f.charCodeAt(m) + p[m + 1 & 7] << 13;
          for (; p.length < 8; ) p.push(0);
          for (m = 0; m < 8 && p[m] === 0; ++m) ;
          for (m == 8 ? p[7] = -1 : p[m], u.x = p, u.i = 0, m = 256; m > 0; --m)
            u.next();
        }
        o(c, l);
      }
      function i(l, c) {
        return c.x = l.x.slice(), c.i = l.i, c;
      }
      function s(l, c) {
        l == null && (l = +/* @__PURE__ */ new Date());
        var o = new a(l), u = c && c.state, f = function() {
          return (o.next() >>> 0) / 4294967296;
        };
        return f.double = function() {
          do
            var m = o.next() >>> 11, p = (o.next() >>> 0) / 4294967296, d = (m + p) / (1 << 21);
          while (d === 0);
          return d;
        }, f.int32 = o.next, f.quick = f, u && (u.x && i(u, o), f.state = function() {
          return i(o, {});
        }), f;
      }
      t && t.exports ? t.exports = s : this.xorshift7 = s;
    })(
      U_,
      r
    );
  })(ba)), ba.exports;
}
var xa = { exports: {} }, k_ = xa.exports, Hl;
function H_() {
  return Hl || (Hl = 1, (function(r) {
    (function(e, t, n) {
      function a(l) {
        var c = this;
        c.next = function() {
          var u = c.w, f = c.X, m = c.i, p, d;
          return c.w = u = u + 1640531527 | 0, d = f[m + 34 & 127], p = f[m = m + 1 & 127], d ^= d << 13, p ^= p << 17, d ^= d >>> 15, p ^= p >>> 12, d = f[m] = d ^ p, c.i = m, d + (u ^ u >>> 16) | 0;
        };
        function o(u, f) {
          var m, p, d, v, x, h = [], D = 128;
          for (f === (f | 0) ? (p = f, f = null) : (f = f + "\0", p = 0, D = Math.max(D, f.length)), d = 0, v = -32; v < D; ++v)
            f && (p ^= f.charCodeAt((v + 32) % f.length)), v === 0 && (x = p), p ^= p << 10, p ^= p >>> 15, p ^= p << 4, p ^= p >>> 13, v >= 0 && (x = x + 1640531527 | 0, m = h[v & 127] ^= p + x, d = m == 0 ? d + 1 : 0);
          for (d >= 128 && (h[(f && f.length || 0) & 127] = -1), d = 127, v = 512; v > 0; --v)
            p = h[d + 34 & 127], m = h[d = d + 1 & 127], p ^= p << 13, m ^= m << 17, p ^= p >>> 15, m ^= m >>> 12, h[d] = p ^ m;
          u.w = x, u.X = h, u.i = d;
        }
        o(c, l);
      }
      function i(l, c) {
        return c.i = l.i, c.w = l.w, c.X = l.X.slice(), c;
      }
      function s(l, c) {
        l == null && (l = +/* @__PURE__ */ new Date());
        var o = new a(l), u = c && c.state, f = function() {
          return (o.next() >>> 0) / 4294967296;
        };
        return f.double = function() {
          do
            var m = o.next() >>> 11, p = (o.next() >>> 0) / 4294967296, d = (m + p) / (1 << 21);
          while (d === 0);
          return d;
        }, f.int32 = o.next, f.quick = f, u && (u.X && i(u, o), f.state = function() {
          return i(o, {});
        }), f;
      }
      t && t.exports ? t.exports = s : this.xor4096 = s;
    })(
      k_,
      // window object or global
      r
    );
  })(xa)), xa.exports;
}
var wa = { exports: {} }, W_ = wa.exports, Wl;
function G_() {
  return Wl || (Wl = 1, (function(r) {
    (function(e, t, n) {
      function a(l) {
        var c = this, o = "";
        c.next = function() {
          var f = c.b, m = c.c, p = c.d, d = c.a;
          return f = f << 25 ^ f >>> 7 ^ m, m = m - p | 0, p = p << 24 ^ p >>> 8 ^ d, d = d - f | 0, c.b = f = f << 20 ^ f >>> 12 ^ m, c.c = m = m - p | 0, c.d = p << 16 ^ m >>> 16 ^ d, c.a = d - f | 0;
        }, c.a = 0, c.b = 0, c.c = -1640531527, c.d = 1367130551, l === Math.floor(l) ? (c.a = l / 4294967296 | 0, c.b = l | 0) : o += l;
        for (var u = 0; u < o.length + 20; u++)
          c.b ^= o.charCodeAt(u) | 0, c.next();
      }
      function i(l, c) {
        return c.a = l.a, c.b = l.b, c.c = l.c, c.d = l.d, c;
      }
      function s(l, c) {
        var o = new a(l), u = c && c.state, f = function() {
          return (o.next() >>> 0) / 4294967296;
        };
        return f.double = function() {
          do
            var m = o.next() >>> 11, p = (o.next() >>> 0) / 4294967296, d = (m + p) / (1 << 21);
          while (d === 0);
          return d;
        }, f.int32 = o.next, f.quick = f, u && (typeof u == "object" && i(u, o), f.state = function() {
          return i(o, {});
        }), f;
      }
      t && t.exports ? t.exports = s : this.tychei = s;
    })(
      W_,
      r
    );
  })(wa)), wa.exports;
}
var Da = { exports: {} };
const V_ = {}, Z_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: V_
}, Symbol.toStringTag, { value: "Module" })), X_ = /* @__PURE__ */ $x(Z_);
var Y_ = Da.exports, Gl;
function J_() {
  return Gl || (Gl = 1, (function(r) {
    (function(e, t, n) {
      var a = 256, i = 6, s = 52, l = "random", c = n.pow(a, i), o = n.pow(2, s), u = o * 2, f = a - 1, m;
      function p(w, b, g) {
        var N = [];
        b = b == !0 ? { entropy: !0 } : b || {};
        var S = h(x(
          b.entropy ? [w, y(t)] : w ?? D(),
          3
        ), N), A = new d(N), E = function() {
          for (var M = A.g(i), T = c, B = 0; M < o; )
            M = (M + B) * a, T *= a, B = A.g(1);
          for (; M >= u; )
            M /= 2, T /= 2, B >>>= 1;
          return (M + B) / T;
        };
        return E.int32 = function() {
          return A.g(4) | 0;
        }, E.quick = function() {
          return A.g(4) / 4294967296;
        }, E.double = E, h(y(A.S), t), (b.pass || g || function(M, T, B, I) {
          return I && (I.S && v(I, A), M.state = function() {
            return v(A, {});
          }), B ? (n[l] = M, T) : M;
        })(
          E,
          S,
          "global" in b ? b.global : this == n,
          b.state
        );
      }
      function d(w) {
        var b, g = w.length, N = this, S = 0, A = N.i = N.j = 0, E = N.S = [];
        for (g || (w = [g++]); S < a; )
          E[S] = S++;
        for (S = 0; S < a; S++)
          E[S] = E[A = f & A + w[S % g] + (b = E[S])], E[A] = b;
        (N.g = function(M) {
          for (var T, B = 0, I = N.i, O = N.j, _ = N.S; M--; )
            T = _[I = f & I + 1], B = B * a + _[f & (_[I] = _[O = f & O + T]) + (_[O] = T)];
          return N.i = I, N.j = O, B;
        })(a);
      }
      function v(w, b) {
        return b.i = w.i, b.j = w.j, b.S = w.S.slice(), b;
      }
      function x(w, b) {
        var g = [], N = typeof w, S;
        if (b && N == "object")
          for (S in w)
            try {
              g.push(x(w[S], b - 1));
            } catch {
            }
        return g.length ? g : N == "string" ? w : w + "\0";
      }
      function h(w, b) {
        for (var g = w + "", N, S = 0; S < g.length; )
          b[f & S] = f & (N ^= b[f & S] * 19) + g.charCodeAt(S++);
        return y(b);
      }
      function D() {
        try {
          var w;
          return m && (w = m.randomBytes) ? w = w(a) : (w = new Uint8Array(a), (e.crypto || e.msCrypto).getRandomValues(w)), y(w);
        } catch {
          var b = e.navigator, g = b && b.plugins;
          return [+/* @__PURE__ */ new Date(), e, g, e.screen, y(t)];
        }
      }
      function y(w) {
        return String.fromCharCode.apply(0, w);
      }
      if (h(n.random(), t), r.exports) {
        r.exports = p;
        try {
          m = X_;
        } catch {
        }
      } else
        n["seed" + l] = p;
    })(
      // global: `self` in browsers (including strict mode and web workers),
      // otherwise `this` in Node and other environments
      typeof self < "u" ? self : Y_,
      [],
      // pool: entropy pool starts empty
      Math
      // math: package containing random, pow, and seedrandom
    );
  })(Da)), Da.exports;
}
var Ei, Vl;
function Q_() {
  if (Vl) return Ei;
  Vl = 1;
  var r = $_(), e = R_(), t = P_(), n = L_(), a = H_(), i = G_(), s = J_();
  return s.alea = r, s.xor128 = e, s.xorwow = t, s.xorshift7 = n, s.xor4096 = a, s.tychei = i, Ei = s, Ei;
}
var j_ = Q_();
const Dd = /* @__PURE__ */ si(j_);
var K_ = /* @__PURE__ */ Dd(Date.now());
function ln(r) {
  var e;
  function t(a) {
    e = a === null ? K_ : Dd(String(a));
  }
  t(r);
  function n() {
    return e();
  }
  return n;
}
var Zl = "pickRandom", eT = ["typed", "config", "?on"], rT = /* @__PURE__ */ R(Zl, eT, (r) => {
  var {
    typed: e,
    config: t,
    on: n
  } = r, a = ln(t.randomSeed);
  return n && n("config", function(s, l) {
    s.randomSeed !== l.randomSeed && (a = ln(s.randomSeed));
  }), e(Zl, {
    "Array | Matrix": function(l) {
      return i(l, {});
    },
    "Array | Matrix, Object": function(l, c) {
      return i(l, c);
    },
    "Array | Matrix, number": function(l, c) {
      return i(l, {
        number: c
      });
    },
    "Array | Matrix, Array | Matrix": function(l, c) {
      return i(l, {
        weights: c
      });
    },
    "Array | Matrix, Array | Matrix, number": function(l, c, o) {
      return i(l, {
        number: o,
        weights: c
      });
    },
    "Array | Matrix, number, Array | Matrix": function(l, c, o) {
      return i(l, {
        number: c,
        weights: o
      });
    }
  });
  function i(s, l) {
    var {
      number: c,
      weights: o,
      elementWise: u = !0
    } = l, f = typeof c > "u";
    f && (c = 1);
    var m = Ee(s) ? s.create : Ee(o) ? o.create : null;
    s = s.valueOf(), o && (o = o.valueOf()), u === !0 && (s = Ve(s), o = Ve(o));
    var p = 0;
    if (typeof o < "u") {
      if (o.length !== s.length)
        throw new Error("Weights must have the same length as possibles");
      for (var d = 0, v = o.length; d < v; d++) {
        if (!Re(o[d]) || o[d] < 0)
          throw new Error("Weights must be an array of positive numbers");
        p += o[d];
      }
    }
    for (var x = s.length, h = [], D; h.length < c; ) {
      if (typeof o > "u")
        D = s[Math.floor(a() * x)];
      else
        for (var y = a() * p, w = 0, b = s.length; w < b; w++)
          if (y -= o[w], y < 0) {
            D = s[w];
            break;
          }
      h.push(D);
    }
    return f ? h[0] : m ? m(h) : h;
  }
});
function Do(r, e) {
  var t = [];
  if (r = r.slice(0), r.length > 1)
    for (var n = 0, a = r.shift(); n < a; n++)
      t.push(Do(r, e));
  else
    for (var i = 0, s = r.shift(); i < s; i++)
      t.push(e());
  return t;
}
var Xl = "random", tT = ["typed", "config", "?on"], nT = /* @__PURE__ */ R(Xl, tT, (r) => {
  var {
    typed: e,
    config: t,
    on: n
  } = r, a = ln(t.randomSeed);
  return n && n("config", function(l, c) {
    l.randomSeed !== c.randomSeed && (a = ln(l.randomSeed));
  }), e(Xl, {
    "": () => s(0, 1),
    number: (l) => s(0, l),
    "number, number": (l, c) => s(l, c),
    "Array | Matrix": (l) => i(l, 0, 1),
    "Array | Matrix, number": (l, c) => i(l, 0, c),
    "Array | Matrix, number, number": (l, c, o) => i(l, c, o)
  });
  function i(l, c, o) {
    var u = Do(l.valueOf(), () => s(c, o));
    return Ee(l) ? l.create(u, "number") : u;
  }
  function s(l, c) {
    return l + a() * (c - l);
  }
}), Yl = "randomInt", aT = ["typed", "config", "log2", "?on"], iT = /* @__PURE__ */ R(Yl, aT, (r) => {
  var {
    typed: e,
    config: t,
    log2: n,
    on: a
  } = r, i = ln(t.randomSeed);
  return a && a("config", function(o, u) {
    o.randomSeed !== u.randomSeed && (i = ln(o.randomSeed));
  }), e(Yl, {
    "": () => l(0, 2),
    number: (o) => l(0, o),
    "number, number": (o, u) => l(o, u),
    bigint: (o) => c(0n, o),
    "bigint, bigint": c,
    "Array | Matrix": (o) => s(o, 0, 1),
    "Array | Matrix, number": (o, u) => s(o, 0, u),
    "Array | Matrix, number, number": (o, u, f) => s(o, u, f)
  });
  function s(o, u, f) {
    var m = Do(o.valueOf(), () => l(u, f));
    return Ee(o) ? o.create(m, "number") : m;
  }
  function l(o, u) {
    return Math.floor(o + i() * (u - o));
  }
  function c(o, u) {
    var f = 2n ** 30n, m = u - o;
    if (m <= f)
      return o + BigInt(l(0, Number(m)));
    for (var p = n(m), d = m; d >= m; ) {
      d = 0n;
      for (var v = 0; v < p; ++v)
        d = 2n * d + (i() < 0.5 ? 0n : 1n);
    }
    return o + d;
  }
}), Jl = "stirlingS2", oT = ["typed", "addScalar", "subtractScalar", "multiplyScalar", "divideScalar", "pow", "factorial", "combinations", "isNegative", "isInteger", "number", "?bignumber", "larger"], sT = /* @__PURE__ */ R(Jl, oT, (r) => {
  var {
    typed: e,
    addScalar: t,
    subtractScalar: n,
    multiplyScalar: a,
    divideScalar: i,
    pow: s,
    factorial: l,
    combinations: c,
    isNegative: o,
    isInteger: u,
    number: f,
    bignumber: m,
    larger: p
  } = r, d = [], v = [];
  return e(Jl, {
    "number | BigNumber, number | BigNumber": function(h, D) {
      if (!u(h) || o(h) || !u(D) || o(D))
        throw new TypeError("Non-negative integer value expected in function stirlingS2");
      if (p(D, h))
        throw new TypeError("k must be less than or equal to n in function stirlingS2");
      var y = !(Re(h) && Re(D)), w = y ? v : d, b = y ? m : f, g = f(h), N = f(D);
      if (w[g] && w[g].length > N)
        return w[g][N];
      for (var S = 0; S <= g; ++S)
        if (w[S] || (w[S] = [b(S === 0 ? 1 : 0)]), S !== 0)
          for (var A = w[S], E = w[S - 1], M = A.length; M <= S && M <= N; ++M)
            M === S ? A[M] = 1 : A[M] = t(a(b(M), E[M]), E[M - 1]);
      return w[g][N];
    }
  });
}), Ql = "bellNumbers", uT = ["typed", "addScalar", "isNegative", "isInteger", "stirlingS2"], cT = /* @__PURE__ */ R(Ql, uT, (r) => {
  var {
    typed: e,
    addScalar: t,
    isNegative: n,
    isInteger: a,
    stirlingS2: i
  } = r;
  return e(Ql, {
    "number | BigNumber": function(l) {
      if (!a(l) || n(l))
        throw new TypeError("Non-negative integer value expected in function bellNumbers");
      for (var c = 0, o = 0; o <= l; o++)
        c = t(c, i(l, o));
      return c;
    }
  });
}), jl = "catalan", lT = ["typed", "addScalar", "divideScalar", "multiplyScalar", "combinations", "isNegative", "isInteger"], fT = /* @__PURE__ */ R(jl, lT, (r) => {
  var {
    typed: e,
    addScalar: t,
    divideScalar: n,
    multiplyScalar: a,
    combinations: i,
    isNegative: s,
    isInteger: l
  } = r;
  return e(jl, {
    "number | BigNumber": function(o) {
      if (!l(o) || s(o))
        throw new TypeError("Non-negative integer value expected in function catalan");
      return n(i(a(o, 2), o), t(o, 1));
    }
  });
}), Kl = "composition", mT = ["typed", "addScalar", "combinations", "isNegative", "isPositive", "isInteger", "larger"], pT = /* @__PURE__ */ R(Kl, mT, (r) => {
  var {
    typed: e,
    addScalar: t,
    combinations: n,
    isPositive: a,
    isNegative: i,
    isInteger: s,
    larger: l
  } = r;
  return e(Kl, {
    "number | BigNumber, number | BigNumber": function(o, u) {
      if (!s(o) || !a(o) || !s(u) || !a(u))
        throw new TypeError("Positive integer value expected in function composition");
      if (l(u, o))
        throw new TypeError("k must be less than or equal to n in function composition");
      return n(t(o, -1), t(u, -1));
    }
  });
}), ef = "leafCount", dT = ["parse", "typed"], vT = /* @__PURE__ */ R(ef, dT, (r) => {
  var {
    parse: e,
    typed: t
  } = r;
  function n(a) {
    var i = 0;
    return a.forEach((s) => {
      i += n(s);
    }), i || 1;
  }
  return t(ef, {
    Node: function(i) {
      return n(i);
    }
  });
});
function rf(r) {
  return We(r) || ir(r) && r.isUnary() && We(r.args[0]);
}
function Za(r) {
  return !!(We(r) || (st(r) || ir(r)) && r.args.every(Za) || et(r) && Za(r.content));
}
function tf(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Mi(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? tf(Object(t), !0).forEach(function(n) {
      or(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : tf(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
var hT = "simplifyUtil", gT = ["FunctionNode", "OperatorNode", "SymbolNode"], No = /* @__PURE__ */ R(hT, gT, (r) => {
  var {
    FunctionNode: e,
    OperatorNode: t,
    SymbolNode: n
  } = r, a = !0, i = !1, s = "defaultF", l = {
    /*      */
    add: {
      trivial: a,
      total: a,
      commutative: a,
      associative: a
    },
    /**/
    unaryPlus: {
      trivial: a,
      total: a,
      commutative: a,
      associative: a
    },
    /* */
    subtract: {
      trivial: i,
      total: a,
      commutative: i,
      associative: i
    },
    /* */
    multiply: {
      trivial: a,
      total: a,
      commutative: a,
      associative: a
    },
    /*   */
    divide: {
      trivial: i,
      total: a,
      commutative: i,
      associative: i
    },
    /*    */
    paren: {
      trivial: a,
      total: a,
      commutative: a,
      associative: i
    },
    /* */
    defaultF: {
      trivial: i,
      total: a,
      commutative: i,
      associative: i
    }
  }, c = {
    divide: {
      total: i
    },
    log: {
      total: i
    }
  }, o = {
    subtract: {
      total: i
    },
    abs: {
      trivial: a
    },
    log: {
      total: a
    }
  };
  function u(y, w) {
    var b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : l, g = s;
    if (typeof y == "string" ? g = y : ir(y) ? g = y.fn.toString() : st(y) ? g = y.name : et(y) && (g = "paren"), xe(b, g)) {
      var N = b[g];
      if (xe(N, w))
        return N[w];
      if (xe(l, g))
        return l[g][w];
    }
    if (xe(b, s)) {
      var S = b[s];
      return xe(S, w) ? S[w] : l[s][w];
    }
    if (xe(l, g)) {
      var A = l[g];
      if (xe(A, w))
        return A[w];
    }
    return l[s][w];
  }
  function f(y) {
    var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : l;
    return u(y, "commutative", w);
  }
  function m(y) {
    var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : l;
    return u(y, "associative", w);
  }
  function p(y, w) {
    var b = Mi({}, y);
    for (var g in w)
      xe(y, g) ? b[g] = Mi(Mi({}, w[g]), y[g]) : b[g] = w[g];
    return b;
  }
  function d(y, w) {
    if (!y.args || y.args.length === 0)
      return y;
    y.args = v(y, w);
    for (var b = 0; b < y.args.length; b++)
      d(y.args[b], w);
  }
  function v(y, w) {
    var b, g = [], N = function(A) {
      for (var E = 0; E < A.args.length; E++) {
        var M = A.args[E];
        ir(M) && b === M.op ? N(M) : g.push(M);
      }
    };
    return m(y, w) ? (b = y.op, N(y), g) : y.args;
  }
  function x(y, w) {
    if (!(!y.args || y.args.length === 0)) {
      for (var b = D(y), g = y.args.length, N = 0; N < g; N++)
        x(y.args[N], w);
      if (g > 2 && m(y, w)) {
        for (var S = y.args.pop(); y.args.length > 0; )
          S = b([y.args.pop(), S]);
        y.args = S.args;
      }
    }
  }
  function h(y, w) {
    if (!(!y.args || y.args.length === 0)) {
      for (var b = D(y), g = y.args.length, N = 0; N < g; N++)
        h(y.args[N], w);
      if (g > 2 && m(y, w)) {
        for (var S = y.args.shift(); y.args.length > 0; )
          S = b([S, y.args.shift()]);
        y.args = S.args;
      }
    }
  }
  function D(y) {
    return ir(y) ? function(w) {
      try {
        return new t(y.op, y.fn, w, y.implicit);
      } catch (b) {
        return console.error(b), [];
      }
    } : function(w) {
      return new e(new n(y.name), w);
    };
  }
  return {
    createMakeNodeFunction: D,
    hasProperty: u,
    isCommutative: f,
    isAssociative: m,
    mergeContext: p,
    flatten: d,
    allChildren: v,
    unflattenr: x,
    unflattenl: h,
    defaultContext: l,
    realContext: c,
    positiveContext: o
  };
}), yT = "simplify", bT = ["typed", "parse", "equal", "resolve", "simplifyConstant", "simplifyCore", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "SymbolNode", "replacer"], xT = /* @__PURE__ */ R(yT, bT, (r) => {
  var {
    typed: e,
    parse: t,
    equal: n,
    resolve: a,
    simplifyConstant: i,
    simplifyCore: s,
    AccessorNode: l,
    ArrayNode: c,
    ConstantNode: o,
    FunctionNode: u,
    IndexNode: f,
    ObjectNode: m,
    OperatorNode: p,
    ParenthesisNode: d,
    SymbolNode: v,
    replacer: x
  } = r, {
    hasProperty: h,
    isCommutative: D,
    isAssociative: y,
    mergeContext: w,
    flatten: b,
    unflattenr: g,
    unflattenl: N,
    createMakeNodeFunction: S,
    defaultContext: A,
    realContext: E,
    positiveContext: M
  } = No({
    FunctionNode: u,
    OperatorNode: p,
    SymbolNode: v
  });
  e.addConversion({
    from: "Object",
    to: "Map",
    convert: Kt
  });
  var T = e("simplify", {
    Node: L,
    "Node, Map": (q, k) => L(q, !1, k),
    "Node, Map, Object": (q, k, Z) => L(q, !1, k, Z),
    "Node, Array": L,
    "Node, Array, Map": L,
    "Node, Array, Map, Object": L
  });
  e.removeConversion({
    from: "Object",
    to: "Map",
    convert: Kt
  }), T.defaultContext = A, T.realContext = E, T.positiveContext = M;
  function B(q) {
    return q.transform(function(k) {
      return et(k) ? B(k.content) : k;
    });
  }
  var I = {
    true: !0,
    false: !0,
    e: !0,
    i: !0,
    Infinity: !0,
    LN2: !0,
    LN10: !0,
    LOG2E: !0,
    LOG10E: !0,
    NaN: !0,
    phi: !0,
    pi: !0,
    SQRT1_2: !0,
    SQRT2: !0,
    tau: !0
    // null: false,
    // undefined: false,
    // version: false,
  };
  T.rules = [
    s,
    // { l: 'n+0', r: 'n' },     // simplifyCore
    // { l: 'n^0', r: '1' },     // simplifyCore
    // { l: '0*n', r: '0' },     // simplifyCore
    // { l: 'n/n', r: '1'},      // simplifyCore
    // { l: 'n^1', r: 'n' },     // simplifyCore
    // { l: '+n1', r:'n1' },     // simplifyCore
    // { l: 'n--n1', r:'n+n1' }, // simplifyCore
    {
      l: "log(e)",
      r: "1"
    },
    // temporary rules
    // Note initially we tend constants to the right because like-term
    // collection prefers the left, and we would rather collect nonconstants
    {
      s: "n-n1 -> n+-n1",
      // temporarily replace 'subtract' so we can further flatten the 'add' operator
      assuming: {
        subtract: {
          total: !0
        }
      }
    },
    {
      s: "n-n -> 0",
      // partial alternative when we can't always subtract
      assuming: {
        subtract: {
          total: !1
        }
      }
    },
    {
      s: "-(cl*v) -> v * (-cl)",
      // make non-constant terms positive
      assuming: {
        multiply: {
          commutative: !0
        },
        subtract: {
          total: !0
        }
      }
    },
    {
      s: "-(cl*v) -> (-cl) * v",
      // non-commutative version, part 1
      assuming: {
        multiply: {
          commutative: !1
        },
        subtract: {
          total: !0
        }
      }
    },
    {
      s: "-(v*cl) -> v * (-cl)",
      // non-commutative version, part 2
      assuming: {
        multiply: {
          commutative: !1
        },
        subtract: {
          total: !0
        }
      }
    },
    {
      l: "-(n1/n2)",
      r: "-n1/n2"
    },
    {
      l: "-v",
      r: "v * (-1)"
    },
    // finish making non-constant terms positive
    {
      l: "(n1 + n2)*(-1)",
      r: "n1*(-1) + n2*(-1)",
      repeat: !0
    },
    // expand negations to achieve as much sign cancellation as possible
    {
      l: "n/n1^n2",
      r: "n*n1^-n2"
    },
    // temporarily replace 'divide' so we can further flatten the 'multiply' operator
    {
      l: "n/n1",
      r: "n*n1^-1"
    },
    {
      s: "(n1*n2)^n3 -> n1^n3 * n2^n3",
      assuming: {
        multiply: {
          commutative: !0
        }
      }
    },
    {
      s: "(n1*n2)^(-1) -> n2^(-1) * n1^(-1)",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    // expand nested exponentiation
    {
      s: "(n ^ n1) ^ n2 -> n ^ (n1 * n2)",
      assuming: {
        divide: {
          total: !0
        }
      }
      // 1/(1/n) = n needs 1/n to exist
    },
    // collect like factors; into a sum, only do this for nonconstants
    {
      l: " vd   * ( vd   * n1 + n2)",
      r: "vd^2       * n1 +  vd   * n2"
    },
    {
      s: " vd   * (vd^n4 * n1 + n2)   ->  vd^(1+n4)  * n1 +  vd   * n2",
      assuming: {
        divide: {
          total: !0
        }
      }
      // v*1/v = v^(1+-1) needs 1/v
    },
    {
      s: "vd^n3 * ( vd   * n1 + n2)   ->  vd^(n3+1)  * n1 + vd^n3 * n2",
      assuming: {
        divide: {
          total: !0
        }
      }
    },
    {
      s: "vd^n3 * (vd^n4 * n1 + n2)   ->  vd^(n3+n4) * n1 + vd^n3 * n2",
      assuming: {
        divide: {
          total: !0
        }
      }
    },
    {
      l: "n*n",
      r: "n^2"
    },
    {
      s: "n * n^n1 -> n^(n1+1)",
      assuming: {
        divide: {
          total: !0
        }
      }
      // n*1/n = n^(-1+1) needs 1/n
    },
    {
      s: "n^n1 * n^n2 -> n^(n1+n2)",
      assuming: {
        divide: {
          total: !0
        }
      }
      // ditto for n^2*1/n^2
    },
    // Unfortunately, to deal with more complicated cancellations, it
    // becomes necessary to simplify constants twice per pass. It's not
    // terribly expensive compared to matching rules, so this should not
    // pose a performance problem.
    i,
    // First: before collecting like terms
    // collect like terms
    {
      s: "n+n -> 2*n",
      assuming: {
        add: {
          total: !0
        }
      }
      // 2 = 1 + 1 needs to exist
    },
    {
      l: "n+-n",
      r: "0"
    },
    {
      l: "vd*n + vd",
      r: "vd*(n+1)"
    },
    // NOTE: leftmost position is special:
    {
      l: "n3*n1 + n3*n2",
      r: "n3*(n1+n2)"
    },
    // All sub-monomials tried there.
    {
      l: "n3^(-n4)*n1 +   n3  * n2",
      r: "n3^(-n4)*(n1 + n3^(n4+1) *n2)"
    },
    {
      l: "n3^(-n4)*n1 + n3^n5 * n2",
      r: "n3^(-n4)*(n1 + n3^(n4+n5)*n2)"
    },
    // noncommutative additional cases (term collection & factoring)
    {
      s: "n*vd + vd -> (n+1)*vd",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    {
      s: "vd + n*vd -> (1+n)*vd",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    {
      s: "n1*n3 + n2*n3 -> (n1+n2)*n3",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    {
      s: "n^n1 * n -> n^(n1+1)",
      assuming: {
        divide: {
          total: !0
        },
        multiply: {
          commutative: !1
        }
      }
    },
    {
      s: "n1*n3^(-n4) + n2 * n3    -> (n1 + n2*n3^(n4 +  1))*n3^(-n4)",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    {
      s: "n1*n3^(-n4) + n2 * n3^n5 -> (n1 + n2*n3^(n4 + n5))*n3^(-n4)",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    {
      l: "n*cd + cd",
      r: "(n+1)*cd"
    },
    {
      s: "cd*n + cd -> cd*(n+1)",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    {
      s: "cd + cd*n -> cd*(1+n)",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    i,
    // Second: before returning expressions to "standard form"
    // make factors positive (and undo 'make non-constant terms positive')
    {
      s: "(-n)*n1 -> -(n*n1)",
      assuming: {
        subtract: {
          total: !0
        }
      }
    },
    {
      s: "n1*(-n) -> -(n1*n)",
      // in case * non-commutative
      assuming: {
        subtract: {
          total: !0
        },
        multiply: {
          commutative: !1
        }
      }
    },
    // final ordering of constants
    {
      s: "ce+ve -> ve+ce",
      assuming: {
        add: {
          commutative: !0
        }
      },
      imposeContext: {
        add: {
          commutative: !1
        }
      }
    },
    {
      s: "vd*cd -> cd*vd",
      assuming: {
        multiply: {
          commutative: !0
        }
      },
      imposeContext: {
        multiply: {
          commutative: !1
        }
      }
    },
    // undo temporary rules
    // { l: '(-1) * n', r: '-n' }, // #811 added test which proved this is redundant
    {
      l: "n+-n1",
      r: "n-n1"
    },
    // undo replace 'subtract'
    {
      l: "n+-(n1)",
      r: "n-(n1)"
    },
    {
      s: "n*(n1^-1) -> n/n1",
      // undo replace 'divide'; for * commutative
      assuming: {
        multiply: {
          commutative: !0
        }
      }
      // o.w. / not conventional
    },
    {
      s: "n*n1^-n2 -> n/n1^n2",
      assuming: {
        multiply: {
          commutative: !0
        }
      }
      // o.w. / not conventional
    },
    {
      s: "n^-1 -> 1/n",
      assuming: {
        multiply: {
          commutative: !0
        }
      }
      // o.w. / not conventional
    },
    {
      l: "n^1",
      r: "n"
    },
    // can be produced by power cancellation
    {
      s: "n*(n1/n2) -> (n*n1)/n2",
      // '*' before '/'
      assuming: {
        multiply: {
          associative: !0
        }
      }
    },
    {
      s: "n-(n1+n2) -> n-n1-n2",
      // '-' before '+'
      assuming: {
        addition: {
          associative: !0,
          commutative: !0
        }
      }
    },
    // { l: '(n1/n2)/n3', r: 'n1/(n2*n3)' },
    // { l: '(n*n1)/(n*n2)', r: 'n1/n2' },
    // simplifyConstant can leave an extra factor of 1, which can always
    // be eliminated, since the identity always commutes
    {
      l: "1*n",
      r: "n",
      imposeContext: {
        multiply: {
          commutative: !0
        }
      }
    },
    {
      s: "n1/(n2/n3) -> (n1*n3)/n2",
      assuming: {
        multiply: {
          associative: !0
        }
      }
    },
    {
      l: "n1/(-n2)",
      r: "-n1/n2"
    }
  ];
  function O(q, k) {
    var Z = {};
    if (q.s) {
      var Q = q.s.split("->");
      if (Q.length === 2)
        Z.l = Q[0], Z.r = Q[1];
      else
        throw SyntaxError("Could not parse rule: " + q.s);
    } else
      Z.l = q.l, Z.r = q.r;
    Z.l = B(t(Z.l)), Z.r = B(t(Z.r));
    for (var j of ["imposeContext", "repeat", "assuming"])
      j in q && (Z[j] = q[j]);
    if (q.evaluate && (Z.evaluate = t(q.evaluate)), y(Z.l, k)) {
      var ce = !D(Z.l, k), oe;
      ce && (oe = W());
      var he = S(Z.l), we = W();
      Z.expanded = {}, Z.expanded.l = he([Z.l, we]), b(Z.expanded.l, k), g(Z.expanded.l, k), Z.expanded.r = he([Z.r, we]), ce && (Z.expandedNC1 = {}, Z.expandedNC1.l = he([oe, Z.l]), Z.expandedNC1.r = he([oe, Z.r]), Z.expandedNC2 = {}, Z.expandedNC2.l = he([oe, Z.expanded.l]), Z.expandedNC2.r = he([oe, Z.expanded.r]));
    }
    return Z;
  }
  function _(q, k) {
    for (var Z = [], Q = 0; Q < q.length; Q++) {
      var j = q[Q], ce = void 0, oe = typeof j;
      switch (oe) {
        case "string":
          j = {
            s: j
          };
        /* falls through */
        case "object":
          ce = O(j, k);
          break;
        case "function":
          ce = j;
          break;
        default:
          throw TypeError("Unsupported type of rule: " + oe);
      }
      Z.push(ce);
    }
    return Z;
  }
  var P = 0;
  function W() {
    return new v("_p" + P++);
  }
  function L(q, k) {
    var Z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Cn(), Q = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, j = Q.consoleDebug;
    k = _(k || T.rules, Q.context);
    var ce = a(q, Z);
    ce = B(ce);
    for (var oe = {}, he = ce.toString({
      parenthesis: "all"
    }); !oe[he]; ) {
      oe[he] = !0, P = 0;
      var we = he;
      j && console.log("Working on: ", he);
      for (var De = 0; De < k.length; De++) {
        var ye = "";
        if (typeof k[De] == "function" ? (ce = k[De](ce, Q), j && (ye = k[De].name)) : (b(ce, Q.context), ce = ee(ce, k[De], Q.context), j && (ye = "".concat(k[De].l.toString(), " -> ").concat(k[De].r.toString()))), j) {
          var Ae = ce.toString({
            parenthesis: "all"
          });
          Ae !== we && (console.log("Applying", ye, "produced", Ae), we = Ae);
        }
        N(ce, Q.context);
      }
      he = ce.toString({
        parenthesis: "all"
      });
    }
    return ce;
  }
  function J(q, k, Z) {
    var Q = q;
    if (q)
      for (var j = 0; j < q.length; ++j) {
        var ce = ee(q[j], k, Z);
        ce !== q[j] && (Q === q && (Q = q.slice()), Q[j] = ce);
      }
    return Q;
  }
  function ee(q, k, Z) {
    if (k.assuming) {
      for (var Q in k.assuming)
        for (var j in k.assuming[Q])
          if (h(Q, j, Z) !== k.assuming[Q][j])
            return q;
    }
    var ce = w(k.imposeContext, Z), oe = q;
    if (oe instanceof p || oe instanceof u) {
      var he = J(oe.args, k, Z);
      he !== oe.args && (oe = oe.clone(), oe.args = he);
    } else if (oe instanceof d) {
      if (oe.content) {
        var we = ee(oe.content, k, Z);
        we !== oe.content && (oe = new d(we));
      }
    } else if (oe instanceof c) {
      var De = J(oe.items, k, Z);
      De !== oe.items && (oe = new c(De));
    } else if (oe instanceof l) {
      var ye = oe.object;
      oe.object && (ye = ee(oe.object, k, Z));
      var Ae = oe.index;
      oe.index && (Ae = ee(oe.index, k, Z)), (ye !== oe.object || Ae !== oe.index) && (oe = new l(ye, Ae));
    } else if (oe instanceof f) {
      var U = J(oe.dimensions, k, Z);
      U !== oe.dimensions && (oe = new f(U));
    } else if (oe instanceof m) {
      var X = !1, re = {};
      for (var $ in oe.properties)
        re[$] = ee(oe.properties[$], k, Z), re[$] !== oe.properties[$] && (X = !0);
      X && (oe = new m(re));
    }
    var H = k.r, Y = ne(k.l, oe, ce)[0];
    if (!Y && k.expanded && (H = k.expanded.r, Y = ne(k.expanded.l, oe, ce)[0]), !Y && k.expandedNC1 && (H = k.expandedNC1.r, Y = ne(k.expandedNC1.l, oe, ce)[0], Y || (H = k.expandedNC2.r, Y = ne(k.expandedNC2.l, oe, ce)[0])), Y) {
      var K = oe.implicit;
      oe = H.clone(), K && "implicit" in H && (oe.implicit = !0), oe = oe.transform(function(te) {
        return te.isSymbolNode && xe(Y.placeholders, te.name) ? Y.placeholders[te.name].clone() : te;
      });
    }
    return k.repeat && oe !== q && (oe = ee(oe, k, Z)), oe;
  }
  function F(q, k) {
    var Z = [], Q, j, ce = S(q);
    if (D(q, k))
      for (var oe = 0; oe < q.args.length; oe++)
        j = q.args.slice(0), j.splice(oe, 1), Q = j.length === 1 ? j[0] : ce(j), Z.push(ce([q.args[oe], Q]));
    else
      for (var he = 1; he < q.args.length; he++) {
        var we = q.args[0];
        he > 1 && (we = ce(q.args.slice(0, he))), j = q.args.slice(he), Q = j.length === 1 ? j[0] : ce(j), Z.push(ce([we, Q]));
      }
    return Z;
  }
  function G(q, k) {
    var Z = {
      placeholders: {}
    };
    if (!q.placeholders && !k.placeholders)
      return Z;
    if (q.placeholders) {
      if (!k.placeholders)
        return q;
    } else return k;
    for (var Q in q.placeholders)
      if (xe(q.placeholders, Q) && (Z.placeholders[Q] = q.placeholders[Q], xe(k.placeholders, Q) && !ae(q.placeholders[Q], k.placeholders[Q])))
        return null;
    for (var j in k.placeholders)
      xe(k.placeholders, j) && (Z.placeholders[j] = k.placeholders[j]);
    return Z;
  }
  function z(q, k) {
    var Z = [];
    if (q.length === 0 || k.length === 0)
      return Z;
    for (var Q, j = 0; j < q.length; j++)
      for (var ce = 0; ce < k.length; ce++)
        Q = G(q[j], k[ce]), Q && Z.push(Q);
    return Z;
  }
  function le(q) {
    if (q.length === 0)
      return q;
    for (var k = q.reduce(z), Z = [], Q = {}, j = 0; j < k.length; j++) {
      var ce = JSON.stringify(k[j], x);
      Q[ce] || (Q[ce] = !0, Z.push(k[j]));
    }
    return Z;
  }
  function ne(q, k, Z, Q) {
    var j = [{
      placeholders: {}
    }];
    if (q instanceof p && k instanceof p || q instanceof u && k instanceof u) {
      if (q instanceof p) {
        if (q.op !== k.op || q.fn !== k.fn)
          return [];
      } else if (q instanceof u && q.name !== k.name)
        return [];
      if (k.args.length === 1 && q.args.length === 1 || !y(k, Z) && k.args.length === q.args.length || Q) {
        for (var ce = [], oe = 0; oe < q.args.length; oe++) {
          var he = ne(q.args[oe], k.args[oe], Z);
          if (he.length === 0)
            break;
          ce.push(he);
        }
        if (ce.length !== q.args.length) {
          if (!D(k, Z) || // exact match in order needed
          q.args.length === 1)
            return [];
          if (q.args.length > 2)
            throw new Error("permuting >2 commutative non-associative rule arguments not yet implemented");
          var we = ne(q.args[0], k.args[1], Z);
          if (we.length === 0)
            return [];
          var De = ne(q.args[1], k.args[0], Z);
          if (De.length === 0)
            return [];
          ce = [we, De];
        }
        j = le(ce);
      } else if (k.args.length >= 2 && q.args.length === 2) {
        for (var ye = F(k, Z), Ae = [], U = 0; U < ye.length; U++) {
          var X = ne(q, ye[U], Z, !0);
          Ae = Ae.concat(X);
        }
        return Ae;
      } else {
        if (q.args.length > 2)
          throw Error("Unexpected non-binary associative function: " + q.toString());
        return [];
      }
    } else if (q instanceof v) {
      if (q.name.length === 0)
        throw new Error("Symbol in rule has 0 length...!?");
      if (I[q.name]) {
        if (q.name !== k.name)
          return [];
      } else
        switch (q.name[1] >= "a" && q.name[1] <= "z" ? q.name.substring(0, 2) : q.name[0]) {
          case "n":
          case "_p":
            j[0].placeholders[q.name] = k;
            break;
          case "c":
          case "cl":
            if (We(k))
              j[0].placeholders[q.name] = k;
            else
              return [];
            break;
          case "v":
            if (!We(k))
              j[0].placeholders[q.name] = k;
            else
              return [];
            break;
          case "vl":
            if (ur(k))
              j[0].placeholders[q.name] = k;
            else
              return [];
            break;
          case "cd":
            if (rf(k))
              j[0].placeholders[q.name] = k;
            else
              return [];
            break;
          case "vd":
            if (!rf(k))
              j[0].placeholders[q.name] = k;
            else
              return [];
            break;
          case "ce":
            if (Za(k))
              j[0].placeholders[q.name] = k;
            else
              return [];
            break;
          case "ve":
            if (!Za(k))
              j[0].placeholders[q.name] = k;
            else
              return [];
            break;
          default:
            throw new Error("Invalid symbol in rule: " + q.name);
        }
    } else if (q instanceof o) {
      if (!n(q.value, k.value))
        return [];
    } else
      return [];
    return j;
  }
  function ae(q, k) {
    if (q instanceof o && k instanceof o) {
      if (!n(q.value, k.value))
        return !1;
    } else if (q instanceof v && k instanceof v) {
      if (q.name !== k.name)
        return !1;
    } else if (q instanceof p && k instanceof p || q instanceof u && k instanceof u) {
      if (q instanceof p) {
        if (q.op !== k.op || q.fn !== k.fn)
          return !1;
      } else if (q instanceof u && q.name !== k.name)
        return !1;
      if (q.args.length !== k.args.length)
        return !1;
      for (var Z = 0; Z < q.args.length; Z++)
        if (!ae(q.args[Z], k.args[Z]))
          return !1;
    } else
      return !1;
    return !0;
  }
  return T;
}), wT = "simplifyConstant", DT = ["typed", "config", "mathWithTransform", "matrix", "?fraction", "?bignumber", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "SymbolNode"], NT = /* @__PURE__ */ R(wT, DT, (r) => {
  var {
    typed: e,
    config: t,
    mathWithTransform: n,
    matrix: a,
    fraction: i,
    bignumber: s,
    AccessorNode: l,
    ArrayNode: c,
    ConstantNode: o,
    FunctionNode: u,
    IndexNode: f,
    ObjectNode: m,
    OperatorNode: p,
    SymbolNode: d
  } = r, {
    isCommutative: v,
    isAssociative: x,
    allChildren: h,
    createMakeNodeFunction: D
  } = No({
    FunctionNode: u,
    OperatorNode: p,
    SymbolNode: d
  }), y = e("simplifyConstant", {
    Node: (O) => N(I(O, {})),
    "Node, Object": function(_, P) {
      return N(I(_, P));
    }
  });
  function w(O) {
    return Rt(O) ? O.valueOf() : O instanceof Array ? O.map(w) : Ee(O) ? a(w(O.valueOf())) : O;
  }
  function b(O, _, P) {
    try {
      return n[O].apply(null, _);
    } catch {
      return _ = _.map(w), A(n[O].apply(null, _), P);
    }
  }
  var g = e({
    Fraction: M,
    number: function(_) {
      return _ < 0 ? E(new o(-_)) : new o(_);
    },
    BigNumber: function(_) {
      return _ < 0 ? E(new o(-_)) : new o(_);
    },
    bigint: function(_) {
      return _ < 0n ? E(new o(-_)) : new o(_);
    },
    Complex: function(_) {
      throw new Error("Cannot convert Complex number to Node");
    },
    string: function(_) {
      return new o(_);
    },
    Matrix: function(_) {
      return new c(_.valueOf().map((P) => g(P)));
    }
  });
  function N(O) {
    return Xe(O) ? O : g(O);
  }
  function S(O, _) {
    var P = _ && _.exactFractions !== !1;
    if (P && isFinite(O) && i) {
      var W = i(O), L = _ && typeof _.fractionsLimit == "number" ? _.fractionsLimit : 1 / 0;
      if (W.valueOf() === O && W.n < L && W.d < L)
        return W;
    }
    return O;
  }
  var A = e({
    "string, Object": function(_, P) {
      var W = St(_, t);
      if (W === "BigNumber")
        return s === void 0 && go(), s(_);
      if (W === "bigint")
        return BigInt(_);
      if (W === "Fraction")
        return i === void 0 && Hp(), i(_);
      var L = parseFloat(_);
      return S(L, P);
    },
    "Fraction, Object": function(_, P) {
      return _;
    },
    // we don't need options here
    "BigNumber, Object": function(_, P) {
      return _;
    },
    // we don't need options here
    "number, Object": function(_, P) {
      return S(_, P);
    },
    "bigint, Object": function(_, P) {
      return _;
    },
    "Complex, Object": function(_, P) {
      return _.im !== 0 ? _ : S(_.re, P);
    },
    "Matrix, Object": function(_, P) {
      return a(S(_.valueOf()));
    },
    "Array, Object": function(_, P) {
      return _.map(S);
    }
  });
  function E(O) {
    return new p("-", "unaryMinus", [O]);
  }
  function M(O) {
    var _ = (L) => t.number === "BigNumber" && s ? s(L) : Number(L), P = O.s * O.n, W = P < 0n ? new p("-", "unaryMinus", [new o(-_(P))]) : new o(_(P));
    return O.d === 1n ? W : new p("/", "divide", [W, new o(_(O.d))]);
  }
  function T(O, _, P) {
    if (!Pt(_))
      return new l(N(O), N(_));
    if (zr(O) || Ee(O)) {
      for (var W = Array.from(_.dimensions); W.length > 0; )
        if (We(W[0]) && typeof W[0].value != "string") {
          var L = A(W.shift().value, P);
          zr(O) ? O = O.items[L - 1] : (O = O.valueOf()[L - 1], O instanceof Array && (O = a(O)));
        } else if (W.length > 1 && We(W[1]) && typeof W[1].value != "string") {
          var J = A(W[1].value, P), ee = [], F = zr(O) ? O.items : O.valueOf();
          for (var G of F)
            if (zr(G))
              ee.push(G.items[J - 1]);
            else if (Ee(O))
              ee.push(G[J - 1]);
            else
              break;
          if (ee.length === F.length)
            zr(O) ? O = new c(ee) : O = a(ee), W.splice(1, 1);
          else
            break;
        } else
          break;
      return W.length === _.dimensions.length ? new l(N(O), _) : W.length > 0 ? (_ = new f(W), new l(N(O), _)) : O;
    }
    if (zn(O) && _.dimensions.length === 1 && We(_.dimensions[0])) {
      var z = _.dimensions[0].value;
      return z in O.properties ? O.properties[z] : new o();
    }
    return new l(N(O), _);
  }
  function B(O, _, P, W) {
    var L = _.shift(), J = _.reduce((ee, F) => {
      if (!Xe(F)) {
        var G = ee.pop();
        if (Xe(G))
          return [G, F];
        try {
          return ee.push(b(O, [G, F], W)), ee;
        } catch {
          ee.push(G);
        }
      }
      ee.push(N(ee.pop()));
      var z = ee.length === 1 ? ee[0] : P(ee);
      return [P([z, N(F)])];
    }, [L]);
    return J.length === 1 ? J[0] : P([J[0], g(J[1])]);
  }
  function I(O, _) {
    switch (O.type) {
      case "SymbolNode":
        return O;
      case "ConstantNode":
        switch (typeof O.value) {
          case "number":
            return A(O.value, _);
          case "bigint":
            return A(O.value, _);
          case "string":
            return O.value;
          default:
            if (!isNaN(O.value)) return A(O.value, _);
        }
        return O;
      case "FunctionNode":
        if (n[O.name] && n[O.name].rawArgs)
          return O;
        {
          var P = ["add", "multiply"];
          if (!P.includes(O.name)) {
            var W = O.args.map((Q) => I(Q, _));
            if (!W.some(Xe))
              try {
                return b(O.name, W, _);
              } catch {
              }
            if (O.name === "size" && W.length === 1 && zr(W[0])) {
              for (var L = [], J = W[0]; zr(J); )
                L.push(J.items.length), J = J.items[0];
              return a(L);
            }
            return new u(O.name, W.map(N));
          }
        }
      /* falls through */
      case "OperatorNode": {
        var ee = O.fn.toString(), F, G, z = D(O);
        if (ir(O) && O.isUnary())
          F = [I(O.args[0], _)], Xe(F[0]) ? G = z(F) : G = b(ee, F, _);
        else if (x(O, _.context))
          if (F = h(O, _.context), F = F.map((Q) => I(Q, _)), v(ee, _.context)) {
            for (var le = [], ne = [], ae = 0; ae < F.length; ae++)
              Xe(F[ae]) ? ne.push(F[ae]) : le.push(F[ae]);
            le.length > 1 ? (G = B(ee, le, z, _), ne.unshift(G), G = B(ee, ne, z, _)) : G = B(ee, F, z, _);
          } else
            G = B(ee, F, z, _);
        else
          F = O.args.map((Q) => I(Q, _)), G = B(ee, F, z, _);
        return G;
      }
      case "ParenthesisNode":
        return I(O.content, _);
      case "AccessorNode":
        return T(I(O.object, _), I(O.index, _), _);
      case "ArrayNode": {
        var q = O.items.map((Q) => I(Q, _));
        return q.some(Xe) ? new c(q.map(N)) : a(q);
      }
      case "IndexNode":
        return new f(O.dimensions.map((Q) => y(Q, _)));
      case "ObjectNode": {
        var k = {};
        for (var Z in O.properties)
          k[Z] = y(O.properties[Z], _);
        return new m(k);
      }
      /* falls through */
      default:
        throw new Error("Unimplemented node type in simplifyConstant: ".concat(O.type));
    }
  }
  return y;
}), nf = "simplifyCore", AT = ["typed", "parse", "equal", "isZero", "add", "subtract", "multiply", "divide", "pow", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "SymbolNode"], ST = /* @__PURE__ */ R(nf, AT, (r) => {
  var {
    typed: e,
    parse: t,
    equal: n,
    isZero: a,
    add: i,
    subtract: s,
    multiply: l,
    divide: c,
    pow: o,
    AccessorNode: u,
    ArrayNode: f,
    ConstantNode: m,
    FunctionNode: p,
    IndexNode: d,
    ObjectNode: v,
    OperatorNode: x,
    ParenthesisNode: h,
    SymbolNode: D
  } = r, y = new m(0), w = new m(1), b = new m(!0), g = new m(!1);
  function N(M) {
    return ir(M) && ["and", "not", "or"].includes(M.op);
  }
  var {
    hasProperty: S,
    isCommutative: A
  } = No({
    FunctionNode: p,
    OperatorNode: x,
    SymbolNode: D
  });
  function E(M) {
    var T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, B = T ? T.context : void 0;
    if (S(M, "trivial", B)) {
      if (st(M) && M.args.length === 1)
        return E(M.args[0], T);
      var I = !1, O = 0;
      if (M.forEach((ne) => {
        ++O, O === 1 && (I = E(ne, T));
      }), O === 1)
        return I;
    }
    var _ = M;
    if (st(_)) {
      var P = D2(_.name);
      if (P) {
        if (_.args.length > 2 && S(_, "associative", B))
          for (; _.args.length > 2; ) {
            var W = _.args.pop(), L = _.args.pop();
            _.args.push(new x(P, _.name, [W, L]));
          }
        _ = new x(P, _.name, _.args);
      } else
        return new p(E(_.fn), _.args.map((ne) => E(ne, T)));
    }
    if (ir(_) && _.isUnary()) {
      var J = E(_.args[0], T);
      if (_.op === "~" && ir(J) && J.isUnary() && J.op === "~" || _.op === "not" && ir(J) && J.isUnary() && J.op === "not" && N(J.args[0]))
        return J.args[0];
      var ee = !0;
      if (_.op === "-" && ir(J) && (J.isBinary() && J.fn === "subtract" && (_ = new x("-", "subtract", [J.args[1], J.args[0]]), ee = !1), J.isUnary() && J.op === "-"))
        return J.args[0];
      if (ee) return new x(_.op, _.fn, [J]);
    }
    if (ir(_) && _.isBinary()) {
      var F = E(_.args[0], T), G = E(_.args[1], T);
      if (_.op === "+") {
        if (We(F) && a(F.value))
          return G;
        if (We(G) && a(G.value))
          return F;
        ir(G) && G.isUnary() && G.op === "-" && (G = G.args[0], _ = new x("-", "subtract", [F, G]));
      }
      if (_.op === "-")
        return ir(G) && G.isUnary() && G.op === "-" ? E(new x("+", "add", [F, G.args[0]]), T) : We(F) && a(F.value) ? E(new x("-", "unaryMinus", [G])) : We(G) && a(G.value) ? F : new x(_.op, _.fn, [F, G]);
      if (_.op === "*") {
        if (We(F)) {
          if (a(F.value))
            return y;
          if (n(F.value, 1))
            return G;
        }
        if (We(G)) {
          if (a(G.value))
            return y;
          if (n(G.value, 1))
            return F;
          if (A(_, B))
            return new x(_.op, _.fn, [G, F], _.implicit);
        }
        return new x(_.op, _.fn, [F, G], _.implicit);
      }
      if (_.op === "/")
        return We(F) && a(F.value) ? y : We(G) && n(G.value, 1) ? F : new x(_.op, _.fn, [F, G]);
      if (_.op === "^" && We(G)) {
        if (a(G.value))
          return w;
        if (n(G.value, 1))
          return F;
      }
      if (_.op === "and") {
        if (We(F))
          if (F.value) {
            if (N(G)) return G;
            if (We(G))
              return G.value ? b : g;
          } else
            return g;
        if (We(G))
          if (G.value) {
            if (N(F)) return F;
          } else
            return g;
      }
      if (_.op === "or") {
        if (We(F)) {
          if (F.value)
            return b;
          if (N(G)) return G;
        }
        if (We(G)) {
          if (G.value)
            return b;
          if (N(F)) return F;
        }
      }
      return new x(_.op, _.fn, [F, G]);
    }
    if (ir(_))
      return new x(_.op, _.fn, _.args.map((ne) => E(ne, T)));
    if (zr(_))
      return new f(_.items.map((ne) => E(ne, T)));
    if (wt(_))
      return new u(E(_.object, T), E(_.index, T));
    if (Pt(_))
      return new d(_.dimensions.map((ne) => E(ne, T)));
    if (zn(_)) {
      var z = {};
      for (var le in _.properties)
        z[le] = E(_.properties[le], T);
      return new v(z);
    }
    return _;
  }
  return e(nf, {
    Node: E,
    "Node,Object": E
  });
}), ET = "resolve", MT = ["typed", "parse", "ConstantNode", "FunctionNode", "OperatorNode", "ParenthesisNode"], CT = /* @__PURE__ */ R(ET, MT, (r) => {
  var {
    typed: e,
    parse: t,
    ConstantNode: n,
    FunctionNode: a,
    OperatorNode: i,
    ParenthesisNode: s
  } = r;
  function l(c, o) {
    var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : /* @__PURE__ */ new Set();
    if (!o)
      return c;
    if (ur(c)) {
      if (u.has(c.name)) {
        var f = Array.from(u).join(", ");
        throw new ReferenceError("recursive loop of variable definitions among {".concat(f, "}"));
      }
      var m = o.get(c.name);
      if (Xe(m)) {
        var p = new Set(u);
        return p.add(c.name), l(m, o, p);
      } else return typeof m == "number" ? t(String(m)) : m !== void 0 ? new n(m) : c;
    } else if (ir(c)) {
      var d = c.args.map(function(x) {
        return l(x, o, u);
      });
      return new i(c.op, c.fn, d, c.implicit);
    } else {
      if (et(c))
        return new s(l(c.content, o, u));
      if (st(c)) {
        var v = c.args.map(function(x) {
          return l(x, o, u);
        });
        return new a(c.name, v);
      }
    }
    return c.map((x) => l(x, o, u));
  }
  return e("resolve", {
    Node: l,
    "Node, Map | null | undefined": l,
    "Node, Object": (c, o) => l(c, Kt(o)),
    // For arrays and matrices, we map `self` rather than `_resolve`
    // because resolve is fairly expensive anyway, and this way
    // we get nice error messages if one entry in the array has wrong type.
    "Array | Matrix": e.referToSelf((c) => (o) => o.map((u) => c(u))),
    "Array | Matrix, null | undefined": e.referToSelf((c) => (o) => o.map((u) => c(u))),
    "Array, Object": e.referTo("Array,Map", (c) => (o, u) => c(o, Kt(u))),
    "Matrix, Object": e.referTo("Matrix,Map", (c) => (o, u) => c(o, Kt(u))),
    "Array | Matrix, Map": e.referToSelf((c) => (o, u) => o.map((f) => c(f, u)))
  });
}), af = "symbolicEqual", _T = ["parse", "simplify", "typed", "OperatorNode"], TT = /* @__PURE__ */ R(af, _T, (r) => {
  var {
    parse: e,
    simplify: t,
    typed: n,
    OperatorNode: a
  } = r;
  function i(s, l) {
    var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = new a("-", "subtract", [s, l]), u = t(o, {}, c);
    return We(u) && !u.value;
  }
  return n(af, {
    "Node, Node": i,
    "Node, Node, Object": i
  });
}), of = "derivative", FT = ["typed", "config", "parse", "simplify", "equal", "isZero", "numeric", "ConstantNode", "FunctionNode", "OperatorNode", "ParenthesisNode", "SymbolNode"], BT = /* @__PURE__ */ R(of, FT, (r) => {
  var {
    typed: e,
    config: t,
    parse: n,
    simplify: a,
    equal: i,
    isZero: s,
    numeric: l,
    ConstantNode: c,
    FunctionNode: o,
    OperatorNode: u,
    ParenthesisNode: f,
    SymbolNode: m
  } = r;
  function p(w, b) {
    var g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
      simplify: !0
    }, N = /* @__PURE__ */ new Map(), S = b.name;
    function A(M) {
      var T = N.get(M);
      if (T !== void 0)
        return T;
      var B = h(A, M, S);
      return N.set(M, B), B;
    }
    var E = D(w, A);
    return g.simplify ? a(E) : E;
  }
  function d(w) {
    var b = n(w);
    if (!b.isSymbolNode)
      throw new TypeError("Invalid variable. " + "Cannot parse ".concat(JSON.stringify(w), " into a variable in function derivative"));
    return b;
  }
  var v = e(of, {
    "Node, SymbolNode": p,
    "Node, SymbolNode, Object": p,
    "Node, string": (w, b) => p(w, d(b)),
    "Node, string, Object": (w, b, g) => p(w, d(b), g)
    /* TODO: implement and test syntax with order of derivatives -> implement as an option {order: number}
    'Node, SymbolNode, ConstantNode': function (expr, variable, {order}) {
      let res = expr
      for (let i = 0; i < order; i++) {
        <create caching isConst>
        res = _derivative(res, isConst)
      }
      return res
    }
    */
  });
  v._simplify = !0, v.toTex = function(w) {
    return x.apply(null, w.args);
  };
  var x = e("_derivTex", {
    "Node, SymbolNode": function(b, g) {
      return We(b) && Ke(b.value) === "string" ? x(n(b.value).toString(), g.toString(), 1) : x(b.toTex(), g.toString(), 1);
    },
    "Node, ConstantNode": function(b, g) {
      if (Ke(g.value) === "string")
        return x(b, n(g.value));
      throw new Error("The second parameter to 'derivative' is a non-string constant");
    },
    "Node, SymbolNode, ConstantNode": function(b, g, N) {
      return x(b.toString(), g.name, N.value);
    },
    "string, string, number": function(b, g, N) {
      var S;
      return N === 1 ? S = "{d\\over d" + g + "}" : S = "{d^{" + N + "}\\over d" + g + "^{" + N + "}}", S + "\\left[".concat(b, "\\right]");
    }
  }), h = e("_isConst", {
    "function, ConstantNode, string": function() {
      return !0;
    },
    "function, SymbolNode, string": function(b, g, N) {
      return g.name !== N;
    },
    "function, ParenthesisNode, string": function(b, g, N) {
      return b(g.content, N);
    },
    "function, FunctionAssignmentNode, string": function(b, g, N) {
      return g.params.includes(N) ? b(g.expr, N) : !0;
    },
    "function, FunctionNode | OperatorNode, string": function(b, g, N) {
      return g.args.every((S) => b(S, N));
    }
  }), D = e("_derivative", {
    "ConstantNode, function": function() {
      return y(0);
    },
    "SymbolNode, function": function(b, g) {
      return g(b) ? y(0) : y(1);
    },
    "ParenthesisNode, function": function(b, g) {
      return new f(D(b.content, g));
    },
    "FunctionAssignmentNode, function": function(b, g) {
      return g(b) ? y(0) : D(b.expr, g);
    },
    "FunctionNode, function": function(b, g) {
      if (g(b))
        return y(0);
      var N = b.args[0], S, A = !1, E = !1, M;
      switch (b.name) {
        case "cbrt":
          A = !0, M = new u("*", "multiply", [y(3), new u("^", "pow", [N, new u("/", "divide", [y(2), y(3)])])]);
          break;
        case "sqrt":
        case "nthRoot":
          if (b.args.length === 1)
            A = !0, M = new u("*", "multiply", [y(2), new o("sqrt", [N])]);
          else if (b.args.length === 2)
            return S = new u("/", "divide", [y(1), b.args[1]]), D(new u("^", "pow", [N, S]), g);
          break;
        case "log10":
          S = y(10);
        /* fall through! */
        case "log":
          if (!S && b.args.length === 1)
            M = N.clone(), A = !0;
          else if (b.args.length === 1 && S || b.args.length === 2 && g(b.args[1]))
            M = new u("*", "multiply", [N.clone(), new o("log", [S || b.args[1]])]), A = !0;
          else if (b.args.length === 2)
            return D(new u("/", "divide", [new o("log", [N]), new o("log", [b.args[1]])]), g);
          break;
        case "pow":
          if (b.args.length === 2)
            return D(new u("^", "pow", [N, b.args[1]]), g);
          break;
        case "exp":
          M = new o("exp", [N.clone()]);
          break;
        case "sin":
          M = new o("cos", [N.clone()]);
          break;
        case "cos":
          M = new u("-", "unaryMinus", [new o("sin", [N.clone()])]);
          break;
        case "tan":
          M = new u("^", "pow", [new o("sec", [N.clone()]), y(2)]);
          break;
        case "sec":
          M = new u("*", "multiply", [b, new o("tan", [N.clone()])]);
          break;
        case "csc":
          E = !0, M = new u("*", "multiply", [b, new o("cot", [N.clone()])]);
          break;
        case "cot":
          E = !0, M = new u("^", "pow", [new o("csc", [N.clone()]), y(2)]);
          break;
        case "asin":
          A = !0, M = new o("sqrt", [new u("-", "subtract", [y(1), new u("^", "pow", [N.clone(), y(2)])])]);
          break;
        case "acos":
          A = !0, E = !0, M = new o("sqrt", [new u("-", "subtract", [y(1), new u("^", "pow", [N.clone(), y(2)])])]);
          break;
        case "atan":
          A = !0, M = new u("+", "add", [new u("^", "pow", [N.clone(), y(2)]), y(1)]);
          break;
        case "asec":
          A = !0, M = new u("*", "multiply", [new o("abs", [N.clone()]), new o("sqrt", [new u("-", "subtract", [new u("^", "pow", [N.clone(), y(2)]), y(1)])])]);
          break;
        case "acsc":
          A = !0, E = !0, M = new u("*", "multiply", [new o("abs", [N.clone()]), new o("sqrt", [new u("-", "subtract", [new u("^", "pow", [N.clone(), y(2)]), y(1)])])]);
          break;
        case "acot":
          A = !0, E = !0, M = new u("+", "add", [new u("^", "pow", [N.clone(), y(2)]), y(1)]);
          break;
        case "sinh":
          M = new o("cosh", [N.clone()]);
          break;
        case "cosh":
          M = new o("sinh", [N.clone()]);
          break;
        case "tanh":
          M = new u("^", "pow", [new o("sech", [N.clone()]), y(2)]);
          break;
        case "sech":
          E = !0, M = new u("*", "multiply", [b, new o("tanh", [N.clone()])]);
          break;
        case "csch":
          E = !0, M = new u("*", "multiply", [b, new o("coth", [N.clone()])]);
          break;
        case "coth":
          E = !0, M = new u("^", "pow", [new o("csch", [N.clone()]), y(2)]);
          break;
        case "asinh":
          A = !0, M = new o("sqrt", [new u("+", "add", [new u("^", "pow", [N.clone(), y(2)]), y(1)])]);
          break;
        case "acosh":
          A = !0, M = new o("sqrt", [new u("-", "subtract", [new u("^", "pow", [N.clone(), y(2)]), y(1)])]);
          break;
        case "atanh":
          A = !0, M = new u("-", "subtract", [y(1), new u("^", "pow", [N.clone(), y(2)])]);
          break;
        case "asech":
          A = !0, E = !0, M = new u("*", "multiply", [N.clone(), new o("sqrt", [new u("-", "subtract", [y(1), new u("^", "pow", [N.clone(), y(2)])])])]);
          break;
        case "acsch":
          A = !0, E = !0, M = new u("*", "multiply", [new o("abs", [N.clone()]), new o("sqrt", [new u("+", "add", [new u("^", "pow", [N.clone(), y(2)]), y(1)])])]);
          break;
        case "acoth":
          A = !0, E = !0, M = new u("-", "subtract", [y(1), new u("^", "pow", [N.clone(), y(2)])]);
          break;
        case "abs":
          M = new u("/", "divide", [new o(new m("abs"), [N.clone()]), N.clone()]);
          break;
        // Needs digamma function, d/dx(gamma(x)) = gamma(x)digamma(x)
        default:
          throw new Error('Cannot process function "' + b.name + '" in derivative: the function is not supported, undefined, or the number of arguments passed to it are not supported');
      }
      var T, B;
      A ? (T = "/", B = "divide") : (T = "*", B = "multiply");
      var I = D(N, g);
      return E && (I = new u("-", "unaryMinus", [I])), new u(T, B, [I, M]);
    },
    "OperatorNode, function": function(b, g) {
      if (g(b))
        return y(0);
      if (b.op === "+")
        return new u(b.op, b.fn, b.args.map(function(_) {
          return D(_, g);
        }));
      if (b.op === "-") {
        if (b.isUnary())
          return new u(b.op, b.fn, [D(b.args[0], g)]);
        if (b.isBinary())
          return new u(b.op, b.fn, [D(b.args[0], g), D(b.args[1], g)]);
      }
      if (b.op === "*") {
        var N = b.args.filter(function(_) {
          return g(_);
        });
        if (N.length > 0) {
          var S = b.args.filter(function(_) {
            return !g(_);
          }), A = S.length === 1 ? S[0] : new u("*", "multiply", S), E = N.concat(D(A, g));
          return new u("*", "multiply", E);
        }
        return new u("+", "add", b.args.map(function(_) {
          return new u("*", "multiply", b.args.map(function(P) {
            return P === _ ? D(P, g) : P.clone();
          }));
        }));
      }
      if (b.op === "/" && b.isBinary()) {
        var M = b.args[0], T = b.args[1];
        return g(T) ? new u("/", "divide", [D(M, g), T]) : g(M) ? new u("*", "multiply", [new u("-", "unaryMinus", [M]), new u("/", "divide", [D(T, g), new u("^", "pow", [T.clone(), y(2)])])]) : new u("/", "divide", [new u("-", "subtract", [new u("*", "multiply", [D(M, g), T.clone()]), new u("*", "multiply", [M.clone(), D(T, g)])]), new u("^", "pow", [T.clone(), y(2)])]);
      }
      if (b.op === "^" && b.isBinary()) {
        var B = b.args[0], I = b.args[1];
        if (g(B))
          return We(B) && (s(B.value) || i(B.value, 1)) ? y(0) : new u("*", "multiply", [b, new u("*", "multiply", [new o("log", [B.clone()]), D(I.clone(), g)])]);
        if (g(I)) {
          if (We(I)) {
            if (s(I.value))
              return y(0);
            if (i(I.value, 1))
              return D(B, g);
          }
          var O = new u("^", "pow", [B.clone(), new u("-", "subtract", [I, y(1)])]);
          return new u("*", "multiply", [I.clone(), new u("*", "multiply", [D(B, g), O])]);
        }
        return new u("*", "multiply", [new u("^", "pow", [B.clone(), I.clone()]), new u("+", "add", [new u("*", "multiply", [D(B, g), new u("/", "divide", [I.clone(), B.clone()])]), new u("*", "multiply", [D(I, g), new o("log", [B.clone()])])])]);
      }
      throw new Error('Cannot process operator "' + b.op + '" in derivative: the operator is not supported, undefined, or the number of arguments passed to it are not supported');
    }
  });
  function y(w, b) {
    return new c(l(w, St(String(w), t)));
  }
  return v;
}), sf = "rationalize", OT = ["config", "typed", "equal", "isZero", "add", "subtract", "multiply", "divide", "pow", "parse", "simplifyConstant", "simplifyCore", "simplify", "?bignumber", "?fraction", "mathWithTransform", "matrix", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "SymbolNode", "ParenthesisNode"], IT = /* @__PURE__ */ R(sf, OT, (r) => {
  var {
    config: e,
    typed: t,
    equal: n,
    isZero: a,
    add: i,
    subtract: s,
    multiply: l,
    divide: c,
    pow: o,
    parse: u,
    simplifyConstant: f,
    simplifyCore: m,
    simplify: p,
    fraction: d,
    bignumber: v,
    mathWithTransform: x,
    matrix: h,
    AccessorNode: D,
    ArrayNode: y,
    ConstantNode: w,
    FunctionNode: b,
    IndexNode: g,
    ObjectNode: N,
    OperatorNode: S,
    SymbolNode: A,
    ParenthesisNode: E
  } = r;
  function M(_) {
    var P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, W = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, L = B(), J = T(_, P, !0, L.firstRules), ee = J.variables.length, F = {
      exactFractions: !1
    }, G = {
      exactFractions: !0
    };
    if (_ = J.expression, ee >= 1) {
      _ = I(_);
      var z, le, ne = !0, ae = !1;
      _ = p(_, L.firstRules, {}, F);
      for (var q; le = ne ? L.distrDivRules : L.sucDivRules, _ = p(_, le, {}, G), ne = !ne, q = _.toString(), q !== z; )
        ae = !0, z = q;
      ae && (_ = p(_, L.firstRulesAgain, {}, F)), _ = p(_, L.finalRules, {}, F);
    }
    var k = [], Z = {};
    return _.type === "OperatorNode" && _.isBinary() && _.op === "/" ? (ee === 1 && (_.args[0] = O(_.args[0], k), _.args[1] = O(_.args[1])), W && (Z.numerator = _.args[0], Z.denominator = _.args[1])) : (ee === 1 && (_ = O(_, k)), W && (Z.numerator = _, Z.denominator = null)), W ? (Z.coefficients = k, Z.variables = J.variables, Z.expression = _, Z) : _;
  }
  return t(sf, {
    Node: M,
    "Node, boolean": (_, P) => M(_, {}, P),
    "Node, Object": M,
    "Node, Object, boolean": M
  });
  function T(_, P, W, L) {
    var J = [], ee = p(_, L, P, {
      exactFractions: !1
    });
    W = !!W;
    var F = "+-*" + (W ? "/" : "");
    z(ee);
    var G = {};
    return G.expression = ee, G.variables = J, G;
    function z(le) {
      var ne = le.type;
      if (ne === "FunctionNode")
        throw new Error("There is an unsolved function call");
      if (ne === "OperatorNode")
        if (le.op === "^") {
          if (le.args[1].type !== "ConstantNode" || !Ne(parseFloat(le.args[1].value)))
            throw new Error("There is a non-integer exponent");
          z(le.args[0]);
        } else {
          if (!F.includes(le.op))
            throw new Error("Operator " + le.op + " invalid in polynomial expression");
          for (var ae = 0; ae < le.args.length; ae++)
            z(le.args[ae]);
        }
      else if (ne === "SymbolNode") {
        var q = le.name, k = J.indexOf(q);
        k === -1 && J.push(q);
      } else if (ne === "ParenthesisNode")
        z(le.content);
      else if (ne !== "ConstantNode")
        throw new Error("type " + ne + " is not allowed in polynomial expression");
    }
  }
  function B() {
    var _ = [
      m,
      // sCore
      {
        l: "n+n",
        r: "2*n"
      },
      {
        l: "n+-n",
        r: "0"
      },
      f,
      // sConstant
      {
        l: "n*(n1^-1)",
        r: "n/n1"
      },
      {
        l: "n*n1^-n2",
        r: "n/n1^n2"
      },
      {
        l: "n1^-1",
        r: "1/n1"
      },
      {
        l: "n*(n1/n2)",
        r: "(n*n1)/n2"
      },
      {
        l: "1*n",
        r: "n"
      }
    ], P = [
      {
        l: "(-n1)/(-n2)",
        r: "n1/n2"
      },
      // Unary division
      {
        l: "(-n1)*(-n2)",
        r: "n1*n2"
      },
      // Unary multiplication
      {
        l: "n1--n2",
        r: "n1+n2"
      },
      // '--' elimination
      {
        l: "n1-n2",
        r: "n1+(-n2)"
      },
      // Subtraction turn into add with un�ry minus
      {
        l: "(n1+n2)*n3",
        r: "(n1*n3 + n2*n3)"
      },
      // Distributive 1
      {
        l: "n1*(n2+n3)",
        r: "(n1*n2+n1*n3)"
      },
      // Distributive 2
      {
        l: "c1*n + c2*n",
        r: "(c1+c2)*n"
      },
      // Joining constants
      {
        l: "c1*n + n",
        r: "(c1+1)*n"
      },
      // Joining constants
      {
        l: "c1*n - c2*n",
        r: "(c1-c2)*n"
      },
      // Joining constants
      {
        l: "c1*n - n",
        r: "(c1-1)*n"
      },
      // Joining constants
      {
        l: "v/c",
        r: "(1/c)*v"
      },
      // variable/constant (new!)
      {
        l: "v/-c",
        r: "-(1/c)*v"
      },
      // variable/constant (new!)
      {
        l: "-v*-c",
        r: "c*v"
      },
      // Inversion constant and variable 1
      {
        l: "-v*c",
        r: "-c*v"
      },
      // Inversion constant and variable 2
      {
        l: "v*-c",
        r: "-c*v"
      },
      // Inversion constant and variable 3
      {
        l: "v*c",
        r: "c*v"
      },
      // Inversion constant and variable 4
      {
        l: "-(-n1*n2)",
        r: "(n1*n2)"
      },
      // Unary propagation
      {
        l: "-(n1*n2)",
        r: "(-n1*n2)"
      },
      // Unary propagation
      {
        l: "-(-n1+n2)",
        r: "(n1-n2)"
      },
      // Unary propagation
      {
        l: "-(n1+n2)",
        r: "(-n1-n2)"
      },
      // Unary propagation
      {
        l: "(n1^n2)^n3",
        r: "(n1^(n2*n3))"
      },
      // Power to Power
      {
        l: "-(-n1/n2)",
        r: "(n1/n2)"
      },
      // Division and Unary
      {
        l: "-(n1/n2)",
        r: "(-n1/n2)"
      }
    ], W = [
      {
        l: "(n1/n2 + n3/n4)",
        r: "((n1*n4 + n3*n2)/(n2*n4))"
      },
      // Sum of fractions
      {
        l: "(n1/n2 + n3)",
        r: "((n1 + n3*n2)/n2)"
      },
      // Sum fraction with number 1
      {
        l: "(n1 + n2/n3)",
        r: "((n1*n3 + n2)/n3)"
      }
    ], L = [
      {
        l: "(n1/(n2/n3))",
        r: "((n1*n3)/n2)"
      },
      // Division simplification
      {
        l: "(n1/n2/n3)",
        r: "(n1/(n2*n3))"
      }
    ], J = {};
    return J.firstRules = _.concat(P, L), J.distrDivRules = W, J.sucDivRules = L, J.firstRulesAgain = _.concat(P), J.finalRules = [
      m,
      // simplify.rules[0]
      {
        l: "n*-n",
        r: "-n^2"
      },
      // Joining multiply with power 1
      {
        l: "n*n",
        r: "n^2"
      },
      // Joining multiply with power 2
      f,
      // simplify.rules[14] old 3rd index in oldRules
      {
        l: "n*-n^n1",
        r: "-n^(n1+1)"
      },
      // Joining multiply with power 3
      {
        l: "n*n^n1",
        r: "n^(n1+1)"
      },
      // Joining multiply with power 4
      {
        l: "n^n1*-n^n2",
        r: "-n^(n1+n2)"
      },
      // Joining multiply with power 5
      {
        l: "n^n1*n^n2",
        r: "n^(n1+n2)"
      },
      // Joining multiply with power 6
      {
        l: "n^n1*-n",
        r: "-n^(n1+1)"
      },
      // Joining multiply with power 7
      {
        l: "n^n1*n",
        r: "n^(n1+1)"
      },
      // Joining multiply with power 8
      {
        l: "n^n1/-n",
        r: "-n^(n1-1)"
      },
      // Joining multiply with power 8
      {
        l: "n^n1/n",
        r: "n^(n1-1)"
      },
      // Joining division with power 1
      {
        l: "n/-n^n1",
        r: "-n^(1-n1)"
      },
      // Joining division with power 2
      {
        l: "n/n^n1",
        r: "n^(1-n1)"
      },
      // Joining division with power 3
      {
        l: "n^n1/-n^n2",
        r: "n^(n1-n2)"
      },
      // Joining division with power 4
      {
        l: "n^n1/n^n2",
        r: "n^(n1-n2)"
      },
      // Joining division with power 5
      {
        l: "n1+(-n2*n3)",
        r: "n1-n2*n3"
      },
      // Solving useless parenthesis 1
      {
        l: "v*(-c)",
        r: "-c*v"
      },
      // Solving useless unary 2
      {
        l: "n1+-n2",
        r: "n1-n2"
      },
      // Solving +- together (new!)
      {
        l: "v*c",
        r: "c*v"
      },
      // inversion constant with variable
      {
        l: "(n1^n2)^n3",
        r: "(n1^(n2*n3))"
      }
      // Power to Power
    ], J;
  }
  function I(_, P, W) {
    var L = _.type, J = arguments.length > 1;
    if (L === "OperatorNode" && _.isBinary()) {
      var ee = !1, F;
      if (_.op === "^" && (_.args[0].type === "ParenthesisNode" || _.args[0].type === "OperatorNode") && _.args[1].type === "ConstantNode" && (F = parseFloat(_.args[1].value), ee = F >= 2 && Ne(F)), ee) {
        if (F > 2) {
          var G = _.args[0], z = new S("^", "pow", [_.args[0].cloneDeep(), new w(F - 1)]);
          _ = new S("*", "multiply", [G, z]);
        } else
          _ = new S("*", "multiply", [_.args[0], _.args[0].cloneDeep()]);
        J && (W === "content" ? P.content = _ : P.args[W] = _);
      }
    }
    if (L === "ParenthesisNode")
      I(_.content, _, "content");
    else if (L !== "ConstantNode" && L !== "SymbolNode")
      for (var le = 0; le < _.args.length; le++)
        I(_.args[le], _, le);
    if (!J)
      return _;
  }
  function O(_, P) {
    P === void 0 && (P = []), P[0] = 0;
    var W = {};
    W.cte = 1, W.oper = "+", W.fire = "";
    var L = 0, J = "";
    q(_, null, W), L = P.length - 1;
    for (var ee = !0, F, G = L; G >= 0; G--)
      if (P[G] !== 0) {
        var z = new w(ee ? P[G] : Math.abs(P[G])), le = P[G] < 0 ? "-" : "+";
        if (G > 0) {
          var ne = new A(J);
          if (G > 1) {
            var ae = new w(G);
            ne = new S("^", "pow", [ne, ae]);
          }
          P[G] === -1 && ee ? z = new S("-", "unaryMinus", [ne]) : Math.abs(P[G]) === 1 ? z = ne : z = new S("*", "multiply", [z, ne]);
        }
        ee ? F = z : le === "+" ? F = new S("+", "add", [F, z]) : F = new S("-", "subtract", [F, z]), ee = !1;
      }
    if (ee)
      return new w(0);
    return F;
    function q(k, Z, Q) {
      var j = k.type;
      if (j === "FunctionNode")
        throw new Error("There is an unsolved function call");
      if (j === "OperatorNode") {
        if (!"+-*^".includes(k.op)) throw new Error("Operator " + k.op + " invalid");
        if (Z !== null) {
          if ((k.fn === "unaryMinus" || k.fn === "pow") && Z.fn !== "add" && Z.fn !== "subtract" && Z.fn !== "multiply")
            throw new Error("Invalid " + k.op + " placing");
          if ((k.fn === "subtract" || k.fn === "add" || k.fn === "multiply") && Z.fn !== "add" && Z.fn !== "subtract")
            throw new Error("Invalid " + k.op + " placing");
          if ((k.fn === "subtract" || k.fn === "add" || k.fn === "unaryMinus") && Q.noFil !== 0)
            throw new Error("Invalid " + k.op + " placing");
        }
        (k.op === "^" || k.op === "*") && (Q.fire = k.op);
        for (var ce = 0; ce < k.args.length; ce++)
          k.fn === "unaryMinus" && (Q.oper = "-"), (k.op === "+" || k.fn === "subtract") && (Q.fire = "", Q.cte = 1, Q.oper = ce === 0 ? "+" : k.op), Q.noFil = ce, q(k.args[ce], k, Q);
      } else if (j === "SymbolNode") {
        if (k.name !== J && J !== "")
          throw new Error("There is more than one variable");
        if (J = k.name, Z === null) {
          P[1] = 1;
          return;
        }
        if (Z.op === "^" && Q.noFil !== 0)
          throw new Error("In power the variable should be the first parameter");
        if (Z.op === "*" && Q.noFil !== 1)
          throw new Error("In multiply the variable should be the second parameter");
        (Q.fire === "" || Q.fire === "*") && (L < 1 && (P[1] = 0), P[1] += Q.cte * (Q.oper === "+" ? 1 : -1), L = Math.max(1, L));
      } else if (j === "ConstantNode") {
        var oe = parseFloat(k.value);
        if (Z === null) {
          P[0] = oe;
          return;
        }
        if (Z.op === "^") {
          if (Q.noFil !== 1) throw new Error("Constant cannot be powered");
          if (!Ne(oe) || oe <= 0)
            throw new Error("Non-integer exponent is not allowed");
          for (var he = L + 1; he < oe; he++) P[he] = 0;
          oe > L && (P[oe] = 0), P[oe] += Q.cte * (Q.oper === "+" ? 1 : -1), L = Math.max(oe, L);
          return;
        }
        Q.cte = oe, Q.fire === "" && (P[0] += Q.cte * (Q.oper === "+" ? 1 : -1));
      } else
        throw new Error("Type " + j + " is not allowed");
    }
  }
}), uf = "zpk2tf", $T = ["typed", "add", "multiply", "Complex", "number"], zT = /* @__PURE__ */ R(uf, $T, (r) => {
  var {
    typed: e,
    add: t,
    multiply: n,
    Complex: a,
    number: i
  } = r;
  return e(uf, {
    "Array,Array,number": function(o, u, f) {
      return s(o, u, f);
    },
    "Array,Array": function(o, u) {
      return s(o, u, 1);
    },
    "Matrix,Matrix,number": function(o, u, f) {
      return s(o.valueOf(), u.valueOf(), f);
    },
    "Matrix,Matrix": function(o, u) {
      return s(o.valueOf(), u.valueOf(), 1);
    }
  });
  function s(c, o, u) {
    c.some((D) => D.type === "BigNumber") && (c = c.map((D) => i(D))), o.some((D) => D.type === "BigNumber") && (o = o.map((D) => i(D)));
    for (var f = [a(1, 0)], m = [a(1, 0)], p = 0; p < c.length; p++) {
      var d = c[p];
      typeof d == "number" && (d = a(d, 0)), f = l(f, [a(1, 0), a(-d.re, -d.im)]);
    }
    for (var v = 0; v < o.length; v++) {
      var x = o[v];
      typeof x == "number" && (x = a(x, 0)), m = l(m, [a(1, 0), a(-x.re, -x.im)]);
    }
    for (var h = 0; h < f.length; h++)
      f[h] = n(f[h], u);
    return [f, m];
  }
  function l(c, o) {
    for (var u = [], f = 0; f < c.length + o.length - 1; f++) {
      u[f] = a(0, 0);
      for (var m = 0; m < c.length; m++)
        f - m >= 0 && f - m < o.length && (u[f] = t(u[f], n(c[m], o[f - m])));
    }
    return u;
  }
}), cf = "freqz", RT = ["typed", "add", "multiply", "Complex", "divide", "matrix"], qT = /* @__PURE__ */ R(cf, RT, (r) => {
  var {
    typed: e,
    add: t,
    multiply: n,
    Complex: a,
    divide: i,
    matrix: s
  } = r;
  return e(cf, {
    "Array, Array": function(u, f) {
      var m = c(512);
      return l(u, f, m);
    },
    "Array, Array, Array": function(u, f, m) {
      return l(u, f, m);
    },
    "Array, Array, number": function(u, f, m) {
      if (m < 0)
        throw new Error("w must be a positive number");
      var p = c(m);
      return l(u, f, p);
    },
    "Matrix, Matrix": function(u, f) {
      var m = c(512), {
        w: p,
        h: d
      } = l(u.valueOf(), f.valueOf(), m);
      return {
        w: s(p),
        h: s(d)
      };
    },
    "Matrix, Matrix, Matrix": function(u, f, m) {
      var {
        h: p
      } = l(u.valueOf(), f.valueOf(), m.valueOf());
      return {
        h: s(p),
        w: s(m)
      };
    },
    "Matrix, Matrix, number": function(u, f, m) {
      if (m < 0)
        throw new Error("w must be a positive number");
      var p = c(m), {
        h: d
      } = l(u.valueOf(), f.valueOf(), p);
      return {
        h: s(d),
        w: s(p)
      };
    }
  });
  function l(o, u, f) {
    for (var m = [], p = [], d = 0; d < f.length; d++) {
      for (var v = a(0, 0), x = a(0, 0), h = 0; h < o.length; h++)
        v = t(v, n(o[h], a(Math.cos(-h * f[d]), Math.sin(-h * f[d]))));
      for (var D = 0; D < u.length; D++)
        x = t(x, n(u[D], a(Math.cos(-D * f[d]), Math.sin(-D * f[d]))));
      m.push(v), p.push(x);
    }
    for (var y = [], w = 0; w < m.length; w++)
      y.push(i(m[w], p[w]));
    return {
      h: y,
      w: f
    };
  }
  function c(o) {
    for (var u = [], f = 0; f < o; f++)
      u.push(f / o * Math.PI);
    return u;
  }
}), PT = "reviver", UT = ["classes"], LT = /* @__PURE__ */ R(PT, UT, (r) => {
  var {
    classes: e
  } = r;
  return function(n, a) {
    var i = e[a && a.mathjs];
    return i && typeof i.fromJSON == "function" ? i.fromJSON(a) : a;
  };
}), kT = "replacer", HT = [], WT = /* @__PURE__ */ R(kT, HT, () => function(e, t) {
  return typeof t == "number" && (!isFinite(t) || isNaN(t)) ? {
    mathjs: "number",
    value: String(t)
  } : typeof t == "bigint" ? {
    mathjs: "bigint",
    value: String(t)
  } : t;
}), GT = "14.9.1", VT = /* @__PURE__ */ R("true", [], () => !0), ZT = /* @__PURE__ */ R("false", [], () => !1), XT = /* @__PURE__ */ R("null", [], () => null), YT = /* @__PURE__ */ Rr("Infinity", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? new t(1 / 0) : 1 / 0;
}), JT = /* @__PURE__ */ Rr("NaN", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? new t(NaN) : NaN;
}), QT = /* @__PURE__ */ Rr("pi", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? wo(t) : Sg;
}), jT = /* @__PURE__ */ Rr("tau", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? _w(t) : Eg;
}), KT = /* @__PURE__ */ Rr("e", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? Mw(t) : Mg;
}), e3 = /* @__PURE__ */ Rr("phi", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? Cw(t) : Cg;
}), r3 = /* @__PURE__ */ Rr("LN2", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? new t(2).ln() : Math.LN2;
}), t3 = /* @__PURE__ */ Rr("LN10", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? new t(10).ln() : Math.LN10;
}), n3 = /* @__PURE__ */ Rr("LOG2E", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? new t(1).div(new t(2).ln()) : Math.LOG2E;
}), a3 = /* @__PURE__ */ Rr("LOG10E", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? new t(1).div(new t(10).ln()) : Math.LOG10E;
}), i3 = /* @__PURE__ */ Rr(
  // eslint-disable-line camelcase
  "SQRT1_2",
  ["config", "?BigNumber"],
  (r) => {
    var {
      config: e,
      BigNumber: t
    } = r;
    return e.number === "BigNumber" ? new t("0.5").sqrt() : Math.SQRT1_2;
  }
), o3 = /* @__PURE__ */ Rr("SQRT2", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? new t(2).sqrt() : Math.SQRT2;
}), s3 = /* @__PURE__ */ Rr("i", ["Complex"], (r) => {
  var {
    Complex: e
  } = r;
  return e.I;
}), u3 = /* @__PURE__ */ R("PI", ["pi"], (r) => {
  var {
    pi: e
  } = r;
  return e;
}), c3 = /* @__PURE__ */ R("E", ["e"], (r) => {
  var {
    e
  } = r;
  return e;
}), l3 = /* @__PURE__ */ R("version", [], () => GT);
function Rr(r, e, t) {
  return R(r, e, t, {
    recreateOnConfigChange: !0
  });
}
var f3 = /* @__PURE__ */ ze("speedOfLight", "299792458", "m s^-1"), m3 = /* @__PURE__ */ ze("gravitationConstant", "6.67430e-11", "m^3 kg^-1 s^-2"), p3 = /* @__PURE__ */ ze("planckConstant", "6.62607015e-34", "J s"), d3 = /* @__PURE__ */ ze("reducedPlanckConstant", "1.0545718176461565e-34", "J s"), v3 = /* @__PURE__ */ ze("magneticConstant", "1.25663706212e-6", "N A^-2"), h3 = /* @__PURE__ */ ze("electricConstant", "8.8541878128e-12", "F m^-1"), g3 = /* @__PURE__ */ ze("vacuumImpedance", "376.730313667", "ohm"), y3 = /* @__PURE__ */ ze("coulomb", "8.987551792261171e9", "N m^2 C^-2"), b3 = /* @__PURE__ */ ze("coulombConstant", "8.987551792261171e9", "N m^2 C^-2"), x3 = /* @__PURE__ */ ze("elementaryCharge", "1.602176634e-19", "C"), w3 = /* @__PURE__ */ ze("bohrMagneton", "9.2740100783e-24", "J T^-1"), D3 = /* @__PURE__ */ ze("conductanceQuantum", "7.748091729863649e-5", "S"), N3 = /* @__PURE__ */ ze("inverseConductanceQuantum", "12906.403729652257", "ohm"), A3 = /* @__PURE__ */ ze("magneticFluxQuantum", "2.0678338484619295e-15", "Wb"), S3 = /* @__PURE__ */ ze("nuclearMagneton", "5.0507837461e-27", "J T^-1"), E3 = /* @__PURE__ */ ze("klitzing", "25812.807459304513", "ohm"), M3 = /* @__PURE__ */ ze("bohrRadius", "5.29177210903e-11", "m"), C3 = /* @__PURE__ */ ze("classicalElectronRadius", "2.8179403262e-15", "m"), _3 = /* @__PURE__ */ ze("electronMass", "9.1093837015e-31", "kg"), T3 = /* @__PURE__ */ ze("fermiCoupling", "1.1663787e-5", "GeV^-2"), F3 = ci("fineStructure", 0.0072973525693), B3 = /* @__PURE__ */ ze("hartreeEnergy", "4.3597447222071e-18", "J"), O3 = /* @__PURE__ */ ze("protonMass", "1.67262192369e-27", "kg"), I3 = /* @__PURE__ */ ze("deuteronMass", "3.3435830926e-27", "kg"), $3 = /* @__PURE__ */ ze("neutronMass", "1.6749271613e-27", "kg"), z3 = /* @__PURE__ */ ze("quantumOfCirculation", "3.6369475516e-4", "m^2 s^-1"), R3 = /* @__PURE__ */ ze("rydberg", "10973731.568160", "m^-1"), q3 = /* @__PURE__ */ ze("thomsonCrossSection", "6.6524587321e-29", "m^2"), P3 = ci("weakMixingAngle", 0.2229), U3 = ci("efimovFactor", 22.7), L3 = /* @__PURE__ */ ze("atomicMass", "1.66053906660e-27", "kg"), k3 = /* @__PURE__ */ ze("avogadro", "6.02214076e23", "mol^-1"), H3 = /* @__PURE__ */ ze("boltzmann", "1.380649e-23", "J K^-1"), W3 = /* @__PURE__ */ ze("faraday", "96485.33212331001", "C mol^-1"), G3 = /* @__PURE__ */ ze("firstRadiation", "3.7417718521927573e-16", "W m^2"), V3 = /* @__PURE__ */ ze("loschmidt", "2.686780111798444e25", "m^-3"), Z3 = /* @__PURE__ */ ze("gasConstant", "8.31446261815324", "J K^-1 mol^-1"), X3 = /* @__PURE__ */ ze("molarPlanckConstant", "3.990312712893431e-10", "J s mol^-1"), Y3 = /* @__PURE__ */ ze("molarVolume", "0.022413969545014137", "m^3 mol^-1"), J3 = ci("sackurTetrode", -1.16487052358), Q3 = /* @__PURE__ */ ze("secondRadiation", "0.014387768775039337", "m K"), j3 = /* @__PURE__ */ ze("stefanBoltzmann", "5.67037441918443e-8", "W m^-2 K^-4"), K3 = /* @__PURE__ */ ze("wienDisplacement", "2.897771955e-3", "m K"), eF = /* @__PURE__ */ ze("molarMass", "0.99999999965e-3", "kg mol^-1"), rF = /* @__PURE__ */ ze("molarMassC12", "11.9999999958e-3", "kg mol^-1"), tF = /* @__PURE__ */ ze("gravity", "9.80665", "m s^-2"), nF = /* @__PURE__ */ ze("planckLength", "1.616255e-35", "m"), aF = /* @__PURE__ */ ze("planckMass", "2.176435e-8", "kg"), iF = /* @__PURE__ */ ze("planckTime", "5.391245e-44", "s"), oF = /* @__PURE__ */ ze("planckCharge", "1.87554603778e-18", "C"), sF = /* @__PURE__ */ ze("planckTemperature", "1.416785e+32", "K");
function ze(r, e, t) {
  var n = ["config", "Unit", "BigNumber"];
  return R(r, n, (a) => {
    var {
      config: i,
      Unit: s,
      BigNumber: l
    } = a, c = i.number === "BigNumber" ? new l(e) : parseFloat(e), o = new s(c, t);
    return o.fixPrefix = !0, o;
  });
}
function ci(r, e) {
  var t = ["config", "BigNumber"];
  return R(r, t, (n) => {
    var {
      config: a,
      BigNumber: i
    } = n;
    return a.number === "BigNumber" ? new i(e) : e;
  });
}
function lf(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function uF(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? lf(Object(t), !0).forEach(function(n) {
      or(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : lf(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
var cF = "mapSlices", lF = ["typed", "isInteger"], fF = /* @__PURE__ */ R(cF, lF, (r) => {
  var {
    typed: e,
    isInteger: t
  } = r, n = Vi({
    typed: e,
    isInteger: t
  });
  return e("mapSlices", {
    "...any": function(i) {
      var s = i[1];
      Re(s) ? i[1] = s - 1 : $e(s) && (i[1] = s.minus(1));
      try {
        return n.apply(null, i);
      } catch (l) {
        throw Tr(l);
      }
    }
  });
}, uF({
  isTransformFunction: !0
}, Vi.meta)), mF = "column", pF = ["typed", "Index", "matrix", "range"], dF = /* @__PURE__ */ R(mF, pF, (r) => {
  var {
    typed: e,
    Index: t,
    matrix: n,
    range: a
  } = r, i = zp({
    typed: e,
    Index: t,
    matrix: n,
    range: a
  });
  return e("column", {
    "...any": function(l) {
      var c = l.length - 1, o = l[c];
      Re(o) && (l[c] = o - 1);
      try {
        return i.apply(null, l);
      } catch (u) {
        throw Tr(u);
      }
    }
  });
}, {
  isTransformFunction: !0
});
function Ao(r, e, t) {
  var n = r.filter(function(c) {
    return ur(c) && !(c.name in e) && !t.has(c.name);
  })[0];
  if (!n)
    throw new Error('No undefined variable found in inline expression "' + r + '"');
  var a = n.name, i = /* @__PURE__ */ new Map(), s = new Ef(t, i, /* @__PURE__ */ new Set([a])), l = r.compile();
  return function(o) {
    return i.set(a, o), l.evaluate(s);
  };
}
var vF = "transformCallback", hF = ["typed"], So = /* @__PURE__ */ R(vF, hF, (r) => {
  var {
    typed: e
  } = r;
  return function(n, a) {
    return e.isTypedFunction(n) ? t(n, a) : ff(n, n.length, a);
  };
  function t(n, a) {
    var i = Object.fromEntries(Object.entries(n.signatures).map((s) => {
      var [l, c] = s, o = l.split(",").length;
      return e.isTypedFunction(c) ? [l, t(c, a)] : [l, ff(c, o, a)];
    }));
    return typeof n.name == "string" ? e(n.name, i) : e(i);
  }
});
function ff(r, e, t) {
  return e === t ? r : e === t + 1 ? function() {
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    var s = a.slice(0, t), l = mf(a[t]);
    return r(...s, l);
  } : e > t + 1 ? function() {
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    var s = a.slice(0, t), l = mf(a[t]), c = a.slice(t + 1);
    return r(...s, l, ...c);
  } : r;
}
function mf(r) {
  return r.map((e) => e + 1);
}
var gF = "filter", yF = ["typed"], bF = /* @__PURE__ */ R(gF, yF, (r) => {
  var {
    typed: e
  } = r;
  function t(a, i, s) {
    var l = Rp({
      typed: e
    }), c = So({
      typed: e
    });
    if (a.length === 0)
      return l();
    var o = a[0];
    if (a.length === 1)
      return l(o);
    var u = a.length - 1, f = a[u];
    return o && (o = n(o, s)), f && (ur(f) || mn(f) ? f = n(f, s) : f = Ao(f, i, s)), l(o, c(f, u));
  }
  t.rawArgs = !0;
  function n(a, i) {
    return a.compile().evaluate(i);
  }
  return t;
}, {
  isTransformFunction: !0
}), xF = "forEach", wF = ["typed"], DF = /* @__PURE__ */ R(xF, wF, (r) => {
  var {
    typed: e
  } = r, t = qp({
    typed: e
  }), n = So({
    typed: e
  });
  function a(s, l, c) {
    if (s.length === 0)
      return t();
    var o = s[0];
    if (s.length === 1)
      return t(o);
    var u = s.length - 1, f = s[u];
    return o && (o = i(o, c)), f && (ur(f) || mn(f) ? f = i(f, c) : f = Ao(f, l, c)), t(o, n(f, u));
  }
  a.rawArgs = !0;
  function i(s, l) {
    return s.compile().evaluate(l);
  }
  return a;
}, {
  isTransformFunction: !0
}), NF = "index", AF = ["Index", "getMatrixDataType"], SF = /* @__PURE__ */ R(NF, AF, (r) => {
  var {
    Index: e,
    getMatrixDataType: t
  } = r;
  return function() {
    for (var a = [], i = 0, s = arguments.length; i < s; i++) {
      var l = arguments[i];
      if (ja(l))
        l.start--, l.end -= l.step > 0 ? 0 : 2;
      else if (l && l.isSet === !0)
        l = l.map(function(o) {
          return o - 1;
        });
      else if (Ye(l) || Ee(l))
        t(l) !== "boolean" && (l = l.map(function(o) {
          return o - 1;
        }));
      else if (Re(l) || en(l))
        l--;
      else if ($e(l))
        l = l.toNumber() - 1;
      else if (typeof l != "string") throw new TypeError("Dimension must be an Array, Matrix, number, bigint, string, or Range");
      a[i] = l;
    }
    var c = new e();
    return e.apply(c, a), c;
  };
}, {
  isTransformFunction: !0
}), EF = "map", MF = ["typed"], CF = /* @__PURE__ */ R(EF, MF, (r) => {
  var {
    typed: e
  } = r, t = Lp({
    typed: e
  }), n = So({
    typed: e
  });
  function a(i, s, l) {
    if (i.length === 0)
      return t();
    if (i.length === 1)
      return t(i[0]);
    var c = i.length - 1, o = i.slice(0, c), u = i[c];
    return o = o.map((m) => f(m, l)), u && (ur(u) || mn(u) ? u = f(u, l) : u = Ao(u, s, l)), t(...o, n(u, c));
    function f(m, p) {
      return m.compile().evaluate(p);
    }
  }
  return a.rawArgs = !0, a;
}, {
  isTransformFunction: !0
});
function _F(r) {
  return Re(r) ? r - 1 : $e(r) ? r.minus(1) : r;
}
function TF(r) {
  return Re(r) || $e(r);
}
function Ct(r) {
  if (r.length === 2 && Ir(r[0])) {
    r = r.slice();
    var e = r[1];
    TF(e) && (r[1] = _F(e));
  }
  return r;
}
var FF = "max", BF = ["typed", "config", "numeric", "larger", "isNaN"], OF = /* @__PURE__ */ R(FF, BF, (r) => {
  var {
    typed: e,
    config: t,
    numeric: n,
    larger: a,
    isNaN: i
  } = r, s = td({
    typed: e,
    config: t,
    numeric: n,
    larger: a,
    isNaN: i
  });
  return e("max", {
    "...any": function(c) {
      c = Ct(c);
      try {
        return s.apply(null, c);
      } catch (o) {
        throw Tr(o);
      }
    }
  });
}, {
  isTransformFunction: !0
}), IF = "mean", $F = ["typed", "add", "divide"], zF = /* @__PURE__ */ R(IF, $F, (r) => {
  var {
    typed: e,
    add: t,
    divide: n
  } = r, a = yd({
    typed: e,
    add: t,
    divide: n
  });
  return e("mean", {
    "...any": function(s) {
      s = Ct(s);
      try {
        return a.apply(null, s);
      } catch (l) {
        throw Tr(l);
      }
    }
  });
}, {
  isTransformFunction: !0
}), RF = "min", qF = ["typed", "config", "numeric", "smaller", "isNaN"], PF = /* @__PURE__ */ R(RF, qF, (r) => {
  var {
    typed: e,
    config: t,
    numeric: n,
    smaller: a,
    isNaN: i
  } = r, s = nd({
    typed: e,
    config: t,
    numeric: n,
    smaller: a,
    isNaN: i
  });
  return e("min", {
    "...any": function(c) {
      c = Ct(c);
      try {
        return s.apply(null, c);
      } catch (o) {
        throw Tr(o);
      }
    }
  });
}, {
  isTransformFunction: !0
}), UF = "range", LF = ["typed", "config", "?matrix", "?bignumber", "equal", "smaller", "smallerEq", "larger", "largerEq", "add", "isZero", "isPositive"], kF = /* @__PURE__ */ R(UF, LF, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    bignumber: a,
    equal: i,
    smaller: s,
    smallerEq: l,
    larger: c,
    largerEq: o,
    add: u,
    isZero: f,
    isPositive: m
  } = r, p = Gp({
    typed: e,
    config: t,
    matrix: n,
    bignumber: a,
    equal: i,
    smaller: s,
    smallerEq: l,
    larger: c,
    largerEq: o,
    add: u,
    isZero: f,
    isPositive: m
  });
  return e("range", {
    "...any": function(v) {
      var x = v.length - 1, h = v[x];
      return typeof h != "boolean" && v.push(!0), p.apply(null, v);
    }
  });
}, {
  isTransformFunction: !0
}), HF = "row", WF = ["typed", "Index", "matrix", "range"], GF = /* @__PURE__ */ R(HF, WF, (r) => {
  var {
    typed: e,
    Index: t,
    matrix: n,
    range: a
  } = r, i = Vp({
    typed: e,
    Index: t,
    matrix: n,
    range: a
  });
  return e("row", {
    "...any": function(l) {
      var c = l.length - 1, o = l[c];
      Re(o) && (l[c] = o - 1);
      try {
        return i.apply(null, l);
      } catch (u) {
        throw Tr(u);
      }
    }
  });
}, {
  isTransformFunction: !0
}), VF = "subset", ZF = ["typed", "matrix", "zeros", "add"], XF = /* @__PURE__ */ R(VF, ZF, (r) => {
  var {
    typed: e,
    matrix: t,
    zeros: n,
    add: a
  } = r, i = yo({
    typed: e,
    matrix: t,
    zeros: n,
    add: a
  });
  return e("subset", {
    "...any": function(l) {
      try {
        return i.apply(null, l);
      } catch (c) {
        throw Tr(c);
      }
    }
  });
}, {
  isTransformFunction: !0
}), YF = "concat", JF = ["typed", "matrix", "isInteger"], QF = /* @__PURE__ */ R(YF, JF, (r) => {
  var {
    typed: e,
    matrix: t,
    isInteger: n
  } = r, a = ho({
    typed: e,
    matrix: t,
    isInteger: n
  });
  return e("concat", {
    "...any": function(s) {
      var l = s.length - 1, c = s[l];
      Re(c) ? s[l] = c - 1 : $e(c) && (s[l] = c.minus(1));
      try {
        return a.apply(null, s);
      } catch (o) {
        throw Tr(o);
      }
    }
  });
}, {
  isTransformFunction: !0
}), pf = "diff", jF = ["typed", "matrix", "subtract", "number", "bignumber"], KF = /* @__PURE__ */ R(pf, jF, (r) => {
  var {
    typed: e,
    matrix: t,
    subtract: n,
    number: a,
    bignumber: i
  } = r, s = kp({
    typed: e,
    matrix: t,
    subtract: n,
    number: a,
    bignumber: i
  });
  return e(pf, {
    "...any": function(c) {
      c = Ct(c);
      try {
        return s.apply(null, c);
      } catch (o) {
        throw Tr(o);
      }
    }
  });
}, {
  isTransformFunction: !0
}), eB = "std", rB = ["typed", "map", "sqrt", "variance"], tB = /* @__PURE__ */ R(eB, rB, (r) => {
  var {
    typed: e,
    map: t,
    sqrt: n,
    variance: a
  } = r, i = wd({
    typed: e,
    map: t,
    sqrt: n,
    variance: a
  });
  return e("std", {
    "...any": function(l) {
      l = Ct(l);
      try {
        return i.apply(null, l);
      } catch (c) {
        throw Tr(c);
      }
    }
  });
}, {
  isTransformFunction: !0
}), df = "sum", nB = ["typed", "config", "add", "numeric"], aB = /* @__PURE__ */ R(df, nB, (r) => {
  var {
    typed: e,
    config: t,
    add: n,
    numeric: a
  } = r, i = hd({
    typed: e,
    config: t,
    add: n,
    numeric: a
  });
  return e(df, {
    "...any": function(l) {
      l = Ct(l);
      try {
        return i.apply(null, l);
      } catch (c) {
        throw Tr(c);
      }
    }
  });
}, {
  isTransformFunction: !0
}), iB = "quantileSeq", oB = ["typed", "bignumber", "add", "subtract", "divide", "multiply", "partitionSelect", "compare", "isInteger", "smaller", "smallerEq", "larger", "mapSlices"], sB = /* @__PURE__ */ R(iB, oB, (r) => {
  var {
    typed: e,
    bignumber: t,
    add: n,
    subtract: a,
    divide: i,
    multiply: s,
    partitionSelect: l,
    compare: c,
    isInteger: o,
    smaller: u,
    smallerEq: f,
    larger: m,
    mapSlices: p
  } = r, d = xd({
    typed: e,
    bignumber: t,
    add: n,
    subtract: a,
    divide: i,
    multiply: s,
    partitionSelect: l,
    compare: c,
    isInteger: o,
    smaller: u,
    smallerEq: f,
    larger: m,
    mapSlices: p
  });
  return e("quantileSeq", {
    "Array | Matrix, number | BigNumber": d,
    "Array | Matrix, number | BigNumber, number": (x, h, D) => d(x, h, v(D)),
    "Array | Matrix, number | BigNumber, boolean": d,
    "Array | Matrix, number | BigNumber, boolean, number": (x, h, D, y) => d(x, h, D, v(y)),
    "Array | Matrix, Array | Matrix": d,
    "Array | Matrix, Array | Matrix, number": (x, h, D) => d(x, h, v(D)),
    "Array | Matrix, Array | Matrix, boolean": d,
    "Array | Matrix, Array | Matrix, boolean, number": (x, h, D, y) => d(x, h, D, v(y))
  });
  function v(x) {
    return Ct([[], x])[1];
  }
}, {
  isTransformFunction: !0
}), vf = "cumsum", uB = ["typed", "add", "unaryPlus"], cB = /* @__PURE__ */ R(vf, uB, (r) => {
  var {
    typed: e,
    add: t,
    unaryPlus: n
  } = r, a = gd({
    typed: e,
    add: t,
    unaryPlus: n
  });
  return e(vf, {
    "...any": function(s) {
      if (s.length === 2 && Ir(s[0])) {
        var l = s[1];
        Re(l) ? s[1] = l - 1 : $e(l) && (s[1] = l.minus(1));
      }
      try {
        return a.apply(null, s);
      } catch (c) {
        throw Tr(c);
      }
    }
  });
}, {
  isTransformFunction: !0
}), hf = "variance", lB = ["typed", "add", "subtract", "multiply", "divide", "mapSlices", "isNaN"], fB = /* @__PURE__ */ R(hf, lB, (r) => {
  var {
    typed: e,
    add: t,
    subtract: n,
    multiply: a,
    divide: i,
    mapSlices: s,
    isNaN: l
  } = r, c = bd({
    typed: e,
    add: t,
    subtract: n,
    multiply: a,
    divide: i,
    mapSlices: s,
    isNaN: l
  });
  return e(hf, {
    "...any": function(u) {
      u = Ct(u);
      try {
        return c.apply(null, u);
      } catch (f) {
        throw Tr(f);
      }
    }
  });
}, {
  isTransformFunction: !0
}), gf = "print", mB = ["typed", "matrix", "zeros", "add"], pB = /* @__PURE__ */ R(gf, mB, (r) => {
  var {
    typed: e,
    matrix: t,
    zeros: n,
    add: a
  } = r, i = Qp({
    typed: e,
    matrix: t,
    zeros: n,
    add: a
  });
  return e(gf, {
    "string, Object | Array": function(c, o) {
      return i(s(c), o);
    },
    "string, Object | Array, number | Object": function(c, o, u) {
      return i(s(c), o, u);
    }
  });
  function s(l) {
    return l.replace(Jp, (c) => {
      var o = c.slice(1).split("."), u = o.map(function(f) {
        return !isNaN(f) && f.length > 0 ? parseInt(f) - 1 : f;
      });
      return "$" + u.join(".");
    });
  }
}, {
  isTransformFunction: !0
}), dB = "and", vB = ["typed", "matrix", "zeros", "add", "equalScalar", "not", "concat"], hB = /* @__PURE__ */ R(dB, vB, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    zeros: a,
    not: i,
    concat: s
  } = r, l = ed({
    typed: e,
    matrix: t,
    equalScalar: n,
    zeros: a,
    not: i,
    concat: s
  });
  function c(o, u, f) {
    var m = o[0].compile().evaluate(f);
    if (!Ir(m) && !l(m, !0))
      return !1;
    var p = o[1].compile().evaluate(f);
    return l(m, p);
  }
  return c.rawArgs = !0, c;
}, {
  isTransformFunction: !0
}), gB = "or", yB = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], bB = /* @__PURE__ */ R(gB, yB, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    DenseMatrix: a,
    concat: i
  } = r, s = $p({
    typed: e,
    matrix: t,
    equalScalar: n,
    DenseMatrix: a,
    concat: i
  });
  function l(c, o, u) {
    var f = c[0].compile().evaluate(u);
    if (!Ir(f) && s(f, !1))
      return !0;
    var m = c[1].compile().evaluate(u);
    return s(f, m);
  }
  return l.rawArgs = !0, l;
}, {
  isTransformFunction: !0
}), xB = "nullish", wB = ["typed", "matrix", "size", "flatten", "deepEqual"], DB = /* @__PURE__ */ R(xB, wB, (r) => {
  var {
    typed: e,
    matrix: t,
    size: n,
    flatten: a,
    deepEqual: i
  } = r, s = Ip({
    typed: e,
    matrix: t,
    size: n,
    flatten: a,
    deepEqual: i
  });
  function l(c, o, u) {
    var f = c[0].compile().evaluate(u);
    if (!Ir(f) && f != null && f !== void 0)
      return f;
    var m = c[1].compile().evaluate(u);
    return s(f, m);
  }
  return l.rawArgs = !0, l;
}, {
  isTransformFunction: !0
}), NB = "bitAnd", AB = ["typed", "matrix", "zeros", "add", "equalScalar", "not", "concat"], SB = /* @__PURE__ */ R(NB, AB, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    zeros: a,
    not: i,
    concat: s
  } = r, l = Fp({
    typed: e,
    matrix: t,
    equalScalar: n,
    zeros: a,
    not: i,
    concat: s
  });
  function c(o, u, f) {
    var m = o[0].compile().evaluate(f);
    if (!Ir(m)) {
      if (isNaN(m))
        return NaN;
      if (m === 0 || m === !1)
        return 0;
    }
    var p = o[1].compile().evaluate(f);
    return l(m, p);
  }
  return c.rawArgs = !0, c;
}, {
  isTransformFunction: !0
}), EB = "bitOr", MB = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], CB = /* @__PURE__ */ R(EB, MB, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    DenseMatrix: a,
    concat: i
  } = r, s = Bp({
    typed: e,
    matrix: t,
    equalScalar: n,
    DenseMatrix: a,
    concat: i
  });
  function l(c, o, u) {
    var f = c[0].compile().evaluate(u);
    if (!Ir(f)) {
      if (isNaN(f))
        return NaN;
      if (f === -1)
        return -1;
      if (f === !0)
        return 1;
    }
    var m = c[1].compile().evaluate(u);
    return s(f, m);
  }
  return l.rawArgs = !0, l;
}, {
  isTransformFunction: !0
});
const _B = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createAbs: wp,
  createAccessorNode: y2,
  createAcos: Uw,
  createAcosh: kw,
  createAcot: Ww,
  createAcoth: Vw,
  createAcsc: Xw,
  createAcsch: Jw,
  createAdd: od,
  createAddScalar: Dp,
  createAnd: ed,
  createAndTransform: hB,
  createArg: fy,
  createArrayNode: x2,
  createAsec: jw,
  createAsech: eD,
  createAsin: tD,
  createAsinh: iD,
  createAssignmentNode: A2,
  createAtan: uD,
  createAtan2: lD,
  createAtanh: mD,
  createAtomicMass: L3,
  createAvogadro: k3,
  createBellNumbers: cT,
  createBigNumberClass: om,
  createBigint: r0,
  createBignumber: gp,
  createBin: Pb,
  createBitAnd: Fp,
  createBitAndTransform: SB,
  createBitNot: ay,
  createBitOr: Bp,
  createBitOrTransform: CB,
  createBitXor: cy,
  createBlockNode: E2,
  createBohrMagneton: w3,
  createBohrRadius: M3,
  createBoltzmann: H3,
  createBoolean: i0,
  createCatalan: fT,
  createCbrt: F0,
  createCeil: L0,
  createChain: BC,
  createChainClass: YN,
  createClassicalElectronRadius: C3,
  createClone: Dg,
  createColumn: zp,
  createColumnTransform: dF,
  createCombinations: b_,
  createCombinationsWithRep: w_,
  createCompare: Ox,
  createCompareNatural: Px,
  createCompareText: kx,
  createCompile: nN,
  createComplex: l0,
  createComplexClass: sm,
  createComposition: pT,
  createConcat: ho,
  createConcatTransform: QF,
  createConditionalNode: C2,
  createConductanceQuantum: D3,
  createConj: Op,
  createConstantNode: I2,
  createCorr: g_,
  createCos: dD,
  createCosh: hD,
  createCot: yD,
  createCoth: xD,
  createCoulomb: y3,
  createCoulombConstant: b3,
  createCount: Ey,
  createCreateUnit: qw,
  createCross: Cy,
  createCsc: DD,
  createCsch: AD,
  createCtranspose: mb,
  createCube: H0,
  createCumSum: gd,
  createCumSumTransform: cB,
  createDeepEqual: ow,
  createDenseMatrixClass: wm,
  createDerivative: BT,
  createDet: dd,
  createDeuteronMass: I3,
  createDiag: Ty,
  createDiff: kp,
  createDiffTransform: KF,
  createDistance: t_,
  createDivide: e_,
  createDivideScalar: Kp,
  createDot: sd,
  createDotDivide: dx,
  createDotMultiply: J1,
  createDotPow: mx,
  createE: KT,
  createEfimovFactor: U3,
  createEigs: LC,
  createElectricConstant: h3,
  createElectronMass: _3,
  createElementaryCharge: x3,
  createEqual: Wx,
  createEqualScalar: dp,
  createEqualText: Zx,
  createErf: Eb,
  createEvaluate: iN,
  createExp: G0,
  createExpm: HC,
  createExpm1: Z0,
  createFactorial: M_,
  createFalse: ZT,
  createFaraday: W3,
  createFermiCoupling: T3,
  createFft: vb,
  createFibonacciHeapClass: Dw,
  createFilter: Rp,
  createFilterTransform: bF,
  createFineStructure: F3,
  createFirstRadiation: G3,
  createFix: J0,
  createFlatten: Iy,
  createFloor: Ap,
  createForEach: qp,
  createForEachTransform: DF,
  createFormat: Rb,
  createFraction: yp,
  createFractionClass: um,
  createFreqz: qT,
  createFunctionAssignmentNode: z2,
  createFunctionNode: K2,
  createGamma: N_,
  createGasConstant: Z3,
  createGcd: x1,
  createGetMatrixDataType: Pp,
  createGravitationConstant: m3,
  createGravity: tF,
  createHartreeEnergy: B3,
  createHasNumericValue: Rg,
  createHelp: TC,
  createHelpClass: VN,
  createHex: Hb,
  createHypot: o2,
  createI: s3,
  createIdentity: Up,
  createIfft: gb,
  createIm: dy,
  createImmutableDenseMatrixClass: ad,
  createIndex: ud,
  createIndexClass: id,
  createIndexNode: q2,
  createIndexTransform: SF,
  createInfinity: YT,
  createIntersect: i_,
  createInv: vd,
  createInverseConductanceQuantum: N3,
  createInvmod: V1,
  createIsInteger: Nm,
  createIsNaN: kg,
  createIsNegative: Og,
  createIsNumeric: $g,
  createIsPositive: Pg,
  createIsPrime: Jb,
  createIsZero: pp,
  createKldivergence: __,
  createKlitzing: E3,
  createKron: Uy,
  createLN10: t3,
  createLN2: r3,
  createLOG10E: a3,
  createLOG2E: n3,
  createLarger: ew,
  createLargerEq: nw,
  createLcm: A1,
  createLeafCount: vT,
  createLeftShift: Ex,
  createLgamma: S_,
  createLog: ox,
  createLog10: M1,
  createLog1p: ux,
  createLog2: _1,
  createLoschmidt: V3,
  createLsolve: hx,
  createLsolveAll: xx,
  createLup: pN,
  createLusolve: LN,
  createLyap: QC,
  createMad: m_,
  createMagneticConstant: v3,
  createMagneticFluxQuantum: A3,
  createMap: Lp,
  createMapSlices: Vi,
  createMapSlicesTransform: fF,
  createMapTransform: CF,
  createMatrix: bp,
  createMatrixClass: cm,
  createMatrixFromColumns: b0,
  createMatrixFromFunction: v0,
  createMatrixFromRows: g0,
  createMax: td,
  createMaxTransform: OF,
  createMean: yd,
  createMeanTransform: zF,
  createMedian: l_,
  createMin: nd,
  createMinTransform: PF,
  createMod: Ep,
  createMode: Ob,
  createMolarMass: eF,
  createMolarMassC12: rF,
  createMolarPlanckConstant: X3,
  createMolarVolume: Y3,
  createMultinomial: F_,
  createMultiply: Cp,
  createMultiplyScalar: Mp,
  createNaN: JT,
  createNeutronMass: $3,
  createNode: h2,
  createNorm: u2,
  createNot: yy,
  createNthRoot: I1,
  createNthRoots: lx,
  createNuclearMagneton: S3,
  createNull: XT,
  createNullish: Ip,
  createNullishTransform: DB,
  createNumber: hp,
  createNumeric: jp,
  createObjectNode: U2,
  createOct: Lb,
  createOnes: Gy,
  createOperatorNode: k2,
  createOr: $p,
  createOrTransform: bB,
  createParenthesisNode: W2,
  createParse: rN,
  createParser: fN,
  createParserClass: uN,
  createPartitionSelect: fw,
  createPermutations: O_,
  createPhi: e3,
  createPi: QT,
  createPickRandom: rT,
  createPinv: zC,
  createPlanckCharge: oF,
  createPlanckConstant: p3,
  createPlanckLength: nF,
  createPlanckMass: aF,
  createPlanckTemperature: sF,
  createPlanckTime: iF,
  createPolynomialRoot: HN,
  createPow: rx,
  createPrint: Qp,
  createPrintTransform: pB,
  createProd: $b,
  createProtonMass: O3,
  createQr: vN,
  createQuantileSeq: xd,
  createQuantileSeqTransform: sB,
  createQuantumOfCirculation: z3,
  createRandom: nT,
  createRandomInt: iT,
  createRange: Gp,
  createRangeClass: ng,
  createRangeNode: V2,
  createRangeTransform: kF,
  createRationalize: IT,
  createRe: hy,
  createReducedPlanckConstant: d3,
  createRelationalNode: X2,
  createReplacer: WT,
  createReshape: Xy,
  createResize: Qy,
  createResolve: CT,
  createResultSet: Xv,
  createReviver: LT,
  createRightArithShift: Cx,
  createRightLogShift: Tx,
  createRotate: Ky,
  createRotationMatrix: rb,
  createRound: nx,
  createRow: Vp,
  createRowTransform: GF,
  createRydberg: R3,
  createSQRT1_2: i3,
  createSQRT2: o3,
  createSackurTetrode: J3,
  createSchur: YC,
  createSec: ED,
  createSech: CD,
  createSecondRadiation: Q3,
  createSetCartesian: PD,
  createSetDifference: LD,
  createSetDistinct: HD,
  createSetIntersect: GD,
  createSetIsSubset: ZD,
  createSetMultiplicity: YD,
  createSetPowerset: QD,
  createSetSize: KD,
  createSetSymDifference: r2,
  createSetUnion: n2,
  createSign: z1,
  createSimplify: xT,
  createSimplifyConstant: NT,
  createSimplifyCore: ST,
  createSin: TD,
  createSinh: BD,
  createSize: Zp,
  createSlu: PN,
  createSmaller: rd,
  createSmallerEq: Qx,
  createSolveODE: Nb,
  createSort: pw,
  createSpaClass: Sw,
  createSparse: zw,
  createSparseMatrixClass: vp,
  createSpeedOfLight: f3,
  createSplitUnit: w0,
  createSqrt: P1,
  createSqrtm: GC,
  createSquare: L1,
  createSqueeze: ib,
  createStd: wd,
  createStdTransform: tB,
  createStefanBoltzmann: j3,
  createStirlingS2: sT,
  createString: n0,
  createSubset: yo,
  createSubsetTransform: XF,
  createSubtract: _p,
  createSubtractScalar: Np,
  createSum: hd,
  createSumTransform: aB,
  createSylvester: ZC,
  createSymbolNode: Q2,
  createSymbolicEqual: TT,
  createTan: ID,
  createTanh: RD,
  createTau: jT,
  createThomsonCrossSection: q3,
  createTo: Vb,
  createToBest: Xb,
  createTrace: m2,
  createTranspose: Xp,
  createTrue: VT,
  createTypeOf: Wg,
  createTyped: Xf,
  createUnaryMinus: xp,
  createUnaryPlus: A0,
  createUnequal: uw,
  createUnitClass: Bw,
  createUnitFunction: Iw,
  createUppercaseE: c3,
  createUppercasePi: u3,
  createUsolve: yx,
  createUsolveAll: Dx,
  createVacuumImpedance: g3,
  createVariance: bd,
  createVarianceTransform: fB,
  createVersion: l3,
  createWeakMixingAngle: P3,
  createWienDisplacement: K3,
  createXgcd: W1,
  createXor: Dy,
  createZeros: Yp,
  createZeta: Fb,
  createZpk2tf: zT
}, Symbol.toStringTag, { value: "Module" }));
var li = /* @__PURE__ */ om({
  config: Ut
}), TB = /* @__PURE__ */ sm({}), Nd = /* @__PURE__ */ um({}), Eo = /* @__PURE__ */ cm({}), kt = /* @__PURE__ */ wm({
  Matrix: Eo
}), Je = /* @__PURE__ */ Xf({
  BigNumber: li,
  Complex: TB,
  DenseMatrix: kt,
  Fraction: Nd
}), FB = /* @__PURE__ */ wp({
  typed: Je
}), fi = /* @__PURE__ */ Dp({
  typed: Je
}), BB = /* @__PURE__ */ Op({
  typed: Je
}), Un = /* @__PURE__ */ dp({
  config: Ut,
  typed: Je
}), OB = /* @__PURE__ */ Pp({
  typed: Je
}), IB = /* @__PURE__ */ Nm({
  typed: Je
}), $B = /* @__PURE__ */ pp({
  equalScalar: Un,
  typed: Je
}), Ad = /* @__PURE__ */ Mp({
  typed: Je
}), zB = /* @__PURE__ */ hp({
  typed: Je
}), mi = /* @__PURE__ */ vp({
  Matrix: Eo,
  equalScalar: Un,
  typed: Je
}), Sd = /* @__PURE__ */ Np({
  typed: Je
}), Ed = /* @__PURE__ */ gp({
  BigNumber: li,
  typed: Je
}), wr = /* @__PURE__ */ bp({
  DenseMatrix: kt,
  Matrix: Eo,
  SparseMatrix: mi,
  typed: Je
}), Ci = /* @__PURE__ */ Xp({
  matrix: wr,
  typed: Je
}), eo = /* @__PURE__ */ Yp({
  BigNumber: li,
  config: Ut,
  matrix: wr,
  typed: Je
}), Mo = /* @__PURE__ */ ho({
  isInteger: IB,
  matrix: wr,
  typed: Je
}), RB = /* @__PURE__ */ yp({
  Fraction: Nd,
  typed: Je
}), ht = /* @__PURE__ */ Up({
  BigNumber: li,
  DenseMatrix: kt,
  SparseMatrix: mi,
  config: Ut,
  matrix: wr,
  typed: Je
}), qB = /* @__PURE__ */ jp({
  bignumber: Ed,
  fraction: RB,
  number: zB
}), PB = /* @__PURE__ */ Zp({
  matrix: wr,
  config: Ut,
  typed: Je
}), UB = /* @__PURE__ */ rd({
  DenseMatrix: kt,
  SparseMatrix: mi,
  bignumber: Ed,
  concat: Mo,
  config: Ut,
  matrix: wr,
  typed: Je
}), Co = /* @__PURE__ */ xp({
  typed: Je
}), Na = /* @__PURE__ */ od({
  DenseMatrix: kt,
  SparseMatrix: mi,
  addScalar: fi,
  concat: Mo,
  equalScalar: Un,
  matrix: wr,
  typed: Je
}), Md = /* @__PURE__ */ Kp({
  numeric: qB,
  typed: Je
}), LB = /* @__PURE__ */ ad({
  DenseMatrix: kt,
  smaller: UB
}), kB = /* @__PURE__ */ id({
  ImmutableDenseMatrix: LB,
  getMatrixDataType: OB
}), ca = /* @__PURE__ */ yo({
  add: Na,
  matrix: wr,
  typed: Je,
  zeros: eo
}), yf = /* @__PURE__ */ _p({
  DenseMatrix: kt,
  concat: Mo,
  equalScalar: Un,
  matrix: wr,
  subtractScalar: Sd,
  typed: Je,
  unaryMinus: Co
}), HB = /* @__PURE__ */ sd({
  addScalar: fi,
  conj: BB,
  multiplyScalar: Ad,
  size: PB,
  typed: Je
}), la = /* @__PURE__ */ ud({
  Index: kB,
  typed: Je
}), vr = /* @__PURE__ */ Cp({
  addScalar: fi,
  dot: HB,
  equalScalar: Un,
  matrix: wr,
  multiplyScalar: Ad,
  typed: Je
}), WB = /* @__PURE__ */ dd({
  divideScalar: Md,
  isZero: $B,
  matrix: wr,
  multiply: vr,
  subtractScalar: Sd,
  typed: Je,
  unaryMinus: Co
}), GB = /* @__PURE__ */ vd({
  abs: FB,
  addScalar: fi,
  det: WB,
  divideScalar: Md,
  identity: ht,
  matrix: wr,
  multiply: vr,
  typed: Je,
  unaryMinus: Co
}), VB = _B, fa = { exports: {} }, bf;
function ZB() {
  if (bf) return fa.exports;
  bf = 1;
  function r() {
  }
  return r.prototype = {
    on: function(e, t, n) {
      var a = this.e || (this.e = {});
      return (a[e] || (a[e] = [])).push({
        fn: t,
        ctx: n
      }), this;
    },
    once: function(e, t, n) {
      var a = this;
      function i() {
        a.off(e, i), t.apply(n, arguments);
      }
      return i._ = t, this.on(e, i, n);
    },
    emit: function(e) {
      var t = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[e] || []).slice(), a = 0, i = n.length;
      for (a; a < i; a++)
        n[a].fn.apply(n[a].ctx, t);
      return this;
    },
    off: function(e, t) {
      var n = this.e || (this.e = {}), a = n[e], i = [];
      if (a && t)
        for (var s = 0, l = a.length; s < l; s++)
          a[s].fn !== t && a[s].fn._ !== t && i.push(a[s]);
      return i.length ? n[e] = i : delete n[e], this;
    }
  }, fa.exports = r, fa.exports.TinyEmitter = r, fa.exports;
}
var XB = ZB();
const YB = /* @__PURE__ */ si(XB);
function JB(r) {
  var e = new YB();
  return r.on = e.on.bind(e), r.off = e.off.bind(e), r.once = e.once.bind(e), r.emit = e.emit.bind(e), r;
}
function QB(r, e, t, n) {
  function a(h, D) {
    var y = arguments.length;
    if (y !== 1 && y !== 2)
      throw new ft("import", y, 1, 2);
    D || (D = {});
    function w(S, A, E) {
      if (Array.isArray(A))
        A.forEach((B) => w(S, B));
      else if (qt(A) || f(A))
        for (var M in A)
          xe(A, M) && w(S, A[M], M);
      else if (En(A) || E !== void 0) {
        var T = En(A) ? v(A) ? A.fn + ".transform" : A.fn : E;
        if (xe(S, T) && S[T] !== A && !D.silent)
          throw new Error('Cannot import "' + T + '" twice');
        S[T] = A;
      } else if (!D.silent)
        throw new TypeError("Factory, Object, or Array expected");
    }
    var b = {};
    w(b, h);
    for (var g in b)
      if (xe(b, g)) {
        var N = b[g];
        if (En(N))
          o(N, D);
        else if (u(N))
          i(g, N, D);
        else if (!D.silent)
          throw new TypeError("Factory, Object, or Array expected");
      }
  }
  function i(h, D, y) {
    var w;
    if (y.wrap && typeof D == "function" && (D = c(D)), m(D) && (D = r(h, {
      [D.signature]: D
    })), r.isTypedFunction(t[h]) && r.isTypedFunction(D)) {
      y.override ? D = r(h, D.signatures) : D = r(t[h], D), t[h] = D, delete n[h], s(h, D), t.emit("import", h, function() {
        return D;
      });
      return;
    }
    var b = t[h] !== void 0, g = (w = t.Unit) === null || w === void 0 ? void 0 : w.isValuelessUnit(h);
    if (!b && !g || y.override) {
      t[h] = D, delete n[h], s(h, D), t.emit("import", h, function() {
        return D;
      });
      return;
    }
    if (!y.silent)
      throw new Error('Cannot import "' + h + '": already exists');
  }
  function s(h, D) {
    D && typeof D.transform == "function" ? (t.expression.transform[h] = D.transform, p(h) && (t.expression.mathWithTransform[h] = D.transform)) : (delete t.expression.transform[h], p(h) && (t.expression.mathWithTransform[h] = D));
  }
  function l(h) {
    delete t.expression.transform[h], p(h) ? t.expression.mathWithTransform[h] = t[h] : delete t.expression.mathWithTransform[h];
  }
  function c(h) {
    var D = function() {
      for (var w = [], b = 0, g = arguments.length; b < g; b++) {
        var N = arguments[b];
        w[b] = N && N.valueOf();
      }
      return h.apply(t, w);
    };
    return h.transform && (D.transform = h.transform), D;
  }
  function o(h, D) {
    var y, w, b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : h.fn;
    if (b.includes("."))
      throw new Error("Factory name should not contain a nested path. Name: " + JSON.stringify(b));
    var g = v(h) ? t.expression.transform : t, N = b in t.expression.transform, S = xe(g, b) ? g[b] : void 0, A = function() {
      var I = {};
      h.dependencies.map(Hf).forEach((_) => {
        if (_.includes("."))
          throw new Error("Factory dependency should not contain a nested path. Name: " + JSON.stringify(_));
        _ === "math" ? I.math = t : _ === "mathWithTransform" ? I.mathWithTransform = t.expression.mathWithTransform : _ === "classes" ? I.classes = t : I[_] = t[_];
      });
      var O = /* @__PURE__ */ h(I);
      if (O && typeof O.transform == "function")
        throw new Error('Transforms cannot be attached to factory functions. Please create a separate function for it with export const path = "expression.transform"');
      if (S === void 0 || D.override)
        return O;
      if (r.isTypedFunction(S) && r.isTypedFunction(O))
        return r(S, O);
      if (D.silent)
        return S;
      throw new Error('Cannot import "' + b + '": already exists');
    }, E = (y = (w = h.meta) === null || w === void 0 ? void 0 : w.formerly) !== null && y !== void 0 ? y : "", M = v(h) || d(h), T = t.expression.mathWithTransform;
    !h.meta || h.meta.lazy !== !1 ? (Tt(g, b, A), E && Tt(g, E, A), S && N ? (l(b), E && l(E)) : M && (Tt(T, b, () => g[b]), E && Tt(T, E, () => g[b]))) : (g[b] = A(), E && (g[E] = g[b]), S && N ? (l(b), E && l(E)) : M && (Tt(T, b, () => g[b]), E && Tt(T, E, () => g[b]))), n[b] = h, t.emit("import", b, A);
  }
  function u(h) {
    return typeof h == "function" || typeof h == "number" || typeof h == "string" || typeof h == "boolean" || h === null || Er(h) || Zr(h) || $e(h) || Rt(h) || Ee(h) || Array.isArray(h);
  }
  function f(h) {
    return typeof h == "object" && h[Symbol.toStringTag] === "Module";
  }
  function m(h) {
    return typeof h == "function" && typeof h.signature == "string";
  }
  function p(h) {
    return !xe(x, h);
  }
  function d(h) {
    return !h.fn.includes(".") && // FIXME: make checking on path redundant, check on meta data instead
    !xe(x, h.fn) && (!h.meta || !h.meta.isClass);
  }
  function v(h) {
    return h !== void 0 && h.meta !== void 0 && h.meta.isTransformFunction === !0 || !1;
  }
  var x = {
    expression: !0,
    type: !0,
    docs: !0,
    error: !0,
    json: !0,
    chain: !0
    // chain method not supported. Note that there is a unit chain too.
  };
  return a;
}
function Cd(r, e) {
  var t = hr({}, Ja, e);
  if (typeof Object.create != "function")
    throw new Error("ES5 not supported by this JavaScript engine. Please load the es5-shim and es5-sham library for compatibility.");
  var n = JB({
    // only here for backward compatibility for legacy factory functions
    isNumber: Re,
    isComplex: Zr,
    isBigNumber: $e,
    isBigInt: en,
    isFraction: Rt,
    isUnit: Er,
    isString: gr,
    isArray: Ye,
    isMatrix: Ee,
    isCollection: Ir,
    isDenseMatrix: _n,
    isSparseMatrix: gt,
    isRange: ja,
    isIndex: $n,
    isBoolean: Cf,
    isResultSet: _f,
    isHelp: no,
    isFunction: ao,
    isDate: Tf,
    isRegExp: Ff,
    isObject: qt,
    isMap: It,
    isPartitionedMap: xv,
    isObjectWrappingMap: wv,
    isNull: Bf,
    isUndefined: Of,
    isAccessorNode: wt,
    isArrayNode: zr,
    isAssignmentNode: If,
    isBlockNode: $f,
    isConditionalNode: zf,
    isConstantNode: We,
    isFunctionAssignmentNode: mn,
    isFunctionNode: st,
    isIndexNode: Pt,
    isNode: Xe,
    isObjectNode: zn,
    isOperatorNode: ir,
    isParenthesisNode: et,
    isRangeNode: Rf,
    isRelationalNode: qf,
    isSymbolNode: ur,
    isChain: io
  });
  n.config = Ev(t, n.emit), n.expression = {
    transform: {},
    mathWithTransform: {
      config: n.config
    }
  };
  var a = [], i = [];
  function s(u) {
    if (En(u))
      return u(n);
    var f = u[Object.keys(u)[0]];
    if (En(f))
      return f(n);
    if (!Av(u))
      throw console.warn("Factory object with properties `type`, `name`, and `factory` expected", u), new Error("Factory object with properties `type`, `name`, and `factory` expected");
    var m = a.indexOf(u), p;
    return m === -1 ? (u.math === !0 ? p = u.factory(n.type, t, s, n.typed, n) : p = u.factory(n.type, t, s, n.typed), a.push(u), i.push(p)) : p = i[m], p;
  }
  var l = {};
  function c() {
    for (var u = arguments.length, f = new Array(u), m = 0; m < u; m++)
      f[m] = arguments[m];
    return n.typed.apply(n.typed, f);
  }
  c.isTypedFunction = Tn.isTypedFunction;
  var o = QB(c, s, n, l);
  return n.import = o, n.on("config", () => {
    Object.values(l).forEach((u) => {
      u && u.meta && u.meta.recreateOnConfigChange && o(u, {
        override: !0
      });
    });
  }), n.create = Cd.bind(null, r), n.factory = R, n.import(Object.values(Nv(r))), n.ArgumentsError = ft, n.DimensionError = Ue, n.IndexError = Hr, n;
}
class ct {
  _accumulated = 0;
  _startTime = 0;
  _isRunning = !1;
  start() {
    this.isRunning || (this._startTime = performance.now(), this._isRunning = !0);
  }
  stop() {
    this.isRunning && (this._accumulated += performance.now() - this._startTime, this._isRunning = !1);
  }
  reset() {
    this._accumulated = 0, this._isRunning = !1;
  }
  restart() {
    this.reset(), this.start();
  }
  get elapsedMilliseconds() {
    return this._isRunning ? this._accumulated + (performance.now() - this._startTime) : this._accumulated;
  }
  get isRunning() {
    return this._isRunning;
  }
  static startNew() {
    const e = new ct();
    return e.start(), e;
  }
}
class C4 {
  windowSizeSeconds;
  values = [];
  constructor(e) {
    this.windowSizeSeconds = e;
  }
  /**
   * Adds a new value (in milliseconds) to the tracker.
   * @param value Time in milliseconds
   */
  add(e) {
    const t = Date.now();
    this.values.push({ timestamp: t, value: e }), this.cleanup(t);
  }
  /**
   * Returns the average of values within the window.
   */
  getAverage() {
    const e = Date.now();
    return this.cleanup(e), this.values.length === 0 ? 0 : this.values.reduce((n, a) => n + a.value, 0) / this.values.length;
  }
  /**
   * Removes old values outside the window.
   * @param now Current timestamp
   */
  cleanup(e) {
    const t = e - this.windowSizeSeconds * 1e3;
    for (; this.values.length && this.values[0].timestamp < t; )
      this.values.shift();
  }
}
const Ze = Cd(VB);
class _4 {
  state;
  covariance;
  transitionMatrix;
  measurementMatrix;
  processNoise;
  measurementNoise;
  constructor() {
    this.state = Ze.zeros(8, 1), this.covariance = Ze.identity(8), this.transitionMatrix = Ze.matrix([
      [1, 0, 0, 0, 1, 0, 0, 0],
      [0, 1, 0, 0, 0, 1, 0, 0],
      [0, 0, 1, 0, 0, 0, 1, 0],
      [0, 0, 0, 1, 0, 0, 0, 1],
      [0, 0, 0, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 0, 1, 0, 0],
      [0, 0, 0, 0, 0, 0, 1, 0],
      [0, 0, 0, 0, 0, 0, 0, 1]
    ]), this.measurementMatrix = Ze.matrix([
      [1, 0, 0, 0, 0, 0, 0, 0],
      [0, 1, 0, 0, 0, 0, 0, 0],
      [0, 0, 1, 0, 0, 0, 0, 0],
      [0, 0, 0, 1, 0, 0, 0, 0]
    ]), this.processNoise = Ze.multiply(Ze.identity(8), 1e-3), this.measurementNoise = Ze.multiply(Ze.identity(4), 0.1);
  }
  predict() {
    return this.state = Ze.multiply(this.transitionMatrix, this.state), this.covariance = Ze.add(
      Ze.multiply(this.transitionMatrix, this.covariance, Ze.transpose(this.transitionMatrix)),
      this.processNoise
    ), this.state;
  }
  update(e) {
    const t = Ze.subtract(e, Ze.multiply(this.measurementMatrix, this.state)), n = Ze.add(
      Ze.multiply(this.measurementMatrix, this.covariance, Ze.transpose(this.measurementMatrix)),
      this.measurementNoise
    ), a = Ze.multiply(this.covariance, Ze.transpose(this.measurementMatrix), Ze.inv(n));
    this.state = Ze.add(this.state, Ze.multiply(a, t));
    const i = Ze.identity(this.state.size()[0]);
    this.covariance = Ze.multiply(Ze.subtract(i, Ze.multiply(a, this.measurementMatrix)), this.covariance);
  }
  filter(e) {
    const t = Ze.matrix([[e.origin.x], [e.origin.y], [e.width], [e.height]]);
    return Ze.deepEqual(this.state, Ze.zeros(this.state.size()[0], 1)) && (this.state = Ze.concat(t, Ze.zeros(4, 1), 0)), this.predict(), this.update(t), {
      origin: {
        x: this.state.get([0, 0]),
        y: this.state.get([1, 0])
      },
      width: this.state.get([2, 0]),
      height: this.state.get([3, 0]),
      score: e.score
      // Score is not filtered
    };
  }
}
class nn extends Error {
  constructor(e) {
    super(e), this.name = "SDKError";
  }
}
class fn extends nn {
  constructor(e, t) {
    super(e), this.name = "SDKError", this.inputImage = t;
  }
  inputImage;
}
class _t extends Ya {
  static ThisExecutorType = "webgpu";
  _engine;
  // private _gpuBuffer?: GPUBuffer;
  // private _gpuDevice?: GPUDevice;
  // private _gpuOutputBuffers: Map<string, GPUBuffer> = new Map();
  // private _outputStagingBuffers: Map<string, GPUBuffer> = new Map();
  constructor(e, t, n) {
    super(e, n), this._engine = t;
  }
  [Symbol.dispose]() {
    this._engine.release(), super[Symbol.dispose]();
  }
  // private areAllOutputsFixedSize(): boolean {
  //     if (this._engine.outputNames.length === 0) {
  //         return false;
  //     }
  //     for (const metadata of this._engine.outputMetadata) {
  //         if (!metadata.isTensor) {
  //             return false; // Non-tensor outputs are not handled by this GPU buffer logic
  //         }
  //         const tensorMeta =
  //             metadata as ort.InferenceSession.TensorValueMetadata;
  //         const shape = tensorMeta.shape;
  //         for (const dim of shape) {
  //             // Dynamic dimensions are represented by non-numbers, negative numbers, or a specific large unsigned int in ORT Web.
  //             if (typeof dim !== "number" || dim < 0 || dim === 4294967295) {
  //                 return false;
  //             }
  //         }
  //     }
  //     return true;
  // }
  // private async ensureResources() {
  //     this._gpuDevice = await ort.env.webgpu.device;
  //     if (!this._gpuDevice) {
  //         throw new Error(
  //             "WebGPU device not found in ort.env.webgpu.device. " +
  //                 "Ensure it's properly set and the ONNX session is configured for WebGPU."
  //         );
  //     }
  //     if (this._gpuBuffer) {
  //         this._gpuBuffer.destroy();
  //         this._gpuBuffer = undefined;
  //     }
  //     if (!this._gpuBuffer) {
  //         const modelWidth = this._engine.inputWidth;
  //         const modelHeight = this._engine.inputHeight;
  //         const channels = 3;
  //         const floatCount = modelHeight * modelWidth * channels;
  //         const byteCount = floatCount * Float32Array.BYTES_PER_ELEMENT;
  //         const alignedSize = Math.ceil(byteCount / 16) * 16;
  //         this._gpuBuffer = this._gpuDevice.createBuffer({
  //             size: alignedSize, // Size in bytes
  //             usage:
  //                 GPUBufferUsage.COPY_SRC |
  //                 GPUBufferUsage.COPY_DST |
  //                 GPUBufferUsage.STORAGE,
  //         });
  //     }
  //     // Clear and destroy existing output and staging buffers before creating new ones
  //     this._gpuOutputBuffers.forEach((buffer) => buffer.destroy());
  //     this._gpuOutputBuffers.clear();
  //     this._outputStagingBuffers.forEach((buffer) => buffer.destroy());
  //     this._outputStagingBuffers.clear();
  //     if (!this.areAllOutputsFixedSize()) {
  //         return;
  //     }
  //     for (const outputMeta of this._engine.outputMetadata) {
  //         if (!outputMeta.isTensor) continue;
  //         const metadata =
  //             outputMeta as ort.InferenceSession.TensorValueMetadata;
  //         const outputName = metadata.name;
  //         const shape = metadata.shape as number[]; // Already validated by areAllOutputsFixedSize
  //         const typedArrayConstructor = tensorTypeToTypedArrayConstructor(
  //             metadata.type as ort.Tensor.Type
  //         );
  //         const elementSize = typedArrayConstructor.BYTES_PER_ELEMENT;
  //         const elementCount = shape.reduce((acc, val) => acc * val, 1);
  //         let byteCount = elementCount * elementSize;
  //         if (metadata.type === "int4" || metadata.type === "uint4") {
  //             byteCount = Math.ceil(elementCount / 2);
  //         }
  //         const alignedSize = Math.ceil(byteCount / 16) * 16; // Common alignment for WebGPU
  //         const newGpuOutputBuffer = this._gpuDevice.createBuffer({
  //             size: alignedSize,
  //             usage:
  //                 GPUBufferUsage.COPY_SRC |
  //                 GPUBufferUsage.COPY_DST |
  //                 GPUBufferUsage.STORAGE,
  //         });
  //         this._gpuOutputBuffers.set(outputName, newGpuOutputBuffer);
  //     }
  // }
  // private createOutputTensors(): ort.InferenceSession.NullableOnnxValueMapType {
  //     if (!this._gpuDevice || !this.areAllOutputsFixedSize()) {
  //         return {};
  //     }
  //     const fetches: ort.InferenceSession.NullableOnnxValueMapType = {};
  //     for (const outputMeta of this._engine.outputMetadata) {
  //         if (!outputMeta.isTensor) continue;
  //         const metadata =
  //             outputMeta as ort.InferenceSession.TensorValueMetadata;
  //         const outputName = metadata.name;
  //         const gpuOutputBuffer = this._gpuOutputBuffers.get(outputName);
  //         if (!gpuOutputBuffer) {
  //             console.error(
  //                 `GPU output buffer not found for ${outputName} during createOutputTensors`
  //             );
  //             continue;
  //         }
  //         const tensorDownload = async () => {
  //             if (!this._gpuDevice) {
  //                 throw new Error(
  //                     "WebGPU device not available for tensor download."
  //                 );
  //             }
  //             let stagingBuffer = this._outputStagingBuffers.get(outputName);
  //             if (!stagingBuffer) {
  //                 stagingBuffer = this._gpuDevice.createBuffer({
  //                     usage:
  //                         GPUBufferUsage.MAP_READ | GPUBufferUsage.COPY_DST,
  //                     size: gpuOutputBuffer.size,
  //                 });
  //                 this._outputStagingBuffers.set(outputName, stagingBuffer);
  //             }
  //             const encoder = this._gpuDevice.createCommandEncoder();
  //             encoder.copyBufferToBuffer(
  //                 gpuOutputBuffer,
  //                 0,
  //                 stagingBuffer,
  //                 0,
  //                 gpuOutputBuffer.size
  //             );
  //             this._gpuDevice.queue.submit([encoder.finish()]);
  //             await stagingBuffer.mapAsync(GPUMapMode.READ);
  //             const arrayBuffer = stagingBuffer
  //                 .getMappedRange()
  //                 .slice(0, gpuOutputBuffer.size);
  //             stagingBuffer.unmap();
  //             return createView(
  //                 arrayBuffer,
  //                 metadata.type as ort.Tensor.GpuBufferDataTypes
  //             ) as ort.Tensor.DataTypeMap[ort.Tensor.GpuBufferDataTypes];
  //         };
  //         (fetches as any)[outputName] = ort.Tensor.fromGpuBuffer(
  //             gpuOutputBuffer,
  //             {
  //                 dataType: metadata.type as ort.Tensor.GpuBufferDataTypes,
  //                 dims: metadata.shape as number[], // Shape elements are numbers due to areAllOutputsFixedSize check
  //                 download: tensorDownload,
  //             }
  //         );
  //     }
  //     return fetches;
  // }
  async runInference(e) {
    const t = e instanceof ImageBitmap ? await this.preprocessImage(e) : e;
    try {
      return await this.runInferenceImpl(t);
    } catch (n) {
      throw console.error(n), new fn("Inference error", t.input);
    }
  }
  async runInferenceImpl(e) {
    const t = ct.startNew(), n = new Cr.Tensor("float32", e.tensor.data.slice(0), [
      1,
      ...e.tensor.shape
    ]);
    let a;
    try {
      a = await this._engine.run({
        [this._engine.inputNames[0]]: n
      });
    } finally {
      n.dispose();
    }
    return {
      inferenceTimeMs: t.elapsedMilliseconds,
      result: a,
      inputImage: e.input,
      resizedHeight: e.resizedHeight,
      resizedWidth: e.resizedWidth,
      tensor: e.tensor
    };
  }
  static defaultSessionOptions = {
    executionProviders: [
      {
        name: "webgpu",
        preferredLayout: "NCHW"
      }
    ],
    graphOptimizationLevel: "extended",
    executionMode: "sequential",
    interOpNumThreads: 2,
    intraOpNumThreads: 1,
    enableProfiling: !1,
    enableGraphCapture: !1,
    enableMemPattern: !1,
    enableCpuMemArena: !0,
    logSeverityLevel: 3,
    extra: {
      session: {
        disable_prepacking: "1",
        use_device_allocator_for_initializers: "1",
        use_ort_model_bytes_directly: "1",
        use_ort_model_bytes_for_initializers: "1",
        disable_cpu_ep_fallback: "0"
      }
    }
  };
  static async create(e, t, n) {
    try {
      const a = n ?? t.defaultExecutorConfigs.get(this.ThisExecutorType) ?? this.defaultSessionOptions, i = await Cr.InferenceSession.create(e, a);
      return i.inputWidth = t.inputWidth, i.inputHeight = t.inputHeight, new _t(t, i, this.ThisExecutorType);
    } catch (a) {
      throw console.error(`Failed to load model at ${t.filename}: ${a}`), a;
    }
  }
}
class Kr extends Ya {
  _engine;
  static ThisExecutorType = "webnn";
  // private static _mlContext: any;
  // private _inputMLTensor: any;
  constructor(e, t, n) {
    super(e, n), this._engine = t;
  }
  [Symbol.dispose]() {
    this._engine.release(), super[Symbol.dispose]();
  }
  // private async ensureResources() {
  //     this._inputMLTensor = await WebNNBackend._mlContext.createTensor({
  //         dataType: "float32",
  //         shape: [1, 3, this._engine.inputHeight, this._engine.inputWidth],
  //         writable: true,
  //     });
  // }
  async runInference(e) {
    const t = e instanceof ImageBitmap ? await this.preprocessImage(e) : e;
    try {
      return await this.runInferenceImpl(t);
    } catch (n) {
      throw console.error(n), new fn("Inference error", t.input);
    }
  }
  async runInferenceImpl(e) {
    const t = ct.startNew(), n = new Cr.Tensor("float32", e.tensor.data.slice(0), [
      1,
      ...e.tensor.shape
    ]);
    let a;
    try {
      a = await this._engine.run({
        [this._engine.inputNames[0]]: n
      });
    } finally {
      n.dispose();
    }
    return {
      inferenceTimeMs: t.elapsedMilliseconds,
      result: a,
      inputImage: e.input,
      resizedHeight: e.resizedHeight,
      resizedWidth: e.resizedWidth,
      tensor: e.tensor
    };
  }
  static defaultSessionOptions = {
    executionProviders: [
      {
        name: "webnn",
        deviceType: "gpu",
        powerPreference: "high-performance"
      }
    ],
    graphOptimizationLevel: "all",
    enableProfiling: !1,
    enableMemPattern: !1,
    enableCpuMemArena: !1,
    enableGraphCapture: !1,
    logSeverityLevel: 3,
    extra: {
      session: {
        disable_prepacking: "1",
        use_device_allocator_for_initializers: "1",
        use_ort_model_bytes_directly: "1",
        use_ort_model_bytes_for_initializers: "1",
        disable_cpu_ep_fallback: "0",
        set_denormal_as_zero: "0",
        use_env_allocators: "0"
      }
    }
  };
  static async create(e, t, n) {
    try {
      const a = n ?? t.defaultExecutorConfigs.get(Kr.ThisExecutorType) ?? this.defaultSessionOptions, i = a.executionProviders?.[0], s = await Cr.InferenceSession.create(e, a);
      return s.inputWidth = t.inputWidth, s.inputHeight = t.inputHeight, new Kr(t, s, Kr.ThisExecutorType);
    } catch (a) {
      throw console.error(`Failed to load model at ${t.filename}: ${a}`), a;
    }
  }
}
const jB = () => {
  if (/iP(hone|od|ad)/.test(navigator.platform)) {
    const r = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    return r ? parseInt(r[1], 10) : -1;
  }
  return -1;
};
Cr.env.wasm.numThreads = jB() === 17 ? 1 : navigator.hardwareConcurrency >= 12 ? 6 : 2;
Cr.env.wasm.proxy = !0;
const xf = Cr.env.versions.web ?? Cr.env.versions.common;
Cr.env.wasm.wasmPaths = {
  wasm: `./ort-wasm-simd-threaded.jsep.wasm?v=${xf}`,
  mjs: `./ort-wasm-simd-threaded.jsep.mjs?v=${xf}`
};
class lt extends Ya {
  _engine;
  static ThisExecutorType = "wasm";
  constructor(e, t, n) {
    super(e, n), this._engine = t;
  }
  [Symbol.dispose]() {
    this._engine.release(), super[Symbol.dispose]();
  }
  async runInference(e) {
    const t = e instanceof ImageBitmap ? await this.preprocessImage(e) : e;
    try {
      return await this.runInferenceImpl(t);
    } catch (n) {
      throw console.error(n), new fn("Inference error", t.input);
    }
  }
  async runInferenceImpl(e) {
    const t = ct.startNew(), n = new Cr.Tensor("float32", e.tensor.data.slice(0), [1, ...e.tensor.shape]);
    let a;
    try {
      a = await this._engine.run({
        [this._engine.inputNames[0]]: n
      });
    } finally {
      n.dispose();
    }
    return {
      inferenceTimeMs: t.elapsedMilliseconds,
      result: a,
      inputImage: e.input,
      resizedHeight: e.resizedHeight,
      resizedWidth: e.resizedWidth,
      tensor: e.tensor
    };
  }
  static defaultSessionOptions = {
    executionProviders: ["wasm"],
    executionMode: "sequential",
    enableCpuMemArena: !1,
    enableMemPattern: !0,
    logVerbosityLevel: 2,
    logSeverityLevel: 3,
    graphOptimizationLevel: "all",
    enableGraphCapture: !1,
    extra: {
      session: {
        disable_prepacking: "1",
        use_device_allocator_for_initializers: "1",
        use_ort_model_bytes_directly: "1",
        use_ort_model_bytes_for_initializers: "1",
        disable_cpu_ep_fallback: "0"
      }
    },
    interOpNumThreads: 1
  };
  static async create(e, t, n) {
    try {
      const a = n ?? t.defaultExecutorConfigs.get(lt.ThisExecutorType) ?? this.defaultSessionOptions, i = await Cr.InferenceSession.create(e, a);
      return i.inputWidth = t.inputWidth, i.inputHeight = t.inputHeight, new lt(t, i, "wasm");
    } catch (a) {
      throw console.error(`Failed to load model ${t.filename}: ${a}`), console.log("the error: " + JSON.stringify(a)), a;
    }
  }
}
const _d = {
  filename: "detection-mobile.onnx",
  inputWidth: 229,
  inputHeight: 129,
  defaultExecutorConfigs: /* @__PURE__ */ new Map([
    [
      "wasm",
      {
        ...lt.defaultSessionOptions,
        executionMode: "parallel",
        enableCpuMemArena: !0,
        enableMemPattern: !0,
        logVerbosityLevel: 2,
        logSeverityLevel: 3,
        graphOptimizationLevel: "all",
        enableGraphCapture: !1,
        extra: {
          session: {
            disable_prepacking: "1",
            use_device_allocator_for_initializers: "1",
            use_ort_model_bytes_directly: "1",
            use_ort_model_bytes_for_initializers: "1",
            disable_cpu_ep_fallback: "0"
          },
          optimization: {
            enable_gelu_approximation: "1"
          }
        },
        interOpNumThreads: 2
      }
    ],
    [
      "webnn",
      {
        ...Kr.defaultSessionOptions,
        graphOptimizationLevel: "disabled",
        enableProfiling: !1,
        enableMemPattern: !1,
        enableCpuMemArena: !0,
        enableGraphCapture: !1,
        logSeverityLevel: 3,
        extra: {
          session: {
            disable_prepacking: "1",
            use_device_allocator_for_initializers: "1",
            use_ort_model_bytes_directly: "1",
            use_ort_model_bytes_for_initializers: "1",
            disable_cpu_ep_fallback: "0",
            set_denormal_as_zero: "0",
            use_env_allocators: "0"
          }
        },
        interOpNumThreads: 1,
        intraOpNumThreads: 2,
        executionMode: "parallel"
      }
    ],
    [
      "webgpu",
      {
        ..._t.defaultSessionOptions,
        graphOptimizationLevel: "extended",
        executionMode: "parallel",
        interOpNumThreads: 1,
        intraOpNumThreads: 2,
        enableProfiling: !1,
        enableGraphCapture: !1,
        enableMemPattern: !1,
        enableCpuMemArena: !0,
        logSeverityLevel: 3,
        extra: {
          session: {
            disable_prepacking: "1",
            use_device_allocator_for_initializers: "1",
            use_ort_model_bytes_directly: "1",
            use_ort_model_bytes_for_initializers: "1",
            disable_cpu_ep_fallback: "0"
          }
        }
      }
    ]
  ])
}, Td = {
  filename: "quality.onnx",
  inputWidth: 112,
  inputHeight: 112,
  defaultExecutorConfigs: /* @__PURE__ */ new Map([
    [
      "webgpu",
      {
        ..._t.defaultSessionOptions,
        graphOptimizationLevel: "basic",
        executionMode: "sequential",
        interOpNumThreads: 1,
        intraOpNumThreads: 2,
        enableProfiling: !1,
        enableGraphCapture: !1,
        enableMemPattern: !1,
        enableCpuMemArena: !0,
        logSeverityLevel: 3,
        extra: {
          session: {
            disable_prepacking: "1",
            use_device_allocator_for_initializers: "1",
            use_ort_model_bytes_directly: "1",
            use_ort_model_bytes_for_initializers: "1",
            disable_cpu_ep_fallback: "0"
          }
        }
      }
    ],
    [
      "webnn",
      {
        ...Kr.defaultSessionOptions,
        graphOptimizationLevel: "disabled",
        executionMode: "sequential",
        interOpNumThreads: 1,
        intraOpNumThreads: 2,
        enableProfiling: !1,
        enableMemPattern: !1,
        enableCpuMemArena: !1,
        enableGraphCapture: !1,
        logSeverityLevel: 3,
        extra: {
          session: {
            disable_prepacking: "1",
            use_device_allocator_for_initializers: "1",
            use_ort_model_bytes_directly: "1",
            use_ort_model_bytes_for_initializers: "1",
            disable_cpu_ep_fallback: "0",
            set_denormal_as_zero: "0",
            use_env_allocators: "0"
          }
        }
      }
    ],
    [
      "wasm",
      {
        ...lt.defaultSessionOptions,
        executionMode: "sequential",
        enableCpuMemArena: !1,
        enableMemPattern: !0,
        logSeverityLevel: 3,
        graphOptimizationLevel: "all",
        enableGraphCapture: !1,
        interOpNumThreads: 1,
        intraOpNumThreads: 1,
        extra: {
          session: {
            disable_prepacking: "1",
            use_device_allocator_for_initializers: "1",
            use_ort_model_bytes_directly: "1",
            use_ort_model_bytes_for_initializers: "1",
            disable_cpu_ep_fallback: "0"
          }
        }
      }
    ]
  ])
}, Fd = {
  filename: "landmarks.onnx",
  inputWidth: 112,
  inputHeight: 112,
  defaultExecutorConfigs: /* @__PURE__ */ new Map([
    [
      "webgpu",
      {
        ..._t.defaultSessionOptions,
        graphOptimizationLevel: "all",
        executionMode: "sequential",
        interOpNumThreads: 2,
        intraOpNumThreads: 1,
        enableProfiling: !1,
        enableGraphCapture: !1,
        enableMemPattern: !1,
        enableCpuMemArena: !1,
        logSeverityLevel: 3,
        extra: {
          session: {
            disable_prepacking: "1",
            use_device_allocator_for_initializers: "1",
            use_ort_model_bytes_directly: "1",
            use_ort_model_bytes_for_initializers: "1",
            disable_cpu_ep_fallback: "0"
          }
        }
      }
    ],
    [
      "webnn",
      {
        ...Kr.defaultSessionOptions,
        graphOptimizationLevel: "disabled",
        enableProfiling: !1,
        enableMemPattern: !1,
        enableCpuMemArena: !1,
        enableGraphCapture: !1,
        logSeverityLevel: 3,
        extra: {
          session: {
            disable_prepacking: "1",
            use_device_allocator_for_initializers: "1",
            use_ort_model_bytes_directly: "1",
            use_ort_model_bytes_for_initializers: "1",
            disable_cpu_ep_fallback: "0",
            set_denormal_as_zero: "0",
            use_env_allocators: "0"
          }
        },
        executionMode: "sequential",
        interOpNumThreads: 1,
        intraOpNumThreads: 2
      }
    ],
    [
      "wasm",
      {
        ...lt.defaultSessionOptions,
        executionMode: "parallel",
        enableCpuMemArena: !1,
        enableMemPattern: !0,
        logSeverityLevel: 3,
        graphOptimizationLevel: "all",
        enableGraphCapture: !1,
        extra: {
          session: {
            disable_prepacking: "1",
            use_device_allocator_for_initializers: "1",
            use_ort_model_bytes_directly: "1",
            use_ort_model_bytes_for_initializers: "1",
            disable_cpu_ep_fallback: "0"
          }
        },
        interOpNumThreads: 2,
        intraOpNumThreads: 1
      }
    ]
  ])
};
Cr.env.webgl.textureCacheMode = "full";
Cr.env.webgl.contextId = "webgl2";
class In extends Ya {
  _engine;
  static ThisExecutorType = "webgl";
  constructor(e, t, n) {
    super(e, n), this._engine = t;
  }
  [Symbol.dispose]() {
    this._engine.release(), super[Symbol.dispose]();
  }
  async runInference(e) {
    const t = e instanceof ImageBitmap ? await this.preprocessImage(e) : e;
    try {
      return await this.runInferenceImpl(t);
    } catch (n) {
      throw console.error(n), new fn("Inference error", t.input);
    }
  }
  async runInferenceImpl(e) {
    const t = new Cr.Tensor("float32", e.tensor.data, [1, ...e.tensor.shape]), n = ct.startNew();
    let a;
    try {
      a = await this._engine.run({
        [this._engine.inputNames[0]]: t
      });
    } finally {
      t.dispose();
    }
    return {
      inferenceTimeMs: n.elapsedMilliseconds,
      result: a,
      inputImage: e.input,
      resizedHeight: e.resizedHeight,
      resizedWidth: e.resizedWidth,
      tensor: e.tensor
    };
  }
  static defaultSessionOptions = {
    executionProviders: [
      {
        name: "webgl"
      }
    ],
    executionMode: "parallel",
    enableCpuMemArena: !0,
    enableMemPattern: !0,
    graphOptimizationLevel: "all",
    interOpNumThreads: 1,
    intraOpNumThreads: 1,
    extra: {
      session: {
        disable_prepacking: "1",
        use_device_allocator_for_initializers: "1",
        use_ort_model_bytes_directly: "1",
        use_ort_model_bytes_for_initializers: "1",
        disable_cpu_ep_fallback: "0"
      }
    }
  };
  static async create(e, t, n) {
    try {
      const a = n ?? t.defaultExecutorConfigs.get(In.ThisExecutorType) ?? this.defaultSessionOptions, i = await Cr.InferenceSession.create(e, a);
      return i.inputWidth = t.inputWidth, i.inputHeight = t.inputHeight, new In(t, i, "webgl");
    } catch (a) {
      throw console.error(`Failed to load model at ${t.filename}: ${a}`), a;
    }
  }
}
const Aa = /* @__PURE__ */ new Map();
function KB() {
  Aa.clear();
}
async function Sn(r, e) {
  const { executor: t, modelConfig: n, modelBasePath: a, sessionOptions: i } = r, s = `${a}/${n.filename}`;
  let l = Aa.has(s) ? Aa.get(s) : await lv(
    s,
    {
      onProgress: (c) => {
      }
    },
    e
  );
  if (!l)
    throw new Error("No model data");
  switch (Aa.set(s, l), l = l.slice(0), t) {
    case "wasm":
      return await lt.create(
        l,
        n,
        i
      );
    case "webgpu":
      return await _t.create(
        l,
        n,
        i
      );
    case "webnn":
      return await Kr.create(
        l,
        n,
        i
      );
    case "webgl":
      return await In.create(
        l,
        n,
        i
      );
    default:
      throw new Error(`executor of type ${t} not supported!`);
  }
}
class e4 {
  _backend;
  constructor(e) {
    this._backend = e;
  }
  [Symbol.dispose]() {
    this._backend[Symbol.dispose]();
  }
  async detectFaces(e, t) {
    let n, a = !1;
    {
      const i = ct.startNew();
      e instanceof ImageBitmap ? n = e : (n = await createImageBitmap(e), a = !0), i.stop();
    }
    try {
      let i;
      {
        const l = ct.startNew();
        i = await this._backend.runInference(n), l.stop();
      }
      n = i.inputImage;
      let s;
      if (s = await this.postprocessResults(
        n,
        i.result,
        t,
        i.resizedWidth,
        i.resizedHeight
      ), s.length === 0 && a) {
        try {
          n.close();
        } catch {
        }
        a = !1;
      }
      return s;
    } catch (i) {
      if (a)
        try {
          n.close();
        } catch {
        }
      throw i;
    }
  }
  async postprocessResults(e, t, n, a, i) {
    const s = [], l = [];
    try {
      const c = t.selected_indices.data.length / 3;
      for (let d = 0; d < c; d++) {
        const v = 3 * (d + 1), x = Number(t.selected_indices.data[v - 1]), h = Array.from(t.bboxes.data.slice(x * 4, x * 4 + 4));
        s.push(h), l.push(Number(t.scores.data[x]));
      }
      const o = this._backend.modelConfig.inputWidth / a, u = this._backend.modelConfig.inputHeight / i;
      let f = s.map((d, v) => {
        const x = {
          x: d[0] * o * e.width,
          y: d[1] * u * e.height
        }, h = d[2] * o * e.width - x.x, D = d[3] * u * e.height - x.y;
        return { origin: x, width: h, height: D, score: l[v] };
      });
      f.sort(
        (d, v) => this.calculateBoundingBoxArea(v, e.width, e.height) - this.calculateBoundingBoxArea(d, e.width, e.height)
      ), n && (f = f.slice(0, 1));
      const m = f.map(
        (d) => this.expandBoundingBox(this.makeSquareBoundingBox(Ti(d, e.width, e.height)), 0.3)
      );
      return f.map((d, v) => ({
        boundingBox: d,
        preparedBoundingBox: m[v],
        sourceImage: e,
        timings: { detection: { preProcess: 0, infer: 0, postProcess: 0 } }
      }));
    } finally {
      for (const c of Object.keys(t))
        t[c].dispose?.();
    }
  }
  calculateBoundingBoxArea(e, t, n) {
    const a = Ti(e, t, n);
    return a.width * a.height;
  }
  expandBoundingBox(e, t) {
    const n = e.width * t, a = e.height * t, i = e.width + n, s = e.height + a, l = e.origin.x - n / 2, c = e.origin.y - a / 2;
    return {
      origin: { x: l, y: c },
      width: i,
      height: s,
      score: e.score
    };
  }
  makeSquareBoundingBox(e) {
    const { origin: t, width: n, height: a, score: i } = e, s = Math.max(n, a), l = t.x + n / 2, c = t.y + a / 2, o = l - s / 2, u = c - s / 2;
    return {
      origin: { x: o, y: u },
      width: s,
      height: s,
      score: i
    };
  }
}
class r4 {
  _backend;
  constructor(e) {
    this._backend = e;
  }
  [Symbol.dispose]() {
    this._backend[Symbol.dispose]();
  }
  groupFacesWithoutPreparedImageWithMap(e) {
    const t = e.filter((a) => !a.preparedImage), n = /* @__PURE__ */ new Map();
    for (const a of t) {
      const i = a.sourceImage, s = n.get(i);
      s ? s.push(a) : n.set(i, [a]);
    }
    return n;
  }
  async runQuality(e) {
    const t = this.groupFacesWithoutPreparedImageWithMap(e), n = [];
    t.forEach((a, i) => {
      const s = async (l, c) => {
        const o = await Af(
          c,
          l.map((u) => u.preparedBoundingBox)
        );
        for (let u = 0; u < o.length; u++)
          a[u].preparedImage = await this._backend.preprocessImage(o[u]);
      };
      n.push(s(a, i));
    }), await Promise.all(n);
    for (let a = 0; a < e.length; a++) {
      const i = e[a];
      if (!i.preparedImage)
        continue;
      const s = ct.startNew(), l = await this._backend.runInference(i.preparedImage);
      s.elapsedMilliseconds, i.quality = l.result.qualities.data[0], i.acceptability = l.result.acceptabilities.data[0];
      for (const c of Object.keys(l.result))
        l.result[c].dispose?.();
    }
  }
}
const T4 = (r, e) => r && !e || !r && e ? !1 : !r && !e ? !0 : !r || !e ? !1 : r.origin.x === e.origin.x && r.origin.y === e.origin.y && r.width === e.width && r.height === e.height && r.score === e.score, t4 = (r) => {
  const { leftEye: e, rightEye: t, nose: n, leftMouth: a, rightMouth: i } = r, s = t.x - e.x, l = t.y - e.y, c = Math.atan2(l, s) * (180 / Math.PI), o = (e.x + t.x) / 2;
  let u = Math.sqrt(s * s + l * l);
  u === 0 && (u = 1);
  const f = Math.max(-1, Math.min(1, (n.x - o) / u)), m = Math.asin(f) * (180 / Math.PI), p = (e.y + t.y) / 2;
  let v = (a.y + i.y) / 2 - p;
  v === 0 && (v = 1);
  const x = p + v / 2, h = Math.max(-1, Math.min(1, (n.y - x) / (v / 2))), D = Math.asin(h) * (180 / Math.PI), y = Math.abs(m) * (Math.PI / 180), w = Math.abs(D) * (Math.PI / 180), b = Math.max(0, Math.min(1, Math.cos(y) * Math.cos(w)));
  return { yaw: m, pitch: D, roll: c, frontality: b };
}, n4 = (r) => t4(r).frontality;
class a4 {
  _backend;
  constructor(e) {
    this._backend = e;
  }
  [Symbol.dispose]() {
    this._backend[Symbol.dispose]();
  }
  groupFacesWithoutPreparedImageWithMap(e) {
    const t = e.filter((a) => !a.preparedImage), n = /* @__PURE__ */ new Map();
    for (const a of t) {
      const i = a.sourceImage, s = n.get(i);
      s ? s.push(a) : n.set(i, [a]);
    }
    return n;
  }
  async runLandmarks(e) {
    if (e.length === 0)
      return;
    const t = this.groupFacesWithoutPreparedImageWithMap(e), n = [];
    t.forEach((a, i) => {
      const s = async (l, c) => {
        const o = await Af(
          c,
          l.map((u) => u.preparedBoundingBox)
        );
        for (let u = 0; u < o.length; u++)
          a[u].preparedImage = await this._backend.preprocessImage(o[u]);
      };
      n.push(s(a, i));
    }), n.length !== 0 && await Promise.all(n);
    for (let a = 0; a < e.length; a++) {
      const i = e[a];
      if (!i.preparedImage)
        continue;
      const s = await this._backend.runInference(i.preparedImage), l = this.processLandmarkOutput(
        s.result.landmarks.data,
        i.preparedBoundingBox
      );
      i.landmarks = l;
      for (const c of Object.keys(s.result))
        s.result[c].dispose?.();
    }
  }
  processLandmarkOutput(e, t) {
    const n = (i) => i * t.width + t.origin.x, a = (i) => i * t.height + t.origin.y;
    if (e.length < 10)
      throw new Error(
        `Expected at least 10 elements in rawLandmarksData for 5 landmarks, but got ${e.length}`
      );
    return {
      leftEye: {
        x: n(e[0]),
        y: a(e[1])
      },
      rightEye: {
        x: n(e[2]),
        y: a(e[3])
      },
      nose: {
        x: n(e[4]),
        y: a(e[5])
      },
      leftMouth: {
        // Assuming these are the correct indices for mouth corners
        x: n(e[6]),
        y: a(e[7])
      },
      rightMouth: {
        x: n(e[8]),
        y: a(e[9])
      }
    };
  }
}
class Xa {
  _backend;
  constructor(e) {
    this._backend = e;
  }
  [Symbol.dispose]() {
    this._backend[Symbol.dispose]();
  }
  groupFacesWithoutPreparedImageWithMap(e) {
    const t = e.filter((a) => !a.preparedImage), n = /* @__PURE__ */ new Map();
    for (const a of t) {
      const i = a.sourceImage, s = n.get(i);
      s ? s.push(a) : n.set(i, [a]);
    }
    return n;
  }
  /**
   * Aligns a single face to the ArcFace recognition template using its
   * landmarks, returning the aligned crop as an ImageBitmap at the requested
   * square `size` (default 128). `gen6Norms` is the template at 128px and is
   * scaled to `size`, so e.g. size=112 yields the standard 112×112 ArcFace
   * crop (used by Paravision "gen5" crop-aligned recognition). Does NOT run
   * recognition inference (unlike {@link getEmbeddings}, which also overwrites
   * `face.aligned` with the post-inference input image).
   */
  async alignFace(e, t = 128) {
    if (!e.landmarks)
      throw new Error("Face is missing landmarks");
    const n = t / 128, a = Xa.gen6Norms.map((i) => ({ x: i.x * n, y: i.y * n }));
    return this.faceAlignTransform(e.sourceImage, e, a, t);
  }
  async getEmbeddings(e) {
    for (let t of e) {
      t.aligned || (t.aligned = await this.faceAlignTransform(t.sourceImage, t, Xa.gen6Norms));
      const n = await this._backend.runInference(t.aligned);
      t.aligned = n.inputImage;
      const i = n.result.embeddings.data.slice(0);
      t.embeddings = i;
      for (const s of Object.keys(n.result))
        n.result[s].dispose?.();
    }
  }
  /**
   * Compute the optimal similarity transform (scale + rotation + translation)
   * that maps srcPoints[i] → dstPoints[i], in a least-squares sense.
   */
  getSimilarityTransform(e, t) {
    const n = e.length;
    if (n !== t.length || n < 2)
      throw new Error("Need same number (≥2) of src & dst points");
    const a = e.reduce((p, d) => ({ x: p.x + d.x / n, y: p.y + d.y / n }), { x: 0, y: 0 }), i = t.reduce((p, d) => ({ x: p.x + d.x / n, y: p.y + d.y / n }), { x: 0, y: 0 });
    let s = 0, l = 0, c = 0;
    for (let p = 0; p < n; p++) {
      const d = e[p].x - a.x, v = e[p].y - a.y, x = t[p].x - i.x, h = t[p].y - i.y;
      s += x * d + h * v, l += h * d - x * v, c += d * d + v * v;
    }
    if (c === 0)
      throw new Error("Src points are all identical");
    const o = s / c, u = l / c, f = i.x - (o * a.x - u * a.y), m = i.y - (u * a.x + o * a.y);
    return [
      [o, -u, f],
      [u, o, m]
    ];
  }
  static gen6Norms = [
    { x: 43.7652, y: 59.0814 },
    { x: 84.0363, y: 58.8587 },
    { x: 64.0288, y: 81.9846 },
    { x: 47.4849, y: 105.561 },
    { x: 80.8341, y: 105.376 }
  ];
  /**
   * Align a batch of faces to a common "template" using a 2D affine warp.
   * @param image The source ImageBitmap (your “frame”).
   * @param faces  Array of Face objects, each with 5 landmarks.
   * @param normFace A 5×2 array of destination/template landmark positions.
   * @returns An array of { face, aligned } where `aligned` is the 128×128 ImageData.
   */
  async faceAlignTransform(e, t, n, a = 128) {
    const i = a;
    if (!t.landmarks)
      throw new Error("Face is missing landmarks");
    const s = t.landmarks, l = [s.leftEye, s.rightEye, s.nose, s.leftMouth, s.rightMouth], c = this.getSimilarityTransform(l, n), o = document.createElement("canvas");
    o.width = i, o.height = i;
    const u = o.getContext("2d", {
      desynchronized: !0
    });
    if (!u)
      throw new Error("Could not get 2D context");
    return u.setTransform(
      c[0][0],
      c[1][0],
      c[0][1],
      c[1][1],
      c[0][2],
      c[1][2]
    ), u.drawImage(e, 0, 0), await createImageBitmap(o);
  }
}
const Bd = {
  filename: "recognition.onnx",
  inputWidth: 128,
  inputHeight: 128,
  defaultExecutorConfigs: /* @__PURE__ */ new Map([
    [
      "wasm",
      {
        ...lt.defaultSessionOptions,
        executionMode: "parallel",
        enableCpuMemArena: !0,
        enableMemPattern: !0,
        logVerbosityLevel: 2,
        logSeverityLevel: 3,
        graphOptimizationLevel: "all",
        extra: {
          session: {
            disable_prepacking: "1",
            use_device_allocator_for_initializers: "1",
            use_ort_model_bytes_directly: "1",
            use_ort_model_bytes_for_initializers: "1",
            disable_cpu_ep_fallback: "0"
          },
          optimization: {
            enable_gelu_approximation: "1"
          }
        },
        interOpNumThreads: 1,
        intraOpNumThreads: 1,
        freeDimensionOverrides: {
          batch_size: 1
        }
      }
    ],
    [
      "webnn",
      {
        ...Kr.defaultSessionOptions,
        graphOptimizationLevel: "all",
        enableProfiling: !1,
        enableMemPattern: !1,
        enableCpuMemArena: !0,
        enableGraphCapture: !1,
        logSeverityLevel: 3,
        freeDimensionOverrides: {
          batch_size: 1
        },
        extra: {
          session: {
            disable_prepacking: "1",
            use_device_allocator_for_initializers: "1",
            use_ort_model_bytes_directly: "1",
            use_ort_model_bytes_for_initializers: "1",
            disable_cpu_ep_fallback: "0",
            set_denormal_as_zero: "0",
            use_env_allocators: "0"
          }
        },
        interOpNumThreads: 1,
        intraOpNumThreads: 1,
        executionMode: "parallel"
      }
    ],
    [
      "webgpu",
      {
        ..._t.defaultSessionOptions,
        graphOptimizationLevel: "all",
        executionMode: "sequential",
        interOpNumThreads: 1,
        intraOpNumThreads: 1,
        enableProfiling: !1,
        enableGraphCapture: !1,
        enableMemPattern: !1,
        enableCpuMemArena: !0,
        logSeverityLevel: 3,
        freeDimensionOverrides: {
          batch_size: 1
        },
        extra: {
          session: {
            disable_prepacking: "1",
            use_device_allocator_for_initializers: "1",
            use_ort_model_bytes_directly: "1",
            use_ort_model_bytes_for_initializers: "1",
            disable_cpu_ep_fallback: "0"
          },
          optimization: {
            enable_gelu_approximation: "1"
          }
        }
      }
    ]
  ])
}, ma = "wasm", i4 = "/models";
class Od {
  _faceDetector;
  _qualityMeasure;
  _landmarksDetector;
  _recognition;
  constructor(e, t, n, a) {
    this._faceDetector = e, this._qualityMeasure = t, this._landmarksDetector = n, this._recognition = a;
  }
  [Symbol.dispose]() {
    this._faceDetector[Symbol.dispose](), this._qualityMeasure[Symbol.dispose](), this._landmarksDetector[Symbol.dispose](), this._recognition[Symbol.dispose](), KB();
  }
  dispose() {
    this[Symbol.dispose]();
  }
  async getFaces(e, t) {
    return await this._faceDetector.detectFaces(e, t);
  }
  async getQualities(e) {
    await this._qualityMeasure.runQuality(e);
  }
  async getLandmarks(e) {
    await this._landmarksDetector.runLandmarks(e);
  }
  async getEmbeddings(e) {
    await this._recognition.getEmbeddings(e);
  }
  /**
   * Produces the recognition-aligned crop for a face using its five-point
   * landmarks, without running recognition inference. The output is a square
   * `size`×`size` ArcFace crop (default 128; pass 112 for Paravision gen5
   * crop-aligned recognition). The face must already have `landmarks` (call
   * {@link getLandmarks} first). Returns a fresh ImageBitmap the caller is
   * responsible for closing.
   */
  async alignFace(e, t = 128) {
    return this._recognition.alignFace(e, t);
  }
  /**
   * Returns a frontality score (1 = perfectly frontal, 0 = fully turned/tilted)
   * computed from five-point facial landmarks.
   */
  static getFrontalityScore(e) {
    return n4(e);
  }
  static async create(e, t) {
    const n = e.modelBasePath ?? i4, a = new e4(
      await Sn(
        {
          executor: e.detectorSettings ? e.detectorSettings.executorType : ma,
          modelBasePath: n,
          modelConfig: _d
        },
        t
      )
    ), i = new r4(
      await Sn(
        {
          executor: e.qualitySettings ? e.qualitySettings.executorType : ma,
          modelBasePath: n,
          modelConfig: Td
        },
        t
      )
    ), s = new a4(
      await Sn(
        {
          executor: e.landmarkSettings ? e.landmarkSettings.executorType : ma,
          modelBasePath: n,
          modelConfig: Fd
        },
        t
      )
    ), l = new Xa(
      await Sn(
        {
          executor: e.recognitionSettings ? e.recognitionSettings.executorType : ma,
          modelBasePath: n,
          modelConfig: Bd
        },
        t
      )
    );
    return new Od(a, i, s, l);
  }
}
const o4 = "./models";
var Id = /* @__PURE__ */ ((r) => (r.Detection = "detection", r.Quality = "quality", r.Landmarks = "landmarks", r.Recognition = "recognition", r))(Id || {});
const wf = {
  detection: _d,
  quality: Td,
  landmarks: Fd,
  recognition: Bd
};
async function s4(r, e) {
  if (typeof OffscreenCanvas > "u")
    throw new nn("OffscreenCanvas is not supported in this environment. Cannot create dummy image.");
  const t = new OffscreenCanvas(r, e), n = t.getContext("2d", {
    desynchronized: !0
    // Enable desynchronized rendering for better performance
  });
  if (!n)
    throw new nn("Failed to get 2D context from OffscreenCanvas for dummy image creation.");
  return n.fillStyle = "rgba(128, 128, 128, 1)", n.fillRect(0, 0, r, e), createImageBitmap(t);
}
class F4 {
  modelsToRun;
  modelsToTest;
  executorsToTest;
  modelBasePath;
  iterations;
  warmupIterations;
  testAllConfigurations;
  constructor(e = [
    "detection",
    "quality",
    "landmarks"
    /* Landmarks */
  ], t = ["wasm", "webgpu", "webgl", "webnn"], n = o4, a = 10, i = 2, s = !1) {
    if (a <= 0)
      throw new nn("Benchmark iterations must be greater than 0.");
    if (i < 0)
      throw new nn("Warmup iterations must be non-negative.");
    this.modelsToRun = e, this.modelsToTest = e.map((l) => {
      const c = wf[l];
      if (!c)
        throw new nn(
          `Unknown model name provided: ${l}. Supported models are: ${Object.keys(Id).join(
            ", "
          )}`
        );
      return c;
    }), this.executorsToTest = t, this.modelBasePath = n, this.iterations = a, this.warmupIterations = i, this.testAllConfigurations = s;
  }
  getSessionOptionCombinations() {
    const e = [], t = [1], n = [1], a = ["parallel", "sequential"], i = [!0, !1], s = [!0, !1], l = ["all", "extended", "basic", "disabled"], c = [
      { key: "disable_prepacking", values: ["0", "1"] },
      {
        key: "use_device_allocator_for_initializers",
        values: ["0", "1"]
      }
      //{ key: "use_ort_model_bytes_directly", values: ["0", "1"] },
      //{ key: "use_ort_model_bytes_for_initializers", values: ["0", "1"] },
      //{ key: "disable_cpu_ep_fallback", values: ["0", "1"] },
    ];
    for (const o of l)
      for (const u of t)
        for (const f of n)
          for (const m of a)
            for (const p of i)
              for (const d of s) {
                const v = `graphOpt:${o},interOp:${u},intraOp:${f},execMode:${m},cpuMem:${p},memPattern:${d}`;
                e.push({
                  name: v,
                  descriptor: v,
                  graphOptimizationLevel: o,
                  interOpNumThreads: u,
                  intraOpNumThreads: f,
                  executionMode: m,
                  enableCpuMemArena: p,
                  enableMemPattern: d
                });
                for (const x of c)
                  for (const h of x.values) {
                    const D = `${x.key}:${h}`, y = `${v},${D}`;
                    e.push({
                      name: y,
                      descriptor: y,
                      graphOptimizationLevel: o,
                      interOpNumThreads: u,
                      intraOpNumThreads: f,
                      executionMode: m,
                      enableCpuMemArena: p,
                      enableMemPattern: d,
                      extra: {
                        session: {
                          [x.key]: h
                        }
                      }
                    });
                  }
              }
    return e.unshift({
      name: "Default",
      descriptor: "Default settings for executor"
    }), e;
  }
  async wait(e) {
    await new Promise((t) => setTimeout(t, e));
  }
  async runAllBenchmarks() {
    const e = [];
    for (const t of this.modelsToRun) {
      const n = wf[t];
      console.log(`Benchmarking model: ${n.filename} (KnownModel: ${t})...`);
      const a = [];
      let i = 1 / 0, s, l;
      try {
        l = await s4(n.inputWidth, n.inputHeight);
      } catch (o) {
        const u = o instanceof Error ? o.message : String(o);
        console.error(
          `Failed to create dummy image for ${n.filename} (KnownModel: ${t}): ${u}`
        ), this.executorsToTest.forEach((f) => {
          a.push({
            modelName: t,
            executorType: f,
            averageInferenceTimeMs: -1,
            error: `Failed to create dummy image: ${u}`
          });
        }), e.push({
          modelName: t,
          results: a
        });
        continue;
      }
      let c;
      this.testAllConfigurations ? c = this.getSessionOptionCombinations() : c = [
        {
          name: "Default",
          descriptor: "Default settings for executor"
        }
      ];
      for (const o of this.executorsToTest) {
        let u;
        const f = n.defaultExecutorConfigs.get(o);
        if (f)
          u = { ...f };
        else
          switch (o) {
            case "wasm":
              u = {
                ...lt.defaultSessionOptions
              };
              break;
            case "webgpu":
              u = {
                ..._t.defaultSessionOptions
              };
              break;
            case "webgl":
              u = {
                ...In.defaultSessionOptions
              };
              break;
            case "webnn":
              u = {
                ...Kr.defaultSessionOptions
              };
              break;
            default:
              u = {}, console.warn(
                `No default session options found for executor: ${o}. Using empty base.`
              );
              break;
          }
        for (const m of c) {
          console.log(
            `  Testing executor: ${o} with config: ${m.descriptor} for model: ${n.filename} (KnownModel: ${t})`
          );
          const p = {
            ...u
          };
          m.name !== "Default" && (m.interOpNumThreads !== void 0 && (p.interOpNumThreads = m.interOpNumThreads), m.intraOpNumThreads !== void 0 && (p.intraOpNumThreads = m.intraOpNumThreads), m.executionMode !== void 0 && (p.executionMode = m.executionMode), m.enableCpuMemArena !== void 0 && (p.enableCpuMemArena = m.enableCpuMemArena), m.enableMemPattern !== void 0 && (p.enableMemPattern = m.enableMemPattern), m.graphOptimizationLevel !== void 0 && (p.graphOptimizationLevel = m.graphOptimizationLevel)), m.extra && m.extra.session && (p.extra || (p.extra = {}), p.extra.session || (p.extra.session = {}), Object.assign(p.extra.session, m.extra.session));
          let d;
          try {
            d = await Sn({
              executor: o,
              modelConfig: n,
              modelBasePath: this.modelBasePath,
              sessionOptions: p
            });
            for (let b = 0; b < this.warmupIterations; b++)
              try {
                l = (await d.runInference(l)).inputImage;
              } catch (g) {
                g instanceof fn && (l = g.inputImage);
              }
            const v = [];
            let x = 0;
            for (let b = 0; b < this.iterations; b++)
              try {
                const g = await d.runInference(l);
                l = g.inputImage, v.push(g.inferenceTimeMs), x++;
              } catch (g) {
                console.warn(
                  `Error during benchmark iteration ${b + 1} for ${o} with config ${m.descriptor}: ${g instanceof Error ? g.message : String(g)}`
                ), g instanceof fn && (l = g.inputImage);
              }
            let h, D, y, w;
            if (x === 0)
              h = -1, D = `All ${this.iterations} iterations failed.`, console.error(`    All iterations failed for ${o} with config ${m.descriptor}.`);
            else {
              v.sort((g, N) => g - N), y = v[0], w = v[v.length - 1];
              const b = Math.floor(v.length / 2);
              v.length % 2 === 0 ? h = (v[b - 1] + v[b]) / 2 : h = v[b], console.log(
                `    Inference for ${m.descriptor} (${x}/${this.iterations} successful)`
              ), console.log(
                `      Median: ${h.toFixed(2)} ms, Min: ${y.toFixed(
                  2
                )} ms, Max: ${w.toFixed(2)} ms`
              ), h > 0 && h < i && (i = h, s = o);
            }
            a.push({
              modelName: t,
              executorType: o,
              averageInferenceTimeMs: h,
              // This now holds the median or -1
              minInferenceTimeMs: y,
              maxInferenceTimeMs: w,
              error: D,
              sessionOptionsUsed: p,
              configDescription: m.descriptor
            });
          } catch (v) {
            const x = v instanceof Error ? v.message : String(v);
            a.push({
              modelName: t,
              executorType: o,
              averageInferenceTimeMs: -1,
              error: x,
              sessionOptionsUsed: p,
              configDescription: m.descriptor
            }), console.error(
              `    Error setting up benchmark for ${o} with config ${m.descriptor} for ${n.filename} (KnownModel: ${t}): ${x}`
            );
          } finally {
            if (d)
              try {
                d[Symbol.dispose]();
              } catch (v) {
                const x = v instanceof Error ? v.message : String(v);
                console.error(
                  `Error disposing backend for ${o} with config ${m.descriptor} on ${n.filename} (KnownModel: ${t}): ${x}`
                );
              }
          }
        }
      }
      l && typeof l.close == "function" && l.close(), e.push({
        modelName: t,
        fastestExecutor: s,
        fastestTimeMs: i === 1 / 0 ? void 0 : i,
        results: a
      });
    }
    return e;
  }
  getFastestExecutorOverall(e) {
    if (!e || e.length === 0) return;
    const t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
    for (const c of e) {
      if (!c.results || c.results.length === 0) continue;
      let o = 1 / 0;
      for (const f of c.results)
        !f.error && f.averageInferenceTimeMs > 0 && (o = Math.min(o, f.averageInferenceTimeMs));
      const u = o !== 1 / 0 && o > 0;
      for (const f of c.results)
        if (!f.error && f.averageInferenceTimeMs > 0) {
          const m = f.executorType, p = c.modelName;
          if (u) {
            const x = f.averageInferenceTimeMs / o, h = t.get(m) || {
              sumNormalizedTime: 0,
              count: 0
            };
            h.sumNormalizedTime += x, h.count++, t.set(m, h);
          }
          let d = n.get(m);
          d || (d = /* @__PURE__ */ new Map(), n.set(m, d));
          const v = d.get(p);
          (!v || f.averageInferenceTimeMs < v.averageInferenceTimeMs) && d.set(p, f);
        }
    }
    const a = /* @__PURE__ */ new Set([
      ...t.keys(),
      ...n.keys()
    ]);
    if (a.size === 0) return;
    let i, s = 1 / 0;
    const l = {};
    for (const [c, o] of t.entries())
      if (o.count > 0) {
        const u = o.sumNormalizedTime / o.count;
        u < s && (s = u, i = c);
      }
    for (const c of a) {
      const o = t.get(c) || {
        sumNormalizedTime: 0,
        count: 0
      }, u = o.count > 0 ? o.sumNormalizedTime / o.count : 1 / 0, f = [], m = n.get(c);
      m && m.forEach((p) => f.push(p)), f.sort((p, d) => p.modelName.localeCompare(d.modelName)), l[c] = {
        bestResults: f,
        sumNormalizedTime: o.sumNormalizedTime,
        count: o.count,
        averageNormalizedTime: u
      };
    }
    return {
      executor: i,
      averageNormalizedScore: s === 1 / 0 ? void 0 : s,
      details: l
    };
  }
}
var u4 = /* @__PURE__ */ ((r) => (r.Unknown = "Unknown", r.Similarity = "Similarity", r.Score = "Score", r.Confidence = "Confidence", r))(u4 || {});
class Sr {
  static MATCH_SCORE_SCALE = 1e3;
  static ENHANCED_MATCH_SCORE_WEIGHT = 2.35;
  static ENHANCED_MATCH_SCORE_BIAS = -0.5;
  static STANDARD_MATCH_SCORE_WEIGHT = 2.2;
  static STANDARD_MATCH_SCORE_BIAS = -5.35;
  static distance(e, t) {
    let n = 0;
    if (e.length !== t.length)
      throw new Error("Input arrays must have the same length for distance calculation.");
    for (let a = 0; a < e.length; a++) {
      const i = e[a] - t[a];
      n += i * i;
    }
    return n;
  }
  static sigmoidTransform(e, t, n) {
    return 1 / (1 + Math.exp(-(t * e + n)));
  }
  static getMatchScore(e, t) {
    let n = -1;
    const i = Sr.getSimilarity(e, t).matchValue, s = e.length === 257 || e.length === 513 || e.length === 1025;
    return i !== -1 && (s ? n = Math.floor(
      Sr.sigmoidTransform(
        i,
        Sr.ENHANCED_MATCH_SCORE_WEIGHT,
        Sr.ENHANCED_MATCH_SCORE_BIAS
      ) * Sr.MATCH_SCORE_SCALE
    ) : n = Math.floor(
      Sr.sigmoidTransform(
        i,
        Sr.STANDARD_MATCH_SCORE_WEIGHT,
        Sr.STANDARD_MATCH_SCORE_BIAS
      ) * Sr.MATCH_SCORE_SCALE
    )), { matchScoreType: "Score", matchValue: n };
  }
  static getSimilarity(e, t) {
    if (e.length === 0 || t.length === 0)
      throw new Error("Empty input embedding.");
    if (e.length !== t.length)
      throw new Error("Invalid input embedding: lengths do not match.");
    return { matchScoreType: "Similarity", matchValue: e.length === 257 || e.length === 513 || e.length === 1025 ? Sr.getEnhancedScore(e, t) : Sr.getStandardScore(e, t) };
  }
  static getStandardScore(e, t) {
    if (e.length === 0 || t.length === 0 || e.length !== t.length)
      throw new Error("Embedding mismatch or empty.");
    return 4 - Sr.distance(e, t);
  }
  static getEnhancedScore(e, t) {
    const n = e[e.length - 1] + t[t.length - 1];
    if (n < 0)
      throw new Error("Negative quality.");
    let a = 0;
    for (let c = 0; c < e.length - 1; ++c)
      a += e[c] * t[c];
    const s = 2 * (1 - a) / (1e-10 + n) + Math.log(1e-10 + n);
    return ((c, o, u) => c < o ? o : c > u ? u : c)(Math.exp(-s), 0, 2);
  }
  static getConfidence(e, t) {
    let n = e, a = t;
    if ((e.length === 257 || e.length === 513 || e.length === 1025) && (n = e.slice(0, e.length - 1)), (t.length === 257 || t.length === 513 || t.length === 1025) && (a = t.slice(0, t.length - 1)), n.length !== a.length)
      throw new Error(
        `Mismatch in embedding lengths for confidence after handling enhanced embeddings: ${n.length} vs ${a.length}`
      );
    return {
      matchScoreType: "Confidence",
      matchValue: ((c) => {
        const o = 4 - c;
        return 1 / (1 + Math.exp(-(20.9678 * o + -58.333076)));
      })(Sr.distance(n, a))
    };
  }
}
function c4(r) {
  if (!r.embeddings)
    throw new Error("FaceRecognitionItem cannot be created from a Face without embeddings.");
  return {
    embeddings: r.embeddings,
    // f.Embedding.Memory is Float32Array
    metrics: {
      acceptability: r.acceptability ?? 0,
      quality: r.quality ?? 0
    }
  };
}
class l4 {
  qualityDiffMinimum = 0;
  compare(e, t) {
    return Math.abs(e.metrics.quality - t.metrics.quality) <= this.qualityDiffMinimum ? e.metrics.acceptability < t.metrics.acceptability ? -1 : e.metrics.acceptability > t.metrics.acceptability ? 1 : 0 : e.metrics.quality < t.metrics.quality ? -1 : e.metrics.quality > t.metrics.quality ? 1 : 0;
  }
}
var f4 = /* @__PURE__ */ ((r) => (r.Unknown = "Unknown", r.NotActive = "NotActive", r.Active = "Active", r.TimedOut = "TimedOut", r.Expired = "Expired", r))(f4 || {}), m4 = /* @__PURE__ */ ((r) => (r.None = "None", r.MatchedOnly = "MatchedOnly", r.MatchedAndAddedToCluster = "MatchedAndAddedToCluster", r.NewSubjectAdded = "NewSubjectAdded", r))(m4 || {});
class p4 {
  // Not exported as it's an internal detail of FaceTrackedSubject
  comparerInstance = new l4();
  faceTrackerSession;
  faceSubjects;
  constructor(e, t) {
    this.faceTrackerSession = t, this.comparerInstance.qualityDiffMinimum = this.faceTrackerSession.qualityDiffMinimum, this.faceSubjects = [e], this.sortFaceSubjects();
  }
  sortFaceSubjects() {
    this.faceSubjects.sort((e, t) => this.comparerInstance.compare(e, t));
  }
  get highestMetrics() {
    return this.faceSubjects.length === 0 ? { quality: -1, acceptability: -1 } : this.faceSubjects[this.faceSubjects.length - 1].metrics;
  }
  get minSubject() {
    return this.faceSubjects.length === 0 ? null : this.faceSubjects[0];
  }
  addFaceSubject(e) {
    this.comparerInstance.qualityDiffMinimum = this.faceTrackerSession.qualityDiffMinimum;
    const t = this.calculateMatchScore(e.embeddings), n = t.matchValue >= this.faceTrackerSession.matchScoreMinimum, a = this.minSubject;
    if (this.faceSubjects.length < this.faceTrackerSession.faceTracker.clusterMaximum || a && this.comparerInstance.compare(e, a) > 0) {
      let i = 0, s = this.faceSubjects.length;
      for (; i < s; ) {
        const l = i + s >>> 1;
        this.comparerInstance.compare(e, this.faceSubjects[l]) > 0 ? i = l + 1 : s = l;
      }
      return this.faceSubjects.splice(i, 0, e), this.faceSubjects.length > this.faceTrackerSession.faceTracker.clusterMaximum && this.faceSubjects.shift(), { matchScore: t, added: !0, matched: n };
    }
    return { matchScore: t, added: !1, matched: n };
  }
  calculateMatchScore(e) {
    let t = { matchScoreType: "Unknown", matchValue: -1 / 0 };
    for (const n of this.faceSubjects) {
      const a = this.faceTrackerSession.faceMatchFunction(n.embeddings, e);
      a.matchValue >= t.matchValue && (t = a);
    }
    return t;
  }
}
function $d() {
  return crypto.randomUUID();
}
class d4 {
  faceTrackerSession;
  // Use concrete type for internal access
  cluster;
  lastState = "Unknown";
  matchCountInternal = 0;
  forcedExpired = !1;
  creationTime;
  lastSeenTime;
  sessionStartTimeInternal = null;
  id;
  constructor(e, t, n) {
    this.id = $d(), this.faceTrackerSession = t, this.cluster = new p4(e, t), this.creationTime = n, this.lastSeenTime = n;
  }
  get trackDuration() {
    return this.faceTrackerSession.currentTime - this.creationTime;
  }
  get lastSeen() {
    return this.faceTrackerSession.currentTime - this.lastSeenTime;
  }
  get isActive() {
    return this.faceTrackerSession.currentTime - this.lastSeenTime < this.faceTrackerSession.activeTimeout && this.matchCountInternal >= this.faceTrackerSession.matchCountMinimum;
  }
  get isSessionTimedOut() {
    return this.faceTrackerSession.currentTime - this.lastSeenTime > this.faceTrackerSession.subjectTimeout;
  }
  get isExpired() {
    return this.forcedExpired || this.faceTrackerSession.currentTime - this.lastSeenTime > this.faceTrackerSession.subjectExpire;
  }
  forceExpired() {
    this.forcedExpired = !0;
  }
  get highestMetrics() {
    return this.cluster.highestMetrics;
  }
  get sessionStart() {
    return this.sessionStartTimeInternal !== null ? this.faceTrackerSession.currentTime - this.sessionStartTimeInternal : null;
  }
  markActive() {
    this.matchCountInternal++, this.lastSeenTime = this.faceTrackerSession.currentTime;
  }
  get faceTrackedState() {
    return this.forcedExpired ? "Expired" : this.matchCountInternal < this.faceTrackerSession.matchCountMinimum ? "Unknown" : this.isExpired ? "Expired" : this.isSessionTimedOut ? "TimedOut" : this.isActive ? "Active" : "NotActive";
  }
  get matchCount() {
    return this.matchCountInternal;
  }
  processState() {
    const e = this.faceTrackedState;
    e === "Active" ? (this.lastState !== "Active" && (this.sessionStartTimeInternal = this.faceTrackerSession.currentTime), this.faceTrackerSession.registerActive(this, this.lastState, !0)) : e === "TimedOut" && this.sessionStartTimeInternal !== null ? (this.faceTrackerSession.registerTimeout(this, this.lastState), this.sessionStartTimeInternal = null) : e === "Expired" ? (this.faceTrackerSession.registerExpired(this, this.lastState), this.sessionStartTimeInternal = null) : this.faceTrackerSession.registerActive(this, this.lastState, !1), this.lastState = e;
  }
  matches(e) {
    const t = this.cluster.calculateMatchScore(e.embeddings);
    return { matches: t.matchValue >= this.faceTrackerSession.matchScoreMinimum, score: t };
  }
  tryAddFaceSubject(e) {
    return this.cluster.addFaceSubject(e);
  }
}
class v4 {
  sessions = /* @__PURE__ */ new Map();
  clusterMaximum = 5;
  tryUnregister(e) {
    return this.sessions.delete(e);
  }
  createSession(e, t) {
    const n = new h4(this, e, t);
    return this.sessions.set(n.id, n), n;
  }
}
class h4 {
  trackedSubjects = /* @__PURE__ */ new Map();
  activeIdsSet = /* @__PURE__ */ new Set();
  // Renamed to avoid conflict with 'id' property
  faceTrackerInstance;
  currentTime = 0;
  // Milliseconds
  subjectStateChangedListeners = [];
  name;
  faceMatchFunction;
  id;
  matchScoreMinimum = 530;
  qualityToAddMinimum = 0.5;
  acceptabilityToAddMinimum = 0.2;
  matchCountMinimum = 0;
  qualityDiffMinimum = 0.01;
  activeTimeout = 3 * 1e3;
  subjectTimeout = 0.15 * 60 * 60 * 1e3;
  subjectExpire = 120 * 1e3;
  constructor(e, t, n) {
    this.id = $d(), this.name = t, this.faceMatchFunction = n, this.faceTrackerInstance = e;
  }
  dispose() {
    this.faceTrackerInstance.tryUnregister(this.id), this.subjectStateChangedListeners = [], this.trackedSubjects.clear(), this.activeIdsSet.clear();
  }
  get faceTracker() {
    return this.faceTrackerInstance;
  }
  addSubjectStateChangedListener(e) {
    this.subjectStateChangedListeners.push(e);
  }
  removeSubjectStateChangedListener(e) {
    const t = this.subjectStateChangedListeners.indexOf(e);
    t > -1 && this.subjectStateChangedListeners.splice(t, 1);
  }
  onSubjectStateChanged(e) {
    this.subjectStateChangedListeners.forEach((t) => t(this, e));
  }
  registerActive(e, t, n) {
    const a = {
      subject: e,
      oldState: t,
      newState: e.faceTrackedState
    };
    n ? this.activeIdsSet.has(e.id) || (this.activeIdsSet.add(e.id), this.onSubjectStateChanged(a)) : this.activeIdsSet.has(e.id) && (this.activeIdsSet.delete(e.id), this.onSubjectStateChanged(a));
  }
  registerTimeout(e, t) {
    this.onSubjectStateChanged({ subject: e, oldState: t, newState: e.faceTrackedState });
  }
  registerExpired(e, t) {
    this.activeIdsSet.delete(e.id), this.onSubjectStateChanged({ subject: e, oldState: t, newState: e.faceTrackedState }), this.trackedSubjects.delete(e.id);
  }
  isQualityHighEnoughToAdd(e) {
    return e.metrics.quality >= this.qualityToAddMinimum && e.metrics.acceptability >= this.acceptabilityToAddMinimum;
  }
  markActive(e) {
    const t = this.trackedSubjects.get(e);
    t && t.markActive();
  }
  processFace(e) {
    const t = this.isQualityHighEnoughToAdd(e), n = this.findMatch(e, t);
    let a = n.subject, i = n.addedToCluster, s = n.matchResult, l = !!a;
    if (a && a.markActive(), !a && t) {
      const o = new d4(e, this, this.currentTime);
      this.trackedSubjects.set(o.id, o), a = o, i = !0, l = !1;
    }
    let c = "None";
    return l ? i ? c = "MatchedAndAddedToCluster" : c = "MatchedOnly" : !l && a && (c = "NewSubjectAdded"), {
      subject: a,
      resultFlags: c,
      matchScore: s,
      hasSubject: !!a
    };
  }
  processState() {
    Array.from(this.trackedSubjects.values()).forEach((e) => e.processState());
  }
  getMatches(e) {
    const t = [];
    for (const n of this.trackedSubjects.values()) {
      const a = n.matches(e);
      a.matches && t.push({ subject: n, matchResult: a.score });
    }
    return t;
  }
  findMatch(e, t) {
    let n = { matchScoreType: "Unknown", matchValue: -1 / 0 }, a = !1, i = null;
    for (const s of this.trackedSubjects.values()) {
      const l = s.matches(e);
      l.matches && l.score.matchValue > n.matchValue && (n = l.score, i = s);
    }
    if (i && t) {
      const s = i.tryAddFaceSubject(e);
      n = s.matchScore, a = s.added;
    }
    return { subject: i, matchResult: n, addedToCluster: a };
  }
}
function g4(r) {
  var e, t;
  const n = Float64Array.from(r.flat()), a = r.length, i = (t = (e = r[0]) === null || e === void 0 ? void 0 : e.length) !== null && t !== void 0 ? t : 0;
  if (n.length !== a * i)
    throw new Error("Arrays cannot convert to a valid Matrix.");
  return { data: n, shape: [a, i] };
}
function y4(r, e, t) {
  const n = r.slice();
  let a = 0;
  for (let i = 0; i < e; i++)
    for (let s = 0; s < t; s++)
      n[s * e + i] = r[a++];
  return n;
}
class b4 {
  constructor(e) {
    this.checkWeightMatrix(e);
    let [t, n] = e.shape;
    t <= n ? (this.rowCount = t, this.colCount = n, this.transposed = !1, this.edgeWeights = e.data) : (this.rowCount = n, this.colCount = t, this.transposed = !0, this.edgeWeights = y4(e.data, t, n), t = this.rowCount, n = this.colCount);
    const a = this.edgeWeights.constructor;
    this.TypedArray = a, this.rowLabels = new a(t), this.colLabels = new a(n), this.candidateSlackValues = new a(n), this.rowCandidates = new Uint8Array(t), this.colToRowMatches = new Uint32Array(n).fill(t), this.rowToColMatches = new Uint32Array(t).fill(n), this.colToRowCommits = new Uint32Array(n).fill(t), this.colToRowCandidates = new Uint32Array(n), this.setBounds(), this._assignments = null, this._assignmentsWeight = null;
  }
  run() {
    const { rowCount: e } = this;
    this.initRowLabels(), this.initMatching();
    let t;
    for (; (t = this.findUnmatchedRow()) !== e; )
      this.initCommitsAndCandidates(t), this.increaseMatching();
  }
  getAssignments() {
    if (this._assignments === null) {
      let e, t, n, a;
      const { rowCount: i, colCount: s, weightUpperBound: l, edgeBoundedWeights: c } = this;
      this.transposed ? (e = s, t = i, n = this.colToRowMatches, a = (u, f) => f * s + u) : (e = i, t = s, n = this.rowToColMatches, a = (u, f) => u * s + f);
      const o = new Array(e).fill(null);
      for (let u = 0; u < e; u++) {
        const f = n[u];
        f !== t && c[a(u, f)] < l && (o[u] = f);
      }
      this._assignments = o;
    }
    return this._assignments;
  }
  getAssignmentsWeight() {
    if (this._assignmentsWeight === null) {
      const { rowCount: e, colCount: t, weightUpperBound: n, rowToColMatches: a, edgeWeights: i } = this;
      let s = 0;
      for (let l = 0; l < e; l++) {
        const c = a[l], o = i[l * t + c];
        c !== t && o < n && (s += o);
      }
      this._assignmentsWeight = s;
    }
    return this._assignmentsWeight;
  }
  match(e, t) {
    this.rowToColMatches[e] = t, this.colToRowMatches[t] = e;
  }
  checkWeightMatrix(e) {
    const { data: t, shape: n } = e;
    if (n.length !== 2)
      throw new Error("weightMatrix must be two dimensional.");
    for (let a = 0, i = t.length; a < i; a++)
      if (Number.isNaN(t[a]))
        throw new Error("NaN weight is not allowed.");
  }
  forcePrecision(e) {
    return new this.TypedArray([e])[0];
  }
  setBounds() {
    const { edgeWeights: e } = this;
    let t = 1 / 0, n = -1 / 0, a = !0;
    for (let c = 0, o = e.length; c < o; c++) {
      const u = e[c];
      if (!Number.isFinite(u)) {
        a = !1;
        continue;
      }
      u < t && (t = u), u > n && (n = u);
    }
    t === 1 / 0 && (t = 0), n === -1 / 0 && (n = 0);
    const i = (n - t) * this.rowCount, s = t - i - 1, l = n + i + 1;
    if (this.weightLowerBound = this.forcePrecision(s), this.weightUpperBound = this.forcePrecision(l), this.slackValueUpperBound = this.forcePrecision(l - s), a)
      this.edgeBoundedWeights = this.edgeWeights;
    else {
      const c = this.edgeWeights.slice();
      for (let o = 0, u = e.length; o < u; o++) {
        const f = e[o];
        f < s ? c[o] = s : f > l && (c[o] = l);
      }
      this.edgeBoundedWeights = c;
    }
  }
  initRowLabels() {
    const { rowLabels: e, weightLowerBound: t, weightUpperBound: n, edgeBoundedWeights: a } = this;
    let i = n;
    for (let s = 0, l = a.length; s < l; s++) {
      const c = a[s];
      if (c < i && (i = c), i === t)
        break;
    }
    e.fill(i);
  }
  initMatching() {
    var e;
    const { rowCount: t, colCount: n, weightUpperBound: a, rowLabels: i, edgeBoundedWeights: s, colToRowMatches: l } = this, c = (e = i[0]) !== null && e !== void 0 ? e : a;
    if (c !== a)
      for (let o = 0; o < t; o++) {
        let u = o * n;
        for (let f = 0; f < n; f++) {
          if (l[f] === t && s[u] === c) {
            this.match(o, f);
            break;
          }
          u++;
        }
      }
  }
  initCommitsAndCandidates(e) {
    const { rowCount: t, colCount: n, rowCandidates: a, rowLabels: i, colLabels: s, edgeBoundedWeights: l, candidateSlackValues: c, colToRowCommits: o, colToRowCandidates: u } = this;
    o.fill(t), a.fill(0), a[e] = 1, u.fill(e);
    const f = i[e];
    let m = e * n;
    for (let p = 0; p < n; p++)
      c[p] = l[m++] - f - s[p];
  }
  findUnmatchedRow() {
    const { rowCount: e, colCount: t, rowToColMatches: n } = this;
    for (let a = 0; a < e; a++)
      if (n[a] === t)
        return a;
    return e;
  }
  increaseMatching() {
    const { rowCount: e, colToRowMatches: t } = this;
    let n = e;
    for (; n; ) {
      n--;
      const [a, i, s] = this.findMinSlack();
      if (i === -1)
        throw new Error("There must be a minSlack.");
      a > 0 && this.updateLabels(a);
      const l = t[s];
      if (l === e) {
        this.augmentAlternatePath(i, s);
        return;
      }
      this.updateCommitsAndCandidates(a, i, s, l);
    }
    throw new Error("Number of loops exceeds rowCount.");
  }
  findMinSlack() {
    const { rowCount: e, colCount: t, slackValueUpperBound: n, candidateSlackValues: a, colToRowCommits: i, colToRowCandidates: s } = this;
    let l = n, c = -1, o = -1;
    for (let u = 0; u < t; u++) {
      if (i[u] !== e)
        continue;
      const f = a[u];
      if (f < l && (l = f, c = s[u], o = u), l === 0)
        break;
    }
    return [l, c, o];
  }
  updateLabels(e) {
    const { rowCount: t, colCount: n, rowCandidates: a, rowLabels: i, colLabels: s, colToRowCommits: l } = this;
    for (let c = 0; c < t; c++)
      a[c] && (i[c] += e);
    for (let c = 0; c < n; c++)
      l[c] !== t && (s[c] -= e);
  }
  augmentAlternatePath(e, t) {
    const { rowCount: n, colCount: a, rowToColMatches: i, colToRowCommits: s } = this;
    let l = e, c = t, o = n;
    for (; o; ) {
      o--;
      const u = i[l];
      if (this.match(l, c), c = u, c === a)
        return;
      if (l = s[c], l === n)
        throw new Error("There must be an edge between from col to row in commits.");
    }
    throw new Error("Number of loops exceeds rowCount.");
  }
  updateCommitsAndCandidates(e, t, n, a) {
    const { rowCount: i, colCount: s, rowCandidates: l, rowLabels: c, colLabels: o, candidateSlackValues: u, edgeBoundedWeights: f, colToRowCommits: m, colToRowCandidates: p } = this;
    m[n] = t, l[a] = 1, u[n] = 0;
    const d = c[a];
    let v = a * s;
    for (let x = 0; x < s; x++) {
      if (m[x] === i) {
        const h = u[x] - e, D = f[v] - d - o[x];
        D < h ? (u[x] = D, p[x] = a) : u[x] = h;
      }
      v++;
    }
  }
}
function x4(r) {
  r instanceof Array && (r = g4(r));
  const e = new b4(r);
  return e.run(), {
    get assignments() {
      return e.getAssignments();
    },
    get assignmentsWeight() {
      return e.getAssignmentsWeight();
    }
  };
}
var Yt = /* @__PURE__ */ ((r) => (r.Started = "Started", r.Matched = "Matched", r.Missed = "Missed", r.Dead = "Dead", r))(Yt || {});
function w4(r) {
  if (r.length === 0)
    return [];
  const { assignments: e } = x4(r);
  return e.map((t, n) => t !== null ? [n, t] : null).filter((t) => t !== null);
}
function D4(r, e) {
  const t = r.length, n = e.length, a = Array.from({ length: t }, () => Array(n).fill(0));
  for (let i = 0; i < t; i++) {
    const [s, l, c, o] = r[i], u = (c - s) * (o - l);
    for (let f = 0; f < n; f++) {
      const [m, p, d, v] = e[f], x = Math.max(s, m), h = Math.max(l, p), D = Math.min(c, d), y = Math.min(o, v), w = Math.max(0, D - x), b = Math.max(0, y - h), g = w * b, N = (d - m) * (v - p);
      a[i][f] = g / (u + N - g);
    }
  }
  return a;
}
function ro(r) {
  const e = r.origin.x, t = r.origin.y, n = e + r.width, a = t + r.height;
  return [e, t, n, a];
}
function pa(r) {
  const [e, t, n, a] = r;
  return { origin: { x: e, y: t }, width: n - e, height: a - t, score: 1 };
}
function Df(r) {
  const [e, t, n, a] = r, i = n - e, s = a - t, l = e + i / 2, c = t + s / 2, o = i * s, u = i / s;
  return wr([[l], [c], [o], [u]]);
}
function Nf(r) {
  const e = r.toArray(), [t, n, a, i] = [e[0][0], e[1][0], e[2][0], e[3][0]], s = Math.sqrt(a * i), l = a / s;
  return [t - s / 2, n - l / 2, t + s / 2, n + l / 2];
}
class N4 {
  dimX;
  dimZ;
  F;
  // State Transition Matrix
  H;
  // Measurement Function
  Q;
  // Process Covariance
  R;
  // Measurement Covariance
  P;
  // State Covariance
  x;
  // State
  constructor(e, t) {
    this.dimX = e, this.dimZ = t, this.F = ht(e), this.H = eo(t, e), this.Q = ht(e), this.R = ht(t), this.P = ht(e), this.x = eo(e, 1);
  }
  predict() {
    this.x = vr(this.F, this.x), this.P = Na(vr(vr(this.F, this.P), Ci(this.F)), this.Q);
  }
  update(e) {
    const t = yf(e, vr(this.H, this.x)), n = Na(vr(vr(this.H, this.P), Ci(this.H)), this.R);
    try {
      const a = vr(vr(this.P, Ci(this.H)), GB(n));
      this.x = Na(this.x, vr(a, t));
      const i = ht(this.dimX);
      this.P = vr(yf(i, vr(a, this.H)), this.P);
    } catch {
    }
  }
}
class _o {
  static count = 1;
  kf;
  id;
  history = [];
  // misses = 0; // Replaced by time-based tracking
  creationTime;
  lastMatchedTime;
  score = 0;
  // Default score, can be set later
  constructor(e, t) {
    this.kf = new N4(7, 4), this.creationTime = t, this.lastMatchedTime = t, this.score = e.score, this.kf.F = wr([
      [1, 0, 0, 0, 1, 0, 0],
      [0, 1, 0, 0, 0, 1, 0],
      [0, 0, 1, 0, 0, 0, 1],
      [0, 0, 0, 1, 0, 0, 0],
      [0, 0, 0, 0, 1, 0, 0],
      [0, 0, 0, 0, 0, 1, 0],
      [0, 0, 0, 0, 0, 0, 1]
    ]), this.kf.H = wr([
      [1, 0, 0, 0, 0, 0, 0],
      [0, 1, 0, 0, 0, 0, 0],
      [0, 0, 1, 0, 0, 0, 0],
      [0, 0, 0, 1, 0, 0, 0]
    ]), this.kf.R = vr(this.kf.R, 10), this.kf.P = vr(this.kf.P, 10), this.kf.P = ca(this.kf.P, la([4, 5, 6], [4, 5, 6]), vr(ht(3), 1e3)), this.kf.Q = ca(this.kf.Q, la(6, 6), 0.01), this.kf.Q = ca(this.kf.Q, la([4, 5, 6], [4, 5, 6]), vr(ht(3), 0.01));
    const n = Df(ro(e));
    this.kf.x = wr([[n.get([0, 0])], [n.get([1, 0])], [n.get([2, 0])], [n.get([3, 0])], [0], [0], [0]]), this.id = _o.count++;
  }
  update(e, t) {
    this.history = [], this.kf.update(Df(ro(e))), this.lastMatchedTime = t, this.score = e.score;
  }
  predict() {
    this.kf.predict(), this.kf.x.get([2, 0]) <= 0 && (this.kf.x = ca(this.kf.x, la(2, 0), 0.1));
    const e = Nf(this.kf.x);
    return this.history.push(e), e;
  }
  getState() {
    return Nf(this.kf.x);
  }
}
function A4(r, e, t = 0.3) {
  if (e.length === 0 || r.length === 0)
    return {
      matches: [],
      unmatchedDet: r.map((o, u) => u),
      unmatchedTrk: e.map((o, u) => u)
    };
  const n = D4(r, e), a = n.map((o) => o.map((u) => 1 - u)), i = w4(a), s = [], l = new Set(r.map((o, u) => u)), c = new Set(e.map((o, u) => u));
  for (const [o, u] of i)
    n[o][u] >= t && (s.push([o, u]), l.delete(o), c.delete(u));
  return {
    matches: s,
    unmatchedDet: Array.from(l),
    unmatchedTrk: Array.from(c)
  };
}
class S4 {
  maxMissedTimeoutMs;
  iouThreshold;
  trackers = [];
  constructor({
    maxMissedTimeoutMs: e = 2e3,
    // Default to 500ms
    iouThreshold: t = 0.3
  }) {
    this.maxMissedTimeoutMs = e, this.iouThreshold = t;
  }
  /**
   * Update tracker with new detections
   * @param dets Array of BoundingBox detections from the current frame.
   * @param currentTime The current timestamp in milliseconds (e.g., from `performance.now()`).
   * @returns Array of active tracks.
   */
  update(e = [], t) {
    const n = e.map(ro), a = [], i = this.trackers.map((f) => ({ trk: f, predBbox: f.predict() })), s = i.map((f) => f.predBbox), {
      matches: l,
      unmatchedDet: c,
      unmatchedTrk: o
    } = A4(n, s, this.iouThreshold);
    l.forEach(([f, m]) => {
      const { trk: p } = i[m];
      p.update(e[f], t), a.push({
        bbox: { ...pa(p.getState()), score: p.score },
        id: p.id,
        state: "Matched",
        ageMs: t - p.creationTime,
        detection: e[f]
      });
    }), o.forEach((f) => {
      const { trk: m } = i[f];
      t - m.lastMatchedTime >= this.maxMissedTimeoutMs ? a.push({
        bbox: { ...pa(m.getState()), score: m.score },
        id: m.id,
        state: "Dead",
        ageMs: t - m.creationTime
      }) : a.push({
        bbox: { ...pa(m.getState()), score: m.score },
        id: m.id,
        state: "Missed",
        ageMs: t - m.creationTime
      });
    }), c.forEach((f) => {
      const m = new _o(e[f], t), p = e[f];
      this.trackers.push(m), a.push({
        bbox: { ...pa(m.getState()), score: m.score },
        id: m.id,
        state: "Started",
        ageMs: t - m.creationTime,
        detection: p
      });
    });
    let u = 0;
    for (let f = 0; f < this.trackers.length; f++) {
      const m = this.trackers[f];
      t - m.lastMatchedTime < this.maxMissedTimeoutMs && (this.trackers[u++] = m);
    }
    return this.trackers.length = u, a;
  }
}
const _i = {
  embeddingTimeoutMs: 3e3,
  faceSdk: null,
  qualityFilterMinimum: 0.4,
  acceptabilityFilterMinimum: 0.35,
  embeddingOverlapThreshold: 0.3,
  boxTrackOptions: {
    maxMissedTimeoutMs: 1200,
    iouThreshold: 0.15
  },
  faceTrackOptions: {
    matchCountMinimum: 0,
    matchScoreMinimum: 530,
    qualityToAddMinimum: 0.5
    // Default qualityToAddMinimum in FaceTracker itself
  }
};
function E4(r) {
  if (r)
    try {
      r.close();
    } catch {
    }
}
function zd(r, e = /* @__PURE__ */ new Set()) {
  const t = /* @__PURE__ */ new Set();
  for (const n of r) {
    const a = [n.preparedImage?.input, n.aligned];
    e.has(n.sourceImage) || a.push(n.sourceImage);
    for (const i of a)
      i && !t.has(i) && (t.add(i), E4(i));
  }
}
function M4(r, e) {
  const t = new Set(e), n = new Set(e.map((a) => a.sourceImage));
  zd(
    r.filter((a) => !t.has(a)),
    n
  );
}
class B4 {
  _faceTrackerSession;
  _boxTrackerSession;
  _faceSdk;
  _boxIdToSubjectIdMap = /* @__PURE__ */ new Map();
  _subjectIdToBoxId = /* @__PURE__ */ new Map();
  _boxLastEmbeddingsTime = /* @__PURE__ */ new Map();
  embeddingTimeoutMs;
  qualityFilterMinimum;
  acceptabilityFilterMinimum;
  embeddingOverlapThreshold;
  _subjectStateChangedListeners = [];
  _boxTrackerStateChangedListeners = [];
  constructor(e) {
    const t = {
      ..._i,
      ...e,
      boxTrackOptions: {
        ..._i.boxTrackOptions,
        ...e?.boxTrackOptions ?? {}
      },
      faceTrackOptions: {
        ..._i.faceTrackOptions,
        ...e?.faceTrackOptions ?? {}
      }
    };
    this._faceSdk = t.faceSdk, this.embeddingTimeoutMs = t.embeddingTimeoutMs, this.qualityFilterMinimum = t.qualityFilterMinimum, this.acceptabilityFilterMinimum = t.acceptabilityFilterMinimum, this.embeddingOverlapThreshold = t.embeddingOverlapThreshold, this._boxTrackerSession = new S4({
      maxMissedTimeoutMs: t.boxTrackOptions.maxMissedTimeoutMs,
      iouThreshold: t.boxTrackOptions.iouThreshold
    }), this._faceTrackerSession = new v4().createSession("CombinedFaceTrackerSession", Sr.getMatchScore), this._faceTrackerSession.matchCountMinimum = t.faceTrackOptions.matchCountMinimum, this._faceTrackerSession.matchScoreMinimum = t.faceTrackOptions.matchScoreMinimum, this._faceTrackerSession.qualityToAddMinimum = t.faceTrackOptions.qualityToAddMinimum, this._faceTrackerSession.addSubjectStateChangedListener((n, a) => {
      this.onSubjectStateChanged(a), a.newState === "Expired" && this.unassociateSubjectId(a.subject.id);
    });
  }
  // Methods for subject state change events
  addSubjectStateChangedListener(e) {
    this._subjectStateChangedListeners.push(e);
  }
  removeSubjectStateChangedListener(e) {
    const t = this._subjectStateChangedListeners.indexOf(e);
    t > -1 && this._subjectStateChangedListeners.splice(t, 1);
  }
  onSubjectStateChanged(e) {
    this._subjectStateChangedListeners.forEach((t) => t(this, e));
  }
  // Methods for box tracker state change events
  addBoxTrackerStateChangedListener(e) {
    this._boxTrackerStateChangedListeners.push(e);
  }
  removeBoxTrackerStateChangedListener(e) {
    const t = this._boxTrackerStateChangedListeners.indexOf(e);
    t > -1 && this._boxTrackerStateChangedListeners.splice(t, 1);
  }
  onBoxTrackerStateChanged(e) {
    this._boxTrackerStateChangedListeners.forEach((t) => t(this, e));
  }
  get faceSdk() {
    return this._faceSdk;
  }
  set faceSdk(e) {
    this._faceSdk = e;
  }
  /**
   * Computes Intersection over Union (IoU) between two bounding boxes.
   */
  computeIoU(e, t) {
    const n = Math.max(e.origin.x, t.origin.x), a = Math.max(e.origin.y, t.origin.y), i = Math.min(e.origin.x + e.width, t.origin.x + t.width), s = Math.min(e.origin.y + e.height, t.origin.y + t.height), l = Math.max(0, i - n) * Math.max(0, s - a);
    if (l === 0) return 0;
    const c = e.width * e.height, o = t.width * t.height;
    return l / (c + o - l);
  }
  /**
   * Checks whether a box track overlaps with any other active (non-Dead) track
   * that already has an associated subject, exceeding the overlap threshold.
   * This suppresses embedding requests for overlapping boxes to avoid
   * expensive re-identification when faces are close together.
   */
  isOverlappingIdentifiedTrack(e, t) {
    if (!e.detection) return !1;
    for (const n of t) {
      if (n.id === e.id || !n.detection || n.state === Yt.Dead || !this._boxIdToSubjectIdMap.has(n.id)) continue;
      if (this.computeIoU(e.detection, n.detection) >= this.embeddingOverlapThreshold)
        return !0;
    }
    return !1;
  }
  async processImage(e, t = !1) {
    if (!this.faceSdk || !this._faceTrackerSession)
      return [];
    const n = performance.now();
    let a = await this.faceSdk.getFaces(e, t);
    try {
      await this.faceSdk.getQualities(a);
      const i = a.filter(
        (o) => o.quality !== void 0 && o.quality >= this.qualityFilterMinimum && o.acceptability !== void 0 && o.acceptability >= this.acceptabilityFilterMinimum
      );
      M4(a, i), a = i;
      const s = this._boxTrackerSession.update(
        a.map((o) => o.boundingBox),
        n
      ), l = /* @__PURE__ */ new Map();
      for (const o of a)
        l.set(o.boundingBox, o);
      const c = [];
      for (const o of s) {
        this.onBoxTrackerStateChanged(o);
        const u = o.detection ? l.get(o.detection) : void 0, f = u?.quality !== void 0 && u.quality >= this._faceTrackerSession.qualityToAddMinimum;
        switch (u && (u.boxTrackerId = o.id), o.state) {
          case Yt.Started:
            f && u && (this.isOverlappingIdentifiedTrack(o, s) || c.push(u));
            break;
          case Yt.Matched:
            if (f && u) {
              if (this.isOverlappingIdentifiedTrack(o, s))
                break;
              const m = this._boxLastEmbeddingsTime.get(o.id);
              m === void 0 ? c.push(u) : n - m >= this.embeddingTimeoutMs && (this.unassociateBoxTrackerId(o.id), c.push(u));
            }
            break;
          case Yt.Missed:
            break;
          case Yt.Dead:
            this.unassociateBoxTrackerId(o.id);
            break;
        }
      }
      if (this._faceTrackerSession.currentTime = n, c.length > 0) {
        await this.faceSdk.getLandmarks(c), await this.faceSdk.getEmbeddings(c);
        for (const o of c) {
          o.boxTrackerId !== void 0 && this._boxLastEmbeddingsTime.set(o.boxTrackerId, n);
          const u = this._faceTrackerSession.processFace(c4(o));
          u.subject?.id && o.boxTrackerId !== void 0 && (this.associateIds(o.boxTrackerId, u.subject.id), o.faceSubjectId = u.subject.id);
        }
      }
      this._faceTrackerSession.processState();
      for (const o of a)
        if (o.boxTrackerId !== void 0) {
          const u = this._boxIdToSubjectIdMap.get(o.boxTrackerId);
          u && (o.faceSubjectId = u, this._faceTrackerSession.markActive(u));
        }
      return a;
    } catch (i) {
      throw zd(a), i;
    }
  }
  associateIds(e, t) {
    this._boxIdToSubjectIdMap.set(e, t), this._subjectIdToBoxId.set(t, e);
  }
  unassociateBoxTrackerId(e) {
    const t = this._boxIdToSubjectIdMap.get(e);
    this._boxLastEmbeddingsTime.delete(e), t !== void 0 && (this._boxIdToSubjectIdMap.delete(e), t && this._subjectIdToBoxId.delete(t));
  }
  unassociateSubjectId(e) {
    const t = this._subjectIdToBoxId.get(e);
    t !== void 0 && (this._subjectIdToBoxId.delete(e), this._boxIdToSubjectIdMap.delete(t), this._boxLastEmbeddingsTime.delete(t));
  }
}
export {
  _4 as BoundingBoxKalmanFilter,
  B4 as CombinedFaceTracker,
  Sr as FaceMatchFunctions,
  Od as FaceSdk,
  F4 as FaceSdkBenchmark,
  l4 as FaceSubjectMetricsComparer,
  m4 as FaceTrackResultFlags,
  d4 as FaceTrackedSubject,
  f4 as FaceTrackedSubjectState,
  v4 as FaceTracker,
  h4 as FaceTrackerSession,
  fn as InferenceError,
  Id as KnownModel,
  C4 as RollingAverage,
  nn as SDKError,
  u4 as ScoreType,
  S4 as SortTracker,
  ct as Stopwatch,
  Yt as TrackState,
  T4 as boundingBoxEquals,
  t4 as calculatePoseAndFrontality,
  c4 as createFaceRecognitionItemFromFace,
  lv as downloadUrlAsArrayBuffer,
  n4 as getFrontalityScore
};
